
export const searchSeries = 
[
    {
      "make": "Acura",
      "models": [
        {
          "model": "CSX",
          "series": [
            "Technology",
            "Premium",
            "Tech",
            "Premium Navigation",
            "Type S",
            "Touring",
            "Premiu",
            "Type-S",
            "Techno",
            "Tourin",
            "I-Tech",
            "Premium/premium Package",
            "Premium Package",
            "Technology Package"
          ]
        },
        {
          "model": "ILX",
          "series": [
            "2.0l",
            "Special Edition",
            "Base Watch Plus",
            "20",
            "Acurawatch Plus Package",
            "20 Premium",
            "Premium Package/technology Plus Package",
            "Premium Package",
            "Premium",
            "Premium A-spec Packages/technology A-spec Packages",
            "Standard",
            "Hybrid 1.5l",
            "2.4l/acurawatch Plus Package",
            "Premium Package/technology Package",
            "Premium A-spec",
            "Hybrid",
            "24 Premium",
            "20 Tech",
            "Premium A-spec Packages/technology Plus A-spec Packages",
            "Premium Tech",
            "Premium/technology",
            "Technology & A-spec Packages/premium & A-spec Packages",
            "W/technology Plus/a-spec Pkg/w/premium/a-spec Pkg",
            "W/technology Plus Pkg/w/premium Pkg",
            "2.4l (a8)/w/acurawatch Plus Pkg",
            "Hybrid Tech",
            "2.4l",
            "Package",
            "Premium/a-spec Package/w/technology/a-spec Package",
            "Premium A-spec/technology",
            "Base (dct)",
            "Premium Pkg",
            "Premium Pkg/w/technology Pkg",
            "Technology Plus Package/premium Package",
            "Hybrid Hybrid",
            "Technology Package/premium Package",
            "Premium A-spec/technology A-spec",
            "Dynamic",
            "Pkg",
            "Ium",
            "Premium   A-spec Packages/technology   A-spec Packages",
            "Premium   A-spec Packages/technology Plus   A-spec Packages",
            "Premiu",
            "Tech 2.0l",
            "4d Tc Pkg",
            "W/technology",
            "W/technology Plus",
            "Premium   A-spec",
            "2.0l A5",
            "Premium Pkg/w/technology Plus Pkg",
            "Base",
            "Technology Plus & A-spec Packages/premium & A-spec Packages",
            "Dynamic W/navi Pkg",
            "Tech Pkg",
            "W",
            "Premium/tech",
            "20 Tec",
            "Base W",
            "24 Pre",
            "2.4l Premium Pkg",
            "Premium Style/tech Style",
            "Hybrid Tech Pkg",
            "W/acurawatch Plus",
            "W/technology Pkg",
            "W/technology Plus Pkg",
            "20 Pre",
            "W/premium/a-spec Pkg",
            "W/acurawatch Plus Pkg",
            "Watch Plus",
            "W/premium",
            "Specia",
            "W/premium Pkg",
            "W/premium Package",
            "W/premium/a-spec Package",
            "W/technology/a-spec Pkg",
            "Acurawatch Plus Package/2.4l",
            "Premium/a-spec Pkg/w/technology Plus/a-spec Pkg",
            "Premium   A-spec Packages/technology Plus   A-spec Pack",
            "Premium/a-spec Pkg/w/technology/a-spec Pkg",
            "4d",
            "Premium Package/w/technology Package",
            "Dynami",
            "Premiu Premiu",
            "20 Tec 20 Tec",
            "20 20",
            "1.5l",
            "Base W Base W",
            "Premium/technology Package",
            "Technology Plus Package/w/premium Pkg",
            "Technology Package/w/premium Pkg",
            "Premium Package/tech Package",
            "A-spec/anniversary Edition",
            "Premium A-spec/tech A-spec",
            "Premium A-spec Packages/w/technology Plus/a-spec Pkg"
          ]
        },
        {
          "model": "Integra",
          "series": [
            "A-Spec",
            "A-spec W/ Technology",
            "Gs",
            "Type S",
            "A-spec Tech",
            "Gs-R",
            "Ls",
            "A-spec Package",
            "Type R",
            "Rs",
            "Gsr",
            "Base (cvt)",
            "Se",
            "W/a-spec Tech Package",
            "A-spec Tech Package",
            "W/a-spec Package",
            "Ls Special",
            "A-spec Technology Package",
            "Type-R",
            "Gs/rs",
            "A-",
            "Integra",
            "Ty",
            "Elite A-spec",
            "A-spec Technology",
            "Rs Se"
          ]
        },
        {
          "model": "MDX",
          "series": [
            "Standard",
            "Technology",
            "A-Spec",
            "Technology Package",
            "Technology A-spec Packages",
            "Base (a10)",
            "Technology Acurawatch Plus Packages/technology Package",
            "Sport Hybrid Advance",
            "Advance Entertainment Packages/advance Package",
            "3.5l",
            "3.5l (a9)/w/acurawatch Plus",
            "W/advance Package",
            "Touring Pkg",
            "Advance",
            "Touring",
            "A-spec Package",
            "Technology Package Acurawatch Plus Pkg",
            "Tech A-spec Pkgs",
            "Tech/w/tech/acurawatch Plus",
            "Advance Package",
            "Advance Pkg W/entertainment Pkg",
            "Technology & Acurawatch Plus Packages/technology Package",
            "Acurawatch Plus Package",
            "Sport",
            "Advance Pkg",
            "Base (a9)",
            "Technology Pkg W/entertainment Pkg",
            "Sport Package",
            "Tech Pkg",
            "Tech Entertainment Pkgs",
            "Technology Pkg",
            "Technology/a-spec Pkg",
            "Type S",
            "Type S Advance",
            "Techno",
            "Advanc",
            "Sport Hybrid Technology",
            "Navi",
            "Technology Entertainment Pkgs",
            "Tech",
            "Type S W/advance Package",
            "Elite 6 Passenger/a-spec",
            "W/technology Package",
            "Sport Hybrid Technology Package",
            "W/tech/w/tech/acurawatch Plus",
            "Advance & Entertainment Pkgs",
            "3.5l (a9)",
            "W/tech/acurawatch Plus/w/tech",
            "W/technology & Entertainment Pkgs",
            "Sport Hybrid Advance Package",
            "W/technology Package & Acurawatch Plus Pkg",
            "Technology & A-spec Packages",
            "Touring Pkg Res W/navigation System",
            "Advance & Entertainment Packages/advance Package",
            "3.5l (a5)",
            "W/advance & Entertainment Pkgs",
            "Tech & A-spec Pkgs",
            "Tech/entertainment Pkg",
            "Advance Entertainment Packages/pmc Edition",
            "Touring W/navi",
            "Elite",
            "Technology Entertainment Packages/technology, Entertainment Acurawatch Plus Packages",
            "Sport Hybrid Sport Hybrid Technology",
            "Advance Entertainment Pkgs",
            "X-runner Access Cab",
            "W/advance Pkg",
            "Technology   Acurawatch Plus Packages/technology Package",
            "Technology   Entertainment Packages/technology, Entertainment   Acurawatch Plus Packa",
            "Advance   Entertainment Packages/advance Package",
            "Technology Package   Acurawatch Plus Pkg",
            "Technology   A-spec Packages",
            "Advance   Entertainment Packages/pmc Edition",
            "Tech   A-spec Pkgs",
            "A-spec/pmc Edition",
            "Sh-awd W/tech Technology Package",
            "Nergy",
            "Advance   Entertainment Pkgs",
            "Advance Package/w/advance/entertainment",
            "W/acurawatch Plus",
            "Technology   Entertainment Pkgs",
            "Avel Trlr",
            "Sport/pwr Tail Gate",
            "Awd",
            "Tech Plus",
            "Awd W/",
            "Touring Pkg Res W/nav",
            "3.5l W/navigation System",
            "Vance/w/advance",
            "Sport Hybrid Sport Hybrid Advance",
            "Tech/pwr Tail Gate",
            "Touring Pkg Res",
            "Touring Pkg W/navigation",
            "T",
            "Touring Res",
            "W/tech/entertainment/w/tech/entertainment/acurawatch Plus",
            "Advance   Entertainment",
            "Technology   Acurawatch",
            "Tech/w/tech",
            "3.7l A5",
            "Advance/w/advance/entertainment",
            "Advance/pmc Edition",
            "W/technology Pkg",
            "W/technology",
            "W/technology/a-spec Pkg",
            "W/a-spec Package",
            "Nology",
            "Nc",
            "W/tech/w/tech",
            "Sport Pkg",
            "Vance",
            "Ch/w/tech",
            "Nce Pkg",
            "Touring Res W/navi",
            " Pkg",
            "W/advance/w/advance",
            "Sport Hybrid W",
            "W/tech/entertainment/w",
            "Sport Hybrid",
            "W/tech/entertainment",
            "W/advance/entertainment",
            "Touring Pkg W",
            "Chnology Pkg",
            "Sport/entertainment Pkg",
            "W/tech",
            "No",
            "/entertainment Pkg",
            "Advance/entertainment Pkg",
            "Nology Pkg",
            "Nce/entertainment Pkg",
            "W/advance",
            "Tourin",
            "W/tech/acurawatch Plus",
            "Ntier S",
            "Tech/entertainment/w/tech/entertainment/acurawatch Plus",
            "Sport Hybrid W/advance Package",
            "Sport Hybrid W/technology Package",
            "3.7l (a5)",
            "Technology   Acurawatch Plus Packages/technology Packag",
            "3.5l A9",
            "Reserve",
            "Technology   Entertainment Packages/technology, Enterta",
            "3.5l W",
            "Advance/w/advance",
            "Technology/entertainment Pkg",
            "Sport Hybrid W/advance Pkg",
            "Advance W/ 3rd Row Seat",
            "Tech   Entertainment Pkgs",
            "E",
            "Prem",
            "Sport Sport",
            "Techno Techno",
            "Advanc Advanc",
            "Platinum Elite",
            "Technology Entertainment Packages",
            "Navi Navi",
            "Technology, Entertainment Acurawatch Plus Packages/w/tech/entertainment",
            "A-spec Advance Package",
            "Elite Pkg",
            "A-spec Advance",
            "Technology, Entertainment   Acurawatch Plus Packages/w/",
            "Navigation Package",
            "Elite Package",
            "Awd W/ Awd",
            "A-spec A-spec",
            "A-Spec/elite",
            "3.5",
            "Tech P",
            "Technology Package/w/tech/acurawatch Plus",
            "Technology   Entertainment Packages"
          ]
        },
        {
          "model": "NSX",
          "series": [
            "Base (dct)",
            "T",
            "Sport"
          ]
        },
        {
          "model": "RDX",
          "series": [
            "Standard",
            "Base (a10)",
            "Technology Package",
            "Technology",
            "Technology & Acurawatch Plus Packages/technology Package",
            "Acurawatch Plus Pkg/base (a6)",
            "Base (a6)/w/acurawatch Plus",
            "Tech Pkg/tech/acurawatch Plus Pkg",
            "Advance",
            "A-spec Package",
            "A-Spec",
            "Technology Acurawatch Plus Packages/technology Package",
            "W/advance Pkg",
            "Acurawatch Plus Package",
            "Advance Package",
            "Technology Acurawatch Plus Packages/w/technology Package",
            "A-spec Advance Package",
            "Advance Package/pmc Edition",
            "A-spec Advance",
            "Technology Pkg/w/technology/acurawatch Plus Pkg",
            "Acurawatch Plus Pkg",
            "Advance Pkg",
            "Tech Pkg",
            "W/advance Package",
            "A-spec Advance Package/pmc Edition",
            "A-spec Pkg",
            "Technology Pkg",
            "W/technology Pkg/w/technology/acurawatch Plus Pkg",
            "Technology   Acurawatch Plus Packages/technology Package",
            "Platinum Elite",
            "Technology   Acurawatch Plus Packages/w/technology Package",
            "A-spec Advance/pmc Editio",
            "Technology Package/w/technology/acurawatch Plus Pkg",
            "Ry Base",
            "Vance Package",
            "Edition/w",
            "No",
            "Awatch Plus Pkg",
            "Urawatch Plus",
            "Pmc Edition/w",
            " Pkg/tech",
            "Advance/pmc Edition",
            "In",
            "4d",
            "W/a-spec Advance Package",
            "Base (a6)/w",
            "Base A6",
            "Base (a5)",
            "Technology   Acurawatch Plus Packages/technology Packag",
            "Vance Pkg",
            "Techno",
            "W/technology Pkg",
            "Advanc",
            "Tech Pkg/tech",
            "W/acurawatch Plus",
            " Pkg",
            "Tech/acurawatch Plus Pkg",
            "Spec Pkg",
            "Nce",
            "W/technology Package",
            "W/technology",
            "Chnology Package",
            "Nc",
            "W",
            "W/a-spec Pkg",
            "W/a-spec Package",
            "Spec Package",
            "Nce Pkg",
            "Nology",
            "Chnology Pkg",
            "Ec",
            "W/technology & Acurawatch Plus Packages/w/technology Package",
            "Technology   Acurawatch Plus Packages/w/technology Pack",
            " T5 Premier",
            "Technology   Acurawatch",
            "W/acurawatch Plus Package",
            "Pmc Edition/w/a-spec Advance Package",
            "Platin",
            "Base",
            "4d 4wd",
            "Awd",
            "Techno Techno",
            "Advanc Advanc",
            "Base (a6)/w/acurawatch Plus Package",
            "A-spec A-spec",
            "A-spec Advance/pmc Edition",
            "Tech Package",
            "Elite",
            "Platinum Elite A-spec",
            "Wd",
            "Es",
            "Tech",
            "Platinum Elite A-spec/pmc Edition",
            "Base (a6)",
            "Pieces",
            "Fwd Acurawatch Plus Pkg",
            "Platinum Elite/pmc Edition"
          ]
        },
        {
          "model": "RL",
          "series": [
            "3.7",
            "3.7l Technology Package",
            "3.5",
            "3.5 (a4)",
            "Rl",
            "W/navigation System",
            "Premium Pkg",
            "Rl Se",
            "Tech Pkg/tech/cmbs W/pax",
            "W/tech Pkg",
            "Tech Pkg/tech/cmbs",
            "Pkg",
            "Tech Pkg",
            "3.5 (48-state Only) (a5)",
            "3.5 Nav System (a4)",
            "3.5 (hawaii Only) (a5)",
            "Elite/premium",
            " Touring",
            "3.7/tech/cmbs W/pax",
            "Elite"
          ]
        },
        {
          "model": "RLX",
          "series": [
            "Sport Hybrid Base W/advance Package",
            "Tech",
            "Advance",
            "Sport Hybrid",
            "Technology",
            "Sport Hybrid Advance",
            "Advance Package",
            "Tech Pkg",
            "Technology Pkg",
            "Standard",
            "Sport Hybrid W/advance Pkg",
            "Sport Hybrid W/advance Package",
            "Sport Hybrid Advance Package",
            "Technology Package",
            "Sport Hybrid Sport Hybrid Advance",
            "Sport Hybrid Technology Package",
            "Advance Pkg",
            "Tech-Audio",
            "Krell Audio Pkg",
            "Hybrid Advance Pkg",
            "T Hybrid",
            "Sport Hybrid/tech",
            "Hybrid Tech Pkg",
            "T Hybrid/advance",
            "Navigation",
            "Nce Pkg",
            " Pkg",
            "Nc",
            "Advanc",
            "W/technology Pkg",
            "Vance Pkg",
            "Sport",
            "-A",
            "T",
            "T Hybrid W",
            "Chnology Pkg",
            "Sport Hybrid W",
            "Gation",
            "T Hybrid Advance",
            "W/advance Pkg",
            "Techno",
            "Tech-A",
            "No",
            "Tech Tech",
            "Hybrid Sport Hybrid Advance",
            "L"
          ]
        },
        {
          "model": "TL",
          "series": [
            "3.5",
            "3.2",
            "3.7",
            "Tl",
            "3.2 (a5)",
            "3.2 W/navigation System (a5)",
            "Type S",
            "Tech",
            "Tl Type-s",
            "W/navigation System",
            "3.2 Type S",
            "Se",
            "Auto",
            "3.5 Special Edition",
            "Advance",
            "3.5 (a5)",
            "Base A5/base W/nav System A5",
            "Type S W/navigation",
            "3.2 A5",
            "W/navigation",
            "Rtl-E",
            "2.5",
            "Type-S",
            "Sh",
            "Awd",
            "3.7/tech Hpt Auto",
            "Navigation System",
            "Tech Auto",
            "Cl Type-s",
            "Tech Hpt",
            "Ance Auto",
            "Nav",
            "Cial Edition",
            "Hp Tires W/navi",
            "3.2 Type",
            "Type S W",
            "Ance",
            "Type-s Summer Tires",
            "4d",
            "Advance Auto",
            "Special Edition",
            "H",
            "O",
            "Tech 18 Wheels",
            "Tech Man",
            "Navigation",
            "H Auto",
            "H Man",
            "Sh-Awd",
            "W/tech",
            "Base (a5)/base W/nav System (a5)",
            "Tech/tech Hpt",
            "Navigation/3.2 (a5)",
            "Base (m6)/base W/nav System (m6)",
            "3.2 A5/nav",
            "Base A5/navigation System",
            "Tl 3.2",
            "Rl Se",
            "Limited",
            "3.2l",
            "3.2  Typ",
            "Uk",
            " Tl 3.2",
            "Tech Tech",
            "2.0t",
            "Base W/nav System (a5)",
            "Summer Tires",
            "Automat",
            "3.7/tech Hpt",
            "L Tl",
            "Tl Type",
            "Elite",
            "3.2tl",
            "3.2 (a5)/nav",
            "Se Se",
            "3.7/tech",
            "3.5/tech",
            "Base (a5)"
          ]
        },
        {
          "model": "TLX",
          "series": [
            "A-spec Package",
            "Advance Package",
            "Tech Pkg",
            "V6 Advance",
            "Advance Pkg",
            "Technology Package",
            "A-spec/a-spec W/red Leather",
            "Tech",
            "Tech A",
            "V6 Tech",
            "A-Spec",
            "V6",
            "W/a-spec Pkg",
            "Standard",
            "Tech A-spec Pkgs",
            "Technology",
            "Type S",
            "Tech+a",
            "Type S - Hp Wheel And Tire",
            "Tech Package",
            "Advance",
            "Type S Pmc Edition",
            "W/technology Package",
            "Advance Package/pmc Edition",
            "Tech & A-spec Pkgs",
            "Type S/type S Pmc Edition",
            "L",
            "Base (dct)",
            "Tech+a/tch+ar",
            "3.5l (a9)",
            "Technology/a-Spec",
            "Technology Pkg",
            "Tech   A-spec Pkgs",
            "Elite",
            "Advance/pmc Edition",
            "Techno",
            "Tech/tech R",
            "Platinum Elite",
            "Dvance",
            "Awd Sp",
            "Spec Pkg",
            "Chnology Pkg",
            "/technology Pkg",
            "/advance Pkg",
            "Spec Package",
            "Nology",
            " A",
            "Vance Pkg",
            "Nce",
            "Ech",
            "Chnology Package",
            "Vance Package",
            " S",
            " S W/performance Tire",
            "Nology/a-Spec",
            "A-spec Pkg/w/a-spec Pkg Red Leather",
            "W/advance Pkg",
            "W/a-spec Package",
            "V6 W/advance Pkg",
            "Type S W/performance Tire",
            "W/advance Pkg/pmc Edition",
            "Tech/t",
            "W/technology Pkg",
            "V6 W/technology Pkg",
            "Advanc",
            "W/a-spec Pkg Red Leather",
            "W/advance Package",
            "Ec Package",
            "Ec/a-spec W",
            "Base (a10)",
            "+a/tch+ar",
            "+a",
            "Platin",
            "Nc",
            "No",
            "Base",
            "Fwd",
            "Ec",
            "E",
            "Tech A-spec Pkgs/w/a-spec Pkg Red Leather",
            "Type S Type S",
            "Tech Tech",
            "Techno Techno",
            "Tech A Tech A",
            "Tech+a Tech+a",
            "Tech   A-spec Pkgs/w/a-spec Pkg Red Leather",
            "Tech A-spec Pkgs/w/a-spec Pkg",
            "Tech A-spec",
            "Tech   A-spec Pkgs/w/a-spec Pkg",
            "Elite A-spec",
            "A-spec Pkg",
            "Hybrid",
            "A-spec A-spec",
            "Tech A-spec/tech A-spec Pmc Edition",
            "Elite/elite A-spec",
            "A-spec/w/a-spec Pkg Red Leather"
          ]
        },
        {
          "model": "TSX",
          "series": [
            "2.4",
            "Tech",
            "Se",
            "3.5",
            "Navi",
            "Navigation",
            "Tech Pkg",
            "2.4 (a5)",
            "Sport Wagon Tech Pkg",
            "Special Edition",
            "W/premium Pkg",
            "Base A5",
            "2.4 A5",
            "Nav",
            "Sport Wagon",
            "W/navigation",
            "Premium Pkg",
            "4d",
            "2.4 (a5)/tech Pkg",
            "Base (a5)",
            "2.4 A5/tech Pkg",
            "Tech Tech",
            "2.4/2.4 (a5)",
            "Se Se",
            "Premium/technology Package",
            "Automa",
            "Sport Tech Pkg"
          ]
        },
        {
          "model": "ZDX",
          "series": [
            "Technology",
            "Advance",
            "A-Spec",
            "Type S/type S Perf. Wheel Tire",
            "Tech Pkg",
            "Advance Pkg",
            "Advanc",
            "Techno",
            "Techno Techno",
            "Type-S",
            "Type S/type S Perf. Wheel   Tire"
          ]
        }
      ]
    },
    {
      "make": "Alfa Romeo",
      "models": [
        {
          "model": "159",
          "series": []
        },
        {
          "model": "4C",
          "series": [
            "Spider",
            "Coupe",
            "Launch Edition",
            "Nch Edition",
            "Launch",
            "Nch",
            "Der"
          ]
        },
        {
          "model": "Giulia",
          "series": [
            "Sport Awd",
            "Ti Q4",
            "Ti",
            "Ti Sport Awd",
            "Q4",
            "Awd",
            "Ti Rwd",
            "Super",
            "Sprint",
            "Ti Sport Rwd",
            "Sprint Awd",
            "Sport Rwd",
            "Rwd",
            "Ti/ti Lusso/ti Sport/ti Sport Carbon",
            "Ti Lusso Awd",
            "Veloce Ti Rwd",
            "Ti Awd",
            "Quadrifoglio Rwd",
            "Quadrifoglio",
            "Sport",
            "Veloce Rwd",
            "Veloce Awd",
            "Sprint Rwd",
            "Ti Lusso Rwd",
            "Estrema Rwd",
            "Competizione Rwd",
            "Super/super Sport",
            "Ti Veloce Awd",
            "Qua",
            "Spr",
            "Sup",
            "Ti Sport Carbon Awd",
            "Ti/lusso/veloce/estrema/speciale",
            "T Carbon",
            "Ti Sport",
            "Ti Sport Carbon Rwd",
            "Spo",
            "Ti/ti Lusso/ti Sport/ti S",
            "Estrema",
            "O/veloce/estrema/s",
            "T",
            "O",
            "Veloce",
            "Ti/ti Lusso/ti Sport",
            "Oglio",
            "Ti Lusso",
            "Ti Sport Carbon",
            "Ti/lusso/veloce/estrema/s",
            "Q4 Q4",
            "Ti Estrema Awd",
            "Ti/veloce/competizione",
            "Qua Qua"
          ]
        },
        {
          "model": "Giulietta",
          "series": []
        },
        {
          "model": "Mito",
          "series": []
        },
        {
          "model": "Stelvio",
          "series": [
            "Sport Awd",
            "Ti Awd",
            "Rwd",
            "Ti",
            "Ti Lusso Awd",
            "Ti Sport Awd",
            "Awd",
            "Sport",
            "Quadrifoglio Awd",
            "Veloce Awd",
            "Quadrifoglio",
            "Ti Luxury",
            "Sprint",
            "Ti Sport",
            "Sprint Awd",
            "Sport Rwd",
            "Ti/ti Sport",
            "Ti/ti Lusso/ti Sport/ti S",
            "Veloce Ti Awd",
            "Sprint Rwd",
            "Ti Sport Carbon Awd",
            "Ti/lusso/veloce/estrema",
            "Ti/ti Lusso/ti Sport/ti Sport Carbon",
            "Estrema Awd",
            "Ti Veloce Awd",
            "Competizione Awd",
            "Sp",
            "Qu",
            "I",
            "4d",
            "Veloce",
            "Glio",
            "Sso/ti Sport",
            " Carbon",
            "Ti Lusso",
            "Ve",
            "Quadrifoglio Carbon Awd",
            "Ti/veloce/competizione",
            "Ti Sport Carbo Awd"
          ]
        },
        {
          "model": "Tonale",
          "series": [
            "Ti",
            "Veloce Eawd",
            "Veloce",
            "Ti Eawd",
            "Veloce Awd",
            "Vel",
            "Veloce Phev",
            "Eawd",
            "Awd",
            "Base",
            "Sprint"
          ]
        }
      ]
    },
    {
      "make": "Aston Martin",
      "models": [
        {
          "model": "DB11",
          "series": [
            "Volante",
            "Launch Edition",
            "Amr",
            "V8",
            "V12",
            "V8/shadow Edition",
            "Amr Signature",
            "Db11"
          ]
        },
        {
          "model": "DB9",
          "series": [
            "Volante",
            "Gt/gt Bond Edition",
            "Volante/volante Carbon Edition",
            "Gt",
            "Gt Volante",
            "Volant"
          ]
        },
        {
          "model": "DBS",
          "series": [
            "Superleggera/superleggera Tag Heuer Edition",
            "Superleggera",
            "Superleggera Volante",
            "Superl"
          ]
        },
        {
          "model": "DBX",
          "series": [
            "707"
          ]
        },
        {
          "model": "DBX707",
          "series": []
        },
        {
          "model": "One-77",
          "series": []
        },
        {
          "model": "Rapide",
          "series": [
            "S",
            "S S",
            "Luxe",
            "Luxury"
          ]
        },
        {
          "model": "V12 Vantage",
          "series": [
            "S",
            "Vantag"
          ]
        },
        {
          "model": "V8 Vantage",
          "series": [
            "S",
            "Gt",
            "Vantage",
            "N420",
            "Vantage/vantage Gt",
            "Vantage S"
          ]
        },
        {
          "model": "Vanquish",
          "series": [
            "S",
            "Volante",
            "V",
            "V12"
          ]
        },
        {
          "model": "Vantage",
          "series": [
            "Vantage",
            "Automatic",
            "F1 Edition",
            "Gt",
            "/f1 Edition",
            "S",
            "Roadster",
            "F1",
            "Amr",
            "F1 Edition/roadster",
            "Am"
          ]
        },
        {
          "model": "Virage",
          "series": [
            "Vol",
            "Volante"
          ]
        }
      ]
    },
    {
      "make": "Audi",
      "models": [
        {
          "model": "A1",
          "series": []
        },
        {
          "model": "A3",
          "series": [
            "2.0t Tech Premium/2.0t Premium",
            "40 Premium/40 Titanium Premium",
            "Premium",
            "Premium Plus",
            "1.8t Premium",
            "2.0t",
            "2.0t Premium",
            "1.8t Premium Plus",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "2.0 Tdi Premium",
            "Premium 40 Tfsi Front-wheel Drive S Tronic",
            "Premium 40 Tfsi Quattro S Tronic",
            "S-line Premium",
            "Prestige S-line",
            "2.0t Premium/2.0t Tech Premium",
            "3.2 Cabriolet Quattro",
            "E-tron Premium Plus",
            "Premium Plus S-line",
            "2.0t Quattro",
            "E-tron Premium",
            "2.0t Premium/tech Premium",
            "Premium Plus 40 Tfsi Quattro S Tronic",
            "40 Premium",
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "2.0",
            "S-line Premium Plus",
            "2.0 Premium",
            "45 Premium",
            "S-line 3.2 Quattro",
            "3.2 S Line",
            "Sedan",
            "Premium Plus 40 Tfsi Front-wheel Drive S Tronic",
            "2.0t Tech Premium",
            "2",
            "2.0 Sport",
            "3.2",
            "E-tron Premium Plus Ultra",
            "Quattro",
            "Premium/titanium",
            "S-Line",
            "Prestig",
            "Technik",
            "Progressiv",
            "40 Titanium Premium",
            "E-tron Prestige",
            "Sedan Premium/tech Premium",
            "2.0t Technik",
            "E-tron Premium Ultra",
            "2.0 Tdi",
            "2.0t Progressiv",
            "Sedan Tech Premium Plus",
            "1.8t Prestige",
            "Sedan Tech Premium",
            "W/sport Pkg",
            "Komfort 45 2.0 Tfsi Quattro",
            "W/premium Pkg",
            "Progres",
            "2.0 Pre",
            "3.2 Qua",
            "Cabriolet",
            "Sedan Premium/titanium Premium",
            "Sedan Premium Plus",
            "Sedan S Line Premium Plus",
            "2.0t Qu",
            "2.0 Tdi Premium Plus",
            "Cabriolet Premium/tech Premium",
            "E-Tron",
            "Sedan Premium",
            "2.0t Premium Plus",
            "S Line",
            "2.0 Tdi Prestige",
            "Sedan Prestige",
            "Premium S Line",
            "2.0t Prestige",
            "Sedan S Line Premium",
            "Prem",
            "Cabriolet Premium",
            "2.0 Spo",
            "Cabriolet Premium Plus",
            "1.8 Pre",
            "Tdi Tec",
            "Cabriol",
            "Prestige",
            "4d 2.0t Prm/ttm",
            "2.0t Sportback M6/2.0t Sportback M6 Discontinued/2.0t Sportback S-tronic",
            "2.0t/2.0t Sportback (m6)",
            "Premium Plus 45 Tfsi S",
            "Premium 45 Tfsi S Line",
            "Premium 40 Tfsi Quattro",
            "2.0 Qua",
            "/ S3",
            "Premium 40 Tfsi",
            "Sedan Premium 40 Tfsi Front-wheel Drive S Tronic",
            "Cabriolet 2.0t Tech Premium/premium Plus",
            "0 Explor",
            "Sedan Premium Plus/tech Premium Plus",
            "Premium Premium",
            "1.8t Progressiv",
            "2.0t 2.0t",
            "Progres Progres",
            "1.4t Premium",
            "S-line S-line",
            "Premium Plus Quat 2.0t Premium",
            "2.0t Premium/2.0t Premium Plus",
            "1.8t",
            "Premium Fwd 1.8t Premium",
            "2.0t Komfort",
            "1.8t Komfort",
            "2.0t Komfort/2.0t Progressiv",
            "2.0t Premium/2.0t Standard",
            "2.0t Cabriolet",
            "Prestige 40 Tfsi Quattro S Tronic",
            "2.0 Tdi Progressiv",
            "2.0 Tdi Technik",
            "40 Komfort",
            "45 Progressiv",
            "40 Progressiv",
            "4d 2wd Premium",
            "2.0t/2.0t Premium",
            "45 Komfort",
            "3.2 Quattro"
          ]
        },
        {
          "model": "A3 e-tron",
          "series": [
            "1.4t Premium",
            "1.4t Premium/1.4t Tech Premium",
            "Premium",
            "Premium Plus",
            "Premium Plus Ultra",
            "E-tron Premium Plus",
            "E-tron Premium",
            "Prestige",
            "Premium Ultra",
            "1.4t Progressiv",
            "1.4t Technik"
          ]
        },
        {
          "model": "A3 Quattro",
          "series": [
            ".2 Quattro"
          ]
        },
        {
          "model": "A3 Sportback e-tron",
          "series": [
            "Tech Premium",
            "Prestige",
            "Premium",
            "Premium Plus",
            "Premium/tech Premium",
            "Premium Plus/tech Premium Plus",
            "1.4t Tech Premium/premium"
          ]
        },
        {
          "model": "A4",
          "series": [
            "2.0t Premium",
            "Premium",
            "3.0/3.0 Special Edition",
            "Premium Plus",
            "2.0t/2.0t Special Edition",
            "3.0",
            "1.8t",
            "Allroad Premium Plus",
            "2.0t Premium/2.0t Tech Premium",
            "40 Premium/40 Titanium Premium",
            "2.0t",
            "45 Premium",
            "2.8 (a5)/2.8 (m5)",
            "2.8",
            "2.0t Tech Premium/2.0t Premium",
            "2.0t/se 2.0t",
            "3.2",
            "2.0t Prem",
            "3.2 Premium Plus",
            "2.0t Ultra Premium",
            "2.0t Qua Premium",
            "Technik Plus",
            "Premium 40 Tfsi Quattro S Tronic",
            "Quattro",
            "S-line 2.0t Cabriolet",
            "3.2 Cabriolet Quattro",
            "Quattro Cabriolet",
            "Premium 45",
            "3.2 Quattro",
            "3.0 Avant Quattro",
            "2.0t Quattro",
            "Premium S-line",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "2.0t Cabriolet Quattro",
            "Ultra Premium",
            "Premium Plus 40 Tfsi Front-wheel Drive S Tronic",
            "3.0 Quattro",
            "Prestige",
            "Premium Plus 40 Tfsi Quattro S Tronic",
            "Premium Plus 45",
            "40 Titanium Premium",
            "2.0t Tech Ultra Premium/2.0t Ultra Premium",
            "2 Turbo",
            "Premium 45 Tfsi Quattro S Tronic",
            "2.0t Cabriolet",
            "Allroad Prestige",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Premium 40",
            "Sedan",
            "Premium Plus S-line",
            "Prestige 45",
            "Komfort",
            "2.0t Special Edition",
            "2.0t Avant",
            "Premium 40 Tfsi Front-wheel Drive S Tronic",
            "1.8 T",
            "2",
            "Allroad Premium",
            "1.8t/1.8t Special Edition",
            "2.0t Special Edition/2.0t",
            "2.8 Quattro",
            "Prestige 40",
            "Premium/titanium",
            "2.0t Avant Quattro",
            "S-line 2.0t Turbo",
            "2.0t Season Of Audi Premium",
            "1.8t Quattro",
            "1.8t Special Edition",
            "Premium Plus 40",
            "S-line 2.0t Avant Quattro",
            "2.0t Season Of Audi Ultra Premium",
            "Komfort 45",
            "1.8 Cabriolet",
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "2.0t Tech Premium",
            "S-line 1.8 Turbo",
            "3.2 Avant",
            "40 Premium",
            "3.0l",
            "Premium Plus Fron 2.0t Premium",
            "3.2l",
            "1.8 T (a5) Quattro/1.8 T (m5) Quattro",
            "Tech Premium/premium",
            "1.8t Se",
            "S-line 2.0t Quattro Turbo",
            "1.8t Quattro/special",
            "2.0t Premium Plus",
            "3.2/3.2 Special Edition",
            "1.8t Avant Quattro",
            "Sedan Komfort 45",
            "Ultra Premium Plus",
            "S-line 3.2 Quattro",
            "Progressiv",
            "1.8t/1.8t Special",
            "2/turbo",
            "S-line 3.2 Cabriolet Quattro",
            "3.0 Cabriolet",
            "3.0 Avant",
            "1.8t Avant",
            "Technik",
            "S-line 2.0t Cab Quattro",
            "2.0t/2.0t Avant Special Edition",
            "Komfort Plus",
            "S-line 2.0t Cabriolet Quattro",
            "Sedan 40 Premium Premium 40 Tfsi Quattro S Tronic",
            "2.0t Qua Prem Plus",
            "1.8t Avant Special Edition",
            "3.2 Avant Quattro",
            "Prestige 45 Tfsi S Line Quattro S Tronic",
            "Premium/s-Line",
            "Progressiv Plus",
            "3.0 Quattro/special",
            "3.2 Qua",
            "Tech Premium",
            "2.0t Tech Ultra Premium",
            "Son Of Audi Premium",
            "Mium S-line",
            "Mium 40",
            "Prestig",
            "Premium/titanium Premium",
            "2.8 Avant",
            "Prestige 40 Tfsi Front-wheel Drive S Tronic",
            "Allroad",
            "Sedan S Line Premium Plus",
            "2.0t Prem Plus",
            "Season Of Audi Ultra Premium",
            "Ultra P",
            "2.8 Avant Quattro",
            "Sedan Technik",
            "Tech Premium Plus",
            "Sedan S Line Prestige",
            "2.0t Av",
            "Tdi S L",
            "S-line 3.0 Quattro",
            "Titanium Premium",
            "Premium Plus Quat 2.0t Premium",
            "Progres",
            "3.2 Cab",
            "3.2l Special Edition",
            "1.8 Cab",
            "3.0l Se",
            "1.8t Av",
            "Sedan Prestige",
            "T Premium",
            "T Premium Plus",
            "4d 2.0t Pres",
            "Sedan Premium Plus",
            "Season Of Audi Ultra",
            "2.0t Ca",
            "2.0t Premium  Plus",
            "3.2l Prem Plus",
            "2.0t Qu",
            "Premium Plus/s-line",
            "2.0t Prestige",
            "2.0t Pr",
            "Premium/tech Premium",
            "Season Of Audi Premium",
            "Sedan Premium",
            "Mium",
            "T Prestige",
            "S-Line",
            "Se 2.0t",
            "Mium/titanium",
            "Sedan S Line Premium",
            "Mium/titanium Premium",
            "Mium Plus S-line",
            "T",
            "Stige",
            "3.2 Ava",
            "3.2l Prestige",
            "Mium Plus",
            "Mium/tech Premium",
            "T Premium  Plus",
            "1.8t Qu",
            "Ra Premium",
            "Mium Plus 45",
            "3.0/3.0 Special Edition/3.0l Se",
            "Road",
            "1.8 Ava",
            "Cabriol",
            "2.8 Qua",
            "3.0 Ava",
            "S-line 3.2",
            "2.0 Tur",
            "Gres",
            "Quat 4d",
            "S2.0t Q",
            "2.8 Ava",
            "Fort",
            "Hnik",
            "S2.0t A",
            "2.0t S-line Quattro",
            "1.8t (a5)/1.8t (m5)",
            "2.8 Avant (a5)",
            "1.8t Avant/1.8t Avant Special Edition",
            "Premium Plus 45 Tfsi",
            "Uke S",
            "2.0t Tech Ultra",
            "1.8t Avant (a5)",
            "3.0 Qua",
            "Premium 40 Tfsi Quattro",
            "Prestige 45 Tfsi S Line",
            "Premium Plus 40 Tfsi",
            "1.8t Avant (a5)/1.8t Avant (m5)",
            "Ra P",
            "2.0t Season Of Audi",
            "Allrd Sw 4x4 2.0t Pres",
            "3.0 Cab",
            "Premium Plus 45 Tfsi S",
            "Premium 40 Tfsi",
            "Se 2.0t/2.0t",
            "2.8 (a5)",
            "Stig",
            "1.8 T/1.8t (m5)",
            "2.0t 2.0t",
            "Premium Premium",
            "2.0t Qu 2.0t Qu",
            "Uk",
            "Prestige 45 Tfsi Quattro S Tronic",
            "S-line 3.2 Avant Quattro",
            "Komfort Komfort",
            "Prestig Prestig",
            "3.2 Special Edition",
            "2.0t/2.0t Special Edition/se 2.0t",
            "Premium Automatic 2.0t Premium",
            "2.0t Komfort Plus",
            "2.0t Technik",
            "2.0t Avant/2.0t Avant Progressiv/2.0t Avant Special Edition",
            "Ultra Premium S T 2.0t Tech Ultra Premium/2.0t Ultra Premium",
            "2.0t Standard",
            "2.0t Ca 2.0t Ca",
            "2.0t Prem Plus/2.0t Premium",
            "2.0 Progressiv",
            "2.0t/2.0t Progressiv/2.0t Special Edition",
            "2.0t Progressiv",
            "2.0t Progressiv Plus",
            "2.0t Allroad Quattro",
            "S Line Premium",
            "2.0t 30 Years Of Quattro Edition/2.0t Premium",
            "45 Progressiv",
            "45 Komfort",
            "2.0 Komfort",
            "2.0t/2.0t Avant",
            "Avant Quattro",
            "2.0t Komfort",
            "2.0t Technik Plus",
            "45",
            "Technik 2.0 Tfsi Quattro",
            "Quatro Primium",
            "Premium Quattro A 2.0t Premium",
            "45 Technik",
            "40 Komfort",
            "S Line Premium Plus",
            "Sedan Komfort",
            "S-line 3.2 Cabriolet Quat"
          ]
        },
        {
          "model": "A4 allroad",
          "series": [
            "2.0t Premium",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "45 Premium",
            "Premium 45 Tfsi Quattro S Tronic",
            "Premium Plus",
            "Prestige",
            "Premium",
            "2.0t Premium/2.0t Tech Premium",
            "Tech Premium Plus",
            "Prestige/tech Prestige",
            "Premium Plus 45 Tfsi",
            "Prestige 45 Tfsi Quattro S Tronic",
            "Allroad",
            "2.0t Technik",
            "45 Progressiv",
            "Premi",
            "2.0t Progressiv",
            "2.0 Technik",
            "Komfort",
            "2.0t Premium Plus"
          ]
        },
        {
          "model": "A4 Quattro",
          "series": [
            "Cabriolet",
            "Plus S-line",
            "Plus",
            "Ttro",
            "Quattro"
          ]
        },
        {
          "model": "A5",
          "series": [
            "2.0t Premium",
            "Premium Plus S-line",
            "Premium Plus",
            "Premium",
            "45 Premium",
            "Premium Plus 40",
            "Cabriolet Premium 45 Tfsi Quattro S Tronic",
            "Premium 45",
            "Premium Plus 45",
            "Quattro",
            "Prestige",
            "Prestige S-line",
            "Premium 40",
            "Prestige 45",
            "3.2l",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Premium S Line",
            "Technik",
            "Cabriolet Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "2.0t Sport",
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "Cabriolet Prestige 45 Tfsi Quattro S Tronic",
            "3.2 Premium Plus",
            "Premium 45 Tfsi Quattro S Tronic",
            "Cabriolet Premium Plus 45 Tfsi Quattro S Tronic",
            "Sport",
            "2.0t Quattro",
            "Progressiv S-line",
            "Komfort 45",
            "Iner M2 112 Medium Duty",
            "Coupe S Line Premium",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "Technik S-line",
            "Prestige 40",
            "Prestig",
            "2.0t Prestige",
            "Progressiv",
            "Cabriolet Premium 45",
            "Cabriolet",
            "Cabriolet Premium 45 Tfsi S Line Quattro S Tronic",
            "Coupe S Line Prestige",
            "Cabriolet Premium Plus",
            "Progres",
            "Technik 2.0 Tfsi Quattro",
            "Coupe Premium Plus S-line",
            "Sportba",
            "Cabriolet Sport",
            "2.0l Premium",
            "2.0t Premium Plus",
            "Cabriolet Prestige",
            "Coupe Premium Plus",
            "2.0l Premium Plus",
            "Coupe",
            "Coupe Premium",
            "3.2l Prestige",
            "2.0l Prestige",
            "Coupe S Line Premium Plus",
            "3.2l Premium Plus",
            "Coupe Prestige",
            "Cabriolet Premium",
            "Coupe Sport",
            "Cabriolet Premium Plus 45",
            "S-Line",
            "Cabriol",
            "Komfort",
            "Prestige 45 Tfsi S Line Quattro S Tronic",
            "Coupe Premium Plus 45 Tfsi",
            "Premium Automatic 2.0t Premium",
            "Cabriolet S Line Premium Plus",
            "Noline E350 Cutaway Van",
            "Coupe Premium 45 Tfsi S Line",
            "20t Qu",
            "Premium Plus Quat 2.0t Premium",
            "Premium Premium",
            "Premium 40 Tfsi Quattro S Tronic",
            "Coupe Premium 45 Tfsi Quattro S Tronic",
            "Coupe Premium Plus 45 Tfsi Quattro S Tronic",
            "Coupe Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "Cabriolet Prestige 45 Tfsi S Line Quattro S Tronic",
            "2.0t Quattro Cabriolet",
            "Premium Plus 40 Tfsi Quattro S Tronic",
            "2.0t Komfort",
            "2.0t Premium Plus/2.0t S Line Competition",
            "2.0t Progressiv Plus",
            "45 Technik",
            "2.0t Technik",
            "3.2",
            "2.0t Progressiv",
            "2.0t/2.0t Premium",
            "2.0 Komfort",
            "2.0t",
            "Technik 45 2.0 Tfsi Quattro",
            "2.0t Technik/2.0t Technik Plus",
            "2.0 Progressiv",
            "3.2l (a6)",
            "Prestige 45 Tfsi Quattro S Tronic",
            "3.2l/3.2l (a6)",
            "45 Progressiv"
          ]
        },
        {
          "model": "A5 Quattro",
          "series": [
            "Plus",
            "Quattro"
          ]
        },
        {
          "model": "A5 Sportback",
          "series": [
            "Premium 40 Tfsi Quattro S Tronic",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "Premium 45 Tfsi Quattro S Tronic",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Premium Plus 40 Tfsi Quattro S Tronic",
            "Prestige 45 Tfsi Quattro S Tronic",
            "S Line Premium",
            "Premium Plus 45",
            "Technik",
            "Prestige 45 Tfsi S Line Quattro S Tronic",
            "Premium Plus",
            "Premium 40",
            "Premium 45",
            "Premium Plus 40",
            "Prestige S-line",
            "S Line Prestige",
            "Premium Plus S-line",
            "Premium",
            "S Line Premium Plus",
            "Prestige",
            "Premium Plus 45 Tfsi",
            "Premium 45 Tfsi S Line",
            "Premium Plus 40 Tfsi",
            "Premium 40 Tfsi Quattro",
            "Prestige 45 Tfsi S Line",
            "Premium 45 Tfsi Quattro",
            "Premium Plus 45 Tfsi S",
            "Prestige 40 Tfsi Quattro S Tronic",
            "45 Prem 45 Premium"
          ]
        },
        {
          "model": "A6",
          "series": [
            "2.0t Premium",
            "3.2",
            "2.0t Premium/2.0t Sport",
            "Premium Plus",
            "Premium",
            "Premium 45 Tfsi Quattro S Tronic",
            "55 Premium",
            "Prestige",
            "3.0 Premium",
            "3.0t Premium Plus",
            "Sedan Premium Plus 45 Tfsi Quattro S Tronic",
            "2.7t (a5)/2.7t (m6)",
            "3.2 (a6)",
            "2.7t S-line",
            "2.0t Premium Plus",
            "3.2 Quattro",
            "3.0t Premium",
            "4.2 Quattro",
            "3.2 Premium",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Competition Prestige",
            "4.2",
            "3.0",
            "4.2 Prestige",
            "Premium 55 Tfsi Quattro S Tronic",
            "Premium Plus 55 Tfsi Quattro S Tronic",
            "2.7t",
            "45 Premium",
            "Allroad Prestige",
            "Premium/sport",
            "Technik",
            "S-line 4.2 Quattro",
            "Sedan Premium Plus 55 Tfsi Quattro S Tronic",
            "2.8 Quattro",
            "Avant Quattro",
            "Premium 45 Tfsi Quattro S Tronic/sport Premium 45 Tfsi Quattro S Tronic",
            "Sport Premium Plus 45 Tfsi Quattro S Tronic",
            "3.0 Quattro",
            "3.0 Avant Quattro",
            "3.0 Tdi Premium Plus",
            "2.0t Sport/2.0t Premium",
            "3.0t Competition Prestige",
            "3.0t Premium/3.0t Sport",
            "Premium Plus 45 Tfsi Quattro S Tronic/sport Premium Plus 45 Tfsi Quattro S Tronic",
            "3.2 Avant",
            "4.2l (a5)",
            "2.7t Quattro",
            "S-line 3.2 Avant Quattro",
            "2.8 Avant Quattro",
            "2.8",
            "Avant",
            "3.0t Quattro",
            "3",
            "S-line Quattro",
            "S-line 3.2 Quattro",
            "4.2 (a6)",
            "2.8 Avant",
            "3.0l",
            "2.0t Quattro",
            "Sport Premium 45 Tfsi Quattro S Tronic",
            "Allroad Premium Plus",
            "Quattro",
            "Quattro Prog/technik S Ln",
            "Premium/sport Premium",
            "Prestige 55 Tfsi Quattro S Tronic",
            "3.2l Premium",
            "Sedan Premium Plus",
            "Prestig",
            "3.2 Quattro Awd",
            "L Quattro",
            "Competi",
            "3.0t Prestige",
            "3.2 S-line Quattro",
            "Quattro Wagon",
            "Quattro Progressiv/technik S Line",
            "Mium/sport",
            "T Premium",
            "Mium Plus",
            "3.2 Qua",
            "Sport",
            "4.2 Qua",
            "3.0t Prestige *ltd Avail*",
            "L Premium Plus",
            "Stige",
            "Allroad",
            "3.0 Qua",
            "L Tdi Prestige",
            "L Tdi Premium Plus",
            "3.0l Tdi Prestige",
            "T Prestige",
            "Mium",
            "3.0t",
            "T Premium Plus",
            "Sedan Premium",
            "Stig",
            "3.2l Premium Plus",
            "3.2l",
            "3.0t Prem Plus *ltd",
            "4.2l",
            "4.2l Prestige",
            "Sport/premium",
            "3.0l Tdi Premium Plus",
            "Sport Premium",
            "Ttro",
            "Premium Quattro Awd Tf Premium",
            "2.8 Qua",
            "Premium Plus 45 Tfsi Quattro S Tronic/sport Premium Plu",
            "Technik Quattro",
            "S-line 3.2",
            "2.0t Qu",
            "55 Premium Plus Q 55 Premium",
            "Sedan",
            "3.2 Pre",
            "Peti",
            "2.8 Ava",
            "Avant Q",
            "Series",
            "Sedan Premium 45 Tfsi Quattro S Tronic",
            "2.0t Prm",
            "3.0l (a5)",
            "S-Line",
            "2.7t Qu",
            "Sedan Sport Premium Plus 45 Tfsi Quattro S Tronic/premium Plus 45 Tfsi Quattro S Tronic",
            "Sedan Premium Plus 55 Tfsi",
            "2.7t (a5)",
            "3.0 Ava",
            "3.0l (cvt)",
            "Base (a5)/celebrate",
            "Sedan Premium 45 Tfsi Quattro",
            "Avant (a5)",
            "Base (a5)",
            "Progressiv",
            "Prestige Quattro 3.0t Premium Plus",
            "Premium Premium",
            "Prestig Prestig",
            "Sedan Premium 55 Tfsi Quattro S Tronic",
            "Progres",
            "4d 2wd",
            "Sedan Premium 45 Tfsi Quattro S Tronic/sport Premium 45 Tfsi",
            "Road",
            "Sedan Premium 45 Tfsi Quattro S Tronic/sport Premium 45 Tfsi Quattro S Tronic",
            "Sedan Sport Premium 45 Tfsi Quattro S Tronic",
            "Premium 45 Tfsi Quattro S Tronic/sport Premium 45 Tfsi",
            "Sedan Prestige 55 Tfsi Quattro S Tronic",
            "2.0t Sport",
            "Premium Plus Fron 2.0t Premium Plus",
            "Premium Plus Quat 3.0t Premium Plus",
            "Progressiv S-line",
            "2.0 Technik",
            "3.0t Progressiv",
            "Avant/celebrate",
            "2.0t Progressiv/2.0t Technik",
            "3.0 Special Edition",
            "3.0 Progressiv",
            "45 Premium Quattr 45 Premium",
            "Tdi Technik",
            "Premium Plus S-line",
            "2.0t Progressiv",
            "3.0t Technik",
            "Tdi Progressiv",
            "55 Technik"
          ]
        },
        {
          "model": "A6 allroad",
          "series": [
            "Prestige 55 Tfsi Quattro S Tronic",
            "Premium Plus 55 Tfsi Quattro S Tronic",
            "Prestige",
            "Premium Plus",
            "S",
            "Attro"
          ]
        },
        {
          "model": "A6 Quattro",
          "series": [
            "*ltd Avai 3.2"
          ]
        },
        {
          "model": "A7",
          "series": [
            "3.0t Premium Plus",
            "Premium",
            "Prestige",
            "Premium Plus",
            "3.0t Premium",
            "Premium Plus S-line",
            "Competition Prestige",
            "Prestige S-line",
            "55 Premium",
            "3.0 Tdi Premium Plus",
            "3.0 Prestige",
            "Quattro Progressiv/technik S Line",
            "Technik 3.0 Tfsi Quattro",
            "Quattro Prog/technik S Ln",
            "3.0t Competition Prestige",
            "E Premium Plus",
            "Technik",
            "Prestig",
            "Competi",
            "3.0t Quattro",
            "3.0",
            "T Progressiv",
            "Progres",
            "Stig",
            "Mium",
            "Stige",
            " Premium Plus",
            "Mium Plus",
            "Stige S-line",
            "3.0 Tdi Prestige",
            "Quattro",
            "3.0 Premium Plus",
            " Prestige",
            " Premium",
            "3.0 Premium",
            "3.0t Technik",
            " Tdi Prestige",
            "Mium Plus S-line",
            "3.0t",
            "Peti",
            "E Prest",
            "Ttro",
            "E Premi",
            "Petition Prestige",
            "T Premium Plus",
            " Tdi Premium Plus",
            "Premium Premium",
            "Prestig Prestig",
            "E Prestige",
            "3.0t Progressiv/3.0t Technik",
            "Premium Plus 55 Tfsi Quattro S Tronic"
          ]
        },
        {
          "model": "A7 Quattro",
          "series": [
            "Progressiv/technik S Line",
            "Plus",
            "Premium",
            "Quattro"
          ]
        },
        {
          "model": "A7 Sportback",
          "series": [
            "Premium Plus 55 Tfsi Quattro S Tronic",
            "E Premium Plus",
            "Prestige S-line",
            "Premium Plus 55 Tfsi E Quattro S Tronic",
            "Prestige 55 Tfsi Quattro S Tronic",
            "Technik",
            "Prestige 55 Tfsi E Quattro S Tronic",
            "E Prestige",
            "Premium 55 Tfsi Quattro S Tronic"
          ]
        },
        {
          "model": "A8",
          "series": [
            "L 4.2",
            "3.0t",
            "L 3.0t",
            "L Quattro",
            "4.2 Quattro",
            "4.2",
            "L Tdi Quattro",
            "L",
            "Quattro",
            "L 55",
            "L 55 Tfsi Quattro Tiptronic",
            "L 4.0t Sport",
            "L 4.0t",
            "L W12 Quattro",
            "L 60 Tfsi Quattro Tiptronic",
            "L L Quattro",
            "L L 4.2 (a6)",
            "4.0t",
            "L L",
            "L 3.0 Tdi",
            "4.2 (a6)",
            "L 3.0l",
            "Premium Plus",
            "L L Tdi Quattro",
            "L L Quattro/sport",
            "L Quattro/sport",
            "Quattro Iv",
            "L Tdi Q",
            "L Quatt",
            "W12",
            "L E",
            "4.2 Qua",
            "L 4.2 (a5)",
            "Ttro",
            "Uatt",
            "T",
            "Uattro",
            "L 4.0l",
            "L W12 Q",
            "4.0l",
            "L 3.0l Tdi",
            "L 6.3l",
            "4.2l",
            "Uattro/sport",
            "3.0l",
            "L Sport",
            "L 4.2l",
            "Di Q",
            "Uat",
            "3.7",
            "Quat",
            "Di Quattro",
            "L 55 (tiptronic)",
            "L W12 (a6)",
            "4.2/4.2 (a5)",
            "55",
            "4.0t Sport",
            "1.8t",
            "3.2 Quattro",
            "55 Tfsi Quattro Tiptronic",
            "4.2 Quattro A"
          ]
        },
        {
          "model": "A8 Quattro",
          "series": [
            "O",
            "Quattro"
          ]
        },
        {
          "model": "allroad",
          "series": [
            "2.0t Premium Plus",
            "2.7t",
            "2.0t Premium",
            "Quattro",
            "4.2",
            "Premium Plus",
            "Premium",
            "Prestige",
            "2.7l",
            "Ad Premium Plus",
            "2.7l (a5)/2.7l (m6)",
            "4.",
            "Plus",
            "Base (a5)/base (m6)"
          ]
        },
        {
          "model": "e-tron GT",
          "series": [
            "Premium Plus Quattro",
            "Prestige",
            "Premium Plus",
            "Prestige Quattro",
            "Premium"
          ]
        },
        {
          "model": "e-tron",
          "series": [
            "Premium Plus",
            "Premium Plus Quattro",
            "Premium Quattro",
            "Premium",
            "Prestige",
            "Sportback Premium Plus",
            "Sportback Premium",
            "Chronos",
            "Prestige Quattro",
            "Pre",
            "Chronos Quattro",
            "Sportback Prestige",
            "Pro",
            "Spo",
            "Progressiv",
            "Chr",
            "Premiumwe",
            "55 Technik",
            "55 Progressiv"
          ]
        },
        {
          "model": "e-tron S",
          "series": [
            "Premium Plus",
            "Prestige Quattro",
            "Premium Plus Quattro",
            "Prestige",
            "P",
            "S",
            "Sportback Prestige"
          ]
        },
        {
          "model": "e-tron S Sportback",
          "series": [
            "Prestige",
            "Prestige Quattro",
            "Premium Plus",
            "Premium Plus Quattro"
          ]
        },
        {
          "model": "e-tron Sportback",
          "series": [
            "Premium Plus Quattro",
            "Premium Plus S Line Quattro",
            "Prestige S Line Quattro",
            "S Line Premium",
            "Prestige Quattro",
            "Prestige",
            "Premium S Line Quattro",
            "Progressiv",
            "Premium Quattro",
            "Premium",
            "Premium Plus",
            "Sportback Premium",
            "S Line Premium Plus",
            "S Line Prestige",
            "Sportback Premium Plus",
            "Premium Plus S Line"
          ]
        },
        {
          "model": "Q2",
          "series": []
        },
        {
          "model": "Q2 Quattro",
          "series": []
        },
        {
          "model": "Q3",
          "series": [
            "Premium S Line 45",
            "2.0t Premium",
            "2.0t Premium Plus",
            "Premium 45 Tfsi S Line Quattro Tiptronic",
            "Premium Plus",
            "Premium",
            "Premium Plus S Line 45",
            "Prestige",
            "Premium Plus S-line",
            "Premium Plus 45 Tfsi S Line Quattro Tiptronic",
            "Premium 40",
            "Premium 45 Tfsi Quattro Tiptronic",
            "2.0t Sport Premium",
            "2.0t Premium/2.0t Sport Premium",
            "Premium S Line",
            "Premium 40 Tfsi Quattro Tiptronic",
            "4p Ti",
            "Prestige S-line",
            "Premium Plus 40",
            "Komfort 45",
            "2.0t S Line Premium",
            "Premium Plus 40 Tfsi Quattro Tiptronic",
            "Premium Plus 45 Tfsi Quattro Tiptronic",
            "2.0t Sport Premium/2.0t Premium",
            "Technik",
            "Prestig",
            "Allroad Prestige",
            "Prestige 45 Tfsi S Line Quattro Tiptronic",
            "Premium S Lin",
            "Progres",
            "Komfort",
            "Sport Premium",
            "4d 4wd 2.0t Prem",
            "S Line Premium",
            "Premium/sport Premium",
            "2.0t Prestige",
            "S Line Premium Plus",
            "Sport Premium Plus",
            "S Line Prestige",
            "Technik 45",
            "Premium 45 Tfsi S Line",
            "2.0t Pr",
            "Premium Plus 45 Tfsi",
            "Premium Plus 45 Tfsi S",
            "Premium 40 Tfsi Quattro",
            "Premium Premium",
            "Prestig Prestig",
            "45 Progressiv",
            "40 Komfort",
            "2.0t Technik",
            "45 Komfort",
            "2.0t Komfort",
            "Progressiv 45 2.0 Tfsi",
            "45 Komfort/45 Progressiv",
            "Komfort 45 2.0 Tfsi",
            "45 S Line Premium Premium 45 Tfsi S Line Quattro Tiptronic",
            "Progressiv",
            "Technik 45 2.0 Tfsi",
            "Se",
            "2.0t Progressiv",
            "45 Technik",
            "3.0 Quattro"
          ]
        },
        {
          "model": "Q3 Quattro",
          "series": []
        },
        {
          "model": "Q4 e-tron",
          "series": [
            "Premium Plus 40 Rwd",
            "Prestige 50 Quattro",
            "Sportback Premium Plus",
            "Premium Plus",
            "Premium 50 Quattro",
            "Premium Plus 50 Quattro",
            "Premium",
            "Prestige",
            "Premium Plus S-line",
            "Sportback Premium",
            "Technik",
            "Sportback Prestige",
            "Sportback Prem Plus S Line",
            "Premium 40 Rwd",
            "Premium Plus 55 Quattro",
            "Prestige S-line",
            "Progressiv",
            "Sportback Prem Plus S Lin",
            "Premium 55 Quattro",
            "Prestige 55 Quattro",
            "50",
            "50 Premium Premium Plus 50 Quattro",
            "Komfort",
            "Sportback",
            "50 Progressiv",
            "55",
            "Premium 45 Quattro",
            "Sportback Prestige S Line"
          ]
        },
        {
          "model": "Q4 e-tron Sportback",
          "series": [
            "Premium Plus 50 Quattro",
            "Premium 50 Quattro",
            "Prestige 50 Quattro",
            "Premium Plus 55 Quattro",
            "Sportback Premium Plus",
            "Premium Plus",
            "Sportback Premium",
            "Prestige",
            "Prestige 55 Quattro",
            "Premium 55 Quattro"
          ]
        },
        {
          "model": "Q5",
          "series": [
            "3.0t Premium Plus",
            "Premium Plus",
            "Premium 45 Tfsi S Line Quattro",
            "2.0t Premium/2.0t Tech Premium",
            "2.0t Premium",
            "Premium Plus 45 Tfsi S Line Quattro",
            "3.2 Premium Plus",
            "Premium",
            "Premium 45",
            "3.2 Premium",
            "2.0t Tech Premium/2.0t Premium",
            "3.0 Tdi Premium Plus",
            "45 Premium",
            "Premium Plus 45",
            "3.2",
            "Tdi Premium Plus",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "Premium Plus S-line",
            "Sportback Prm Pls 45",
            "Prestige",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Premium Plus 40 Tfsi Quattro S Tronic",
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "Premium 45 Tfsi Quattro S Tronic",
            "Premium Plus 55 Tfsi E S Line Quattro S Tronic",
            "Prestige 45 Tfsi Quattro S Tronic",
            "Premium Plus 40",
            "Prestige 45 Tfsi S Line Quattro S Tronic",
            "E Premium Plus",
            "Prestige 45",
            "E Premium Plus 55",
            "Prestige 40",
            "E Premium",
            "Prestige S-line",
            "Premium Hybrid",
            "Premium 40",
            "Premium 40 Tfsi Quattro S Tronic",
            "Sportback Premium 45",
            "Progressiv S-line",
            "Technik",
            "E Prestige 55",
            "Titanium Premium Plus 45 Tfsi Quattro S Tronic",
            "V6",
            "E Premium 55",
            "Tdi/premium Plus",
            "Premium Plus 55 Tfsi E Quattro S Tronic",
            "Hybrid 2.0t Prestige",
            "E Prestige",
            "Sportback Premium Plus",
            "Premium 55",
            "3.2l Premium Plus",
            "Premium 45 Tfsi Quattro S Tronic/titanium Premium 45 Tfsi Quattro S Tronic",
            "Titanium Prestige",
            "Premium 55 Tfsi E S Line Quattro S Tronic",
            "Premium 55 Tfsi E Quattro S Tronic",
            "Prestige 55 Tfsi E S Line Quattro S Tronic",
            "Tdi Prestige",
            "Technik S-line",
            "Plus S-line",
            "Premium/titanium Premium",
            "2.0t Premium Plus",
            "Premium S-line",
            "Sportback Premium",
            "Sportback Prestige 45",
            "Titanium Premium Plus",
            "Progressiv",
            "Komfort",
            "2.0l Premium Plus",
            "40",
            "Tdi Premium Plus S-line",
            "Progressiv 45 2.0 Tfsi",
            "Plus",
            "45",
            "Plus 45",
            "S Line Premium Plus",
            "Plus 40",
            " Prestige",
            "Hybrid",
            "Titaniu",
            "Sportba",
            "Prestige 40 Tfsi Quattro S Tronic",
            "E Prest",
            "Mium",
            "Sportback Prestige",
            "2.0t Tech Premium",
            "Komfort 45",
            "Prestige 55 Tfsi E Quattro S Tronic",
            "Quattro",
            "E Premi",
            "V6 Tdi",
            "Prestig",
            "Prestige 55",
            "Mium/titanium Premium",
            "Tech Premium",
            "3.2l",
            "3.0l Tdi Technik",
            "Tech Prestige",
            " Pre",
            "S Line Premium",
            "S Line Prestige",
            "Mium/tech Premium",
            "Progres",
            "3.0l Premium",
            "Stige",
            "L Premium Plus",
            "L Prestige",
            "Ine Premium",
            "T Premium",
            "Mium Plus 45",
            "Stig",
            "Tdi Tec",
            "Ine Premium Plus",
            "Mium Plus S-line",
            "Q-5",
            "Ine Prestige",
            "Stige Hybrid",
            "Mium 45",
            "Prestige/tech Prestige",
            "Tdi Pre",
            "Mium Plus",
            "3.2l Prestige",
            "Titanium Premium",
            "Premium/tech Premium",
            "/premium Plus",
            "Prestige Hybrid",
            "Tech Premium Plus",
            "3.2l Premium",
            "2.0l Progressiv",
            "Stige/tech Prestige",
            "T Premium Plus",
            "Mium Plus 40",
            "Remi",
            "Tdi/prestige",
            "Premium Plus Quat Premium Plus",
            "4d 4wd",
            "Premium 45 Tfsi Quattro S Tronic/titanium Premium 45 Tf",
            "Tdi Technik",
            "Tdi",
            "Rest",
            "Gres",
            "3.2 Pre",
            "Hnik",
            "Rtba",
            "Noline E450 Super Duty Cutaway Van",
            "-30 Preferred",
            "2.0t Progressiv",
            "Premium 45 Tfsi Quattro",
            "Premium Plus 45 Tfsi S",
            "Premium Plus 45 Tfsi",
            "Premium Plus 40 Tfsi",
            "Premium 40 Tfsi Quattro",
            "Premium Plus 55 Tfsi E S",
            "Tech Prestige/prestige",
            "Premium 45 Tfsi S Line",
            "Prestige 45 Tfsi S Line",
            "Technik/s-Line",
            "45 Titanium Premi Premium 45 Tfsi Quattro S Tronic",
            "2.0t Premium/tech Prestige",
            "Prestig Prestig",
            "Plus Quat 3.0t Premium Plus",
            "Plus Tfsi 2.0t Premium/2.0t Tech Premium",
            "Progressiv/s-Line",
            "Premium Plus/tech Premium Plus",
            "Komfort 45 2.0 Tfsi",
            "Tdi Pre Tdi Pre",
            "Progressiv 45 2.0 Tfsi Sb",
            "40 Pres",
            "2.0t Komfort",
            "3.2 3.2",
            "45 Progressiv",
            "Progres Progres",
            "2.0 Komfort",
            "3.0t Premium",
            "45 Technik",
            "Plus Quat 2.0t Premium",
            "3.2/3.2 Premium",
            "2.0t Technik",
            "45 Komfort",
            "3.0t Progressiv",
            "2.0 Progressiv",
            "Tdi Prestige S-line",
            "2.0 Technik",
            "3.0 Tdi Technik",
            "3.0 Tdi Progressiv",
            "Tdi  Pr",
            "3.0 Progressiv",
            "3.0t Technik",
            "3.0t Premium/3.0t Premium Plus",
            "2.0t",
            "45 S Line Premium Premium 45 Tfsi S Line Quattro",
            "Tdi Technik S-line",
            "40 Komfort",
            " Sportback Premium Plus",
            "Tdi/technik",
            "Technik 45 2.0 Tfsi",
            "Titanium Prestige 45 Tfsi Quattro S Tronic",
            "2.0t Tech Premium/premium",
            "Tdi/technik/s-Line",
            "3.0 Technik"
          ]
        },
        {
          "model": "Q5 PHEV",
          "series": [
            "4d"
          ]
        },
        {
          "model": "Q5 Sportback",
          "series": [
            "Premium 45 Tfsi S Line Quattro S Tronic",
            "Premium Plus 45 Tfsi S Line Quattro S Tronic",
            "Premium Plus 45 Tfsi Quattro S Tronic",
            "Prestige 45 Tfsi S Line Quattro S Tronic",
            "Sportback Prm Pls 45",
            "Prestige 45",
            "Sportback Premium 45",
            "S Line Premium Plus",
            "Premium 45 Tfsi Quattro S Tronic",
            "S Line Premium",
            "Premium Plus",
            "M Plus",
            "M",
            "Premium",
            "Sportback Premium Plus",
            "Premium 45",
            "Prestige",
            "S Line Prestige",
            "Prm Pls 45",
            "Premium 45 Tfsi S Line",
            "Prestige 45 Tfsi Quattro S Tronic",
            "45 S Li Premium Plus 45 Tfsi S Line Quattro S Tronic"
          ]
        },
        {
          "model": "Q7",
          "series": [
            "Premium Plus",
            "3.6 Premium",
            "3.0t S Line Prestige",
            "3.0t Premium",
            "3.0 Tdi Premium",
            "4.2 Premium",
            "Prestige",
            "Premium Plus 45 Tfsi Quattro Tiptronic",
            "4.2",
            "Premium",
            "55 Premium/55 Se Premium",
            "55 Premium",
            "2.0t Premium",
            "Prestige 55 Tfsi Quattro Tiptronic",
            "Premium 45 Tfsi Quattro Tiptronic",
            "45 Premium",
            "45 Premium/45 Se Premium",
            "Premium Plus 55 Tfsi Quattro Tiptronic",
            "3.6 Quattro",
            "3.6 Quattro Premium",
            "Tdi",
            "4.2 Quattro Premium",
            "Tdi Premium Plus",
            "Premium 55 Tfsi Quattro Tiptronic",
            "3.6 5 Passenger/3.6 Premium",
            "4.2 Prestige",
            "Premium Plus/se Premium Plus",
            "3.6",
            "Premium Plus/se Premium P",
            "4.2 Quattro",
            "Technik S-line",
            "(canada) Premium Plus",
            "Tdi Prestige",
            "Premium/se Premium",
            "3.0l Tdi Premium Plus",
            "V6",
            "4.2 Quattro S-line",
            "4.2l Premium",
            "Progressiv",
            "4.2 Qua",
            "Prestige S-line",
            "3.6 Quattro Premium S-line",
            "Technik",
            "4.2 Quattro Premium S-line",
            "Plus",
            "Komfort",
            "Prestig",
            "3.0 Tdi",
            "Tdi S-line",
            "3.0l Tdi Premium",
            "V6 Tdi",
            "3.6l Premium",
            "Tdi/premium Plus",
            "45 Se Premium",
            "45 Se Premium/premium",
            "S-line V6",
            "3.0l Premium Plus",
            "3.0t Premium Plus",
            "Tdi/prestige",
            "3.0l Premium",
            "Mium",
            "L Tdi Premium Plus",
            "Mium Plus/se Premium P",
            "L Premium",
            "Stig",
            "Mium Plus",
            "T Premium Plus",
            "Mium/se Premium",
            "3.6l",
            "L Tdi Premium",
            "Stige",
            "L Tdi Prestige",
            "3.0l Tdi Prestige",
            "Tdi Pre",
            "3.6 Qua",
            "3.6l Prestige",
            "3.0t S Line",
            "3.6l Premium Plus",
            "Premium Plus/prestige",
            "T S Line",
            "T S Line Prestige",
            "T Premium",
            "Progres",
            "L Premium Plus",
            "Tdi S-l",
            "4.2l Prestige",
            " Pre",
            "Gres",
            "Awd Pre",
            "Tdi Premium",
            "3.6 Qua 3.6 Qua",
            " Other 100",
            "3.6 Quattro Prem S-line",
            "L Prestige",
            "3.0t Pres",
            "/premium Plus",
            "2.0xt Premium",
            "Hnik S-line",
            "3.6 5 Passenger",
            "Premium 55 Tfsi Quattro",
            "Progressiv S-line",
            " Tdi Premium",
            "Mium Plus 55 Tfsi",
            "Premium Plus 55 Tfsi",
            "Prestige 55 Tfsi Quattro",
            "Premium 45 Tfsi Quattro",
            "Premium/55 Se Premium",
            "Plus Tfsi 3.0t Premium",
            "Prestig Prestig",
            "45 Premium Quattr Premium 45 Tfsi Quattro Tiptronic",
            "Tdi Pre Tdi Pre",
            "55 Prestige Quatt Prestige 55 Tfsi Quattro Tiptronic",
            "V8",
            "3.0 Premium",
            "45 Premium Plus Q Premium Plus 45 Tfsi Quattro Tiptronic",
            "3.0t Technik",
            "3.0t Vorsprung Edition",
            "300s",
            "4.2 Quattro Prem S-line",
            "55 Se Premium",
            "Sport",
            "3.0t Progressiv",
            "3.0t Sport",
            "Tdi Progressiv",
            "Tfsi",
            "Plus Quat 3.6 5 Passenger/3.6 Premium",
            "Tdi Technik",
            "3.0 Tdi Progressiv",
            "3.6 5 Passenger/3.6 Premium/prestige",
            "3.0 Premium Plus",
            "Premium 40",
            "55 Technik",
            "3.0 Tdi Vorsprung Edition",
            "55 Progressiv"
          ]
        },
        {
          "model": "Q8",
          "series": [
            "55 Premium",
            "Premium",
            "Prestige 55 Tfsi Quattro Tiptronic",
            "Prestige S-line",
            "Premium Plus S-line",
            "E-tron Sportback Premium Plus",
            "Prestige",
            "Premium Plus",
            "Premium Plus 55 Tfsi Quattro Tiptronic",
            "E-tron Premium Plus",
            "E-tron S Line Premium Quattro",
            "E-tron Prestige",
            "E-tron Sportback Prestige",
            "E-tron Premium Plus Quattro",
            "Premium 55 Tfsi Quattro Tiptronic",
            "E-tron Premium Quattro",
            "Progressiv",
            "Progressiv S-line",
            "E-tron S Line Premium Plus Quattro",
            "Plus S-line",
            "E-Tron",
            "Plus",
            "E-tron Premium",
            "Prestige 55 Tfsi Quattro",
            "E-tron Prestige Quattro",
            "Premium 55 Tfsi Quattro",
            "E-tron S Line Prestige Quattro",
            "E-tron Sportback Premium",
            "Progres",
            "Q8",
            "Prestig",
            "Mium Plus S-line",
            "Premium Plus 55 Tfsi",
            "E-tron Sportback",
            "55 Premium Plus Q 55 Premium",
            "55 Technik",
            "Premium Plus 55 Tfsi Quattro",
            "55 Progressiv",
            "Prestig Prestig",
            "Progressiv 55 3.0 Tfsi"
          ]
        },
        {
          "model": "R8",
          "series": [
            "4.2 Quattro",
            "5.2 Plus Quattro",
            "Rws",
            "5.2 Quattro",
            "Spyder V10 Quattro S Tronic",
            "V10 Performance Rwd S Tronic",
            "4.2",
            "Spyder Plus",
            "Spyder",
            "V10 Performance Quattro S Tronic",
            "5.2 V10",
            "5.2 V10 Plus",
            "5.2",
            "5.2 Plus",
            "Spyder V10",
            "5.2 Plu",
            "4.2 Qua",
            "5.2 Quattro Competition",
            "V10 Plus",
            "V8",
            "5.2l Gt",
            "Coupe V10",
            "V10",
            "Coupe V10 Plus",
            "4.2l",
            "Coupe",
            "Spyder V10 Performance",
            "5.2l",
            "5.2 Qua",
            "Coupe V10 Performance",
            "Spyder V10 Performance Quattro S Tronic",
            "Spyder V10 Performance Rwd S Tronic",
            "Gt",
            "5.2 V10/5.2 V10 Plus",
            "V10 Gt Rwd S Tronic",
            "5.2 Plu 5.2 Plu",
            "V10 Rwd S Tronic",
            "V10 Quattro S Tronic"
          ]
        },
        {
          "model": "RS e-tron GT",
          "series": [
            "Quattro",
            "Performance"
          ]
        },
        {
          "model": "RS Q3",
          "series": []
        },
        {
          "model": "RS Q8",
          "series": [
            "Tfsi Quattro Tiptronic",
            "Q8",
            "4.0t"
          ]
        },
        {
          "model": "RS3",
          "series": [
            "2.5t",
            "Sedan",
            "Tfsi Quattro S Tronic",
            "3 Premium Plus",
            "3",
            "3 2.0t Premium",
            "3 Premium",
            "3 2.0t Premium Plus",
            " 2.5t",
            " Tfsi Quattro S Tronic",
            "E350 4 Matic 2.0t Premium",
            " Sedan",
            "2.0t Premium",
            "Sedan Tfsi Quattro S Tronic",
            "2.5t (s Tronic)"
          ]
        },
        {
          "model": "RS5",
          "series": [
            "2.9t",
            "Tfsi Quattro Tiptronic",
            "4.2",
            " Coupe",
            "S5 Rs5",
            " Coupe +",
            "Rs 5 Tfsi",
            "Rs 5 Carbo",
            "Rs 5 Audi",
            "Fsi Qu",
            " 4.2",
            "Limite",
            " 2.9t",
            " Tfsi Quattro Tiptronic",
            "Rs5",
            "2.9"
          ]
        },
        {
          "model": "RS5 Sportback",
          "series": [
            "Tfsi Quattro Tiptronic",
            " Tfsi Quattro Tiptronic"
          ]
        },
        {
          "model": "RS6",
          "series": [
            "4.2",
            "S6 Rs6",
            "Tfsi Quattro Tiptronic"
          ]
        },
        {
          "model": "RS6 Avant",
          "series": [
            "Tfsi Quattro Tiptronic",
            " Tfsi Quattro Tiptronic",
            " Performance Tfsi Quattro Tiptronic",
            "Performance Tfsi Quattro Tiptronic",
            "4.0t Performance"
          ]
        },
        {
          "model": "RS7",
          "series": [
            "4.0t Prestige",
            "Performance",
            "Prestige",
            "4.0t Performance Prestige",
            "4.0t Performance",
            "S7 Rs7 Perfor",
            " Performance",
            " 4.0t Performance Prestige",
            " Prestige",
            "S7 Rs7",
            " Performance Prestige",
            "S7 Rs7 Presti",
            "Ormance",
            " 4.0t Performance",
            " 4.0t Prestige",
            "Performance/prestige",
            "Presti Rs7 Presti",
            "Perfor",
            "4.0t"
          ]
        },
        {
          "model": "RS7 Sportback",
          "series": [
            "Tfsi Quattro Tiptronic",
            " Tfsi Quattro Tiptronic",
            "Performance",
            "Performance Tfsi Quattro Tiptronic"
          ]
        },
        {
          "model": "S3",
          "series": [
            "2.0t Tech Premium Plus/2.0t Premium Plus",
            "Premium Plus",
            "Premium Tfsi Quattro S Tronic",
            "2.0t Premium Plus",
            "2.0t Premium Plus/2.0t Tech Premium Plus",
            "Prestige",
            "Premium",
            "Premium Plus Tfsi Quattro S Tronic",
            "Prestig",
            "Sedan Premium Plus",
            "Technik",
            "Mium Plus",
            "Mium",
            "Prestige/tech Prestige",
            "Ine Premium Plus",
            "Sedan Prestige",
            "T Prestige",
            "2.0t Prestige",
            "Stige",
            "S Line Premium",
            "S Line Premium Plus",
            "Tech Premium Plus",
            "Ine Premium",
            "Stig",
            "Premium Plus Tfsi",
            "T Premium Plus",
            "Sedan",
            "Premium Premium",
            "Prestige Tfsi Quattro S Tronic",
            "2.0t Progressiv",
            "2.0t Quattro",
            "2.0t Technik",
            "2.0t Komfort"
          ]
        },
        {
          "model": "S4",
          "series": [
            "3.0t Premium Plus",
            "Premium Plus",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Quattro",
            "Prestige",
            "Quattro Cabriolet",
            "4.2",
            "4.2 Avant",
            "3.0 Premium Plus",
            "3.0t Premium",
            "Avant Quattro",
            "Premium",
            "2.7t",
            "Sedan",
            "3.0t Quattro",
            "2.7 Quattro",
            "Prestige Tfsi Quattro Tiptronic",
            "Technik Plus",
            "Tro",
            "Prestig",
            "Stige",
            "Mium Plus",
            "Rs4 S4",
            " S4 Quattro",
            "Rs4 S4 Quattro",
            "Mium",
            "Rs4 S4 Premium",
            "Rs4 S4 Prestig",
            "Sedan Premium Plus",
            "Rs4 S4 Technik",
            "Premium Tfsi Quattro Tiptronic",
            " S4 Avant Quattro",
            "Technik",
            "Base (a6)",
            "4.2 A6",
            "Prestige Tfsi Quattro",
            "Base (m6)",
            "Se",
            "2.7t (a5)/2.7t (m6)",
            "4.2/4.2 (a6)",
            "Premium S4 Premium",
            "4.2 (a6)",
            "Prestig S4 Prestig",
            "450 4matic",
            "3.0/3.0 Premium",
            "3.0t Progressiv/3.0t Progressiv Plus",
            "4.2 Quattro",
            "3.0",
            "3.0t",
            "3.0 Premium",
            "3.0 Technik",
            "3.0t Progressiv",
            "3.0t Technik"
          ]
        },
        {
          "model": "S5",
          "series": [
            "Premium Plus",
            "Cabriolet Premium Tfsi Quattro Tiptronic",
            "3.0t Premium Plus",
            "Prestige",
            "4.2 Special Edition",
            "4.2l",
            "3.0t Premium",
            "3.0 Premium Plus",
            "4.2 Premium Plus",
            "Quattro",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Coupe Premium Plus Tfsi Quattro Tiptronic",
            "Premium",
            "3.0t",
            "Prestige Tfsi Quattro Tiptronic",
            "Technik",
            "Cabriolet Premium Plus Tfsi Quattro Tiptronic",
            "Cabriolet Premium",
            "3.0t Quattro",
            "Cabriolet Prestige Tfsi Quattro Tiptronic",
            "3.0t Pr",
            "Cabriolet",
            "4.2 Quattro",
            "Quarttro",
            "Special Edition",
            "Coupe Premium",
            "Dynamic",
            "Prestig",
            "Rs5 S5 Premium",
            "Cabriolet Premium Plus",
            "Cabriolet Prestige",
            "Coupe",
            "Rs5 S5 Prestig",
            "Rs5 S5 Technik",
            "Stige",
            "Coupe Premium Plus",
            "Rs5 S5",
            "Coupe Prestige",
            "Mium Plus",
            "Rs5 S5 Quattro",
            "Rs5 S5 Progres",
            "Progressiv",
            "Mium",
            "Coupe Prestige Tfsi Quattro Tiptronic",
            "T Premium Plus",
            " Premium Plus",
            "4.2l (a6)/4.2l (m6)",
            "Premium Plus Manu 3.0t Premium Plus",
            "Premium S5 Premium",
            "Prestig S5 Prestig",
            "Premium Tfsi Quattro Tiptronic",
            "Quattro S5 Quattro",
            "3.0t Technik",
            "Progressiv 3.0 Tfsi Quattro",
            "4.2 Premium",
            "4.2",
            "3.0t Progressiv",
            "4.2/4.2 Metall",
            "3.0 Technik",
            "3.0 Progressiv"
          ]
        },
        {
          "model": "S5 Sportback",
          "series": [
            "Premium Plus Tfsi Quattro Tiptronic",
            "Premium Tfsi Quattro Tiptronic",
            "Premium Plus",
            "Prestige Tfsi Quattro Tiptronic",
            "Premium",
            "Prestige",
            "Premium Plus Tfsi",
            "Tfsi",
            "Technik"
          ]
        },
        {
          "model": "S6",
          "series": [
            "4.0t Premium Plus",
            "4.0t Prestige",
            "5.2",
            "Prestige",
            "Quattro",
            "Premium Plus",
            "Avant",
            "Premium Plus Tfsi Quattro Tiptronic",
            "5.2 Prestige",
            "Avant Quattro",
            "Rs6 S6 Prestig",
            "Prestige Tfsi Quattro Tiptronic",
            "Premium",
            "Rs6 S6 Premium",
            "Rs6 S6",
            "Rs6 S6 Quattro",
            "Prestig",
            "Sedan",
            "4.0t",
            "S6",
            "Sedan Premium Plus Tfsi Quattro Tiptronic",
            "Prestig S6 Prestig",
            "5.2 Quattro"
          ]
        },
        {
          "model": "S7",
          "series": [
            "Prestige",
            "4.0t Premium Plus",
            "Premium",
            "Premium Plus",
            "4.0t",
            "4.0t Prestige",
            "Rs7 S7 Prestig",
            "Rs7 S7 Premium",
            "Rs7 S7",
            "Prestig",
            "Rs7 S7 Quattro",
            "Prestig S7 Prestig",
            "Prestige Tfsi Quattro Tiptronic",
            "4.0",
            "4.0t Quattro"
          ]
        },
        {
          "model": "S7 Sportback",
          "series": [
            "Premium Plus Tfsi Quattro Tiptronic",
            "Prestige",
            "Prestige Tfsi Quattro Tiptronic",
            "Us"
          ]
        },
        {
          "model": "S8",
          "series": [
            "4.0t",
            "Quattro",
            "Plus Quattro",
            "4.0t Plus",
            "5.2",
            "Plus Qu",
            "Plus",
            "Ttro",
            "Tfsi Quattro Tiptronic",
            "4.0t (tiptronic)",
            "4.2l",
            "4.2",
            "Quattro Quattro"
          ]
        },
        {
          "model": "SQ5",
          "series": [
            "3.0t Premium Plus",
            "Prestige",
            "Premium Plus",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Prestige Tfsi Quattro Tiptronic",
            "Premium Tfsi Quattro Tiptronic",
            "Premiu",
            "3.0t Premium",
            "Premium",
            "Technik",
            "Sportback Prestige",
            "Presti",
            "Sportback Premium Plus",
            "Uattro",
            "Sportback Premium",
            "Sportb",
            "Techni",
            "Quattr",
            "3.0t Technik",
            "Premium Plus Tfsi",
            "Premiu Premiu",
            "Presti Presti",
            "Remium",
            "Progressiv 3.0 Tfsi Sb",
            "3.0t Dynamic Edition"
          ]
        },
        {
          "model": "SQ5 Sportback",
          "series": [
            "Prestige",
            "Premium",
            "Premium Plus",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Sportback Premium Plus",
            "Premium Tfsi Quattro Tiptronic",
            "Prestige Tfsi Quattro Tiptronic"
          ]
        },
        {
          "model": "SQ7",
          "series": [
            "Prestige Tfsi Quattro Tiptronic",
            "Prestige",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Premium Plus",
            "Premiu",
            "Presti",
            "Prestige Tfsi Quattro",
            "Presti Presti",
            "4.0t",
            "Sq7 Parts Only"
          ]
        },
        {
          "model": "SQ8",
          "series": [
            "Prestige",
            "Premium Plus",
            "Prestige Tfsi Quattro Tiptronic",
            "Premium Plus Tfsi Quattro Tiptronic",
            "Presti",
            "E-tron Prestige",
            "E-tron Sportback Premium Plus",
            "Premiu",
            "E-Tron",
            "Premium Plus 4.0 Tfsi Quattro",
            "E-tron Premium Plus",
            "E-tron Premium Plus Quattro",
            "4.0t"
          ]
        },
        {
          "model": "TT",
          "series": [
            "1.8l (a6)",
            "Premium Plus",
            "Quattro",
            "2.0t",
            "1.8l",
            "3.2",
            "1.8l (m6)",
            "Rs",
            "2.0t Premium Plus",
            "3.2 Quattro",
            "3.2l",
            "45 Tfsi Quattro S Tronic",
            "1.8l 180 Hp (m5)",
            "Prestige",
            "2.0t Premium",
            "225 Hp W/esp (m6)/225 Hp W/o Esp (m6) (discontinued)",
            "1.8l 225 Hp (m6)",
            "Rs Prestige",
            "1.8l/alms Commemorative Edition",
            "Premium",
            "45",
            "Prestig",
            "Quaro",
            "Coupe Quattro",
            "Alms Commemorative Edition",
            "Prestige/prem Plus",
            "Coupe",
            "Prem Plus/prestige",
            "Rs Pres",
            "3.2 Qua",
            "Roadster",
            "Prem",
            "2.0t Prestige",
            "Prem Plus",
            "Alms Edition",
            "2.0t Pr",
            "180 Hp (m5)",
            "225 Hp W/esp (m6)",
            "1.8l 225 Hp (m6)/alms Edition",
            "3.2l (auto Direct Shift)",
            "Alms Edition/1.8l 225 Hp (m6)",
            "180 Hp W/esp (m5)/180 Hp W/o Esp (m5) (discontinued)",
            "Roadster 45 Tfsi Quattro S Tronic",
            "225 Hp W/esp M6/225 Hp W/o Esp M6 Discontinued",
            "T-Type",
            "Coupe 45 Tfsi Quattro S Tronic",
            "S Coupe",
            "3.2 Quaro",
            "2.0t Quattro",
            "Ltima 2.5",
            "Prestige Quattro 2.0t Premium Plus",
            "Quattro Special"
          ]
        },
        {
          "model": "TT Quattro",
          "series": [
            "Special"
          ]
        },
        {
          "model": "TT RS",
          "series": [
            "2.5t",
            "Prestige",
            "Tfsi Quattro S Tronic",
            "2.5 M6 No Longer Orderable"
          ]
        },
        {
          "model": "TT RS Quattro",
          "series": []
        },
        {
          "model": "TTS",
          "series": [
            "2.0t",
            "2.0t Premium Plus",
            "Premium",
            "Prestige",
            "2.0t Premium",
            "Tfsi Quattro S Tronic",
            "Premium Plus",
            "2.0t Prestige",
            "Prem Plus",
            "Premiu",
            "Prem/prem Plus/prestige",
            "Presti",
            "Coupe Tfsi Quattro S Tronic"
          ]
        },
        {
          "model": "TTS Quattro",
          "series": []
        }
      ]
    },
    {
      "make": "BMW",
      "models": [
        {
          "model": "1 Series",
          "series": [
            "I",
            "128i",
            "135i",
            "Performance",
            "135 I",
            "Activehybr",
            "128 I",
            "I/is",
            "R",
            "128i Sulev",
            "100rs",
            "S",
            "135i/135is",
            "135is",
            "M",
            "X3 Xdrivem30i",
            "128i Sulev 128i",
            "Ormance",
            "40i",
            "128",
            "135",
            "Rid 3",
            "28i",
            " 40i",
            "Lev",
            "Ev",
            "35i"
          ]
        },
        {
          "model": "2 Series",
          "series": [
            "Xdrive",
            "Gran Coupe I Sdrive",
            "228i Xdrive",
            "Sdrive",
            "I",
            "I Sulev",
            "I Xdrive",
            "228i",
            "Gran Coupe I Xdrive",
            "Sulev",
            "Xi Sulev",
            "Xi",
            "230i Xdrive",
            "230i",
            "Gran Coupe",
            "228 Xi Sul",
            "228xi",
            "M235i",
            "228 Xi",
            " Coupe Sdrive",
            "28i",
            " Coupe Xdrive",
            "E",
            "228 I",
            "M240i",
            "228 I Sule",
            "Sule",
            "L",
            "M235i Xdrive",
            "Ive",
            "Ve",
            "230xi",
            "M240i Xdrive",
            "M",
            "Ev",
            "Sul",
            "Lev",
            "I/sulev",
            "Xi/sulev",
            "2d",
            "Coupe I Xdrive",
            "Coupe I Sdrive",
            " Coupe",
            "Coupe",
            "Ulev",
            "Sule 228 I Sule",
            "I Sdrive",
            "Sul 228 Xi Sul",
            "Gran Coupe Xdrive",
            "35i",
            "228i Rwd I Sulev"
          ]
        },
        {
          "model": "3 Series",
          "series": [
            "Xdrive",
            "I",
            "M340i Xdrive",
            "Gran Turismo Xdrive",
            "Iperformance",
            "Sulev",
            "325i",
            "328xi",
            "330i",
            "330e",
            "I Automatic",
            "Ci",
            "M340i",
            "328i",
            "330ci",
            "Ti Automatic",
            "I Sulev",
            "Ic Automatic",
            "Xi Sulev",
            "E",
            "325xi",
            "328i Xdrive",
            "328ci",
            "D",
            "2.8l",
            "330i Xdrive",
            "330e Xdrive",
            "I/is",
            "M3",
            "325ci",
            "Xi",
            "335i",
            "Xit",
            "It",
            "Is Sulev",
            "Is Automatic",
            "I Xdrive",
            "328ica",
            "1.9l",
            "328ic",
            "I Automatic/is Automatic",
            "Is",
            "320i",
            "Gran Turismo 328i Xdrive",
            "Xigt",
            "D Xdrive",
            "335i Xdrive",
            "4d Awd",
            "Ci Sulev",
            "E Automatic",
            "Ic",
            "340i Rwd",
            "320i Xdrive",
            "Ti",
            "340i Xdrive",
            "Automatic",
            "Touring",
            "Cabriolet",
            "Gran Turismo Xigt",
            "Xdri",
            "335 Xi",
            "340i",
            "I/xdrive",
            "328 Xi Sul",
            "335 I Sule",
            "320 Xi",
            "328 I Sule",
            "320 I",
            "328 Xi",
            "340 I",
            "328 I",
            "330xi",
            "330xe",
            "328 Ic Aut",
            "328 D Xdri",
            "340 Xi",
            "335 I",
            "328d Xdrive",
            "325 Is",
            "330 I",
            "330 Xi",
            "318 I",
            "335is",
            "335 Xigt",
            "335 Is",
            "330 Xigt",
            "E Automatic/automatic",
            "330 Ci",
            "323i",
            "328 D",
            "D/xdrive",
            "Sul",
            "Xigt Sulev",
            "328 Xigt",
            "318",
            "320",
            "320 I Xdri",
            "Ve",
            "L",
            "S",
            "328 Xigt S",
            "335 D",
            "Gran Turismo",
            "Gran Tur 328i Xdrive",
            "Ev",
            "Omatic",
            "323ci",
            "335xi",
            "325 It Sul",
            "328it",
            "325 Is Sul",
            "328 It",
            "325 Xit",
            "323 I",
            "325i Auto/",
            "325 It",
            "325ix",
            "325",
            "325 Ci Sul",
            "328",
            "325 Ci",
            "325 I Auto",
            "325 Xi",
            "325 I",
            "3 Ser",
            "328xd Spor",
            " Turismo Xdrive",
            "Rid 3",
            "Lev",
            "335d",
            "340 Xigt",
            "330e Iperformance",
            "Formance",
            "325i Autom",
            "330",
            "323",
            "V",
            "Gran Turismo Xigt/sulev",
            "Activehybrid 3",
            "328 Xit",
            "Ive",
            "Gran Turismo 335i Xdrive",
            "328d",
            "328ic Auto",
            "340xi Gt",
            "323 It",
            "340xi",
            "318 Euro",
            "328d Rwd",
            "328xi Sule",
            "330xi Gt",
            "Sule",
            "Gran Turismo 335 335i Xdrive",
            "328i Xdrive Awd 328i Xdrive",
            "3 Series",
            "Parts******",
            "4d 4x4",
            "Ced/advanced+/presti",
            "4d",
            "500 Slt",
            "Tomatic",
            "Ulev",
            "Rive",
            "0 Xi",
            " Turismo Xigt",
            "340i Xdrive Xdrive",
            "               328 I",
            " Turismo Xigt Sulev",
            "3",
            "328i Autom",
            "Su",
            "335",
            "Gt",
            "Gt S",
            "328 I Auto",
            "328i Sulev",
            "335i Xdrive Xdrive",
            "Sul 328 Xi Sul",
            "Atic",
            "Xdri 320 I Xdri",
            "318ia",
            "320i Rwd",
            "               Ix Xdrive5",
            "Gran Turismo Xigt Sulev",
            "330i Xdrive Xdrive",
            "328i Rwd",
            "S 4d Sedan 330i Xdrive Msport",
            "328i Xdrive Xdrive",
            "Xdrive/xdrive Classic Line",
            "Xdri 328 D Xdri",
            "Xdrive Touring",
            "330i 330i",
            "28i",
            "330i Rwd",
            "Ix Xi",
            "T",
            "Ix Automatic",
            " 35",
            "335i Xdrive Xi",
            "Sule 328 I Sule",
            "320i Xdrive/xdrive",
            "2.5 S"
          ]
        },
        {
          "model": "4 Series",
          "series": [
            "M440i Xdrive",
            "Xdrive",
            "Gran Coupe Xdrive",
            "Gran Coupe",
            "Gran Coupe I Gran Coupe Sulev",
            "430i",
            "I Sulev",
            "Gran Coupe Xi Gran Coupe Sulev",
            "I",
            "I Gran Coupe Sulev",
            "Gran Coupe I Gran Coupe",
            "I Gran Coupe",
            "Gran Coupe 430i Xdrive",
            "Xi Gran Coupe Sulev",
            "Gran Coupe 430i Xdrive Gran Coupe",
            "Gran Coupe 430i",
            "430i Xdrive",
            "M440i",
            "Xi Gran Coupe",
            "Xi",
            "435i Xdrive",
            "428i Xdrive",
            "Sulev",
            "435 I Gran",
            "Gran",
            "428 Xi",
            "430xi",
            "435 I",
            "440i",
            "428 I",
            "440i Gran",
            "430i Gran",
            "440xi Gran",
            "428 Xi Gra",
            "430xi Gran",
            "435 Xi",
            "428 I Sule",
            "428 I Gran",
            "440i Xdrive Hybrid",
            "Xi Sulev",
            "435i",
            "430i Gran C",
            "435 Xi Gra",
            "Gra",
            "N",
            "440xi",
            "Sule",
            "Coupe Xdrive",
            "An Coupe",
            " Coupe Xdrive",
            "Oupe Sulev",
            " Coupe",
            "N Coupe",
            "L",
            "A",
            "Ive",
            "E",
            "Upe Sulev",
            "Ve",
            "Oupe",
            "Upe",
            "440i Xdrive",
            "428i",
            "Upe/sulev",
            "428 Xi Sul",
            "428i Gran",
            "I/sulev",
            "435",
            "I/gran Coupe/sulev",
            "I/gran Coupe",
            "Xi/gran Coupe",
            "N Coupe Sulev",
            "N Coupe/sulev",
            "An Coupe/sulev",
            "Xi/gran Coupe/sulev",
            "Ev",
            "Oupe/sulev",
            "An Coupe Sulev",
            "Lev",
            " Coupe 430i",
            " Coupe 435i",
            "C",
            " Coupe 428i",
            "Coupe",
            "Coupe 428i",
            " Coupe 440i",
            "Coupe Xi Gran Coupe Sulev",
            "428xi",
            " Coupe Gran Coupe",
            " Coupe I Gran Coupe",
            "Coupe I Gran Coupe Sulev",
            "Gran Coupe Gran Coupe",
            " Coupe I Gran Coupe Sulev",
            "Coupe I Gran Coupe",
            "Coupe Xi Gran Coupe",
            "Ulev",
            " Coupe Xi Gran Coupe Sulev",
            "428",
            "4",
            "435xi",
            "Gran 430xi Gran",
            "Gran 440xi Gran",
            "Gran 430i Gran",
            "Gran 428 I Gran",
            "Gran 435 I Gran",
            "430i Xdrive 430i Xdrive",
            "435i Xdrive Xdrive",
            "Gran 440i Gran",
            "435i Rwd",
            "Gran Coupe Xi Gran Coupe",
            "Sul",
            "S 4d Sedan 430i Gc Msport",
            "Sule 428 I Sule",
            "Gra 428 Xi Gra",
            "S 2d Convertible 430i Msport",
            "S 4d Sedan 430i Gc Xdrive Msport",
            " 35",
            "Gran Coupe 428i"
          ]
        },
        {
          "model": "5 Series",
          "series": [
            "I Automatic",
            "Xdrive Iperformance",
            "Xdrive",
            "I",
            "530ia",
            "Iperformance",
            "Automatic",
            "528ia",
            "I Xdrive",
            "Gran Turismo Xdrive",
            "Gran Turismo",
            "M550i Xdrive",
            "Xi",
            "535i",
            "528i",
            "540i Xdrive",
            "Xigt",
            "D Xdrive",
            "D",
            "535i Xdrive",
            "540iat",
            "525i",
            "540ia",
            "530i",
            "530i Xdrive",
            "525ia",
            "540i",
            "528i Xdrive",
            "525xi",
            "Gt",
            "Xit",
            "550i",
            "Gran Turismo Xigt",
            "Gran Turismo 535i",
            "E",
            "It Automatic",
            "Gran Turismo Igt",
            "Hybrid",
            "540 I Auto",
            "540 I",
            "530 Xi",
            "540 Xi",
            "535 I",
            "528i Xdrive Xdrive",
            "530xe",
            "528 Xi",
            "530 I",
            "528 I",
            "530e",
            "535 Xi",
            "550 I",
            "530xi",
            "E Automatic",
            "535 Gt",
            "535 Xigt",
            "520",
            "Xdri",
            "Hybr",
            "530e Iperformance",
            "535 Igt",
            "Igt",
            "Omatic",
            "525ita",
            "525iat",
            "Tomatic",
            " Turismo",
            "528xi",
            "M5",
            "525 I",
            "530 I Auto",
            "525 It",
            "525 Xi",
            "545 I",
            "530 Xit",
            "545i",
            "535",
            "525 It Aut",
            "530",
            "530xit",
            "533 I",
            "Ve Iperformance",
            "528",
            "535xit",
            "545ia/545i",
            "535xi",
            "525",
            "540ita",
            "R",
            "5",
            "Ve",
            "535d",
            "Gran Turismo 535i Xdrive",
            "525 I Auto",
            "525it",
            "Activehybrid 5",
            "Ive",
            "550 Xi",
            "Gran Turismo 550i",
            "540 It Aut",
            "535 D",
            "Formance",
            "Gran Turismo 550i Xdrive",
            "550 Xigt",
            "Gran Turismo Gt",
            "535 D Xdri",
            "535d Xdrive",
            "550i Xdrive",
            "530e Xdrive Iperformance",
            "Rid 5",
            "540",
            "540xd",
            "0 Xi",
            " I",
            "550 Gt",
            "D/xi",
            "I/hybrid",
            "530e Xdrive",
            "535 I Hybr",
            "550 Igt",
            "4d 4wd 528xi",
            "530i 530i",
            "535i Rwd 535i",
            "540d Xdrive",
            "4d",
            " Turismo 535i",
            " Turismo Xdrive",
            "Rid",
            " Turismo Xigt",
            " Turismo Gt",
            " Turismo Igt",
            "               528 I",
            "550",
            "S 4d Sedan 530i Msport",
            "535d Xdriv",
            "Awd",
            "Atic",
            "530i Xdrive Xdrive",
            "540i Xdrive Xdrive",
            "Gt 535 Gt",
            "It",
            "I Hybrid",
            "Sport",
            "4d 4wd",
            "Is",
            "M",
            "Elctr",
            "Series",
            "Xe"
          ]
        },
        {
          "model": "6 Series",
          "series": [
            "Xdrive",
            "Gran Turismo Xdrive",
            "I Gran Coupe",
            "650i",
            "I",
            "Xigt",
            "650i Xdrive",
            "Xi",
            "Ci Automatic",
            "Xi Gran Coupe",
            "645ci",
            "650 I Gran",
            "640i",
            "640 Xi Gra",
            "650 Xi Gra",
            "640 Xigt",
            "640 I Gran",
            "650 I",
            "Gran Turismo Xigt",
            "635 Csi",
            "An Coupe",
            "A",
            "650 Xi",
            "640 I",
            "Gra",
            "I/gran Coupe",
            "Gran",
            "Xi/gran Coupe",
            "Tomatic",
            "N Coupe",
            "650ci",
            "M6",
            " Xdrive",
            "Upe",
            "Oupe",
            "N",
            "640i Xdrive",
            "Alpina B6",
            "645 Ci Aut",
            "640 Xi",
            "Ve",
            "40i",
            "645",
            "640xi",
            "650",
            "Alpina B6 Xdrive",
            " Coupe",
            " Coupe Xdrive",
            " Coupe 640i",
            " Turismo Xdrive",
            " Coupe 650i",
            " Coupe I Gran Coupe",
            " Coupe Xi Gran Coupe",
            " Turismo Xigt",
            " Coupe I",
            " Coupe Xi",
            "T 645 Ci Aut",
            "Utomatic",
            "Utomatic L6",
            "35i"
          ]
        },
        {
          "model": "7 Series",
          "series": [
            "740il",
            "740i",
            "Xdrive",
            "745li",
            "I",
            "I Xdrive",
            "Li",
            "750i",
            "Xi",
            "750li",
            "745e Xdrive Iperformance",
            "Lxi",
            "Iperformance",
            "Il Automatic",
            "I Automatic",
            "740i Xdrive",
            "740ia",
            "745i",
            "750i Xdrive",
            "Il",
            "Automatic",
            "740 Li",
            "750 I",
            "740 Lxi",
            "Na B7 Swb",
            "750 I Xdri",
            "Xdrive Iperformance",
            "740 Xi",
            "Alpina B7",
            "750i Xdriv",
            "750 Il",
            "740 I",
            "750 Xi",
            "745xe",
            "750 Li",
            "750lxi",
            "Xdr",
            "750 Lxi",
            "I/xdrive",
            "Ld Xdrive",
            "740li",
            "Omatic",
            "745 I",
            "750",
            "740 Il",
            "Series 7",
            "               750 Li",
            "V",
            "760 I",
            "R",
            "750li Xdrive",
            "Na B7",
            "Ina B7 Lwb",
            "750li/alpina B7 Lwb",
            " Xdrive",
            "750i/alpina B7",
            "740 I Auto",
            "760li",
            "Ive",
            "Alpina B7 Xdrive",
            "740 Xe",
            "740li Xdrive",
            "Ina B7",
            "750i/alpina B7 Swb",
            "745 Li",
            "760 Li",
            "Ve",
            "Alpina B7/750li",
            "750li/alpina B7",
            "Vehybrid",
            "Ivehybrid",
            "/750li",
            "Ve Iperformance",
            "750 Li Xdr",
            "740e Xdrive Iperformance",
            "4d",
            "Brid",
            "750i Activehybrid",
            "750li Activehybrid",
            "740 Ld Xdr",
            "Alpina B7 Swb",
            "Li/xdrive",
            "740ld Xdrive",
            "745e Xdrive",
            "Alpina B7 Lwb Xdrive",
            "750li Xdri",
            "M760i Xdrive",
            "Alpina B7 Lwb",
            "Rive",
            "Xdri",
            "Activehybrid 7 L",
            "760i",
            "7",
            "740",
            "750xia",
            "760i Xdrive",
            "/alpina B7",
            "750il",
            "750il Xdri",
            "750 Xi 4d",
            " M Sport",
            "740 Li Hyb",
            "750lxia",
            "750xi",
            "B",
            "Li Xdrive",
            "7 Series 750li Xdrive",
            "Tomatic",
            "Alpina B7 Xdrive/750i Xdrive",
            "750i Xdrive/xdrive",
            "750i Xdrive Xi",
            "Xdr 750 Li Xdr",
            "750li Rwd",
            "Xe",
            "740ia I Automatic"
          ]
        },
        {
          "model": "8 Series",
          "series": [
            "M850i Xdrive",
            "Xdrive",
            "I",
            "Gran Coupe I Xdrive",
            "Gran Coupe I",
            "Ci Automatic",
            "Gran Coupe",
            "I Xdrive",
            "M850i",
            "840i",
            "Ive",
            " Coupe Xdrive",
            " Coupe 840i",
            "840xi",
            " Coupe",
            "Coupe I",
            "Coupe I Xdrive",
            "Ve",
            "Coupe",
            "Tomatic",
            "Omatic",
            "Ev",
            "M850i Xdriv Xdrive"
          ]
        },
        {
          "model": "ActiveHybrid 3",
          "series": [
            "Hybr"
          ]
        },
        {
          "model": "ActiveHybrid 5",
          "series": []
        },
        {
          "model": "ActiveHybrid 7",
          "series": [
            "Li"
          ]
        },
        {
          "model": "Alpina B6 Gran Coupe",
          "series": [
            "N Coupe",
            "Xdrive"
          ]
        },
        {
          "model": "Alpina B6 xDrive Gran Coupe",
          "series": []
        },
        {
          "model": "Alpina B7",
          "series": [
            "Xdrive",
            "Xi",
            "Lxi",
            "Li",
            "Lpina B7",
            "Alpina B7",
            "750li"
          ]
        },
        {
          "model": "Alpina B7 xDrive",
          "series": []
        },
        {
          "model": "Alpina B7L",
          "series": []
        },
        {
          "model": "Alpina B7L xDrive",
          "series": []
        },
        {
          "model": "Alpina B8 Gran Coupe",
          "series": [
            "Xdrive",
            "Rive"
          ]
        },
        {
          "model": "Alpina XB7",
          "series": [
            "Alpina Xb7"
          ]
        },
        {
          "model": "i3",
          "series": [
            "Base W/range Extender",
            "Bev",
            "Rex",
            "94 Ah W/range Extender",
            "94 Ah",
            "120ah W/range Extender",
            "120ah",
            "94ah",
            "94ah W/range Extender",
            " I Sulev",
            "Eries I3 Rex",
            "Eries I3 Bev",
            "Ah W/range Extender",
            "S",
            "Ev",
            "550 4matic",
            "Eries I3",
            "S Bev",
            "S Rex",
            "H W/range Extender",
            "E W/range Extender",
            "W/range Extender 94ah W/range Extender",
            "Bev I3 Bev",
            "Rex I3 Rex"
          ]
        },
        {
          "model": "i3s",
          "series": [
            "94ah W/range Extender",
            "Rex",
            "Bev",
            "S Bev",
            "94ah",
            "120ah W/range Extender",
            "120ah",
            "S Rex",
            " Rex",
            " Bev",
            "Ries I3 S Rex",
            "Ries I3 S Bev",
            "Rex I3 S Rex"
          ]
        },
        {
          "model": "i4",
          "series": [
            "Edrive40",
            "Edrive35",
            "M50",
            "Edrive 35",
            "Xdrive40",
            "Xdrive 40",
            "Edrive 40",
            "Edrive",
            "Edrive3",
            "Ive35",
            "Ive40",
            "Edrive4",
            "Xdrive"
          ]
        },
        {
          "model": "i7",
          "series": [
            "Edrive50",
            "Xdrive60",
            "M70",
            "Ive60",
            "Edrive5",
            "Xdrive6"
          ]
        },
        {
          "model": "i8",
          "series": [
            "Eries I8",
            "I8"
          ]
        },
        {
          "model": "iX",
          "series": [
            "Xdrive50",
            "M60",
            "Xdrive40",
            "Ive50",
            "Xdrive4",
            "Xdrive5"
          ]
        },
        {
          "model": "iX xDrive40",
          "series": []
        },
        {
          "model": "iX xDrive50",
          "series": []
        },
        {
          "model": "iX3",
          "series": []
        },
        {
          "model": "M135i",
          "series": []
        },
        {
          "model": "M140i",
          "series": []
        },
        {
          "model": "M2",
          "series": [
            "5i",
            "0i",
            "0xi",
            "5xi",
            "Competition",
            "Base (m6)",
            "Cs",
            "40i",
            "35xi",
            "35i",
            "Competi",
            "40xi",
            "I",
            "Petition",
            "Peti"
          ]
        },
        {
          "model": "M235i",
          "series": [
            "Gran Coupe Xdrive",
            "Xdrive",
            "Gran Coupe I Xdrive",
            "Gran Coupe",
            "I",
            "35i",
            "Es M235i",
            "Drive",
            "235i",
            "Ran Coupe I Xdrive",
            " 35xi",
            "Ran Coupe"
          ]
        },
        {
          "model": "M235i xDrive",
          "series": []
        },
        {
          "model": "M235i xDrive Gran Coupe",
          "series": []
        },
        {
          "model": "M240i",
          "series": [
            "Xdrive",
            " 40xi",
            "Awd",
            "40i",
            "M240i"
          ]
        },
        {
          "model": "M240i xDrive",
          "series": []
        },
        {
          "model": "M3",
          "series": [
            "Competition Xdrive",
            "Competition",
            "0xi",
            "Cs",
            "0i",
            "Oadster",
            "Oupe",
            "Sedan",
            "Automatic",
            " Xi",
            "Ci",
            "40xi",
            "40i",
            " I Sulev",
            "Competi",
            " I",
            "M Coupe",
            "Peti",
            "Petition Xdrive",
            " Europe",
            "M Roadster",
            "Petition",
            "I",
            "Bmw",
            "M3",
            "Competition M Xdrive",
            "Competi Competi",
            "Base (m6)",
            " I Automatic",
            "Competition Package",
            "4d",
            "Competition Xdriv Competition Xdrive"
          ]
        },
        {
          "model": "M340i",
          "series": [
            "40i",
            " 40xi",
            "I",
            "M340i Xdrive",
            "M340i",
            "40xi",
            "Xdrive"
          ]
        },
        {
          "model": "M340i xDrive",
          "series": []
        },
        {
          "model": "M4",
          "series": [
            "Cs",
            "Competition Xdrive",
            "Competition",
            "0xi",
            "0i",
            "Coupe",
            "Competi",
            "40xi",
            "40i",
            "Peti",
            "Petition Xdrive",
            "Gts",
            "I",
            "Petition",
            "Base (m6)",
            "Csl",
            "Competi Competi",
            "Competition M Xdrive",
            " I"
          ]
        },
        {
          "model": "M440i",
          "series": [
            " Coupe",
            "Xdrive",
            "Gran Coupe",
            " 40xi",
            "40i",
            " Gran Coupe",
            " Gra",
            "Es M440i Xdrive",
            "Gran",
            "40xi"
          ]
        },
        {
          "model": "M440i Gran Coupe",
          "series": [
            "Xdrive",
            "Gran Coupe"
          ]
        },
        {
          "model": "M440i xDrive",
          "series": []
        },
        {
          "model": "M440i xDrive Gran Coupe",
          "series": []
        },
        {
          "model": "M5",
          "series": [
            "0xi",
            "Competition",
            "Base",
            "Cs",
            "50xi",
            "M5 Competition",
            "E",
            "I",
            "Petition",
            "Base (a8)",
            "Base (dct)",
            "Bmw",
            "Base Base"
          ]
        },
        {
          "model": "M550i xDrive",
          "series": [
            "50xi",
            "Xdrive"
          ]
        },
        {
          "model": "M6",
          "series": [
            "Gran Coupe",
            "Gran Co",
            "N Co",
            "N Coupe",
            "San Marino"
          ]
        },
        {
          "model": "M6 Gran Coupe",
          "series": [
            "Gran Coupe"
          ]
        },
        {
          "model": "M760i xDrive",
          "series": []
        },
        {
          "model": "M760Li xDrive",
          "series": []
        },
        {
          "model": "M8",
          "series": [
            "0xi",
            "Competition",
            "Cabriolet Competition",
            "50xi",
            "I",
            "Petition",
            "Base (a8)"
          ]
        },
        {
          "model": "M8 Gran Coupe",
          "series": [
            "Competition",
            "Competition Gran Coupe"
          ]
        },
        {
          "model": "M850i xDrive",
          "series": [
            "Xdrive"
          ]
        },
        {
          "model": "M850i xDrive Gran Coupe",
          "series": []
        },
        {
          "model": "X1",
          "series": [
            "Sdrive28i",
            "Xdrive28i",
            "28i",
            "Xdrive35i",
            "M35i",
            "Sdrive2",
            "Xdrive2",
            "Sdrive28i Sports Sdrive28i",
            "Ive2",
            "Xdrive3",
            "Xdrive 28i Turbo",
            "Ive3",
            "Ive",
            "Ive28i",
            "Ive35i",
            "4d 4wd",
            "4d Sd 28i",
            "Xdrive",
            "Xdrive2 Xdrive2",
            "Xdrive35i Awd Xdrive35i",
            "Sdrive2 Sdrive2",
            "Xdrive28i Sports Xdrive28i",
            "E",
            "Xdrive28i/xdrive28i Essential"
          ]
        },
        {
          "model": "X2",
          "series": [
            "Sdrive28i",
            "Xdrive28i",
            "M35i",
            "E2",
            "Xdrive2",
            "Sdrive2",
            "I",
            "Ive2",
            "Ive28i",
            "X2",
            "Sdrive2 Sdrive2",
            "Xdrive2 Xdrive2"
          ]
        },
        {
          "model": "X3",
          "series": [
            "Xdrivem40i",
            "Xdrive35i",
            "Sdrive28i",
            "Xdrive30i",
            "M40i",
            "Xdrive28i",
            "Sdrive30i",
            "3.0si",
            "M Competition",
            "3.0i",
            "Xdrive28d",
            "2.5i",
            "M",
            "Phev Xdrive30e",
            "Xdrive2",
            "Xdrive30e",
            "2.8i",
            "M X3 M/x3 M Competition",
            "Xdrive3",
            "28i",
            "M Competition/m",
            "30i",
            "Sdrive3",
            " Xi",
            "3.0i Suv",
            " Ic",
            "Sdrive30i Sports Sdrive30i",
            "Sdrive2",
            "3.5i",
            "M Compe",
            "Xdrivem",
            "Ive3",
            "Ive2",
            "Ive30i",
            "35i",
            " Sdrive30i",
            "Ive",
            "3.0",
            "2.5",
            "Ive28i",
            "Ivem40i",
            "Ive28d",
            "Ivem",
            "Ompe",
            "Ive30e",
            "Ompetition",
            "4d 4wd",
            "I",
            "Ive35i",
            "Drive",
            "Si",
            "Xdrive 28i",
            "25i",
            "M X3 M",
            "Xdrive",
            "Xd M40i",
            "Diesel",
            "Xd 28i",
            "Cv",
            "Sdrive",
            "Xdrive 30i Sports Xdrive30i",
            "M50 Xdrive",
            "Sdrive3 Sdrive3",
            "Xdrive3 Xdrive3",
            "28i Awd",
            "Competition",
            "30 Xdrive",
            "Xdrive28i Awd Xdrive28i",
            "Xdrivem Xdrivem",
            "30 Xdri",
            "Sdrive2 Sdrive2",
            " Ci",
            " Series X3 4d Suv 30i Xdrive Msport",
            "330xi",
            "M50",
            "Awd 3.0i",
            " Series X3 4d Suv 30i Sdrive Msport",
            "M40i Parts Only",
            "Xdrive28i Sports Xdrive28i",
            "M50 Xdrive Sports M50"
          ]
        },
        {
          "model": "X4",
          "series": [
            "Xdrive30i",
            "Xdrive28i",
            "Xdrive35i",
            "M40i",
            "Xdrivem40i",
            "M Competition",
            "M",
            "M Competition/m",
            "M X4 M",
            "I",
            "Xdrivem",
            "30i",
            "Xdrive3",
            "M Base (a8)",
            "M M Competition",
            "M M",
            "Ive2",
            "Ive3",
            "Xdrive2",
            "M Compe",
            "Ivem",
            "Ompe",
            "Ivem40i",
            "Ive35i",
            "Ive30i",
            "Ive28i",
            "Xd 28i",
            "Ompetition",
            "Xdrive3 Xdrive3",
            "Xdrive35d"
          ]
        },
        {
          "model": "X5",
          "series": [
            "Xdrive30i",
            "4.8i",
            "Xdr40e",
            "Xdrive35i",
            "3.0i",
            "Xdrive35i/xdrive35i Premium/xdrive35i Sport Activity",
            "Edrive Xdrive40e Iperformance",
            "Xdrive50i",
            "3.0si",
            "Xdrive40i",
            "Sdrive35i",
            "3.0",
            "Xdrive35d",
            "Edrive Xdrive40e",
            "M",
            "Xdrive50e",
            "Sdrive40i",
            "4.4i",
            "Xdrive48i",
            "Xdrive3",
            "Sdrive 40i",
            "4.4",
            "M50i",
            "Phev Xdrive45e",
            "4.8is",
            "Phev Xdrive50e",
            "I",
            "Xdrive45e",
            " Xi",
            "M X5 M Competition",
            "M60i",
            "M Competition",
            "Series",
            "35i",
            "4.6is",
            "Xdrivem40i",
            "35d",
            "Edrive Xdr40e",
            "M M",
            "3.5d",
            "Edrive",
            "3.5i",
            "E",
            "Sdrive30i",
            "48i",
            " I",
            "Sdrive",
            "Xdrive4",
            "Sdrive28i",
            "Sdrive3",
            "Xdrive5",
            "Series 4.6is",
            "3.0d M",
            "Ive3",
            "Ive4",
            "Ive5",
            "Ive35i",
            "Ive50i",
            "40e",
            "Ive35d",
            "Ive35i Premium",
            "Ive",
            "0i",
            "50i",
            "Xdrive40e Iperformance",
            "4.4l",
            "3.0l",
            "Ive30i",
            "Ive 40i",
            " Competition",
            "Ive50e",
            "Ive48i",
            "Ive45e",
            "30i",
            "Ive40i",
            "Ive40e Iperformance",
            " Premium",
            "35i Premium",
            "35i Sport Activity",
            "M/m Competition",
            ".0i",
            "M M/m Competition",
            "Ive35i/xdrive35i Premium/xdrive35i Sport Activity",
            "Xdrive28i",
            "M M Competition",
            "Xdri",
            "M Compe",
            "Xdrive35i Awd Xdrive35i",
            "Xdrive5 Xdrive5",
            "Limited",
            "Xdrive3 Xdrive3",
            "Xdr40e Xdr40e",
            "Xdrive4 Xdrive4",
            "Sdrive Sdrive",
            "40i",
            "M50i M50i",
            "Sdrive3 Sdrive3",
            "Xdrive35i Sports Xdrive35i",
            " Series X5 4d Suv 40i Sdrive Msport",
            " Series X5 4d Suv 40i Xdrive Msport",
            "Awd 4.8i",
            "Xdrive40e",
            "Xdrive40i Sports Xdrive40i"
          ]
        },
        {
          "model": "X6",
          "series": [
            "Xdrive35i",
            "Xdrive50i",
            "Xdrive40i",
            "M",
            "Sdrive35i",
            "M50i",
            "Sdrive40i",
            "M Competition",
            "Sdrive 40i",
            "Xdrive5",
            "35i",
            "M60i",
            "M/m Competition",
            "M M",
            "Xdrive3",
            "Hybrid",
            "M M Competition",
            "Xdrive4",
            "Sdrive3",
            "Ive3",
            "Ive",
            "Ive40i",
            "Rid",
            "Ive 50i",
            "Xdrive 50i",
            "Ive35i",
            "Xdrive40i Sports",
            "50i",
            "Ive50i",
            "I",
            "Ive5",
            "Ivehybrid",
            "Ive4",
            "Ive 40i",
            " Competition",
            "Idrive3",
            "M Compe",
            "Sdrive",
            "Activehybrid",
            "M X6 M",
            "Sdrive3 Sdrive3",
            "M50i M50i",
            "Xdrive3 Xdrive3",
            "Xdrive35i Sports Xdrive35i",
            " Series X6 4d Suv 40i Xdrive Msport"
          ]
        },
        {
          "model": "X7",
          "series": [
            "Xdrive50i",
            "Xdrive40i",
            "M50i",
            "Alpina Xb7",
            "M60i",
            "Xdrive4",
            "I",
            "Ive5",
            "Ive40i",
            "Ive4",
            "4d 4wd Xdrive 40",
            "Xdrive5",
            "Ina",
            "Ive50i",
            "Ina Xb7",
            "Alpina",
            "Xdrive 40i",
            "Xdrive4 Xdrive4"
          ]
        },
        {
          "model": "Z4",
          "series": [
            "Sdrive28i",
            "Sdrive35i",
            "Sdrive30i",
            "3.0i",
            "2.5i",
            "2.5",
            "M40i",
            "3.0",
            "3.0si",
            "Sdrive35is",
            "Sdrive3",
            "Sdrive2",
            "Ive2",
            "Ive3",
            "M",
            "Coupe",
            "I",
            "Sdrivem40i",
            "Ive30i",
            "Ive35is",
            "Ive35i",
            "Ive28i",
            "Sd 28i",
            "Sdrive3 Sdrive3",
            "M40i M40i"
          ]
        }
      ]
    },
    {
      "make": "Bentley",
      "models": [
        {
          "model": "Azure",
          "series": []
        },
        {
          "model": "Bentayga",
          "series": [
            "Mulliner/onyx Edition/w12/activity Edition/black Edition",
            "W12/w12 First Edition",
            "Hybrid",
            "Speed",
            "Activity Edition/black Edition/mulliner/onyx Edition/w12",
            "Azure/azure First Edition",
            "S/v8",
            "V8/first Edition",
            "V8",
            "First Edition/v8",
            "S",
            "W12 Signature",
            "V8/s",
            "W12",
            "Activity Edition/black Edition/mulliner/onyx Edition/w1",
            "V8/design Edition",
            "Design Edition/v8",
            "Bentayga"
          ]
        },
        {
          "model": "Continental",
          "series": [
            "Gt",
            "Gt V8",
            "Flying Spur",
            " Gt",
            " Gtc",
            "Gtc",
            " Gt V8 S",
            "Gt Gt",
            " Gt Speed",
            " Flying Spur",
            "Gt V8/v8 First Edition",
            "Gt V8 S",
            "Gt Speed",
            " Gt V8",
            " Flying Spur Speed",
            "Gt Mulliner/v8",
            "Gtc V8",
            "Gt Gt V8 S",
            " Gtc V8",
            "Gtc Speed",
            "Gt W12",
            " Gtc Speed",
            "Gt V8 Gtc V8",
            "Gtc V8 S",
            "Gt Supersports",
            "R",
            "Supersports",
            "Flying Spur Speed",
            "Supersports Supersports",
            "Flying Spur Flying Spur",
            "Gt V8/s",
            "Gt Gt Speed",
            "Super Sport",
            "Gt Speed Gt Speed",
            " R",
            "Gt Speed Speed",
            " Gt Supersports",
            " Gt3 R",
            "Gt Azure/mulliner V8/s",
            "Gtc Gtc",
            " Super Sport",
            "Gt A/azure/mulliner V8/s"
          ]
        },
        {
          "model": "Flying Spur",
          "series": [
            "V8",
            "W12",
            "V8 S",
            "Hybrid",
            "W12 S",
            "Azure/mulliner V8/s",
            "Mulliner W12/speed/speed Edition 12"
          ]
        },
        {
          "model": "Mulsanne",
          "series": [
            "Speed",
            "L",
            "S",
            "S Mulsanne S"
          ]
        }
      ]
    },
    {
      "make": "Bugatti",
      "models": [
        {
          "model": "Chiron",
          "series": []
        },
        {
          "model": "Divo",
          "series": []
        },
        {
          "model": "Veyron 16.4",
          "series": []
        }
      ]
    },
    {
      "make": "Buick",
      "models": [
        {
          "model": "Allure",
          "series": [
            "Cx",
            "Lacrosse Cxl",
            "Cxl",
            "Cxs",
            "Gx Select",
            "/lac",
            "Lacrosse Cx",
            " Preferred",
            " Essence",
            "Gx Preferred",
            "S",
            "Preferred",
            "Super Series",
            "Lacrosse Cxs",
            "Lac /lac",
            " Avenir",
            "E Cxs",
            " Custom",
            "E",
            "Super",
            " Premium",
            "Sport Touring",
            " Limited"
          ]
        },
        {
          "model": "Cascada",
          "series": [
            "Premium",
            "1sv",
            "Sport Touring",
            "Pr",
            "Sp",
            "Uring",
            "1s",
            "Pr Pr",
            "Sp Sp"
          ]
        },
        {
          "model": "Enclave",
          "series": [
            "Leather",
            "Awd Premium",
            "Essence",
            "Essence Fwd",
            "Premium",
            "Cxl",
            "1xl",
            "Fwd Premium",
            "Fwd Avenir",
            "Avenir",
            "Convenience",
            "2xl",
            "Fwd Essence",
            "Cx",
            "Awd Essence",
            "Premium Awd",
            "Awd Avenir",
            "Avenir Awd",
            " Essence",
            "Preferred",
            "Essence Awd",
            "Cxl1",
            "Premium Fwd",
            "Avenir Fwd",
            "Fwd Preferred",
            "Cxl W/2xl",
            "Cxl-1",
            "Cxl2",
            "Pr",
            "Cx Suv",
            "Nce",
            "Es",
            "Av",
            "L",
            "Cxl W/1xl",
            "Base",
            "D",
            "Cxl-2",
            "4d Prm",
            "4d Avenir",
            "Ir",
            "Av Av",
            "Onvenience",
            "Sport Touring",
            "Aw",
            "Cxl Awd",
            "Emium",
            "Sp",
            "Preferred Fwd",
            "Parts Only No Vehicle",
            "Sport Touring Fwd",
            "X Preferred",
            "Ssence"
          ]
        },
        {
          "model": "Enclave Avenir",
          "series": []
        },
        {
          "model": "Encore",
          "series": [
            "Convenience",
            "Essence",
            "Preferred Ii",
            "Fwd Essence",
            "Fwd Preferred",
            "Preferred",
            "Premium",
            "Leather",
            "Gx Select",
            "Awd Preferred",
            "Awd Sport Touring",
            "Sport Touring",
            "Gx Avenir",
            "Awd Essence",
            "Gx Preferred",
            "Gx Essence",
            "Fwd Sport Touring",
            "Gx Sport Touring",
            "Pre",
            "Fwd Encore 1sv",
            "Enience",
            "Ess",
            "Gx",
            "Spo",
            "Ouring",
            "Con",
            "Ed",
            "Ence",
            "Ed Ii",
            "Suv",
            " Essence",
            "Awd",
            "4d",
            "Fwd",
            "Ferred",
            "2lt",
            "Fwd1sv",
            "Sport",
            "Preferred Ii/sport Touring",
            "N Premium Ii"
          ]
        },
        {
          "model": "Encore GX",
          "series": [
            "Essence",
            "Fwd Preferred",
            "Fwd Select",
            "Preferred Fwd",
            "Select Fwd",
            "Select",
            "Essence Fwd",
            "Preferred",
            "Awd Essence",
            "Preferred Awd",
            "Awd Select",
            "Select Awd",
            "Essence Awd",
            "Sport Touring Awd",
            "Awd Preferred",
            "Sport Touring Fwd",
            "Fwd Essence",
            "Avenir Fwd",
            "Sport Touring",
            "Avenir Awd",
            "St",
            "Fwd",
            "Awd",
            "Red",
            "Avenir",
            "Gx",
            "Essence Essence"
          ]
        },
        {
          "model": "Envision",
          "series": [
            "Fwd Preferred",
            "Preferred",
            "Awd Premium I",
            "Fwd Essence",
            "Essence",
            "Premium Ii",
            "Essence Fwd",
            "Preferred Fwd",
            "Premium",
            "Awd Preferred",
            "Awd Essence",
            "Premium I",
            "Essence Awd",
            "Avenir",
            "E",
            "Fwd 1sv",
            "Fwd Avenir",
            "Turbo",
            "Awd Avenir",
            "Avenir Awd",
            "Avenir Fwd",
            "Preferred Awd",
            "Fwd Envision 1sv",
            "Essense Turbo",
            "Awd Premium Ii",
            "Sport Touring Awd",
            "P",
            "A",
            "I",
            "Awd",
            "Ce",
            "Wd",
            " Fwd",
            "Turbo 4p Ti",
            "A A",
            "Preferred Turbo",
            "Sport Touring",
            "S"
          ]
        },
        {
          "model": "LaCrosse",
          "series": [
            "Premium 1 Group",
            "Leather",
            "Premium 2 Group",
            "Premium Ii Group",
            "Cxl",
            "Cx",
            "Leather Group",
            "Cxs",
            "Premium",
            "Touring",
            "Preferred",
            "Essence",
            "Premium I Group",
            "Premium Ii",
            "Sport Touring",
            "Premium I",
            "Touring Group",
            "Premium 3 Group",
            "Convenience Group",
            "Super",
            "Fwd Essence",
            "Awd Essence",
            "Avenir",
            "Super Series",
            "Convenience",
            "1sv",
            "V6",
            "Fwd Preferred",
            "Cxl V6",
            "Base",
            "C",
            "P",
            "I",
            "T",
            "Premium 2",
            "S",
            "Ce",
            "A",
            "Premium 1",
            "E",
            "Premium 3",
            "Ring",
            "Crosse Cxl",
            "Na",
            "4d",
            "Awd Avenir",
            " Group",
            "Roup",
            "Fwd Sport Touring",
            "Awd Premium",
            "Fwd Avenir",
            "X",
            "1",
            "Cx 4 Cyl.",
            "T T",
            "Fwd Premium",
            "Xl",
            "Base Fwd",
            "F",
            "Cxs V6",
            "Crosse Cx",
            "Cx V6"
          ]
        },
        {
          "model": "Lucerne",
          "series": [
            "Cx",
            "Cxl",
            "Cxs",
            "Cxl Special Edition",
            "Cxl Premium",
            "Cx-2",
            "Super",
            "Cxl-3",
            "Cxl-5",
            "Super Series",
            "Cxl-4",
            "V6 Cxl",
            "Cxl V6",
            "Cx V6",
            "Cx/cx-2",
            "Cxl Special Edition *ltd",
            "Ial Edition",
            "D Avail*",
            "Cxl V8",
            "Ium",
            "Ial Edition *ltd",
            "Su",
            "Cxl-5 *ltd Avail*",
            "Td Avail*",
            "Cxl-3 *ltd Avail*",
            "Cxl-4 *ltd Avail*",
            "S",
            "Cxl/cxl Special Edition/cxl-3/cxl-4/cxl-5",
            "Super 1sp *ltd Avail*",
            "Ries",
            "Cx-2 *ltd Avail*",
            "V8 Cxl",
            " Cxl"
          ]
        },
        {
          "model": "Regal",
          "series": [
            "1fl",
            "Turbo",
            "Preferred",
            "Turbo Premium Ii",
            "Gs",
            "Custom",
            "Turbo - Premium 1",
            "Ls",
            "Turbo/e-assist Premium I",
            "Gse",
            "Premium 1",
            "Cxl Russelsheim",
            "Tourx Essence",
            "Sport Touring",
            "Cxl",
            "Cxl Turbo Russelsheim",
            "Premium",
            " S",
            "Essence",
            "Custom/gran Sport",
            "Turbo Gs",
            "Turbo - Premium 3",
            "T-Type",
            "Cxl Turbo To4",
            "Turbo Sport Touring",
            "1sv",
            "Preferred Ii",
            "Prem",
            "Tourx Preferred",
            "Cxl Oshawa",
            "Gs Cmi",
            "Turbo - Premium 2",
            "Cxl Rl5",
            "Premium 2",
            "Ls/lse",
            "Limited",
            "Gran Sport",
            "Cxl Turbo Oshawa",
            "Cxl Rl1",
            "Turbo Premium I",
            "Grand National",
            "Cxl Turbo To3",
            "Turbo Premium 1",
            "Esse",
            "Cxl Rl6",
            "Premium 3",
            "Cxl Turbo To5",
            "5",
            "4",
            "Spor",
            "1",
            "3",
            "Rbo To7",
            "Turbo W/1sr",
            "M 1",
            "Rbo To3",
            "Rbo To2",
            "W/1sr",
            "W/1sh",
            "Pref",
            "Base",
            "Tour",
            "Turbo Premium 2",
            "Cxl Rl2",
            "Premium Ii",
            "Cxl Rl3",
            "6",
            "2",
            "M 2",
            "M",
            "Ls Cmi",
            "Cxl Turbo To7",
            "Cxl Rl4",
            "Premium I",
            "Cxl Turbo To2",
            "Turbo Premium 3",
            "Cxl Turbo To6",
            "Touring",
            "M I",
            "M Ii",
            "Cxl Turbo To1",
            "Rbo To1",
            "Rbo To4",
            "4d Cxl",
            "Rbo To5",
            "Rbo To6",
            "Red",
            "Aven",
            "E",
            "Red Ii",
            "Avenir",
            "- Premium 1",
            "Sselsheim",
            "Hawa",
            "E-assist Premium I",
            "T-Ty",
            "Aven Aven",
            "Gs Gs",
            "Gs/gse",
            "Spor Spor",
            "Fwd Preferred",
            "Lse",
            "Cxl Turbo"
          ]
        },
        {
          "model": "Regal Sportback",
          "series": [
            "Essence",
            "Preferred Ii",
            "Awd Avenir",
            "Gs",
            "Preferred",
            "Fwd Preferred",
            "Fwd Preferred Ii",
            "Awd Preferred Ii",
            "Awd Gs",
            "Fwd Essence",
            "Awd Essence",
            "Avenir"
          ]
        },
        {
          "model": "Regal TourX",
          "series": [
            "Essence",
            "Awd Preferred",
            "Preferred",
            "Awd Essence"
          ]
        },
        {
          "model": "Verano",
          "series": [
            "Sport Touring",
            "Leather Group",
            "Sport Touring Group",
            "Convenience",
            "Premium Group",
            "Convenience Group",
            "1sv",
            "Premium",
            "Premium Turbo Group",
            "Turbo",
            "Ence Group",
            "W/1sb",
            "Spo",
            "Ouring",
            "Con",
            "Pre",
            " Group",
            "Base",
            "Ence",
            " Turbo Group",
            "Convenience 1",
            "4d",
            "Ibu 1lt",
            "Pre Pre",
            "Spo Spo",
            "Leather",
            "Leather Package"
          ]
        }
      ]
    },
    {
      "make": "Cadillac",
      "models": [
        {
          "model": "ATS",
          "series": [
            "Luxury",
            "Premium",
            "Performance",
            "Standard",
            "Luxury Collection",
            "V",
            "Premium Luxury",
            "Premiu",
            "Premium Performance",
            "Performance Collection",
            "Luxury Awd",
            "Premium Collection",
            "Standard Rwd",
            "Awd",
            "Turbo",
            "V6",
            "Sedan",
            "Perfor",
            "Sedan Luxury Awd",
            "Sedan Standard Rwd",
            "Standard Awd",
            "Sedan Luxury",
            "Coupe",
            "Sedan Luxury Collection Awd",
            "Coupe Luxury Collection Awd",
            "Premium Rwd",
            "Sedan Performance Awd",
            "Coupe Premium Luxury Rwd",
            "Luxury Rwd",
            "Sedan Premium Rwd",
            "Coupe Premium Rwd",
            "Coupe Performance Awd",
            "Coupe Performance Collection",
            "Coupe Premium Awd",
            "Sedan Performance Rwd",
            "Coupe Luxury Awd",
            "Coupe Performance Rwd",
            "Coupe Luxury Rwd",
            "Sedan Premium Awd",
            "Performance Awd",
            "Coupe Standard Awd",
            "Sedan Premium Luxury Awd",
            "Coupe Standard Rwd",
            "Sedan Awd",
            "Sedan Luxury Collection Rwd",
            "Sedan Rwd",
            "Coupe Luxury Collection Rwd",
            "Sedan Standard Awd",
            "Coupe Awd",
            "Sedan Premium Collection Rwd",
            "Sedan Luxury Rwd",
            "Sedan Premium Luxury Rwd",
            "Premium Awd",
            "Performance Rwd",
            "Sedan Performance Collection",
            "Coupe Premium Luxury Awd",
            "Coupe Premium Performance Rwd",
            "Sedan Performance",
            "Coupe Rwd",
            "-V",
            "Coupe Premium Collection Awd",
            "Seda",
            "Iu",
            "2d 2wd",
            "Sd",
            "V -v",
            "Or",
            "Sedan Premium Luxury",
            "Coupe Premium Collection Rwd",
            "Coupe Luxury",
            "Coupe Performance",
            "Sedan Premium Collection Awd",
            "Sedan Premium Performance Rwd",
            "Ry Rwd",
            "Ry",
            "Dard Rwd",
            "Ium",
            "Dard Awd",
            "Ry Awd",
            "Ormance",
            "Luxury Luxury",
            "Premiu Premiu",
            "Rwd",
            "Luxury Collection Awd",
            "Turbo Luxury",
            "Turbo Base",
            "Turbo Luxury Collection",
            "2.0l Turbo"
          ]
        },
        {
          "model": "CT4",
          "series": [
            "Luxury",
            "V",
            "Sport",
            "Premium Luxury",
            "Wing",
            "V-series Blackwing",
            "V-Series",
            "Luxury +",
            "Premiu",
            "Premium Luxury Special Edition",
            "V V-series",
            "Iu",
            "T",
            "V -v",
            "-V",
            "V Blackwing",
            "V V-series Blackwing",
            "V Blac",
            "Kwing",
            "Ry",
            "V-Blackwing",
            "Premium Luxury Special Ed",
            "Luxury Luxury",
            "Blackwing",
            "Premiu Premiu",
            "Sport Rwd",
            "4d Lux Luxury",
            "Premium Luxury Rwd"
          ]
        },
        {
          "model": "CT5",
          "series": [
            "Premium Luxury",
            "Sport",
            "Luxury",
            "V-Series",
            "Wing",
            "V",
            "Premium Luxury Special Edition",
            "V-series Blackwing",
            "Premium Collection",
            "Premiu",
            "-V",
            "Blackwing",
            "V V-series",
            "Iu",
            "V Blac",
            "Premium Luxury Special Ed",
            "V Blackwing",
            "Ries",
            "T",
            "Ry",
            "Ium Luxury",
            "V V-series Blackwing",
            "Sport Sport",
            "Premium Luxury Rwd",
            "V-series Rwd",
            "Sport Rwd"
          ]
        },
        {
          "model": "CT6",
          "series": [
            "Luxury",
            "Sport",
            "Standard",
            "Awd Premium Luxury",
            "Premium Luxury Csav",
            "Platinum",
            "Premium",
            "Premium Luxury",
            "Luxury Csav",
            "V",
            "Twin Turbo Premium Luxury",
            "Awd Blackwing",
            "Platinum Csav",
            "Sport Csav",
            "Sedan Platinum Awd",
            "Luxury Awd",
            "Plug-in Premium Luxury",
            "Premium Collection",
            "Sedan",
            "Twin Turbo Luxury",
            "Platin",
            "Premium Luxury Awd",
            "Sedan Luxury",
            "Sedan Premium Luxury Awd",
            "Sedan Plug-in Rwd",
            "Sedan Luxury Awd",
            "Sedan Awd",
            "Sedan Rwd",
            "Sedan Sport Awd",
            "Sedan Premium Luxury",
            "Sedan Luxury Rwd",
            "Premiu",
            "Plug-in Standard",
            "V Blackwing",
            "V Awd Blackwing",
            "Iu",
            "-V",
            "In",
            "Ry Csav",
            "Ry Awd",
            "Ium Luxury Csav",
            "Ry",
            "Premium Luxury Rwd",
            "Awd Luxury",
            "3.0l Twin Turbo Premium Luxury",
            "3.6l Premium Luxury"
          ]
        },
        {
          "model": "CTS",
          "series": [
            "Luxury",
            "V",
            "Standard",
            "Premium",
            "Premium Collection",
            "Luxury Collection",
            "Performance",
            "C/t Cts Hi Feature",
            "Performance Collection",
            "Hi Feature V6",
            "Vsport",
            "Premium Luxury",
            "Sedan",
            "Vsport Premium",
            "Rwd",
            "Vsport Premium Luxury",
            "Sedan Luxury Awd",
            "V-sport Premium",
            "Sedan Luxury Rwd",
            "Awd W/1sb",
            "V-Sport",
            "Rwd W/1sa",
            "Luxury Rwd",
            "Wagon",
            "3.6l",
            "Performance Rwd",
            "3.0l",
            "Sedan Performance",
            "V-sport Premium Luxury",
            "Sedan Luxury Collection",
            "Coupe",
            "Awd W/1sa",
            "4",
            "Coupe Premium",
            "Wagon Performance Collection",
            "Perfor",
            "Premiu",
            "Hi Fea",
            "Sedan Luxury Collection Awd",
            "-V",
            "Sedan Performance Collection",
            "Sedan Performance Rwd",
            "Coupe Performance",
            "Sedan Premium Luxury Rwd",
            "Coupe Premium Collection",
            "Deluxe",
            "Wagon Performance",
            "Wagon Luxury Collection",
            "Sedan Premium",
            "Sedan Luxury Collection Rwd",
            "Sedan Premium Rwd",
            "Sedan Performance Awd",
            "Sedan Vsport Premium Rwd",
            "Sedan Premium Collection Rwd",
            "Sedan Rwd",
            "Sedan Vsport Rwd",
            "Sedan Premium Awd",
            "Rwd W/1sb",
            "Wagon Premium",
            "Sedan Awd",
            "Sedan V-sport Rwd",
            "Sedan Premium Luxury Awd",
            "Wagon Luxury",
            "Sedan Premium Collection",
            "Coupe Performance Collection",
            "Sedan Premium Collection Awd",
            "Sedan Luxury",
            "V Sedan",
            "V -v",
            "Base W/1sa",
            "Or",
            "Awd",
            "Rt",
            "Base W/1sb/1sc",
            "Sport W/1sb",
            "Luxury Awd",
            "Ea",
            "High F",
            "2.0t",
            "Sedan V-sport Premium Luxury",
            "Sedan V-sport Premium Rwd",
            "C/t  Hi",
            "Sedan Vsport Premium",
            "Wagon Premium Collection",
            "Ry",
            "Eature V6",
            "Iu",
            "Ium Collection",
            "W/1sa",
            "Ormance Collection",
            "W/1sb",
            "Ry Collection",
            "Performance Awd",
            "Luxury Luxury",
            "Hi Fea Hi Fea",
            "Premiu Premiu",
            "2.8l",
            "Ress G2500",
            "Vsport Vsport",
            "Luxury Collection Rwd",
            "2.0l Turbo Luxury",
            "Turbo",
            "3.6l Base",
            "2.0 Turbo",
            "Lle"
          ]
        },
        {
          "model": "DTS",
          "series": [
            "Premium Collection",
            "Luxury Collection",
            "Standard",
            "Platinum Collection",
            "1sb",
            "Luxury I",
            "1sa",
            "Luxury Ii",
            "1sd",
            "Performance",
            "1sc",
            "1se",
            "V8",
            "Platinum",
            "Livery",
            "Luxury I/luxury Ii/standard",
            "Funeral Coach",
            "Premiu",
            "Luxury",
            "Professional",
            "Platin",
            "Base",
            "W/1se",
            "W/1sb",
            "Professional Funeral Coach",
            "W/1sc",
            "W/1sa",
            "W/1sh",
            "W/1sd",
            "Professional Limousine",
            "Livery Package",
            "Professional V8",
            "Lle Dts",
            "In",
            "Ry",
            "Iu",
            "1sh",
            "W/1sa/w/1sb/w/1sc/w/1sd",
            "W/1sb/w",
            "D",
            "C",
            "H",
            "W/livery Pkg",
            "B",
            "Ium Collection",
            "Ry Collection",
            "E",
            "Premiu Premiu",
            "Platin Platin",
            "1sb/w/livery Pkg/w/1sc/w/1sd",
            "Hi Feature V6",
            "1sa/1sb/1sc/1sd"
          ]
        },
        {
          "model": "ELR",
          "series": [
            "Sport",
            "Luxury",
            "Standard",
            "Ry",
            "Luxury Luxury"
          ]
        },
        {
          "model": "Escalade",
          "series": [
            "Luxury",
            "Standard",
            "Premium Luxury",
            "Luxury Collection",
            "Premium",
            "Sport Platinum",
            "4wd Luxury",
            "Platinum",
            "Esv Luxury",
            "Esv",
            "Ext",
            "Esv Premium",
            "2wd Sport",
            "Esv Premium Luxury",
            "Esv Sport",
            "2wd Luxury",
            "Esv Platinum",
            "4wd Sport Platinum",
            "Esv Premium Luxury Platinum",
            "4wd Sport",
            "Hybrid",
            "4wd Premium Luxury Platinum",
            "Ext Premium",
            "Premium Collection",
            "Esv Sport Platinum",
            "Ext Luxury",
            "V",
            "Premium Luxury Platinum",
            "Sport",
            "Platinum Edition",
            "L",
            "4wd Premium Luxury",
            "V Sport",
            "Hybrid Platinum Edition",
            "2wd Premium Luxury",
            "2wd Sport Platinum",
            "Hybrid Standard",
            "Hybrid Platinum",
            "Base",
            "Platinum Hybrid",
            "V Esv Sport",
            "4wd Platinum",
            "4wd V-series",
            "E",
            "Hybrid Hybrid",
            "Esv Premium Luxury Platin",
            "P",
            "S",
            "V Esv",
            "H",
            "Awd V-series",
            "Escalde",
            "2wd Platinum",
            "4",
            "Num",
            "Llection",
            "Uxury",
            "Y",
            "Um",
            "Um Luxury",
            "Rwd Premium Luxury",
            "Tinum",
            "Rwd Sport",
            " Platinum",
            "L L",
            "Ty",
            "4wd",
            "Iq Sport-1",
            "Platinum 4wd",
            "2wd Premium Luxury Platinum",
            "Iq Sport-2",
            "2wd",
            "Ext Sport",
            "Iq Lux-1",
            "S S",
            "I"
          ]
        },
        {
          "model": "Escalade ESV",
          "series": [
            "Premium",
            "Standard",
            "Luxury",
            "4wd Sport Platinum",
            "Premium Luxury",
            "Platinum",
            "Premium Collection",
            "2wd Luxury",
            "4wd",
            "Esv Premium",
            "Platinum Edition",
            "4wd Luxury",
            "4wd Sport",
            "4wd V-series",
            "Esv Luxury",
            "Luxury Collection",
            "4wd Premium Luxury",
            "Esv Premium Luxury",
            "4wd Platinum",
            "2wd Premium Luxury",
            "Esv Platinum",
            "2wd Sport",
            "2wd Premium Luxury Platinum",
            "2wd Escalade Esv",
            "4wd Premium Luxury Platinum",
            "Premium Luxury Platinum",
            "Sport Platinum",
            "2wd",
            "Sport",
            "Esv",
            "Esv Premium Luxury Platin",
            "2wd Platinum",
            "Base",
            "2wd Sport Platinum",
            "Esv Sport",
            "De",
            "Premium Rwd",
            "Y Platinum",
            "V-Series",
            "Ction",
            "Tion",
            "Rwd Sport",
            "Awd V-series",
            "Y",
            "Ion",
            "Esv Sport Platinum"
          ]
        },
        {
          "model": "Escalade EXT",
          "series": [
            "Standard",
            "Luxury",
            "Premium",
            "Ext",
            "Awd 4dr",
            "Ext Premium",
            "Ext Luxury"
          ]
        },
        {
          "model": "LYRIQ",
          "series": [
            "Rwd Luxury",
            "Luxury",
            "Sport",
            "Tech W/1sa",
            "Luxury W/1se",
            "Sport W/1sj",
            "Luxury W/1sc",
            "Sport W/1sf",
            "Tech",
            "Sport W/1sk",
            "Awd Luxury",
            "Luxury W/1sd",
            "Spor",
            "Luxu",
            "Xury",
            " Motors 825",
            "Sport 3 Rwd",
            "Sport 1 Rwd"
          ]
        },
        {
          "model": "SRX",
          "series": [
            "Premium Collection",
            "Luxury Collection",
            "Performance Collection",
            "Standard",
            "V6",
            "V8",
            "Turbo Premium",
            "Turbo Performance",
            "V6 4dr 2wd",
            "Awd",
            "Perfor",
            "Luxury",
            "4",
            "Premiu",
            "Base",
            "Ormance Collection",
            "Turbo Premium Collection",
            "Leather Collection",
            "Ium Collection",
            "Fwd",
            "Rwd",
            "Ry Collection",
            "Ry",
            " Awd",
            "Perfor Perfor",
            "3.0 Base",
            "Iu",
            "Or",
            "O Performance",
            "4d Performance",
            "Premiu Premiu",
            "Luxury And Performance Collection",
            "Premium",
            "Performance"
          ]
        },
        {
          "model": "STS",
          "series": [
            "V6",
            "Luxury",
            "V8",
            "Luxury Performance",
            "V",
            "Performance",
            "Premium Package",
            "Luxury Package",
            "Premium",
            "Luxury Sport",
            "Rwd W/1se",
            "Rwd W/1sc",
            "Awd W/1sg",
            "Rwd W/1sb",
            "W/1sb",
            "Rwd W/1sa",
            "Awd W/1sb",
            "Rwd W/1sg",
            "Awd W/1sa",
            "V6 V6",
            "Rwd W/1sb/awd W/1sb",
            "Ry",
            "W/1se",
            "-V",
            "W/1sc",
            "W/1sa",
            "Ls",
            "Rwd W/1sa/rwd W/1sb",
            "W/1sg",
            "Ry Performance",
            "4 V6"
          ]
        },
        {
          "model": "XT4",
          "series": [
            "Premium Luxury",
            "Fwd Premium Luxury",
            "Awd Premium Luxury",
            "Awd Sport",
            "Sport",
            "Luxury",
            "Fwd Luxury",
            "Fwd Sport",
            "Awd Luxury",
            "Premiu",
            "Iu",
            "Ry",
            "T",
            "Ium Luxury",
            "Premiu Premiu",
            "Luxury Luxury"
          ]
        },
        {
          "model": "XT5",
          "series": [
            "Luxury",
            "Premium Luxury",
            "Standard",
            "Fwd Luxury",
            "Platinum",
            "Awd Premium Luxury",
            "Sport",
            "Fwd Premium Luxury",
            "Awd Sport",
            "Platinum Premium Luxury",
            "Awd Luxury",
            "Premium Luxury Awd",
            "Platin",
            "Luxury Awd",
            "Premiu",
            "Luxury Fwd",
            "Platinum Awd",
            "Fwd",
            "Premium Luxury Fwd",
            "Awd",
            "Sport Awd",
            "Iu",
            "In",
            "Ry Awd",
            "Inum Awd",
            "Ry Fwd",
            "Ry",
            "Ium Luxury Awd",
            "Ium Luxury Fwd",
            "Ium Luxury",
            "T Awd",
            "Inum",
            "Dard",
            "T",
            "Sport/platinum Sport",
            "Platin Platin",
            "Luxury Luxury",
            "Premiu Premiu",
            "4d 4wd",
            "Suv"
          ]
        },
        {
          "model": "XT6",
          "series": [
            "Fwd Premium Luxury",
            "Awd Premium Luxury",
            "Fwd Luxury",
            "Premium Luxury",
            "Sport",
            "Awd Luxury",
            "Awd Sport",
            "Platinum Premium Luxury",
            "Luxury",
            "Sport Platinum",
            "Sport/platinum Sport",
            "Premiu",
            "Platin",
            "Iu",
            "T",
            "Ry",
            "Ium Luxury",
            "Luxury Luxury",
            "Premiu Premiu",
            "Turbo"
          ]
        },
        {
          "model": "XTS",
          "series": [
            "Luxury",
            "Luxury Collection",
            "Platinum",
            "W20 Livery Package",
            "Premium",
            "Premium Collection",
            "E",
            "Standard",
            "Premium Luxury",
            "Vsport Premium",
            "Limousine",
            "Funeral Coach",
            "Vsport Platinum",
            "V4u Coachbuilder Limousine",
            "Turbo",
            "B9q Coachbuilder Funeral Coach",
            "Premiu",
            "Vsport",
            "Livery Package",
            "Platin",
            "Platinum V-sport",
            "Stretch Livery",
            "Limous",
            "Funera",
            "Armore",
            "Iu",
            "V-sport Premium Twin Turbo",
            "Rt",
            "Us",
            "In",
            "V-sport Platinum",
            "Premium V-sport",
            "Ry",
            "4d",
            "Ry Package",
            "Ral Coach",
            "V-sport Premium Twin",
            "Ry Collection",
            "W30 Coachbuilder Stretch Livery",
            "Inum",
            "Ium",
            "Ium Collection",
            "Luxury Luxury",
            "Fwd",
            "B9q Coachbuilder Hearse",
            "Premiu Premiu",
            "Platin Platin",
            "Funera Funera",
            "Performance Collection",
            "B9q Funeral Coach/v4u Limousine/w20 Livery Package/w30 Stretch Livery"
          ]
        }
      ]
    },
    {
      "make": "Chevrolet",
      "models": [
        {
          "model": "Captiva",
          "series": [
            "Lt",
            "Ltz",
            "Ls",
            "Sport",
            "Sport/lt",
            "Sport/ls",
            "Ltz Suv",
            "Sport/ltz",
            "Sp",
            "Z",
            "Premium",
            "Ls W/2ls",
            "2ls",
            "Ls Ls"
          ]
        },
        {
          "model": "Avalanche",
          "series": [
            "C1500",
            "Ltz",
            "1500 Lt2",
            "K1500",
            "1500 Z71",
            "1500 Ltz",
            "1500",
            "1500 Lt",
            "1500 Ls",
            "Ls",
            "1500 Z66",
            "1500 Lt1",
            "Z71",
            "1500 C1500",
            "1500 K1500 Lt",
            "Lt",
            "K1500 Lt",
            "1500 K1500 Ls",
            "K1500 Ltz",
            "Lt W/3lt",
            "1500 K1500",
            "K1500 Ls",
            "C1500 Ls",
            "1500 Ls/lt/ltz",
            "K2500",
            "2500",
            "2500 Ls",
            "2500 Lt",
            "1500 Lt/ls/ltz",
            "Lt W/2lt",
            "C1500 Lt",
            "C1500 Ltz",
            "C2500",
            "Z66",
            "1500 C1500 Lt",
            "1500 Lt Z71",
            "Lt W/1lt",
            "1500 Ls Z71",
            "2500 C2500",
            "N T880",
            "Ls/lt/z71",
            "Gls",
            "Ls/lt/z66",
            "Ls/lt",
            "Ls/lt W/1lt/lt W/2lt",
            "C1500  Ls",
            "Lt1",
            "1500 K1500 Ltz",
            "Ls/lt/ltz",
            "Avlnch1500",
            "Avalance",
            "Lt2",
            "1500 Lt/ltz",
            "2500 K2500",
            "1500 Ls/lt",
            "1500 Ls/lt/z71",
            "1500 Ls/ltz"
          ]
        },
        {
          "model": "Aveo",
          "series": [
            "Lt",
            "1lt",
            "Ls/lt",
            "Ls",
            "Special Value",
            "2lt",
            "Base",
            "Lt W/2lt",
            "Lt W/1lt",
            "1lt/ls",
            "Ls/special Value",
            "Svm/ls",
            "4d Ls",
            "Svm",
            "Ls/lt W/1lt",
            " W/1lt",
            "4d",
            "Base/",
            "Ls Ls",
            "/ls",
            "5 Ls"
          ]
        },
        {
          "model": "Aveo5",
          "series": [
            "Ls",
            "Special Value",
            " Special Value",
            " Ls",
            "Lt"
          ]
        },
        {
          "model": "Beat",
          "series": []
        },
        {
          "model": "Blazer",
          "series": [
            "2lt",
            "Awd Premier",
            "Ls",
            "Fwd 1lt",
            "S10",
            "Lt",
            "Awd 2lt",
            "Rs",
            "3lt",
            "Fwd 2lt",
            "Fwd Rs",
            "Premier",
            "Fwd Premier",
            "Awd Rs",
            "1lt",
            "L",
            "V10",
            "K10",
            "Azer Lt",
            "Awd 3lt",
            "K1500",
            "Xtreme",
            "Fwd 3lt",
            "Trailblazer",
            "R",
            "T",
            "Azer",
            "Ev Rwd Rs",
            "True North",
            "Zer",
            "Ev Eawd 2lt",
            "Pre",
            "Ev Eawd Rs",
            "Ev Rs",
            " S10",
            "Ls/lt/trailblazer",
            "Ev Eawd Lt",
            "Ev 2lt",
            "Fwd L",
            "Blazer",
            "Fleet",
            "Fleet 1sa/1sc",
            "Ls/fleet",
            "Suv Rs Awd",
            "Fleet 1st",
            "K5",
            "Eawd 2lt",
            "Ev",
            "Rs Rs",
            "Ls Cmi",
            "4x4",
            "Azer Ls",
            "10",
            "C10",
            "Pre Pre",
            "3lt 3lt",
            "Ls Yc3/ls Ze5",
            "Lt2",
            "1lt 1lt",
            "1500 Lt",
            "Azer Ext Ls",
            "Eawd Rs",
            "Ev 2lt Eawd",
            "Eawd Lt",
            "Ev Awd Rs",
            "Ls Cloth/ls Leather",
            "Ls/lt",
            "Bev Rs",
            "Ev Rs Eawd"
          ]
        },
        {
          "model": "Bolt EUV",
          "series": [
            "Fwd Lt",
            "Fwd Premier",
            "Ev Lt",
            "Ev 2lt",
            "Euv Premier",
            "Euv Lt",
            "Ev Premier",
            "Lt",
            "Euv P",
            "Ev 1lt",
            "Premier",
            "R",
            "T",
            "L",
            "P",
            "Ev",
            "Ev 2l",
            "Ev Pr",
            "Ev 1l",
            "Euv L",
            "L Euv L"
          ]
        },
        {
          "model": "Bolt EV",
          "series": [
            "Fwd Lt",
            "Premier",
            "Fwd Premier",
            "Lt",
            "2lt",
            "Fwd 1lt",
            "Fwd 2lt",
            "1lt",
            "1l",
            "2l Ev 2l",
            "Lt Ev Lt",
            "2l",
            "Pr Ev Pr",
            "Pr"
          ]
        },
        {
          "model": "Camaro",
          "series": [
            "2lt",
            "Lt",
            "1lt",
            "Rwd 2ss",
            "2ss",
            "Rwd Lt1",
            "Rwd 1lt",
            "Ls",
            "Ss",
            "Rs",
            "2ls",
            "Z28",
            "1ss",
            "Zl1",
            "Lz",
            "Lt1",
            "Rwd 1ss",
            "1ls",
            "Rwd Zl1",
            "Ls/lt",
            "Rwd 1ls",
            "Rwd 2lt",
            "Z/28",
            "Rwd 3lt",
            "Lz/ss",
            "Copo",
            "3lt",
            "Base",
            "Lt1/ss",
            "Berlinetta",
            "Rwd  Lt1",
            "Rwd  1lt",
            "Rwd  1ss",
            "Rwd  1ls",
            "Rwd  2ss",
            "2d",
            "Rwd  2lt",
            "Rwd  Zl1",
            "Rwd  3lt",
            "Bas",
            "Ls1",
            "1ls/1lt",
            "2lt/3lt",
            "Special Service Package",
            "2d 1lt",
            "Cnv",
            "2d 1ls/1lt",
            "2d 2ss",
            "Police",
            "Ls Ls",
            "2d 2ls",
            "Police Pkg B4c",
            "Rwd  2lt/rwd  3lt",
            "K1500 Lt",
            "2d Ls",
            "Camero",
            "Zl1 Zl1",
            "Rwd  1ss/rwd  Lt1",
            "Lz Lz",
            "2ss 2ss",
            "Rs V6",
            "Camero Z28",
            "/rs",
            "Lt/",
            "L",
            "Lt Lt",
            "Iroc-Z",
            "Rwd 2lt/rwd 3lt",
            "Ls/ Ls",
            "Rsz11 Pace"
          ]
        },
        {
          "model": "Caprice",
          "series": [
            "Classic",
            "Classic Brougham",
            "Classic Ltz",
            "/ Impala Classic Ss",
            "Police",
            "Classic Ls",
            "Cl",
            "/ Impala Classic/ss",
            "Detective",
            "Police Patrol Police",
            "Police Patrol",
            "Po",
            "Police Patrol Detective",
            "Po Po",
            "Ls",
            "/"
          ]
        },
        {
          "model": "Captiva Sport",
          "series": [
            "Ltz",
            "2ls",
            "Lt",
            "Fleet Lt",
            "Sport/lt",
            "Sport/ltz",
            "Ls",
            "1ls",
            "Sport/ls",
            "Fleet Ltz",
            "Fleet",
            "Fleet Sport/lt",
            "Fleet Ls",
            "Fleet Sport/ltz",
            "Fleet Ls W/2ls",
            "Fleet Ls W/1ls",
            "Fleet Sport/ls"
          ]
        },
        {
          "model": "Cavalier",
          "series": [
            "Ls",
            "Ls Sport",
            "Rs",
            "Base",
            "Vl/rs",
            "Cng",
            "Z24",
            "Vlx",
            "Vl",
            "Cs",
            "Base Cmi",
            "B",
            "Base W/1sv",
            "W/1sv",
            "L",
            "T",
            "Type 10",
            "Caviler",
            "Z",
            "2",
            "V",
            " Cavallier",
            "Aviler",
            "Vl/vlx"
          ]
        },
        {
          "model": "Chevy",
          "series": [
            "2 Nova",
            "Van G1500",
            "Van G2500",
            "Van",
            "Van Yf7 Upfitter Pkg.",
            "Van G3500",
            "Ado K1500 Lt",
            "Es Chevy Van",
            "Se Ls",
            "Ii"
          ]
        },
        {
          "model": "Cheyenne",
          "series": []
        },
        {
          "model": "City Express",
          "series": [
            "1lt",
            "1ls",
            "Lt",
            "Ls",
            "Ls Cargo Van",
            "Cargo Van Lt",
            "Cargo Van Ls",
            "Cargo Van",
            "Expre",
            "Lt Cargo Van"
          ]
        },
        {
          "model": "Cobalt",
          "series": [
            "1lt",
            "Ls",
            "Lt",
            "Ss",
            "Sport",
            "Ss Supercharged",
            "2lt",
            "Ltz",
            "Lt W/1lt",
            "Lt W/2lt",
            "Lev",
            "Spo",
            "Ss *ltd Avail*",
            "Base",
            "2d Internet",
            "4d Lt",
            "4d",
            "T",
            "Ls Cobalt Ls",
            "Lt Lt",
            "Cobolt Ls",
            "Cobolt",
            "1lt 1lt",
            "Ss Ss",
            "Cobalt Ls"
          ]
        },
        {
          "model": "Colorado",
          "series": [
            "Lt",
            "4wd Short Box Z71",
            "Wt",
            "Work Truck",
            "Ls",
            "Z71",
            "4wd Long Box Wt",
            "2wd Short Box Wt",
            "2wd Long Box Wt",
            "4wd Short Box Trail Boss",
            "4wd Short Box Zr2",
            "2wd Short Box Z71",
            "Lt W/1lt",
            "1lt",
            "4wd Short Box Wt",
            "Fleet",
            "2wd Short Box Lt",
            "4wd Long Box Z71",
            "Zr2",
            "2wd Long Box Lt",
            "2lt",
            "2wd Wt",
            "4wd Long Box Lt",
            "Ls Crew Cab",
            "Trail Boss",
            "4wd Short Box Lt",
            "Z85",
            "Ls Z85",
            "4wd Wt",
            "4wd Long Box Z71/4wd Short Box Z71",
            "2wd Long Box Base",
            "2wd Z71",
            "3lt",
            "4wd Work Truck",
            "2wd Lt",
            "2wd Work Truck",
            "4wd Z71",
            "Z71 Crew Cab",
            "Lt Ext Cab",
            "Lt W/2lt",
            "Lt Crew Cab",
            "2wd  Short Box Wt",
            "4wd  Long Box Wt",
            "2wd  Long Box Lt",
            "4wd  Short Box Z71",
            "4wd  Long Box Lt",
            "Ls/lt/work Truck",
            "4wd  Short Box Wt",
            "4wd  Short Box Lt",
            "2wd  Short Box Lt",
            "2wd  Long Box Wt",
            "2wd  Short Box Z71",
            "2wd  Long Box Base",
            "4wd  Short Box Zr2",
            "4wd  Short Box Trail Boss",
            "4wd  Long Box Lt/4wd  Short Box Lt",
            "4wd  Long Box Z71/4wd  Short Box Z71",
            "4wd Long Box Lt/4wd Short Box Lt",
            "Wt Crew Cab",
            "4wd Lt",
            "4wd Trail Boss",
            "2wd Long Box Lt/2wd Short Box Lt",
            "4wd  Long Box Z71",
            "4wd Z71/z71",
            "4wd Zr2",
            "Lt/work Truck",
            "Z",
            "L",
            "1sf Ls Z71",
            "1wt",
            "K/lt W/1lt",
            "K/lt W/1vl",
            "Fleet Z85/z85",
            "Ext Lt",
            "2wd Base",
            "Work Truck/lt W/1lt",
            "Work Truck/lt W/1vl",
            "1se Ls Z71",
            "2wt",
            "Ls Ext Cab",
            "1sb Ls Z85",
            "Ls Z71",
            "Work Truck/ls",
            "1sc Ls Z85",
            "Lt W/3lt",
            "Fleet Z85",
            "Truck",
            "K",
            "Zq8",
            "1sj Ls Zq8",
            "Ls Zq8",
            "Z71/zq8/ls Zq8",
            "1sh Ls Zq8",
            "2wd  Long Box Lt/2wd  Short Box Lt",
            "4wd  Long Box Zr2",
            "4x4 Ex 1lt",
            "4wd Long Box Zr2",
            "4",
            " K1500",
            " C1500 Ltz",
            " C1500 Custom",
            "         Colorado",
            "T",
            "C",
            " C1500",
            "Z71 Crew Ca 2wd Short Box Z71",
            "V71",
            "Zr2 Crew Cab",
            "Z71 Crew Ca 2wd  Short Box Z71",
            "1",
            "Trail Boss Pickup Truck",
            "Pickup Truck",
            "Trail Boss 4wd",
            "Lt/lt Z71",
            "Wt Ext Cab",
            " K2500 Heavy Duty",
            "Ls/lt"
          ]
        },
        {
          "model": "Corvette",
          "series": [
            "Stingray 2lt",
            "Stingray 1lt",
            "Z06",
            "Stingray",
            "Stingray Rwd 1lt",
            "Stingray Z51 1lt",
            "Z06 3lz",
            "Stingray Z51 2lt",
            "Stingray Z51",
            "Grand Sport 2lt",
            "Z06 1lz",
            "Stingray 3lt",
            "Hardtop",
            "Stingray Rwd 3lt",
            "Stingray Stingray 1lt",
            "Z06 Rwd 3lz",
            "Grand Sport",
            "Z06 Hardtop",
            "Stingray Z51 3lt",
            "Stingray Rwd 2lt",
            "Z06 2lz",
            "Z",
            "Grand Sport 1lt",
            "Grand Sport 3lt",
            "2",
            "Zr-1 1zr",
            "Stingray Stingray 2lt",
            "Stingray Stingray 3lt",
            "Zr1",
            "3lt",
            "Zr-1",
            "Stingray Rwd  2lt",
            "Z06 Rwd 1lz",
            "Stingray Rwd  1lt",
            "Stingray Rwd  3lt",
            "Stingray Stingray Z51 3lt",
            "Zr-1 3zr",
            "4",
            "S",
            "G",
            "A",
            "1lt",
            "(top Only)",
            "2lt",
            "Ls 5.7 Manual Trans",
            "427",
            "Z06/3lz",
            "Stingray Stingray Z51 2lt",
            "Z51 2lt",
            "Stingray Stingray/2lt",
            "W/1lt",
            "Zr1 3zr",
            " Sport W/3lt",
            "Stingray Stingray/3lt/z51",
            " Sport W/2lt",
            "Rt 1lt",
            " Sport W/4lt",
            "Zr1 W/3zr",
            "Z16 Grand Sport W/2lt",
            "Z16 Grand Sport W/3lt",
            "Z16 Grand Sport W/1lt",
            "Z51 1lt",
            "Z06 W/2lz",
            "Grand Sport 4lt",
            "427 1sc",
            "Stingray/1lt",
            "Z06 W/3lz",
            "Z51 3lt",
            "Z16 Grand Sport W/4lt",
            "W/3lt",
            "W/4lt",
            "W/2lt",
            "3lz",
            "Z06 Rwd  3lz",
            "Z06 Rwd 2lz",
            "Z06 W/1lz",
            " Sport W/1lt",
            "427 1sb",
            "Stingray/3lt/z51",
            "Stingray/3lt",
            "Stingray Stingray/2lt/z51",
            "Stingray Stingray/3lt",
            "Rt 3lt",
            "Z06/1lz",
            "Stingray/2lt",
            "3lz/z06",
            "Grand Sport/2lt",
            "Zr1 1zr",
            "Stingray/2lt/z51",
            "Grand Sport/3lt",
            "Rt",
            "Rt 2lt",
            "Zr1 W/1zr",
            "Stingray/1lz/z06",
            "Z06/2lz",
            "Z06 Rwd  1lz",
            "Z06 Rwd  2lz",
            "Indy Pace Car Edition",
            "Corv Z06",
            "Rwd 3lt",
            "Rwd 1lt",
            "Stingray Stingray Z51 1lt",
            "S S",
            "4 4",
            "Z51",
            "G G",
            "Rwd 2lt",
            "E",
            "Rwd 3lz",
            "Rwd  2lt",
            "E-ray 3lz",
            "Rwd  1lt",
            "Z Z",
            "Rwd  3lt",
            "Indy 500 Pace Car Replica",
            "1",
            "Rwd 1lz",
            "3",
            "Rwd  1lz",
            "E-ray Rwd 3lz",
            "E-Ray"
          ]
        },
        {
          "model": "Cruze",
          "series": [
            "Eco Auto",
            "Ltz",
            "1lt Auto",
            "Eco",
            "Lt",
            "Lt Auto",
            "1lt",
            "2lt",
            "Ls Auto",
            "Premier",
            "2lt Auto",
            "Limited Ls",
            "Ls",
            "Premier Auto",
            "Limited Lt",
            "Lt Manual",
            "Eco Manual",
            "Limited Eco",
            "Ls Manual",
            "Diesel",
            "2lt Manual",
            "L",
            "Limited Ltz",
            "1lt Manual",
            "Ltz Turbo",
            "Cvt (fleet Orders Only)",
            "Ltz/cruze Ltz Rs",
            "Lt W/1lt",
            "Lt Turbo",
            "Lt W/2lt",
            "Premier Turbo",
            "Eco Turbo",
            "2ls",
            "L Manual",
            "Ls+ W/1sb",
            "Limited L",
            "Ls Turbo",
            "1ls",
            "Prem",
            "Limi",
            "Lt W/1fl",
            "Eco W/1xf",
            "Lt1 Manual Lt",
            "4d L",
            "O",
            "To",
            "Nual",
            "4d 1lt",
            " Lt",
            "Ual",
            "I",
            "Fl",
            "1xf",
            "R",
            "4d 2ls",
            "4d",
            "Dies",
            "Ls Ls",
            "Cruz",
            "Cruise Lt",
            "Ls A",
            "Lt1",
            "L W/",
            "L Ma",
            " Lt Cruise Lt",
            "L L",
            "Xlt",
            "Lt2",
            "4d 1"
          ]
        },
        {
          "model": "Cruze Limited",
          "series": [
            "1lt Auto",
            "Ltz",
            "Ls Auto",
            "2lt Auto",
            "Ltz Auto",
            "Lt",
            "Eco Auto",
            "Ls Manual",
            "Ls",
            "1lt Manual",
            "Eco Manual",
            "Eco",
            "L",
            "L Manual",
            "2lt",
            "1lt",
            "2ls"
          ]
        },
        {
          "model": "Cruze NG",
          "series": []
        },
        {
          "model": "Equinox",
          "series": [
            "2lt",
            "1lt",
            "Rs",
            "Ls",
            "Lt",
            "Premier",
            "Fwd Lt 1.5l Turbo",
            "Awd Lt",
            "Awd Lt 1.5l Turbo",
            "Fwd Lt",
            "Fwd Ls",
            "Ltz",
            "Awd Lt 2.0l Turbo",
            "Fwd 2fl",
            "Awd 2fl",
            "Awd Ls",
            "Fwd Rs",
            "Fwd Lt 2.0l Turbo",
            "Awd Premier 2.0l Turbo",
            "Awd Rs",
            "Awd Premier 1.5l Turbo",
            "Fwd Premier 2.0l Turbo",
            "Premiere",
            "Fwd Premier 1.5l Turbo",
            "Awd Premier",
            "Sport",
            "Fwd Premier",
            "Awd 1fl",
            "L",
            "Pr",
            "Fwd 1fl",
            "Lt W/1lt",
            "V6",
            "Lt W/2lt",
            "Ls V6",
            "4d",
            "Xi",
            "Ltz V6",
            "Premier V6",
            "3rs",
            "Ev Rs",
            "Fwd L",
            "Emium",
            "Ev Lt",
            "2.0t",
            "Ev 3rs",
            "Fwd Activ",
            "Limited",
            "Sp",
            "L/ls",
            "4d 1lt",
            "4d L",
            ".5l Turbo",
            ".0l Turbo",
            "4d Fleet",
            "Ier",
            "Ier 1.5l Turbo",
            "2l",
            "Lt/ltz",
            "Ac",
            "Awd Activ",
            "Awd 4c",
            "Gs",
            "Ev",
            "2.5i",
            "Ls1 Fwd Fwd Ls",
            "Pr Pr",
            "3r",
            "Fw",
            "1l",
            "Ss",
            "Lt Lt",
            "Ls Ls",
            "4x",
            " Lt",
            "Awd",
            "2lt Awd",
            "Activ",
            "2rs",
            "3lt",
            "Sport V6",
            "Rs Rs",
            "Limited 1lt",
            "2r",
            "Premium Package",
            "Premier 2.0t",
            "Ev 2lt",
            "3l",
            "Ut",
            "Lt Suv",
            "Bev Rs",
            "Ev Lt2 W/pde",
            "Bev Lt"
          ]
        },
        {
          "model": "Express 1500",
          "series": [
            "Work Van",
            "Ls",
            "Lt",
            "Upfitter",
            "Base/ls/lt",
            "Cargo Van",
            "3lt",
            " Lt",
            " 3lt",
            "0 Z71",
            " Ls",
            "Upfitter Pkg.",
            " 4lt",
            "4lt",
            "Upfitter Pk.",
            "Upfitter/work Van",
            "1wt",
            "Standard",
            "Ls Cargo Van"
          ]
        },
        {
          "model": "Express 2500",
          "series": [
            "G2500",
            "G1500",
            "G3500",
            "Cutaway",
            "Work Van",
            "G3500 Lt",
            "Lt",
            "Ress Ls",
            "G2500 Ls",
            "Cutaway Work Van",
            "Commercial Cutaway Base W/c7e",
            "Cutaway Base W/c7l/c7n",
            "Cutaway 4500 Series",
            "Van Ls",
            "G3500 Ls",
            "Ls",
            "Van",
            "Cutaway 3500",
            "Upfitter Pkg.",
            "Ress Lt",
            "G4500",
            "Upfitter",
            "Commercial Cutaway",
            "G1500 3lt",
            "Cutaway Diesel",
            "2500",
            "Cargo Van Ext",
            "G2500 Lt",
            "Cutaway G3500",
            "Comm Cutaway",
            "Rwd 3500 Extended Wheelbase Lt",
            "Cutaway 4500 Van",
            "Cutaway 4500 4500 Van",
            "Rwd 2500 Regular Wheelbase Ls",
            "Cutaway 4500",
            "Rv Cutaway",
            "Commercial Cutaway Base W/c7l",
            "Cargo Van",
            "Cutaway G4500",
            "G1500 Lt",
            "Rwd 2500 Regular Wheelbase Lt",
            "Yf7 Upfitter",
            "Rwd 3500 Extended Wheelbase Ls",
            "G2",
            "Cutaway Base W/c7a",
            "Commercial",
            "Commercial Cutaway C7l Drw",
            "Cutaway 4500 Series Diesel",
            "Cutaway 4500 Diesel",
            "Commercial Cutaway Work Van",
            "Cutaway Bus",
            "G3",
            "G1500 Ls",
            "E",
            "G1500 4lt",
            "Cutaway 3500 Diesel",
            "00",
            "       Express G2",
            "G2500 3lt",
            "00 Ls",
            "00 Lt",
            "00 3lt",
            "Cutway Work Van",
            "Ls Cargo Van",
            "0 Ce",
            "Commercial C7l/c7n",
            "Rv Cutway",
            "Nger Lt",
            "Nger",
            "Commercial Cutaway G3500",
            "Rcial",
            "Rcial 3500",
            "Rcial 2wt",
            "Rcial Work Van",
            "Rcial 4500 2wt",
            "Expre",
            "Rcial Diesel",
            "Nger Ls",
            "Commercial Work Van",
            "Ter Pkg.",
            "Rcial 3500/4500",
            "Rcial C7a",
            "Ay Drw",
            "Rcial C6y Srw/c7a Drw/c4m Srw",
            "Rcial C7a/c7l",
            "Ay C7l",
            "Ay E23",
            " G2500",
            "Rcial C7n",
            "Nger 1ls",
            "Rcial 3500 Diesel",
            "Nger 1lt",
            "Rcial Drw",
            "Rcial 4500",
            "Ay",
            "Ter",
            "Nger Rwd 3500 Extended Wheelbase Lt",
            "S",
            "Rcial Base W/e23",
            "Nger Rwd 3500 Extended Wheelbase Ls",
            "Ay C7a/c7l",
            "Ay G3500",
            "0 Work Truck",
            "Ay 4500 Series",
            "Rcial Base W/c7l",
            "Ay Work Van",
            "Ay Base W/c7l/c7n",
            "Rcial C7l/c7n",
            " Unknown",
            "Ay C7n",
            "Pfitter",
            "Rcial C7n Drw",
            "Rcial C7a/c7l/c7n",
            " Van",
            "Rcial C7l Drw/c7n Drw/c7l/c7n",
            " Lt",
            " 3lt",
            "Rcial C6y",
            " Ls",
            "Rcial C6y Srw/c7a Drw",
            "Commercial 3500",
            "Commercial Diesel",
            "Ay 4500 4500 Van",
            "Commercial 3500 Diesel",
            "Ay 3500",
            "Ay 3500 Diesel",
            "Ay Diesel",
            "Rcial Cutaway Work Van",
            "Rcial Cutaway",
            "Ay 4500",
            "Ay 4500 Van",
            "Nger Rwd 2500 Regular Wheelbase Ls",
            "Diesel",
            "Ay 4500 Diesel",
            "Comm Cutaway G3500",
            "Nger Rwd 2500 Regular Wheelbase Lt",
            "Rwd 2500 Regular Wheelbase Wt",
            "City Expre",
            "G4",
            "Rwd 2500 Extended Wheelbase Wt",
            "G1 G1",
            "G4 G4",
            "G1",
            " Expr",
            "Ca",
            "Jayco Motor Home",
            "Rwd 3500 Extended",
            "Sunseeker Motor Home",
            "Standard",
            "Rwd 3500 Regular Wheelbase Lt",
            "1wt",
            "Pr",
            "Ct Xl",
            "Expres",
            "3lt",
            "Upfitter Pk.",
            "G35",
            "Va",
            "G500 Delivery Van",
            "Motorhome",
            "G2 Van",
            "G3500 Delivery Van",
            "G3500 Box Truck",
            "3500 Delivery Truck",
            "G4500 Delivery Van",
            "Cutaway*ors",
            "25",
            "Box Truck",
            "G3500 Delivery Truck",
            "Delivery Van",
            "15",
            "G2500 Paratransit",
            "Cu",
            "Cutaway*poss Ors 3500",
            "Press V"
          ]
        },
        {
          "model": "Express 3500",
          "series": [
            "Lt",
            "Ambulance",
            "Ls",
            "Work Van",
            "Diesel",
            "2ls",
            "Cargo Van",
            "Cutaway (amalgam)",
            "3500",
            "Ext",
            "Cargo Van Ext",
            " Lt",
            "G3500",
            " Ls",
            " Ambulance",
            " Paratransit",
            "2ls Diesel",
            "2lt",
            "Base W/c7l/c7n",
            "3500 Diesel",
            "Ls, Wg, 4.8",
            "Commercial",
            "Rwd 3500 Extended Wheelbase Lt",
            "Rwd 3500 Extended Wheelbase Wt",
            "Rwd 3500 Extended Wheelbase Ls",
            "Cutaway",
            "Box Truck",
            "1wt",
            "Standard",
            "Rwd 3500 Regular Wheelbase Wt"
          ]
        },
        {
          "model": "Express 4500",
          "series": [
            "Van",
            "4500 Diesel",
            "4500 Series"
          ]
        },
        {
          "model": "Express Cargo",
          "series": [
            "Van",
            "Rwd 2500 Extended Wheelbase Wt",
            "Rwd 2500 Regular Wheelbase Wt",
            "Rwd 3500 Regular Wheelbase Wt",
            "Rwd 3500 Extended Wheelbase Wt",
            "Van Work Van",
            "Van Yf7 Upfitter",
            "Van Diesel",
            "Rwd 2500 Regular",
            "Rwd 3500 Regular",
            "Rwd 2500 Extended",
            "Van Y3h Paratransit",
            "2500 1 Work Van",
            "2500 Ext Van",
            "Work Van"
          ]
        },
        {
          "model": "Express Pasajeros",
          "series": []
        },
        {
          "model": "Groove",
          "series": []
        },
        {
          "model": "HHR",
          "series": [
            "Lt",
            "Ls",
            "Panel Lt",
            "Panel Ls",
            "Ss",
            "Lt W/1lt",
            "Panel Panel Ls",
            "Lt W/2lt",
            "1lt",
            "Lt2 Lt",
            "Panel",
            "/2lt",
            "/1lt",
            "2lt",
            "L",
            "Panel Panel",
            "Hhr",
            "Ls Fwd",
            "Ss Ss"
          ]
        },
        {
          "model": "Impala",
          "series": [
            "Lt",
            "Ls",
            "Police",
            "1lt",
            "Ltz",
            "Fwd Premier",
            "Limited Lt",
            "2lz",
            "Premier",
            "2lt",
            "Ss",
            "Police/taxi Pkgs Police Pkg 9c1",
            "1lz",
            "3.5l Lt",
            "Lt Fleet",
            "1ls",
            "Limited Ltz",
            "1fl",
            "Limited Ls",
            "Super Sport",
            "Fwd Lt",
            "Limited Police",
            "Pre",
            "Ls Eco",
            "Ss Supercharged",
            "50th Anniversary",
            "Lt V6",
            "Ls V6",
            "Police Pkg Unmarked Police Pkg 9c3",
            "Lt 50th Anniversary",
            "Lt Eco",
            "Eco",
            "Cng 3lt",
            "Lt 3.5l",
            "Lt 1lt",
            " / Impala Classic Ss",
            " Classic",
            "Ltz V6",
            "           Impala",
            " Ss",
            "3.9l Lt",
            "Police Police",
            "Lim",
            "Lt Limited",
            "4d",
            "Police Cruiser",
            "Ls Fleet",
            "Cng 2fl",
            "Pol",
            "Base",
            "Ls Retail",
            "Lt Retail",
            "Se/le/xle",
            "Sup",
            "50t",
            "4d Fleet",
            "Lt 3.9l",
            "Eco/1sa",
            "Impa Ls",
            "4d Lt",
            "4d Ls",
            "S",
            "Lt1",
            "Imp",
            "4d 1lt",
            "Eco/2sa",
            "T",
            "Il",
            "2lt 2lt",
            "Impal Ls",
            "1lt 1lt",
            "Pol Pol",
            "(inspected)",
            "Impalla",
            "4d 4d",
            "K2500 Heavy Duty Lt",
            " Classic Ls",
            "1",
            "Premier V6",
            "Cus"
          ]
        },
        {
          "model": "Impala Limited",
          "series": [
            "Police",
            "Ls",
            "Lt",
            "Ltz",
            "Police Police"
          ]
        },
        {
          "model": "LCF 3500",
          "series": []
        },
        {
          "model": "LCF 3500HD",
          "series": []
        },
        {
          "model": "LCF 4500",
          "series": []
        },
        {
          "model": "LCF 4500HD",
          "series": [
            "Lcf Diesel",
            "Diesel",
            "El",
            "0hd",
            "1wt"
          ]
        },
        {
          "model": "LCF 4500XD",
          "series": [
            "Lcf Diesel 176 Wheelbase",
            "Lcf Diesel"
          ]
        },
        {
          "model": "LCF 5500HD",
          "series": [
            "Lcf Diesel",
            "0hd",
            "El",
            "Diesel"
          ]
        },
        {
          "model": "LCF 5500XD",
          "series": [
            "Lcf Diesel",
            "Diesel"
          ]
        },
        {
          "model": "LCF 6500XD",
          "series": [
            "Lcf Diesel",
            "Diesel"
          ]
        },
        {
          "model": "Malibu",
          "series": [
            "Lt",
            "Eco",
            "Ls",
            "1lt",
            "Ltz",
            "1ls",
            "Fwd 1fl",
            "2lt",
            "Limited Ls",
            "1lz",
            "Fwd Lt",
            "Fwd Rs",
            "2lz",
            "Fwd Ls",
            "Maxx Ltz",
            "Fwd 2lt",
            "Premier",
            "Hybrid",
            "Fwd Premier",
            "Limited Lt",
            "1fl",
            "Ls W/1fl",
            "Ls W/1ls",
            "Maxx Ls",
            "Lt W/1lt",
            "Maxx Lt",
            "Rs",
            "Limited Ltz",
            "Fwd 1lt",
            "3lt",
            "Journey",
            "L",
            "Eco Premium Audio",
            "Classic",
            "Classic Ls",
            "Maxx Ss",
            "Classic Lt",
            "Ss",
            "V6",
            "Lt W/2lt",
            "Maxx Maxx Lt",
            "Maxx Maxx Ls",
            "Lt1",
            "Hybrid Hybrid",
            "Ltz W/2lz",
            "Maxx",
            "Lt Platinum Edition",
            "       Malibu 1lt",
            "Ls Ls",
            "Ltz V6",
            "Hyb",
            "Ls V6",
            "Lim",
            "Landau",
            "Lt/classic",
            "Chevlle",
            "Lt Platinum",
            "Cls",
            "Pre",
            "Ltz W/1lz",
            "Max",
            "Lx",
            "4d 2lt",
            "Clc",
            "Classic 1lt",
            "4d 1lt",
            "4d (new)",
            "Slt",
            "Lt W/3lt",
            "4d Ls",
            "Sport",
            "S/se/r-Line",
            "Ce/le/xle",
            "4d",
            "Lt W/0lt",
            "Base",
            "S",
            "Ls W/2fl",
            "T",
            "Lz",
            "E",
            "Fwd L",
            "Eco Lt",
            " Lt Lt",
            "Cla",
            "1",
            "Ltd",
            "Sed",
            "Ls1",
            "           Malibu 1lt",
            "Malibu Ls",
            "All",
            " Lt",
            "Malibu All",
            "1lt 1lt",
            "4d 4d",
            "Lt1 Lt1",
            "Cla Cla",
            "Ltd Ls",
            "Hyb Hyb",
            "Lt Platium Edition",
            "Maxx Ls/lt",
            "(bci) Accord Cou",
            "Lt2",
            "Lt Eco"
          ]
        },
        {
          "model": "Malibu Limited",
          "series": [
            "Ltz",
            "Ls",
            "1fl",
            "Lt",
            "V6",
            "4d",
            "2lt",
            "Turbo"
          ]
        },
        {
          "model": "Matiz",
          "series": []
        },
        {
          "model": "Nuevo Aveo",
          "series": []
        },
        {
          "model": "Onix",
          "series": []
        },
        {
          "model": "Optra",
          "series": [
            "Wgn",
            "Ls",
            "5",
            "5 Ls",
            "5 Lt",
            "Lt"
          ]
        },
        {
          "model": "Orlando",
          "series": [
            "Lt",
            "Ltz",
            "Ls",
            "Lt Lt",
            "1lt/2lt"
          ]
        },
        {
          "model": "S10",
          "series": [
            "Uck S10",
            "Crew Cab",
            "Bu Ls",
            "Erado K3500",
            "Nox Ls",
            "Bu Lt",
            "Nox Lt",
            "4+cab",
            " Ls",
            "Ls",
            "Ls 4+cab",
            "Er Rs",
            "La Premier",
            "Bu Premier",
            "Erse Lt",
            "Erado K1500 Lt",
            "S10",
            "400 C1500",
            " 2rs",
            "E Lt",
            "S Truck S1",
            "S-10 Ls Re",
            "S Truck",
            "S-10",
            "Pickup",
            "S-10 Exten",
            "10",
            ".",
            "Erado K1500",
            "S 10",
            "S Truck/s1",
            "Blazer",
            "Er",
            "Ess G3500",
            "Er S10",
            "Ette Stingray 1lt",
            "Bu",
            "E K1500",
            "Rban C1500",
            "00",
            " Ls Re",
            "Erse Ls",
            "Bu Hybrid",
            "Uck S1",
            "Ess G2500",
            "Ro Ss",
            "Ure",
            "Bu 1lt",
            "Erse Premier",
            "Erado C1500"
          ]
        },
        {
          "model": "Silverado",
          "series": [
            "1500 Lt",
            "1500 Lt1",
            "2500hd Lt1",
            "K1500 Lt",
            "K2500 Custom",
            "C1500 Custom",
            "K3500 Lt",
            "K1500",
            "K1500 Ltz",
            "K2500 Heavy Duty Lt",
            "C1500",
            "K1500 Trail Boss Custom",
            "K1500 Custom",
            "Ld K1500 Lt",
            "K2500 Heavy Duty Ltz",
            "1500 2lz",
            "2500hd Ls",
            "1500 Work Truck",
            "1500 Ls",
            "1500 Custom",
            "1500 Wt",
            "1500 4wd Short Bed Ltz",
            "1500 4wd Short Bed Rst",
            "1500 2wd Regular Cab Long Bed Wt",
            "1500 Z71",
            "1500 2lt",
            "1500 4wd Short Bed Lt Trail Boss",
            "1500 2wd Short Bed Custom",
            "2500hd Lt",
            "2500hd Ltz",
            "K1500 Lt Trail Boss",
            "1500 Ltz",
            "1500 1lt",
            "2500hd",
            "1500 Rst",
            "1500 Ltd 4wd Short Bed Rst",
            "2500hd Work Truck",
            "1500 Ls/lt1/work Truck",
            "K2500 Heavy Duty",
            "1500 Lt2",
            "1500 4wd Standard Bed Rst",
            "1500 High Country",
            "1500 1lz",
            "1500 4wd Short Bed Lt",
            "1500 2wd Short Bed Wt",
            "1500 Ltd 2wd Double Cab Standard Bed Wt",
            "C2500 Heavy Duty",
            "2500hd Wt",
            "K1500 Rst",
            "K2500 High Country",
            "C1500 Lt",
            "C1500 Classic Crew Cab",
            "C1500 Crew Cab",
            "K1500 High Country",
            "1500 Classic Ls",
            "2500 Lt",
            "Ltd K1500 Lt Trail Boss",
            "1500 Custom Trail Boss",
            "1500 4wd Short Bed Custom Trail Boss",
            "1500 Silverado Custom",
            "1500 2wd Short Bed Lt",
            "1500 4wd Short Bed Lt With 2fl",
            "1500",
            "1500 4wd Standard Bed Lt",
            "1500 Ld Lt",
            "C1500 Ls",
            "1500 Classic Lt1",
            "1500 Lt W/1lt",
            "1500 Lt1/lt2/ltz/work Truck",
            "1500 1lz/2lz",
            "K1500 Classic Crew Cab",
            "Ld C1500 Lt",
            "K2500",
            "2500hd C2500 Heavy Duty",
            "1500 2wd Short Bed Ltz",
            "1500 Ld Wt",
            "1500 1lt/2lt",
            "K1500 Crew Cab",
            "C1500 Classic",
            "1500 4wd Regular Cab Long Bed Wt",
            "K1500 Zr2",
            "Ltd K1500 Custom",
            "3500hd Lt",
            "K3500",
            "K3500 Ltz",
            "1500 Work Truck 1wt",
            "1500 Ltd 2wd Short Bed Lt",
            "1500 4wd Short Bed High Country",
            "K3500 High Country",
            "1500 2wd Double Cab Standard Bed Rst",
            "Ltd K1500 Lt-l",
            "C1500 Rst",
            "1500 Ltd 4wd Short Bed Lt Trail Boss",
            "1500 2wd Double Cab Standard Bed Wt",
            "1500 2wd Short Bed High Country",
            "1500 4wd Standard Bed Lt Trail Boss",
            "K1500 Ls",
            "C3500",
            "Ltd C1500 Lt",
            "2500hd High Country",
            "1500 Ltd 2wd Short Bed Rst",
            "1500hd Lt",
            "1500 Classic Work Truck",
            "3500hd Wt",
            "1500 4wd Short Bed Wt",
            "2500hd 4wd Standard Bed Lt",
            "1500 4wd Short Bed Custom",
            "1500 Work Truck 2wt",
            "1500 Lt W/2lt",
            "1500 Lt Trail Boss",
            "2500hd Lt3",
            "C1500 Ltz",
            "Ltd K1500 Trail Boss Custom",
            "Ld C1500",
            "1500 2wd Short Bed Rst",
            "1500 Ltd 4wd Short Bed Lt With 2fl",
            "2500 Ls",
            "C1500 High Country",
            "2500hd 4wd Standard Bed Custom",
            "3500hd Chassis Lt1",
            "3500 Chassis Lt1",
            "3500 Chassis Classic Work Truck",
            "3500hd 4wd Long Bed Lt",
            "1500 K1500 Lt",
            "1500 K1500",
            "1500 4wd Double Cab Standard Bed Lt",
            "1500 Hybrid 1hy",
            "1500 K1500 Ltz",
            "2500hd 2wd Double Cab Long Bed Wt",
            "1500 K1500 Rst",
            "2500hd 4wd Standard Bed Ltz",
            "6500hd 1wt",
            "3500hd Chassis Wt",
            "1500 4wd Short Bed Rst/4wd Standard Bed Rst",
            "1500 Ltd 4wd Short Bed Ltz",
            "2500hd Classic Lt1",
            "1500 Ld Silverado Custom",
            "1500 2wd Standard Bed Lt",
            "Md Work Truck",
            "3500 Chassis Work Truck",
            "3500hd 4wd Standard Bed Ltz",
            "2500hd 4wd Long Bed Wt",
            "1500 Lt3",
            "2500hd K2500 High Country",
            "C2500",
            "2500hd K2500 Heavy Duty",
            "2500hd Ls/lt",
            "3500 Ls",
            "C1500 Heavy Duty",
            "2500hd 4wd Standard Bed High Country",
            "3500 Classic Lt3",
            "3500hd Chassis Work Truck",
            "3500hd Work Truck",
            "3500hd K3500 Lt",
            "3500hd 4wd Long Bed High Country",
            "3500 Work Truck",
            "1500 K1500 Lt-l",
            "3500hd Ltz",
            "K1500 Classic Hd",
            "1500 Hybrid 2hy",
            "3500 Lt3",
            "Medium Duty",
            "1500 Ltd 4wd Short Bed Custom",
            "1500 Ltd 2wd Standard Bed Wt",
            "1500hd Ls",
            "K1500 Heavy Duty",
            "1500 Ltd 2wd Short Bed Custom",
            "3500hd",
            "3500 Lt",
            "1500 Ltd 2wd Regular Cab Long Bed Wt",
            "1500 4wd Short Bed Lt Trail Boss/4wd Standard Bed Lt Trail Boss",
            "1500 4wd Standard Bed Custom",
            "1500 4wd Double Cab Standard Bed Custom",
            "C3500 Lt",
            "3500hd High Country",
            "3500 Chassis",
            "2500hd 4wd Double Cab Long Bed Wt",
            "3500hd 4wd Double Cab Long Bed Wt",
            "K1500 Lt-l",
            "3500hd 4wd Long Bed Ltz",
            "3500 Chassis Ls",
            "3500hd 4wd Double Cab Long Bed Work Truck",
            "C2500 Heavy Duty Ltz",
            "C2500 Heavy Duty Lt",
            "Ltd C1500",
            "1500 2wd Standard Bed Rst",
            "Ltd K1500 Lt",
            "1500 4wd Short Bed Zr2",
            "1500 Ltd 4wd Short Bed Custom Trail Boss",
            "1500 Lt Double Cab",
            "1500 Custom Crew Cab",
            "Ltd K1500 Rst",
            "1500 C1500 Ls",
            "1500 2wd Double Cab Standard Bed Lt",
            "Ld C1500 Custom",
            "Ltd C1500 Custom",
            "Ld K1500 Base/ls",
            "1500 Ld C1500 Lt",
            "1500hd Classic Lt1",
            "1500 Ld Custom",
            "Ltd K1500 Ltz",
            "K1500 Classic",
            "1500 Ltd 4wd Short Bed Lt",
            "2500hd Lt2",
            "Ltd K1500",
            "1500 Ls/wt",
            "1500 4wd Double Cab Standard Bed Wt",
            "1500 Ss",
            "Ltd K1500 High Country",
            "2500hd Lt W/2lt/lt1/lt2/ltz/work Truck",
            "1500 Classic Lt2",
            "2500hd Classic Lt2",
            "1500 2wd Double Cab Standard Bed Custom",
            "1500 4wd Standard Bed Wt",
            "3500hd K3500 High Country",
            "Ss",
            "2500hd Classic Lt3",
            "2500",
            "1500 Xtra Fuel Economy",
            "2500hd 2wd Long Bed Wt",
            "2500hd 4wd Standard Bed Wt",
            "1500 Ltd C1500 Rst",
            "1500 K1500 High Country",
            "1500 Ltd K1500 Custom",
            "2500hd Classic Work Truck",
            "1500 Ltd 2wd Short Bed Ltz",
            "Ltd C1500 Ltz",
            "1500 Silverado Custom Trail Boss",
            "K1500/k1500 Ls",
            "2500hd 4wd Double Cab Standard Bed Custom",
            "2500hd 4wd Long Bed Lt",
            "2500hd 4wd Double Cab Long Bed Lt",
            "2500hd 4wd Long Bed Ltz/4wd Standard Bed Ltz",
            "1500 4wd Short Bed Custom/4wd Standard Bed Custom",
            "2500hd 2wd Long Bed Work Truck",
            "K2500 Zr2",
            "1500 Hybrid 1hy/2hy",
            "C1500 Hybrid",
            "Ld K1500 Custom",
            "1500 K1500 Crew Cab",
            "1500 C1500 Lt",
            "1500 4wd Double Cab Standard Bed Rst",
            "3500 Lt1",
            "C1500/c1500 Ls",
            "3500hd K3500",
            "Ltd C1500 Rst",
            "1500 4wd Double Cab Standard Bed Custom Trail Boss",
            "1500 Classic Lt3",
            "0",
            "2500hd K2500 Zr2",
            "3500",
            "1500 Ltd Custom",
            "3500 Classic Work Truck",
            "3500hd 4wd Standard Bed Lt",
            "1500 K1500/k1500 Ls",
            "1500 Ls/work Truck",
            "3500hd Lt1",
            "1500 Crew Cab C1500",
            "1500hd C1500 Heavy Duty",
            "2500hd K2500 Heavy Duty Ltz",
            "2500hd K2500 Heavy Duty Lt",
            "1500 Classic K1500 Classic Crew Cab",
            "1500 C1500",
            "1500 Ltd",
            "1500 K1500 Custom",
            "1500 K1500 Zr2",
            "1500 C1500 Custom",
            "1500 C1500 Crew Cab",
            "2500 C2500",
            "1500 Ltd K1500 Ltz",
            "1500 Lt Ext Cab",
            "C3500 Ltz",
            "1500 Ltd 4wd Standard Bed Lt Trail Boss",
            "1500 Ltz Crew Cab",
            "1500 Ls Ext Cab",
            "2500 Ls/lt",
            "2500 Work Truck",
            "2500 Crew Cab",
            "6500hd 1lt",
            "1500 Ltd 4wd Standard Bed Lt With 2fl",
            "1500 Ltd Lt",
            "1500 4wd Standard Bed Ltz",
            "1500 Classic C1500 Classic Crew Cab",
            "1500hd Lt1",
            "3500 Ltz",
            "1500 Ltd K1500 Lt Trail Boss",
            "1500 Ltd K1500 Lt",
            "2500 K2500",
            "1500 2wd Long Bed Wt",
            "3500 Lt2",
            "1500 Ltd 4wd Short Bed High Country",
            "3500hd 4wd Standard Bed High Country",
            "3500hd K3500 Ltz",
            "1500 4wd Short Bed Custom Trail Boss/4wd Standard Bed Custom Trail Boss",
            "3500hd Chassis C3500",
            "1500 2wd",
            "1500 C1500 Ltz",
            "3500hd Lt2",
            "1500 Ltd 4wd Standard Bed Lt",
            "2500hd 4wd Long Bed High Country/4wd Standard Bed High Country",
            "4500hd 1wt",
            "3500 Ls/lt1/lt2/lt3/work Truck",
            "2500hd 4wd Double Cab Standard Bed Wt",
            "1500 Hybrid Lt1",
            "3500 Drw Ls",
            "3500hd Chassis K3500",
            "1500hd Lt1/lt2/lt3",
            "1500 Ltd 2wd Short Bed High Country",
            "3500 Classic",
            "1500 Ltd 4wd Standard Bed High Country",
            "2500hd 2wd Standard Bed Custom",
            "3500hd 4wd Double Cab Long Bed Lt",
            "2500hd 2wd Regular Cab Long Bed Work Truck",
            "1500 4wd Short Bed Lt/4wd Standard Bed Lt",
            "Ls",
            "1500 K1500 Lt Trail Boss",
            "1500 2wd Standard Bed Custom",
            "1500 Commercial",
            "2500hd 4wd Long Bed Custom",
            "3500hd Chassis Lt",
            "1500 Ltd 4wd Double Cab Standard Bed Lt",
            "2500hd 2dr",
            "1500 Ls/lt1/lt2/lt3",
            "3500hd 4wd Regular Cab Long Bed Wt",
            "1500 Ls/lt",
            "3500hd 2wd Regular Cab Long Bed Work Truck",
            "2500hd 4wd Regular Cab Long Bed Work Truck",
            "1500 Ltd 2wd Double Cab Standard Bed Lt",
            "4500hd 1lt",
            "2500hd Work Truck/wt",
            "1500 4wd Long Bed Wt",
            "3500hd 4wd Long Bed Wt",
            "2500hd 2wd Double Cab Standard Bed Wt",
            "1500 4wd Standard Bed Custom Trail Boss",
            "K1500 Hybrid",
            "1500 Ltz/work Truck",
            "3500 Ls/lt",
            "1500 2wd Standard Bed Wt",
            "2500 Hd Ltz Crew Cab",
            "K2500hd Ltz",
            "2500hd 4wd Double Cab Standard Bed Lt",
            "C2500hd",
            "2500hd K2500 Custom",
            "1500 Ld K1500 Lt",
            "1500 Classic K1500 Classic",
            "2500hd 4wd Standard Bed Zr2",
            "3500 Classic Lt1",
            "3500 Chassis C3500",
            "2500hd Classic Ls",
            "C1500hd",
            "1500 Ltd K1500 Rst",
            "2500hd Ls/lt/work Truck",
            "3500hd 4wd Regular Cab Long Bed Work Truck",
            "1500 Wt Ext Cab",
            "1500 Lt Crew Cab",
            "2500hd Classic",
            "2500hd Classic C2500 Heavy Duty",
            "4500hd",
            "Ltd C1500 High Country",
            "1500 4wd Standard Bed High Country",
            "1500 K1500 Trail Boss Custom",
            "3500 K3500",
            "1500 Crew Cab Ls",
            "2500hd 2wd Regular Cab Long Bed Wt",
            "1500 Ld",
            "1500 Ltd 4wd Standard Bed Ltz",
            "6500",
            "2500hd Lt1/lt2/ltz/work Truck",
            "1500 Ltd C1500 Custom",
            "2500hd 2wd Standard Bed Ltz",
            "500",
            "1500 C1500/c1500 Ls",
            "1500 Ltd 4wd Standard Bed Custom",
            "2500hd 4wd Double Cab Long Bed Work Truck",
            "3500hd Cc Work Truck",
            "1500 4wd  Standard Bed Custom",
            "1500 4wd  Short Bed Lt With 2fl",
            "1500 2wd  Short Bed Lt",
            "1500 Ltd 2wd  Short Bed Lt",
            "3500hd 4wd  Long Bed High Country",
            "1500 Ld C1500",
            "1500 C1500 Rst",
            "2500hd C2500 Heavy Duty Lt",
            "1500hd",
            "2500hd 2wd Long Bed Lt",
            "1500 Hybrid C1500 Hybrid",
            "1500 Ls/lt/z71",
            "1500 Wt Double Cab",
            "2500hd 4wd Regular Cab Long Bed Wt",
            "2500hd 4wd Long Bed Ltz",
            "3500 Chassis Classic Lt1",
            "1500 High Country Cc",
            "2500hd Custom",
            "2500hd 2wd Standard Bed Lt",
            "1500 Ltd 4wd Double Cab Standard Bed Lt With 2fl",
            "1500 Ext Cab",
            "1500 Ss Classic",
            "1500 Custom Trail Cc",
            "1500 4wd Double Cab Standard Bed Ltz",
            "C1500  Ls",
            "C2500 Custom",
            "2500hd Ls/lt1/lt2/lt3/work Truck",
            "1500 4wd Double Cab Standard Bed Lt With 2ft",
            "1500 Ltd 4wd  Short Bed Lt Trail Boss",
            "2500hd 4wd  Standard Bed Lt",
            "1500 4wd  Short Bed Lt Trail Boss",
            "1500 4wd  Short Bed Custom",
            "1500 Ltd 4wd  Short Bed Custom Trail Boss",
            "1500 2wd  Short Bed Rst",
            "1500 4wd  Short Bed Custom Trail Boss",
            "1500 Ltz Ext Cab",
            "3500hd 4wd Regular Cab Long Bed Lt",
            "2500 Hd Crew Cab",
            "1500 Crew Cab",
            "1500 Ltd 2wd Double Cab Standard Bed Custom",
            "3500 Classic Lt2",
            "1500 Classic",
            "1500 Lt1/work Truck",
            "1500 4wd  Short Bed Ltz",
            "1500 2wd  Short Bed Custom",
            "1500 2wd  Standard Bed Custom",
            "1500 4wd  Short Bed Wt",
            "1500 2wd  Short Bed Ltz",
            "1500 4wd  Short Bed High Country",
            "3500 C3500",
            "1500 Wt Crew Cab",
            "2500hd 4wd  Standard Bed Custom",
            "Ev Work Truck",
            "3500hd 4wd  Long Bed Lt",
            "2500hd 4wd  Standard Bed High Country",
            "1500 4wd  Short Bed Rst",
            "1500 Ltd 2wd  Short Bed Custom",
            "1500 4wd  Standard Bed Lt",
            "2500hd 4wd  Standard Bed Ltz",
            "1500 4wd  Short Bed Lt",
            "2500hd 4wd  Long Bed Ltz",
            "Silverado",
            "1500 Hybrid Classic Lt1",
            "1500 Ltd 4wd  Short Bed Rst",
            "1500 4wd  Short Bed Custom/4wd  Standard Bed Custom",
            "1500 Ltd 2wd  Short Bed Rst",
            "1500 Ltd 4wd  Short Bed Ltz",
            "1500 4wd  Standard Bed Wt",
            "2500hd 4wd  Long Bed Wt",
            "1500 4wd  Short Bed Rst/4wd  Standard Bed Rst",
            "2500hd 4wd Regular Cab Long Bed Lt",
            "3500hd 4wd  Long Bed Ltz",
            "1500 4wd  Short Bed Zr2",
            "1500 4wd  Long Bed Wt",
            "C1500/c1500  Ls",
            "1500 Ltd 4wd  Short Bed Custom",
            "2500hd 4wd  Long Bed Lt",
            "3500hd 4wd  Standard Bed Ltz",
            "1500 Ls Crew Cab",
            "1500 2wd Short Bed Rst/2wd Standard Bed Rst",
            "2500hd 4wd  Standard Bed Wt",
            "2500hd 4wd  Long Bed Lt/4wd  Standard Bed Lt",
            "1500 2wd Crew Cab Short Bed Lt/2wd Crew Cab Standard Bed Lt/2wd Double Cab Standard Bed Lt",
            "1500 Ls/lt/work Truck/z71",
            "1500 4wd Short Bed High Country/4wd Standard Bed High Country",
            "3500 Drw Wrk Trk",
            "2500hd 4wd Long Bed Lt/4wd Standard Bed Lt",
            "2500hd 4wd Long Bed High Country",
            "3500hd 4wd  Standard Bed High Country",
            "1500 Ltd 4wd  Short Bed High Country",
            "1500 Ltd K1500 High Country",
            "1500 Ltd 4wd  Short Bed Lt",
            "1500 Ltd C1500",
            "3500hd 4wd  Long Bed Wt",
            "3500 Ls/lt/work Truck",
            "3500hd C3500 Ltz",
            "1500 4wd  Standard Bed High Country",
            "1500 2wd  Short Bed Wt",
            "2500 Hd Wt",
            "1500 Work Truck 1wt/work Truck 2wt",
            "1500 Rst Crew Cab",
            "3500 Chassis K3500",
            "3500 Chassis Classic C3500",
            "1500hd K1500 Heavy Duty",
            "1500 Ltz Double Cab",
            "3500 Lt1/work Truck",
            "2500hd 4wd  Long Bed Custom",
            "2500 Ext Cab",
            "1500 4wd  Standard Bed Custom Trail Boss",
            "2500hd 4wd Double Cab Standard Bed Work Truck",
            "3500hd 4wd Standard Bed Wt",
            "2500 Crew Cab C2500",
            "1500 K1500 Ls",
            "1500 Wt/lt",
            "2500 Hd Lt Ext Cab",
            "2500 Hd Lt Crew Cab",
            "1500 Hd Ls Crew Cab",
            "2500hd 2wd  Standard Bed Custom",
            "2500hd 2wd  Long Bed Wt",
            "Ss Ss",
            "1500 2wd Short Bed Custom/2wd Standard Bed Custom",
            "1500hd Lt3",
            "3500 Wt",
            "C3500 C3500",
            "1500 Ltd 4wd Standard Bed Rst",
            "1500 2wd Short Bed Lt/2wd Standard Bed Lt",
            "3500hd 4wd  Standard Bed Lt",
            "1500 Ld C1500 Custom",
            "1500 Classic Ls/lt1/work Truck",
            "2500hd 4wd  Long Bed High Country/4wd  Standard Bed High Country",
            "1500 4wd  Standard Bed Rst",
            "1500 Ltd C1500 Lt",
            "1500 4wd Short Bed Wt/4wd Standard Bed Wt",
            "1500 4wd  Standard Bed Ltz",
            "1500 Ltd Custom Trail Boss",
            "1500 Ltd 4wd Short Bed Rst/4wd Standard Bed Rst",
            "1500 Ltd 4wd Short Bed Wt",
            "1500 C1500 High Country",
            "1500 Ls/lt/work Truck",
            "1500 4wd  Short Bed Lt/4wd  Standard Bed Lt",
            "1500 4wd  Standard Bed Lt Trail Boss",
            "2500 Crew Cab Ls",
            "1500 Ltd K1500 Trail Boss Custom",
            "1500 Ltd 2wd  Standard Bed Wt",
            "3500hd 4wd  Standard Bed Wt",
            "2500 Hd Lt",
            "2500hd Ls/work Truck",
            "2500 Hd Ext Cab",
            "3500hd Srw Work Truck",
            "1500 Ls/lt1/lt2/lt3/work Truck",
            "2500 Hd Custom Cc",
            "1500hd Ls/lt",
            "1500 2wd  Short Bed High Country",
            "2500hd 2wd Double Cab Long Bed Lt",
            "2500 Hd Ls Ext Cab",
            "1500 Ls Double Cab",
            "1500 4wd Regular Cab Standard Bed Wt",
            "1500 2wd  Standard Bed Wt",
            "1500 Custom Dc",
            "1500 Ltd 4wd  Short Bed Lt With 2fl",
            "1500 4wd Double Cab Standard Bed Lt With 2fl",
            "1500 Classic C1500 Classic",
            "1500 4wd  Short Bed Lt Trail Boss/4wd  Standard Bed Lt Trail Boss",
            "3500 Srw Wrk Trk",
            "1500 1lt/lt",
            "2500hd 2wd  Standard Bed Ltz",
            "1500 4wd  Short Bed Custom Trail Boss/4wd  Standard Bed Custom Trail Boss",
            "2500hd Lt W/1lt",
            "1500 C1500/c1500  Ls",
            "2500hd Built",
            "Md",
            "Truck Bed",
            "3500hd Built",
            "Cab Only",
            "1500 C1500  Ls",
            "Ld",
            "3500hd Drw Lt",
            "1500 Hybrid",
            "2500hd Built High Country",
            "2500 Lt Ext. Cab Sprayer Bed Pickup Truck",
            "Custom",
            "Wt",
            "Rail Boss",
            "1500 Zr2",
            "Silv1500 2",
            "Silvrdo Ls",
            "3500hd Srw Lt W/1lt",
            "Silv2500 2",
            " Silver1500",
            "1500 Lt1/lt2/lt3",
            "Silv2500 4",
            "Lt2",
            "Hd 2500 4w",
            "Silver1500",
            "2",
            "Silv1500 4",
            "3500hd Drw Lt W/2lt",
            "1500 Silve",
            "1500 Lt1/lt2/lt3/ls",
            "3500hd Drw Lt W/1lt",
            "1500 Work Truck/ls/lt1",
            "1500 2wd  Long Bed Wt",
            " Silv1500 2",
            "4",
            "1500 Ss Ss",
            "3500hd Built High Country",
            "Silver 4x4",
            "Work Truck",
            "3500hd Srw Lt",
            " Truck Bed",
            "3500hd Srw Ltz",
            "1500 Work Truck/ls/ltz",
            "1500 Ld Work Truck",
            "3500hd Drw Ltz",
            "3500hd Drw Work Truck",
            "Md Lt",
            "2500hd Wt/lt",
            "2500hd Lt W/2lt",
            "1500 Work Truck/ls",
            "Silvrdo Lt",
            "Truckbed",
            " K1500hd Si",
            "1500 Ls/work Truck/lt1/lt2/lt3",
            "1500hd Classic Lt3",
            "1500 4wd  Standard Bed Lt/4wd  Short Bed Lt",
            "1500 2wd Regular Cab Standard Bed Wt",
            "00 Picku",
            "2500hd Crew Cab",
            "1500 4wd  Standard Bed Custom/4wd  Short Bed Custom",
            "2500hd 4wd Standard Bed Work Truck",
            " 2",
            "1500 2wd  Standard Bed Lt",
            "1500 Ltd 4wd  Standard Bed Lt Trail Boss",
            "1500 Work Truck/lt1",
            "1500 Work Truck/lt1/lt2/ltz",
            "Slvrd 3500",
            " Slvrd 1500",
            "2500 Base (discontinued)",
            "2500hd 4wd  Standard Bed High",
            "2500 Hd",
            "1500 4wd  Short Bed Lt With",
            "1500 4wd  Short Bed Lt Trail",
            "1500 Wt/ls",
            "1500 Base (discontinued)",
            "3500 Classic Ls",
            "3500hd Srw Lt/lt",
            "1500 Work Truck/ltz",
            "K2500 Heavy Dut",
            "0  Ls",
            "Slvrd 1500",
            "1500 Ltd Lt Trail Boss",
            "1500 Ltd Rst",
            "1500 Work Truck/lt W/1lt",
            "1500 Ltd Ltz",
            "Lt",
            "Ltz",
            "Drw Work Truck",
            "Silvrk1500",
            "2500hd Built K2500 High Country",
            "Double Cab Sr/sr5",
            "2500hd C2500 Heavy Duty Ltz",
            "2500hd Work Truck/lt W/1lt",
            "Sle",
            "2500hd Work Truck/ls/lt1/lt2/lt3",
            "1500 Lt W/1lt/lt W/2lt/ltz",
            "L Boss Custom",
            "1500 Work Truck/custom/lt/rst",
            "Om",
            "1500 4wd  Standard Bed Lt Trail Boss/4wd  Short Bed Lt Trail Boss",
            "1500 Work Truck/lt W/2lt/ltz",
            "1500 Ltd 4wd  Standard Bed Lt With 2fl",
            "1500 Ltd High Country",
            "1500 Ls/z71/lt",
            "0 Ls",
            "Y Duty",
            "Y Duty Lt",
            "1500 Ltd Work Truck",
            " Country",
            "Y Duty Ltz",
            "1500 Work Truck/lt W/1lt/ls",
            "4wd  Short Bed Lt Trail Boss",
            "4wd  Short Bed Custom Trail Boss",
            "4wd  Short Bed Wt",
            "1hy",
            "4wd  Long Bed Work Truck",
            "1lt/2lt",
            "1lt/2lt/lt",
            "4wd  Short Bed Lt",
            "1500 Base Discontinued",
            "1500 Ls/lt1/lt2/ltz/work Truck",
            "2500hd 4wd Crew Cab Standard Bed Ltz",
            "1500 Ltd 4wd  Standard Bed Lt",
            "1500 Base (discontinued)/ls/lt",
            "3500hd C3500",
            "1500 Ltd 2wd  Short Bed Ltz",
            "1500 Ltd 4wd  Standard Bed Custom",
            "1500 Ltd 4wd  Standard Bed Custom Trail Boss",
            "3500hd Chassis K3500 Lt",
            "1500 Ltd 4wd  Standard Bed Wt",
            "2500hd 4wd  Long Bed Ltz/4wd  Standard Bed Ltz",
            "Slvrado Ss",
            " Slvrd 3500",
            "1500 Ld K1500 Base/ls",
            "1500 Ltd 2wd  Short Bed High Country",
            "1500hd Lt2",
            "1500 Ltd 2wd  Short Bed Wt",
            "2lz",
            "4wd Short Bed Custom",
            "Lt Trail Boss",
            "1500 2wd  Standard Bed Rst",
            "2500hd 4wd  Long Bed High Country/4wd  Standard Bed High Count",
            "C1500 Silv",
            "1500 Ltd 4wd  Standard Bed Ltz",
            "Se",
            "1lt",
            "Lt3",
            "4wd Long Bed Work Truck",
            "4wd Long Bed Ltz",
            "2lt",
            "Ltd 4wd Short Bed Custom Trail Boss",
            "2wd Short Bed Lt",
            "4wd Short Bed Rst",
            "4wd Standard Bed Lt",
            "4wd Short Bed Custom Trail Boss",
            "High Country",
            "Lt1",
            "Work Truck 1wt",
            "Ld Silverado Custom",
            "4wd Short Bed Custom/4wd Standard Bed Custom",
            "4wd Short Bed Lt/4wd Standard Bed Lt",
            "4wd Standard Bed Ltz",
            "2500 C2500hd",
            "Ltd 2wd Short Bed Custom",
            "4wd Short Bed Lt Trail Boss",
            "4wd Long Bed Lt",
            "1lz",
            "2wd Standard Bed Lt",
            "4wd Standard Bed Wt",
            "Rst",
            "4wd  Short Bed Custom",
            "4wd  Long Bed Ltz",
            "Ls/lt/work Truck",
            "Ls/work Truck",
            "4wd Double Cab Standard Bed Custom",
            " Silvrk1500",
            "2500hd 2wd  Long Bed Lt",
            "1500 Ltd K1500 Lt-l",
            "2500hd 2wd  Standard Bed Lt",
            "1500 4wd  Short Bed Lt Trail Boss/4wd  Standard Bed Lt Trail",
            "1500 4wd  Short Bed Custom Trail Boss/4wd  Standard Bed Cust",
            "1500 4wd  Short Bed High Country/4wd  Standard Bed High Coun",
            "2500 K2500 Heavy Duty Lt",
            "Pick Up",
            "K2500 Heavy Duty Bed Only",
            " Silv1500 4",
            "C1500 Classic Hd",
            "4wd Long Bed Custom/4wd Standard Bed Custom",
            "Ls/lt1/work Truck",
            "2wd Long Bed Wt",
            "4wd Standard Bed Custom",
            "4wd Short Bed Ltz",
            "Medium Duty 1wt",
            "4wd Short Bed Lt With 2fl",
            "Ltd 2wd Short Bed Lt",
            "2wd Short Bed Custom",
            "2wd  Short Bed Custom",
            "2hy",
            "4wd Standard Bed Lt Trail Boss",
            "Xtra Fuel Economy",
            "Work Truck 2wt",
            "2wd  Long Bed Wt",
            " Silver 4x4",
            "Slvt",
            "Pick",
            " Silvrdo Lt",
            "2 Ton",
            "Z71",
            "Ld Wt",
            "Ls/lt",
            "2wd  Standard Bed Wt",
            "4wd Long Bed Wt",
            "Ld Lt",
            "Ltd 4wd Short Bed Ltz",
            "4wd Standard Bed Work Truck",
            "4wd  Standard Bed Wt",
            "2500 Hd Ls Crew Cab",
            "Ltd 4wd Short Bed Rst",
            "K3500 Silv",
            "Pickup",
            " K1500 Silv",
            " 1500 Silve",
            " C/k 1500 S",
            "00 Hd",
            " Silvrdo Ls",
            " Silv2500 4",
            "500 4x4",
            " Slvrado Ss",
            " 4",
            "4wd  Long Bed Lt",
            "2wd  Short Bed Lt",
            " Silv2500 2",
            "4wd Long Bed Custom",
            "Custom Trail Boss",
            "2wd Short Bed Rst",
            "4wd Standard Bed Rst",
            "4wd  Short Bed Ltz",
            "4wd  Standard Bed Lt",
            "2wd  Standard Bed Lt",
            "4wd Short Bed Zr2",
            "/1500",
            "Ltd 4wd Short Bed Custom",
            "4wd  Standard Bed Ltz",
            "2wd Short Bed Ltz",
            "4wd  Short Bed Rst",
            "1hy/2hy",
            "Ls/wt",
            "4wd Short Bed Lt",
            "4wd Short Bed Wt",
            "2wd Short Bed Wt",
            "2wd Long Bed Work Truck",
            "2wd Standard Bed Wt",
            "2wd Double Cab Standard Bed Custom",
            "2500 Hd Wt Crew Cab",
            "4wd  Long Bed Wt",
            "4wd Short Bed High Country",
            "2wd  Short Bed Wt",
            "Ltd 4wd  Short Bed Custom",
            "4wd  Short Bed Lt/4wd  Standard Bed Lt",
            "4wd Double Cab Standard Bed Wt",
            "4wd  Standard Bed Custom",
            "4wd Double Cab Long Bed Work Truck",
            "Work Truck 1wt/work Truck 2wt",
            "4wd  Short Bed Custom/4wd  Standard Bed Custom",
            "Hd",
            "4wd Double Cab Long Bed Wt",
            "Ltd 2wd  Short Bed Custom",
            "Lt1/lt2/ltz/work Truck",
            "4wd Double Cab Standard Bed Lt",
            "2wd  Short Bed Rst",
            "4wd  Short Bed Lt With 2fl",
            "Ltd 4wd Standard Bed Lt",
            "4wd Double Cab Standard Bed Ltz",
            "Ltd 4wd Short Bed Lt Trail Boss",
            "4wd Long Bed Lt/4wd Standard Bed Lt",
            "4wd  Short Bed Zr2",
            "Ltd 2wd  Short Bed Lt",
            "6500 Work Truck",
            "K1500 Slt",
            "1lz/2lz",
            "Ltd 4wd Short Bed Lt With 2fl",
            "4wd  Long Bed Custom/4wd  Standard Bed Custom",
            "2500 Hd Crew (amalg)",
            "4wd Short Bed Custom Trail Boss/4wd Standard Bed Custom Trail Boss",
            "4wd  Standard Bed High Country",
            "4wd  Standard Bed Rst",
            "Ltd 4wd  Short Bed Ltz",
            "4wd Double Cab Long Bed Lt/4wd Double Cab Standard Bed Lt",
            "K1500 Ppv",
            "4wd Standard Bed High Country",
            "4wd  Short Bed High Country",
            "Ls/lt1/lt2/lt3/work Truck",
            "4wd  Standard Bed Lt Trail Boss",
            "Ltd 4wd Short Bed Lt",
            "Ltd 4wd  Short Bed Custom Trail Boss",
            "5500",
            "Ltd 4wd  Short Bed Rst",
            "Ltd 4wd  Short Bed Lt",
            "2500 Hd Wt Ext Cab",
            "2wd Short Bed High Country",
            "Pickuptruk",
            "Ltd 4wd  Short Bed Lt Trail Boss",
            "2500 Hd Hc Crew Cab",
            "2500 C2500 Heavy Duty",
            "4wd Long Bed High Country",
            "Ltd 4wd  Standard Bed Lt",
            "2wd  Short Bed Ltz",
            "Ltd 4wd Short Bed Rst/4wd Standard Bed Rst",
            "C1500 Silverado",
            "Commercial/ls",
            "4wd  Long Bed Custom",
            "4wd  Standard Bed Work Truck",
            "Luxury Collection",
            "2500 High Country",
            "K2500 Utility Bed Pickuptruck",
            "2wd Double Cab Long Bed Wt/2wd Double Cab Standard Bed Wt",
            "4wd Double Cab Standard Bed Rst",
            "1500 Pickup Truck",
            "2wd Double Cab Long Bed Wt/2wd Double Cab Standard Bed",
            "Medium Duty Work Truck",
            "2wd Double Cab Standard Bed Wt",
            "Ltd 4wd Long Bed Wt",
            "2500 Hd Lt Dbl Cab",
            "4wd Short Bed Rst/4wd Standard Bed Rst",
            "Medium Duty 6500hd 4x4",
            "Ltd 4wd  Short Bed Lt With 2fl",
            "4wd Double Cab Standard Bed Lt With 2fl",
            "Gm515 Flatbed Truck",
            "Hd 2500 2w",
            "1500 Work",
            "Ev First-edition Rst 4wd",
            "4wd  Short Bed Custom Trail Boss/4wd  Standard Bed Cust",
            "Ltd 4wd  Short Bed Rst/4wd  Standard Bed Rst",
            "Ltd 4wd Short Bed Wt",
            "4wd  Long Bed High Country",
            "Dump Truck",
            "4wd  Long Bed Lt/4wd  Standard Bed Lt",
            "4wd Long Bed High Country/4wd Standard Bed High Country",
            "4wd Long Bed Ltz/4wd Standard Bed Ltz",
            "4wd Double Cab Long Bed Custom",
            "2wd Double Cab Long Bed Wt",
            "2wd  Short Bed High Country",
            "4wd Short Bed Ltz/4wd Standard Bed Ltz",
            "4wd  Short Bed Rst/4wd  Standard Bed Rst",
            "2wd Long Bed Wt/2wd Standard Bed Wt",
            "Lt W/1lt",
            "Hd 2500 2w Lt1",
            "Ev Rst",
            "Ltd 4wd Double Cab Standard Bed Custom"
          ]
        },
        {
          "model": "Sonic",
          "series": [
            "Premier",
            "Ltz",
            "Ls Auto",
            "Fwd Lt",
            "Lt Auto",
            "Lt",
            "Ltz Auto",
            "2lt",
            "Rs Manual",
            "Lt Manual",
            "Premier Auto",
            "Rs Auto",
            "Ltz Manual",
            "1ls",
            "Rs",
            "Ls",
            "2ls",
            "2lz",
            "Ls Manual",
            "Fwd Ls",
            "Fwd Lt 5-door",
            "1lz",
            "1lt",
            "Fwd Premier",
            "Cv1",
            "Fwd Premier 5-door",
            "Fwd 1fl 5-door",
            "Fwd  1fl 5-door",
            "Fwd  Lt",
            "Fwd  Premier",
            "Prem",
            "Fwd  Ls",
            "Fwd  Lt 5-door",
            "4d Lt",
            "4d Ls",
            "O",
            "To",
            "R",
            "Fwd  Premier 5-door",
            "Ls Ls",
            "Prem Prem",
            "Ado 1500 Silve",
            "4d",
            "Ls A",
            "Rs Rs",
            "Ls Lt",
            "Premier Manual",
            "4d F",
            "Lt Auto/lt Manual"
          ]
        },
        {
          "model": "Spark",
          "series": [
            "Ls Auto",
            "1lt",
            "Ls",
            "Fwd Ls Automatic",
            "Ls Cvt",
            "2lt",
            "Fwd Ls Manual",
            "1lt Auto",
            "1lt Cvt",
            "Fwd 1lt Automatic",
            "2lt Auto",
            "Activ",
            "Ls Manual",
            "2lt Cvt",
            "1lt Manual",
            "Lt",
            "Gt",
            "Ev 1lt",
            "Ev 2lt",
            "Fwd 1lt Manual",
            "Fwd Activ Automatic",
            "Fwd 2lt Automatic",
            "Activ Manual",
            "Fwd Activ Manual",
            "2lt Manual",
            "Activ Cvt",
            "Ev 1",
            "Acti",
            "5d",
            "4d Ls",
            "4d 1lt",
            "Ev 2",
            "2lt 2lt",
            "Ev",
            "K S10",
            "1lt Cvt/2lt Cvt"
          ]
        },
        {
          "model": "Spark Classic",
          "series": []
        },
        {
          "model": "Spark EV",
          "series": [
            "2lt",
            "1lt",
            "Lt",
            "2 Ev 2",
            "1",
            "2"
          ]
        },
        {
          "model": "SS",
          "series": [
            "Verado K1500",
            "396"
          ]
        },
        {
          "model": "Suburban",
          "series": [
            "K1500",
            "K1500 Premier",
            "C1500 Premier",
            "K1500 Rst",
            "4wd Lt",
            "K1500 Lt",
            "C1500 Lt",
            "K2500",
            "Z71",
            "4wd Z71",
            "Ls",
            "2wd High Country",
            "C1500 Ls",
            "Lt",
            "2wd Lt",
            "K1500 Ltz",
            "C1500 Rst",
            "C1500",
            "C1500 Ltz",
            "2wd Premier",
            "2wd Commercial",
            "4wd Rst",
            "K1500 Ls",
            "K1500 Z71",
            "4wd Premier",
            "Commercial Fleet",
            "4wd High Country",
            "Ltz",
            "2wd Ls",
            "2wd Rst",
            "4wd Commercial",
            "K1500 High Country",
            "K10",
            "R1500",
            "K2500 Lt",
            "00",
            "Premier",
            "4wd Ls",
            "V2500",
            "V1500",
            "Lt W/2lt",
            "Rst",
            "C2500",
            "R1",
            "V10",
            "K2",
            "C2500 Ls",
            "K3500 Lt",
            "K",
            "V200",
            "C1500  Ls",
            "C1500 High Country",
            "R20",
            "R2500",
            "Suv",
            "K2500 Ls",
            "K2500 Suv",
            "C",
            "C2",
            "Commercial",
            "3500hd Ls",
            "Base",
            "Ls/lt/ltz/commercial",
            "Suburb Ltz",
            "1",
            "Lt W/1lt",
            "Commercial/ls",
            "Suburan",
            "High Country",
            "C2500 Lt",
            "1 1",
            "Parts",
            "Mier",
            "M",
            "L/ls",
            "2wd Commercial Fleet",
            "Lt W/3lt",
            "Try",
            "L",
            "Ls W/1wt",
            "C10",
            "Fleet Awd",
            "Z",
            "Lt1",
            "L L",
            "C2500  Lt",
            "Subur 1500",
            "0",
            "Suburan C",
            "Suburb",
            "Subrbn1500",
            "V",
            " Suburan C",
            "C1500 Taho",
            "Ls/lt/ltz",
            "Lt2",
            "O",
            "K1500 Suv",
            "U",
            "4wd Commercial Fleet",
            "Ls/lt",
            "Ls/lt/z71"
          ]
        },
        {
          "model": "Suburban 1500",
          "series": [
            "Ls",
            "Lt",
            "Ltz",
            "Lt2",
            "Lt1",
            "Z71",
            "K1500 Ltz",
            "C1500 Ltz",
            "K1500",
            "C1500",
            "C1500 Lt",
            "K1500 Lt",
            "Commercial Fleet",
            "K1500 Ls",
            "C1500 Ls",
            "Ls/lt/ltz",
            "Suv",
            "Ls/lt/z71",
            "Ls/lt",
            " Lt",
            "Ls/z71/lt",
            "4d Ls",
            "Lariat/xl/xlt",
            "  Ls",
            "C1500  Ls"
          ]
        },
        {
          "model": "Suburban 2500",
          "series": [
            "Lt",
            "Lt1",
            "Commercial Fleet",
            "Lt2",
            "Ls",
            "K2500",
            "C2500",
            "Suv",
            "K2500 Ls",
            "K2500 Lt",
            "Ls1/lt1"
          ]
        },
        {
          "model": "Suburban 3500 HD",
          "series": []
        },
        {
          "model": "Tahoe",
          "series": [
            "Ls",
            "K1500 Lt",
            "C1500 Lt",
            "Ltz",
            "C1500",
            "Lt",
            "Premier",
            "K1500 Ltz",
            "K1500",
            "Special",
            "4wd Lt",
            "4wd Rst",
            "Z71",
            "Commercial Fleet",
            "2wd Ls",
            "All New Lt",
            "Lt1",
            "2wd Lt",
            "Limited",
            "K1500 Z71",
            "C1500 Tahoe Lt",
            "K1500 Tahoe Ltz",
            "4wd Z71",
            "Police",
            "C1500 Ls",
            "K1500 Ls",
            "C1500 Ltz",
            "K1500 Premier",
            "K1500 Rst",
            "Hybrid",
            "C1500 Premier",
            "K1500 High Country",
            "C1500 Rst",
            "4wd Commercial Fleet",
            "All New Ls/all New Lt",
            "Lt2",
            "2wd Commercial Fleet",
            "4wd Commercial",
            "4wd Ls",
            "Commercial",
            "C150",
            "4wd Premier",
            "4wd High Country",
            "All New Ls",
            "C1500 High Country",
            "2wd Rst",
            "K1500 Hybrid",
            "C1500 Hybrid",
            "2wd High Country",
            "2wd Premier",
            "Lt W/1lt",
            "Ls/lt/z71",
            "Lt Cmi",
            "C1500 Police",
            "Special Services",
            "K1500 Police",
            "Lt W/3lt",
            "C1500  Ls",
            "C1500 Police/spcl Svc",
            "K150",
            "Hybrid Hybrid",
            "2wd Commercial",
            "Police Suv",
            "Suv",
            "Ls/ls W/1wt/lt/z71",
            "Ls/lt",
            "Ls/lt/ltz",
            "K1500 Police/special Svc",
            "Poli",
            "Hybrid K1500 Hybrid",
            "Hybr",
            "Spec",
            "Lt W/2lt",
            "Ountry",
            "Ls/lt/z71/commercial",
            "Ls Xfe",
            "Commercial/police",
            "L",
            "Special Service Vehicle",
            "High Country",
            "Rst",
            "Cial/police",
            "Ls 1",
            "Commercial/ls",
            "4d Lt",
            "L Service Vehicle",
            "Ls/base/lt",
            " Ls",
            "Ls W/1wt",
            "Ls/commercial",
            "Cial",
            "Ls/lt/ltz/commercial",
            "R",
            "Ls2wd",
            "D Lt",
            "Hybr Hybr",
            "Mium Luxury",
            "All New Base",
            "1500",
            "T",
            "2wd Commercial Fleet/4wd Commercial Fleet",
            "Taho Lt",
            "K1500 Taho",
            "Limi",
            "Other",
            "4x4",
            "Lt 1",
            "K150 K150",
            "Her 150",
            "4d 4",
            "Lt 1 Lt 1",
            "Ls/lt/lt W/2lt/ltz",
            "Racked Skid Steer Loader",
            "Ls Ls",
            "4wd Short Bed Lt Trail Boss",
            "S/lt",
            "Police Police",
            "Taho",
            "Lt1/lt2",
            "Fl",
            "K S10",
            "Rst/z71"
          ]
        },
        {
          "model": "Tornado",
          "series": []
        },
        {
          "model": "Tornado Van",
          "series": []
        },
        {
          "model": "Tracker",
          "series": [
            "Hard Top",
            "Hard Top Lt",
            "Hard Top Base",
            "Lt",
            "Zr2",
            "Hard Top Zr2",
            "Lx",
            "Base Cmi",
            "Zr",
            "Base",
            "Zr2 Sport",
            "Hard Top Base/hard Top Lt"
          ]
        },
        {
          "model": "Trailblazer",
          "series": [
            "Fleet",
            "Ls",
            "Lt",
            "Fwd Ls",
            "Awd Rs",
            "Fwd Lt",
            "Rs",
            "Activ",
            "Ltz",
            "Fwd Rs",
            "Ext Ls",
            "Ext Lt",
            "Awd Lt",
            "Ls/lt",
            "Ext",
            "Ext Ls/lt",
            "Ss",
            "Awd Activ",
            "Fwd Activ",
            "Awd Ls",
            "Ext Ext",
            "L",
            "Ext Ext Ls/ext Lt",
            "Ext Ls/ext Lt",
            "Ls/lt/ltz",
            "Lt Turbo",
            "Ls Suv",
            "Suv",
            "Activ Turbo",
            "Rs Turbo",
            "Lt W/2lt",
            "Fleet W/1fl",
            "Ailblaze",
            "Ss W/1ss",
            "Fleet W/2fl",
            "Lt W/3lt",
            "Lt W/1lt",
            "Ss W/3ss",
            "4d Lt",
            "Railblazr",
            "Fwd L",
            "Rail Blaz",
            "Ls Turbo",
            "Ext Ls/lt/north Face Edition",
            "Lt1/lt3",
            "Ls/lt/vl"
          ]
        },
        {
          "model": "Traverse",
          "series": [
            "Ls",
            "Lt",
            "Premier",
            "Fwd Ls",
            "2lt",
            "1lt",
            "Awd Lt Cloth",
            "Ltz",
            "Awd Ls",
            "Rs",
            "Lt W/1lt",
            "Fwd Lt Leather",
            "3lt",
            "High Country",
            "Awd Premier",
            "Fwd Rs",
            "1fl",
            "Awd Lt Leather",
            "Fwd Lt Cloth",
            "Awd High Country",
            "Fwd Premier",
            "Awd Rs",
            "Fwd High Country",
            "Lt Cloth",
            "L",
            "Fwd 1fl",
            "2fl",
            "Lt Leather",
            "Limited Ls",
            "Limited Lt",
            "Fwd 2fl",
            "Awd 2fl",
            "Base Ls",
            "High Country/rs",
            "Limited Fwd Lt Cloth",
            "Awd 1fl",
            "Fwd 2fl Cloth",
            "Lt W/2lt",
            "Z",
            "Limited Fwd Ls",
            "Awd 2fl Cloth",
            "Limited Premier",
            "Limited Fwd High Country",
            "Limited Awd Lt Cloth",
            "Limited Fwd Lt Leather",
            "Awd Z71",
            "Fwd Lt",
            "P",
            "T",
            "Limited Fwd Rs",
            "Lt Z71",
            "Limited High Country",
            "Awd Lt",
            "Limited Awd Rs",
            "Ls/ltz",
            "Limited Rs",
            "H",
            "Try/rs",
            "R",
            "L Ls",
            "4d L",
            "4d Lt",
            "4d Ls",
            "Ls1 Ls",
            "2",
            "Prm",
            "Try",
            "4",
            "Limited Fwd Premier",
            "R R",
            "Limited Awd Lt Leather",
            "Limited Awd Premier",
            "Z71",
            "4 L",
            "Limited",
            "H H",
            "1lt/2lt",
            "Lt True North",
            "Lt1 Fwd 1lt",
            "1ls"
          ]
        },
        {
          "model": "Trax",
          "series": [
            "1lt",
            "Ls",
            "Lt",
            "Fwd Lt",
            "Fwd Ls",
            "Fwd 2rs",
            "2rs",
            "1ls",
            "Awd Lt",
            "Awd Ls",
            "Fwd 1rs",
            "1rs",
            "Activ",
            "Fwd Sp",
            "Fwd Activ",
            "Premier",
            "Ltz",
            "1fl",
            "Fwd Premier",
            "Awd Premier",
            "2lt",
            "Rs",
            "Premi",
            "Lt Aw",
            "Lt Plate",
            "Er",
            "2lt 2lt",
            "Ltz Ltz",
            "Premi Premi",
            "Lt Fw",
            "1ls A",
            "1lt A",
            "2lt A",
            "4d 1r",
            "Ls Aw",
            "Ca Touring L",
            "4d 2w",
            "1rs Fwd",
            "Activ Fwd",
            "Lt Fwd",
            "2rs Fwd"
          ]
        },
        {
          "model": "Volt",
          "series": [
            "Premier",
            "Lt",
            "Ltz",
            "Premi",
            "Er",
            "Ltz Ltz",
            "Premi Premi",
            "Ev Premier",
            "Ev Lt"
          ]
        },
        {
          "model": "W4500 Tiltmaster",
          "series": []
        },
        {
          "model": "W5500 Tiltmaster",
          "series": []
        }
      ]
    },
    {
      "make": "Chrysler",
      "models": [
        {
          "model": "200",
          "series": [
            "Limited",
            "C",
            "Lx",
            "Touring",
            "Limited Platinum",
            "S",
            " & Country Touring",
            "Limited V6",
            "C V6",
            "Fica Touring L Plus",
            "S V6",
            "Slt",
            "Touring V6",
            "Limite",
            "Fica Touring L",
            "Tourin",
            "200s Alloy Edition",
            "4d S",
            "4d 2wd",
            "Sedan",
            "V6",
            "C Awd",
            "C Platinum",
            "200s",
            "4d Ltd",
            "4d C",
            "Ing Touring",
            "Ruiser Touring",
            "Limite Limite",
            "Lx Lx",
            "Tourin Tourin",
            "C C",
            "S S",
            "K2500 Heavy Duty Lt",
            "200c Platinum",
            "S V6 Convertible",
            "Ls",
            "200s Alloy Edition Awd",
            "Limited Fwd Limited",
            "Limited/limited Platinum"
          ]
        },
        {
          "model": "300",
          "series": [
            "Limited",
            "Motown",
            "300s",
            "S",
            "Touring",
            "Limited Awd",
            "Hemi",
            "300c",
            "Touring/signature Series/executive Series",
            "Platinum",
            "C",
            "300s Awd",
            "300c Awd",
            "Srt8",
            "300s Alloy Edition",
            "Lx",
            "Touring L",
            "300s Alloy Edition Awd",
            "Luxury Series",
            "Awd",
            "300s V6",
            " Varvatos",
            "S V6",
            "300 Srt8 Core",
            "Platinum Awd",
            "S V8",
            "Touring Awd",
            " Special",
            "Touring/signature Series",
            "Srt-8",
            " Luxury",
            " Srt-8",
            "Anniversary Edition",
            "John Varvatos",
            " Platinum",
            "John Varvatos Luxury Edition Awd",
            "C Platinum",
            "Touring L Awd",
            "Srt",
            "300 Touring",
            "John Varvatos Limited Edition",
            "Touring-l Awd",
            "John Varvatos Luxury",
            "300c John Varvatos Luxury Edition",
            "John Varvatos Luxury Edition",
            "Uptown Edition",
            "Touring Plus",
            "300",
            "Luxury",
            "Luxury Series Awd",
            "S Awd",
            "C Awd",
            "Touring/touring L",
            "Varvatos",
            "Os",
            "V8",
            "Limite",
            "Tourin",
            "Fica Touring L",
            "Fica L",
            "John Varvatos Limited Edition Awd",
            "300s Glacier",
            "M",
            " C",
            " John Varvatos Luxury Edition",
            "Chrysler 3",
            "Letter",
            " Varva C Varva",
            "C C",
            " Plati C Plati",
            "4d S",
            " Srt8",
            " 300c Platinum",
            " 300c Awd",
            " 300c",
            " Luxur",
            " Varva",
            "V6",
            " John Varvatos Luxury",
            " Awd",
            "M Speci",
            "S Rwd 300s",
            "Hurst",
            " V8",
            "Srt8 C",
            " Srt-8 C Srt-8",
            "               300c",
            "Touring/limited",
            "Srt8 Core",
            "4d Tou/l",
            " Luxury Series",
            "300 S",
            " Luxur C Luxur",
            " John Varvatos Luxury Edition Awd",
            " Luxury Series Awd",
            "C Srt-8",
            " Platinum Awd",
            " John Varvatos Limited Edition",
            "300s/300s Alloy Edition",
            " S",
            "Ruiser Limited",
            "C Varva",
            "C Hemi",
            "C Plati",
            "C Luxur",
            "300c Hemi",
            "300c John Varvatos",
            "Touring Signature",
            "300c Srt8",
            "300s V8",
            "300c Platinum",
            "300c Luxury Series",
            "Mopar 12",
            "Signature",
            " Hemi",
            "300 Touring Awd",
            " John Varvatos",
            " 300s V8",
            "C Srt8",
            "Tourin Tourin",
            "Rwd Motown",
            " John Varvatos Limited Edition Awd",
            "Lx Lx",
            "Limite Limite",
            "300s Alloy Edition Awd/300s Awd",
            "300 S Awd",
            "Fica Limited",
            "Srt-8 Srt-8",
            "Touring-L"
          ]
        },
        {
          "model": "Cirrus",
          "series": [
            "Lxi",
            "Lx/lxi",
            "Lx"
          ]
        },
        {
          "model": "Grand Caravan",
          "series": [
            "Gt",
            "Sxt",
            "Try Touring",
            "Se",
            "An Sxt"
          ]
        },
        {
          "model": "Pacifica",
          "series": [
            "Touring L",
            "Touring",
            "Hybrid Touring L",
            "Touring Plus",
            "Touring L Plus",
            "Hybrid Limited",
            "Lx",
            "Limited",
            "Hybrid Select",
            "Pinnacle",
            "Touring-l Plus",
            "Pinnacle Awd",
            "Touring-L",
            "Awd Launch Edition",
            "Limited Awd",
            "35th Anniversary Touring L",
            "L",
            "Hybrid Touring Plus",
            "Touring L Awd",
            "X",
            "Ehybrid Premium",
            "Hybrid Pinnacle",
            "Hybrid Hybrid Pinnacle",
            "Hybrid Premium",
            "Hybrid Platinum",
            "Hybrid Touring-l",
            "35th Anniversary Touring L Plus",
            "Ehybrid Platinum",
            "Hybrid Hybrid Limited",
            "Hybrid Touring",
            "Touring Awd",
            "H",
            "35th Anniversary Limited",
            "Launch Edition Awd",
            "Hybrid Red S Edition",
            "Limited Hybrid",
            "Hybrid Ehybrid Platinum",
            "Hybrid Hybrid Touring L",
            "T",
            "Red S Edition",
            "Hybrid 35th Anniversary Touring L",
            "Hybrid Touring-l Plus",
            "Hybrid 35th Anniversary Limited",
            "Hybrid Touring L Plus",
            "Hybrid Premium S Appearance Pkg",
            "P",
            "E",
            "Hybrid Red S",
            "Touring L 35th",
            "Touring L Plus 35th",
            "Launch Edition",
            "Limited 35th Anniversary",
            "Touring Plus/touring-l",
            "H H",
            "T T",
            "Ehybrid Touring",
            "Tou",
            "4d",
            "Hybrid Limited 35th",
            "Red S",
            "Pacifica",
            "Select",
            "S",
            "L L",
            "Hybrid S Appearance Pkg",
            "Touring-l 35th Anniversary",
            "Touring-l Plus Awd",
            "Premium S Appearance Pkg",
            "Touring L F Touring L",
            "Hybrid Premium S Appearance Pkg/road Tripper/s Appearance Pkg/select",
            "35th Anniversary Limited/limited/red S Edition",
            "Platinum",
            "35th Anniversary Touring L Plus/touring L Plus",
            "Hybrid Premium S Appearance Pkg/road Tripper/s Appearance Pkg/",
            "E E",
            "Touring Van",
            "Pinnacle Hybrid",
            "Touring-l Awd",
            "Hybrid Premiuim S Appearance Package",
            "Plug-in Hybrid Pinnacle",
            "Utility"
          ]
        },
        {
          "model": "PT Cruiser",
          "series": [
            "Limited",
            "Touring",
            "Lx",
            "Gt",
            "Classic",
            "Limited/dream Cruiser",
            "Touring Edition",
            "Classic Edition",
            "Pt Cruise"
          ]
        },
        {
          "model": "Sebring",
          "series": [
            "Touring",
            "Limited",
            "Lx",
            "Lx/lx Plus",
            "Lxi",
            "Jx",
            "Gtc",
            "Jxi",
            "Touring/limited",
            "Sdn Touring",
            "Ted",
            "Special",
            "Tsi",
            "Ct",
            "Lxi/touring",
            "Gt",
            "Ltd",
            "Sdn",
            "To",
            "Li",
            "Touring  *ltd Avail*",
            "Lx  *ltd Avail*",
            "Limited  *ltd Avail*",
            "Li Li",
            "To To",
            "Lx Lx",
            "Touring *ltd Avail*",
            "Xb",
            "Hard Top Convertible",
            "4d"
          ]
        },
        {
          "model": "Town & Country",
          "series": [
            "Touring",
            "Touring L",
            "El",
            "Limited Platinum",
            "Limited",
            "Lxi",
            "Lx",
            "Touring-L",
            "Swb",
            "Touring Plus",
            "New Lx",
            "Touring-l 30th Anniversary",
            "S",
            "Premium",
            "Sx",
            "Ex",
            "New Limited",
            "Touring-l Anniversary Edition",
            "Touring Ed",
            "Lmt",
            "Lwb Limited",
            "Lx/lxi",
            "Van",
            "Lwb Touring",
            "Cou",
            "Touring W/leather",
            " And C",
            " & Cou",
            "Unt",
            "Nd C",
            "&count",
            "Touring-l 30th",
            "Touring-l Anniversary",
            "Touri Touring",
            "Sxt"
          ]
        },
        {
          "model": "Voyager",
          "series": [
            "Lxi",
            "Lx",
            "L",
            "Base",
            "Se",
            "Voyager Lx",
            "Voyager L",
            "Ec",
            "Lx Voyager Lx"
          ]
        }
      ]
    },
    {
      "make": "Dodge",
      "models": [
        {
          "model": "Atos",
          "series": []
        },
        {
          "model": "Attitude",
          "series": []
        },
        {
          "model": "Avenger",
          "series": [
            "Sxt Plus",
            "Sxt",
            "Sxt/se",
            "R/t",
            "Se",
            "Express",
            "Mainstreet",
            "Se V6",
            "Se/sxt",
            "Sxt V6",
            "Lux",
            "Sxt/r/t",
            "Es",
            "Sx",
            "Sport",
            "R/",
            "Ex",
            "Lu",
            "Ma",
            " Sl",
            "Heat",
            "Et",
            "Rt",
            "Cc 150 Cus Cc",
            "Sp",
            "4d Lux",
            "4d Se",
            "Base",
            "4d Sxt",
            "Se Se",
            "Lu Lu",
            "R/ R/",
            "Ma Ma",
            "Ex Ex",
            "Mainstreet V6",
            "4d 2wd",
            "Tl (bci) Cr-v Ex Au",
            "/es"
          ]
        },
        {
          "model": "Caliber",
          "series": [
            "Sxt",
            "Mainstreet",
            "Heat",
            "Se",
            "R/t",
            "Uptown",
            "Sxt Plus",
            "Express",
            "Rush",
            "Srt4",
            "Srt-4",
            "Ma",
            "Sx",
            "R/",
            "Ex",
            "He",
            "Ru",
            "Up",
            "Et",
            "Sr",
            "-4",
            "Sx Sx",
            "Ex Ex",
            "He He",
            "Ma Ma",
            "Sw"
          ]
        },
        {
          "model": "Challenger",
          "series": [
            "Srt Hellcat",
            "R/t Scat Pack",
            "Sxt",
            "R/t",
            "Se",
            "Srt8",
            "Sxt 100th Anniversary Appearance Group",
            "Sxt Plus",
            "Gt",
            "R/t 392",
            "Gt Awd",
            "R/t Plus",
            "Sxt Plus Or R/t Plus",
            "R/t Scat Pack Widebody",
            "Srt Hellcat Redeye Widebody",
            "Srt Hellcat/srt Hellcat Widebody",
            "Sxt Or R/t",
            "Rallye Redline",
            "Srt-8",
            "392 Hemi Scat Pack Shaker",
            "Srt Hellcat Redeye",
            "Srt 392",
            "Sxt Awd",
            "R/t Classic",
            "R/t Shaker",
            "R/t Scat Pack/r/t Scat Pack Shaker",
            "T/a",
            "Srt8 392",
            "Srt Super Stock",
            "R/t Scat Pack Shaker",
            "R/t Plus Shaker",
            "Shaker Pkg",
            "Srt Hellcat Widebody",
            "R/t 100th Anniversary Appearance Group",
            "R/t Scat Pack Widebody 50th Anniversary",
            "R/t 50th Anniversary",
            "T/a Plus",
            "Srt8 Core",
            "Srt Hellcat Jailbreak",
            "T/a 392",
            "Scat Pack 392",
            "Scat Pack",
            "Rt Shaker",
            "R/t Scat Pack 50th Anniversary",
            "Rallye Redline/sxt/sxt 100th Anniversary Appearance Group/sxt Plus",
            "Mopar Edition R/t",
            "Sxt Plus Or R/t",
            "Srt",
            "Srt Hellcat Redeye Widebody Jailbreak",
            "Sxt/sxt Plus",
            "Gt 50th Anniversary",
            "Se/sxt",
            "Srt Demon",
            "Police",
            "R/t Scat Pack 50th Ann.",
            "Ck",
            " Redeye",
            "Chalng Rt",
            "Rt",
            "Chalng  Rt",
            "Ck Shaker",
            "Gt 50th Ann.",
            "R/t 50th Ann.",
            "Yellow Jacket",
            "R",
            "Sxt 100th Anniversary",
            "S/r",
            "N.",
            "Ck 50th Ann.",
            "Nniversary",
            "At Pack Shaker",
            "Ck Widebody",
            "Aker",
            "Ine",
            " Widebody",
            "R/t/r/t Plus/t/a/t",
            " R/t Plus",
            "Srt Jailbreak",
            "Rallye Redline/sxt/sxt 100th Anniversary Appearance Gro",
            ".",
            "2d Sxt",
            "Hellcat",
            "Chall Srt8",
            "S/sv/sl",
            "R/t/r/t Plus/r",
            "Scat Pack 392 Widebody",
            "R/t/r/t Plus/r/t Plus Shaker/r/t Shaker/t/a/t/a Plus",
            "C1500 Ls",
            "C1500  Ls",
            "Lariat/xl/xlt",
            "Scat Pack 392 50th",
            "R/t/r/t Classic/r/t Plus"
          ]
        },
        {
          "model": "Charger",
          "series": [
            "R/t Rwd",
            "Scat Pack",
            "R/t 392",
            "Se",
            "R/t",
            "Sxt Awd",
            "Sxt Rwd",
            "Sxt",
            "Scat Pack Rwd",
            "Daytona 392 Rwd",
            "Road/track",
            "Police",
            "Sxt Plus Rwd",
            "Scat Pack Widebody Rwd",
            "R/t Scat Pack",
            "Srt Hellcat",
            "Gt",
            "Gt Rwd",
            "R/t 100th Anniversary",
            "Sxt Plus",
            "Srt 392",
            "Daytona 340 Rwd",
            "Se Rwd",
            "Police Awd",
            "Srt Hellcat Rwd",
            "R/t Scat Pack Rwd",
            "Rt",
            "Scat Pack Widebody",
            "Daytona Rwd",
            "Srt8 Super Bee",
            "Gt Awd",
            "R/t Plus",
            "Srt8",
            "Sxt 100th Anniversary",
            "Srt-8",
            "R/t Max",
            "Srt8 Superbee",
            "Srt Hellcat Redeye Widebody Rwd",
            "Srt Jailbreak",
            "Srt Hellcat Widebody Rwd",
            "Pursuit",
            "Police Rwd",
            "Srt Hellcat Widebody",
            "Rallye",
            "Sc",
            "Super Bee",
            "Se/sxt",
            "R/",
            "Srt Hellcat Redeye Widebody",
            "Er Srt Hellcat Redeye",
            "Sr",
            "Sx",
            "Sp",
            "V6",
            "Motor And Transmission Only",
            "3.5l",
            "Srt 392 Rwd",
            "Lx",
            "Scat Pack Rwd/scat Pack Widebody Rwd",
            "Rt 100th Anniversary",
            "R/t/r/t 100th Anniversary/r/t Max/r/t Plus/road/track",
            " Plus",
            "              Charger",
            "Enforcer Police",
            "Se Awd",
            "Srt",
            "Se V8",
            "Scat Pack/scat Pack Widebody",
            "Sxt/sxt Plus",
            "Sxt/sxt 100th Anniversary/sxt Plus",
            "Daytona R/t",
            "4d 2wd",
            "Daytona Rwd/r/t Rwd",
            "Daytona 340",
            "Cat",
            "Po",
            "Ra",
            "Rt Max",
            "Daytona 392",
            "Daytona",
            "Rt Plus",
            "K",
            "Rallye Plus",
            "Aw Aw",
            "Srt Hellcat Redeye Wide",
            "R/t/road/track",
            "Rt Scat Pack",
            "Pack",
            "R/t Daytona Edition",
            "Srt Redeye Jailbreak",
            "Ck",
            "Mopar 11",
            "340",
            "Srt Hellcat Redeye",
            "Cat Redeye",
            "Se/rallye/rallye Plus",
            "R/t Scat Pack/daytona 392",
            "Se/police",
            "392",
            " Pack",
            "Us/road/track",
            "K Widebody",
            "Er Bee",
            " Anniversary",
            "R/t/daytona",
            "Rt/rt Plus/road/track",
            "H Anniversary",
            "Su",
            "Aw",
            "Se/sxt/sxt Plus",
            "Lus",
            "Ona",
            " Pack Rwd",
            "Wd",
            "K Rwd",
            "K Widebody Rwd",
            "Scat Pack 392",
            "Daytona 392 Rwd/r/t Scat Pack Rwd",
            "392 Rwd",
            "E",
            "Rt Max/road/track",
            " Pack/daytona 392",
            "Fleet",
            "Cat Widebody",
            "Ona 340",
            "4d",
            "Wide Body Scat Pack",
            "4x",
            "Hellcat",
            "Rw",
            "Gt Gt",
            "R/ R/",
            "Po Po",
            "Se Se",
            "Sc Sc",
            "R/t/r/t Max/r/t Plus",
            "Enforcer Awd",
            "Er R/t Scat Pack",
            "Denali",
            "Se Se/sxt",
            "Scat Pack 392 Widebody",
            "6 Hellcat 16 Dodge Charger Parts",
            "Daytona R/t Awd",
            "Daytona Rwd/r/t",
            "Daytona Scat Pack",
            "He",
            "Daytona Scat Pack Awd",
            "Slt",
            "Lt",
            "Da",
            "Ls",
            "Er Sxt",
            "Srt Superbee"
          ]
        },
        {
          "model": "Dakota",
          "series": [
            "Slt/sport",
            "Sport/sxt",
            "Slt",
            "Laramie",
            "St",
            "Sport",
            "Quad Slt",
            "Quad Sport",
            "Sxt",
            "Quad Laramie",
            "Quad",
            "Rt",
            "Sxt/bighorn/lonestar",
            "Bighorn/lonestar",
            "Quad Sport/quad R/t",
            "Quad/st",
            "Quad Cab Slt",
            "Sport/rt",
            "Base",
            "T",
            "Trx",
            "Slt V8 Quad Cab",
            "St V8 Quad Cab",
            "Sxt V8 Crew Cab",
            "St Quad Cab",
            "V8 Quad Cab",
            "Sport V8 Quad Cab",
            "V8 Club Cab",
            "Sport/slt",
            "Slt V8 Crew Cab",
            "Club Cab",
            "R/t",
            "Sxt Crew Cab",
            "Sxt V8 Ext Cab",
            "Lar",
            "Qua",
            "/sxt",
            " Cc 150 Cus Cc",
            "4wd",
            "B Dak Club",
            "St St",
            "Se",
            "Base/sport/slt",
            "/lonestar",
            " Double Cab",
            "Spo",
            "St/laramie",
            "4x4",
            "Base/sport",
            "Dak Club",
            "Bas",
            "Sxt Sxt",
            "Sxt Ext Cab",
            "Slt Quad Cab",
            "Sport/base",
            "Slt V8 Club Cab",
            "Slt Slt",
            "Laramie/st",
            "Sport V8 Club Cab",
            "Sport Club Cab",
            "Slt Club Cab",
            "Quad Cab",
            "Laramie V8 Crew Cab",
            "St V8 Club Cab",
            "Shelby",
            "Slt/sport/base",
            "St Quad Cab 1 St",
            "Slt Crew Cab",
            "Slt V8 Ext Cab"
          ]
        },
        {
          "model": "Dart",
          "series": [
            "Rallye",
            "Aero",
            "Sxt",
            "Gt",
            "Se",
            "Limited",
            "Sxt/rallye",
            "Se/aero",
            "Limited/gt",
            "Sxt Sport",
            "Se Aero",
            "Limited/r/t",
            "Sxt Sport Blacktop",
            "Gt Sport",
            "Sxt Sport Rallye",
            "Turdo",
            "Gt Sport Blacktop",
            "D",
            "Swing",
            "Limit",
            "Gt Sp",
            "Se Ae",
            "Sxt S",
            "Port Rallye",
            "Sxt/d",
            "Lt",
            "Ed/r/t",
            "Ro",
            "Allye",
            "Ed/gt",
            "Ort",
            "E",
            "Ort Blacktop",
            "Ed",
            "Port Blacktop",
            "Turbo",
            "Port",
            "4d",
            "Se Se",
            "Sxt Sxt",
            "Sxt S Sxt S",
            "Limit Limit",
            "Gt Gt",
            "Gt/limited/gt",
            "Rallye/sxt",
            "Edan"
          ]
        },
        {
          "model": "Durango",
          "series": [
            "Limited",
            "R/t",
            "Sxt",
            "Gt",
            "Gt Rwd",
            "Sxt Plus Rwd",
            "Sxt Awd",
            "Gt Awd",
            "R/t Plus Awd",
            "Crew",
            "Srt Awd",
            "Gt Plus Rwd",
            "R/t Awd",
            "Citadel",
            "Srt",
            "Slt",
            "St",
            "Srt 392",
            "Slt Plus",
            "Express",
            "Pursuit Awd",
            "Ssv",
            "Sxt Rwd",
            "Sport",
            "Pursuit",
            "R/t Plus Rwd",
            "R/t Rwd",
            "Gt Plus Awd",
            "Sxt Plus Awd",
            "Sport/sxt",
            "Srt 392 Awd",
            "Special Service",
            "Special Service Rwd",
            "Srt Hellcat Awd",
            "Srt Hellcat",
            "Citadel Awd",
            "Ssv/enforcer/pursuit",
            "Li",
            "R/",
            "Srt 392 Premium Awd",
            "Hemi Orange Awd",
            "Adventurer",
            "Pursuit/enforcer",
            "Heat",
            "Sr",
            "Citadel Anodized Platinum",
            "Gt Launch Edition Awd",
            "Gt Launch Edition Rwd",
            "Sxt Launch Edition Awd",
            "Orange Sport Rwd",
            "Srt Hellcat Plus Awd",
            "Se",
            "Citadel Rwd",
            "R/t Premium Awd",
            "Gt Plus",
            "Sxt Launch Edition Rwd",
            "Special Service Awd",
            "Srt Hellcat Premium Awd",
            "Sx",
            "Police",
            "T",
            "Citadel Anodized Platinum Awd",
            "R/t Premium Rwd",
            "Crew Plus",
            "Orange Sport Awd",
            "Citadel Anodized Platinum Rwd",
            "R/t Plus",
            "Gt Premium Rwd",
            "H4 Suv",
            "Police Suv",
            "Suv",
            "Ssv Suv",
            "Sxt Awd/sxt Plus Awd",
            "Sxt Plus",
            "Lt",
            "Gt Awd/gt Plus Awd",
            "Gt Launch Edition  Awd",
            "Gt Premium Awd",
            "Ci",
            "Srt 392 Plus Awd",
            "Cr",
            "Ex",
            "Ss",
            "Sl",
            "Derango",
            "Lt Durngo Slt",
            "Gt Premium",
            "S",
            "Um",
            "Hy",
            "R/t Premium",
            "Citadel Platinum",
            "He",
            "Service",
            "Limited Hybrid",
            "Platinum",
            "Anodized Platinum",
            "Premium Luxury",
            "Po",
            "Ad",
            "Srt Hellcat Awd/srt Hellcat Plus Awd/srt Hellcat Premium Awd",
            "Durngo Slt",
            "4d Citadel",
            "Durang",
            "Cat",
            "Sxt Launch Edition",
            "Ium",
            "Rt",
            "Pu",
            "Orange Sport",
            "Gt Launch Edition",
            "Sp",
            "Srt Hellcat Premium",
            "4d",
            "4x",
            "Ex Ex",
            "Pu Pu",
            "Gt Gt",
            "Cr Cr",
            "Sx Sx",
            "Ci Ci",
            "Li Li",
            "Sxt Tradesman 4x4 6'4 Box",
            "2lt",
            "Citadel Sxt Rwd",
            "Srt 392 Alchemi Awd",
            "Srt 392 Premium",
            "R/t 20th Anniversary Plus Awd",
            "Sr Sr",
            "Ss Ss",
            "Hemi Orange Rwd",
            "R/t Awd/r/t Plus Awd/r/t Premium Awd",
            "Gt Awd/gt Launch Edition Awd/gt Plus Awd/gt Premium Awd",
            "Hemi Orange Awd/r/t Awd/r/t Plus Awd/r/t Premium Awd",
            "Gt Awd/gt Launch Edition  Awd/gt Plus Awd/gt Premium Aw",
            "Sxt Tradesman  4x4 6'4 Box",
            "Orange Sport Awd/r/t Awd/r/t Plus Awd",
            "R/t Awd R/t Awd",
            "Srt Hellcat Awd/srt Hellcat Plus Awd/srt Hellcat Premiu",
            "Laredo",
            "Le"
          ]
        },
        {
          "model": "H100",
          "series": []
        },
        {
          "model": "H100 Van",
          "series": []
        },
        {
          "model": "Hornet",
          "series": [
            "Gt Plus Awd",
            "R/t Eawd",
            "R/t Plus",
            "Gt",
            "Gt Awd",
            "Gt Plus",
            "R/t",
            "R/t Plus Eawd",
            "R/t Plus Phev",
            "Phev R/t"
          ]
        },
        {
          "model": "i10",
          "series": []
        },
        {
          "model": "Journey",
          "series": [
            "American Value Pkg",
            "Se",
            "Sxt",
            "Crossroad Awd",
            "Crossroad Plus Awd",
            "R/t",
            "Se Value",
            "Crossroad",
            "Gt",
            "Crossroad Plus",
            "Se Value Package",
            "Limited",
            "Crew",
            "Se Awd",
            "Sxt Crew",
            "Gt Awd",
            "Mainstreet",
            "Cvp/se Plus",
            "Sxt Awd",
            "Se/avp",
            "Sxt & Crew",
            "Cvp/se",
            "Sxt/limited",
            "Express",
            "Sxt/crew",
            "Cvp",
            "American Value Pkg/se",
            "R/t Rallye",
            "Lux",
            "Canada Value Package",
            "Canada Value",
            "Sxt   Crew",
            "Cr",
            "Sx",
            "Crossroad/crossroad Plus",
            "Suv",
            "R/",
            " Value Pkg",
            "D",
            "Ex",
            "Ma",
            "Li",
            "Canada Value Pkg",
            "Se Value Pkg",
            "Jny",
            "Se Se",
            "4d R/t",
            "Se Fwd Se",
            "D Plus",
            "Ye",
            "Lu",
            "Et",
            "Se Plus",
            " Pkg",
            "Alue Pkg",
            "R/ R/",
            "Erado C1500 Lt",
            "4d",
            "Can Value Pkg",
            "Ex Ex",
            "Cr Cr",
            "Gt Gt",
            "Ma Ma",
            "Sxt Suv",
            "Li Li",
            "T",
            "Crossroad Fw Crossroad"
          ]
        },
        {
          "model": "Neon",
          "series": [
            "Srt-4",
            "Highline",
            "Sxt",
            "Se",
            "Base",
            "Es",
            "R/t",
            "Highline/sport/le",
            "Se/es",
            "Sx 2.0",
            "Ex",
            "Competition/highline",
            "S",
            "Base Competition",
            "Highline/sport/r/t",
            "Sport",
            "4d",
            "Srt4",
            "Es/sxt",
            "Sx 2."
          ]
        },
        {
          "model": "Nitro",
          "series": [
            "Heat",
            "Slt/rt",
            "Sxt",
            "Detonator",
            "Se",
            "Shock",
            "Slt",
            "R/t",
            "Se/sxt",
            "Rt",
            "Shoc",
            "Deto",
            "4d Se",
            "Tor",
            "Lt-2",
            "Heat Heat",
            "Deto Deto",
            "Sxt Sxt",
            "Se Se"
          ]
        },
        {
          "model": "Ram 1500",
          "series": [
            "St",
            "Slt/laramie",
            "Slt/sport/trx",
            "Slt/trx4 Off Road/sport",
            "Laramie",
            "Slt",
            "Slt/laramie/st",
            "St/slt/laramie",
            "St/work Special",
            "St/slt",
            "Srt-10",
            "Xt",
            "St/sxt",
            "Longhorn",
            "Slt/sport",
            "Lt",
            "Sport",
            "Slt/trx",
            "Laramie Slt Quad Cab",
            "Laramie/sxt/slt",
            "R Sxt",
            "E",
            "Sxt/slt",
            "C Slt",
            "T",
            "St/ws",
            "Tradesman Crew Cab",
            "Limited Crew Cab",
            "St (discontinued)",
            "Lt/work Special",
            "Laramie Slt",
            "S",
            "Quad Cab",
            "Cat Pack",
            "Big Horn Crew Cab",
            "D150",
            "Man",
            "Outdoorsman Crew Cab",
            "Big Horn Quad Cab",
            "Rn/lone Star",
            "Xt Plus",
            "Rebel Crew Cab",
            "Sxt Quad Cab",
            " B150",
            "500",
            "500 1500 Standard",
            "Club Cab",
            "Tradesman Quad Cab",
            "L",
            "Laramie Slt/work Special",
            "/t",
            "Sxt Crew Cab",
            "Slt/st",
            "Avan Se",
            "150 4x4 Cc",
            "R R/t Scat Pack",
            "Slt/st/sxt",
            "Olice",
            "Laramie/slt/sport/trx/st",
            "Laramie Slt/st",
            "Laramie/slt/st",
            "M",
            "Trx",
            "Ram Pickup",
            "1500 Trade",
            "00",
            "150 Cus Cc",
            "Expre",
            "L L",
            "0 Ram Pu1500",
            "P Ram Pickup",
            "4 4",
            "Big H",
            "Slt/trx/st",
            "R",
            "Ram 150",
            "Activ",
            "St/slt/sport/trx/laramie",
            "Slt/sport/trx/laramie/st",
            "1500 Slt",
            "Slt/sport/trx/laramie",
            "C",
            " 1500 Rebel",
            " 1500",
            "/trx/laramie",
            "R/t",
            "Rm 1500 Cc",
            "Pickup",
            "Ram Truck",
            "4x2 Rg Slt",
            "Limited",
            "Slt/trx4 Off Road",
            "Ram15004x4",
            "150 Ram",
            "1500 Ram V",
            " 1500 Quad",
            "Dr1500",
            "1500 Big H",
            "Ram1500 Pu",
            "Ram Pu15",
            "R1500",
            "0",
            "150 Cus 4x",
            "Ort/trx/laramie",
            "Limited/se",
            "V",
            "Ram 15",
            "Ram Pu1500",
            "Outdo",
            "Big Horn",
            "150 Club",
            "Q",
            "P",
            "X",
            "4x4 Cnvtlcab",
            "1500",
            "Ram 100",
            "H",
            "4wd",
            "Laramie Sl",
            "Rn",
            "1500 Quad",
            "S S",
            "Ram 1500",
            "Outdoorsman Quad Cab",
            "4x",
            "U",
            "Trx Crew Cab",
            "C Tradesman",
            "Laramie Longhorn",
            "Slt/sport/trx/st",
            "St/work Special/ws",
            "2.4 Ex",
            "Avan Sxt",
            "Tradesman 4x2 8' Box",
            "Laramie Laramie",
            "R Srt 392",
            "D100",
            "Pickup Truck",
            "Trx Quad Cab",
            "T Regular Slt/trx4 Off Road/sport",
            "Pickup 150",
            "Classic St Crew Cab",
            "Tradesman  4x2 8' Box",
            "Value",
            "Quad Cab (amalgamate)",
            "4wd 1500",
            "Cn",
            "Rew",
            "1500 Rebel",
            "Laramie Longhorn Edition",
            "P Ram",
            "Ram Pick U",
            "Laramie Longhorn/limited Edition",
            "R R/t",
            "Ram Vans"
          ]
        },
        {
          "model": "Ram 2500",
          "series": [
            "Slt/power Wagon",
            "Slt",
            "St",
            "Slt/laramie",
            "Laramie",
            "Slt/trx4 Off Road/sport/power Wagon",
            "St/slt/laramie",
            "Slt/laramie/st",
            "Longhorn",
            "St/slt",
            "500 2500 High",
            "Slt/sport",
            "St/sxt",
            "Rn",
            "Quad Cab",
            "Slt/trx",
            "Sxt/slt",
            "W200",
            "Lt",
            "Laramie Crew Cab",
            "Laramie/slt",
            "S",
            "Slt Quad Cab",
            "Laramie Quad Cab",
            "Slt Mega Cab",
            "Power Wagon Crew Cab",
            "Quad Cab (amalgamate)",
            "Laramie Mega Cab",
            "Powerwagon",
            "2500",
            "Sport Quad Cab",
            "Laramie/slt/st",
            "Limited Crew Cab",
            "Laramie Slt/st",
            "Slt Crew Cab",
            "Man",
            "Crew Cab (amalgamate)",
            "Q",
            "L",
            "B2500 Ram",
            "2500 Turbo",
            "00br",
            "Rm2500",
            "D",
            "Dr2500 2wd",
            "Laram",
            "Dr2500 4wd",
            "Sxt",
            "Power Wagon",
            "St/slt/laramie/trx",
            "Ram2500",
            "St/sxt/slt",
            "Trx",
            "Sxt/slt/laramie",
            "P",
            "Bed",
            "Cc",
            "C",
            "2500 Ram",
            "2500 Cumin",
            "Ram",
            "2500 Quad",
            "2500 Picku",
            "M",
            "Dr2500",
            "2500 Van",
            "Br2500 4x2",
            "V 2500 Ram V",
            "2500 Ram V",
            "Ram2500 4x",
            "Value",
            "L L",
            "Ram 2500",
            "Laramie Longhorn",
            "Q Q",
            "Chassis Lt",
            "E",
            "Laramie/slt/sport/st",
            "Laramie Longhorn/limited Edition",
            "Hemi 2500 Hemi",
            "Sxt Quad Cab",
            "Club Cab",
            "Trx Crew Cab",
            "Crew Cab Pikcup Truck",
            "R",
            "Laramie/slt/slt/power Wagon/st/sxt",
            "2500 Hemi",
            "Slt/slt/laramie/st"
          ]
        },
        {
          "model": "Ram 3500",
          "series": [
            "Slt/sport",
            "Laramie",
            "Slt",
            "St",
            "Slt/laramie/st",
            "St/sxt",
            "Sxt/slt",
            "Longhorn",
            "Hd Chassis St/slt/laramie",
            "Slt/laramie",
            "St/slt",
            "Slt/trx4 Off Road/sport",
            "Laramie Mega Cab",
            "St/slt/laramie",
            "Chassis Lt",
            "Hd Chassis St/slt",
            "Value",
            "Slt Quad Cab",
            "E",
            "L",
            "Laramie/slt",
            "C",
            "Quad Cab",
            "S",
            "Sxt",
            "Ted Longhorn  4x4 6'4\" Box",
            "Q",
            "2wd",
            "Laramie Slt/st",
            " 3500",
            "Hd",
            "Tradesman",
            "Big Horn",
            "S S",
            "Ram Vans",
            "Sxt/slt/laramie",
            "Ramie",
            "P",
            "Laram",
            "I Rm3500 Cci",
            "L L",
            "Laramie Longhorn/limited Edition",
            "Ram 3500",
            "0 Slt/laramie",
            "0 Sxt/slt",
            "0",
            "3500 Slt",
            "Pickup Truck",
            "Ramie Longhorn/limited Edition",
            "0 Slt/sport",
            "0 Slt",
            "0 St",
            "Cr",
            "0 St/slt",
            "Man",
            "Big Horn 4x4 6'4 Box",
            "Tradesman/slt/laramie",
            "350 Ram"
          ]
        },
        {
          "model": "Ram 4000",
          "series": []
        },
        {
          "model": "Ram 4500",
          "series": [
            "St",
            "Hd Chassis St/slt",
            "Hd Chassis St/slt/laramie",
            "S",
            "Crew Cab Utility / Service Truck",
            "Ramie",
            "St/slt/laramie",
            "Slt",
            "St/slt",
            "Flatbed Truck"
          ]
        },
        {
          "model": "Ram 5500",
          "series": [
            "St",
            "St/slt/laramie",
            "Hd Chassis St/slt",
            "Hd Chassis St/slt/laramie",
            "St/slt",
            "Hd Dump Truck",
            "Utility / Service Truck",
            "S",
            "Slt",
            "Hd Chassis",
            "500 St",
            "Crew Cab Flatbed Truck",
            "Service Truck",
            "Rollback Truck",
            "(amalgamated)"
          ]
        },
        {
          "model": "Viper",
          "series": [
            "Srt",
            "Srt-10",
            "Rt/10",
            "Gts",
            "Srt10",
            "Rt-10",
            "Acr *ltd Avail*",
            "Srt-",
            "Gtc",
            "Rt-1",
            "Srt10 Acr"
          ]
        },
        {
          "model": "Vision",
          "series": []
        }
      ]
    },
    {
      "make": "Ferrari",
      "models": [
        {
          "model": "296 GTB",
          "series": []
        },
        {
          "model": "458 Italia",
          "series": [
            "Spider",
            "Speciale"
          ]
        },
        {
          "model": "458 Speciale",
          "series": []
        },
        {
          "model": "458 Spider",
          "series": []
        },
        {
          "model": "488 GTB",
          "series": []
        },
        {
          "model": "488 Pista",
          "series": []
        },
        {
          "model": "488 Pista Spider",
          "series": []
        },
        {
          "model": "488 Spider",
          "series": [
            "488 Spider"
          ]
        },
        {
          "model": "599 GTB",
          "series": [
            "Fiorano",
            "Fi"
          ]
        },
        {
          "model": "599 GTO",
          "series": []
        },
        {
          "model": "612 Scaglietti",
          "series": []
        },
        {
          "model": "812 GTS",
          "series": []
        },
        {
          "model": "812 Superfast",
          "series": []
        },
        {
          "model": "California",
          "series": [
            "T",
            "California"
          ]
        },
        {
          "model": "California T",
          "series": [
            "T"
          ]
        },
        {
          "model": "F12 Berlinetta",
          "series": [
            "Berlin"
          ]
        },
        {
          "model": "F12tdf",
          "series": []
        },
        {
          "model": "F8 Spider",
          "series": []
        },
        {
          "model": "F8 Tributo",
          "series": []
        },
        {
          "model": "FF",
          "series": []
        },
        {
          "model": "GTC4Lusso",
          "series": [
            "V12",
            "T"
          ]
        },
        {
          "model": "GTC4Lusso T",
          "series": []
        },
        {
          "model": "LaFerrari",
          "series": []
        },
        {
          "model": "Portofino",
          "series": []
        },
        {
          "model": "Portofino M",
          "series": []
        },
        {
          "model": "Roma",
          "series": [
            "2 Rims Only"
          ]
        },
        {
          "model": "SF90 Spider",
          "series": []
        },
        {
          "model": "SF90 Stradale",
          "series": []
        }
      ]
    },
    {
      "make": "Fiat",
      "models": [
        {
          "model": "500",
          "series": [
            "Sport",
            " Trekking",
            "Pop",
            "Turbo",
            "Abarth",
            " Pop",
            "Electric",
            " Easy",
            " Sport",
            "Lounge",
            " Lounge",
            "Easy",
            " Trekking Plus",
            "Gucci",
            "1957 Edition",
            "Turbo Cattiva",
            "Sport Cattiva",
            "C Lounge",
            "Ribelle",
            "Retro",
            "Electr",
            "L Loung",
            "Ge",
            "Ung",
            "Ekk",
            "T",
            "Th",
            "L Trekk",
            "L Pop",
            "L Easy",
            "P",
            "I",
            " Edition",
            "Ge/1957 Edition",
            "Tric",
            "Ort",
            "L",
            "X Sport",
            "2d Abarth",
            "X",
            "Tr",
            "Lle",
            "Sy",
            "X Trekk",
            "T Cattiva",
            "O",
            "O Cattiva",
            "C",
            "X Pop",
            "X Easy",
            "Sport/sport Cattiva",
            "X Loung",
            "2d",
            "Battery Electric",
            "Electr Electr",
            "Sport Sport",
            "E La Prima",
            " Trekk",
            "Sport Turbo",
            "E Red",
            "Inspi(red) Fwd"
          ]
        },
        {
          "model": "124 Spider",
          "series": [
            "Classica",
            "Lusso",
            "Lusso Red Top Edition",
            "Elaborazione Abarth",
            "Abarth",
            "Classica/lusso/abarth",
            "Urbana Edition",
            "Op Edition",
            "E Abarth",
            "Ion",
            "Sso/abarth",
            "124 Spider",
            "Urbana"
          ]
        },
        {
          "model": "500L",
          "series": [
            "Trekking",
            "Pop",
            "Lounge",
            "Easy",
            "Urbana Trekking",
            "Urbana",
            "Sport",
            "E",
            "Ing",
            "Trekk",
            "Trekking/urbana Trekking",
            " Trekk",
            "Ounge",
            "A Trekking",
            " Loung",
            " Pop",
            "Trekk L Trekk",
            "Loung",
            "Easy L Easy",
            "Loung L Loung"
          ]
        },
        {
          "model": "500X",
          "series": [
            "Trekking Plus",
            "Easy",
            "Trekking Awd",
            "Pop Awd",
            "Urbana Awd",
            "Pop Fwd",
            "Lounge Fwd",
            "Trekking Fwd",
            "Trekking",
            "Lounge",
            "Pop",
            "Urbana Fwd",
            "Lounge Awd",
            "Sport Awd",
            "Sport",
            "Trekking Plus Awd",
            "Ing",
            "120th Anniversary Edition",
            "Yacht Club Capri Awd",
            "Trekk",
            "Loung",
            "Ing Plus",
            "A Edition",
            "E",
            "Blue Sky Edition",
            " Easy",
            "Ing Fwd",
            "Lue Sky Edition",
            "Wd",
            " Trekk",
            "Urbana Edition",
            "Trekking Plus A Trekking Plus",
            "E Awd",
            "Pop X Pop",
            "Loung X Loung",
            "Blue Sky Edition Awd",
            " Loung",
            "Trekk X Trekk",
            " Pop",
            "Easy X Easy",
            "120th Anniversary Edition Awd"
          ]
        },
        {
          "model": "Albea",
          "series": []
        },
        {
          "model": "Argo",
          "series": []
        },
        {
          "model": "Ducato",
          "series": []
        },
        {
          "model": "Linea",
          "series": []
        },
        {
          "model": "Mobi",
          "series": []
        },
        {
          "model": "Palio",
          "series": []
        },
        {
          "model": "Panda",
          "series": []
        },
        {
          "model": "Punto",
          "series": [
            "Evo"
          ]
        },
        {
          "model": "Strada",
          "series": []
        },
        {
          "model": "Uno",
          "series": []
        },
        {
          "model": "JOLLY",
          "series": []
        },
        {
          "model": "500C",
          "series": [
            "Pop",
            "Lounge",
            "Abarth",
            "Gucci",
            "Gq Edition",
            "Port",
            "Ition",
            "Op",
            "E/1957 Edition",
            "H",
            "E",
            "Ounge",
            "Edition",
            "Retro",
            "1957 Edition"
          ]
        },
        {
          "model": "500E",
          "series": [
            "Battery Electric",
            "Electric",
            "Ric",
            "Ry Electric",
            "Red",
            "Inspi(red) Fwd",
            "La P"
          ]
        }
      ]
    },
    {
      "make": "Fisker",
      "models": [
        {
          "model": "Karma",
          "series": [
            "Ecosport",
            "Ecochic",
            "Tive Karma Sport"
          ]
        },
        {
          "model": "OCEAN",
          "series": [
            "One",
            "Extreme",
            "Ocean One",
            "Ultra",
            "Cean Ocean One",
            "Sport"
          ]
        }
      ]
    },
    {
      "make": "Ford",
      "models": [
        {
          "model": "Bronco",
          "series": [
            "Base",
            "Sport Big Bend",
            "Sport Outer Banks",
            "Badlands",
            "Outer Banks",
            "Big Bend/black Diamond/outer Banks",
            "Big Bend",
            "Sport Badlands",
            "Black Diamond",
            "Wildtrak",
            "U100",
            "Sport",
            "Big Bend/black Diamond/outer Banks/badlands/wildtrak/everglades",
            "Sport Heritage Limited",
            "Sport Heritage",
            "Raptor",
            "Heritage Limited Edition",
            "Ii",
            "Big Bend/black Diamond/ou",
            "Sport First Edition",
            "Heritage",
            "U10",
            "First Edition",
            "Big Bend/black Diamond/outer Banks/badlands/wildtrak",
            "Heritage Limited",
            "Everglades",
            "Spo",
            "Base/big Bend/black Diamond/outer Banks/badlands/everglades",
            "4x4",
            "Bas",
            "Suv",
            "Base/big Bend/black Diamond/outer Banks/badlands/wildtrak",
            "Heritage Edition",
            "D",
            "Base/big Bend",
            "Rap",
            "S",
            "Dition",
            "Anks",
            "Fir",
            "K",
            "G Bend",
            "D/black Diamond/ou",
            "Big Bend/black Diamond/outer Banks/badlands/wildtrak/ev",
            "Bla",
            "Badlands/big Bend/black Diamond/outer Banks/wildtrak",
            "Sport Free Wheeling",
            "Bas Bas",
            "Her",
            "Out",
            "Bad",
            "Big",
            "Eve",
            "Wil",
            "4x4 5.0v8 Coyote Motor",
            "R",
            "Badlands/big Bend/black Diamond/outer Banks"
          ]
        },
        {
          "model": "Bronco Sport",
          "series": [
            "Outer Banks",
            "Big Bend",
            "First Edition",
            "Badlands",
            "Big Bend Big Bend",
            "Heritage",
            "Big Ben Big Bend",
            "Heritage Limited",
            "Base",
            "Outer B Outer Banks",
            "Free Wheeling",
            "4wd"
          ]
        },
        {
          "model": "C-Max",
          "series": [
            "Hybrid Se",
            "Hybrid Sel",
            "Premium Sel",
            "Se",
            "Premium",
            "Energi Sel",
            "Sel",
            "Hybrid Titanium",
            "Titanium",
            "Energi Titanium",
            "Energi Se",
            "Energi Premium",
            "Sel Hybrid",
            "Energi",
            "Hybrid",
            "Energi Premium Sel",
            "-max Prem",
            "-max Sel",
            "-max Se",
            "M",
            "M Sel",
            "Um",
            "-max Tita",
            "Tita C-max Tita",
            "Prem",
            "Prem C-max Prem",
            "-Max",
            "Tita"
          ]
        },
        {
          "model": "Courier",
          "series": []
        },
        {
          "model": "Crown Victoria",
          "series": [
            "Lx",
            "Police/police Interceptor",
            "Police Interceptor",
            "Police Pkg Police Interceptor",
            "Police",
            "Standard",
            "Lx/lx Sport",
            "Natural Gas Vehicle/police/police Street Appearance",
            "Lx Sport/lx",
            "Police Pkg",
            "Police/street Appear W/3.27 Axle",
            "Lx/sport",
            "Country Squire",
            "Country Squire Lx",
            "S",
            "Commercial Regular Wheelbase",
            "Police Interceptor Police Interceptor Sedan",
            "Commercial Long Wheelbase",
            "Commercial Base",
            "Commercial",
            "Nterceptor",
            "Tor",
            "Commercial Standard",
            "Police (inspec)",
            "Commercial Applications",
            "Police/police Interceptor/pursuit",
            "Police Interceptor/police Street Appearance"
          ]
        },
        {
          "model": "E-150",
          "series": [
            "Commercial",
            "E150 Wagon",
            "Xl/xlt",
            "Commercial/recreational",
            "Recreational",
            "Chateau/xl/xlt",
            "Vans",
            "Vans Econoline",
            "Chateau/xlt/xl",
            "Recreational/commercial",
            "Econoline Xl",
            "Xlt",
            "Line E150 Van",
            "Standard",
            "Xl",
            "E150 Van",
            "Line E250 Van",
            "Econoline Cargo Van",
            "Supercrew",
            "Van",
            "Handicap Accessible Van",
            "Line E150 Wagon",
            "Cial",
            " St",
            "Argo Commercial/recreational",
            "-150",
            "Ine E150 Wagon",
            "Ine E150 Van",
            "Upercrew",
            "50 Cbwgin",
            "-150 Van",
            "Wgin",
            "Cono",
            "E-150",
            "Cono 150",
            "150 Cbwgin",
            "Super Cab",
            "Econo",
            "Line E350 Super Duty Van",
            "E-150 Van",
            "A Se",
            "Line E250 Super Duty Van",
            "Ition Eddie Bauer",
            "Commercial/rv"
          ]
        },
        {
          "model": "E-250",
          "series": [
            "Recreational/commercial",
            "Commercial",
            "Commercial/recreational",
            "E250 Van",
            "Standard",
            "Stripped Commercial",
            "Recreational",
            "Line E250 Van",
            "Spr I",
            "Ine E250 Van",
            "Econoline Cargo",
            "Econoline Cargo Van Ext",
            "-250",
            "Cono",
            "Cial",
            "Uper",
            "C Van 250",
            "Cono 250",
            "Argo",
            "E-250",
            "It T-250",
            "Sd",
            "Ec Van 250",
            "Cargo Commercial",
            "Super Duty"
          ]
        },
        {
          "model": "E-350 Super Duty",
          "series": [
            "Xlt/xl",
            "Xlt",
            "Commercial",
            "Chateau/xl/xlt",
            "Xl/xlt",
            "E350 Super Duty Wagon",
            "Xl",
            "Commercial/recreational",
            "Recreational/commercial",
            "Recreational",
            "Chateau/xlt/xl",
            "E350 Super Duty Van",
            "Shuttle Bus",
            "Chateau",
            "Box Truck",
            "0 Super Duty Ctway Van",
            "Tional",
            "Per Duty Wagon",
            "Tway Van",
            "Refrigerated Truck",
            "Van With Bucket Lift"
          ]
        },
        {
          "model": "E-450 Super Duty",
          "series": [
            "Shuttle Bus",
            "Ambulance",
            "Y Shuttle Bus",
            "0 Super Duty Cutwy Van",
            "0 Super Duty Cutaway Van",
            "Duty Cutwy Van",
            "Refrigerated Truck",
            "Delivery Van",
            "Box Truck"
          ]
        },
        {
          "model": "E-Transit",
          "series": [
            "Cargo Van",
            "Cargo Van Xl"
          ]
        },
        {
          "model": "Econoline Van",
          "series": [
            "E250 Van",
            "E350 Super Duty Van",
            "E150 Van",
            "E350 Super Duty Wagon",
            "E450 Super Duty Cutwy Rv",
            "Recreational/commercial",
            "E350 Cutaway Van",
            "E450 Super Duty Cutaway Van",
            "Econoline E350 Super Duty",
            "Econoline E250",
            "Commercial/recreational",
            "E350 Super Duty Cutaway Van",
            "E450 Super Duty Cutaway Van Rv",
            "E350 Super Duty Stripped Chassis",
            "E450 Super Duty Commercial Stripped Chassis",
            "E350 Commercial Stripped Chassis",
            "E250 Super Duty Van",
            "Cutaway Standard",
            "E350 Super Duty Strp Chas",
            "E350 Motor Home Chassis",
            "E150",
            "E350 Super Duty",
            "E350 Super Duty Ctway Van",
            "E450 Super Duty Cutwy Van",
            "E150 Wagon",
            "E350",
            "E350 Super Duty Ctwy V Rv",
            "Stripped Chas Standard",
            "Rv Cutaway Standard",
            "Commercial",
            "E350 Super Dty Commctwy V",
            "E350 Super Duty Cutaway V",
            "Cutaway",
            "Cutaway E350 Super Duty Ctway Van",
            "S350 Super Duty Van",
            "E450 Super Duty Cmm Ctway",
            "E450 Super D Cmm Strp Chs",
            "Standard",
            "S250 Super Duty Van",
            "Xl/xlt",
            "Recreational",
            "E450 Starcraft Bus",
            "E550 Super Duty Chassis",
            "Cargo Commercial/recreational",
            "E150 Super Duty Van",
            "E450 Super Duty Cutaway V",
            "E450 Super Duty Commercial Cut",
            "E350 Van",
            "E450 Super Duty Commercial Str",
            "350",
            "D Home",
            "Rv/rv Hd/super Rv Hd",
            "E350 Super Duty Cutaway Van Rv",
            "E250",
            "Stripped Chas E150 Van",
            "Cargo",
            " E150 Van",
            " E350 Super Duty Cutaway Van",
            "             Econoline",
            "E350 Super Duty Stripped Chass",
            "E350 Super Duty Commercial Cutaway Van",
            "E450 Super Duty Cutwy  Rv",
            " Recreational/commercial",
            "Super Duty Van",
            "E450 Gulstream Motorhome",
            "Chassis",
            "Ercial",
            "O Van E250 Van",
            "Light",
            " Super Duty Wagon",
            "O Van",
            "O Van Commercial",
            "E250 Super Duty",
            "O Van Recreational/commercial",
            "O Van E350 Super Duty Van",
            "O Van E150 Van",
            "E450 Super Duty Commercia",
            "O Van Commercial/recreational",
            "350 Ambulance",
            "O Van Recreational",
            "E450 E450 Super Duty Cutwy Van",
            "E350 Majestic Motorhome",
            "E550 Super Duty Cutaway Van",
            "Comm. Cutaway Standard",
            "E150 Van 1/2 Ton",
            "Ercial/recreational",
            "Ercial Standard",
            " Super Duty Ctway Van",
            "S",
            "E Winnie",
            "E350 Motorhome",
            "O Van Super Recreational",
            "O Van Super",
            "Eational/commercial",
            " Super Duty",
            "O",
            "Estic 23 A)",
            " Duty",
            "E450 Super Duty Commercial Cutaway Van",
            "O Van Super Duty Recreational",
            " Van",
            " Wagon",
            " Super Duty Cutwy Van",
            "O Van Super Duty Commercial",
            " Super Duty Cutaway",
            "Ercial E350 Super Duty Ctway Van",
            " Super Duty Strp Chas",
            "Motor Home",
            " Super D Cmm Strp Chs",
            "Y Cutwy Van",
            "Lt",
            "Ries C",
            "Xl",
            "Eau/xl/xlt",
            "O Van Super Duty",
            " Super Duty Cutaway V",
            "Y Cutaway V",
            "Xlt",
            "Reational/commercial",
            " Super Duty Van",
            "Reational",
            "Mercial",
            "Eational",
            " Super Duty Commercia",
            "Mm Strp Chs",
            "Y Van",
            "Ommercial",
            "Y Wagon",
            " Super Duty Cutaway Van",
            "Y Ctway Van",
            "O Van Econoline",
            "No",
            "Nnect Xl",
            "O Commercial/recreational",
            "Ercial Cutaway E350 Super Duty Ctway Van",
            "Olin",
            "Ercial Cutaway",
            " Super Duty Cmm Ctway",
            "Line",
            "Ne E350 Cutaway Van",
            "Jayco Motor Home E350 Cutaway Van",
            " E450 Super Duty Cutwy Van",
            " Super Duty Commercial Stripped Chassis",
            " Super Duty Stripped Chassis",
            "E250 Super Duty Strip Chs",
            "Econoline",
            "Ster",
            "Commrcl Chassis",
            "Van",
            "E250 Heavy Duty Van",
            "E100 Van",
            "Way V",
            "R Othr",
            "Cargo E-15 E150 Van",
            "E250 Cutaway Van",
            "Econline",
            "350 Super Duty",
            "S150 Super Duty Van",
            "E550 Super Duty Ctwy Van",
            "Xl/xl Plus/xlt",
            "Chateau/xl/xlt",
            "Ne E350 Motor Home Chassis",
            "Ne E450 Super Duty Cutwy Rv",
            " Imperial S",
            "250",
            "Utaway",
            "15 Passenger",
            "Cargo E-25 Commercial/recreational",
            "E350 Commercial Stripped Chass",
            "Ambulance",
            "350 Box Truck",
            "Econolin",
            "350 Delivery Van",
            "E350 Comm Strippedchassis",
            "E-ser Othr",
            "Heavy Motorhome",
            "Econo",
            "Oncorde",
            "Coachman",
            "Cargo E-25 Commercial",
            "450 E450 Super Duty Cutwy",
            "E-series C",
            "E250 Super Duty Commercial Cutaway Van",
            "E350 Xlt"
          ]
        },
        {
          "model": "Econoline Wagon",
          "series": [
            "Xl/xlt",
            "Xlt/xl",
            "Econoline E350 Super Duty",
            "Xl/xlt/chateau",
            "E350 Super Duty Wagon",
            "E150 Wagon",
            "Chateau",
            "Xlt",
            "Xl",
            "Xl E Xl",
            "Chateau/xl/xlt"
          ]
        },
        {
          "model": "EcoSport",
          "series": [
            "S",
            "Titanium",
            "Se",
            "Ses",
            " E350 Super Duty Cutaway Van",
            "L",
            "Titanium Awd",
            "T",
            "4",
            "Se Fwd Se",
            "4d S",
            "Eco",
            "Se 4wd Se",
            " E250 Van",
            "X",
            "A",
            "T T",
            " E150 Wagon",
            "Trend"
          ]
        },
        {
          "model": "Edge",
          "series": [
            "Se",
            "Sport",
            "Limited",
            "Titanium",
            "Sel",
            "St",
            "Sel Plus",
            "St Line",
            "St-Line",
            "Sel/st-Line",
            "Sel/st Line",
            "Equinox Lt",
            "Sel Ecoboost",
            "Limit",
            "Ltd",
            "Sel Suv",
            "Titan",
            "Sel Awd Sel",
            "T-Line",
            "Sel P",
            "Ed",
            "Se Aw Se Aw",
            "Cobalt Lt",
            "Titanium Awd",
            "Ium",
            "2.5/2.5s",
            "T Line",
            "4d Ltd",
            "Ttm",
            "Se Aw",
            "Sel A",
            "Fwd Suv Titanium",
            "Se Fwd Se",
            "Limited Fwd Limited",
            "4d 2w",
            "4d 4w",
            "Sport Sport",
            "E Limited",
            "St Aw",
            "Titanium Fwd Titanium",
            "Se Se",
            "St St",
            "E S F",
            "Limit Limit",
            "4d Se",
            "Limited Awd Limited",
            "Sel..",
            "Limited Suv",
            "Unlimited",
            "Sel/s",
            "E Se"
          ]
        },
        {
          "model": "Escape",
          "series": [
            "Sel",
            "Xls",
            "Se",
            "S",
            "Titanium",
            "Limited",
            "Xlt",
            "Hybrid Limited",
            "Active",
            "Xlt/xlt Sport",
            "Hev",
            "St-Line",
            "Hybrid",
            "Xlt Sport/xlt",
            "Xls/xls Manual",
            "Xlt Choice/xlt Midnight/xlt Premium/xlt Sport",
            "Phev",
            "Se Sport",
            "Xlt Automatic",
            "Se Sport Hybrid",
            "Titanium Hybrid",
            "St-line Elite",
            "St Line",
            "Hybrid Hybrid",
            "Platinum",
            "Se Hybrid",
            "Hybrid Hev",
            "St Line Plus",
            "St Line Premium",
            "Limited V6",
            "Sel Plug-in Hybrid",
            "Titanium Plug-in Hybrid",
            "Sel Hybrid",
            "Xls Popular",
            "Xls Choice",
            "St-line Select",
            "Xlt Choice/xlt Choice 2/xlt Midnight/xlt Premium",
            "Phev Se",
            "Xlt V6",
            "Se Plug-in Hybrid",
            "Xlt Manual",
            "St Line Select",
            "Tit",
            "St Line Elite",
            "Sel 2.0t",
            "4d",
            "St Line Select 2.0t",
            "St Line Elite Hybrid",
            "Lim",
            "Hyb",
            "Xls V6",
            "Xlt Suv",
            "Limited Suv",
            "Platinum 2.0t",
            "4x2",
            "Pla",
            "Le/xle/se/xse",
            "St",
            "Hybrid Suv",
            "Suv",
            "Phev Sel",
            "Se Awd Se",
            "Xlt 4wd Xlt/xlt Sport",
            "St Line Hybrid",
            "M Plug-in Hybrid",
            "4d Xlt",
            "Xlt Premium",
            "Xlt Sport",
            "4d S",
            "Trend S",
            "Se 4wd Se",
            "Exl",
            "4d Se",
            "S Fwd S",
            "Xlt Choice",
            "Ltd",
            "Titanium 2.0t",
            "Hyb Hyb",
            "4d Ltd",
            "Xlt Popular 2",
            "S F",
            "Xls Value",
            "Act",
            "Laredo",
            "Hybrid/hybrid Limited",
            "Xls/xls Value",
            "4d Xls",
            "M",
            "Xls Sport",
            "Rid",
            "Premium",
            " Select",
            "Xlt Popular",
            "M Hybrid",
            "-in Hybrid",
            "Id",
            "T",
            "T Hybrid",
            "Xls Sport/xls Value",
            "All Wheel Drive",
            "Hyb 4d Se",
            " Manual",
            "Sel 4wd Sel",
            "Awd 3c Se",
            "Limited Fwd Limited",
            "Titanium 4wd Titanium",
            "Sel Fwd Sel",
            "Xls 4wd Xls",
            "Sel Sel",
            "Lim Lim",
            "S A",
            "Xls Xls",
            "4d 4d",
            "Limited Hybrid",
            "Le Sel",
            "Ls",
            " Cold Planer",
            "4 D",
            "Titanium Fwd Titanium",
            "Plug-in Hybri Titanium Plug-in Hybrid",
            "Xlt Automatic/xlt Manual",
            "Mited",
            "Titanium Hybrid Titanium Hybrid",
            "Base",
            "L",
            "Platinum Hybrid",
            "Xls Suv",
            "Leather Group"
          ]
        },
        {
          "model": "Expedition",
          "series": [
            "El Limited",
            "Eddie Bauer",
            "Eddie Bauer/xlt",
            "Xlt",
            "Max Xlt",
            "Limited",
            "El Xlt",
            "El Eddie Bauer",
            "El King Ranch",
            "Xl",
            "Xlt Max",
            "Nbx/xlt",
            "El El Xlt",
            "Max Limited",
            "El Platinum",
            "Max Platinum",
            "King Ranch",
            "Platinum Max",
            "Platinum",
            "Eddie Bauer/king Ranch",
            "Limited Max",
            "Timberline",
            "El Xlt/el King Ranch",
            "Xls",
            "Xlt/king Ranch",
            "El El Limited",
            "El Xl",
            "Xlt/xlt Sport",
            "Max Xl",
            "Max Max Xlt",
            "El Eddie Bauer/king Ranch",
            "Xl Max",
            "King Ranch Max",
            "Max King Ranch",
            "Special Service/xlt/xlt Sport",
            "El El Xlt/el King Ranch",
            "Max Max Limited",
            "Xlt Sport/xlt",
            "El",
            "Die Bauer",
            "El El Platinum",
            "Imited",
            "Max Max Platinum",
            "El King Ranch/xlt",
            "Rew",
            "Max Xlt Limo",
            "Xlt/eddie Bauer",
            "Ssv/xlt",
            "Max Ssv",
            "Max Eddie Bauer",
            "Xlt/xlt Premium",
            "Max Limit Limited Max",
            "Xlt Suv",
            "El Ssv/xlt",
            "Suv",
            "El Suv",
            "Special Service/xlt",
            "Max",
            "T",
            "King Ranch/xlt",
            "King Ranch Suv",
            "Ort Trac",
            "El El Eddie Bauer",
            "Xlt Premium",
            "Xlt Value",
            "Exp Xlt",
            "Exped Xlt",
            "Special Service",
            "Xlt Xlt",
            "Xlt Nbx",
            "Xlt Fx4 Off-road",
            "Expdtion",
            "Ssv",
            "Xlt Popular/xlt Premium",
            "El Xlt/king Ranch",
            "4d Eb/kr",
            "Exp",
            "Xlt Popular",
            "El El Xl",
            "/king Ranch",
            "Uer",
            "M",
            "Nch",
            "Ing Ranch",
            "El Li",
            "Le/xle/se/xse",
            "Xlt/xlt Nbx",
            "Special Service/xlt/xlt Nbx/xlt Sport",
            "Limited 4 Limited",
            "Pdtion",
            "Eddie Bau Eddie Bauer/king Ranch",
            "Mited",
            "Tive",
            "Xlt 4wd Xlt",
            "Eddie Bau Eddie Bauer",
            "El Xlt Limo",
            "Active",
            "Active Max",
            "Max Active"
          ]
        },
        {
          "model": "Explorer",
          "series": [
            "Xlt",
            "Limited",
            "Eddie Bauer",
            "Sport Trac",
            "Platinum",
            "Sport",
            "Xls",
            "St",
            "Timberline",
            "Sport Trac Xlt",
            "Xlt/xlt Sport",
            "Xlt/xlt Sport/nbx",
            "Nbx/xlt",
            "Eddie Bauer/xl/xlt/limited",
            "Xls/xls Sport",
            "Police Interceptor",
            "Base",
            "X",
            "St-Line",
            "Eddie Bauer/limited/xlt",
            "Eddie Bauer/limited/xl/xlt",
            "Xlt Sport/xlt",
            "Eddie Bauer/limited Edition/xlt",
            "King Ranch",
            "St St",
            "Sport Trac Limited",
            "Eddie Bauer/xlt/limited",
            "Xl/xlt",
            "Supercrew",
            "Sport/xl",
            "Sport Xls/xlt",
            "Sport Choice/premium/value",
            "Xlt/eddie Bauer/limited",
            "N El Limited",
            "Limited Edition/eddie Bauer/xlt",
            "Xl Fleet",
            "Sport Ecoboost",
            "Xlt/xlt Spt/nbx",
            "4",
            "T",
            "Xlt Police",
            "P",
            "Sport Sport",
            "E",
            "N Eddie Bauer",
            "Sport Tr",
            "Police Interceptor Suv",
            "Suv",
            "Limited Hybrid",
            "L",
            "Xlt Ecoboost",
            "Xlt Suv",
            "S",
            "Active",
            "Explor Xlt",
            "Xlt Sport",
            "Police",
            "H",
            "Xl/xlt/fx4/lariat",
            "2",
            "F",
            "4d Ltd",
            "Xls Sport",
            "Nbx/xlt/xlt Sport",
            "N Xlt",
            "Er",
            "I",
            "K",
            "Sp",
            "Explo Xl",
            "Terceptor",
            "N Limited",
            "A",
            "Xlt 4wd Xlt",
            "Explor Xls",
            "Xl",
            "Expl Ltd",
            "Xls/xlt",
            "T T",
            "Expl Lt",
            "Explor Spt",
            "Explor Eb",
            "Xls 114\" Wb Xls/xls Sport",
            "Expl. Spor",
            "S S",
            "P P",
            "Exp Sport",
            "Xlt Xlt",
            " Sr5",
            "Xlt Fwd Xlt",
            "E E",
            "U",
            "Expsprtrac",
            "Limited Limited",
            "Xlt 114\" Wb Xlt",
            "K K",
            "Fwd",
            "St Line",
            "Ecoboost",
            "St 4wd St",
            "Xl/xlt/eddie Bauer/limited",
            "Limited Fwd Limited",
            "Platinum Ecoboost",
            "Xl 112\" Wb",
            "U P",
            "Utility Pol",
            "Sc",
            "N",
            "Xlt Rwd Xlt"
          ]
        },
        {
          "model": "Explorer Sport Trac",
          "series": [
            "Choice/premium/value",
            "Xlt",
            "Limited",
            "Adrenalin/xls/xlt",
            "Xls/xlt",
            "Xls/xlt/xlt Premium",
            "Value/choice/premium",
            "Adrenal V8",
            "Limited V8",
            "Xls",
            "Adrenaline",
            "(truck)",
            "Xlt Premium",
            "Adrenalin/xlt Premium/xls/xlt",
            "Adrenalin",
            "Xls/xlt/xlt Premium/adrenalin",
            "Adrenalin/xls/xlt/xlt Premium",
            "C",
            "Value"
          ]
        },
        {
          "model": "F-150",
          "series": [
            "Xl/xlt",
            "Xlt",
            "Fx4/harley-davidson/king Ranch/lariat/platinum/xl/xlt",
            "Fx4/lariat/xlt",
            "Lariat/work Series/xl/xlt",
            " Heritage Classic",
            "Upercrew",
            "Standard Lariat/standard/xl/xlt",
            "Lariat/fx4/xl/xlt",
            "Lariat",
            "Xlt/lariat/fx4/xl",
            "Xl",
            "Lariat/xl/xlt",
            "Xlt/stx/xl",
            "Stx/xl/xl W/mid-box Prep/xlt/xlt W/mid-box Prep",
            "Fx4",
            "Platinum",
            "Stx/xl/xlt",
            "Lariat/xlt",
            "Fx4/king Ranch/lariat/platinum/xl/xlt",
            "King Ranch",
            "Stx",
            "Harley-davidson Edition/king Ranch Edition/lariat/xlt",
            "Uper Cab",
            "Fx4/lariat/xl/xlt",
            "King Ranch/lariat/xlt",
            "60th Anniversary/fx4/king Ranch/lariat/xlt",
            "60th Anniversary/fx2/king Ranch/lariat/xlt",
            "Stx/xl",
            "Supercrew",
            "60th Anniversary/fx2/xl/xlt",
            "Lariat/standard/xl/xlt",
            "Xlt/lariat/king Ranch",
            "Xlt/fx4/lariat/xl",
            "Xlt/lariat/xl",
            "Xl/xlt/lariat",
            "Work Series/xlt/lariat/xl",
            "Xlt/xl/lariat/platinum",
            "Heritage Xlt/xl",
            "Xlt/xl",
            "Xlt/lariat",
            "Supercrew Xlt/harley-davidson/lariat/king Ranch",
            "Supercrew Xlt/lariat/king Ranch",
            "Standard/xlt/xl",
            "Xlt/lariat/fx4",
            "Raptor",
            "Xl/xlt/fx4/lariat",
            "Xlt/standard/lariat/xl",
            "Heritage Xl/xlt",
            "Standard Standard/xl/xlt",
            "Work Series/xlt/xl",
            "Limited",
            "Standard/xlt/lariat/xl",
            "Work Series/xl/xlt",
            "Supercrew Xlt/lariat",
            "Fx2 Sport/xl/xlt",
            "Fx4/king Ranch/lariat/xlt",
            "Fx4/harley-Davidson/lariat/xl/xlt",
            "Tremor",
            "Stx/xlt",
            "Fx2",
            "Supercrew Harley-davidson/king Ranch Edition/lariat/xlt",
            "Harley-Davidson",
            "King Ranch Edition/lariat/xlt",
            "Fx2/lariat/xl/xlt",
            "Fx2/stx/xl/xlt",
            "Svt Raptor",
            "Svt Lightning",
            "Uper",
            "Standard/xl/xlt",
            "Police Responder",
            "Supercrew King Ranch Edition/lariat/xlt",
            "King Ranch/lariat/platinum/xl/xlt",
            "Super Cab",
            "Fx4/stx/xl/xlt",
            "Fx2 Sport/stx/xl/xlt",
            "Fx4/xl/xlt",
            "Rapto",
            "Lariat/stx/xl/xlt",
            "Lightning",
            "Xl/xlt/fx4/lariat/king Ranch/platinum",
            "Fx2 Sport/harley-davidson/king Ranch/lariat/platinum/xl/xlt",
            "Police Responder Xl",
            "T Ex",
            "Ssv",
            "Platinum Supercrew",
            "Xl Pickup",
            "Xlt Supercab",
            "King Ranch/lariat/platinum/tremor/xl/xlt",
            "Super Duty",
            "Supercrew Harley-davidson/king Ranch/lariat/xlt",
            "Cab",
            "Fx2/xl/xlt",
            "King Ranch/lariat/xl/xlt",
            "Aptor",
            "60th Anniversary/xl/xlt",
            "Fx4/xlt",
            "Xl/xlt/fx4/lariat/king Ranch/platinum/harley-davidson",
            "Upercrew Harley Davidson",
            "Xlt/fx4/stx/xl",
            "Xlt/lariat/stx/xl",
            "Xlt/lariat/king Ranch/xl",
            "Xlt/fx4/xl",
            "Xlt/fx4",
            "King Ranch/lariat/limited/platinum/xl/xlt",
            "Xl/xlt/fx2/lariat/king Ranch/platinum",
            "Fx4 Supercrew",
            "Xl/lariat/xlt",
            "60th Anniversary/fx2/king Ranch/lariat/limited/xlt",
            "Fx2 Sport/lariat/xl/xlt",
            "60th Anniversary/fx4/king Ranch/lariat/limited/xlt",
            "Xlt Supercrew",
            "Heritage Classic",
            "Xl Supercab",
            "Fx4 Supercab",
            "Fx4/king Ranch/lariat/platinum/xlt",
            "Xl/stx/xlt/fx4/lariat",
            "Fx4/king Ranch/lariat/limited/platinum/xl/xlt",
            "Lightning Pro/lightning X",
            "Xl/xlt/stx/fx4/lariat/king Ranch/platinum",
            "Harley-Davidson/limited",
            "Supercrew Xlt/lariat/king Ranch/harley-davidson",
            "Harley Davidson",
            "Xlt/harley-Davidson/lariat/xl",
            "Work Series",
            "Harley-Davidson/lariat/xl/xlt",
            "Harley-davidson/king Ranch/lariat/platinum/xl/xlt",
            "Fx2/stx/xlt",
            "Lariat/platinum/tremor/xl/king Ranch/xlt",
            "Xl/xlt/xl W",
            "Fx2 Sport",
            "Lariat/platinum/xl/king Ranch/xlt/limited",
            "Supercrew King Ranch/lariat/xlt",
            "Xlt/stx",
            "Xl/xlt/fx2 Sport",
            "Standard",
            "Xl/stx/xlt",
            "Xl/xlt/lariat/king Ranch",
            "Supercab",
            "Xlt/fx4/lariat",
            "Lariat/platinum",
            "Upercrew Xlt",
            "Fx2/king Ranch/lariat/platinum/xl/xlt",
            "Stx/xlt/fx4/xl",
            "Fx2/king Ranch/lariat/limited/platinum/xl/xlt",
            "Lightning Pro/lightning Xlt/lightning Lariat/lightning Platinum",
            "Lariat King Ranch Supcrew",
            "Stx/xlt/xl",
            "Xl/xlt/fx4/lariat/king Ranch/platinum/limited",
            "Xl Supercab 4w Xl",
            "Lariat/xlt/fx4",
            "Sel",
            "Xl/xlt/lariat/king Ranch/platinum",
            "Su",
            "Fx4/lariat/stx/xl/xlt",
            "Xl/xlt/lariat/king Ranch/platinum/limited/tremor",
            "Fx4 Tremor",
            "Lariat Supercab",
            " Se",
            "Pickup",
            "Lariat/xl",
            "Supercrew Harley Davidson",
            "Xlt/xl/lariat/platinum/king Ranch",
            "Rew",
            "Uper Duty",
            "Rew Harley Davidson",
            "Lariat Limited",
            "Rew Xlt",
            "Fx2/lariat/stx/xlt",
            "Xl Supercrew",
            "Heritage Xl",
            "R Xl",
            "Lariat Harley Davidson Sc",
            "Series",
            " Xl R",
            "Fx4/king Ranch/lariat/platinum/stx/xl/xlt",
            "King Ranch Sup 60th Anniversary/fx4/king Ranch/lariat/xlt",
            "Xlt/fx4/lariat/king Ranch",
            "Lightning Pro/lightning Xlt/lightning Lariat",
            "Xl/xlt/xlt Heritage",
            "Lightning Pro",
            "Lariat/xl/xlt/xlt Heritage",
            "Xl/xlt/fx2/60th Anniversary",
            "Xlt/fx2",
            "Xlt Pickup",
            "F150 Super",
            "Vt R",
            "Xl/stx/xlt/xl W",
            "Xlt/xl W",
            "Xl/xlt/stx",
            "Xl/lariat",
            "Xl/xlt/fx2/lariat",
            "Xl/xlt/stx/fx4/lariat",
            " Supe",
            "Ition El Xlt",
            "Vt F150 Rapto",
            "Xlt/xl/lariat/platinum/king Ranch/limited",
            "Lariat/king Ranch/platinum/xlt/fx4/xl",
            "Apto",
            "Xlt W/hd Payload Pkg",
            "Xl S",
            "Xlt Supercab 1 Lariat/xl/xlt/xlt Heritage",
            "Xlt/xl/lariat",
            "Vt",
            "Xl/stx/xlt/fx2/lariat",
            "Svt R",
            "Tremor Supercrew",
            "Xl/xlt/lariat/king Ranch/platinum/limited",
            "Xlt Supercrew Xlt",
            "N Se",
            "60th Anniversary",
            "Xl/xlt/lariat/harley-Davidson",
            "Xlt Supercrew (amalgamat)",
            "Fx2 Supercab",
            "Upercrew 4x4",
            "Xlt/fx4/lariat/king Ranch/platinum",
            "Heritage",
            "Heritage Lightning",
            "Stx Supercab",
            "Styleside 4wd",
            "Lariat Pickup",
            "Xl Regular Cab Stx",
            "Harley-Davidson/lariat/xlt",
            "4x4 Xlt 5.0",
            "Riat/xl/xlt",
            "Lt/xl/lariat",
            "Xl/xlt/fx4",
            "Laria",
            "Xlt/lariat/fx4/king Ranch",
            "D",
            "Xl W/mid-box Prep",
            "Xl/xlt/60th Anniversary",
            "Sprcr 4x4 Spr Crew",
            "Limited/harley-Davidson",
            "Olice Responder",
            "Spcr",
            "Itanium",
            "Ightning Pro/lightning X",
            " 150",
            "Touring",
            "Xlt Heritage",
            "Lariat/fx4/xlt",
            "Vt Lightning",
            "R4x4",
            "L/stx/xlt",
            "-150 Heri",
            "Stx/xlt/fx2",
            "/xl/xlt",
            "Ightning Pro",
            "Anch",
            "Lariat/platinum/fx4/xl/king Ranch/xlt",
            "Xlt/fx2/lariat/platinum",
            "Xlt W/mid-box Prep",
            "Stx/xlt/fx4/lariat",
            "Xl/xlt/fx2 Tremor",
            "Xlt W/midbox Prep",
            "Wd",
            "50",
            "Vt Raptor",
            "-150 Xlt",
            "Olic",
            "Xlt/lariat/king Ranch/fx2",
            "Xl/stx/xlt/lariat/fx2",
            "T4x4",
            "Lt",
            "Lariat W/hd Payload Pkg",
            "50 Pu Sci",
            "Stx/xlt/xl/fx2",
            "Xl/xlt/fx2",
            "L4x4",
            "Harley-davidson Sup Xl/xlt/fx4/lariat",
            "-150 Supe",
            "Sprcab 4x4 Rap Svt",
            "Vt F150 Rptor",
            "Uper Pu 4x4 (",
            "Iat/xlt",
            "Xl Supercab 145\" Wb Xl/stx/xlt/fx4/lariat",
            "/lariat",
            "Lt4x4",
            "Vt L",
            "Lariat/king Ranch/xlt",
            "Xlt/60th Anniversary/fx2/lariat/king Ranch",
            "Fx2 Sport/harley-davidson/king Ranch/lariat/platinum/xl",
            "Xl/xlt/fx4/lariat/king Ranch/limited/platinum",
            "Xl/lariat/king Ranch/xlt/platinum",
            "Xl/stx/xlt/xl W/mid-box Prep/xlt W/mid-box Prep",
            "Lariat/stx/xlt",
            "Xl/xlt/stx/lariat/fx4",
            "Xl/xlt/lariat/fx4",
            "-150",
            "Xlt W",
            "Xl/xlt/stx/fx2/lariat",
            "Xl W/hd Payload Pkg",
            "W/hd Payload Pkg",
            "Xl/stx",
            "Xl/stx/xlt/fx2",
            "King Ranch Supercre Xl/xlt/fx4/lariat",
            "L",
            "/xlt",
            "/fx4/lariat",
            "/lariat/platinum",
            "/fx2/lariat",
            "/xlt/fx4/lariat",
            "/xlt/fx2/lariat",
            "/platinum",
            "Stx/xlt/fx2/xl",
            "Fx2 Tremor",
            "Xl/xlt/fx4 Tremor",
            "Xlt/fx4/lariat/platinum",
            "Xl/stx/xlt/fx2 Sport",
            "Xlt/fx2/lariat",
            "Xl/xlt/fx2 Sport/lariat",
            "Xlt/lariat/xl/stx",
            "F-150",
            "4/lariat",
            "/stx",
            "Icku",
            "/stx/fx2/lariat",
            "Xl Regular Cab 126\"",
            "Xlt/lariat/fx2",
            "L/xlt/fx4/lariat",
            "L/xlt/stx/fx2/lariat",
            "Tx/xlt",
            "L/xlt/lariat",
            "Lt/fx4/lariat/king Ranch",
            "L/stx",
            "Lt/xl/lariat/platinum",
            "L/xlt",
            "L/stx/xlt/fx2/lariat",
            "/stx/fx4/lariat",
            "Iat",
            "Um",
            "/fx2 Sport",
            "/xlt/xl W",
            "Xlt/fx2/lariat/stx",
            "Ayload Pkg",
            "Ptor",
            "Xlt/lariat/stx",
            "2/lariat/platinum",
            "-150 Lari",
            "2/lariat",
            " W",
            "Lariat/platinum/fx4/king Ranch/xlt",
            "/stx/lariat/fx4",
            "Ight",
            "/lariat/fx4",
            "Uper F150 Super",
            "Svt Raptor Supercre",
            "Ort Se",
            "-150 Xl",
            "Fx2/lariat/stx/xl/xlt",
            "Ightning Pro/lightning Xlt/lightning Lariat/lightning Platinum",
            "Fx4 Pickup",
            "Outlander Sport Se",
            "Supercrew Xlt",
            "Ng Ranch/lariat/limited/platinum/xl/xlt",
            "Xl/xlt/fx2/lariat/king Ranch/platinum/limited",
            "Limited Supercrew",
            "Stx Supercrew",
            "Xlt Supercab 1 Xlt",
            "X2 Ex Super Cab",
            "X4 Ex Super Cab",
            "-150 Fx4",
            "Ightning Pro/lightning Xlt/lightning Lariat/lightning",
            "Limited Superc Limited",
            "00 Clb Wg",
            "E Titanium",
            "X4",
            "X4x2",
            "Lare",
            "F-150 Supe",
            "Polic",
            "King",
            "X4/harley-davidson/king Ranch/lariat/platinum/xl/xlt",
            "Imit",
            "F150",
            "Xl/xlt/fx2 Sport/lariat/king Ranch/platinum/harley-davi",
            "Es Pk",
            "Prcb",
            "X4x4",
            "Sv",
            "-150 King",
            "50 Pu Sup",
            "-150 V-6",
            "Upercrew Lariat",
            "Crew",
            "-150 Xl R",
            "Rapto Rapto",
            "Tremo",
            "Plati",
            "Rer Xlt",
            "4wd",
            "Fx4/king Ranch/lariat/platinum Package/xlt",
            "150",
            "Fx4 Supercrew Fx4",
            "Xl Regular Cab Xl",
            "50 Sup Cl",
            "U",
            "Ariat",
            "Aria",
            "Ing",
            "Her Uk",
            "Tx",
            "Lari",
            "Xl/xlt/lariat/xlt Heritage",
            "Platinum Hybrid Supercrew",
            "Lati",
            "C",
            "50 Wgn Xl",
            "X Ss",
            "Remo",
            "C 4x",
            "T4x4 Xlt4x4",
            "Light",
            "Supe",
            "C Rc",
            "Xlt F-150 Xlt",
            "L Xl",
            "Xten",
            "Wd 2wd",
            "Fx4 F-150 Fx4",
            "Xl/xlt/xl W/hd Payload Pkg/xlt W/hd Payload Pkg",
            "Fx4/lariat/svt Raptor/xl/xlt",
            "Supe F-150 Supe",
            "Svt R Svt R",
            "Fx4x4",
            "Rew Crew",
            "Lariat Supercr Lariat",
            " Lari",
            "Xlt/fx2/lariat/king Ranch/60th Anniversary",
            "F 150",
            "Sup",
            "C 4x Cc 4x",
            "St 1220 Hst",
            "F-150 Xl",
            "Pu",
            "Polic Polic",
            "F-150 Lari",
            "F-150 Xlt",
            "Xlt/fx4/lariat/xl/harley-Davidson",
            "King Ranch/lariat/limited/platinum/tremor/xl/xlt",
            "2wd",
            "Upercrew Platinum",
            "Stx F150",
            "Police Responder Police Responder",
            " Xlt",
            "Xlt4x4",
            "Lariat Hybrid Supercrew",
            "Ssv Fx2",
            "Svt L",
            "Xl Supercab 16 Xlt",
            "Xl Supercrew 4 Xlt",
            "3.5s/3.5sv/3.5sl",
            "Lt Supercrew",
            "Fx4/harley-davidson/king Ranch/lariat Chrome Package/xlt",
            "Heritage Xl Su Xl/xlt",
            "Stx F150 Super",
            "F-150 Fx4",
            "Fx4/harley-Davidson/lariat/xlt",
            "Style",
            "Xlt Supercab 4 Xlt",
            "Xlt Supercrew Fx4/lariat/xlt",
            "Styleside Supe",
            "Xlt/fx4/lariat/xl/60th Anniversary",
            "Lverado",
            "Fx4 Supercrew Fx4/lariat/xlt",
            "It Connect Titanium",
            "Fx4x2",
            "Pieces",
            "Xl Regular Cab Stx/xl/xlt",
            "Heri",
            "Xl/lariat/king Ranch/platinum/xlt",
            "Harley-davidso Lariat/xl/xlt",
            "Pickup Truck",
            "Xlt Supercrew Lariat/xlt",
            "Styleside",
            "Lightning Pro/lightning Xlt/lightning Lariat/lightning",
            " Xl",
            "Hd Payload Pkg",
            "Fx4 Supercrew Xlt",
            "Lightning Xlt",
            "Ng",
            "Parts",
            "Super",
            "Xlt W/hd Payload Pkg/lariat W/hd Payload Pkg/xlt/lariat/xl/xl W/hd Payload Pkg/platinum/king Ranch",
            "Exten",
            "Sxt",
            "Stx/xlt/fx2/xl/60th Anniversary",
            "Xtr Supercab",
            " Flar",
            "Fx4 Sc 139 Wb Fx4/lariat/xlt",
            "Xls",
            "Xl Supercab W/ Xlt",
            "Raptor Supercrew",
            "Xlt W/hd Payload Pkg/lariat W/hd Payload Pkg/xlt/lariat",
            "King Ranch Supercrew",
            "4x4",
            "150 Wgn Xl",
            "Xl Supercrew 1 Fx2",
            "Pickup Lariat/xl/xlt",
            "Xlt Supercrew Supercrew",
            "2.4 Lx-p",
            "F-150 King",
            "Rer Sport Trac",
            "150 Pu Sup",
            "Pro",
            "Raptor Superca Raptor",
            "Lariat Supercr Supercrew",
            "Lariat/platinum/harley-davidson/lariat Limited",
            "Harley Davidson Supercab",
            "Xl/xlt/fx2 Sport/lariat/king Ranch/platinum/harley-davidson",
            "Xl Xl",
            "Lariat Supercrew (amalga)",
            "Xlt/fx2/lariat/king Ranch/platinum",
            "Pickup Xlt",
            "Lariat Fx4 Supercrew",
            "R"
          ]
        },
        {
          "model": "F-150 Lightning",
          "series": [
            "Xlt",
            "Pro",
            "Lariat",
            "Platinum",
            "Lightning Pro/lightning X",
            "Flash",
            "Lightning Xlt",
            "Pro/xlt/lariat",
            "Pro/xlt/lariat/platinum",
            "Ro"
          ]
        },
        {
          "model": "F-250",
          "series": [
            "Lariat/xl/xlt",
            "Super Duty",
            "Lariat",
            "Fx4/harley-davidson/king Ranch/lariat/xl/xlt",
            "Xl",
            "Xlt",
            "Xl/xlt",
            "King Ranch",
            "Xlt/lariat/xl",
            "Xl/xlt/lariat",
            "Hd Xlt",
            "Srw Super Duty",
            "Fx4/lariat/xl/xlt",
            "Platinum",
            "Sd",
            "Cabela's/king Ranch/lariat/xl/xlt",
            "King Ranch/lariat/xl/xlt",
            "Fx4/king Ranch/lariat/xl/xlt",
            "Super",
            "Xlt/lariat/fx4/king Ranch/xl",
            "Sd Xlt Supercab",
            "Cabela's/harley-davidson/king Ranch/lariat/xl/xlt",
            "Fx4",
            "Xlt/lariat/king Ranch/xl",
            "Xlt/harley-davidson/lariat/fx4/king Ranch/xl",
            "Pu",
            "Lariat/standard/xl/xlt",
            "Sd Fx4 Crew Cab",
            "Sd Lariat Crew Cab",
            "Lariat/work Series/xl/xlt",
            "Xlt/standard/lariat/xl",
            "Standard Lariat/standard/xl/xlt",
            "Er Truck Camper",
            "Limited",
            "Xlt/lariat/fx4/xl",
            "Xlt/xl",
            "Lariat/xl/king Ranch/xlt",
            "Xlt/lariat/king Ranch/cabela's/xl",
            "Standard/xlt/lariat/xl",
            "Xlt/harley-davidson/lariat/king Ranch/cabela's/xl",
            "Lariat/platinum/xl/king Ranch/xlt/limited",
            "Sd Xlt Crew Cab",
            "Uper Duty",
            "Cutaway",
            "Sd Crew Cab",
            "Styleside 4wd",
            "Sd Xl Crew Cab",
            "Parts",
            "King Ranch/lariat/platinum/xl/xlt",
            "Sd Lariat",
            "Sd Supercab",
            "Uper",
            "Cab & Chassis",
            "Supercrew",
            "Duty F-250 Super Duty",
            " Powe",
            "Xl Pickup",
            "R Super Cab",
            "Crew C Crew",
            "Amarillo/lariat/xl/xlt",
            "Line E250 Van",
            "Sd Fx4 Supercab",
            "Rer Xlt",
            "Sd Lariat/xl/xlt",
            "U",
            "Fx4/harley-Davidson",
            " 250",
            "Duty F-250 Srw Lariat/platinum",
            "X4",
            "Cabela's/harley-Davidson",
            "Uxury Collection",
            "L/xlt/lariat",
            "Duty F-250 Srw Xlt/lariat/xl",
            "C 4x4",
            "Bed New",
            "Hd Crew Cab",
            "50 Pu Sup",
            "-250",
            "50 Cc 4x4",
            "Duty F-250 Srw Xl/xlt/lariat",
            "Duty F-250 Xl/xlt/fx4/lariat",
            "Cabelas/king Ranch/lariat/xl/xlt",
            "Series Standard/xl/xlt/lariat",
            "Updty",
            "Duty F-250 Xl/xlt/lariat/king Ranch",
            "-250 Supe",
            "Duty F-250 Srw Xlt/xl",
            "Bed",
            "Lt",
            "Duty F-250 Srw Xlt/xl/lariat",
            "Lariat/xlt/xl",
            "L/xlt/cabelas/lariat",
            "Wd",
            "L/xlt",
            "Duty",
            "X4/harley-davidson/king Ranch/lariat/xl/xlt",
            "Supdty",
            "/d",
            "L",
            "D",
            "Rew",
            "50 Chscab",
            "Ing Ranch",
            "50 Super Duty",
            "Sd Super Duty",
            "50 S\\c 4x",
            " Supe",
            "F 250",
            "250pu Crew",
            "2wd",
            "Sd Xl Supercab",
            "Arts",
            "50pu Crew",
            "C 4x",
            "50 Crw Cc",
            "4x4",
            "F-250",
            "Hd Series Crew Cab",
            "Harley-Davidson/lariat/xl/xlt",
            "50 Platinum",
            "Sd Lariat Supercab",
            "Lariat Supercab",
            "F250",
            "4wd 4x4",
            "F-250 Supe",
            "Supercab",
            "Sd Fx4/harley-davidson/king Ranch/lariat/xl/xlt",
            "Super Duty Pickup Truck",
            "Silverado K2500 Custom",
            "Supe",
            "Superduty Pickup Truck",
            "4wd",
            "Harley-davidson/king Ranch/lariat/outlaw/xl/xlt",
            "Series",
            "Supercab Hd 15",
            "Sd Pickup",
            "Sd Xl Pickup",
            "Hd C",
            "Ranger Xlt",
            "Sd Limited"
          ]
        },
        {
          "model": "F-250 Super Duty",
          "series": [
            "F-350 Srw Xlt/lariat/xl",
            "F-250 Xl/xlt/fx4/lariat/king Ranch/harley-davidson",
            "F-350 Srw Lariat/xl/xlt",
            "F-250 Lariat/xl/xlt",
            "F-350 Srw Xl/xlt/lariat",
            "F-250 Srw Xlt/lariat/xl",
            "F-250 Xl/xlt",
            "F-250 Xl/xlt/lariat",
            "F-250 Xlt/lariat/xl",
            "F-250 Lariat/platinum Edition/xl/xlt",
            "F-650 Xl/xlt",
            "F-350 Srw Platinum/xl/xlt/lariat/king Ranch",
            "F-550 Drw Xlt/xl",
            "F-350 Drw Xlt/lariat/xl",
            "F-450 Drw Xl/xlt",
            "F-250 Srw",
            "F-450 Drw Xlt/xl",
            "F-350 Drw Xl/xlt/lariat/king Ranch",
            "F-350 Drw Xl/xlt/lariat",
            "F-350 Drw Lariat/xl/xlt",
            "F-350 Drw",
            "F-250 Xl/xlt/fx4/cabelas/lariat/king Ranch/harley-davidson",
            "F-350 Srw Xl/xlt",
            "F-250 Srw Xl",
            "F-350 Drw Super Duty",
            "F-350",
            "F-350 Srw Xl/xlt/lariat/king Ranch",
            "F-350 Drw Xl/xlt/lariat/king Ranch/platinum",
            "F-250 Srw Xlt",
            "F-350 Srw Xl",
            "F-550 Drw Xl/xlt/lariat",
            "F-550 Drw Xl/xlt",
            "Truck Bed",
            "4dr Pickup",
            "F-450 Xlt/xl",
            "F-350 Drw Xl/xlt/lariat/king Ranch/platinum/limited",
            "F-350 Srw Xl/xlt/fx4/lariat/king Ranch/harley-davidson",
            "F-250 Srw Fx4/harley-davidson/king Ranch/lariat/xl/xlt",
            "F-250",
            "F-350 Drw Lariat",
            "F-250 Srw Xl/xlt/lariat",
            "F-550 Drw Lariat/xl/xlt",
            "F-250 Lariat/king Ranch/xl/xlt",
            "F-350 Drw Lariat/xlt/xl",
            "F-550 Xlt/xl",
            "F-250 Srw Xl/xlt",
            "F-350 Drw Xl/xlt",
            "F-750 Xl/xlt",
            "F-350 Drw Xlt/xl",
            "F-350 Srw Platinum/xl/xlt/lariat",
            "F-350 Srw Xl/xlt/fx4/lariat",
            "F-250 Srw Xl/xlt/lariat/king Ranch/platinum/limited",
            "F-350 Srw Xl/xlt/lariat/king Ranch/harley-davidson",
            "F-350 Srw",
            "F-250 Srw Lariat/platinum/king Ranch/xlt/xl",
            "F-250 Xlt/lariat/king Ranch",
            "F-250 Srw Super Duty",
            "Crew Cab",
            "F-250 Xl/xlt/lariat/king Ranch",
            "F-250 Super Duty",
            "F-350 Srw Lariat",
            "F-250 Xl/xlt/lariat/king Ranch/harley-davidson",
            "F-250 Srw Xl/xlt/lariat/king Ranch",
            "F-450 Drw Xl/xlt/king Ranch/lariat/platinum",
            "F-450 Xl/xlt/lariat/king Ranch",
            "Duty",
            "F-450 Drw Super Duty",
            "F-350 Srw Super Duty",
            "F-350 Srw Xl/xlt/lariat/king Ranch/amarillo/harley-davidson",
            "F-450 Drw Xl/xlt/lariat",
            "Bed New",
            "F-350 Srw Platinum",
            "Drw Xl/xlt/lariat/king Ranch",
            "F-450",
            "E350 Shuttle Bus",
            "F-550 Drw",
            "F-250 Xl/xlt/cabelas/lariat/king Ranch/harley-davidson",
            "F-250 W/s Xl",
            "F-350 Srw Srw Super Duty",
            "F-250 Srw Xl/xlt/lariat/king Ranch/platinum",
            "F-450 Drw Xl",
            "F-650 Straight Frame Xl/xlt",
            "Drw Lariat/xl/xlt/platinum",
            "Srw Platinum/xl/xlt/lariat",
            "Drw Xl/xlt",
            "Drw Xl/lariat/xlt",
            "F-450 Drw Lariat",
            "Srw Xlt/lariat/xl",
            "Srw Xl",
            "Xl/xlt/lariat/king Ranch",
            "F-550 Drw Xl/lariat/xlt",
            "Drw Xl/xlt/lariat",
            "F-750",
            "Srw Xl/xlt/lariat/king Ranch",
            "F-250 Srw Lariat/platinum",
            "F-250 Xl/xlt/fx4/cabelas",
            "Drw Xlt/lariat/xl",
            "Srw Lariat/platinum",
            "Srw Xl/xlt/lariat",
            "Xl/xlt",
            "F-250 Xl",
            "F-650",
            "Drw Super Duty",
            "F-450 Xlt",
            "Super Duty",
            "Srw Xlt",
            "Drw Xl/xlt/lariat/king Ranch/platinum",
            "Dr Pickup",
            " Srw Lariat",
            "Srw Super Duty",
            "Srw Platinum",
            "Xl/xlt/lariat",
            "Srw Lariat/xl/xlt/king Ranch",
            "F-450 Super Duty",
            "Srw Platinum/xl/xlt/lariat/king Ranch",
            "Srw Xl/xlt/lariat/king Ranch/platinum",
            "Srw Xl/xlt",
            "Drw Xl/xlt/lariat/king Ranch/platinum/limited",
            "Straight Frame Xl/xlt",
            ".7l Diesel Fx4",
            "8 Foot",
            "Super",
            "/plow",
            "Lt",
            "Supe",
            "F-450 Xl/xlt",
            "6.7l Turbo Diesel",
            "F-450 Lariat/xl/xlt",
            "F-550 Lariat/xl/xlt"
          ]
        },
        {
          "model": "F-350",
          "series": [
            "Super Duty",
            "Srw Super Duty",
            "Lariat/xl/xlt",
            "Xl",
            "Xlt",
            "Xlt/lariat/xl",
            "Chassis Lariat/xl/xlt",
            "Xlt/harley-davidson/fx4/lariat/king Ranch/xl",
            "Chassis Xl",
            "Xlt/fx4/lariat/king Ranch/xl",
            "Chassis Cab Xlt",
            "Lariat",
            "Xl/xlt",
            "King Ranch/lariat/platinum/xl/xlt",
            "Chassis Xl/xlt",
            "Cabela's/harley-davidson/king Ranch/lariat/xl/xlt",
            "F350 Super Duty",
            "Chassis Xlt",
            "King Ranch",
            "Er Duty",
            "Xlt/xl",
            "Chassis Super Duty",
            "Srw S",
            "Fx4/king Ranch/lariat/xl/xlt",
            "Platinum",
            "Fx4/lariat/xl/xlt",
            "Chassis Lariat",
            "Chassis",
            "Fx4/harley-davidson/king Ranch/lariat/xl/xlt",
            "King Ranch/lariat/xl/xlt",
            "Sd Pickup",
            "Super",
            "It T-350",
            "Chassis Xlt/xl",
            "Limited",
            "Super Duty Stripped Chassis",
            "Cab And Bed Only",
            "Xlt/harley-davidson/lariat/king Ranch/cabela's/xl",
            "Lariat/xl/king Ranch/xlt",
            "Xlt/fx4/lariat/xl",
            "Chassis Lariat/xlt/xl",
            "Sd Platinum Crew Cab",
            " Alpine M",
            "Sd Lariat Crew Cab",
            "King Ranch/lariat/limited/platinum/xl/xlt",
            "Sd Crew Cab",
            "Uper Duty",
            "Sd Xlt Crew Cab",
            "Sd Lariat Supercab",
            "Sd Xl Crew Cab",
            " Duty",
            "Uper",
            "Sd Super Duty",
            "Er Du",
            "King Ranch King Ranch",
            "Sd Fx4 Crew Cab",
            "Sd Xlt Supercab",
            "Chassis Cab",
            "Brush Fire Truck",
            "It T-350 Hd",
            "Sd Lariat King Ranch",
            "Line E450 Super Duty Cutaway Van",
            "Custom Rescue Vehicle",
            "Crew Cab",
            "Fx4",
            "Cabela's/harley-Davidson",
            "Xlt/lariat/fx4/xl",
            "Ariat",
            "King",
            "/xl/xlt",
            "Fx4/harley-Davidson",
            "Rw Super Duty",
            "Rw S",
            "-350",
            "L/xlt/lariat/king Ranch",
            "Xl/xlt/fx4/lariat",
            "Lt/lariat/xl",
            "Xlt/harley-davidson/lariat/fx4/king Ranch/xl",
            "D",
            "Series Crew Cab",
            "Xl/xlt/lariat/king Ranch",
            "Drw Xl/xlt/lariat",
            "Wd",
            "Duty",
            "Xl/xlt/lariat",
            "Ariat/xl/xlt/king Ranch",
            "50 Crewcb",
            "L/xlt",
            "Xlt/xl/lariat",
            "50 Spr Cc",
            " 350",
            "Xl/xlt/fx4/cabelas",
            "L/xlt/lariat",
            "-350 Supe",
            "50",
            "Supercrew",
            "Sd Platinum Cc (amalgama)",
            "Cab & Chassis 161\" Wb 4wd",
            "6.7l Srw Xl",
            "Srw",
            "Super Super",
            "Series",
            "X4",
            "Us",
            "50 Crw Cs",
            "50 Lariat",
            "F-350 Supe",
            "Ine E350 Super Duty Wagon",
            "Chassis Srw Super Duty",
            "Sd",
            "Sd Platinum/xl/xlt/lariat/king Ranch",
            "Supe E-350 Supe",
            "Supe",
            "-350 Lari",
            "-450 Supe",
            "50 Cc 4x4",
            "Crew",
            "50 Transi",
            "F 350",
            "F-350",
            "Uper Super",
            "Line E350 Super Duty Cutaway Van",
            "50 Xlt",
            "350 Xlt",
            "Crew Srw",
            "Crew Cab 168.4",
            "Line E450 Super Duty Cutaway Van Rv",
            "Extended Cab",
            "Harley-Davidson/lariat/xl/xlt",
            "50 Xl",
            "50 Super Duty",
            "Sd Harley Davidson",
            "Series Xlt",
            "Line E350 Super Duty Van",
            "Sd Lariat (amalgamated)",
            "F-450 Supe",
            "F250",
            "Super Duty Crew Cab Bale Bed Truck",
            "4x4",
            "Super Duty Service Truck",
            "Super Duty Dump Truck",
            "Super Duty Supercab Utility/service Truck",
            "Super Duty Flat Bed Pickup Truck",
            "Super Duty Pickup Truck Cab And Chassis",
            "Super Duty Pickup Truck",
            "Highline/lariat/xl/xlt",
            "Super Duty Xl Utility Bed Pickup Truck",
            "Harley-davidson/king Ranch/lariat/outlaw/xl/xlt",
            "Super Duty Xl Supercab Utility Bedpickup Truck",
            "Regul",
            "C 4x4",
            "Pickup",
            "Super Flat Bed Truck",
            "Parts Only",
            "350 Transi",
            " Supe",
            "Super Service Truck",
            "Super Duty Utility / Service Truck",
            "Super Trucks Flat Bed Truck",
            "6.7l Turbo Diesel",
            "Sd Xlt Pickup",
            "F Super Du",
            "Sd Xl Pickup",
            "Lariat/platinum/xl/xlt",
            " Duty F-350 W/d"
          ]
        },
        {
          "model": "F-350 Super Duty",
          "series": [
            "Xl Bucket Truck",
            "Xl Utility / Service Truck"
          ]
        },
        {
          "model": "F-450",
          "series": [
            "Super Duty",
            "Chassis Xl",
            "Chassis Lariat/xlt/xl",
            "Chassis Xlt/xl",
            "Lariat/xl/xlt",
            "Lariat",
            "Chassis Xlt",
            "Chassis Xl/xlt",
            "Xlt",
            "Super",
            "Chassis",
            "Xl",
            "King Ranch",
            "Xl/xlt",
            "Xlt/lariat/king Ranch/xl",
            "Platinum",
            "King Ranch/lariat/xl/xlt",
            "Chassis Lariat/xl/xlt",
            "Limited",
            "F Super Duty",
            "Chassis Bus",
            "Bucket Truck",
            "Harley-davidson/king Ranch/lariat/xl/xlt",
            "Line E450 Super Duty Cutaway Van",
            "Chassis Super Duty",
            "Dump Tru",
            "Uper Duty",
            "Chassis Lariat",
            "L/xlt/lariat/king Ranch",
            "L/xlt",
            "Duty",
            "L/lariat/xlt",
            "L/xlt/lariat",
            "Uper",
            "Xl/xlt/lariat",
            "Ed",
            "450 Super",
            "Upe",
            "450 Chassis Xlt",
            "50 Super Duty",
            "U-Haul",
            "Sd Pickup",
            "Super Duty Box Truck",
            "Super Duty Lariat Crew Cab Servicetruck",
            "King Ranch/lariat/limited/platinum/xl/xlt",
            "Super Duty Refrigerated Delivery Truck",
            "Super Duty Bucket Truck",
            "Super Duty Flatbed Truck",
            "Super Duty Utility / Service Truck",
            "Super Duty Flat Bed Truck",
            "Er Duty",
            "E450 Super",
            "Super Duty Tow Truck",
            "Super Duty Xl Crew Cab Service Truck",
            "Sd Xl Crew Cab",
            "Super Duty Service Truck",
            "Super Super"
          ]
        },
        {
          "model": "F-450 Super Duty",
          "series": [
            "Dump Truck",
            "Utility / Service Truck",
            "Crew Cab Flatbed Truck",
            "Bucket Truck",
            "Xlt Flatbed Truck",
            "Xl Utility / Service Truck",
            "Xl Bucket Truck",
            "Winch Truck",
            "Xlt Ambulance",
            "Supercab Utility / Service Truck",
            "Flatbed Truck",
            "Xl Street Sweeper Truck",
            "Xl Dump Truck",
            "Refuse Truck",
            "Xl Crew Cab Utility / Service Truck",
            "Supercab Truck Cab And Chassis",
            "Crew Cab Dump Flatbed Truck",
            "Xl Dump Flatbed Truck",
            "Truck Cab And Chassis",
            "Xl Supercab Dump Truck",
            "Xlt Crew Cab Utility / Service Truck",
            "/xl"
          ]
        },
        {
          "model": "F-550 Super Duty",
          "series": [
            "Stripped Chassis",
            "Stripped Chass",
            "Xlt",
            "Xl Truck Cab And Chassis",
            "Box Truck",
            "Utility / Service Truck",
            "Crew Cab Utility / Service Truck",
            "Supercab Flatbed Truck",
            "Xl Utility / Service Truck",
            "Xlt Utility / Service Truck",
            "Truck Cab And Chassis",
            "Xl Bucket Truck",
            "Xl Shuttle Bus",
            "Bucket Truck",
            "Xl Dump Truck",
            "Xl Supercab Utility / Service Truck",
            "Xl Crew Cab Truck Cab And Chassis",
            "Xl Winch Truck",
            "Xl Brush Fire Truck",
            "Limo Bus",
            "Crew Cab Winch Truck",
            "Xl Supercab Flatbed Truck",
            "Xl Rescue Vehicle",
            "Xlt Bucket Truck",
            "Crew Cab Flatbed Truck",
            "Ambulance",
            "Dump Truck",
            "Brush Fire Truck",
            "Tripped Chass",
            "Tripped Chassis",
            "Xl"
          ]
        },
        {
          "model": "F-600 Super Duty",
          "series": [
            "Super Duty",
            "Srw Xl/xlt/lariat",
            "Xl/xlt/cabelas/lariat",
            "Drw Xl/xlt",
            "Drw Xlt/lariat/xl",
            "Drw",
            "Srw",
            "Drw Xl/xlt/lariat",
            "Srw Lariat/platinum",
            "Srw Platinum/xl/xlt/lariat",
            "Drw Lariat/xl/xlt",
            "Xl/xlt",
            "Bed",
            "Drw Lariat",
            "Drw Xlt/xl",
            "Drw Xl/xlt/lariat/king Ranch",
            "Tripped",
            "Srw Super Duty",
            "Srw Xl/xlt/lariat/king Ranch",
            "Xl/xlt/lariat",
            "Xl/xlt/lariat/king Ranch",
            "Srw Lariat/xl/xlt",
            "Srw Xl",
            "Drw Xl/lariat/xlt",
            "Srw Xl/xlt",
            "Srw Xlt/xl/lariat/platinum",
            "Drw Xl",
            "Srw Xlt/xl/lariat",
            "Pro",
            "Xlt/platinum Edition/lariat/xl",
            "Lariat/platinum Edition/xlt/xl",
            "Xl/xlt/lariat/highline",
            "Srw Xl/xlt/lariat/highline",
            "Uty",
            "Drw Xl/xlt/lariat/king Ranch/platinum/limited",
            "Lariat/platinum Edition/xl/xlt",
            "Xl/xlt/lariat/king Ranch/harley-davidson/outlaw",
            "Drw Lariat/xlt/xl/platinum",
            "Drw Xlt/xl/lariat",
            "L/xlt/lariat/king Ranch",
            "Xlt/lariat/xl",
            "Lariat",
            "Lariat/xl/xlt",
            "Srw King",
            "Xl",
            "Ly",
            "Srw Xl/lariat/xlt",
            " Truck B",
            "Xlt",
            "Drw Xlt",
            "Xlt/harley-davidson/lariat/king Ranch/xl",
            "Srw Lariat",
            "Xl/xlt/lariat/king Ranch/amarillo/harley-davidson",
            "Pro Xl/xlt",
            "Srw Xlt/lariat/king Ranch/xl",
            "Drw King Ranch",
            "Srw Xlt/harley-davidson/lariat/fx4/king Ranch/xl",
            "King Ranch/lariat/xl/xlt",
            "Srw Platinum",
            "Srw King Ranch",
            "Drw King Ranch/lariat/xl/xlt",
            "Srw Xl/xlt/lariat/king Ranch/platinum/limited",
            "Srw Xl/xlt/fx4/lariat/king Ranch/harley-davidson",
            "Drw Xlt/platinum",
            "Srw Xl/xlt/fx4/cabelas",
            "Srw Xl/xlt/cabelas/lariat",
            "Srw Xlt/lariat/xl",
            "Xl/xlt/fx4/lariat",
            "Drw Platinum/xl/xlt/lariat",
            "Drw Lariat/xl/xlt/platinum",
            "Srw Lariat/xl/xlt/king Ranch",
            "Srw King Ranch/lariat/xl/xlt",
            "Xl/xlt/fx4/cabelas",
            "Xlt/xl",
            "Srw Xlt/xl",
            "Srw Xlt",
            "Drw Lariat/xlt/xl",
            "Drw Xl/platinum/xlt/lariat",
            "Srw Xl/xlt/fx4/lariat",
            "Drw Xl/xlt/fx4/lariat",
            "Srw Lariat/xlt/xl",
            "Srw Srw Super Duty",
            "Er Duty",
            "Xl/xlt/fx4/lariat/king Ranch/harley-davidson",
            "Drw Super Duty",
            "Srw Fx4/harley-davidson/king Ranch/lariat/xl/xlt",
            "Srw Platinum/xl/xlt/lariat/king Ranch",
            "Srw Xl/xlt/fx4/cabelas/lariat/king Ranch/harley-davidson",
            "Drw Xl/xlt/king Ranch/lariat/platinum",
            "Srw Lariat/platinum/king Ranch/xlt/xl",
            "Straight Frame Gas",
            "R Du"
          ]
        },
        {
          "model": "F53",
          "series": [
            "Ystar",
            " F53",
            "Y Star 3226",
            "Motorhome",
            "Motor Home",
            " Adventurer",
            "Ver Mh",
            " F53 Vacationer",
            " Flair",
            "Windsport Motor Home",
            "By Thor",
            "53",
            "Ace Motor Home",
            "R Windsport",
            "Cept F53"
          ]
        },
        {
          "model": "F59",
          "series": [
            "Delivery Truck",
            "Delivery Van"
          ]
        },
        {
          "model": "F650",
          "series": [
            "Super Duty",
            "Rollback",
            "Super",
            "Super Duty Xl Dump Truck",
            "Super Duty Rollback Truck",
            "Super Duty Flatbed Truck",
            "Super Duty Delivery Truck",
            "Super Duty Xlt Flatbed Truck",
            "Super Duty Xl Refuse Truck",
            "Super Duty Crew Cab Fuel/ Lube Truck",
            "Socage Forste Daj105 Aerial Lift",
            "Socage Forste 120dj Aerial Lift",
            " Duty",
            "Super Super",
            "Xl/xlt",
            "Super Crewzer",
            "Super Duty Box Truck",
            "Super Duty Rollback Tow Truck",
            "Box Truck",
            "Super Duty Truck Cab And Chassis",
            "Flatbed Truck",
            "Super Duty Tow Truck",
            "Dump Truck",
            "Super Duty Flatbed Truck With Crash Attenuator",
            "Super Duty Bucket Truck"
          ]
        },
        {
          "model": "F750",
          "series": [
            "Super Duty",
            "Super",
            "/con O Lift Trailer",
            "Water Truck",
            "Pumper Fire Truck",
            "Xl/xlt",
            "Super Duty Box Truck",
            "Super Duty Dump Flatbed Truck",
            "Super Duty Flatbed Truck",
            "Super Duty Truck Cab And Chassis",
            "Supercab Bucket Truck",
            "Super Duty Dump Truck",
            "Super Duty Water Truck",
            "Super Cable Placer Bucket Truck",
            "Super Cnstruction Dump Truck",
            "Super Duty Crane Truck",
            "Bucket Truck",
            "Super Duty Bucket Truck",
            "Service Truck",
            "Super Duty Service Truck",
            "Super Duty Forestry Bucket Truck"
          ]
        },
        {
          "model": "Fiesta",
          "series": [
            "Se",
            "S",
            "St",
            "Titanium",
            "Ses",
            "Sel",
            "St Line",
            " Gl",
            "Tit",
            "Zet",
            "Feista",
            "M",
            "4d S",
            "4d Se",
            "Super Duty",
            "4d",
            "Amb",
            "Ses Ses",
            "Sel Sel",
            "5d",
            "Se Se",
            "St St",
            "S S",
            "Tit Tit",
            "Ex"
          ]
        },
        {
          "model": "Fiesta Ikon",
          "series": []
        },
        {
          "model": "Figo",
          "series": [
            "Titanium",
            "Ambie",
            "Titan",
            "Ambiente"
          ]
        },
        {
          "model": "Flex",
          "series": [
            "Sel",
            "Limited",
            "Se",
            "Limit",
            "Titanium",
            " Se",
            "Limited/titanium",
            "W/ecoboost",
            "Ium",
            "Titanium W/ecoboost",
            "Sel W/ecoboost",
            "Limited Ecoboost",
            "Ed",
            "Limited W/ecoboost",
            "Ed W/ecoboost",
            "Ed Ecoboost",
            "Ed/titanium",
            "Lx",
            "Se Se",
            "Limit Limit",
            "Se Fwd Se",
            "H Intl (bci) Other",
            "Limited Fwd Limited"
          ]
        },
        {
          "model": "Focus",
          "series": [
            "Se",
            "Lx",
            "Zx4",
            "Titanium",
            "Rs",
            "Sel",
            "St",
            "Ses",
            "S",
            "Se Base/se Comfort",
            "S/se/ses",
            "Se/ses",
            "Se Street Edition/se",
            "Zx5",
            "Zx3",
            "Se/se Sport",
            "Se/se Comfort",
            "Se Comfort/se Sport",
            "Bev",
            "Zxw",
            "Electric",
            "Zts",
            "Se/se Sport/ztw",
            "Zx5/s/se/ses",
            "St St",
            "Se Comfort",
            "Zx4/s/se/ses",
            "S/se",
            "Se/sel/ses",
            "Ses Ses",
            "Ztw",
            "Zx4 Se",
            "Zx5 Ses",
            "Se/ztw",
            "Zx4 St",
            " Se Hybrid",
            "Svt",
            "Se/se Street Edition",
            "Zx3/s/se/ses",
            "Lx Base/lx Premium",
            "Ztw/se",
            "Se Base/se Comfort/ztw",
            "Zx3 Base/zx3 Premium/zx3 Pwr Premium",
            "Titanium Titanium",
            "Se/se Comfort/se Sport",
            "Tita",
            "Svt/zx5",
            "Zx4 Ses",
            "Rs Rs",
            "Se/se Comfort/ztw/se Sprt",
            "Zx4 S",
            "Zxw/s/se/ses",
            "Se/le/xle",
            "Zx5 Svt",
            "Se/zx3",
            "Zx3/zx3 Premium",
            "Se/zx4",
            "Zxw Se",
            "Rs Lx",
            "Zx3 Svt",
            "Electric Bev",
            "(mex) St",
            "Sel Sel",
            "Zx3 Base/zx3 Premium",
            "Electric Electric",
            "Zx5/svt",
            "Se Fleet/se Base",
            "Zx5 Base",
            "Zx5 Base/zx5 Comfort",
            "Zx3 Base",
            "Sv",
            "Se C",
            "Zts/zts W/mach Audio",
            "Foc Zx3",
            "Zx3 Pwr Premium",
            "Sw St",
            "Sw Se",
            "Se Base",
            "4d Se",
            "4d",
            "Um",
            "Focus Se",
            "Se Fleet/se/ztw",
            "4d S",
            "Zx3 Premium",
            "2d Ses",
            "Zx",
            "Se/sport/limited",
            "S Se",
            "Se/s",
            "Se 4",
            "Ambi",
            "Seda",
            "Focus",
            "Tita Tita",
            "S Zx",
            "Wag",
            " Titanium",
            "Spor",
            "Elec",
            "S Zx S Zx",
            "220",
            "Se/s Se/s",
            " Se",
            "+",
            "3",
            "Zxw Ses",
            "Zx5/zx5 Base",
            "4d L",
            "Fwd Premier"
          ]
        },
        {
          "model": "Fusion",
          "series": [
            "Titanium",
            "Se",
            "Sport",
            "S",
            "Sel",
            "Hybrid",
            "Hybrid Se",
            "Hybrid Sel",
            "Titanium Phev",
            "Se Hybrid",
            "Energi Se Luxury",
            "Titanium/platinum Phev",
            "Titanium/platinum Hev",
            "Platinum",
            "Hybrid Titanium",
            "Plug-in Hybrid Titanium",
            "Se Phev",
            "Titanium Hev",
            "Titanium/platinum",
            "S Hybrid",
            "Hybrid S",
            "Energi Titanium",
            "Hybrid Hybrid",
            "Hybrid Se Hybrid",
            "Hybrid Platinum",
            "Titanium Hybrid",
            "Se V6",
            "Energi Titanium Phev",
            "Energi Se Phev",
            "Se Gl",
            "Hybrid Titanium Hev",
            "Energi Platinum",
            "Energi Platinum/titanium",
            "Sel V6",
            "Hybrid S Hybrid",
            "Police Responder",
            "Sport V6",
            "Tit",
            "Spo",
            "Hybrid Titanium/platinum",
            "V6 Sport",
            "Energi Sel",
            "S H",
            "Hyb",
            "Energi Titanium/platinum",
            "Energi",
            "Police Interceptor",
            "Hybrid Titanium/platinum Hev",
            "Energi Titanium/platinum Phev",
            "4d",
            "E",
            "S Fwd S",
            "Se Fwd Se",
            "4d Sel",
            "Ex",
            "Ene",
            "Pol",
            "Hyb 4d Se",
            "4d S",
            "Supercrew",
            "St",
            "K1500 Lt",
            "Sel Fwd Sel",
            "S F S F",
            "Energi Se",
            "Hybrid Titanium Fw Titanium",
            "4d Se",
            "M Phev",
            "M",
            "Hyb 4d",
            "M/platinum",
            "M Hev",
            "C1500 Custom",
            "M/platinum Hev",
            "Hybrid Titanium Fw Hybrid",
            "Id",
            "Per Duty Wagon",
            "Lx",
            " Service",
            "D",
            "M Hybrid",
            "Zx3",
            "S H S H",
            "S F",
            "Tit Tit",
            "S S",
            "Spo Spo",
            "Hyb Hyb",
            "Fusion",
            "Spe",
            "Tax",
            "Titanium Fwd Titanium",
            "4d 4d",
            "Se Se",
            "Lt",
            "Platinum/titanium",
            "Se Luxury",
            "Rear-wheel Drive",
            "Special Service",
            "4d Tit",
            "R",
            "-4 C",
            "Hyb Se",
            "Hyb Titanium"
          ]
        },
        {
          "model": "GT",
          "series": [
            "N Torin",
            "Dtorino",
            "Lby",
            "N Torino",
            "Bygt350 Clone",
            "Shelby",
            "Lby Kit",
            "Tang Gt"
          ]
        },
        {
          "model": "LCF",
          "series": [
            "655a",
            "645a"
          ]
        },
        {
          "model": "Lobo",
          "series": []
        },
        {
          "model": "Maverick",
          "series": [
            "Xl",
            "Lariat",
            "Xlt",
            "Lariat/xl/xlt",
            "Xlt/lariat",
            "Xl/xlt/lariat",
            "Xl/xlt",
            "Lariat Tremor",
            "Xlt Tremor",
            "Advanced",
            "Riat",
            "X",
            "X X",
            "L",
            "Xlt Supercr Xl",
            "Xlt Supercrew",
            " E350 Cutaway Van",
            "Pickup Truck",
            "Tremor",
            "Xl Supercrew",
            "S",
            "T",
            "Lobo-Premium",
            "Lobo"
          ]
        },
        {
          "model": "Mustang",
          "series": [
            "V6 Deluxe/v6 Premium",
            "Ecoboost",
            "Ecoboost Premium",
            "V6/v6 Premium",
            "V6",
            "Gt",
            "Gt Fastback",
            "Gt Premium",
            "V6 Premium",
            "Gt Premium Fastback",
            "Ecoboost Premium Fastback",
            "Ecoboost Fastback",
            "Shelby Gt500",
            "Gt Deluxe/gt Premium",
            "Mach I",
            "Deluxe/premium",
            "Gt/gts",
            "Shelby Gt500 Fastback",
            "Mach-e Gt",
            "Mach-e Premium",
            "Mach-e Select",
            "Shelby Gt350",
            "Lx",
            "Gt Bullitt Edition/gt Deluxe/gt Premium",
            "Boss 302",
            "Bullitt",
            "Gt/gt Premium",
            "Mach 1 Fastback",
            "Gt/cobra Gt",
            "Gt 50 Years Limited Edition",
            "Mach-e California Route 1",
            "Cobra",
            "50th Anniversary",
            "Cobra Svt",
            "Glx",
            "Gt Deluxe",
            "L",
            "T",
            "Fastback W/ecoboost",
            "Dark Horse Fastback",
            "V6 Deluxe",
            "2 Plus 2",
            "Mach 1",
            "Standard/deluxe/premium",
            "Ecoboost /ecoboost Premium",
            "Ecoboost Fastback/ecoboost Premium Fastback",
            "Shelby",
            "Deluxe/premium/standard",
            "Svo",
            "10th Anniversary Package/cobra",
            "Ma",
            "2d",
            "Bullitt Premium Fastback",
            "Ecoboost/ecoboost Premium",
            "Lx/gt",
            "Deluxe",
            "Svt Cobra",
            "Deluxe V6 Deluxe",
            "Fastback",
            "Dark Horse",
            "Convertible",
            "Cobra/svt",
            "Sh",
            "Gr",
            "Zimmer",
            "Cv",
            "Ii 2+2",
            "Hardtop",
            "Premium",
            "Co",
            "50",
            "Ex",
            "Emium",
            "Gt 50 Years Limited",
            "T500 Fastback",
            "Premium/v6 (110a)",
            "Bu",
            "Um",
            "Bo",
            "Gt500",
            "Parts",
            "Must",
            "Gt 2d",
            "T350",
            " Premium",
            "Svt Cobra/svt Cobra 10th Anniv",
            "Gt Saleen #789",
            "Ha",
            "Le",
            "Standard",
            "Gt/gt Deluxe",
            "Fastback W/e Ecoboost",
            "4c",
            "Gt Roush",
            "Premium V6 Premium",
            "Gt Gt",
            "Sh Sh",
            "Mustang",
            "Gl",
            "M1",
            "Gt 50 Years Gt 50 Years Limited Edition",
            "Da",
            "Cobra Kit",
            "Co Co",
            "Must Gt Cv",
            "Ii Ghia",
            "Ii",
            "Bu Bu",
            "Premium W/ec Ecoboost Premium",
            "Ra",
            "Gt Deluxe Gt",
            "Shelby Gt350r",
            "De",
            "Gt Fastback Gt Premium Fastback",
            "Deluxe V6 Deluxe/v6 Premium",
            "Eco Premium",
            "Cobra R",
            "Gt Bullitt",
            "Premium Fast Ecoboost",
            "Mustang Parts Only",
            "Fastback W/e Ecoboost Premium Fastback",
            "Gt Gt Premium",
            "Sv",
            "Conv Jack Roush E",
            "Coupe Notchb",
            "Gt Fastback/gt Premium Fastback"
          ]
        },
        {
          "model": "Mustang Mach-E",
          "series": [
            "Select",
            "Gt",
            "Premium",
            "California Route 1",
            "Premium 300a 4p 2rm",
            "Gt Performance Edition",
            "Premium 300a",
            "Cali Rte 1 200a"
          ]
        },
        {
          "model": "Police Interceptor Sedan",
          "series": [
            "Interceptor",
            "Police Prep Pkg/street Appear Police Prep/base",
            "Police Interceptor",
            "Police/police Prep Pkg/street Appear Base/street Appear Police Prep/street Appear Wiring Prep",
            "Street Appear/police Interceptor W/3.27 Axle (720a)/police Interceptor W/3.55 Ls Axle (730a)",
            "Interceptor Police Interceptor",
            " Interceptor",
            "Erceptor",
            "Police/police Prep Pkg/street Appear Base/street Appear Police Prep/str",
            " Prep Pkg",
            "R",
            "R Police Interceptor",
            " Appear W/3.27 Axle",
            " Appear/police Interceptor W/3.27 Axle (720a)/police Interceptor ",
            " Prep Pkg/street Appear Base/street Appear Police Prep/street App",
            "Or",
            " Police Interceptor",
            "Ase W",
            "Ursuit",
            "/3.27 Axle",
            "Base W/3.27 Axle/ngv Base W/3.27 Axle/police",
            "Base/base W/street Appear Pkg/pursuit/pursuit W/street Appear Pkg",
            "Police/police Interceptor"
          ]
        },
        {
          "model": "Police Interceptor Utility",
          "series": [
            "Police Interceptor"
          ]
        },
        {
          "model": "Police Responder Hybrid",
          "series": []
        },
        {
          "model": "Ranger",
          "series": [
            "Xl/xlt",
            "Xl",
            "Xlt/edge/xl",
            "Xlt/splash/xl",
            "Xlt/xlt Off-rd/xlt Off-rd W/391a/xlt Off-rd W/394a/edge/edge Plus/w/392a/w/393a",
            "Xlt",
            "Edge/tremor/xlt",
            "Edge/tremor/xl/xlt",
            "Fx4 Off-road/sport/xlt",
            "Edge/xl/xlt",
            "Super Cab",
            "Lariat",
            "Edge/xlt",
            "Xlt/xls/xl",
            "Sport/xl/xlt",
            "Sport/stx/xlt",
            "Splash/xlt",
            "Xlt/xl",
            "Xlt/edge",
            "Xlt/xlt App/xlt Appearance/edge/edge Plus/xl",
            "Xl/xlt/lariat",
            "Xlt/sport/xl",
            "Xlt/sport",
            "Xlt/tremor/edge",
            "Sport",
            "Splash/xl/xlt",
            "Sport/stx/xl/xlt",
            "Xl/xls/xlt",
            "Fx4 Off-road/sport/xl/xlt",
            "Fx4 Level Ii/fx4 Off-road/sport/xlt",
            "Edge/stx/xl/xls/xlt",
            "Stx/xl/xlt",
            "Xl/sport/xlt",
            "Edge/stx/xl/xlt",
            "Sport/xlt",
            "Xlt/tremor/edge/xl",
            "Xl (pickup Box Delete)",
            "Xlt/edge/stx",
            "Edge/edge Plus/w/392a/w/393a/xlt/xlt Off-rd",
            "Splash/stx/xl/xlt",
            "Xlt/stx/xl",
            "Edge",
            "Edge/tremor/xl/xlt/xlt Appearance",
            "Sport Supercab",
            "Edge/stx/xlt",
            "Xlt/fx4 Level Ii/fx4 Off-road/sport",
            "Unique Fleet",
            "Xlt/xlt Appearance/edge/xl",
            "Xl/xlt/xlt Appearance",
            "Xlt/stx/sport/xl",
            "Edge/fx4 Level Ii/fx4 Off-road/xlt",
            "Edge/xlt/xlt Appearance",
            "Xlt Appearance/tremor Plus/edge Plus",
            "Xlt Appearance/edge Plus",
            "Edge/edge Plus/w/392a/w/393a/xlt/xlt Off-rd/xlt Off-rd W/391a/xlt Off-rd W/394a",
            "Xlt/sport/fx4 Off-rd",
            "Xlt/stx/sport",
            "Edge/edge Plus/xlt/xlt Fx4/xlt Off-rd",
            "Edge/edge Plus/xl/xlt/xlt App/xlt Appearance",
            "Xlt/stx/edge",
            "Xlt Appearance",
            "Xlt/stx/xls/edge/xl",
            "Xlt/xlt Fx4/xlt Off-rd/edge/edge Plus",
            "Edge Plus",
            "Xlt/fx4 Off-road/sport/xl",
            "Edge Plus/tremor Plus/xlt Appearance",
            "Xlt/xlt Appearance/tremor/edge/xl",
            "Xl/xl Fleet/xlt",
            "Xlt/xlt Appearance/xl",
            "Edge/tremor Plus/xlt Appearance",
            "Supercab",
            "Edge/xl/xlt/xlt Appearance",
            "Raptor",
            "Fx4 Supercab",
            "Xl/xlt/edge",
            "Splash/stx/xlt",
            "Xlt Supercab",
            "Xlt/splash",
            "Edge/xlt/xlt Off-rd",
            "Sup",
            "Edge Supercab",
            "150",
            "Xl Supercab",
            "Lariat/xl/xlt",
            "Xl Fleet/w/392a/w/393a/xlt Off-rd W/391a/xlt Off-rd W/394a/xlt/xlt Off-rd/edge/edge Plus",
            "Fx4 Off-road",
            "Edge Plus/xlt Appearance",
            "Lt",
            "-Road/sport/xlt",
            "Xlt/stx",
            "Supercrew",
            "Xl/xlt/sport/fx4 Off-road",
            "Ext Sprcab",
            "Xlt/xlt Off-rd/edge",
            "L/xlt",
            "Edge/xlt Off/rd",
            "Xl/xlt/sport",
            "Xlt/sport/fx4 Off-road",
            "Xlt/stx/edge/xl",
            "Rt",
            "Stx/xlt/sport",
            "Xlt/fx4 Level Ii/fx4 Off-road/edge",
            "Xl/xls",
            "Ab",
            "Xlt/fx4 Off-road/sport",
            "Rt/fx4 Off-road",
            "Edge Plus/tremor/xlt Appearance",
            "Stx/xlt",
            "4x2 Rg",
            "Xlt Supercrew",
            "Xl Supercab 1 Super Cab",
            "Xl Xl",
            "Edge Deluxe/tremor Plus/xlt Appearance",
            "Xlt Supercrew Xlt",
            "Xl/",
            "Lar",
            "Rap",
            "4x4",
            "Spo",
            "Ther",
            "Xl Fleet",
            "Edge/tremor/xlt/xlt Fx4 Off-road",
            "Stx",
            "Xl/xlt/sport/fx4 Off-rd",
            "Edge/tremor Plus/xlt/xlt Fx4 Level Ii/xlt Fx4 Off-road",
            "Edge/xlt/xlt Fx4 Off-road",
            "Sup Sup",
            "Lariat Supercrew",
            "Edge/tremor/xl",
            "Splash",
            "Xl/xlt/splash",
            "Xlt Xlt",
            "Xlt/sport/fx4 Off-rd/fx4 Lvl Ii",
            "Sport Superca Fx4 Level Ii/fx4 Off-road/sport/xlt",
            "Edge/fx4 Level Ii/fx4 Off-road/xl/xlt",
            "Xl Fleet/xlt Appearance/edge Plus/tremor Plus",
            "Xlt Supercab Xlt",
            "Xl/xlt/xlt Appearance/xlt App/edge/edge Plus",
            "Bile Other",
            "Supercab (amalgamated)",
            "Xlt Supercab Super Cab",
            "Fx4 Level Ii/fx4 Off-road/sport/xl/xlt",
            "Xl Fleet/xlt/xlt Fx4 Off-road/xlt Fx4 Level Ii/edge/tremor Plus",
            "Xl/xlt/edge/stx",
            "Edg",
            "Pic",
            "Styleside Sup Super Cab",
            "Edge Plus Sup Edge/tremor/xlt",
            "Reg",
            "Xl Fleet/xlt/xlt Fx4 Off-road/xlt Fx4 Level Ii/edge/edge Plus"
          ]
        },
        {
          "model": "Special Service Police Sedan",
          "series": []
        },
        {
          "model": "SSV Plug-In Hybrid",
          "series": []
        },
        {
          "model": "Taurus",
          "series": [
            "Ses",
            "Sel",
            "Se",
            "Limited",
            "X Sel",
            "Sho",
            "Lx Standard",
            "X Eddie Bauer",
            "Ses Deluxe/ses Standard",
            "X Limited",
            "Se Standard",
            "Lx",
            "Ses/ses Standard",
            "Police Interceptor",
            "Gl",
            "Gl/se",
            "Se/se-Ne",
            "Lx/se",
            "L",
            "Se/comfort/sport",
            "Sel Deluxe",
            "Ses Standard",
            "Se Comfort",
            "Se/lx",
            "Se-Ne/se",
            "Police",
            "G",
            "Pol",
            "4 Door Sedan",
            "Lx/lx Standard",
            "Se/se Standard",
            "X",
            "Lim",
            "Ses Standard Fleet",
            "Ses Deluxe",
            "Se Deluxe/se Premium/se Standard",
            "Se Deluxe/se Premium",
            "Se-",
            "Int",
            "X E",
            "X S",
            "Sel Deluxe/sel Premium",
            "4d Se",
            "4d",
            "Sel/sho",
            "X L",
            "Taraus",
            "Ltd",
            "Interceptor",
            "R",
            " Sport",
            "Se/se Premium/se Standard",
            "Sho Awd Sho",
            "Se Se",
            "Lim Lim",
            "Sel Sel",
            "Sho Sho",
            "Mt5",
            "Er 1220 Hst",
            "Wag",
            "Wag Wag",
            "4d 4d",
            "Taurus",
            "Sel Fwd Sel",
            "Limited Fwd Limited",
            "Es",
            "Se Fwd Se",
            "Taur Wagon"
          ]
        },
        {
          "model": "Transit",
          "series": [
            "Connect Xl",
            "T-250",
            "T-350",
            "Connect Xlt",
            "Connect Titanium",
            "T-150",
            "Van",
            "T-350 Hd",
            "Connect Xlt Premium",
            "350 Wb 148 Xl",
            "T-",
            "Cargo Van",
            "Cargo Van T",
            "Co",
            "Van Passenger 3 Door",
            "Van Base W/sliding Pass-side Cargo Door",
            "250 Wb 148 Cargo Van",
            "Connect",
            "E E250 Van",
            "Passenger Wagon Xl/xlt",
            "Van T-350",
            "250",
            "Van T-250",
            "Co Transit T-",
            "Wagon Xl/xlt",
            "Wagon",
            "Passenger Wagon",
            "S Transit Connect E Xlt",
            "Cutaway",
            "Wagon T-350",
            "Cargo Van T-150",
            "Chassis Cab",
            "Wagon Xlt",
            "Cargo Van T-250",
            "Wagon T-150",
            "350 Xlt Van",
            "Passenger Xlt",
            "Chassis",
            "Van T-150",
            "250 Wb 148 El Cargo",
            "250 Wb 130 Cargo Van",
            "150 Wb 130 Xlt",
            "Passenger Wagon T-350",
            "Cargo Van T-350",
            " City",
            "Passenger Xl",
            "15",
            "Wagon Xl",
            "100.8 Roof",
            "Xlt",
            "T-250 Ambulance",
            "Passenger Wagon Xl",
            "Tradesman",
            "Crew Van",
            "Cargo Van Base W/sliding Pass-side Cargo-door",
            "Passenger",
            "Van Sel",
            "Co Transit",
            "Passenger Wagon Xlt",
            "Chassis T-350 Hd",
            "150 Wb 130 Cargo Van",
            "T -150",
            "Xl",
            "Transit",
            "Co Co",
            "Xl/xlt",
            "Va",
            "Co Xlt",
            "Ca",
            "150 Medium Roof",
            "350 Wb 148 Xlt El",
            "150 Wb 148 Cargo Van",
            "Trans",
            "350 Wb 130 Bev Cargo",
            "250 Van",
            "Delivery Van",
            "Ambulance",
            "It T-250",
            "350 Wb 148 Cargo Van",
            "350 Wb 148 Xlt",
            "It T-350 Hd",
            "C",
            "X Truck",
            "Co Xl",
            "Ercrew",
            "Van T-250 Hi",
            "Van T-250 Me"
          ]
        },
        {
          "model": "Transit Connect",
          "series": [
            "Xlt",
            "Xl",
            "Xl Passenger Wagon",
            "Xlt Premium",
            "Titanium",
            "Xlt Passenger",
            "Xl Cargo Van",
            "Titanium Passenger",
            "Xl Passenger",
            "Van Xl",
            "Van Xlt",
            "Xlt Cargo Van",
            "Xlt Passenger Wagon",
            "Wagon",
            "Wagon Xlt Premium",
            "Wagon Xl",
            "Van",
            "Wagon Xlt",
            "Crg Xl",
            "Titanium Passenger Wagon",
            "Wagon Titanium",
            "Cargo",
            "Xlt Xlt",
            "Wago Xlt",
            "Cargo (rear Windows) Xlt"
          ]
        },
        {
          "model": "Transit Courier",
          "series": []
        },
        {
          "model": "Transit Custom",
          "series": []
        },
        {
          "model": "Transit-150",
          "series": [
            "T-150",
            "Passenger Van Xl",
            "Xlt",
            "Xl",
            "Cargo Van",
            "Cargo",
            "Passenger Van T-150",
            "Passenger Van Xlt",
            "Cargo Van T-150",
            "O Van",
            "Crew Van"
          ]
        },
        {
          "model": "Transit-250",
          "series": [
            "T-250",
            "Cargo Van",
            "Cargo Van T-250",
            "Cab",
            "Cab T-250",
            "Cargo",
            "Cutaway",
            "Cutaway T-250",
            "Crew Van",
            "0",
            "Crew Van T-250",
            "Xl",
            "O Van"
          ]
        },
        {
          "model": "Transit-350",
          "series": [
            "Passenger Van Xlt",
            "Xlt",
            "Cutaway",
            "Xl",
            "Cab",
            "Passenger Van Xl",
            "Passenger Van Xl/xlt",
            "Cargo Van",
            "Cargo Van T-350 Hd",
            "T-350",
            "Cargo Van T-350",
            "Xl/xlt",
            "Cutaway T-350 Hd",
            "Cab T-350 Hd",
            "T-350 Hd",
            "Electric",
            "Cargo",
            "Passenger Van",
            "Passenger Van T-350",
            "Cutaway T-350",
            "Passenger Xl",
            "Passenger Xlt",
            "N Xl/xlt",
            "O Van",
            "Cab T-350",
            "Cutaway*hold?",
            "Motor Home",
            "Cab Chassis",
            "Crew Van"
          ]
        },
        {
          "model": "Transit-350 HD",
          "series": []
        },
        {
          "model": "SHELBY",
          "series": [
            "Gt350",
            "Gt500",
            "Gt",
            "Gt500 Shelby Gt500",
            "Gt350 Shelby Gt350",
            " Shelby Gt500",
            "Gt350 Shelby",
            "F-250",
            "Cobra"
          ]
        }
      ]
    },
    {
      "make": "GMC",
      "models": [
        {
          "model": "Acadia",
          "series": [
            "Sle-2",
            "Sle",
            "Slt-1",
            "Sl",
            "Fwd Slt",
            "Fwd Sle",
            "Fwd Denali",
            "Denali",
            "Slt-2",
            "All Terrain",
            "Slt",
            "At4",
            "Awd Sle",
            "Sle-1",
            "Awd Slt",
            "Limited Slt-2",
            "Awd Denali",
            "Awd At4",
            "Slt1",
            "Slt2",
            " Tr6",
            "Sle1",
            "Fwd Elevation",
            "Uplevel",
            "K3500 Denali",
            "4d",
            "4d Slt1",
            "4d Denali",
            "4d Sle1",
            "Sle2 Awd Sle",
            "Den",
            "Lim",
            "All",
            "Sle2",
            "Slt1/slt2",
            "Slt-1/slt-2",
            "Sle Awd Sle",
            "Slt Slt",
            "Upl",
            "Slt Fwd Slt",
            "K1500 Sl",
            "Denali Fwd Denali",
            "Sle Sle",
            "At4 At4",
            "Awd Elevation",
            "Ls",
            "Slt1 Fwd Slt-1",
            "Sle2 Fwd Sle-2",
            "Awd 4d Suv Elevation",
            "Slt1 Slt-1",
            "Elevation",
            "Fwd 4d Suv Elevation",
            "Ele",
            "Uti",
            "All All",
            "Lim Lim",
            "Slt1 Awd Slt-1",
            "Elevation Fwd Uplevel"
          ]
        },
        {
          "model": "Acadia Limited",
          "series": [
            "Limited",
            "Slt-2"
          ]
        },
        {
          "model": "Canyon",
          "series": [
            "Sle",
            "Slt",
            "2wd Short Box Denali",
            "Elevation",
            "Sl",
            "2wd Short Box Elevation Standard",
            "4wd Short Box Elevation",
            "At4",
            "Denali",
            "Sle1",
            "4wd Short Box Denali",
            "Value Package",
            "4wd Long Box Denali",
            "Sle2",
            "4wd Short Box At4 - Cloth",
            "Work Truck",
            "4wd Short Box At4",
            "All Terrain W/cloth",
            "At4x",
            "Sle Crew Cab",
            "2wd Short Box Elevation",
            "4wd Short Box Sle",
            "All Terrain",
            "4wd Short Box At4x",
            "4wd Short Box At4 - Leather",
            "2wd Elevation",
            "4wd Long Box At4 - Leather",
            "2wd Sle",
            "4wd Elevation",
            "All Terrain W/leather/slt",
            "Fleet",
            "2wd Short Box Sle",
            "4wd Short Box All Terrain - Leather",
            "Sle-2",
            "2wd Elevation Standard",
            "4wd Elevation Standard",
            "Sle1/sle2/slt",
            "4wd Long Box Denali/4wd Short Box Denali",
            "4wd Short Box Slt",
            "4wd At4",
            "4wd Long Box At4 - Cloth/4wd Long Box At4 - Leather/4wd Short Box At4 - Cloth",
            "2wd Short Box",
            "Sl Ext Cab",
            "Yc1",
            "Sle Ext Cab",
            "2wd  Elevation Standard",
            "2wd  Short Box Elevation",
            "All Terrain W/leather",
            "All Terrain W/cloth/all Terrain W/leather",
            "4wd  Short Box Denali",
            "2wd  Short Box Elevation Standard",
            "4wd Denali",
            "4wd Long Box Elevation",
            "4wd  Short Box Elevation",
            "2wd  Short Box Denali",
            "4wd  Short Box Slt",
            "4wd  Short Box At4",
            "4wd  Short Box At4 - Leather",
            "4wd  Long Box Elevation",
            "2wd  Short Box",
            "4wd Sle",
            "4wd Long Box Slt",
            "4wd  Elevation Standard",
            "2wd  Short Box Sle",
            "Sl Z85",
            "Sle/slt",
            "Sle1/sle2/slt/work Truck",
            "4wd  Short Box At4 - Cloth",
            "4wd  Sle",
            "4wd  Short Box All Terrain - Leather",
            "All Terrain W/cloth/sle",
            "Sle1/value Package/work Truck",
            "4wd  Short Box Sle",
            "Fleet Z85",
            "4wd At4x",
            "4wd  Short Box At4 -",
            "2wd  Canyon",
            "4wd  Short Box All Terrain - Cloth",
            "4wd  Elevation",
            "4wd  Long Box At4 - Leather",
            "Den",
            "4wd Slt",
            "Work Truck/sle1/sle2/slt",
            "4wd All Terrain W/cloth",
            "2wd",
            "4wd All Terrain W/leather",
            "4wd",
            "Sle W/1sd",
            "2wd Slt",
            "2wd Denali",
            "4wd At4 W/leather",
            "4wd At4 W/cloth",
            "All",
            "3vl",
            "2wd Sl",
            "2wd  Sle",
            "4wd  Long Box At4 - Cloth",
            "Sle1/sle2",
            "4wd  Long Box Denali",
            "4wd  Canyon",
            "4wd  Short Box At4x",
            "2wd  Short Box Slt",
            "Sl Z85/sle Z85",
            "4wd  Long Box At4 - Cloth/4wd  Long Box At4 - Leather/4",
            "Ele",
            "Sle3",
            "Sl Z71",
            "4wd Crew Cab Short Box Denali",
            "Denali Crew Cab",
            "1sf Sle Z71",
            "1sc Sle Z85",
            "Sle Z85",
            "Work Truck/sle1",
            "1sb Sle Z85",
            "4wd All Terrain",
            "1se Sle Z71",
            "Sle Z71",
            "1sa",
            "Sle2/slt",
            "4wd  Long Box Denali/4wd  Short Box Denali",
            "4wd Long Box At4 - Cloth",
            "Slt Slt",
            "Sle Sle",
            "Crew Cab",
            "Ele Ele",
            "At4 At4",
            "Slt Crew Cab",
            "4wd Long Box All Terrain - Leather",
            "4wd Short Box All Terrain - Cloth",
            "1sf Sle Z71/sle",
            "All All",
            "At4 Crew Cab",
            "4wd Canyon",
            "Commercial Special/sl/sle",
            "4wd  Long Box All Terrain - Leather",
            "Sl/sle",
            "All Terrain Crew Cab",
            "4wd Long Box Elevation/4wd Short Box Elevation",
            "All Terrain W/cloth/all Terrain W/leather/denali",
            "4wd At4 W/cloth/at4 W/cloth/at4 W/leather",
            "4wd  Long Box Elevation/4wd  Short Box Elevation",
            "At4 W/cloth/at4 W/leather",
            "Crw",
            "4wd All Terrain W/leather/all Terrain W/cloth/all Terrain W/leather",
            "4wd All Terrain W/leather/all Terrain W/cloth/all Terra",
            "Elevation Crew Cab",
            "4wd Long Box All Terrain - Cloth/4wd Long Box All Terrain - Leather/4wd Long Box Denali"
          ]
        },
        {
          "model": "Hummer EV",
          "series": [
            "Suv 3x",
            "Pickup Edition 1",
            "Pickup 3x",
            "Suv 2x",
            "Pickup",
            "Pickup 2x",
            "Pickup E4wd 2x",
            "Pickup E4wd 3x"
          ]
        },
        {
          "model": "Savana",
          "series": [
            "G1500",
            "Cutaway Work Van",
            "Work Van",
            "Cargo Van Standard",
            "G2500",
            "G3500",
            "Rv G1500 3lt",
            "Cutaway Standard",
            "Upfitter",
            "Cutaway G3500",
            "Cutaway Standard W/c7l/c7n",
            "Cutaway G4500",
            "Cargo Van",
            "Standard",
            "Cutaway 4500 Van",
            "Cargo Rwd 2500 Extended Wheelbase Work Van",
            "Xpress G2500",
            "Cargo Rwd 2500 Regular Wheelbase Work Van",
            "Rv G1500",
            "G1500 Lt",
            "Rv G2500",
            "Slt",
            "Ls",
            "Special Base W/c7a",
            "G2500 Ls",
            "Cutaway E23",
            "Passenger Rwd 3500 Extended Wheelbase Ls",
            "Cargo Rwd 3500 Extended Wheelbase Lt",
            "Cutaway Cutaway G3500",
            "Special",
            "Cargo Van G3500 Standard",
            "Cutaway 3500",
            "Cutaway Standard W/c7a",
            "Cutaway 4500 Series",
            "Cutaway C7l",
            "Special Base W/c7l",
            "Cargo Van Yf7 Upfitter",
            "Rv",
            "Rv G3500",
            "Yf7",
            "Cutaway",
            "Cutaway Standard/standard W/c7l/c7n",
            "Commercial",
            "G3500 Lt",
            "G2500 Lt",
            "Rv G2500 3lt",
            "Commercial Cutaway",
            "Standard/upfitter",
            "G1500 Luxury",
            "G3500 Paratransit",
            "G2500 Ext Length 3 Dr Cargo Van",
            "G35",
            "Cargo G2500",
            "Box Truck",
            "Passenger",
            "Cutaway C6y/c7l Drw",
            "Cargo Rwd 3500 Regular Wheelbase Work Van",
            "G3500 Ls",
            "G3500 Box Truck",
            "G1500 Ls",
            "Cargo Van Work Van",
            "Standard/yf7",
            "Rv G1500 4lt",
            "Cargo 3500",
            "2500",
            "Commercial Cutaway 4500 2wt",
            "Cutaway 4500 4500 Van",
            "Cargo Rwd 3500 Regular",
            "Cargo",
            "Commercial Cutaway Work Van",
            "Cargo Van G3500",
            "Cargo Van G1500",
            "Cut",
            "Commercial Cutaway 3500",
            "G25",
            "G15",
            "Cargo Van G2500",
            "Cargo Van +",
            "Passenger 1ls",
            "Passenger 1lt",
            "Cargo Van Upfitter",
            "Passenger Ls",
            "Passenger Lt",
            "Commercial Cutaway Diesel",
            "Commercial Cutaway 3500 Diesel",
            "Cutaway 4500",
            "Cuttaway",
            "Passenger Rwd 2500 Regular Wheelbase Ls",
            "Cargo Rwd 3500 Extended Wheelbase Ls",
            "Passenger Sle",
            "Cutaway 4500 Cutaway G4500",
            "Cargo Van Y3h Paratransit",
            "Yf7 Upfitter",
            "H",
            "Van",
            "Savan2500",
            "Cargo Van Diesel",
            "3500",
            "500 3500",
            "Passenger G2500 Lt",
            "Passenger G3500 Lt",
            "Passenger G3500 Ls",
            "Special Standard",
            "Commercial Cutaway 4500 Van",
            "Rwd 2500 Extended Wheelbase Work Van",
            "G25 G25",
            "Rwd 2500 Regular Wheelbase Work Van",
            "Rwd 3500 Regular Wheelbase Work Van",
            "Cargo Rwd 3500 Extended Wheelbase Work Van",
            "Cube",
            "G2500 Paratransit",
            "Cargo 1500 13 Rv",
            "Standard W/c7a",
            "Cut Cut",
            "Passenger Rwd 2500 Regular Wheelbase Lt",
            "Standard W/c7l/c7n",
            "Diesel",
            "Cutaway*ors",
            "Ve Premium",
            "G4500 Cutaway",
            "G4500 Cut Delivery Van",
            "Lt",
            "Cutaway 3500 1wt",
            "Cargo 1500 13 Upfitter",
            "Delivery Truck",
            "250",
            "Rwd 3500 Extended Wheelbase Work Van",
            "Cutaway 4500 Diesel",
            "G3500 G3500",
            "Refrigerated Truck",
            "500",
            "Sl/sle",
            "Rwd 2500 Regular Wheelbase Lt",
            "G3500 Cutaway",
            "Rv G1500 Rv G1500",
            "G4500 Delivery Van",
            "Cargo 3500 15"
          ]
        },
        {
          "model": "Savana 1500",
          "series": [
            "Work Van",
            "Lt",
            "Upfitter",
            "G1500",
            "Ls",
            "Sle",
            "Cargo Van"
          ]
        },
        {
          "model": "Savana 2500",
          "series": [
            "Work Van",
            "Upfitter",
            "Ls",
            "Lt",
            "Cargo Van",
            "G2500",
            "Ext Crg",
            "Cargo Van Ext",
            "1wt",
            "Standard",
            "Sl"
          ]
        },
        {
          "model": "Savana 3500",
          "series": [
            "Diesel",
            "Work Van",
            "Lt",
            "Ls",
            "Ext",
            "Cutaway G3500",
            "Cargo Van Ext",
            "3500",
            "Van G3500",
            "Cargo Van",
            "Duracube Work Van",
            "Standard",
            "Ls Ext",
            "Sl",
            "Sl Ext"
          ]
        },
        {
          "model": "Savana 4500",
          "series": [
            "Cutaway G4500"
          ]
        },
        {
          "model": "Sierra",
          "series": [
            "2500hd Sle2",
            "K1500 Sle",
            "2500hd Slt",
            "C1500",
            "K1500 Slt",
            "K3500 Denali",
            "Rra K1500",
            "Rra C1500",
            "2500hd Denali",
            "K2500 Sle",
            "K2500 Denali",
            "C2500 Heavy Duty",
            "K2500 Heavy Duty",
            "K1500",
            "K1500 At4",
            "C1500 Sle",
            "K1500 Denali",
            "2500hd Sle1",
            "K3500 Sle",
            "2500hd 4wd Standard Bed Denali",
            "Rra K3500",
            "2500hd Sle",
            "K2500 Slt",
            "2500hd Work Truck",
            "2500hd Sle/work Truck/slt",
            "2500 Classic Sl",
            "Rra K1500 Classic",
            "K3500",
            "C2500",
            "3500 Slt",
            "K2500",
            "C1500 Slt",
            "2500hd",
            "Limited C1500 Sle",
            "Limited K1500",
            "2500hd Sle/slt/work Truck",
            "Limited K1500 Elevation",
            "C1500 Denali",
            "K2500 At4",
            "K1500 Elevation",
            "Limited K1500 Denali",
            "Lim",
            "2500hd Available Wifi Denali",
            "2500hd Sl/sle1/sle2/slt/work Truck",
            "C1500 Heavy Duty",
            "K1500 At4x",
            "3500hd",
            "3500hd 4wd Regular Cab Long Bed Pro",
            "2500 Sl/sle",
            "C1500 Elevation",
            "2500hd 4wd Standard Bed Sle",
            "3500hd 4wd Standard Bed At4",
            "C1500 Sl",
            "2500hd Sle/sl",
            "2500hd Sle/slt",
            "3500hd 4wd Regular Cab Long Bed Sierra",
            "2500hd K2500 Heavy Duty",
            "3500hd Chassis Work Truck",
            "3500hd Sle",
            "2500hd 4wd Standard Bed At4",
            "3500hd Chassis",
            "3500hd Denali",
            "3500hd Work Truck",
            "2500hd 4wd Long Bed Pro",
            "3500 Sle",
            "2500hd Sl",
            "K2500 Denali Ultimate",
            "1500hd Sle1",
            "Rra C1500 Classic",
            "Rra C3500",
            "Limited K1500 Sle",
            "Limited K1500 Slt",
            "C3500",
            "2500hd 4wd Standard Bed Sierra Pro",
            "2500hd 4wd Standard Bed Pro",
            "2500hd 4wd Long Bed",
            "3500 Chassis Work Truck",
            "3500hd 4wd Long Bed Denali",
            "3500hd Slt",
            "K1500 Elevation-l",
            "K3500 At4",
            "Limited K1500 At4",
            "K25",
            "Limited C1500",
            "3500 Classic Sle1",
            "C3500 Sle",
            "K1500 Heavy Duty",
            "3500",
            "C2500 Sle",
            "K1500 Denali Ultimate",
            "2500hd 4wd Double Cab Standard Bed Pro",
            "1500",
            "K3500 Slt",
            "K15",
            "K1500 Sl",
            "2500hd Sle1/sle2/slt/work Truck",
            "Ilverado K1500",
            "K1500 Hybrid",
            "2500 Slt",
            "Rra Denali",
            "Rra K1500 Denali",
            "2500hd 4wd Long Bed Sierra",
            "C3500 Heavy Duty",
            "K3500 Denali Ultimate",
            "2500hd 4wd Double Cab Long Bed",
            "Limited C1500 Slt",
            "1500hd Sle",
            "C2500 Denali",
            "2500hd C2500 Heavy Duty",
            "2500hd K2500 Denali",
            "2500hd K2500 At4",
            "2500hd 4wd Standard Bed Slt",
            "2500hd Classic Slt",
            "K1500 C3",
            "Rra K2500",
            "K1500 Classic Hd",
            "2500hd K2500 Slt",
            "3500 Classic Sl",
            "2500hd Classic K2500 Heavy Duty",
            "2500hd K2500 Sle",
            "2500hd Classic Sle2",
            "C1500/c1500 Sl",
            "3500hd C3500",
            "Rra C1500 Denali",
            "Rra C2500",
            "2500 Sl",
            "3500hd K3500 Slt",
            "3500hd 4wd Regular Cab Long Bed Sle",
            "2500hd Classic Work Truck",
            "K2500 Crew Cab",
            "1500hd Slt",
            "2500hd 4wd Long Bed Denali/4wd Standard Bed Denali",
            "3500hd Chassis Pro",
            "2500hd 4wd Long Bed Sle/4wd Standard Bed Sle",
            "3500hd 4wd Long Bed Denali Ultimate",
            "3500hd 4wd Long Bed Pro",
            "3500hd 4wd Long Bed Sle",
            "2500hd 4wd Standard Bed Denali Ultimate",
            "3500hd 4wd Standard Bed Denali",
            "3500 Chassis Classic Work Truck",
            "2500 Standard",
            "2500hd 4wd Regular Cab Long Bed Sle",
            "2500hd Classic",
            "C3500 Hd Sl",
            "2500hd 4wd Standard Bed Denali/4wd Long Bed Denali",
            "2500 Sle",
            "3500 Sle2",
            "3500hd 4wd Long Bed",
            "2500hd Classic Sl/sle1/sle2/slt/work Truck",
            "2500hd 4wd Standard Bed Sierra",
            "2500hd Sl/sle/standard",
            "2500hd Work Truck/sle1/sl",
            "2500hd 4wd Standard Bed",
            "2500hd Sl/sle",
            "3500 Chassis Sle1",
            "2500hd Pro",
            "3500 Sl/sle/slt",
            "K2500 Hd",
            "3500hd Sle1",
            "3500hd Pro",
            "3500hd 4wd Long Bed Sle/4wd Standard Bed Sle",
            "3500 Chassis",
            "1500 Nevada Edition",
            "3500 Sle1",
            "3500 Classic",
            "Classic 3500",
            "2500hd K2500 Denali Ultimate",
            "Den",
            "2500hd 2wd Regular Cab Long Bed",
            "3500 Sle Crew Cab",
            "3500hd 4wd Long Bed Denali/4wd Standard Bed Denali",
            "2500 C2500",
            "Limited C1500 Elevation",
            "Limited K1500 Elevation-l",
            "K35",
            "C1500 Hybrid",
            "2500 Work Truck",
            "2500hd 4wd Double Cab Standard Bed Sle",
            "C3500 Slt",
            "C15",
            "2500hd 4wd  Standard Bed Denali",
            "K2500 At4x",
            "3500hd Chassis K3500",
            "3500hd 4wd Standard Bed Slt",
            "2500hd 4wd Long Bed Sle",
            "3500hd K3500 Denali",
            " Intl (bci) Cr-v Ex Aw",
            "Mt-400 K1500",
            "2500 Chassis Sl",
            "Limited C1500 Denali",
            "2500hd 2wd Double Cab Long Bed Pro",
            "2500hd Classic Sle1",
            "1500hd Sle/slt",
            "2500hd 4wd Double Cab Long Bed Sle/4wd Double Cab Standard Bed Sle",
            "2500 K2500",
            "2500hd 4wd  Long Bed Pro",
            "1500 Sle",
            "3500hd Denali Ultimate",
            "2500hd 4wd Long Bed Denali",
            "2500hd 4wd Long Bed At4/4wd Standard Bed At4",
            "3500hd 4wd  Standard Bed At4",
            "Ra",
            "Ilverado K2500 Heavy Duty",
            "2500hd 4wd  Standard Bed At4",
            "3500hd 4wd  Long Bed Denali",
            "3500hd 4wd  Standard Bed Slt",
            "2500hd 4wd  Standard Bed Pro",
            "2500hd 4wd  Long Bed Sle",
            "1500hd Classic Sle1",
            "2500hd 4wd  Long Bed",
            "3500hd 4wd  Standard Bed Denali",
            "2500hd Sle/work Truck",
            "3500 Slt Crew Cab",
            "2500hd 2wd Regular Cab Long Bed Pro",
            "Parts Only",
            "3500 Sl",
            "3500 Work Truck",
            "3500hd K3500 Sle",
            "3500hd At4",
            "3500hd 4wd Standard Bed Denali Ultimate",
            "2500hd 4wd Standard Bed At4x",
            "3500hd 4wd Long Bed Slt",
            "2500",
            "2500 Ext Cab",
            "Rra",
            "2500hd 4wd Long Bed At4",
            "2500hd 4wd  Standard Bed Slt",
            "C2500 Crew Cab",
            "3500 Chassis Sle",
            "2500hd 4wd Double Cab Standard Bed",
            "3500hd Chassis Sle",
            "3500hd K3500",
            "2500 Sl/sle/slt",
            "3500 Classic Slt",
            "500",
            "3500hd 4wd  Long Bed Pro",
            "Bed",
            "2500hd 4wd Regular Cab Long Bed",
            "2500hd 2wd Long Bed",
            "1500hd",
            "3500hd Srw Sle1",
            "3500hd Drw Sle2",
            "2500 Sle Ext Cab",
            "2500hd 4wd Long Bed Slt/4wd Standard Bed Slt",
            "2500hd At4",
            "3500 Chassis Classic K3500",
            "C2500 Slt",
            "3500 Chassis Classic C3500",
            "2500 Sle Crew Cab",
            "3500 C3500",
            "3500hd Sle2",
            "3500 Chassis Sle/work Truck",
            "3500 Chassis Classic Sle1",
            "2500hd 4wd  Standard Bed",
            "2500hd 4wd  Long Bed At4/4wd  Standard Bed At4",
            "1500hd K1500 Heavy Duty",
            "3500 Chassis K3500",
            "2500hd 4wd Long Bed Denali Ultimate/4wd Standard Bed Denali Ultimate",
            "3500hd K3500 Denali Ultimate",
            "6000 Grain Truck",
            "2500hd Standard",
            "3500 K3500",
            "3500 Crew Cab K2500 Slt",
            "3500 K3500 Sle",
            "250",
            "C1500 C1500 Slt",
            "Siera",
            "2500 K1500 Sle",
            "2500hd Denali Ultimate",
            "3500 K3500 Denali",
            "3500hd Drw Sle1",
            "1500hd Sle2",
            "3500hd Srw Work Truck/work Truck",
            "3500hd Srw Sle/sle",
            "2500 Crew Cab",
            "Classic 1500",
            "2500 Crew Cab K2500 Denali",
            "2500hd Classic Sl",
            "2500hd K3500 Denali",
            "3500 Classic Work Truck/sle1/sle2/slt/sl",
            "2500hd 4wd  Long Bed Denali",
            "3500hd 4wd  Long Bed Sierra Pro",
            "C 1500 K1500 Slt",
            "3500 Chassis K3500 Sle",
            "2500hd Sle/standard/sl",
            "2500hd 4wd  Standard Bed Sle",
            "3500hd Slt/srw Slt",
            "C25",
            "Limited",
            "Denali",
            "K1500 Elevati",
            "3500hd Wt",
            "2500hd Work Truck/sle",
            "3500hd Srw Sle",
            "3500hd Drw Denali",
            "150",
            "3500hd Srw Work Truck",
            "3500hd Sle/srw Sle",
            "New",
            "15",
            "Truck Bed",
            "3500hd Srw Denali",
            "C35",
            "2500hd Work Truck/sle1/sle2/slt",
            "3500hd Srw Slt",
            "Siera15002",
            "Sle",
            "3500hd Drw Slt",
            "2500hd 4wd  Standard Bed Denali Ultimate",
            "2500hd 4wd Regular Cab Long Bed Sierra Pro",
            "2500hd 2wd Double Cab Long Bed Sierra Pro",
            "3500hd 4wd  Long Bed Sle",
            "2500hd 4wd Double Cab Long Bed Sle",
            "2500 Sl/sle/standard",
            "3500hd Chassis C3500",
            "4x4",
            "3500hd 4wd  Long Bed Slt",
            "1500hd Classic Sle1/sle2/slt",
            "3500hd K3500 At4",
            "Work Truck",
            "2500hd 2wd  Standard Bed Slt",
            "3500hd 2wd Double Cab Long Bed Pro",
            "2500hd 2wd  Long Bed Sierra",
            "2500hd 4wd  Long Bed Sle/4wd  Standard Bed Sle",
            "3500hd 4wd Long Bed At4",
            "3500hd Drw Work Truck",
            "3500hd Drw Sle",
            "2500hd 4wd  Long Bed Denali/4wd  Standard Bed Denali",
            "2500hd 4wd  Long Bed At4",
            "500 2500",
            "C1500 5.3 Litre At",
            "Z71 Pickup",
            "C1500 Classic Hd",
            "3500 Denali",
            "Hd2500 Heavy Duty",
            "K1500 Denali Classic",
            "Sierra",
            "2500hd Wt/sle/slt",
            "00 2500hd",
            "C15 C15",
            "Sle Sle",
            "K15 K15",
            "150 150",
            "4x4 4x4",
            "3500 Denali Crew Cab",
            "Slt",
            "C2500 Hd",
            "2500 C2500 Heavy Duty",
            "Sel",
            "Denali 1500 K1500 Denali",
            "Siera15004",
            "2500hd Work",
            "Denali K1500 Denali",
            "2500 K2500 Heavy Duty",
            "2500hd C2500 Sle",
            "Limited/sel/sport/ultimat",
            "K1500/k1500 Sl",
            "K1500 Sle 4 D",
            "4wd Short Box Sle",
            "4wd  Short Box",
            "Sle/slt/work Truck",
            "3500hd 4wd  Long Bed",
            "3500hd 4wd  Long Bed Denali/4wd  Standard Bed Denali",
            "4wd Long Bed Denali",
            "2500hd 4wd  Standard Bed At4x",
            "3500 Chassis Sl/sle/standard",
            "3500 Chassis C3500",
            "Sl Wideside/sle Sportside",
            "2500hd 4wd Long Bed Denali Ultimate",
            "4wd Short Box Elevation With 3sb",
            "2500hd 2wd Long Bed Pro",
            "2wd  Standard Box Pro",
            "4wd Short Box Pro",
            "4wd Double Cab Standard Box Elevation",
            "4wd Short Box Slt",
            "Sle1",
            "4wd Standard Bed At4",
            "4wd Standard Bed Denali",
            "Classic Sl",
            "4wd Short Box",
            "Pro",
            "4wd Short Box Sle/4wd Standard Box Sle",
            "At4",
            "Limited 4wd Short Box At4",
            "2wd Short Box Elevation",
            "4wd Standard Box Pro",
            "Sl",
            "K25 K25",
            "C25 C25",
            "4wd Short Box Denali Ultimate",
            "2wd Standard Box Pro",
            "Sle2",
            "3500 Chassis Classic Sl",
            "3500hd 4wd  Long Bed At4",
            "Elevation",
            "4wd  Standard Box Pro",
            "4wd Long Bed",
            "4wd Short Box Elevation With 3sb/4wd Short Box Elevation With 3vl/4wd Standard Box Elevation",
            "3500 Wt Ext Cab",
            "3ha/3hb",
            "4wd Long Bed Denali Ultimate",
            "4wd Long Box",
            "2500hd 2wd  Long Bed",
            "Sl Wideside",
            "4wd Standard Box Slt",
            "3500 Chassis Sl",
            "2wd Short Box Slt",
            "Limited 4wd Short Box At4/4wd Standard Box At4",
            "2wd  Short Box Slt",
            "4wd Standard Box Elevation",
            "Sle1/sle2/slt/work Truck",
            "4wd  Long Box",
            "2500 Chassis Classic Sl",
            "4wd  Long Bed Denali",
            "C35 C35",
            "4wd Standard Box Denali",
            "Lim Lim",
            "K35 K35",
            "2500hd 4wd  Long Bed Denali Ultimate/4wd  Standard Bed Denali",
            "2500hd 2wd  Long Bed Pro",
            "4wd Standard Box At4",
            "2wd Long Bed",
            "Denali Ultimate",
            "3500hd*direct Disposal*",
            "4wd Long Bed Slt",
            "2wd  Short Box Elevation",
            "Limited 2wd Short Box Elevation",
            "Limited 4wd Short Box Denali",
            "4wd Standard Bed Sle",
            "4wd Short Box At4",
            "4wd  Short Box Slt",
            "4wd  Standard Bed At4",
            "2500hd 4wd  Long Bed Slt/4wd  Standard Bed Slt",
            "4wd Long Bed Pro",
            "Sl/sle/standard",
            "4wd Short Box Elevation With 3vl",
            "2500hd 2wd Standard Bed Slt",
            "Ilverado C2500",
            "Gra",
            "4wd Short Box Denali",
            "4wd Double Cab Standard Box Elevation With 3sb",
            "4wd  Long Bed",
            "4wd Standard Bed Denali Ultimate",
            "C3500 Denali",
            "4wd  Short Box Elevation With 3sb",
            "4wd  Standard Bed Denali",
            "Limited 4wd  Short Box Denali",
            "Limited 4wd  Short Box At4",
            "4wd Short Box At4x",
            "4wd Short Box At4/4wd Standard Box At4",
            "3500 Classic Sl/sle1/sle2/slt/work Truck",
            "2wd  Long Bed",
            "2wd Short Box Denali",
            "4wd  Standard Box Elevation",
            "4wd  Short Box Denali",
            "Limited 4wd  Short Box At4/4wd  Standard Box At4",
            "4wd  Standard Box Slt",
            "4wd  Short Box Sle",
            "4wd Short Box Elevation",
            "Ev Max Range Denali",
            "4wd Standard Bed Pro",
            "2500hd Sl/sle/slt",
            "2500hd 4wd Double Cab Standard Bed Slt",
            "Limited 4wd Short Box Slt",
            "2500hd 4wd Double Cab Long Bed Pro",
            "4wd  Standard Box Denali",
            "4wd  Short Box At4",
            "2wd Short Box Sle",
            "2wd Double Cab Standard Box",
            "4wd  Standard Bed Sle",
            "2500hd Sle/slt/wt",
            "Limited 2wd Short Box Sle",
            "2500hd 2wd Standard Bed Sle",
            "4wd  Standard Box At4",
            "4wd Long Bed/4wd Standard Bed",
            "4wd  Short Box At4x",
            "4wd  Short Box Pro",
            "Limited 2wd  Short Box Elevation",
            "3500 All-new Sle/slt/wt",
            "3500 Sle/slt/work Truck",
            "4wd Double Cab Standard Box",
            "4wd  Standard Bed Denali Ultimate",
            "4wd Standard Bed At4x",
            "4wd  Short Box Elevation",
            "4wd  Short Box At4/4wd  Standard Box At4",
            "4wd Standard Bed Slt",
            "4wd  Long Bed Pro",
            "4wd  Standard Bed Pro",
            "3500 Crew Cab",
            "2500hd Ext. Cab Pickup Truck",
            "1500 Pickup Truck",
            "Esis 3.8l",
            "2500hd Wt",
            "4wd  Short Box Elevation With 3vl",
            "4wd Short Box Denali/4wd Standard Box Denali",
            "3500hd Utility / Service Truck",
            "2500hd 2wd  Standard Bed Sle",
            "Limited 2wd  Short Box Sle",
            "2wd  Short Box Denali",
            "2wd Double Cab Standard Box Elevation",
            "Ahoe K1500",
            "4wd Standard Bed",
            "4wd Short Box Elevation/4wd Standard Box Elevation",
            "Limited Sle",
            "2500hd 4wd Double Cab Long Bed Slt",
            "2wd Long Box",
            "3500 Drw Sle",
            "4wd Double Cab Long Bed",
            "Ev Denali Edition 1",
            "4wd Double Cab Standard Box Sle",
            "1lt",
            "4wd Long Bed Sle/4wd Standard Bed Sle",
            "2wd  Short Box Sle",
            "4wd  Short Box Denali Ultimate",
            "2500hd All-new Sle/slt/wt",
            "4wd  Short Box Denali/4wd  Standard Box Denali",
            "Limited 4wd  Short Box Slt",
            "4wd Long Bed Sle",
            "K2500hd Denali",
            "Shelby Kr",
            "4wd  Standard Bed At4x",
            "4wd  Standard Bed Slt",
            "3500 Sle Ext Cab",
            "4wd  Long Bed Denali Ultimate",
            "1500hd Denali",
            "Sl/sle1/sle2/slt/work Truck",
            "4wd Long Bed At4",
            "4wd  Long Bed Sle",
            "4wd Short Box Elevation With 3sb/4wd Standard Box Elevation",
            "4wd  Short Box Elevation With 3sb/4wd  Standard Box Ele",
            "2500hd 4wd Long Bed Slt",
            "3500 Chassis Standard",
            "2500hd 2wd Regular Cab Long Bed Sierra",
            "2500hd At4x",
            "Sl/sle",
            "Limited 4wd Long Box Pro",
            "4wd Double Cab Standard Box Pro",
            "2500hd 2wd Standard Bed Pro",
            "4wd Long Bed Slt/4wd Standard Bed Slt",
            "3500 Classic Work Truck",
            "3500 Sl Ext Cab",
            "4wd  Standard Bed",
            "2500hd All-new Sle/wt",
            "3500 Pickup",
            "4wd Short Box Slt/4wd Standard Box Slt",
            "2500 4wd/4x4"
          ]
        },
        {
          "model": "Sierra 1500",
          "series": [
            "Slt",
            "4wd Short Box Sle/4wd Standard Box Sle",
            "Sle",
            "4wd Short Box At4",
            "Sl",
            "Denali",
            "2wd Short Box Slt",
            "4wd Short Box Slt",
            "At4",
            "Work Truck",
            "Sle1",
            "4wd Double Cab Standard Box Elevation",
            "4wd Short Box Pro",
            "Classic Sl",
            "4wd Short Box At4/4wd Standard Box At4",
            "Sl Wideside",
            "Work Truck/sle1/sle2/slt",
            "4wd Short Box Sle",
            "Work Truck/sle1",
            "Classic Sle1",
            "4wd Short Box Elevation/4wd Standard Box Elevation",
            "4wd Standard Box Denali",
            "Sle2",
            "4wd Regular Cab Long Box Pro",
            "2wd Short Box Denali",
            "C1500",
            "C1500 Slt",
            "K1500",
            "4wd Short Box Denali",
            "4wd Double Cab Standard Box Sle",
            "4wd Short Box Elevation With 3sb",
            "4wd Standard Box",
            "4wd Short Box Denali Ultimate",
            "Standard",
            "Special",
            "2wd Short Box Elevation",
            "4wd Double Cab Standard Box Elevation With 3vl",
            "4wd Short Box Elevation With 3vl",
            "Ext Cab",
            "Slt Crew Cab",
            "Classic Slt",
            "K1500 Sle",
            "2wd Double Cab Standard Box Pro",
            "Elevation",
            "2wd Double Cab Standard Box Sle",
            "4wd Short Box Elevation",
            "2wd Short Box Sle",
            "4wd Short Box",
            "Sl/sle/slt",
            "Sl Sportside/sl Wideside",
            "Sl/sle1/work Truck",
            "Classic Work",
            "4wd Standard Box At4",
            "Classic Work Truck",
            "Classic",
            "4wd Short Box/4wd Standard Box",
            "2wd Short Box Pro",
            "K1500 Slt",
            "C1500 Sle",
            "K1500 At4",
            "K1500 Denali",
            "Sle Double Cab",
            "Crew Cab",
            "4wd Double Cab Standard Box Elevation With 3sb",
            "4wd Regular Cab Long Box",
            "Hd Crew Cab",
            "C1500 Denali",
            "Sl/sle1/sle2/slt/work Truck",
            "4wd Double Cab Standard Box",
            "4wd Short Box Denali/4wd Standard Box Denali",
            "K1500 Elevation",
            "Xtra Fuel Economy",
            "Shelby Kr",
            "4wd Short Box At4x",
            "C1500 Sl",
            "4wd Standard Box Slt",
            "4wd Standard Box Sle",
            "2wd Regular Cab Long Box",
            "Sle Ext Cab",
            "4wd Standard Box Elevation With 3sb",
            "C3",
            "Classic Sle2",
            "4wd Standard Box Elevation",
            "Sle Crew Cab",
            "Hybrid 3ha",
            "Denali Crew Cab",
            "Sl Ext Cab",
            "Double Cab",
            "C1500 Elevation",
            "4wd Short Box Slt/4wd Standard Box Slt",
            "Pickup",
            "Hd Slt Crew Cab",
            "Sle1/sle2/slt/work Truck",
            "Classic K1500 Classic",
            "4wd  Standard Box Slt",
            "2wd Double Cab Standard Box",
            "Wt Pickup",
            "Pro",
            "Sl/sle",
            "Sle Pickup",
            "At4 Crew Cab",
            "2wd Double Cab Standard Box Elevation",
            "Classic Sl/sle1/work Truck",
            "Sl/work Truck",
            "4wd  Short Box At4",
            "4wd  Short Box Denali",
            "4wd  Short Box Slt",
            "Sle/slt",
            "4wd Double Cab Standard Box Pro",
            "Sl Wideside/sle Sportside",
            "Slt Ext Cab",
            "Sle Sportside",
            "4wd  Short Box Elevation/4wd  Standard Box Elevation",
            "4wd  Short Box Elevation With 3sb",
            "Denali Ultimate",
            "2wd  Short Box Slt",
            "2wd  Short Box Denali",
            "4wd  Short Box Elevation",
            "4wd  Short Box Sle",
            "4wd  Short Box At4/4wd  Standard Box At4",
            "4wd  Short Box",
            "4wd  Short Box Slt/4wd  Standard Box Slt",
            "4wd  Standard Box Denali",
            "2wd  Short Box Elevation",
            "4wd  Short Box At4x",
            "Sle/work Truck",
            "2wd  Short Box Sle",
            "Sl Crew Cab",
            "At4x",
            "K1500 Sl",
            "Sle/slt/work Truck",
            "Hd Sle Crew Cab",
            "4wd Regular Cab Standard Box Pro",
            "Classic C1500 Classic",
            "K1500 C3",
            "Sle/slt/",
            "4wd  Short Box Elevation With 3vl",
            "Sl/sle/standard",
            "Crew Cab C1500 Slt",
            "2wd  Short Box Pro",
            "Wt Ext Cab",
            "4wd  Standard Box At4",
            "4wd  Standard Box Elevation",
            "2wd Short Box",
            "4wd  Short Box Pro",
            "4wd  Short Box Denali/4wd  Standard Box Denali",
            "2wd Standard Box Slt",
            "K1500 Denali Ultimate",
            "Hybrid 3hb",
            "K1500 At4x",
            "Slt Crew Slt",
            "Classic Work Truck/sle1/sle2/slt/sl",
            "Crew Cab K1500 Sle",
            "4wd  Long Box Sierra",
            "4wd  Standard Box Sle",
            "Crw Elev",
            "2wd",
            "Ltd",
            "Classic K1500 Elevation",
            "4wd",
            " Slt",
            "Crew Cab K1500",
            "4wd  Standard Box Elevation With 3sb",
            "500",
            "4wd  Short Box Sierra",
            "Crew Cab K1500 Elevation",
            "4wd  Standard Box Pro",
            "2wd  Standard Box Pro",
            "4wd  Standard Box",
            "Crew Cab K1500 At4",
            "2wd  Standard Box Sle",
            "4wd  Standard Box Sierra",
            " Sle",
            "4wd  Short Box Elevation With 3sb/4wd  Short Box Elevation With 3vl/4wd  Standa",
            "4wd  Short Box Denali Ultimate",
            "2wd  Standard Box Sierra",
            " K1500 Slt",
            "Crew Cab K1500 Denali",
            "Special K1500 Elevation",
            "4wd  Short Box Sierra/4wd  Standard Box Sierra",
            "Hybrid",
            "C1500/c1500 Sl",
            "Work Truck/sl",
            "Elevation Crew Cab",
            " Denali",
            "Classic Sl/sle1/sle2/slt/work Truck",
            "Sle1/work Truck",
            "2wd  Standard Box",
            "Hybrid Sl/sle1/sle2/slt/work Truck",
            "4wd  Short Box Sle/4wd  Standard Box Sle",
            "2wd  Long Box Sierra",
            "4wd  Short Box/4wd  Standard Box",
            "1500",
            "K1500 Elevation-l",
            " At4",
            "Slt Crew",
            "Work",
            "K2500 Denali",
            "C1500 Heavy Duty",
            "Hybrid 3ha/3hb",
            "1500 Sle",
            "Classic K1500 Slt",
            "Sle1/sle2/slt",
            "Work Truck/sle1/sl",
            "Denali C Denali",
            "Denali Cc (amalga)",
            "Slt Crew 4wd  Short Box Slt",
            "Sl Wideside Cmi",
            "4wd Long Box",
            "2wd Standard Box Pro",
            "Slt Doub Slt",
            "2wd  Short Box",
            "Elevatio 4wd Standard Box Elevation With 3sb",
            "Sl Sportside",
            "Work Tru",
            "Elevatio 4wd  Short Box Elevation",
            "4wd Long Box Pro",
            "4wd Standard Box Elevation With 3vl",
            "Slt Crew (amalgam)",
            "2wd  Standard Box Elevation",
            "2wd Standard Box Elevation",
            "2wd Standard Box",
            "Slt Double Cab",
            "4wd Standard Box Pro",
            "4wd Short Box Elevation With 3sb/4wd Short Box Elevation With 3vl/4wd Standard Box Elevation",
            "2wd Long Box Pro",
            "Sl Pickup",
            "4wd  Long Box",
            "Sle Exte Sle",
            "2wd  Long Box Pro",
            "Crew Cab Slt",
            "2wd  Long Box",
            "Shelby Kr/sle1/work Truck",
            "Sl Crew Sl",
            "Wt",
            "At4 Crew 4wd Short Box At4",
            "Sle1 Sle1",
            "Elevatio 4wd  Standard Box Elevation With 3sb",
            "2wd Long Box",
            "Elevation Dc",
            "4wd  Standard Box Elevation With 3vl",
            "Sle/slt/wt",
            "4wd  Long Box Pro",
            "Pro Double Cab",
            "4wd Short Box Elevation With 3sb/4wd Standard Box Elevation",
            "4wd Short Box Denali/4wd Short Box Denali Ultimate/4wd Standard Box Denali",
            "Classic Denali",
            "Sle/wt",
            "Wt/sle/slt",
            "At4 Crew 4wd  Short Box At4",
            "2wd C1500",
            "All-new Sle/slt/wt",
            "At4 Crew 4wd Standard Box At4",
            "4wd K1500 Sle",
            "Sl/sle/wt",
            "Sle1 Reg",
            "All-new Denali",
            "Crew Cab Sle",
            "Sl/value Leader/wt",
            "At4 Crew 4wd  Standard Box At4",
            "Classic Sl/sle1/work/work Truck",
            "Double Cab (amalg)"
          ]
        },
        {
          "model": "Sierra 1500 Limited",
          "series": [
            "4wd Double Cab Standard Box Elevation With 3vl",
            "4wd Short Box At4",
            "2wd Short Box Slt",
            "Sle",
            "4wd Short Box Slt",
            "4wd Short Box Denali",
            "4wd Short Box Sle",
            "4wd Standard Box Denali",
            "4wd Short Box Elevation/4wd Standard Box Elevation",
            "4wd Standard Box Slt",
            "4wd Short Box Elevation",
            "2wd Double Cab Standard Box Pro",
            "2wd Short Box Denali",
            "4wd Double Cab Standard Box Elevation",
            "K1500 Sle",
            "4wd Double Cab Standard Box Pro",
            "K1500 Slt",
            "C1500 Slt",
            "At4",
            "2wd Double Cab Standard Box Elevation",
            "4wd  Short Box Denali",
            "2wd Short Box Elevation",
            "K1500 At4",
            "4wd Short Box At4/4wd Standard Box At4",
            "4wd  Short Box Elevation",
            "2wd  Short Box Slt",
            "4wd  Standard Box Slt",
            "2wd  Short Box Denali",
            "4wd Double Cab Standard Box Sle",
            "4wd  Short Box At4/4wd  Standard Box At4",
            "K1500 Denali",
            "2wd Regular Cab Long Box Pro",
            "4wd  Short Box Slt",
            "4wd  Short Box At4",
            "4wd Short Box Denali/4wd Standard Box Denali",
            "2wd Short Box Sle",
            "C1500 Elevation",
            "4wd  Short Box Sle",
            "4wd  Short Box Denali/4wd  Standard Box Denali",
            "4wd  Short Box Elevation/4wd  Standard Box Elevation",
            "K1500",
            "4wd  Standard Box Elevation",
            "4wd  Standard Box At4",
            "4wd  Standard Box Denali",
            "Elevation",
            "2wd  Short Box Elevation",
            "K1500 Elevation",
            "C1500 Denali",
            "Slt",
            "Pro",
            "Denali",
            "4wd Standard Box Pro",
            "4wd Standard Box Elevation With 3vl",
            "C1500",
            "2wd  Short Box Sle",
            "2wd Standard Box Elevation",
            "4wd  Standard Box Elevation With 3vl",
            "2wd Long Box Pro",
            "4wd Long Box Pro",
            "2wd Double Cab Standard Box Sle",
            "4wd Short Box Elevation With 3vl",
            "4wd  Short Box Elevation With 3vl",
            "4wd  Long Box Pro",
            "2wd  Long Box Pro",
            "4wd Standard Box Elevation",
            "4wd Standard Box Sle"
          ]
        },
        {
          "model": "Sierra 2500 HD",
          "series": [
            "Sl",
            "Crew Cab",
            "Ext Cab",
            "Slt Crew Cab",
            "Slt Ext Cab",
            "Wt Ext Cab",
            "Sle Double Cab",
            "At4 Crew Cab",
            "Sle Ext Cab",
            "Sle Crew Cab",
            "Crew Cab (amal)",
            "Wt Pickup",
            "Sle C Slt",
            "Sl Ext Cab",
            "Denali Crew Cab",
            "Sle Pickup",
            "Denal Denali"
          ]
        },
        {
          "model": "Sierra 3500 HD",
          "series": [
            "Sl",
            "K3500 Slt",
            "K3500 Denali",
            "K3500",
            "Slt (carry-over)",
            "Denali"
          ]
        },
        {
          "model": "Terrain",
          "series": [
            "Slt",
            "Slt-1",
            "Denali",
            "Fwd Sle",
            "Sle-1",
            "Sle",
            "Sle-2",
            "Slt-2",
            "Awd Slt",
            "Fwd Slt",
            "Awd Sle",
            "Awd Denali",
            "At4",
            "Awd At4",
            "Fwd Denali",
            "Sl",
            "Slt Diesel",
            "Slt V6",
            "Sle Diesel",
            "Awd",
            "Slt 2.0t",
            "Sle V6",
            "De",
            "Lt-1",
            "Sle1 Fwd Sle-1",
            "K1500 Slt",
            "Sle 2.0t",
            "Denali 2.0t",
            "Slt Fwd Slt",
            "At",
            "Sle1",
            "Xl",
            "4d Slt1",
            "4d Sle1",
            "4d Sl",
            "Lx",
            "K1500 Elevation",
            "4d Sle",
            "Al",
            "Sl Sl",
            "Lt Slt",
            "Sle1 Awd Sle-1",
            "4d",
            "Slt1",
            "Sle-1 Fwd Sle-1",
            "K1500 Sle",
            "Slt Awd Awd Slt",
            "De De",
            "At4 Awd Awd At4",
            "Elevation",
            "El",
            "Sle2 Fwd Sle-2",
            "Denali Fwd Denali",
            "Sle-1 Awd Sle-1",
            "Slt Suv",
            "Bile 1500 4wd",
            "Slt2 Fwd Slt-2",
            "Awd Elevation",
            "Le",
            "Denali V6",
            "Fwd Elevation",
            "Elevation Awd",
            "Slt1 Fwd Slt-1"
          ]
        },
        {
          "model": "W4500 Forward",
          "series": []
        },
        {
          "model": "W5500 Forward",
          "series": []
        },
        {
          "model": "Yukon",
          "series": [
            "Xl K1500 Slt",
            "Sle",
            "Denali",
            "Xl Denali",
            "Slt",
            "Hybrid",
            "Slt W/4sb",
            "Hybrid Denali",
            "4wd Denali",
            "Xl K1500",
            "At4",
            "Xl C2500",
            "Sle/slt",
            "Slt2",
            "Xl K2500",
            "4wd Slt",
            "Commercial Fleet",
            "Xl C1500",
            "Slt Standard Edition",
            "Xl K1500 Sle",
            "4wd At4",
            "Sle2",
            "4wd Sle",
            "Xl C1500 Slt",
            "Xl C1500 Sle",
            "Denali Ultimate",
            "4wd Slt Standard Edition",
            "Xl Denali Ultimate",
            "2wd Slt",
            "Denali Denali",
            "Slt1",
            "Denali Hybrid",
            "Xl K1500 At4",
            "4wd Denali Ultimate",
            "2wd Sle",
            "2wd Slt Standard Edition",
            "Sle1",
            "2wd Denali",
            "Denali Denali (awd)",
            "Sl",
            "Dena",
            "Xl K2500 Slt",
            " Xl K1500",
            "Xl D",
            "Xl K",
            "Sle1/sle2",
            "Gt Line",
            "Sle W/3sa",
            "Denali Xl Suv",
            "C2500 Heavy Duty",
            "Slt W/4sa",
            "Zx4",
            "K1500",
            "K1500 Sle",
            "/dena",
            "Denali Denali Awd",
            "Xl C",
            "Hybr",
            "Sle W/3sb",
            "Commercial/sle",
            "Xl K2500 Sle",
            "Xl 1",
            "N Sle",
            "X",
            "Yuk/den",
            "Xl S",
            "Dena Dena",
            "4 0 W4s04",
            "N Yuk/den",
            "Commercial",
            "Hybrid Hybrid",
            "Commercial/sle/slt",
            "C1500 Sle",
            "Commercial/sle W/3sa",
            "Xl",
            "Sle/slt/commercial",
            "Xl C2500 Sle",
            "Slt 1500 Slt",
            "Sle Sle",
            "Hybr Hybr",
            "Slt Slt",
            "Slt Cmi",
            "Denali 1500 Aw Denali",
            "Elevation",
            "4d 4",
            "Xl C2500 Slt",
            "Denali Awd",
            "4wd At4 Ultimate",
            "2wd Elevation",
            "4wd Elevation",
            "Sl/sle/slt W/1sd/slt W/1se",
            "Elev",
            "4dr 4wd"
          ]
        },
        {
          "model": "Yukon XL",
          "series": [
            "2wd Slt",
            "Slt",
            "4wd Slt",
            "Denali",
            "2wd Denali",
            "Denali Denali",
            "Sle",
            "K1500 Sle",
            "4wd Denali Ultimate",
            "C1500 Slt",
            "4wd Sle",
            "4wd Denali",
            "K1500",
            "C1500 Sle",
            "K1500 Slt",
            "4wd At4",
            "C1500",
            "2wd Sle",
            "K1500 At4",
            "4wd Slt Standard Edition",
            "Denali Ultimate",
            "K2500",
            "Slt W/4sb",
            "Slt W/4sa",
            "Slt Standard Edition",
            "Commercial/sle W/3sa",
            "At4",
            "C",
            "Slt 1500 4w Sle/slt",
            "Sle/slt/commercial",
            "Commercial/sle/slt",
            "Sl",
            "C2500",
            "Sle W/3sa",
            "Sle W/3sb",
            "A /dena",
            "D",
            "K",
            "Commercial",
            "1",
            " Sle",
            "Denali 4wd Denali",
            "K2500 Slt",
            "Sle/slt",
            "Denali Denali (awd)",
            "C Xl C",
            "K Xl K",
            "D Xl D",
            "Slt2",
            "Denali 1500 Denali",
            "Elevation",
            "K2500 Sle",
            "Slt 4wd Slt",
            "2wd Slt Standard Edition",
            "At4 Ultimate",
            "E",
            "A",
            "2wd Elevation"
          ]
        },
        {
          "model": "Yukon XL 1500",
          "series": [
            "Sle",
            "Slt",
            "Denali",
            "C1500",
            "Slt2",
            "K1500",
            "Sle/slt",
            "K1500 Slt",
            "Xl K1500",
            "Sle2",
            "Commercial Fleet",
            "Slt1",
            "Slt1/slt2",
            "C1500 Slt",
            "I",
            "000 Eps Ride Command Edition",
            "Sle1",
            "K1500 Sle",
            "Sl"
          ]
        },
        {
          "model": "Yukon XL 2500",
          "series": [
            "Sle",
            "Slt",
            "K2500",
            "Sle/slt"
          ]
        }
      ]
    },
    {
      "make": "Genesis",
      "models": [
        {
          "model": "G70",
          "series": [
            "2.0t Awd",
            "Prestige",
            "Advanced",
            "2.0t Rwd",
            "3.3t Rwd",
            "Elite",
            "Base",
            "2.0t Advanced",
            "3.3t Advanced",
            "3.3t Awd",
            "Sport Advanced",
            "Prestige/sport",
            "Sport Advanced/sport Pres",
            "3.3t Awd Launch Edition",
            "3.3t Prestige Awd/3.3t Sport Awd",
            "Sport Advanced/sport Prestige",
            "3.3t",
            "Prestige/sport/dynamic/de",
            "3.3t Sport",
            "3.3t Dynamic",
            "2.5t Rwd",
            "Launch Edition",
            "Prestige/dynamic/sport",
            "2.0t Elite Awd",
            "3.3t Design",
            "Launch",
            "Advanced 2.0t",
            "2.5t Awd",
            "Sport",
            "2.0t Advanced Awd",
            "2.0t Sport",
            "Sport Prestige",
            "3.3t Rwd Sport Advanced",
            "3.3t Awd/3.3t Rwd",
            "2.0t Prestige Awd",
            "Presti",
            "2.0t",
            "Advanc",
            "3.3t Launch Edition",
            "Awd",
            "2.0t Rwd Manual",
            "3.3t Rwd Launch Edition",
            "2.0t Elite",
            " Base",
            "3.3t Awd Sport Advanced",
            "Elite Elite",
            "Prestige/sport/dynamic/design Edition",
            "3.3t Sport Awd",
            "2.0t Sport Rwd",
            "3.3t Sport Launch Edition Awd",
            "2.5t Prestige Awd",
            "Sport 3.3t",
            "Advanced Rwd 2.0t Advanced",
            "2.0t Awd/2.0t Rwd",
            "Prestige 2.0t",
            "Elite 2.0t",
            "Sport 2.0t"
          ]
        },
        {
          "model": "G80",
          "series": [
            "3.8",
            "Ultimate",
            "Base",
            "2.5t Rwd",
            "3.8 Awd",
            "Sport",
            "2.5t Awd",
            "Premium/ultimate",
            "3.3t Sport",
            "Sport Prestige",
            "3.5t Rwd",
            "Advanced/prestige",
            "3.5t Sport Awd",
            "5.0 Ultimate",
            "Electrified Awd Standard",
            "Advanced",
            "3.5t Sport Plus Awd",
            "2.5t",
            "3.3t Sport Awd",
            "3.8 Technology",
            "Sport/ultimate",
            "5.0 Ultimate Rwd",
            "3.8l",
            "Ultima",
            "5.0l Ultimate",
            "3.5t",
            "3.5t Sport",
            "Prestige",
            "Trified G80",
            "3.8 Rwd",
            "3.5t Awd",
            "2.5t Awd/2.5t Rwd",
            "Base/p",
            "Sport/sport Advanced/sport Prestige",
            "3.3t Sport Rwd",
            "Base Base",
            "Advanc",
            "Sport Sport",
            "3.5t Sport Prestige Awd",
            "Awd 2.5t Awd",
            "G80",
            " Base",
            "Tech 3.8",
            "3.8 Technology Awd",
            "2.5t Advanced Awd",
            "Sis 3.8l"
          ]
        },
        {
          "model": "G90",
          "series": [
            "Ultimate",
            "5.0 Ultimate",
            "3.3t Premium",
            "Premium",
            "3.3t Premium Awd",
            "3.3t Ultimate",
            "5.0 Ultimate Awd",
            "3.3t Premium Rwd",
            "5.0 Ultimate Rwd",
            "5.0l Ultimate",
            "3.5t E-sc Awd",
            "3.5t Awd",
            "Ultima",
            "Premiu",
            "Premiu Premiu"
          ]
        },
        {
          "model": "GV70",
          "series": [
            "Base",
            "3.5t Awd Sport",
            "2.5t Awd",
            "Select/advanced/sport Prestige",
            "Advanced",
            "2.5t Advanced Awd",
            "2.5t Prestige Awd",
            "Sport Advanced/sport Prestige",
            "Select/advanced/sport Pre",
            "3.5t Sport Plus Awd",
            "3.5t Sport Awd",
            "Advanced/prestige",
            "Advanced Awd",
            "Prestige",
            "Sport Advanced/sport Pres",
            "2.5t Advanced Plus Awd",
            "Sport Plus 3.5t",
            "3.5t Sport",
            "2.5t",
            "Select/advanced",
            "Rified Gv70 Advanced",
            "Rified Gv70 Advanced Awd",
            "Advan",
            "2.5t Stan/select/adv/spt Prest Awd",
            "Prestige Awd",
            "Advanced/advanced Plus/prestige",
            "Sport",
            "Sport Plus",
            "2.5t Select Awd",
            "2.5t Select",
            "2.5t Sport Prestige",
            "3.5t Sport Plus With Elsd Awd",
            "Sport 3.5t"
          ]
        },
        {
          "model": "GV80",
          "series": [
            "2.5t Awd",
            "Base",
            "3.5t Awd",
            "Advanced/advanced+/prestige",
            "3.5t Awd Advanced",
            "2.5t Rwd",
            "3.5t Prestige Signature Awd",
            "2.5t Advanced Awd",
            "3.5t Prestige Awd",
            "Advanced/advanced+/presti",
            "Advanced/prestige",
            "3.5t Awd Prestige Signature",
            "Prestige",
            "Advanced/prestige/prestige Signature",
            "Advanced/prestige/prestig",
            "Advanced +",
            "Prestige Signature",
            "2.5t (a8)",
            "3.5t (a8)",
            "Adv+",
            "Advanced",
            "Standard",
            "2.5t Standard Awd",
            "Coupe 3.5t E-sc",
            "Advan",
            "Base Base",
            "Stand",
            "3.5t E-sc",
            "Prest",
            "3.5t Prestige 5p Awd",
            "Advanced 2.5t",
            "2.5t Prestige Awd",
            "3.5t Prestige 7p Awd",
            "2.5t Select Awd",
            "Coupe 3.5t V6 Awd",
            "Coupe",
            "3.5t Advanced 5p Awd",
            "Select",
            "Selec"
          ]
        },
        {
          "model": "GV60",
          "series": [
            "Performance Awd",
            "Advanced",
            "Advanced Awd",
            "Mance",
            "Performance",
            "Standard",
            "Standard Rwd",
            "Perfo",
            "Advan",
            "Stand"
          ]
        }
      ]
    },
    {
      "make": "Honda",
      "models": [
        {
          "model": "Accord",
          "series": [
            "2.4 Lx",
            "3.0 Ex",
            "2.4 Ex",
            "Lx",
            "2.4 Ex-l",
            "2.3 Ex",
            "2.4 Se",
            "Ex",
            "Exl",
            "Crosstour Exl",
            "Hybrid Exl",
            "Lxp",
            "2.3 Se",
            "Cpe Ex",
            "Sport",
            "2.4 Lx-s",
            "Sdn Lx Se",
            "Touring V6",
            "Touring",
            "Hybrid Sport",
            "3.5 Ex",
            "Hybrid Ex-l",
            "Sport Special Edition",
            "Hybrid",
            "3.5 Ex-l",
            "Ex-l V-6",
            "2.4 Lx-p",
            "Ex-L",
            "Hybrid Touring",
            "3.0 Lx",
            "Lx-S",
            "Touring Hybrid",
            "Sport Se",
            "Se",
            "Sport 2.0t",
            "Hybrid Ima",
            "Touring 2.0t",
            "Hybrid Ex",
            "Ex V6",
            "Lx-P",
            "Sdn Lx",
            "Cpe Lx",
            "Sdn Ex W/leather",
            "Sdn Ex-l",
            "Dx",
            "Sdn Ex W/leather/ex",
            "Sdn Vp",
            "Lx/ex",
            "Sdn Se",
            "2.4 Vp",
            "Ex-l V6",
            "Hybrid Sport-l",
            "Cpe Ex W/leather",
            "Value",
            "2.3 Lx",
            "Hybrid Sport-l/sport-l",
            "Sdn Ex/ex W/leather/se",
            "3.0 Se",
            "Ex-l 2.0t",
            "Ex/ex-R",
            "Sdn",
            "Hybrid Hybrid",
            "2.3 Ex/2.3 Se",
            "Hybrid Touring Hybrid",
            "2.3 Dx",
            "Sdn Lxp",
            "2.3 Vp",
            "Cpe Lx Se",
            "2.4 Lx Special Edition",
            "2.4 Dx",
            "Lx V6",
            "Sdn Ex-l V6 With Navi",
            "Ex-V6",
            "Crosstour Ex",
            "Lx 1.5t",
            "Spo",
            "X",
            "Sdn Special Edition",
            "Sdn Ex W/leather/se/ex",
            "Lxi",
            "Cpe Lx-s",
            "Dx/lx",
            "Sdn Ex-l V6",
            "Sdn Ex",
            "Sdn Lx-p",
            "Sdn Sport",
            "Sdn Ex/ex-l With Navi",
            "Sdn Exl",
            "Cpe",
            "Plug-in Hybrid",
            "Cpe Ex-l",
            "Value Package",
            "3.0 Lx Special Edition",
            "Ex/se",
            "Cpe Ex-l V6",
            "Cpe Se",
            "Hyb",
            "Cpe Ex W/leather/ex",
            "Wgn Lx",
            "Cpe Ex/ex W/leather",
            "Sdn Ex/ex W/leather",
            "Cpe Ex-l V6 With Navi",
            "Se-V6",
            "Exi",
            "Hybrid Hybrid Exl",
            "Sdn Ex V6",
            "10th Anniversary",
            "Dx 25th Anniversary",
            "Tou",
            "Sdn Lx-g",
            "T",
            "T Se",
            "T Special Edition",
            "1800",
            "Hybrid Hybrid Sport",
            "Hybrid Hybrid Ex",
            "Sdn 2.4 Ex-l/ex-l",
            "Hybrid Sport- Hybrid Sport-l",
            "Ex-R",
            "Sei 1.8",
            "Ur Exl",
            "Cpe Exl",
            "1800 Lx",
            "Lx-G",
            "S",
            "Sport 1.5t",
            "Sdn Dx",
            "Sdn Ex/ex-l",
            "Port",
            "Ex-l 1.5t",
            "Sedan",
            "Sedan Sport Se",
            "Sedan Ex-l",
            "Sedan Exl",
            "Sedan Lx",
            "Sedan Sport 2.0t",
            "Coupe",
            "Sedan Sport",
            "Coupe Exl",
            "Sdn Se/ex-l",
            "Sed",
            "Plu",
            "-V6",
            "Sei",
            "Ex-",
            "4d",
            "Acc Sedan",
            "Accrd",
            "Gt",
            "Acord Ex",
            "Hybrid/touring",
            "Sedan Touring",
            "Sedan Ex-l Navi 2.0t",
            "Coupe Touring",
            "Sedan Ex-l 2.0t",
            "Sedan Touring 2.0t",
            "Lx-",
            "Cro",
            "Sedan Ex 1.5t",
            "Sedan Lx 1.5t",
            "Sedan Sport Special Edition",
            "Coupe Ex",
            "Coupe Ex-l",
            "Sedan Ex-l V6",
            "Sedan Ex-l 1.5t",
            "Coupe Lx-s",
            "Sedan Touring 1.5t",
            "Sdn Lx Premium",
            "Sedan Ex-l Navi 1.5t",
            "Sedan Ex",
            "Sedan Sport 1.5t",
            "Hybrid Hybrid/exl",
            "Sdn Touring",
            "Lxu Lxu",
            "Accord Exl",
            "Xle",
            "Hybrid Ex-l W/navi",
            "Cpe Ex-l W/navi",
            "V6 -v6",
            "Dx-G",
            "Lx/",
            "4d Se",
            "-4 C",
            "1200cc",
            "Lx- Lx-",
            "Cou",
            "Exr",
            "Lxu",
            "10t",
            "Coupe Ex-l V6",
            "4d Ex",
            "Hybrid Hybrid/touring",
            "Cpe Ex/ex-l With Navi",
            "Hybrid/exl",
            "Val",
            "Cpe Ex/exl With Navi",
            "Sdn Lx V6",
            "Sdn Se/ex/ex W/leather",
            "Cpe Ex/ex-l",
            "Cpe Lx V6 Se",
            "Hybrid With Navi",
            "2d Ex",
            "Cross Tour",
            "Ex/",
            "Acc S Ex",
            "Sdn Ex-l With Navi",
            "Sedan Sport Automa Sport",
            "Cpe Lx V6",
            "Cv 1",
            "4d Exl",
            " Lx",
            "Touring Touring",
            "Lx Lx",
            "4d Lx",
            "Ex 1.5t",
            "Sed Sed",
            "Plug-in Hybrid Plug-in Hybrid",
            "Ex Sport",
            "Cpe 3.5 Ex-l",
            "2.3 Lx/lx",
            " Ex",
            "Lx W/co Lx",
            "Sdn 2.3 Ex/2.3 Se",
            "Sdn 2.3 Lx",
            "Sdn 3.0 Ex",
            "Ex-l/ex-l V-6",
            "Tor 10hp Motor",
            "Sei Sei",
            "X Acord Ex",
            "Ccrd",
            "Ex Ex",
            "Exl Exl",
            "Tou Tou",
            "Sdn 2.4 Se",
            "Dx Dx",
            "2.4 Ex/ex",
            "Lt",
            "Cpe 2.4 Ex",
            "Sdn 2.4 Lx-p",
            "Cpe 2.4 Ex-l/ex-l",
            "Lx Premium",
            "Cpe 2.4 Ex-l",
            "Sdn 3.5 Ex-l",
            "H",
            "Cro Cro",
            "Limited",
            "2.4 Ex-l/ex-l",
            "Sdn 2.4 Ex",
            "Spo Spo",
            "Hyb Hyb",
            "Lxp Lxp",
            "Se Se",
            "Cpe 3.0 Ex",
            "Hybrid Hybrid Touring",
            "Special Edition",
            "Cpe 3.5 Ex-l/ex-l",
            "Sho",
            "Ex-l W/ Ex-l",
            "Sdn 2.4 Lx",
            "Sdn 2.3 Ex",
            "Sdn 2.4 Ex-l",
            "3.5 Ex-l/ex-l",
            "Ima",
            "Sdn 2.3 Vp/vp",
            "Exl Ex",
            "Xlt/king Ranch",
            "Touring 2.0",
            "Touring 1.5t",
            "2wd Sport/2wd Sport W/o Bsi",
            "Cpe Special Edition",
            "Ex Auto 2.4 Ex",
            "2d",
            "Se V6",
            "Sport Hybrid",
            "Cv",
            "Ile Other",
            "Ex-L/se",
            "Odyssey Ex",
            "Sport 2.0",
            "Ex-l-navi V6",
            "Ybrid",
            "Cpe 2.4 Lx-s",
            "- C",
            "Sdn 3.0 Lx",
            "Ex-L-Navi",
            "Cpe 2.3 Ex/ex",
            "Sport W Sport",
            "Sdn 2.3 Ex/ex",
            "(acsc)",
            "4 C",
            "2.3 Ex/ex",
            "Ur Ex",
            "Special Edition V6",
            "Hybrid Touring/touring",
            "Euro-R",
            "Lx-ulev Lx",
            "Xl",
            "Hyb Hybrid Sport-l",
            "Ex-L/lx-G"
          ]
        },
        {
          "model": "Accord Crosstour",
          "series": [
            "Ex-L",
            "Exl",
            "Ex",
            "Ex-l V6",
            "Ex V6"
          ]
        },
        {
          "model": "BR-V",
          "series": []
        },
        {
          "model": "City",
          "series": []
        },
        {
          "model": "Civic",
          "series": [
            "Ex",
            "Lx",
            "Sport",
            "Base",
            "Exl",
            "Ex-T",
            "Ex-L",
            "Se",
            "Sport Touring",
            "Dx/lx",
            "Si",
            "Natural Gas",
            "Touring",
            "Hybrid",
            "Lx-S",
            "Type-r Touring",
            "Vp",
            "Dx",
            "S Es",
            "Cpe Ex",
            "Hatchback Sport",
            "Sedan Ex-t",
            "Sedan Lx",
            "Gx",
            "Sdn Ex",
            "Sdn Lx",
            "Hf",
            "Si Sedan",
            "Dx Vp",
            "Ex-l /ex-l W/o Bsi",
            "Del Sol Si",
            "Ex /ex W/o Bsi",
            "Type-R",
            "Sdn Lx-s",
            "Lx-P",
            "Sedan Sport",
            "Hx",
            "Type R Touring",
            "Si Coupe",
            "1500 Crx Si",
            "Laredo",
            "Sdn",
            "Sedan",
            "Lx/ex",
            "Hybrid Hybrid",
            "Hatchback",
            "Deluxe",
            "Value Package",
            "Si/ex",
            "Cx",
            "Cpe",
            "Si Si",
            "Dx-A",
            "Hatchback Lx",
            "Type R",
            "Sedan Lx Autom Lx",
            "Hybrid L",
            "Sedan Ex",
            "Del Sol S",
            "Dx-G",
            "1500 Dx",
            "Ex/ex-V",
            "Type R Type-r Touring",
            "Si/si Mugen",
            "Ex 4dr",
            "Lx-G",
            "Sedan Ex-l",
            "Crx Dx",
            " S",
            "Sdn Exl",
            "Coupe Lx",
            "Sdn Si",
            "Cpe Lx",
            "Coupe",
            "Crx",
            "Crx 1.5 Hf",
            " Ex",
            "Ex W/o Bsi /ex",
            "Dx/lx/se",
            "Sir",
            "1.5",
            "Sdn Ex-l",
            "Sdn Dx-g",
            "Sedan Si",
            "Vx",
            "1500 S",
            "Hatchback Ex",
            "Cpe Dx-g",
            "Lx-Sr",
            "Sedan Touring",
            "T Ex",
            "Sdn Ex With Navi",
            "1.5 Dx",
            "Type R Type-r",
            "Lx/lx Se",
            "Crx Si",
            "Sdn Se",
            "Hybrid Hybrid L",
            "Si-G",
            "Type R Base (m6)",
            "Cvcc 1300",
            "Cvcc",
            "Cvcc 1500 Dx",
            "Cpe Lx/lx-sr",
            "Dx/dx-G",
            "Pieces Lx",
            "Type R Limited Edition",
            "Lx-Se",
            "Spor",
            "Type-r Limited Edition",
            "Type",
            "A S",
            "Ex-l Navi",
            "Crx Si/crx Se",
            "Del Sol",
            "Hx Cvt",
            "Cpe Ex-l",
            "1500 Crx",
            "Si/sir",
            "Hatchback Sport Touring",
            " Lx",
            " Exl",
            "1500 Gl",
            "Sdn Dx-vp",
            "Sport/sport Touring",
            "Sedan Exl",
            "Hybr",
            "Coupe Ex",
            "Coupe Lx-p",
            "Tour",
            "Seda",
            "4d",
            "Coup",
            "4d E",
            "Del",
            "Cpe Si",
            "2d C",
            "Lx S",
            "Sdn Vp",
            "Si Sedan Si",
            "Natu",
            "Sedan Se",
            "Coupe Ex-t",
            "Coupe Si",
            "Hatchback Exl",
            "Coupe Sport",
            "Coupe Ex-l",
            "Civ 2dr",
            "Hatc",
            "Coup Coup",
            "Si/s",
            "Sedan Cng",
            "Sdn Dx",
            "Cpe Ex Ssrs",
            "4d Hbk Lx Sensing",
            "Sedan Dx",
            "Cpe Exl",
            "Cpe Dx",
            "4d 4d",
            "Lx Lx",
            "/se",
            "Awd",
            "Hatchback Ex-l Navi",
            "Hatchback Ex-l",
            "Sdn Cng",
            "Sdn Gx",
            "Sedan Hf",
            "Hyb",
            "Sdn Hf",
            "Coupe Touring",
            "Coupe Exl",
            "Si Coupe Si",
            "Sedan Natural Gas",
            "Dx V",
            "Sdn Natural Gas",
            "Cpe Ex With Navi",
            "Cpe Vp",
            "Cpe Lx Ssrs",
            "Cpe Vp Ssrs",
            ".del Sol",
            "4d Ex",
            "Sdn Touring",
            "Cpe Hx",
            "Lx/e",
            "Ex/e",
            "Cpe Lx Se",
            "4d Dx",
            "2d Ex-t",
            "4door",
            "4d Exl",
            "Cpe Ex Se",
            "Hatchbatch Sport",
            "250",
            "2d Ex",
            "4d Spt",
            "Sx/sxp",
            "Ex, Cp, 1.5",
            "Lx A",
            "4d E 4d E",
            "Dxl",
            "2d Dx",
            "Si Base (m6)",
            " Ex-l",
            "4d Lx",
            "Coupe Dx",
            " Sport",
            "Sdn Ex/ex With Navi",
            "Si Base M6/base W/high Performance Summer Tires M6",
            "Si Base (m6)/base W/summer Tires (m6)",
            "Hybrid Base Cvt/base W/navi Cvt",
            "A Double Cab Sr/sr5",
            "Cpe Ex/ex With Navi",
            "Cv 2",
            "Sdn Ex With Navi/ex",
            "Si Si (m6)/si Hpt (m6)",
            "Hybrid Hybrid W/at-pzev Cvt/hybrid W/ulev Cvt",
            "4 Cy -4 Cy",
            "A Le",
            "Sdn Ex/ex Se",
            "Cpe Ex/ex Se",
            "Seda Seda",
            "Sedn",
            "-4 Cy",
            "Dx A",
            "Super Duty",
            " Hybrid Sport Touring",
            "Se Se",
            "Dx-g Dx-g",
            "Natu Natu",
            "Hybr Hybr",
            "Ex Ex",
            "Dx Dx",
            "Ex-l Ex-l",
            "Lx/se",
            "Lx Special",
            "Sedan Lx W/con Lx",
            "Hybrid W/ulev (cvt)",
            "Sdn Cng/natural Gas",
            "Type R Type-r Limited Edition",
            "Coupe Lx Autom Lx",
            "Exl Exl",
            "Spor Spor",
            "Vp Vp",
            "Type Type",
            "Lx-s Lx-s",
            "Sedan Hybrid",
            "X",
            "Coupe Si Manua Si",
            "Reverb",
            " Hybrid Sport/sport Touring",
            "A-spec Package",
            "Tour Tour",
            "R",
            " Hybrid Sport",
            "Si Base W/high Performance Summer Tires/",
            "E",
            "Gxe",
            "Hf Hf",
            "Dx/dx-A",
            "Ex-G",
            "Sdn Lx Ssrs",
            "1.5 Si",
            "Sport/sport-B",
            "Ex/ex W/new Wheel Design",
            "Atchback Spor Sport",
            "Hatchback Hybrid Sport Touring",
            "Lx Sport",
            "Lx/lx-B",
            "Ex/ex-B",
            "Si/si-G",
            "Base W/high Performance Summer Tires/",
            "Spt Tour",
            "Hybr Hybrid",
            "Intl (bci) Civic Seda",
            "Ne E450 Super Duty Cutaway Van",
            "2d Coupe",
            "Sport Hev",
            "Civ Type R",
            "Cpe Se",
            "2d D",
            "Cv2",
            "Special Edition",
            "Lx Sr",
            " Base",
            "Lx-B",
            "Sdn Si/si Mugen",
            "T",
            "(us Mdl)",
            "4 Cy",
            "Y Ex",
            "Sport Touring Hev",
            "Intl (bci) Accord Sed",
            "1.3",
            "Coupe Sport/sport Touring",
            "Ex-l/ex-l W/o Bsi",
            "El",
            "Ima",
            "Premium Plus 45 Tfsi S Line Quattro Tiptronic",
            "Wagovan",
            "Hybird",
            "Sdn Vp Ssrsv",
            "Hatchback Spor Sport",
            "2.5 S",
            "Dx/reverb/se"
          ]
        },
        {
          "model": "Clarity",
          "series": [
            "Touring",
            "Fuel Cell",
            "To",
            "To To"
          ]
        },
        {
          "model": "Clarity Plug-In Hybrid",
          "series": [
            "Touring"
          ]
        },
        {
          "model": "CR-V",
          "series": [
            "Ex",
            "Awd Lx",
            "Lx",
            "Se",
            " Exl",
            " Lx",
            "Ex-l/ex-l Navi",
            "Ex-L",
            "Awd Ex",
            "Hybrid Ex-l",
            "Awd Special Edition",
            " Ex",
            "Touring",
            " Touring",
            " Se",
            "Ex-l 2wd",
            "2wd Ex-l",
            "Lx Awd",
            "Awd Ex-l",
            "Hybrid Sport Touring",
            "Base (a4)/base Abs (a4)",
            "Hybrid Ex",
            "Special Edition",
            "2wd Ex",
            "Hybrid Sport",
            "Ex Awd",
            " Sport",
            "Ex-l Awd",
            "Lx 2wd",
            " Sport Touring",
            " Sport-l",
            "Hybrid Touring",
            "Exl",
            "Hybrid Sport-l",
            "Base (a4)",
            "2wd Lx",
            "Se/ex",
            "Ex 2wd",
            "Awd Touring",
            "2wd Special Edition",
            "Sport",
            "2wd Touring",
            " Touri",
            "Sport Touring",
            "Sport-L",
            "Hybrid",
            "Hybrid Lx",
            "Limited",
            "Ex-l Hybrid",
            "Ex Se",
            "Se/le",
            "Cr-v Exl",
            "Cr-v Sport",
            "Sport Touring Hybrid",
            "Cr-v Touri",
            "Cr-v Ex",
            "R-v Lx",
            "R-v Ex",
            "R-v Exl",
            "R-v Touri",
            "R-v Se",
            "Touri",
            "Ouring",
            "R-v Ex-l",
            "R-v Ex Aw",
            "Exl Cr-v Exl",
            "4d 4w Cr-v 4d 4w",
            "Wd",
            "4d 4w",
            "R-V",
            "X4",
            "4d Ex",
            "X",
            "X-L",
            "100",
            "Tou",
            "R-v Sport",
            "4d Exl",
            "Ex-l Cr-v Ex-l",
            "R-v 4d 4w",
            "Xl",
            "Exln",
            "Lx 4wd Lx",
            "E",
            "Cr-v 4d 4w",
            "Hybrid Hybrid Touring",
            "Cr-v Lx",
            "Cr-v Se",
            "Cr-V",
            "Lx Cr-v Lx",
            "X Lx",
            "Xl Exl",
            "Cr-v Ex-l",
            "Black Edition",
            "Lx Lx",
            "X Ex",
            "Ex Cr-v Ex",
            "Se Cr-v Se",
            "Sport Cr-v Sport",
            "Touri Cr-v Touri",
            "Awd",
            "Touring Hybrid",
            "Ex-l 4wd Ex-l",
            "Awd Cr-v Ex",
            "Hybrid Hybrid Sport",
            "Nz A220",
            "Performa Il",
            "Sport/sport-B",
            "Black Edition/touring",
            "Lx Aw Cr-v",
            "Limited Edition",
            "Righthand",
            " Ex Suv",
            "Lx-B",
            " 4d 4w",
            "Lx/lx-B",
            "Ex Awd Ex",
            "Parts",
            "Cr-v Ex Aw",
            "Ex-L/lx",
            "Ex Auto"
          ]
        },
        {
          "model": "CR-Z",
          "series": [
            "Ex",
            " Ex",
            "Ex/ex-l Navi",
            "Lx",
            "Hybrid",
            "Ex Hybrid",
            "Ybrid",
            "Ex/ex-L",
            "R-Z",
            "R-z Ex",
            "Ex Cr-v Ex",
            "Ex Cr-z Ex",
            "Cr-z Ex",
            "Cr-Z",
            "Base (cvt)"
          ]
        },
        {
          "model": "Crosstour",
          "series": [
            "Exl",
            "Ex",
            "Ex-L",
            "2.4 Ex-l",
            "Ex-l V6",
            "2.4 Ex",
            "Sstour Exl",
            "Ex V6",
            " Cro",
            "Sstour Ex",
            "Sstour"
          ]
        },
        {
          "model": "Element",
          "series": [
            "Sc",
            "Lx",
            "Ex",
            "Ex-P",
            "Dx",
            "Se",
            "-4",
            "Ex Ex",
            "Ex W/navi",
            "4 -4",
            "4d 4d",
            "Y-Package",
            "Tl (bci) Civic Coup",
            "Y Package"
          ]
        },
        {
          "model": "Fit",
          "series": [
            "Ex",
            "Sport",
            "Lx",
            "Ex/ex-L",
            "Ex-L",
            "S",
            "Exl",
            "Ex/exl",
            "Dx-A",
            "Dx",
            "Ex-L/ex",
            "Sport Automatic Sport",
            "Ov1",
            "Lx W/honda Sensing",
            "Sw",
            "Ex W/c",
            "Sport W/navi",
            "Ex-l W/navi",
            "Automa",
            "Sw Lx",
            ".del Sol",
            "Sw Ex",
            "Base (m5)",
            "Base A5",
            "Base (a5)",
            "Se",
            "Sport 5dr",
            "Automa Automa",
            "Sw Sw",
            "Ex Ex",
            "Sport Sport",
            "Dx/dx-A/lx",
            "Dx/lx",
            "Ex-l Navi",
            "Ex/ex-l Navi"
          ]
        },
        {
          "model": "HR-V",
          "series": [
            "2wd Lx",
            "Awd Sport",
            "2wd Ex-l",
            "Ex-L",
            "Awd Ex-l/awd Ex-l W/o Bsi",
            "Lx",
            "Ex",
            "2wd Sport",
            "Sport",
            "Awd Ex",
            "Awd Sport/awd Sport W/o Bsi",
            "2wd Ex",
            "Awd Lx",
            "Exl",
            "Touring",
            "2wd Sport/2wd Sport W/o Bsi",
            "2wd Ex-l/2wd Ex-l W/o Bsi",
            "Awd Ex-l",
            "Awd Touring",
            "Ex Awd",
            "Ex-l Navi",
            "Touri",
            "Ex-l W/navi",
            "Awd",
            "Hrv",
            "Hrv Sport",
            "4d Ex",
            "Port",
            "Lf Outer Panel",
            "-Line",
            "V",
            "Awd Sport/awd Sport W",
            "2wd Sport/2wd Sport W",
            "Sport 2wd Sport",
            "Port Hrv Sport",
            "00",
            "2wd Sport/sport",
            "Awd Sport/sport",
            "Awd Ex-l/ex-l",
            "Ex W/",
            "Exl Exl",
            "Lx Lx",
            "Sport Sport",
            "Ex Ex",
            "Lx Awd W/cvt Lx",
            "Sport-B",
            "Suv",
            "Lx-B"
          ]
        },
        {
          "model": "Insight",
          "series": [
            "Ex",
            "Lx",
            "Touring",
            "Cvt",
            "To",
            "Base W/ac",
            "Base (cvt)",
            "Hy",
            "W/air Cond",
            "Air Cond",
            "To To",
            "Lx Lx",
            "Cx",
            "2.0 Se Awc"
          ]
        },
        {
          "model": "Odyssey",
          "series": [
            "Exl",
            "Ex-L",
            "Lx",
            "Touring",
            "Ex",
            "Se",
            "Touring/touring Elite",
            "Elite",
            "Sport-L",
            "Ex-l/ex-l W/navi Res",
            "Ex-l/ex-l W/navi & Res",
            "Ex-l W/leather",
            "(u.s.) Ex",
            "Sport",
            "Lx/ex",
            "Ex-l Ex-l",
            "Ba",
            "Dx",
            "Ex-l W/dvd/leather",
            "Ex/lx",
            "(u.s.) Exl",
            "Base",
            "Ex-l Res",
            "Ex-l/ex-l W/navi   Res",
            "To",
            "Ex Odyssey Ex",
            "Ex-l W/leath Ex-l",
            "El",
            "Oddyssey",
            "Oddessey",
            "Xl",
            "Odessy",
            "Va",
            "Odyss Ex-l",
            "Odyss Ex",
            "(o",
            "Ex-l W/navi/res",
            "Ex-l W/navigation/leather",
            "Touring Elite",
            "Ex-Res",
            "Ex W/navigation",
            "Ex-l Navi",
            "Odysey",
            "Odysssey",
            "Van (new)",
            "Ex/ex-Res",
            "Sp",
            "Ls Odyssey",
            "Ean Ocean One",
            "Odyseey",
            "Tou",
            "Ex-l/ex-l W/navi/res",
            "/lx",
            "(u.s.)",
            "Oddesey",
            "Se Se",
            "Dessy",
            "Lx Odyssey Lx",
            "To To",
            "Sle-1",
            " Oddyssey",
            " Odyss Ex",
            "Odyssey",
            " Oddessey",
            "El El",
            "(u.s.) Touring/touring Elite",
            "Black Edition",
            "-L",
            "Ex-l Navi/ex-l Res",
            "Le",
            "Oddsey",
            "Ex-L/touring",
            "Absolute",
            "Per Cab",
            "Touring Touring/touring Elite",
            "5fnrl38499b503287",
            "Touring Elit Touring/touring Elite"
          ]
        },
        {
          "model": "Passport",
          "series": [
            "Awd Ex-l",
            "Sport",
            "Ex/lx",
            "2wd Ex-l",
            "Exl",
            "Awd Touring",
            "Ex-L",
            "Elite",
            "Awd Elite",
            "Touring",
            "Awd Trailsport",
            "Trail Sport",
            "Ex/ex W/luxury Pkg/lx",
            "Ex",
            "E",
            "2wd Sport",
            "Awd Sport",
            "Ex/lx/lxp/ext",
            "2wd Touring",
            "Black Edition",
            "Awd Black",
            "Lx",
            "Trailsport",
            "T",
            "S",
            "B",
            "Stx/xlt/xl",
            "Lx/ex/ex W/luxury Pkg",
            "Ex/lx/ex W/luxury Pkg",
            "E E",
            "T T",
            "Awd Trailsport Elite/awd Trailsport Elite Blackout"
          ]
        },
        {
          "model": "Pilot",
          "series": [
            "Ex-L",
            "Exl",
            "Touring",
            "Se",
            "Ex",
            "Lx",
            "Elite",
            "Awd Touring",
            "Awd Ex-l",
            "2wd Special Edition",
            "Vp",
            "Awd Special Edition",
            "Exln",
            "Awd Touring 7 Passenger",
            "2wd Ex",
            "Awd Touring 8 Passenger",
            "Awd Ex",
            "2wd Ex-l",
            "Sport",
            "Awd Elite",
            "2wd Ex-l 8 Passenger",
            "2wd Ex-l 7 Passenger",
            "Trailsport",
            "Awd Ex-l 8 Passenger",
            "Awd Sport",
            "2wd Touring 7 Passenger",
            "Awd Trailsport",
            "2wd Lx",
            "2wd Touring",
            " Sport",
            "Awd Black Edition",
            "2wd Sport",
            "Black",
            "Special Edition",
            "Awd Lx",
            "2wd Touring 8 Passenger",
            "Awd Lx/awd Sport",
            "Ex-l With Navi",
            "Awd Ex-l 7 Passenger",
            "Awd Ex-l W/navi",
            "Suv",
            "Black Edition",
            "2wd Ex-l W/navi",
            "Tour",
            "Elit",
            "Touring 7-passenger",
            "Touring 8-passenger",
            "Ex-l W/navi & Res",
            "Blac",
            "Ex-l With Res",
            "Trai",
            "Ex-l W/res",
            "Scat Pack",
            "4d Exl",
            "4d Ex",
            "Ex-l 8-passenger",
            "4d Lx",
            " S",
            "Ex-l 7 Passenger",
            "Ex-l 8 Passenger",
            "Altitude",
            "Spor",
            "Ex-l 7-passenger",
            "4x4",
            "-v6 U",
            "Hoe C1500",
            "Exl Exl",
            "Lx Lx",
            "Trai Trai",
            "Blac Blac",
            "Rt Elite",
            "100",
            "Ex Ex",
            "Ex-l Ex-l",
            "Elit Elit",
            "Lx/sport",
            "Tour Tour",
            "Se Se",
            "Spor Spor",
            "Exln Exln",
            "Ex-l Awd W/8-p Awd Ex-l 8 Passenger",
            "Touring 4wd W/ Touring",
            "Ex-l Navi",
            "Ex Automatic Ex",
            "Ex-l Awd Ex-l",
            "Touring 8p",
            "V6 U",
            "Tour Suv",
            "Ex-l Res",
            "Touring 7p",
            "4d 4 Tour",
            "Se-L",
            "X",
            "Granite"
          ]
        },
        {
          "model": "Ridgeline",
          "series": [
            "Rtl-E",
            "Rt",
            "Rtl-T",
            "Rtl",
            "Sport",
            "Rts",
            "Rtx",
            "Black Edition",
            "Trailsport",
            "Awd Sport",
            "Rtl W/leather",
            "Rtl-S",
            "Ex-L",
            "Se",
            "Awd Rtl",
            "2wd Sport",
            "Vp",
            "Dx",
            "Lx",
            "Trail Sport",
            "Rtl With Moonroof",
            "Rtl W/leather & Navi",
            "Ridgel Rtl",
            "Rtl W/leather/rtl W/leather & Navi",
            "Rtl/rtl With Moonroof/rtl With Moonroof   Navi",
            "Rtl/rtl With Moonroof",
            "2wd Rtl",
            "Ex-L/vp",
            "Touring",
            "Vp Vp",
            "Special Edition",
            "Sport+"
          ]
        }
      ]
    },
    {
      "make": "Hummer",
      "models": [
        {
          "model": "H3",
          "series": [
            "Suv",
            "Suv Alpha",
            "Alpha",
            " Alpha",
            "H3t Luxury",
            "Suv H3x",
            "Suv Luxury",
            " Adventure",
            "Luxury",
            "Suv Adventure",
            "Adventure",
            "T",
            "Hummer",
            "T Luxury",
            "Suv Suv Adventure",
            "H3t",
            " Alpha Leather",
            " Luxury",
            " H3x",
            "T Alpha",
            "Adventu",
            "X",
            "T Advent",
            "H3x"
          ]
        },
        {
          "model": "H3T",
          "series": [
            "Alpha",
            "Alpha T Alpha",
            "Alpha Leather"
          ]
        }
      ]
    },
    {
      "make": "Hyundai",
      "models": [
        {
          "model": "Accent",
          "series": [
            "Se",
            "Gs",
            "Gls",
            "Gl",
            "Sel",
            "Gls/se",
            "Se/sel",
            "Gls/gs",
            "L",
            "Se/value Edition",
            "Gls/gt",
            "Gl/gt",
            "Value Edition",
            "Gls/gs/se",
            "Blue",
            " Touring Gls",
            "Sport",
            "Limited",
            "Imited",
            "Ignature",
            "Gl/gls/l",
            "Base",
            "Se/sport",
            " Se",
            "Blue/gs",
            " Sel",
            "E Sport",
            "Le",
            "Preferred",
            "Gt/gl/gls",
            "E Limited",
            "Hybrid",
            "Z Gls",
            "Essential With Comfort Package Auto Ivt",
            "E",
            "E Sel",
            "Preferred Auto Ivt",
            "Gs/se",
            "Blue/acce",
            "Gt",
            "Auto Se",
            "Blu",
            "Auto Gls",
            "Man Gs",
            "Lim",
            "Ultimate Auto Ivt",
            "Gl Sport",
            "Al W",
            "E Edition",
            "Gt/gl",
            "Rse Ls",
            "Bas",
            "(pr)",
            "10t",
            "Gl/",
            "4d",
            " Limited",
            "Auto Gs",
            "Spo",
            "Man Se",
            "Man Gls",
            "Sport/se",
            "Gt/gls",
            "L/gl/gl W/sport Pkg",
            "S",
            "Gs/",
            "Altitude",
            "Dition",
            "Se/",
            "L/le/gl/se/gls",
            "Gl/gs",
            "Sel Plus",
            "Essential",
            "Spo Spo",
            "L Sport",
            "Gs Gs",
            "Mited",
            "Gl Se",
            "Gl/gl Sport/l",
            "Gs/gs W/premium Pkg/sr",
            "Hat",
            "Gl/gls",
            "Gl Gl",
            "25th Anniversary/gl/gls/l",
            "Gsl",
            "Ultimate",
            " Blue",
            "Gs/sr",
            "5",
            "Gsi",
            " 3.8l",
            "Line",
            "E Gls",
            "E Calligraphy",
            "Gs/gt"
          ]
        },
        {
          "model": "Azera",
          "series": [
            "Limited/se",
            "Gls",
            "Limited",
            "Gls/limited",
            "Se",
            "Se/limited",
            "Limi",
            "A6)",
            "6",
            "Gls/",
            "Se/l",
            "D",
            "Ited",
            "Mited",
            "Limi Limi",
            "Er",
            "Base (a6)",
            " Se"
          ]
        },
        {
          "model": "Creta",
          "series": []
        },
        {
          "model": "Creta Grand",
          "series": []
        },
        {
          "model": "Elantra",
          "series": [
            "Se",
            "Limited",
            "Sel",
            "Blue",
            "Gt/gls",
            "Gls",
            "Limited (ulsan Plant)",
            "Gt",
            "Gls (ulsan Plant)",
            "Value Edition",
            "N Line",
            "Gls/limited",
            "Hybrid Blue",
            "Se (ulsan Plant)",
            "Touring",
            "Touring Gls",
            "Eco",
            "Gs",
            "Touring Se",
            "Gls/gt",
            "Limited/gls/se",
            "Sport",
            "Gls/se",
            "Gl",
            "Gls/limited/se",
            "Limited/gls",
            "Gt Sport",
            "Coupe Gs",
            "Sel/value/limited",
            "Se/sport/limited",
            "Hybrid Limited",
            "Limited Ulsan Plant",
            "Se/value/limited",
            "Gs/se",
            "Gls/gt/limited",
            "Gls Ulsan Plant",
            "Blue/gls/se",
            "Gls/se/limited",
            "N",
            "Preferred Ivt",
            "Preferred Auto Ivt",
            "Preferred With Sun And Safety Package Auto Ivt",
            "Gl/gls",
            "Gt N Line",
            "Essential",
            "Le-R",
            "Essential Ivt With Hyundai Smartsense Package",
            "Co",
            "Preferred W/tech Package",
            "Essential Auto Ivt",
            "Touring Gls/se",
            "Limited/sel/value Edition",
            "Touring Gl/gls/gls Sport/l",
            "Gl Se",
            "Preferred",
            "Ultimate Ivt",
            "Preferred Ivt With Sun And Tech Package",
            "Touring Gl",
            "Base",
            "Ex",
            "Luxury",
            "L",
            "Ve",
            "Limited/se/value Edition",
            "L+",
            "Blue/gls/gls Pzev/se/se Pzev",
            "Gls/ltd/se",
            "Gls Pzev",
            "Ltd Pzev",
            "Se Ulsan Plant",
            "Base (a4)/base (m5)",
            "Preferred Ivt With Tech Package",
            "Essential Manual",
            "4d",
            "Gl/gls/l/limited",
            "Sport Appearance",
            "Ultimate Ivt With Tech Package With Two-tone Interior",
            "Luxury Ivt",
            "Le",
            "Limited Pzev",
            "L Limited",
            "Ultimate Ivt With Tech Package",
            "Hybrid Preferred",
            "Hybrid Luxury",
            "Gls/se/ltd",
            "N Line Dct",
            "Gt Gls",
            "To",
            "Gl Sport",
            "Gls (ulsan Plant)/limited (ulsan Plant)",
            "N Line Unlimited Dct",
            "Ultimate",
            "Touring L",
            "Imited",
            "Limited Ultimate",
            "Sport Tech",
            "Touring L/gl",
            "Sp",
            "Sport Dct",
            "Ls",
            "E Edition/limited",
            "Preferred Preferred",
            "Li",
            "Hybrid Luxury W/two-tone Interior",
            "/gls Pzev/se",
            "E",
            "Hybrid Ultimate",
            "Limited/se",
            "Se/limited",
            "Sel Automati Sel",
            "Ec",
            "Ltd",
            "Value Edition/limited/sel",
            "Bl",
            "Sr/sr5/trd Sport",
            "Value Edition/sel",
            "Se/elantra Limite",
            "Select",
            "N Plant)",
            "An Plant)",
            "(ulsan Plant)",
            " Plant",
            "N Plant",
            "Ulsan Plant",
            "Coupe Gs/se",
            "K2500 Custom",
            "Se/limited/value Edition",
            "Value Edition Value Edition",
            "Elant Glsw",
            "/gl",
            "N-",
            "-4",
            "Elntra",
            "N-Line",
            "Blue/sel Sport",
            "-",
            "Sw",
            "Ba Ba",
            "Blue/gls/gls Pzev/se",
            "Se Pzev",
            "Limited/value Edition/sel",
            "Se/value Edition/limited",
            "Gls/gls Pzev/se/se Pzev",
            "Ition",
            "Sel/value Edition/limited",
            "Gls/ltd",
            "Lu",
            "Sel Convenience",
            "Se Se",
            "Sle",
            "2d Gs/se",
            "Lx/s/se",
            "Gl/gls/gl W/sport/limited",
            "Pzev",
            "E/limited",
            "Ted",
            "/se",
            "/limited",
            "Ed",
            "Ba",
            "D",
            "Wagon",
            "I",
            "Elentra",
            "Coupe Gs Pzev",
            " Edition/limited",
            "Ition/limited/sel",
            "Se/value Edition",
            "Co Co",
            "Gls Automati Gls",
            "Preferred W/sun Safety Package",
            "Sport Manual",
            "Li Li",
            "Luxury Hybrid",
            "Luxury Ivt With Two-tone Interior",
            "Sel Sport",
            "Hy",
            "Xle/night Shade/limited",
            "Police Interceptor",
            "Gl/gls/gls Sport/limited",
            "Limited Se",
            "(cv 1)",
            "Se/ve",
            "Preferred Hybrid",
            "Value Editio Value Edition",
            "Gl/ve",
            "Gl/l",
            "Essential/luxury/luxury W/two-tone Interior/preferred/preferred W/tech Package",
            "N Line Ultimate",
            "2d",
            "(c",
            "Gt Se",
            "Ultimate Hybrid",
            "Luxury/preferred/ultimate",
            "Luxury/luxury W/two-tone Interior/preferred/preferred W/tech Package",
            "Luxury W/two-tone Interior",
            "(ov1)",
            "Essential Ivt With Hyundai Smartsense Package/preferred Ivt/preferred Ivt With Tech Package",
            "W/intelli Se"
          ]
        },
        {
          "model": "Elantra Coupe",
          "series": [
            "Gs/se",
            "Gs",
            "Se",
            "Gs Pzev",
            "2d Gs/se"
          ]
        },
        {
          "model": "Elantra GT",
          "series": [
            "Sport",
            "Base W/blue",
            "Elantra Gt",
            "N Line",
            "Gl",
            "Gls",
            "Preferred",
            "Luxury Auto",
            "Se",
            "L",
            "Gls Tech",
            "N Line Ultimate",
            "Gl Se",
            "Preferred Auto",
            "Base (a6)",
            "Blue Int",
            "W/blue Int",
            "Gt",
            "Preferred Manual",
            "Sport Ultimate",
            "Luxury",
            "Gl/gls/l/limited",
            "N Line Ultimate Dct",
            "Outback Awp",
            "Preferred Preferred",
            "N Line Dct",
            "Limited"
          ]
        },
        {
          "model": "Elantra N",
          "series": [
            "Dct",
            "Line",
            "Elantra N",
            "Base Dct",
            "L",
            "N",
            "Manual"
          ]
        },
        {
          "model": "Entourage",
          "series": [
            "Gls",
            "Gls/limited/se",
            "Limited/gls",
            "Limited/gls/se",
            "Gls/limited",
            "Gls/se/limited",
            "Gl",
            "Limited",
            "Se",
            "Gls/se/ltd",
            "Gl/gls",
            "Gl/gls/l/limited"
          ]
        },
        {
          "model": "Equus",
          "series": [
            "Signature",
            "Ultimate",
            "Signature/ultimate",
            "Sign",
            "Ure",
            "Ure/ultimate",
            "Te"
          ]
        },
        {
          "model": "EX6",
          "series": []
        },
        {
          "model": "EX8",
          "series": []
        },
        {
          "model": "Genesis",
          "series": [
            "3.8",
            "3.8l",
            "3.8 Track",
            "4.6",
            "Coupe 2.0t",
            "5.0",
            "5.0l",
            "2.0t Premium",
            "3.8 Base",
            "2.0t",
            "3.8 Grand Touring",
            "Coupe 3.8 R-spec",
            "Mate",
            "Coupe 3.8l",
            "4.6l",
            "5.0 R-spec",
            "2.0t R-spec",
            "3.8 R-spec",
            "3.8 Ultimate",
            "3.8l/3.8 R-spec/3.8 Ult",
            "3.8 Premium",
            "Track",
            "Co",
            "3.8 Luxury",
            "Sedan Luxury",
            "E",
            "T",
            "2.0t Track",
            "V6",
            "3.8 Technology",
            "5.0l R-spec",
            "4.6 Technology",
            "G80 Sport",
            "3.8 Gt",
            "V8",
            "Sedan",
            "G80",
            "4.",
            "5.",
            "3.",
            "/3",
            "Coupe 2.0t R-spec",
            "G80 Base",
            "Ec",
            "K",
            " 2.0t",
            "D Touring",
            "2.",
            "Mium",
            "Coupe",
            "G90",
            "Gen 3.8l/3",
            "G8",
            "Ium",
            "Gen",
            "Sedan W/premium Pkg",
            "Sedan Technology",
            "Pec",
            "3.8 Gt Navigation",
            "2.0t Gt",
            "Aw",
            "3.8/3.8 Premium/3.8 Technology",
            "Track W/nav",
            "R-spec V6",
            "4d",
            "5.0 Ultimate"
          ]
        },
        {
          "model": "Genesis Coupe",
          "series": [
            "2.0t",
            "3.8 R-spec/3.8 Ultimate",
            "3.8l",
            "3.8l/3.8 R-spec/3.8 Ult",
            "3.8 R-spec",
            "3.8 Grand Touring",
            "C/3.8 Ult",
            "Track",
            "3.8l Ultimate",
            "2.0t R-spec",
            "2.0t Premium",
            "3.8l R-spec",
            "Track W/nav",
            "3.8 Track",
            "Premium",
            "W/nav",
            "W/blk Lth",
            "Grand Touring W/blk Lth",
            "Grand Touring W/brn Lth",
            "R-Spec",
            "Grand Touring W/nav",
            "3.8l Base",
            "Grand Touring",
            "3.8 Ultimate",
            "Ing",
            "W/brn Lth",
            "3.8",
            " Ultimate",
            "Ultima 3.8 Ultimate",
            "3.8 Base",
            "2.0t Track"
          ]
        },
        {
          "model": "Grand i10",
          "series": []
        },
        {
          "model": "H200",
          "series": []
        },
        {
          "model": "H300",
          "series": []
        },
        {
          "model": "H400",
          "series": []
        },
        {
          "model": "H500",
          "series": []
        },
        {
          "model": "HD55",
          "series": []
        },
        {
          "model": "HD65",
          "series": []
        },
        {
          "model": "HD78",
          "series": []
        },
        {
          "model": "Ioniq",
          "series": [
            "Limited",
            "Hybrid Blue",
            "Hybrid Sel",
            "5 Limited",
            "6 Sel",
            "Hybrid Limited",
            "5 Se",
            "Blue",
            "5 Sel",
            "Sel",
            "Plug-in Hybrid Se",
            "Hybrid Se",
            "Plug-in Hybrid Limited",
            "Electric Limited",
            "Se",
            "6 Limited",
            "Plug-in Hybrid Sel",
            "6 Se",
            "Plug-in Hybrid",
            "6 Se Standard Range",
            "Electric",
            "Electric Se",
            "Hybrid Preferred",
            "Plug-in Hybrid Preferred",
            "Electric Ultimate",
            "Preferred Electric Plus",
            "Hybrid Essential",
            "Ultimate",
            "Ev Se",
            "6 Preferred Long Range",
            "Preferred",
            "Limi Limi",
            "Plug-in Hybrid Ultimate",
            "Blue Hybrid",
            "Ev Limited",
            "6 Preferred Long Range With Ultimate Package",
            "Electric Preferred",
            "D",
            "Limi",
            "Ultimate Electric Plus",
            "Hybrid",
            "Ev Preferred",
            "Ev",
            "5 Li",
            "Ev Electric",
            "Ulti",
            "Pref",
            "Hybr",
            "6 Li",
            "Elec",
            "Se Se",
            "Se Hybrid",
            "Sel Sel",
            "Preferred Hybrid",
            "5 Preferred",
            "Ultimate Electric"
          ]
        },
        {
          "model": "Ioniq 5",
          "series": [
            "Sel",
            "Se",
            "Limited",
            "Preferred",
            "Se Standard Range",
            "Preferred Long Range",
            "Preferred Long Range With Ultimate Package",
            "Limited/disney 100 Platin",
            "Li",
            "N",
            "Limited/disney 100 Platinum Edition",
            "Disney100 Platinum Edition",
            "Preferred Long Range With Luxury Package/preferred Long Range With Ultimate Package",
            "Xrt"
          ]
        },
        {
          "model": "ix35",
          "series": []
        },
        {
          "model": "Kona",
          "series": [
            "N Line",
            "Limited",
            "Se",
            "Sel",
            "Ultimate",
            "Night",
            "Sel Plus",
            "N Base",
            "Essential Awd",
            "Preferred Awd",
            "Essential",
            "Sel/tech",
            "Luxury Awd",
            "Sel/se",
            "Ev Limited",
            "Preferred Awd With Sun And Leather Package",
            "Ev Sel",
            "Ultimate Awd",
            "Iron Man",
            "Le N Line Awd",
            "Essential 4p Ti",
            "Trend Awd",
            "2.0l Luxury",
            "Trend Awd With Two-tone Roof",
            "Preferred Preferred",
            "Preferred",
            "2.0l Preferred",
            "Trend 1.6t",
            "2.0l Essential",
            "N Line With Ultimate Package",
            "2.0l Preferred With Trend Package",
            "Se Se",
            "1.6t Trend",
            "1.6t Ultimate",
            "Limit",
            "1.6t N Line",
            "1.6t N Line Ultimate",
            "Trend Awd With Urban Edition Package",
            "Ultim",
            "Preferred Awd Special Edition",
            "N Lin",
            "Ev Ultimate",
            "Ev",
            "Ev Preferred",
            "Sel P",
            "Ech",
            "Ult",
            "Essen",
            "N Bas",
            "4d 4w",
            "Awd",
            "N Line S",
            "Ate",
            "Ed",
            "Lus",
            "Man",
            "E",
            "Ultimate Awd With Red Colour Pack",
            "Ultim Ultim",
            "1.6t N Line With Two-tone Roof",
            "Hybrid/sel",
            "Sel Convenience",
            "Preferred Electric",
            "1.6t",
            "N Line Ultimate",
            "Essential Awd Value Edition",
            "1.6t N Line/1.6t N Line Ultimate/1.6t N Line Ultimate With Two-tone Roof",
            "Luxury Awd/preferred Awd",
            "1.6t N Line Ultimate/1.6t N Line Ultimate With Two-tone Roof",
            "Preferred Sport",
            "Ultimate Electric",
            "N Line Awd With Ultimate Package/n Line Ultimate/preferred Sport Awd",
            "1.6t N Line Ultimate W/two-tone Roof",
            "1.6t N Line Ultimate W/two-tone Roof/1.6t N Line W/two-tone Roof/n Line Awd",
            "2.0l Preferred/2.0l Preferred With Trend Package",
            "Prefe",
            "Luxury",
            "Preferred Awd With Trend Package"
          ]
        },
        {
          "model": "Kona Electric",
          "series": [
            "Ultimate W/sage-green Interior",
            "Se",
            "Sel",
            "Limited",
            "Ultimate",
            "Preferred",
            "Preferred With Two-tone Roof",
            "Ultimate W/two-tone Interior",
            "Ultimate W/two-tone Exterior"
          ]
        },
        {
          "model": "Kona N",
          "series": [
            "Line",
            "2.0t",
            "Bas",
            "Base",
            "Lin",
            "Line Ultimate"
          ]
        },
        {
          "model": "Nexo",
          "series": [
            "Limited",
            "Blue",
            "Limit",
            "Ed"
          ]
        },
        {
          "model": "Palisade",
          "series": [
            "Limited",
            "Sel",
            "Calligraphy",
            "Se",
            "Sel Premium",
            "Luxury 7-passenger Seating",
            "Calligraphy Night Edition",
            "Xrt",
            "Preferred",
            "Ultimate",
            "Ultimate Calligraphy",
            "Luxury 8-passenger Seating",
            "Urban 8-passenger Seating",
            "Calligraphy/calligraphy Night Edition",
            "Luxury",
            "Essential",
            "C",
            "Palisade S",
            "L",
            "S",
            "Calligraphy/calligraphy N",
            "Palisada",
            "Ltd",
            "X",
            "Hy",
            "Urban 7-passenger Seating",
            "Preferred/urban 7-passenger Seating/urban 8-passenger Seating",
            "Ultimate Calligraphy Ultimate Calligraphy",
            "Preferred/urban 7-passenger Seating/urban 8-passenger S",
            "Ultimate Calligraphy With Beige Interior",
            "Essential Fwd",
            "Essential Awd",
            "Ultimate Calligraphy/urban 7 Passenger Seating",
            "Ultimate Calligraphy/ultimate Calligraphy Night",
            "Urban"
          ]
        },
        {
          "model": "Santa Cruz",
          "series": [
            "Limited",
            "Sel",
            "Night",
            "Se",
            "Sel Premium",
            "Ultimate Awd",
            "Preferred Awd",
            "Xrt",
            "Ultimate",
            "         Santa Cruz",
            "Preferred",
            "Trend",
            "Trend Awd",
            "Preferred Awd With Trend Package",
            "Sel Activity",
            "Preferred/preferred Awd"
          ]
        },
        {
          "model": "Santa Fe",
          "series": [
            "Gls",
            "Sport",
            "Limited",
            "Se",
            "Sport 2.4l",
            "Limited/se",
            "Limited V6",
            "Sport 2.0t Ultimate",
            "Sel",
            "Limited 2.0t",
            "Se Ultimate",
            "Gls/lx",
            "Sport 2.0t",
            "Limited Ultimate",
            "Base (a4)/base (m5)",
            "Lx/gls",
            "2.7l V6 Gls/2.7l V6 Lx/gls",
            "Sel 2.0t",
            "Sport 2.0l Turbo",
            "Hybrid Limited",
            "Calligraphy",
            "Sel Premium",
            "Se/limited",
            "Xl Se",
            "Hybrid Blue",
            "Sel/xrt",
            "Plug-in Hybrid Limited",
            "Gls V6",
            "Sport 2.0t Limited",
            "Xrt",
            "Xl Se Ultimate",
            "Blue",
            "Limited 3.5",
            "Preferred",
            "Hybrid Sel",
            "Ultimate",
            "Hybrid Sel Premium",
            "L",
            "Gls/limited",
            "Sel/sel Plus",
            "Sport 2.4 Premium",
            "Ultimate 2.0t",
            "Sport 2.4 Se",
            "Limited/ultimate",
            "Gl",
            "Plug-in Hybrid Sel Convenience",
            "Sport 2.4 Luxury",
            "Sel Plus",
            "Preferred Awd With Sun And Leather Package",
            "Sport 2.0t Se",
            "Ultimate Turbo Awd",
            "Luxury Plug-in Hybrid Awd",
            "Sport 2.4 Base",
            "Preferred Awd With Trend Package",
            "Limited/gls",
            "2.7l V6 Gls/2.7l V6 Lx",
            "Preferred Awd",
            "S",
            "Luxury Hybrid Awd",
            "Gl (4 Cyl)",
            "G",
            "Gl 3.5 Sport",
            "Gl Sport",
            "Preferred 2.4",
            "Essential Awd With Smartsense Package",
            "Xl",
            "Hybrid Calligraphy",
            "Essential",
            "Gl 2.4 Premium",
            "2.0t Limited",
            "Gl 3.5/gl 3.5 Sport",
            "Luxury",
            "Essential Awd",
            "Gl 2.4",
            "2.0t",
            "Ultimate 2.0",
            "Sport 2.0t Premium",
            "Preferred Hybrid Awd With Trend Package",
            "Ultimate Calligr 2.5t",
            "Gl 5pass",
            "Urban Awd",
            "X",
            "Sport Limited Adventure Edition",
            "2.4 Premium",
            "Premium",
            "Ultimate Calligraphy",
            "Gl 3.5",
            "2.0t Sport",
            "T",
            "2.0t Sport W/saddle Int",
            "Um",
            "4",
            "Gls W/xm",
            "Ls",
            "Santafe",
            "Lx",
            "Sante Fe",
            "/saddle Int",
            "C",
            "Limited/limited W/xm/se/se W/xm",
            "Gls/gls W/xm",
            "Sport 2.4l (a6)",
            "S S",
            "Plug-in Hybrid Sel",
            "B",
            "6",
            ".0t",
            "Se/limited/se W/xm/limited W/xm",
            " 150",
            "Sntfe Awd",
            "Xl Limited",
            "Se W/sulev",
            "Sel W/sulev",
            "Limited W/saddle Int",
            "Limited W/sulev",
            "Santa Fe C",
            "/sulev",
            "Ltimate",
            "T W/saddle Int",
            "Ev",
            "Te",
            "Hy",
            "D",
            "Se Ultimate/limited",
            "V",
            "Lus",
            "Ed",
            "Se Awd Se",
            "Urban",
            "Preferred Turbo Awd With Sun And Leather Package",
            "2.4l/2.4l Gl",
            "C C",
            "Luxury Turbo Awd",
            "Limited 2.0t/ultimate 2.0t",
            "Preferred 2.0",
            "Essential Fwd",
            "2.4 Luxury",
            "Limited Ultimate/se Ultimate",
            "Sport 2.4",
            "Gl/gls",
            "Luxury 2.0t",
            "U",
            "Se/limited Awd",
            "Essential Fwd With Smartsense Package",
            "X X",
            "Xl Ultimate",
            "Ultimate Calligraphy W/beige Interior",
            "Gl V6",
            "2.0t Se",
            "Santa Gls",
            "Ultimate Calligraphy/ultimate Calligraphy Hybrid Awd Nhl Special Edition",
            "Preferred Hybrid Awd/preferred Hybrid Awd With Trend Package",
            "Luxury Hybrid",
            "Imited Sport",
            "Xl Luxury"
          ]
        },
        {
          "model": "Santa Fe XL",
          "series": [
            "Se",
            "Limited",
            "Luxury",
            "Limited Ultimate",
            "Essential",
            "Preferred",
            "Ultimate",
            "Se Ultimate",
            "Premium",
            "Se Ultimate/limited Ultim",
            "Mate",
            "Se Ultimate/limited Ultimate",
            "Luxury Adventure Edition",
            "Limited Adventure Edition"
          ]
        },
        {
          "model": "Sonata",
          "series": [
            "Limited",
            "Gls",
            "Hybrid",
            "Limited/se V6",
            "Limited 2.0t",
            "Se",
            "Sel",
            "Sport",
            "Gls/lx",
            "Hybrid Sel",
            "Gls V6/lx V6",
            "Sport+",
            "Eco",
            "Sel Plus",
            "Se 2.0t",
            "Gl",
            "Hybrid Limited",
            "Plug-in Hybrid",
            "Lx V6/gls V6",
            "Gls V6",
            "Gls Pzev",
            "Sport 2.0t",
            "Se/limited",
            "2.4l Se",
            "Lx/gls",
            "Hybrid Blue",
            "Hybrid Se",
            "N Line",
            "Eco Turbo",
            "Limited V6",
            "Sel+",
            "Sport/limited/sel",
            "Hybrid Hybrid",
            "Gls/limited/se",
            "Hybrid Hybrid/limited",
            "Sport/limited",
            "Hybrid/limited",
            "Hybrid/se",
            "Blue",
            "Base W/2.7l V6",
            "Limited/sel/sport",
            "Essential",
            "Limited V6/se V6",
            "Preferred",
            "Se V6",
            "Limited Turbo",
            "Sport 1.6t 4dr",
            "Limited/se",
            "Plug-in Hybrid Limited",
            "Limited 2.0t+",
            "Base (a4)/base (m5)",
            "Se V6/limited V6",
            "2.4l",
            "Limited Pzev",
            "Gl V6",
            "Hybrid/blue",
            "Hybrid/sel",
            "Spo",
            "2.0t Limited",
            "Limited/limited W/xm/se V6",
            "Gls/gls W/leather",
            "Sport Tech",
            "E Se",
            "Ltd",
            "2.4l Sport",
            "Se/ltd/ltd W/wine Int",
            "Limited/gls/se",
            "Gls/2.4l Se/2.4l Limited/2.4l Limited W/wine Int",
            "2.4l Limited Pzev",
            "2.4 Sport",
            "2.0t",
            "S",
            "Plug-in Hybrid/limited",
            "N Line/night",
            "Luxury",
            "N Line Ultimate",
            "Hybrid Hybrid/se",
            "Gl/gls",
            "Ultimate",
            "2.4l Limited",
            "Hybrid Ultimate With Solar Roof",
            "Gls Special Edition",
            "Limited/sport",
            "Limited W/navi",
            "Limited Hybrid",
            "E Sport",
            "Limited 2.0t/se 2.0t",
            "Se/sport",
            "Hyb",
            "Base",
            "Hybrid Hybrid/blue",
            "1.6t Eco",
            " Se",
            "N Line Night Edition",
            "Ine Int",
            "Lim",
            "2.0t Sport Ultimate",
            "Hybrid Premium",
            "2.0t Ultimate",
            "Limited/sel/sel+/sport/sport+",
            "Sel/sport/limited",
            "Hybrid Limited W",
            "Preferred-Trend",
            "2.0t Se",
            "Gls/2.4l Se",
            "Limited+",
            "Limited W/wine Int",
            "(u.s.)",
            "Ltd W/wine Int",
            "Se/",
            "Ltd Pzev",
            "2.0t Sport",
            "N L",
            "Se/2.4l",
            "Mited W/wine Int",
            "Se/sport/limited",
            "Imited/sel",
            "Gl/",
            "Lx",
            " Hybrid",
            "Night",
            "Se Se",
            "S10",
            "Se/sonata Limited",
            "/gl/",
            "+",
            "Ec",
            "4d",
            "(u.s.) Hybrid",
            "Ited/se",
            ".0t",
            " V6",
            "Limited/se W/xm/se/limited W/xm",
            "Se/limited/se W/xm/limited W/xm",
            "Base A4/base M5",
            "Gls/gls W/xm",
            "Gls/gls Special Value/lx",
            "L",
            "Hybrid Hybrid/sel",
            "Gls/se/limited/limited W/wine Int",
            "Santa Gls",
            "Plug-in Hybrid Plug-in Hybrid",
            "E Limited",
            " 2.0t",
            "Base W/2.7l V6 (a4)/base W/2.7l V6 (m5)",
            "/gl",
            "Bas",
            "Del",
            "Pre",
            "Se/sel",
            "4d 4d",
            "/ef",
            "Gls/se/limited",
            "Limited Pzev W/wine Int",
            "Ltd W/17\" Wheels",
            "Sport/limited/sel/sel+",
            "Ltd Pzev W/wine Int",
            "2.4l Limited Pzev W",
            "Se Pzev",
            "2.0",
            "Se *ltd Avail*/limited/se",
            "2.4l Limited W/wine Int",
            "Plu",
            "V-6",
            "Gl/gl W/srf/gls",
            "Se/ltd",
            "2.0t Limited W/wine Int",
            "Ort",
            "Gls/lx/gls Special Value",
            "Plug-in Hybrid Limited W",
            "Sonota",
            "V",
            "Mited",
            " Pzev",
            " W/wine Int",
            "Ted",
            "7\" Wheels",
            "V W/wine Int",
            "Imited",
            "Night Edition",
            "L Se",
            "Mited Pzev W",
            "Le",
            "Hybrid/hybrid Limi",
            "Gls Gls",
            "O",
            "/sel/sport",
            "Ltd W",
            "Se/ltd/ltd W",
            " Pzev W/wine Int",
            "Touring",
            "Mited Pzev",
            "Base W/2.7l V6 (a4)",
            "Base (a4)",
            "Blu Blu",
            "Limited W/nav",
            "Sport 1.6t",
            "Lux",
            "N L N L",
            "Plu Plu",
            "Ca Vehicle Grand Vita",
            "N-Line",
            "Ef",
            "Gl V6/gls V6",
            "Gl V6/gl V6 Sport/limited V6",
            "Gl/gl Premium/gl Sport/limited",
            "Lx V6",
            "Gl Sport",
            "E Gls",
            "Gls Tech",
            "N-line Ultimate",
            "Luxury 1.6t",
            " Touring Gls",
            "Sel Convenience",
            "Luxury Hybrid"
          ]
        },
        {
          "model": "Starex",
          "series": []
        },
        {
          "model": "Tucson",
          "series": [
            "Se",
            "Sport",
            "Limited",
            "Night",
            "Ultimate",
            "Sel",
            "Value",
            "Limited/se",
            "Gls",
            "Blue",
            "Se Plus",
            "N Line",
            "Limited/sport And Eco/se",
            "Limited/gls",
            "Eco",
            "Gl",
            "Gls/lx",
            "Sel Plus",
            "Hybrid Sel Convenience",
            "Hybrid Limited",
            "Gls/limited",
            "Limited/sel/sport/ultimat",
            "Limited V6/se",
            "Preferred Awd",
            "Plug-in Hybrid Limited",
            "Limited/sel/sport/ultimate/value",
            "N Line/xrt",
            "Xrt",
            "Sel Convenience",
            "Limited V6",
            "Se 2.0l",
            "Hybrid Blue",
            "Gls/limited/se",
            "Preferred Awd With Trend Package",
            "Preferred",
            "Limited/sel/sport/ultimate/value/night",
            "Luxury",
            "Plug-in Hybrid Sel",
            "Se/limited",
            "Hybrid N Line",
            "Pieces",
            "Luxury Hybrid Awd",
            "Lx/gls",
            "Ultimate Hybrid Awd",
            "Se/value",
            "Essential Awd",
            "Premium",
            "L/gl/25th Anniversary",
            "Preferred Awd With Sun And Leather Package",
            "Essential Fwd",
            "Preferred W/trend Package",
            "Premium 1.6",
            "Essential",
            "Se/se Plus",
            "Ultimate Awd",
            "Preferred Fwd",
            "Se 1.6t",
            "Gls V6",
            "Lim",
            "Luxury 2.0l",
            "Gl/gls",
            "N Line/sel/xrt",
            "Gl V6",
            "Trend Awd",
            "1.6t",
            "L",
            "Essential W/safety Package",
            "Urban Edition",
            "Premium 2.0l",
            "Walking Dead Edition",
            "Preferred Preferred",
            "Base 2.0l",
            "Val",
            "Luxury Awd",
            "Plug-in Hybrid Luxury",
            "N Line Awd",
            "Luxury Hybrid",
            "Ultimate Hybrid",
            "Luxury/ultimate",
            "Sel Convenience Hybrid",
            "Gl/gls/l/premium",
            "Noir 1.6t",
            "Eco/limited/sport",
            "N-line Awd",
            "Limited/night/sel/sport/ultimate",
            "Plug-in Hybrid Ultimate",
            "Gls Pzev",
            "N Line/sel",
            "Eco/limited/night/sport/value",
            "Sel/n Line/xrt",
            "Competition",
            "Eco/sport/limited",
            "N L",
            "/sel/sport",
            "Sel Sel",
            "Lux",
            "Tuscon",
            "/sel/sport/ultimate/value",
            "Ander Se",
            "4d 2wd",
            "Atitude",
            "4d",
            "Se/",
            "4wd",
            "Fue",
            "Lim Lim",
            "Spo",
            "Limited Pzev",
            "Se Awd",
            "25th Anniversary",
            "Sel/limited/sport",
            "Limited/sport And Eco/se/",
            "Limited/sel/sport",
            "Limited/value",
            "Limited/eco/sport",
            "Se/sel/sel Plus",
            "Eco/sport/limited/night",
            "V",
            " Pzev",
            "S",
            "/sport And Eco/se",
            "Ited",
            "E",
            " Dead Edition",
            "Ted",
            "/se",
            "/value",
            "Blu",
            "Ited/se",
            "Venience",
            "/sel/sport/ultimat",
            "Limited/sel/sport/ultimate",
            "Gl Gl",
            "Lux Lux",
            "Essential/preferred",
            "Limited/limited V6/se",
            "Ultimate 1.6t",
            "Ult",
            "25th Anniversary/gl/l",
            "Gl/gls/l",
            "N-Line",
            "Gl V6/gls",
            "Spo Spo",
            "Trend",
            "Luxury Awd/n-line Awd/ultimate Awd",
            "Gl V6/limited",
            "E G29",
            "Ultimate Plug-in Hybrid Awd",
            "N-line Hybrid",
            "Suv",
            "N-line Hybrid Awd",
            "Sel/sel Plus"
          ]
        },
        {
          "model": "Veloster",
          "series": [
            "Turbo W/black",
            "Base W/black",
            "Base W/gray",
            "Value Edition",
            "Turbo",
            "Base W/red/black",
            "Turbo W/blue",
            "Base",
            "N",
            "2.0",
            "2.0 Premium",
            "Turbo Rally Edition",
            "W/tech",
            "Tech",
            "Base W/red",
            "Turbo R-spec",
            "Mix",
            "Flex",
            "Turbo/turbo R-spec/turbo",
            "Re:flex",
            "Turbo Ultimate",
            "Re:mix",
            "W/red Int",
            "Re:flex W/red",
            "Re:flex W/black",
            "Flex W/black",
            "Rally",
            "Turbo/turbo R-spec/turbo Ultimate",
            "Flex W/red",
            "Premium",
            "Se",
            "2.0 Gl",
            "Base W/black/base W/gray/base W/red/re:flex W/black/re:flex W/red",
            "Base W/black/base W/gray/base W/red/re:mix",
            "Preferred",
            "Turbo W/black Int",
            "W/black Int",
            "T",
            "W/gray Int",
            "B",
            "Turbo W/blue Int",
            "Nt/w",
            "3dr",
            "Bo R-spec/turbo",
            "Ay",
            "Ack",
            "Lack",
            "Gray Int",
            "Base W/yellow Accent (a6)",
            "Black Int",
            "Base W/black/base W/gray/base W/red/re:flex W/black/re:",
            "Base W/black (m6)",
            "A",
            "W/black Int/w",
            "Int",
            "Tion",
            "Imate",
            "Turbo Int",
            "Nt",
            "Lack Int",
            "Pec",
            "Lue Int",
            "Ly Edition",
            "Um",
            "Red Int",
            "Turbo Manual",
            "Turbo W/black/turbo W/blue",
            "Black Int/w/gray Int/re:mix/w/red Int",
            "Base (m6)",
            "S",
            "Turbo Tech",
            "Se/tech",
            "Base W/black/base W/gray/base W/red/black"
          ]
        },
        {
          "model": "Veloster N",
          "series": [
            "Veloster N",
            "Manual",
            "N",
            "Dct"
          ]
        },
        {
          "model": "Venue",
          "series": [
            "Sel",
            "Se",
            "Limited",
            "Trend",
            "Sel/limited",
            "Preferred",
            "Sel/denim",
            "Denim",
            "Preferred With Two-tone Body Colour",
            "Essential With Two-tone",
            "Ultimate With Black Interior",
            "Essential",
            "Essential Auto Ivt With Two-tone Body Colour",
            "Preferred With Two-tone",
            "Essential Auto Ivt",
            "Essential Manual",
            "Trend With Urban Edition Package With Denim Blue Interior Colour Pack",
            "Essential With Two-tone Body Colour",
            "Denim/sel",
            "Ultimate",
            "Urban With Black Interior",
            "Limited/sel",
            "4d 2",
            "D",
            "Mited",
            "Nim",
            "Ultimate With Denim Blue Interior Colour Pack",
            "Sel Sel",
            "Trend With Urban Edition Package With Grey-lime Interior Colour Pack",
            "Preferred Preferred",
            "Ultimate With Denim Interior",
            "Preferred/preferred With Two-tone/ultimate With Black Interior/ultimate With Denim Interior",
            "Essential W/two-tone",
            "Ultimate W/black Interior (ivt)"
          ]
        },
        {
          "model": "Veracruz",
          "series": [
            "Limited",
            "Gls",
            "Gls/limited/se",
            "Gls/se/limited",
            "Limited/gls/se",
            "Gls/limited",
            "Gl V6",
            "Limited V6",
            "Gls V6",
            "G",
            "Ed",
            "G G",
            "Gl"
          ]
        }
      ]
    },
    {
      "make": "Infiniti",
      "models": [
        {
          "model": "EX35",
          "series": [
            "Journey",
            "Base",
            "Essential",
            "Base/journey",
            "/journ",
            "Ase",
            "Ed Sport 400",
            "Base Base",
            "Journey Awd"
          ]
        },
        {
          "model": "EX37",
          "series": [
            "Journey",
            "Base",
            "Luxe",
            "Base/",
            "Ase",
            "Luxury"
          ]
        },
        {
          "model": "FX35",
          "series": [
            "Base (a5)",
            "Limited Edition",
            "W/options",
            "O Options",
            "Options",
            "Suv"
          ]
        },
        {
          "model": "FX37",
          "series": [
            "Limited Edition",
            "Limited Edition/premium"
          ]
        },
        {
          "model": "FX50",
          "series": [
            "Base (a5)"
          ]
        },
        {
          "model": "G25",
          "series": [
            "Journey",
            "Base",
            "X",
            "Sedan X",
            "Sedan",
            "Sedan Journey",
            "Sedan Base",
            " X",
            "Base Base"
          ]
        },
        {
          "model": "G37",
          "series": [
            "Journey",
            "Base",
            "Sport",
            "Journey/sport",
            "Journey/ipl",
            "X",
            "S Sport",
            "Anniversary Edition",
            "Sedan",
            "Ipl",
            "Sedan X",
            "Sedan Journey",
            "Limited Edition",
            "Sport Appearance Edition",
            "Coupe Journey",
            "Sport/ipl",
            "Coupe Sport",
            "Anniversary Edition/journey/s Sport",
            "Sedan Sport",
            "Limited Edition/sport",
            "Convertible",
            "Coupe",
            "Convertible Base",
            "/journe",
            "Sedan Journey/sport",
            "Journe",
            "Anniversary Edition/sport",
            "Base/s",
            "Coupe Journey/sport",
            "Coupe X",
            "Coupe Anniversary Edition",
            "Sedan X Sport Appearance",
            "Sedan Sport 6mt",
            "Sedan Base",
            "Coupe Sport 6mt",
            "Sedan Sport Appearance Edition",
            "Sedan X Limited Edition",
            "Coupe Base",
            "Coupe Ipl",
            "Sedan Anniversary Edition",
            "Convertible Anniversary Edition",
            "Convertible Sport",
            "Convertible Sport 6mt",
            "Convertible Ipl",
            "Coupe Ipl 6mt",
            "Sedan Base/journey/sport",
            "Convertible Sport/ipl",
            "Convertible Limited Edition",
            "Sport/",
            "Convertible Base/sport",
            " Sport Appearance Edition",
            "Coupe Base/journey/sport",
            "Sedan Limited Edition",
            " X",
            "Coupe Journey/ipl",
            "Sedan Journey/sport 6mt",
            " Limited Edition",
            "Awd",
            " Anniversary Edition",
            "Sport 6mt",
            "Conver",
            "Base Base",
            "Sport Sport",
            "Limited Edition/sport Appearance Edition",
            " S",
            "Base/j Base"
          ]
        },
        {
          "model": "JX35",
          "series": [
            "Base (cvt)",
            "Awd",
            "35"
          ]
        },
        {
          "model": "M35",
          "series": [
            "Sport",
            "Base",
            "Base A5",
            "X",
            "Awd",
            "H",
            "Base (a5)",
            "Sedan/",
            "Base Base",
            "Luxury"
          ]
        },
        {
          "model": "M35h",
          "series": [
            "Hybrid",
            "H"
          ]
        },
        {
          "model": "M37",
          "series": [
            "X",
            "Base A7",
            " X",
            "Base (a7)",
            "X Awd",
            "X X"
          ]
        },
        {
          "model": "M45",
          "series": [
            "Base",
            "Sport",
            "Sdn",
            "Awd"
          ]
        },
        {
          "model": "M56",
          "series": [
            "X",
            "Es/le/be",
            " X"
          ]
        },
        {
          "model": "Q40",
          "series": [
            "Base (a7) (eop February 2015)",
            " Base"
          ]
        },
        {
          "model": "Q50",
          "series": [
            "Premium",
            "Pure",
            "Sensory",
            "2.0t Luxe",
            "Luxe",
            "Hybrid Sport",
            "3.0t Luxe",
            "2.0t Premium",
            "Base",
            "2.0t Base",
            "Red Sport 400",
            "3.0t Sport",
            "3.0t Premium",
            "2.0t Pure",
            "Sport",
            "Hybrid Premium",
            "3.0t Red Sport 400",
            "3.7",
            "3.0t Signature Edition",
            "Luxe Awd",
            "Premium/sport",
            "Luxe/sport/signature Edit",
            "Edition 30 Awd",
            "3.0t Luxe/3.0t Signature Edition/3.0t Sport",
            "Luxe/sport",
            "Edition 30",
            "Hybrid Luxe",
            "Red Sport 400 Awd",
            "Sensory Awd",
            "Signature Edition Awd",
            "Hybrid",
            "3.0t Luxe/3.0t Sport",
            "Pure/luxe",
            "2.0t Base/2.0t Premium",
            "Premium/sport/se",
            "Luxe/sport/signature Edition",
            "3.0t Premium/3.0t Signature Edition/3.0t Sport",
            "Pure/luxe/sport/edition 30",
            "Pure/luxe/sport/edition 3",
            "Hybrid Hybrid Premium/sport",
            "2.0t Sport",
            "3.0t Red Sport 400/3.0t Signature Edition",
            "Hybrid Premium/sport",
            "Sport/premium",
            "Sensory/signature Edition",
            "2.0t Base/2.0t Premium/2.0t Sport",
            "Sport Awd",
            "Signature Edition",
            "3.0t Premium/3.0t Sport",
            "Premiu",
            "3.0t",
            "Red Sp",
            "2.0t",
            "Red Sport I-line",
            "Pure Awd",
            "Base Premium",
            "Rwd",
            "3.0t Pure",
            "Hybrid Hybrid",
            "3.0t Sensory",
            "Sensor",
            "3.0t Pure/3.0t Luxe",
            "Pure/luxe/sport",
            "Premiu Premiu",
            "/premiu",
            "Base/p",
            "Edition 30 Awd/luxe Awd/pure Awd/sport Awd",
            "Base Base",
            "4d 2wd",
            "S",
            "Base P",
            "Pure Pure",
            " Base/",
            " Base",
            "Edition 30/luxe/pure/sport",
            "Sensor Sensor",
            "Red Sp Red Sp",
            "Red Sport I-line Pro 3.0t",
            "Sport 3.0t",
            "Pure/signature Edition",
            "Base/p Base",
            "Red Sport 400 3.0t",
            "Luxe/pure/signature Edition/signature Edition Proassist/sport/sport Proactive",
            "Signature 3.0t",
            "Awd",
            "Base/premium/spo",
            "3.0t I-line Red Sport/3.0t Red Sport 400"
          ]
        },
        {
          "model": "Q60",
          "series": [
            "Red Sport 400 Awd",
            "Luxe 300",
            "3.0t Luxe",
            "3.0t Sport",
            "Red Sport 400",
            "Pure",
            "Journey",
            "Premium",
            "3.0t Red Sport 400",
            "Luxe",
            "Base",
            "3.0t Premium",
            "Pure/luxe",
            "2.0t Premium",
            "Sport 3.0t",
            "Journey/ipl",
            "Premium/sport",
            "Luxe 300/sport 300",
            "Ipl",
            "2.0t/2.0t Premium",
            "Sport",
            "2.0t",
            "S Limited",
            "3.0t Pure",
            "Luxe Awd",
            "Pure Awd",
            "2.0t Pure",
            "2.0t Luxe",
            "Premiu",
            "Coupe",
            "Red Sp",
            "Coupe 3.0t Red Sport 400",
            "3.0t",
            "S",
            "Convertible",
            "3.0t Premium/3.0t Sport",
            "3.0t Luxe/3.0t Sport",
            "Journe",
            "Luxe 3",
            "Coupe S Limited",
            "Coupe Journey",
            "Coupe Sport",
            "Coupe S",
            "Coupe Journey/sport/ipl",
            "Coupe Ipl",
            "3.0t Premium/sport",
            "Coupe Journey/s/s Limited",
            "Luxe A",
            "Convertible Ipl",
            "Coupe Journey/ipl",
            "2d 3.0t Luxe",
            "/ipl",
            "Journe Journe",
            "Premiu Premiu",
            "Luxe Luxe",
            "Pure Pure",
            "Luxe 3 Luxe 3",
            "Journey/sport",
            "Journey/s/s Limited",
            "Base Base",
            "Ipl Ipl"
          ]
        },
        {
          "model": "Q70",
          "series": [
            " 3.7",
            "3.7",
            "3.7 Luxe",
            "3.7x",
            " 3.7 Luxe",
            " 5.6",
            "5.6",
            "5.6x",
            " 5.6 Luxe",
            "3.7x Luxe",
            "5.6 Luxe",
            "L 3.7",
            "L 3.7 L",
            "3.7 Lu",
            "L 5.6",
            "Hybrid Luxe",
            "L",
            "Hybrid",
            "5.6 Lu",
            "3.7 3.7",
            "L 5.6 L"
          ]
        },
        {
          "model": "Q70L",
          "series": [
            "3.7",
            "3.7x",
            "3.7x Luxe",
            "3.7 Luxe",
            "5.6",
            "5.6 Luxe",
            "5.6x",
            "3.7 L 3.7",
            "3.7 L L 3.7 L",
            "5.6 L 5.6",
            "3.7 L"
          ]
        },
        {
          "model": "QX30",
          "series": [
            "Pure",
            "Sport",
            "Luxury",
            "Luxe",
            "Base",
            "Premium",
            "Luxury/premium/sport",
            "Essential",
            "Pure/luxe/essential/sport",
            "Pure/essential/luxe/sport",
            "Luxe/essential",
            "Luxury/premium",
            "Essen",
            "Base Base",
            "Essential/luxe/luxury/premium"
          ]
        },
        {
          "model": "QX50",
          "series": [
            "Essential",
            "Luxe",
            "Sport",
            "Luxe Awd",
            "Sensory Awd",
            "Sensory",
            "Essential Awd",
            "Pure",
            "Essential/pure",
            "Autograph",
            "Journey",
            "Ase",
            "Autograph Awd/essential Awd/luxe Awd/pure Awd/sensory Awd",
            "Pure Awd",
            "Essential/luxe/pure",
            "Pure/luxe/essential/sensory/autograph",
            "Pure/luxe/essential/senso",
            "Sensory/autograph",
            "Essential 2.0t",
            "Essen",
            "Essential/sensory",
            "Uxe",
            "Sport Awd",
            "Awd",
            "Autograph Awd",
            "Pure/luxe/essential",
            "Senso",
            "Autog",
            " Auto D Auto",
            "Essen Essen",
            "Luxe Luxe",
            "Autograph Awd/essential Awd/luxe Awd/pure Awd/sensory A",
            "Autog Pure",
            "Pure Pure",
            "Autograph/essential/essential + Conv/proassist/pure/sensory",
            "Sport 2.0t",
            "Pure 2.0t",
            "Luxe/luxe I-line",
            "Essential/essential Tech/sensory",
            "Ed Sport 400",
            "Autograph/essential/luxe/proactive/sensory"
          ]
        },
        {
          "model": "QX55",
          "series": [
            "Sensory Awd",
            "Luxe Awd",
            "Luxe",
            "Essential",
            "Sensory",
            "Essential Awd",
            "Essen",
            "Senso",
            "Essential Proassist"
          ]
        },
        {
          "model": "QX56",
          "series": [
            "4wd W",
            "7-Passenger",
            "8-Passenger",
            "Base (a5)"
          ]
        },
        {
          "model": "QX60",
          "series": [
            "Pure",
            "Pure Awd",
            "Luxe",
            "Hybrid",
            "Luxe Awd",
            "Sensory",
            "Autograph",
            "Luxe/pure/special Edition",
            "Sensory Awd",
            "Signature Edition",
            "Autograph Awd",
            "Luxe/pure",
            "Hybrid Hybrid",
            "Parts",
            "Luxe Awd/pure Awd/signature Edition Awd",
            "Awd",
            "Signature Edition Awd",
            "Autog",
            "Remium",
            "Hybri",
            "Pure/luxe",
            "Senso",
            "Base (cvt)",
            "Base Cvt",
            "Luxe Luxe",
            "Hybri Hybri",
            "Limited",
            "Ourney",
            "Black Edition/luxe",
            "Essential/limited Edition/proactive/pure/sensory/signature Edition",
            "Hybrid Premium"
          ]
        },
        {
          "model": "QX70",
          "series": [
            "Sport",
            "3.7"
          ]
        },
        {
          "model": "QX80",
          "series": [
            "Luxe",
            "Luxe Awd",
            "Sensory",
            "Signature",
            "Base",
            "Limited",
            "Premium Select",
            "Signature/limited",
            "Luxe/limited",
            "Premium Select Awd",
            "Luxe/premium Select",
            "Sensory Awd",
            "Signature Edition",
            "Limited Awd",
            "Senso",
            "Luxe/limited/proactive",
            "Limited/signature Edition",
            "Premi",
            "Base Base",
            "Autograph",
            "Limited/luxe",
            "Luxe Luxe",
            "Autog",
            "Pure",
            "Luxe 7 Passenger/proactive 7 Passenger/proactive 8 Passenger",
            "Luxe 7 Passenger/luxe 8 Passenger/proactive 7 Passenger/proactive 8 Passenger",
            "Luxe Awd/premium Select Awd/sensory Awd",
            "Autograph Awd",
            "Limited 7 Passenger/luxe 7 Passenger/proactive 7 Passenger/proactive 8 Passenger",
            "Limited 7 Passenger/luxe 7 Passenger/luxe 8 Passenger",
            "Base 7 Passenger"
          ]
        },
        {
          "model": "G35",
          "series": [
            "Luxury Leather",
            "Journey",
            "W/leather",
            "Awd",
            "Sport",
            "Leather",
            "Sport W/6-speed Manual",
            "Base W/leather",
            "Base W/6 Speed Manual",
            "Sedan Journey",
            "Sedan",
            "Sedan X",
            "Luxury",
            "X",
            "Sedan Leather",
            "X Sport",
            "Base W/6 Speed Manual/luxury/luxury Leather",
            "Sedan W/leather",
            " W/leather",
            "Luxury (a5)",
            "Sedan G35x",
            "Base A5",
            "4door",
            "Base",
            "Coupe",
            "               G35",
            "Sedan Sport",
            "4d 4wd",
            "4d 2wd",
            "Journey/sport",
            "Sedan Journey Au Journey"
          ]
        }
      ]
    },
    {
      "make": "Isuzu",
      "models": [
        {
          "model": "ELF 100",
          "series": []
        },
        {
          "model": "ELF 200",
          "series": []
        },
        {
          "model": "ELF 300",
          "series": []
        },
        {
          "model": "ELF 400",
          "series": []
        },
        {
          "model": "ELF 500",
          "series": []
        },
        {
          "model": "ELF 600",
          "series": []
        },
        {
          "model": "ELF 600-BUS",
          "series": []
        },
        {
          "model": "Forward 1100",
          "series": []
        },
        {
          "model": "Forward 1400",
          "series": []
        },
        {
          "model": "Forward 800",
          "series": []
        },
        {
          "model": "FTR",
          "series": [
            "Truck Cab And Chassis",
            "Other Ftr",
            "/ Fvr",
            "Box Truck"
          ]
        },
        {
          "model": "FVR",
          "series": []
        },
        {
          "model": "FXR",
          "series": []
        },
        {
          "model": "NPR",
          "series": [
            "Hd",
            "Hd Gas Crew",
            "Xd",
            "Dsl Reg At",
            "Hd Gas Reg",
            "Hd Dsl Reg",
            "Hd Dsl Reg At",
            "Gas Reg",
            "Hd Reg",
            "Hd Dsl Crew",
            "Npr-St",
            "Xd Dsl Crew",
            "Reg",
            "Dsl Reg At Eco-max",
            "Reg*ors",
            "Hd Crew",
            "Xd Dsl Reg At",
            "Reg Ibt Pwl/ibt Air Pwl/obt Air Pwl/ibt Pwl Lsd",
            "Sprayer Truck",
            "Carpet Cleaner Truck",
            "Hd Dsl Reg Cab",
            "Dsl Crew",
            "Gas Crew",
            "Dsl Reg At Ibt Pwl/ibt Air Pwl/obt Air Pwl",
            "Dsl Reg At Eco-max Ibt",
            "Dsl Reg At Ibt Pwl/ibt Air Pwl",
            "Gas Reg Ibt Pwl",
            "Hd Gas Reg Ibt Pwl",
            "Hd Dsl Crew Cab Ibt",
            "Hd Dsl Reg At Ibt Pwl/ibt Air Pwl",
            "Dsl Reg At Eco-max Cab Ibt",
            "Cab",
            "Dsl Crew Ibt",
            "Crew Ibt",
            "Reg Ibt Pwl/ibt Air Pwl",
            "Hd Reg Ibt Pwl/ibt Air Pwl",
            "Dsl Reg At Ibt",
            "Hd Gas Reg Ibt Pwl Alt Fuel",
            "Gas Crew Ibt Pwl",
            "Hd Dsl Reg At Ibt",
            "Xd Dsl Reg At Ibt",
            "Hd Dsl Crew Ibt",
            "Hd Gas Crew Ibt Pwl",
            "Nrr",
            "Hd Ibt Pwl",
            "Npr",
            "Dsl Reg",
            "Dump Truck",
            "Delivery Truck",
            "Grain Truck",
            "Truck Cab And Chassis",
            "Box Truck",
            "Xd Street Sweeper Truck",
            "Flatbed Truck",
            "Flat Bed Truck",
            "Street Sweeper Truck",
            "Refrigerated Truck",
            "Cab Over Cab"
          ]
        },
        {
          "model": "NPR-HD",
          "series": [
            "Sprayer Truck"
          ]
        },
        {
          "model": "NPR-XD",
          "series": []
        },
        {
          "model": "NQR",
          "series": [
            "Dsl Reg At",
            "Dsl Crew",
            "Dsl Crew Ibt",
            "Dsl Crew Cab Ibt",
            "Dsl Reg At Ibt",
            "Truck",
            "Nqr",
            "Box Truck",
            "Street Sweeper Truck"
          ]
        },
        {
          "model": "NRR",
          "series": [
            "Dsl Reg At",
            "Dsl Reg At Ibt",
            "Bx20",
            "Nrr",
            "Flat Bed Truck",
            "Refrigerated Truck",
            "Truck Cab And Chassis",
            "Box Truck",
            "Flatbed Truck",
            "Refrigerated Delivery Truck",
            "Refuse Truck",
            "Dump Truck",
            "Sewer Jetter Truck"
          ]
        },
        {
          "model": "Reach",
          "series": []
        }
      ]
    },
    {
      "make": "Jaguar",
      "models": [
        {
          "model": "E-Pace",
          "series": [
            "Se P250 Awd Automatic",
            "S",
            "Se",
            "R-dynamic S/s",
            "Sport",
            "R-dynamic S",
            "First Edition",
            "P250 Awd Automatic",
            "Checkered Flag",
            "R-dynamic Se",
            "Checkered Flag Edition P250 Awd Automatic",
            "R-dynamic Hse",
            "300 Sport P300 Awd Automatic",
            "First P250",
            "R-dynamic Hse P300 Awd Automatic",
            "Se R-dyn P300",
            "R-dynamic S P300 Awd Automatic",
            "-Pace",
            "-pace Se",
            "Checkered Flag Edition",
            "R-D",
            "-pace Fir",
            "-pace Spo",
            "-pace R-d",
            "Che",
            "-pace Che",
            "S/r-dynamic S",
            "-pace S",
            "Standard",
            "300 Sport",
            "-pace Sta",
            "Spo",
            "Sta",
            "S E-pace S",
            "R-d E-pace R-d",
            "E-Pace",
            "S P250",
            "R-dynamic Se P300 Awd Automatic",
            "Se E-pace Se",
            "R-dynamic Se P250 Awd Automatic"
          ]
        },
        {
          "model": "F-Pace",
          "series": [
            "Premium",
            "P250 Awd Automatic",
            "Portfolio",
            "25t Prestige/30t Prestige",
            "S",
            "Prestige",
            "25t",
            "35t Prestige",
            "S P380 Awd Automatic",
            "25t Premium",
            "Prestige P300 Awd Automatic",
            "25t Prestige",
            "R - Sport",
            "30t Portfolio",
            "35t Premium",
            "S P250 Awd Automatic",
            "35t R-sport",
            "R-dynamic S",
            "Svr P550 Awd Automatic",
            "30t Premium",
            "25t Premium/30t Premium",
            "Svr",
            "Checkered Flag",
            "25t R-sport",
            "R-dynamic S P400 Awd Automatic",
            "20d Prestige",
            "Premium P250 Awd Automatic",
            "30t Prestige",
            "Prestige P250 Awd Automatic",
            "20d Premium",
            "35t",
            "R-dynamic S P250 Awd Automatic",
            "20d R-sport",
            "First Edition",
            "S P340 Awd Automatic",
            "R-sport P250 Awd Automatic",
            "30t R-sport",
            "25t R-sport/30t R-sport",
            "Pre",
            "Svr 575 Edition",
            "R-sport P300 Awd Automatic",
            "Premium P300 Awd Automatic",
            "Por",
            "35t Portfolio",
            "300 Sport",
            "Portfolio P300 Awd Automatic",
            "R -",
            "R-Sport",
            "25t Checkered Flag",
            "Fir",
            "20d",
            "Che",
            "300",
            "R-dynamic S P250 Awd",
            "R-D",
            "Checkered Flag P250 Awd Automatic",
            "300 Sport Limited Edition",
            "Premium P250 Awd",
            "Pre Pre",
            "Svr Svr",
            "S S",
            "Bas",
            "P250 S",
            "30t 300 Sport",
            "P250 R-dynamic S",
            "Prestige 30t"
          ]
        },
        {
          "model": "F-Type",
          "series": [
            "R",
            "Premium",
            "S",
            "V8 S",
            "R Dynamic",
            "Checkered Flag Rwd Automatic/p300 Rwd Automatic",
            "R75",
            "400 Sport",
            "R Awd Automatic",
            "R Rwd Automatic",
            "R-dynamic Awd Automatic",
            "P300/checkered Flag",
            "P340 Rwd Automatic",
            "P300",
            "296hp",
            "340hp",
            "Svr",
            "75",
            "S/s British Design Edition",
            "R-Dynamic",
            "P450 75 Awd Automatic",
            "P450 Rwd Automatic",
            "P340",
            "Coupe R-dynamic Rwd Automatic",
            "First Edition",
            "Automatic Rwd",
            "V8",
            "400",
            "V8 R",
            "V6",
            "V6 S",
            "R-dynamic/checkered Flag",
            "S British Design Edition",
            "P450",
            "P450 75",
            "R D",
            "380hp",
            "P450 R-dynamic",
            "Fir",
            "P450 R-dynamic Rwd Automatic",
            "Svr Awd Automatic",
            "Checkered Flag Awd Automatic/r-dynamic Awd Automatic",
            "P300 Rwd Automatic",
            "V8 V8",
            "P450 R-dynamic Awd Automatic",
            "S A",
            "Las"
          ]
        },
        {
          "model": "I-Pace",
          "series": [
            "Hse",
            "First Edition/hse",
            "Hse Ev400 Awd Automatic",
            "First Edition",
            "Se",
            "S",
            "R-dynamic Hse",
            "Hse Ev400 Awd",
            "S Ev400 Awd Automatic",
            "Fir",
            "Hse/first Edition",
            "Se Ev400 Awd Automatic",
            "4d 4x4 Hse",
            "R-D"
          ]
        },
        {
          "model": "XE",
          "series": [
            "25t Premium",
            "20d Prestige",
            "Prestige",
            "Premium",
            "25t Prestige",
            "35t Premium",
            "25t",
            "30t 300 Sport",
            "S Awd Automatic",
            "R - Sport",
            "20d Premium",
            "35t Portfolio Limited Edition",
            "25t R-sport",
            "S",
            "35t R-sport",
            "35t First Edition",
            "S Rwd Automatic",
            "First Edition",
            "R-dynamic S",
            "20d",
            "35t Prestige",
            "R-dynamic S Awd Automatic",
            "Landmark",
            "25t Landmark",
            "20d R-sport",
            "300 Sport",
            "Prestig",
            "35t",
            "Ype 2.5",
            "30t Prestige",
            "R - Spo",
            "Sv Proj",
            "300 Spo",
            "30t Premium",
            "Landmar",
            "R-Dynam",
            "Portfolio Le",
            "30t R-sport",
            "Portfol",
            "30t Sport",
            "35t Portfolio Limited",
            "First E",
            "R - Spo R - Spo",
            "Prestig Prestig",
            "30t Portfolio Limited Edition",
            "Premium Premium",
            "S S",
            "Sv Project 8",
            "3.0l V6 Sc R-sport",
            "3.0l V6 Sc Premium",
            "Portfolio"
          ]
        },
        {
          "model": "XF",
          "series": [
            "Premium",
            "3.0 Portfolio/3.0 Sport",
            "2.0t Premium",
            "35t Premium",
            "Supercharged",
            "25t Premium",
            "Xfr",
            "Premium Luxury",
            "25t R-sport",
            "R-dynamic Se P300 Awd Automatic",
            "3.0 Sport Awd",
            "I4 T",
            "Luxury",
            "Prestige",
            "3.0 Sport",
            "Portfolio",
            "30t Checkered Flag Awd Automatic",
            "R",
            "S",
            "35t Prestige",
            "Portfolio Le",
            "R - Sport",
            "R-dynamic Se",
            "V6 Sc",
            "25t",
            "35t R-sport",
            "20d Premium",
            "R+speed",
            "V6 Rwd",
            "Se",
            "35t Portfolio Limited Edition",
            "25t Premium Awd Automatic",
            "Se P250 Rwd Automatic",
            "3.0 Spo",
            "Superch",
            "2.0t Pr",
            "30t 300 Sport Limited Edition",
            "Checkered Flag",
            "25t Prestige",
            "5.0l Supercharged",
            "S First Edition",
            "R - Spo",
            "R-dynamic Se P250 Rwd Automatic",
            "Prestig",
            "R-dynamic Se P250 Awd Automatic",
            "3.0",
            "Portfol",
            "Rs",
            "Home Built Rule King",
            "R Sport",
            "V6 Awd",
            "I4 T Premium",
            "I4 Rwd",
            "V6",
            "Premium Luxury/portfolio",
            "Premium/portfolio",
            "35t",
            "20d Prestige",
            "Xfr-S",
            "S First",
            "V6 Portfolio",
            "20d R-sport",
            "V6 Sport",
            "V8 Supercharged",
            "First E",
            "Checker",
            "35t Portfolio Ltd Edition",
            "Base/sport/luxury",
            "Sportback S Awd Automatic",
            "Sportback Prestige Awd Automatic",
            "Portfolio W/sport Pkg",
            "300 Sport Le",
            "V8 Supercharged Rwd",
            "20d",
            "R-Dynam",
            "30t Prestige",
            "Portfol Portfol",
            "Luxury Luxury",
            "Portfolio/premium",
            "Premium Premium",
            "2.0t Pr 2.0t Pr",
            "Prestig Prestig",
            "Superch Superch",
            "First Edition",
            "S S",
            "25t Premium Rwd Automatic",
            "3.0 Spo 3.0 Spo",
            "25t Prestige Awd Automatic",
            "25t Prestige Rwd Automatic",
            "Luxury/sport",
            "3.0l",
            "2.0l"
          ]
        },
        {
          "model": "XFR",
          "series": []
        },
        {
          "model": "XFR-S",
          "series": []
        },
        {
          "model": "XJ",
          "series": [
            "Xjl",
            " Supercharged",
            "Supercharged",
            "Xj8",
            "Xjl Supersport",
            " Portfolio",
            "Xjr",
            "Xjl Portfolio",
            "Vdp",
            "R - Sport",
            "Xj8 L",
            "Denplas",
            "Vanden Plas",
            "2l",
            "Series",
            "Vanden Plas Supercharged",
            "L",
            "Xj R-sport",
            "Xjl Supercharged",
            "Portfolio",
            "R-Sport",
            "Sport",
            "Er V8",
            "Super V8",
            "Denplas Majestic",
            "                  Xj",
            "Vandenplas",
            "L Portfo",
            "Superch",
            "Supersport",
            "Xjr Lwb",
            "Series Sedan",
            " Supersport",
            "L Superc",
            "Base",
            " Sovereign",
            "2",
            "L Ultima",
            "Super V8 P",
            "Portfol",
            " Portfolio/xj50 V6",
            "Series Xj8 L",
            "Series Xj8",
            "Series Super V8 Portfolio",
            "Port/xjl Portfolio",
            "Vanden",
            "Collection",
            "L Supers",
            "Super V",
            "Premium Luxury",
            "Vdp Supercharged",
            "Supersp",
            "0 V6/xjl Portfolio",
            "R - Spo",
            "Xj Collection/xj50 V8/xjl Supercharged",
            "Xj8 Lwb",
            "Xj Sport",
            "Super V8 Portfolio",
            "Collection/xj50 V8/xjl Supercharged",
            "Xj50 V6/xjl Portfolio",
            "Long Wheel Base",
            "Super V Super V",
            "3.0l",
            "Lwb 4d",
            "Portfolio S/c",
            "Pe",
            "Portfolio/r-Sport",
            "3.0l Premium Luxury",
            "Ype 3.0"
          ]
        },
        {
          "model": "XJR",
          "series": [
            "S",
            "Enplas",
            "Eries Xjr",
            "Long W",
            "Long Wheel Base",
            "Xjr"
          ]
        },
        {
          "model": "XJR575",
          "series": []
        },
        {
          "model": "XK",
          "series": [
            "Portfolio",
            "Xkr",
            "Touring",
            "Series",
            "Portfol",
            "175 75th Anniversary",
            "Xkr-S",
            "-S",
            "Xkr175",
            "Series Base (a6)"
          ]
        },
        {
          "model": "XKR",
          "series": [
            "Portfolio",
            "Portfo",
            "Eries Xkr",
            "S",
            "Eries Xkr Portfolio",
            "Xkr"
          ]
        },
        {
          "model": "XKR-S",
          "series": []
        }
      ]
    },
    {
      "make": "Jeep",
      "models": [
        {
          "model": "Cherokee",
          "series": [
            "Sport",
            "Limited",
            "Latitude Plus",
            "Latitude Plus Fwd",
            "Limited 4x4",
            "Latitude Lux Fwd",
            "Limited Fwd",
            "Latitude Fwd",
            "Trailhawk 4x4",
            "Sport Fwd",
            "Altitude",
            "Latitude 4x4",
            "Latitude",
            "Altitude Fwd",
            "Latitude Tech Connect Fwd",
            "Trailhawk",
            "Latitude Plus 4x4",
            "Latitude Lux 4x4",
            "Country",
            "Se",
            "High Altitude 4x4",
            "Classic/sport",
            "Trailhawk Elite 4x4",
            "Classic",
            "Sport/classic",
            "75th Anniversary Edition Fwd",
            "High Altitude",
            "80th Anniversary 4x4",
            "Trailhawk L Plus 4x4",
            "High Altitude Fwd",
            "Sport 4x4",
            "Latitude Lux",
            "Altitude 4x4",
            "Altitude Lux 4x4",
            "Upland 4x4",
            "75th Anniversary",
            "Overland",
            "Altitude Lux",
            "Pioneer",
            "Laredo",
            "Rokee Limited",
            "Limited/sport",
            " Sport",
            "Overland 4x4",
            "Classic/limited/sport",
            "Rokee Srt-8",
            "Latitude Altitude",
            "Rokee Overland",
            "North",
            "75th Anniversary Edition 4x4",
            "Rokee Trailhawk",
            "Classic/limited",
            "Latitude Tech Connect 4x4",
            "Parts",
            "Overland Fwd",
            "Sport/limited",
            "Rhd Rural Letter Carrier",
            "X 4x4",
            "Briarwood",
            "X",
            "Rokee Laredo",
            " Rubicon",
            "Trailhawk Elite",
            "80th Anniversary Fwd",
            "Oneer",
            "North Edition 4x4",
            "Latitude Fw",
            "Latitude Suv",
            "High Altitude 4x4/limited 4x4",
            "Rokee Limited 4xe",
            "Altitude/latitude",
            "Atitude",
            "Suv (4 Door)",
            "Limited/high Altitude",
            "Upland",
            "Plus",
            "Versary",
            "And Cher",
            "Grnd Chero",
            "E",
            "O",
            "Latitude/latitude Altitude",
            "Grand Cher",
            "T",
            "Limited Suv",
            "Rhd Postal Unit",
            "Altitude Fwd/sport Fwd",
            "Latitude Fw Latitude",
            "Lux",
            "L",
            "R",
            "75th Anniversary Edition",
            "Trailhawk L Plus",
            "Latitude Tech Connect",
            "80th Anniversary",
            "D",
            "S",
            "Gr Cheroke",
            "Cher 4x4",
            "G Cherk L",
            "Freedom",
            "Latitude/altitude",
            "Sport/altitude",
            "Cheerokee",
            "Latitude/x",
            "4d 2wd",
            "Lattitude",
            "Cerokee",
            "R Cherokee L",
            "C",
            "4",
            "L Plus Pkg",
            "Gran Cher",
            "Cher Se",
            "Lat Pls",
            "R Cherokee S",
            "Cv1",
            "Cheroke",
            "4d 4wd",
            "Gr Cher4x4",
            "Latitude 4x4/latitude Tech Connect 4x4",
            "Trailhawk Leather Plus",
            "Cher Srt",
            "A",
            "Rh Drive",
            "Cher Sport",
            "Chereokee",
            "Port",
            "Ch Pioneer",
            "B",
            "Cherreoke",
            "Chrokee",
            "Cher Coun",
            "Cherke Ltd",
            "4x4 Laredo",
            "Imited",
            "Cherockee",
            "Cherokke",
            "Cher 4d",
            "Cherk Lar",
            "Gr Ch Lim",
            "Latitude Plus/altitude",
            "Cher Srt8",
            "Gcher Srt8",
            "7",
            "Cherrokee",
            "T Cher Sport",
            "Rokee L Overland",
            "O O",
            "Rokee L Limited",
            "Chief",
            "Sport 4wd",
            "80th Anniversary 4x4/latitude Lux 4x4",
            "Sport 4wd Se",
            "Er",
            "Latitude Pl Latitude Plus 4x4",
            "Altitude 4x4/latitude Plus 4x4",
            "Latitude 4w Latitude",
            "Limited 4wd Limited 4x4",
            "4x4",
            "N",
            "Limited Fwd Limited",
            "80th Anniversary Edition",
            "Limited 4wd Limited",
            "Trailhawk 4x4/trailhawk Elite 4x4",
            "Cher 4d Sp",
            "4x4 Se",
            "Cher",
            "Cherokee L",
            "Trailhawk 4 Trailhawk 4x4",
            "P",
            "Hse",
            "Postal",
            "Latitude Fwd/latitude Tech Connect Fwd",
            "Rokee Summit",
            "Unlimited Sport",
            "Cherokee Parts Only",
            "Cherokee S"
          ]
        },
        {
          "model": "Commander",
          "series": [
            "Sport",
            "Limited",
            "Overland",
            "Comander",
            "-"
          ]
        },
        {
          "model": "Compass",
          "series": [
            "Limited",
            "Latitude",
            "Sport",
            "Trailhawk",
            "High Altitude Edition",
            "Altitude 4x4",
            "Trailhawk 4x4",
            "Latitude 4x4",
            "Sport 4x4",
            "Sport Fwd",
            "Sun And Safety 4x4",
            "Latitude Fwd",
            "Limited 4x4",
            "80th Anniversary 4x4",
            "75th Anniversary",
            "Latitude Lux Fwd",
            "Latitude Lux",
            "Altitude Edition",
            "Sport Se Fwd",
            "High Altitude 4x4",
            "Sun And Wheel Fwd",
            "Latitude Lux 4x4",
            "Altitude Fwd",
            "Limited Fwd",
            "High Altitude Fwd",
            "High Altitude",
            "Upland",
            "(red) Edition 4x4",
            "Sport Se",
            "80th Edition",
            "Upland Edition 4x4",
            "75th Anniversary Edition Fwd",
            "Li",
            "High Altitude Edition/latitude",
            "North",
            "Sport/north",
            "Altitude",
            "80th Anniversary Fwd",
            "(red) Edition",
            "X",
            "Sun And Safety Fwd",
            "Latitude Lux Awd",
            "La",
            "Sport Se 4x4",
            "High Altitude 4x4/limited 4x4",
            "Freedom 4x4",
            "Trailhawk Elite",
            "75th Anniversary Edition 4x4",
            "North Edition 4x4",
            "Rocky Mountain",
            "80th Anniversary Edition",
            "Sport/sport Se",
            "Sport Se Pkg",
            "80th Anniversary",
            "Sp",
            "Altitude 4x4/latitude 4x4/sun And Safety 4x4",
            "Altitude Fwd/latitude Fwd/sun And Wheel Fwd",
            "K",
            "Itude Edition",
            "Itude",
            "70th Anniversary",
            "Altitude/sport",
            "Tr",
            "Altitude Edition/sport",
            "Sport/altitude Edition",
            "Sport/altitude",
            "Latitude W/sun/wheel Pkg",
            "75th Anniversary Edition",
            "Latitude 4wd",
            "Latitude W/sun/safety Pkg",
            "North Edition",
            "80",
            "Sport/75th Anniversary",
            "Upland Edition",
            "Al",
            "Latitude/altitude",
            "Limited/high Altitude",
            "Ass Latitude Fwd",
            "4d Latitude",
            "Freedom",
            "Sport/latitude",
            "Ass Trailhawk 4x4",
            "Ass Limited",
            "Ass Sport 4x4",
            "Ltd",
            "Ass Sport Fwd",
            "Ass Sport",
            "Ass Latitude 4x4",
            "Ass Limited 4x4",
            "Compas",
            "4d",
            "No",
            "(o",
            "Ass Trailhawk",
            "Ass Latitude",
            "Latitude/high Altitude",
            "Compass",
            "Limited Fwd Limited Fwd",
            "Latitude Fwd Latitude Fwd",
            "Sport Fwd W/ Sport Fwd",
            "High Altitud High Altitude 4x4",
            "Compus",
            "Sport 4wd Sport",
            "Sport Fwd Sport Fwd",
            "High Altitude Fwd/limited Fwd",
            "Fw",
            "Latitude 4wd Latitude",
            "Lattitude",
            "Limited 4wd Limited 4x4",
            " Sport",
            "Latitude Latitude Fwd",
            "Altitude 4x4/latitude 4x4",
            "High Altitud High Altitude Fwd",
            " Limited",
            "2.5 S",
            " Latitude",
            "L",
            "Sport 4wd Sport 4x4",
            "Latitude Fwd Latitude",
            "S"
          ]
        },
        {
          "model": "Gladiator",
          "series": [
            "Overland 4x4",
            "Sport S",
            "Sport S 4x4",
            "Rubicon 4x4",
            "Willys 4x4",
            "High Altitude 4x4",
            "Mojave 4x4",
            "Altitude 4x4",
            "Mojave",
            "Rubicon",
            "Sport",
            "Overland",
            "North Edition 4x4",
            "Texas Trail 4x4",
            "Freedom 4x4",
            "Sport 4x4",
            "Willys Sport 4x4",
            "80th Anniversary 4x4",
            "Willys",
            "Altitude",
            "Willys Sport",
            "High Altitude 4x4/overland 4x4",
            "High Altitude",
            "80th Anniversary 4x4/california Edition 4x4/freedom 4x4/sport 4x4/sport S 4x4",
            "Gladiator",
            "80th Anniversary",
            "North Edition",
            "Freedom",
            "California Edition",
            "Crw 4x4 Spt",
            "80th Anniversary 4x4/california Edition 4x4/freedom 4x4",
            "Texas Trail",
            "Mojave X",
            "Imited",
            "Willys Spo Texas Trail 4x4",
            "Rubicon/rubicon X",
            "L/le/xle/se/xse",
            "Rubicon X",
            "Rubicon Farout 4x4",
            "Freedom 4x4/sport 4x4/sport S 4x4/texas Trail 4x4/willys 4x4/willys Sport 4x4",
            "California Edition 4x4",
            "Nighthawk",
            "High Tide",
            "Freedom 4x4/sport 4x4/sport S 4x4/texas Trail 4x4/willy",
            "Black Appearance",
            "Sport 80th Anniversary"
          ]
        },
        {
          "model": "Grand Cherokee",
          "series": [
            "Limited",
            "Kee Trailhawk",
            "Kee Laredo",
            "Upland 4x4",
            "Titude Plus",
            "Titude",
            "Kee Trackhawk",
            "Laredo",
            "Srt",
            "Limited 4x2",
            "Trackhawk 4x4",
            "Limited 4x4",
            "Altitude 4x2",
            "Altitude 4x4",
            "Limited 75th Anniversary",
            "Ort",
            "Overland",
            "Kee Overland",
            "Altitude",
            "Laredo X 4x4",
            "Summit",
            "Laredo X 4x2",
            "Kee Limited",
            "Summit 4x4",
            "Kee L Limited",
            "4xe",
            "Mited",
            "Kee Srt-8",
            "Limited X 4x4",
            "80th Anniversary 4x4",
            "Laredo E 4x2",
            "Kee Summit",
            "Sterling Edition 4x4",
            "Srt 4x4",
            "Laredo 4x4",
            "Laredo E 4x4",
            "Limited 75th Anniversary Edition 4x4",
            "Titude Lux",
            "Laredo/columbia/freedom",
            "High Altitude 4x4",
            "Overland 4x4",
            "Kee L Overland",
            "Kee L Laredo",
            "Trailhawk 4x4",
            "Laredo 4x2",
            "High Altitude",
            "Laredo/tsi",
            "4xe Limited 4x4",
            "Trackhawk",
            "Kee Summit 4xe",
            "Upland 4x2",
            "75th Anniversary",
            "Kee Limited 4xe",
            "Srt8",
            "Srt-8",
            "4xe Trailhawk 4x4",
            "Laredo Trailhawk",
            "80th Anniversary 4x2",
            "Laredo/altitude",
            "Kee L Summit",
            "Redo",
            "Kee Laredo E",
            "Overland 4x2",
            "75th Anniversary Edition 4x4",
            "Ailhawk",
            "Kee Overland 4xe",
            "High Altitude 4x2",
            "Kee Limited 5.9l",
            "Kee Trailhawk 4xe",
            "L Limited",
            "Altitude X 4x4",
            "Srt Night",
            "4xe Summit",
            "Altitude 4x4/laredo 4x4/laredo E 4x4/upland 4x4",
            "Limited 4xe",
            "L Laredo/l Altitude",
            "L Laredo",
            "Laredo Altitude",
            "Laredo E/laredo X",
            "4xe Overland",
            "Trailhawk",
            "Kee Sport",
            "Overland 4xe",
            "Sterling Edition 4x2",
            "4xe Limited 4xe",
            "North Edition 4x4",
            "4xe Summit Reserve 4x4",
            "4xe Overland 4x4",
            "4xe 30th Anniversary",
            "Limited 4x4/limited X 4x4",
            "4xe Trailhawk",
            "Summit Reserve",
            "Limited/orvis",
            "4xe Summit Reserve",
            "Srt8 Alpine",
            "Summit Reserve 4x4",
            "Limited X 4x2",
            "Sterling Edition",
            "L Summit",
            "4xe Trailhawk 4xe",
            "Overland Summit",
            "4xe Overland 4xe",
            "L Overland",
            "Srt8 Vapor",
            "Sport",
            "Limited X",
            "Freedom 4x2",
            "Summit 4x2",
            "75th Anniversary Edition 4x2",
            "Trailhawk 4xe",
            "Kee L Altitude",
            "Summit/summit Reserve",
            "80th Anniversary Edition",
            "4xe Summit 4x4",
            "Limited 4x2/limited 75th Anniversary Edition 4x2",
            "Freedom 4x4",
            "Rocky Mountain",
            "4xe Anniversary Edition",
            "Suv",
            "Limited Suv",
            "Laredo/special",
            "L Summit/l Summit Reserve",
            "Limited 4x2/sterling Edition 4x2",
            "Upland",
            "80th Anniversary",
            "K",
            "Altitude X 4x2",
            "Cherokee L",
            "Cherokee S",
            "Ojave",
            "Altitude/laredo",
            "Itude",
            "Laredo E",
            "70th Anniversary",
            "75th Anniversary Edition",
            "Laredo/altitude/upland",
            "North",
            "Limited/sterling Edition",
            "Laredo X",
            "Y",
            "Okee L",
            "Freedom",
            "Laredo E/freedom/laredo X",
            " Chero",
            "Okee S",
            "Heroke",
            "R 4d",
            "Laredo/70th Anniversary",
            "4xe 30th Anniversary 4xe",
            "Altitude Iv",
            "Loredo",
            "Summit 4xe",
            "Altitude X",
            "4d 4x4",
            "Laredo/altitude/laredo E",
            "Limited 4w",
            "Limited Limited",
            " Sport",
            "High Altitude 4x4/overland 4x4",
            "D Che",
            "L Altitude",
            "Awk",
            "Imited",
            " Cherk",
            "D Cher",
            " Srt",
            "R Srt8",
            "Her",
            "Er Lar",
            " Cher",
            "Overland/overland Summit",
            "Erokee",
            "Er L",
            "Dchero",
            " Cheor",
            "Chrkee",
            "Ted",
            "4xe Summit 4xe",
            "D",
            "D Chee",
            "Er 4d",
            "Dcherk",
            "H Lim",
            "Laredo/75th Anniversary",
            "High Altitude Ii",
            "Limited 4w Limited",
            "Do",
            "Laredo/rocky Mountain",
            "Cher",
            "Er Ltd",
            "Er",
            "Edo",
            "De Plus",
            "Se",
            "Trail Trailhawk 4x4",
            "75th Anniversary/laredo",
            "Grnd Chero",
            "Grand Che",
            "High Altitude 4x2/overland 4x2",
            "Gr Cher4x4",
            "4x4 Laredo",
            "4x4limited",
            "Altit Altitude 4x4",
            "Overl Overland",
            "Lared",
            "Limit Limited",
            "Gran Cher",
            "Lared Altitude 4x4",
            "Gran Chero",
            "Lared Laredo",
            "Limit Limited 4x2",
            "Limited 4x4/limited 75th Anniversary Edition 4x4",
            "Limited/limited 75th Anniversary",
            "Limited 75th Anniversary Edition",
            "Grd Chrkee",
            "Limit Limited X 4x2",
            "G.cher 4d",
            "Gand Chero",
            "T",
            "Grandchero",
            "Rt",
            "Limited Sahara",
            "Limited 5.9l",
            "Altitude 4x4/altitude X 4x4/laredo 4x4/laredo X 4x4",
            "Grandcherk",
            "Altitude 4x4/laredo 4x4",
            "Grcher Ltd",
            "4xe Limited",
            "Fx4/lariat/xl/xlt",
            "80th Anniversary Edition/limited/limited X",
            "Kee Suv",
            "Kee Laredo Suv",
            "80th Anniversary 4x4/limited 4x4/limited X 4x4",
            "Kee 4xe",
            "Grnd Cherk",
            "G.cherokee",
            "5.9 Limited",
            "Grand",
            "C 300 4matic",
            "Altit Laredo/altitude",
            "Gran Cheor",
            "Grand Chee",
            "Gr Cher",
            "Ilhawk"
          ]
        },
        {
          "model": "Grand Cherokee L",
          "series": [
            "Overland 4x4",
            "Limited 4x4",
            "Limited 4x2",
            "Altitude 4x4",
            "Laredo 4x4",
            "Summit 4x4",
            "Altitude 4x2",
            "Overland 4x2",
            "L Laredo/l Altitude",
            "Laredo 4x2",
            "Laredo X 4x2",
            "L Limited",
            "Altitude",
            "Summit Reserve 4x4",
            "L Laredo",
            "Limited",
            "Altitude X 4x2",
            "Laredo",
            "Laredo X 4x4",
            "Altitude X 4x4",
            "L Overland",
            "Overland",
            "L Summit/l Summit Reserve",
            "Summit",
            "Summit Reserve",
            "Summit 4x2",
            "Altitude X",
            "Laredo/l Altitude",
            "L Summit",
            "Altitude 4x4/altitude X 4x4/laredo 4x4/laredo X 4x4",
            "Altitude 4x4/laredo 4x4",
            "Lim Limited 4x4",
            "Laredo L Laredo"
          ]
        },
        {
          "model": "Grand Cherokee WK",
          "series": [
            "Laredo X 4x4",
            "Laredo E 4x4",
            "Laredo X 4x2",
            "Limited 4x4",
            "Laredo E 4x2",
            "Limited 4x2",
            "Altitude",
            "Laredo E/laredo X",
            "Limited",
            "Altitude/laredo",
            "Laredo E",
            "Laredo X",
            "Limited X",
            "Limited 4wd"
          ]
        },
        {
          "model": "Grand Wagoneer",
          "series": [
            "4x4",
            "Series Ii 4x4",
            "Series I",
            "Series Ii",
            "Series Iii 4x4",
            "Series Iii",
            "Series Ii Obsidian",
            "Series Ii Obsidian 4x4",
            "Obsidian 4x4",
            "L Series I",
            "Series I 4x4",
            "L Series Ii",
            "L Series Ii 4x4",
            "L Series Iii",
            "L Series Iii 4x4",
            "Series Iii Obsidian 4x4",
            "L L Series Ii",
            "L 4x4",
            "L Series Iii Obsidian 4x4",
            "Series Iii 4x4/series Iii Obsidian 4x4"
          ]
        },
        {
          "model": "Liberty",
          "series": [
            "Sport",
            "Limited",
            "Limited Edition",
            "Renegade",
            "Limited Jet Edition",
            "Sport/freedom",
            "Jet",
            "Li",
            "Je",
            "Rocky Mountain",
            "Rocky Mountain Edition",
            "Sport Latitude",
            "Arctic",
            "Sp",
            "Re",
            "Limited Jet",
            "Sport Jet",
            "Sport 70th Anniversary",
            "Limited 70th Anniversary",
            "4d",
            "80th Anniversary",
            "Ar",
            "Sport/rocky Mountain",
            "Sp Sp",
            "3.7",
            "Spt",
            "Liberrty",
            "Jeep Liber",
            "Lt",
            "-V6",
            "Libery",
            "Ut",
            "Sport 4wd Sport",
            "4x",
            "4d 4d",
            "Je Je",
            "Re Re",
            "Li Li"
          ]
        },
        {
          "model": "Patriot",
          "series": [
            "Latitude",
            "Latitude Fwd",
            "High Altitude 4x4",
            "Sport Fwd",
            "Sport",
            "Sport Se",
            "High Altitude Edition",
            "Latitude X",
            "Limited",
            "75th Anniversary",
            "Sport 4x4",
            "Sport Se Fwd",
            "Altitude Edition",
            "Latitude 4x4",
            "Sport/north",
            "High Altitude",
            "Altitude",
            "75th Anniversary Edition Fwd",
            "High Altitude Fwd",
            "75th Anniversary Edition 4x4",
            "North",
            "Sport/altitude",
            "Sport Se 4x4",
            "High Altitude Edition/latitude",
            "La",
            "75th Anniversary Edition 4x4/sport 4x4/sport Se 4x4",
            "Altitude/sport",
            "High Altitude/latitude",
            "Itude Edition",
            " X",
            "Sport/rocky Mountain",
            "High Altitude Fwd/latitude Fwd",
            "Li",
            "Sp",
            "Altitude Edition/sport",
            "Sport/altitude Edition",
            "75th Anniversary Edition",
            "Titude Edition",
            "Titude",
            "70th Anniversary",
            "Rocky Mountain",
            "Sport/latitude",
            "Latitude/high Altitude",
            "Sport/sport Se",
            "Partroit",
            "Sut",
            "Laredo/columbia/freedom",
            "Patroit",
            "Al",
            "4d",
            "-4",
            "Sport/75th Anniversary",
            "La La",
            "Sport Fwd Sport/north",
            "Sport Fwd Sport Fwd",
            "Sport Fwd Sport",
            "Sp Sp",
            "75th Anniversary/sport",
            "Latitude 4wd Latitude",
            "Altitude 4wd Sport"
          ]
        },
        {
          "model": "Renegade",
          "series": [
            "Sport",
            "Latitude",
            "Latitude 4x4",
            "Trailhawk",
            "(red) Edition 4x4",
            "Sport 4x4",
            "Limited",
            "Limited Fwd",
            "Trailhawk 4x4",
            "Latitude Fwd",
            "Altitude 4x4",
            "Limited 4x4",
            "Altitude Fwd",
            "Sport Fwd",
            "75th Anniversary",
            "Upland Edition 4x4",
            "Justice",
            "Upland 4x4",
            "Freedom Edition 4x4",
            "80th Anniversary 4x4",
            "High Altitude 4x4",
            "Orange Edition Fwd",
            "Altitude",
            "Jeepster 4x4",
            "North",
            "Orange Edition 4x4",
            "Deserthawk 4x4",
            "High Altitude Fwd",
            "Jeepster Fwd",
            "Altitude Fwd/latitude Fwd/orange Edition Fwd",
            "Sport 4x4/upland Edition 4x4",
            "North Edition 4x4",
            "Sport/jeepster",
            "Islander Fwd",
            "Islander 4x4",
            "Sport/upland/jeepster",
            "S",
            "Enegade",
            "Imited",
            "North Edition",
            "Latitude/altitude",
            "Jeepster",
            "T",
            "L",
            "Altitude 4x4/latitude 4x4/upland 4x4",
            "Upland",
            "Upland Edition",
            "Orange Edition",
            "Deserthawk",
            "High Altitude",
            "80th Anniversary",
            "Islander",
            "Sv",
            "Freedom Edtion",
            "Latitude/altitud",
            "A",
            "Sport/upland Edition",
            "Altitude Fwd/latitude Fwd",
            "4",
            "Renagade",
            "I",
            "Trailhawk Trailhawk 4x4",
            "T T",
            "Latitude 4w Latitude 4x4",
            "Latitude 4w Latitude",
            "Latitude Fw Latitude",
            "Latitude Fw Latitude Fwd",
            "Altitude 4x4/latitude 4x4",
            "Sport 4wd Sport",
            "Latitude/justice/75th Anniversary",
            "American Value Pkg",
            "Sport Suv",
            "75th Anniversary/latitude",
            "Trailhawk 4 Trailhawk 4x4"
          ]
        },
        {
          "model": "Wagoneer",
          "series": [
            "Series Iii",
            "Series Ii 4x4",
            "L Series Iii",
            "Series Ii 4x2",
            "Series Iii 4x4",
            "Limited",
            "Series Ii",
            "Series I 4x4",
            "L Series Iii 4x4",
            "Series I",
            "L Series Ii",
            "L Series Ii 4x4",
            "Series Iii 4x2",
            "L Series I 4x4",
            "Series I 4x2",
            "Series Ii Carbide 4x4",
            "L Series Ii Carbide",
            "Series Iii Carbide 4x4",
            "L Series Ii 4x2",
            "L Series Ii Carbide 4x4",
            "L Series I",
            "Series Ii Carbide 4x2",
            "L L Series I",
            "Series Ii Carbide",
            "Series Iii Carbide 4x2",
            "L Series Ii Carbide 4x2",
            "Grand Wago",
            "S",
            "L Series Iii 4x2",
            "Series I Obsidian 4x4",
            "L",
            "L L",
            "S S",
            "L Series I 4x2",
            "L L Series Iii",
            "L L Series Ii",
            "Series Iii/series Iii Carbide",
            "Unlimited Sport",
            "Series Ii 4 Series Ii 4x4",
            "S Launch Edition",
            "Series Ii C Series Ii Carbide 4x2",
            "S Limited",
            "Sport",
            "Carbide 4x4"
          ]
        },
        {
          "model": "Wrangler",
          "series": [
            "Unlimited Sahara",
            "Sahara",
            "/ Tj Se",
            "Unlimited",
            "Sport S",
            "Unlimited Rubicon 4xe",
            "Unlimited Rubicon",
            "Sport",
            "Unlimited Sport",
            "Unlimited Rubicon 4x4",
            "Unlimited Willys 4x4",
            "Unlimited Sahara Altitude 4x4",
            "4xe Sport 4x4",
            "Unlimited Sport S 4x4",
            "/ Yj S/rio Grande",
            "High Altitude 4xe",
            "Unlimited 75th Anniversary Edition 4x4",
            "X",
            "4-door Rubicon Farout 4x4",
            "Unlimited Sport Altitude 4x4",
            "Unlimited Sahara 4x4",
            "Rubicon",
            "Unlimited Sport 4x4",
            "/ Yj Se",
            "Unlimited X",
            "Unlimited Willys Sport 4x4",
            "4xe Sahara 4x4",
            "Unlimited Altitude",
            "/ Tj Sport",
            "Unlimited Freedom",
            "4xe Unlimited Rubicon 4x4",
            "Unlimited Sahara 4xe",
            "4xe",
            "Sport S 4x4",
            "Rubicon X",
            "/ Yj S",
            "4xe Willys 4x4",
            "4xe Rubicon 4x4",
            "Willys Wheeler",
            "Se",
            "Sahara 4xe",
            "Unlimited Sport Rhd",
            "U",
            "Unlimited North Edition 4x4",
            "Unlimited Islander 4x4",
            "Sport 4x4",
            "Unlimited Smoky Mountain 4x4",
            "Unlimited Willy Wheeler 4x4",
            "/ Tj X",
            "/ Tj Sahara",
            "4-door Sport S 4x4",
            "Commando",
            "4xe 4x4",
            "4xe Unlimited Sahara 4x4",
            "Unlimited Sport S",
            "Unlimited Freedom Edition",
            "4xe Sahara 4xe",
            "4-door Rubicon 4x4",
            "2-door Sport 4x4",
            "Unlimited Black Bear",
            "Unlimited Willys Wheeler",
            "4-door Willys 4x4",
            "Rubicon 4x4",
            "Moab",
            "/ Yj Sahara",
            "4-door Willys Sport 4x4",
            "4-door Sport Altitude 4x4",
            "4-door High Tide 4x4",
            "/ Yj",
            "Unlimited Rubicon Hard Rock",
            "Unlimited High Altitude 4x4",
            "Unlimited Rubicon X",
            "2-door Sport S 4x4",
            "Unlimited Rubicon 392",
            "Rubicon 4xe",
            "Unlimited Moab 4x4",
            "Unlimited Rubicon 392 4x4",
            "Unlimited 75th Anniversary",
            "Freedom Edition",
            "Sahara 4x4",
            "/ Tj Unlimited",
            "Altitude",
            "Unlimited Sport Rhd 4x4",
            "/ Tj Rubicon",
            "Sport Rhd",
            "Unlimited Freedom 4x4",
            "Unlimited Black And Tan 4x4",
            "4-door Sahara 4x4",
            "Unlimited 80th Anniversary 4x4",
            "Willys Sport 4x4",
            "Unlimited High Altitude",
            "Unlimited Jeep 70th Anniversary",
            "Unlimited Rubicon Recon 4x4",
            "Unlimited Big Bear 4x4",
            "/ Tj Unlimited Rubicon",
            "4xe Unlimited High Altitude 4x4",
            "Unlimited Sahara High Altitude",
            "Unlimited Backcountry",
            "Black Bear",
            "Unlimited Wrangler X",
            "4xe Rubicon 20th Anniversary 4x4",
            "4xe 4-door Rubicon",
            "Freedom",
            "Rubicon 392",
            "Unlimited Sahara 80th Anniversary Edition",
            "Unlimited Rubicon 10th Anniversary",
            "4-door Sahara",
            "Winter 4x4",
            "4xe Summit 4x4",
            "4-door Rubicon 392 4x4",
            "2-door Willys 4x4",
            "75th Anniversary",
            "2-door Rubicon 4x4",
            "Unlimited Black And Tan Edition",
            "Unlimited Sport Altitude",
            "4xe Unlimited Rubicon",
            "Unlimited Black And Tan 4x4/freedom 4x4/sport 4x4/sport Altitude 4x4/sport S 4x4/willys 4x4/willys Sport 4x4",
            "Unlimited Moab",
            "Willys 4x4",
            "Unlimited 70th Anniversary",
            "Unlimited Chief Edition 4x4",
            "4xe Rubicon X",
            "75th Anniversary Edition 4x4",
            "4-door Sport 4x4",
            "Rubicon Hard Rock",
            "Unlimited Rubicon Hard Rock 4x4",
            "Unlimited High Tide 4x4",
            "Rubicon Recon 4x4",
            "4-door Willys",
            "4-door Rubicon",
            "Unlimited Sahara Altitude",
            "4-door Sport S",
            "4-door Sahara Altitude 4x4",
            "4xe 4-door Willys",
            "4xe High Altitude",
            "4-door Rubicon 20th Anniversary 4x4",
            "Unlimited Willys",
            "4xe 4-door High Altitude",
            "Unlimited Sahara 80th",
            "/ Yj Laredo",
            "80th Anniversary 4x4",
            "4xe Rubicon 4xe",
            "4x4",
            "Unlimited Winter 4x4",
            "/ Yj Renegade",
            "S",
            "4-door Sport Rhd 4x4",
            "2-door Willys Sport 4x4",
            "/ Yj Islander",
            "4xe Unlimited Sahara",
            "4xe Sport S",
            "Laredo",
            "X Rhd",
            "Willy Wheeler 4x4",
            "Unlimited Polar Edition",
            "4-door High Altitude 4x4",
            "Unlimited Willys Edition",
            "4xe Willys",
            "Willys",
            "Freedom 4x4",
            "Big Bear 4x4",
            "4xe Sahara",
            "Backcountry",
            "4",
            "4xe 4-door Sahara",
            "7",
            "4xe Sport S 4xe",
            "Unlimited Dragon Edition",
            "Islander 4x4",
            "Commando/x",
            "4xe Rubicon X 4xe",
            "/",
            "Unlimited 70th Anniv",
            "Unlimited R",
            "Jeep 70th Anniversary",
            "Big Bear 4x4/freedom 4x4/sport 4x4/willy Wheeler 4x4",
            "Piece",
            "Limited",
            "Unlimited Sahara Suv",
            "Unlimited 80th Anniversary 4x4/freedom 4x4/islander 4x4/sport 4x4/sport Altitude 4x4/sport S 4x4",
            "4xe Willys 4xe",
            "L",
            "R",
            "4xe 4xe",
            "Unlimited Rubicon/rubicon X",
            "Unlimited Mountain",
            "Unlimited Arctic",
            "Unlimited Winter",
            "4xe Unlimited High Altitude 4x4/unlimited Sahara 4x4",
            "Sahara (amalgamated)",
            "Suv",
            "Sport Suv",
            "Unlimited Black Bear/freedom/sport/willys Wheeler",
            "4xe Summit 4xe",
            "80th Anniversary 4x4/freedom 4x4/islander 4x4/sport 4x4/sport S 4x4/willys 4x4/willys Sport 4x4",
            "H",
            "Arctic",
            "Unlimited Big Bear",
            "Polar Edition",
            "Winter",
            "Islander",
            "Chief Edition 4x4",
            "Rubicon 10th Anniversary",
            "Unlimited Rubicon 4xe Hybrid",
            "Unlimited X Rhd",
            "Unlimited Freedom Edition/sport/willys Wheeler",
            "Unlimited R Rubicon",
            "Unlimited S",
            "Unlimite",
            "Unlimited Call Of Duty Mw3",
            "Big Bear",
            "Unlimited Recon",
            "Unlimited Islander",
            "Unlimited Black And Tan",
            "Unlimited Smoky Mountain",
            "Unlimited Willys Sport",
            "Unlimited 80th",
            "Unlimited Mojave",
            "Unlimited Sahara/moab",
            "Call Of Duty Mw3",
            "Willys Sport",
            "Unlimited North Edition",
            "Unlimited Sahara High",
            "Unlimited Rubicon Recon",
            "Mountain",
            "Mojave",
            "Sahara Altitude",
            "Eeler",
            "Unlimite Sport",
            "Rubicon Recon",
            "Islander/mountain",
            "80th Anniversary",
            "Black And Tan",
            "Chief Edition",
            "I",
            "C",
            "4xe Unlimited Sahara High",
            "70th Anniversary",
            "4xe Rubicon",
            "Sport/sport S/fr",
            "High Tide",
            "4xe Sahara High Altitude",
            "4xe Unlimited High Altitude",
            "J",
            "Wranger",
            "Sport/freedom Edition",
            "Unlimited Rubicon Lwb",
            "Sport Altitude",
            "High Altitude",
            "Rubicon Hard Rock 4x4",
            "Wrang Sprt",
            "4xe High Altitude 4x4",
            "Unlimited Sport 4wd Sport 4x4",
            "Black And Tan Edition",
            "Wra Sahara",
            "Wrnglr Spt",
            "Wraglr Spt",
            "Wrgl Lared",
            "2",
            "Wrangle",
            "Unlimited 80th Anniversary 4x4/freedom 4x4/islander 4x4/sport 4x4",
            "Unlimited S Sport S 4x4",
            "T",
            "Unlimited S Sport",
            "Wrang Spor",
            "A",
            "Angler S",
            "Wranger Sp",
            "Wran Reneg",
            "Unlimited Lwb",
            "Unlimited High Tide",
            "Smoky Mountain",
            "Sport Right Hand Drive",
            "4-door Recon 4x4",
            "Tj",
            "T Wrnglr Spt",
            "J J",
            "Rubicon 4x4/rubicon Recon 4x4",
            "Willys 4xe",
            "80th Anniversary 4x4/freedom 4x4/islander 4x4/sport 4x4",
            "Wrnglr Con",
            "4 4",
            "Wrangler",
            "W",
            "Sport S 4xe",
            "Rubicon 20th Anniversary 4x4",
            "Rangler",
            "4xe Unlimit Unlimited Sahara 4x4",
            "Rubicon Unlimited",
            "High Altitude 4x4",
            "Willy Wheeler W 4x4",
            "Summit 4xe",
            "Sport 4wd Willys Wheeler",
            "2-Door",
            "2d 4x4 (ne",
            "Rubicon/rubicon 10th Anniversary",
            "Sahara Altitude 4x4",
            "4-door Freedom 4x4",
            "Rubicon X 4xe",
            "4-door Summit 4x4",
            "4xe 4-door Recon",
            "4-door Rubicon 20th Anniversary 4x4/4-door Rubicon 392 4x4",
            "4-door Rubicon 392 Final Edition 4x4",
            "Jeep Beach 4xe/sport S 4xe/willys 4xe",
            "4xe Unlimited Sahara High Altitude",
            "Smoky Mountain 4x4",
            "Unlmtd Hard Top Only",
            "Freedom Edition/sport/willys Wheeler",
            "Sport 4xe",
            "4-door Sport Altitude",
            "Latitude",
            "Parts Only",
            "Black And Tan 4x4",
            "Unlimited Sport 80th Anniversary Edition",
            "4-door Sahara Altitude",
            "2-door Willys Sport"
          ]
        },
        {
          "model": "Wrangler JK",
          "series": [
            "Willy Wheeler 4x4",
            "Sahara 4x4",
            "Unlimited Sport S 4x4",
            "Unlimited Sport S",
            "Sport S 4x4",
            "Unlimited Willy Wheeler 4x4",
            "Unlimited Sahara",
            "Unlimited Sport",
            "Sport 4x4",
            "Unlimited Altitude 4x4",
            "Unlimited Sahara 4x4",
            "Unlimited Freedom Edition 4x4",
            "Unlimited Rubicon 4x4",
            "Rubicon 4x4",
            "Unlimited Sport 4x4",
            "Unlimited Rubicon",
            "Unlimited Golden Eagle 4x4",
            "Unlimited Willy Wheeler W 4x4",
            "Unlimited Rubicon Recon 4x4",
            "Willy Wheeler W 4x4",
            "Unlimited Willys Wheeler W",
            "Unlimited Willys Wheeler",
            "Sahara",
            "Sport",
            "Freedom Edition 4x4",
            "Unlimited",
            "Freedom Edition",
            "Sport S",
            "Rubicon",
            "Unlimited Altitude",
            "Unlimited Rubicon Recon",
            "Golden Eagle",
            "Unlimited Golden Eagle",
            "Willys Wheeler W",
            "Willys Wheeler",
            "Altitude",
            "Imited Sport",
            "Unlimited Sport Rhd 4x4",
            "Rubicon Recon",
            "Unlimite Sport S 4x4",
            "Altitude 4x4",
            "Freedom Edition 4x4/golden Eagle 4x4/sport 4x4/sport S 4x4/willy Wheeler 4x4/willy Wheeler W 4x4",
            "Freedom Edition 4x4/golden Eagle 4x4/sport 4x4/sport S",
            "Rubicon Recon 4x4"
          ]
        }
      ]
    },
    {
      "make": "Kia",
      "models": [
        {
          "model": "Borrego",
          "series": [
            "Lx",
            "Ex V6",
            "Lx/ex",
            "Ltd",
            "Ex V8",
            "Lx V6",
            "X",
            "L",
            "Ne",
            "Ex",
            "Limited",
            "Lx Lx",
            " Lx",
            "Ex V6/lx V6",
            "Lx V8",
            "Premium",
            " Ex",
            "Pr",
            "Base",
            " Line"
          ]
        },
        {
          "model": "Cadenza",
          "series": [
            "Premium",
            "Technology",
            "Premium/limited",
            "Limited",
            "Luxury",
            "Premium/limited/technolog",
            "E Lx",
            "X",
            "Premium/limited/technology",
            " Lx",
            " Line",
            " S",
            "Pr",
            "Lu",
            "Luxury/limited/technology",
            " Ex",
            "Te",
            "Ex",
            "Gy",
            "Base",
            "Li",
            "Imited/technology",
            "Ne",
            "Lu Lu",
            "E S",
            "Lx",
            "Premium/tech",
            "Limited/premium",
            "K1500 Sle",
            "Premium Premium",
            " Base"
          ]
        },
        {
          "model": "Carnival",
          "series": [
            "Mpv Ex",
            "Lx",
            "Mpv Lx Seat Package",
            "Sx Prestige",
            "Mpv Sx Prestige",
            "Sx",
            "Ex",
            "Mpv Sx",
            "Mpv Lx",
            "Sx/sx Prestige",
            "Mpv Sx/sx Prestige",
            "Lx+",
            "Mpv Lxs",
            "Lxs",
            "E",
            "S",
            "L",
            "Lx/lxs",
            "Mpv Lx/lx Seat Package",
            "Ge",
            "Mpv Lx/lxs",
            "Mpv Hybrid Sx Prestige",
            "Lx Seat Package",
            "Mpv Hybrid Ex",
            "Mpv Hybrid Lxs",
            "Lx/lx+",
            "Ex/ex+",
            "Mpv Hybrid Sx"
          ]
        },
        {
          "model": "EV6",
          "series": [
            "Gt-Line",
            "Gt Line",
            "Light",
            "Wind",
            "Gt",
            "Light/wind",
            "Light/wind/gt Line",
            "Light Long Range",
            "Gt Lin",
            "Gt-Lin",
            "Ex+",
            "Ine",
            "T/wind",
            "T",
            "T/wind/gt Line",
            "Wind Rwd Wind",
            "Wind Awd Wind",
            "Land/wind",
            "Land W/gt-line Pkg 1/land W/gt-line Pkg 2",
            "Long Range W/gt-line Pkg 1/long Range W/gt-line Pkg 2",
            "Long Range/long Range W/gt-line Pkg 1"
          ]
        },
        {
          "model": "Forte",
          "series": [
            "Lxs",
            "Lx",
            "Ex",
            "Fe",
            "S",
            "Gt Line",
            "Gt-Line",
            "Gt",
            "Sx",
            "Fe/lxs",
            "Gt Manual",
            "Fe/lx/lxs",
            "Lx/lxs",
            "Gt L",
            "Gt Line/s",
            "Lx/s",
            "5-Door",
            "5-door Sx",
            "Supercrew",
            "Lx+",
            "Ex/ex+/ex Premium",
            "Ex+",
            "Ex/ex+/ex Premium/gt-line",
            "5-door Lx+/ex/ex Luxury",
            "Ex/sx",
            "5-door Ex",
            "5-door Lx",
            "Lx/lx+",
            "Gt/gt Manual",
            "Ex Premium",
            "4d Fe/lxs 4cy",
            "4d Ex",
            "Lxs/fe",
            "Lx Automatic Lx",
            "Koup",
            "Fe/l",
            "E",
            "E/s",
            "Fe/lx",
            "Gt-line W/inte",
            "Lxs W/intellig",
            "Automatic Lx",
            "4d Lx",
            "4d Gt",
            "4d",
            "Olla L",
            " Lx",
            "Silverado C1500 Lt",
            "Grade 5.7l V8",
            "Tradesman Slt",
            "Lxs W/intellig Fe/lxs",
            "S S",
            "Lt",
            "Lxs W/intellig Lxs",
            "Manual Lx",
            "Xl",
            "1.8l Lx/1.8l Lx+",
            "Ex/ex Luxury/ex+/sx",
            "Ex/ex Premium/ex+",
            "Ex/ex Limited/ex Premium/ex+",
            "2.0l Ex",
            "Ex/ex Premium/ex+/gt-line",
            "Ex/ex Luxury/ex+/lx/lx+",
            "Se",
            "Ex/ex Luxury/ex+",
            "2.0l Ex/2.0l Sx",
            "Gt/gt Limited",
            "2.0l Ex/2.0l Ex Se/2.0l Sx",
            "1.8l Lx/1.8l Lx+/lx+ Winter Edition",
            "2.0l Ex/2.0l Lx+",
            "Gt Limited",
            "2.0l Lx+",
            "2.0l Sx",
            "Mobile Suntracker",
            "1.8l Lx/1.8l Lx+/1.8l Se",
            "Ex/ex Premium/ex+/lx",
            "2.0l Ex/2.0l Ex Se",
            "2.0l Lx",
            "1.6l Sx/1.6l Sx Luxury",
            "1.6l Sx/1.6l Sx Premium",
            "2.4l Sx/2.4l Sx Luxury",
            "Ex/ex Premium/gt-line",
            "2.0l Ex/ex",
            "2.4l Sx",
            "2.0l Ex/2.0l Ex Luxury/2.0l Lx+",
            "2.0l Lx/lx",
            "2.0l Ex/2.0l Ex Luxury",
            "5 Ex",
            "1.6l Sx",
            "Gt-line W/inte Gt-line"
          ]
        },
        {
          "model": "Forte Koup",
          "series": [
            "Ex",
            "Sx",
            "Le",
            "Ex Automa Ex",
            "2.0l Ex",
            "2.4l Sx",
            "2.4l Sx/2.4l Sx Luxury",
            "1.6l Sx/1.6l Sx Luxury"
          ]
        },
        {
          "model": "Forte5",
          "series": [
            "Ex",
            "Lx",
            "Sx",
            "2.0l Ex",
            "2.0l Lx",
            "Gt/gt Limited",
            "Gt",
            "2.4l Sx/2.4l Sx Luxury"
          ]
        },
        {
          "model": "K5",
          "series": [
            "Gt-Line",
            "Gt Line",
            "Lx",
            "Ex",
            "Lxs",
            "Gt",
            "Ima Lx",
            "Line",
            "4d Gt-line",
            "Gt-line 1.6 Turbo",
            "4d",
            "Gt-line Automatic",
            "Ex Ex",
            "Lxs Fwd/k5 Lxs Awd",
            "Lxs Automatic Fwd Lxs",
            "Gt Gt",
            "Gt-line Automatic Gt Line",
            "Gt-line Automatic Gt-line",
            "Gt W/black Interior",
            " Light",
            "Ima Ex"
          ]
        },
        {
          "model": "K900",
          "series": [
            "Luxury",
            "Premium",
            "Premium 3.8l",
            "Luxury 3.8l",
            "Y",
            "Um",
            "Luxur",
            "Elite",
            "Luxury 5.0l"
          ]
        },
        {
          "model": "Magentis",
          "series": [
            "Lx",
            "Lx V6",
            "Ex Leather/lx",
            "Lx/sx",
            "Anniversary Edition"
          ]
        },
        {
          "model": "Niro",
          "series": [
            "Wind",
            "Touring",
            "Fe",
            "Ex",
            "Lx",
            "Touring Special Edition",
            "Ex Premium",
            "Plug-in Hybrid Lx",
            "Lxs",
            "S",
            "Plug-in Hybrid Ex",
            "Wave",
            "Ex Touring",
            "Lx/lxs/lxs Se",
            "S Touring",
            "Sx",
            "Lxs Se",
            "Fe/lx",
            "Plug-in Hybrid Lxs",
            "Touring Se",
            "Lx/lxs",
            "Sx/sx Touring",
            "Ex/graphite",
            "Touring/ex/premium",
            "Sx Touring",
            "Touring Sport",
            "Plug-in Hybrid Sx Touring",
            "S/ex",
            "Plug-in Hybrid Ex Premium",
            "Plug-in Hybrid",
            "Touring/ex Premium",
            "Touring/touring Special E",
            "Touri",
            "Ex Plug-in Hybrid",
            "Touring/touring Special Edition",
            "Ex/touring S",
            "Ex/ex Touring",
            " Gt",
            "Ex To",
            "Ex Pr",
            "Touring Se Fwd Touring Special Edition",
            "Touring Launch Edition",
            "Ng",
            "Ng Launch Edition",
            "Sx To",
            "Ring",
            "Ng Se",
            "Emium",
            "Ng/ex Premium",
            "Ng/ex/premium",
            "S/lxs Se",
            "Uring S",
            "Aphite",
            "Uring",
            "E",
            "Ng Special Edition",
            "Ng/touring Special E",
            "Ex/sx Touring",
            "Ex/ex Premium",
            "Premi",
            "L",
            "Hybd Ex",
            "Hybd Lx",
            "Ex/ex Premium/sx Touring"
          ]
        },
        {
          "model": "Niro EV",
          "series": [
            "Ex",
            "Wind",
            "Wave",
            "S",
            "Ex Premium",
            "Um",
            "D",
            "Wind/wind+",
            "Premium+",
            "Premium/premium+",
            "Ex/ex+",
            "Wave/wave W/snow White Pearl Grey Exterior",
            "Ex/sx Touring",
            "Sx Touring",
            "Premium",
            "Ex+/sx Touring",
            "Limited/limited W/snow White Pearl Grey Exterior"
          ]
        },
        {
          "model": "Optima",
          "series": [
            "Hybrid Ex",
            "Lx",
            "Ex",
            "Sx",
            "S",
            "Lx Turbo",
            "Hybrid",
            "Sxl Turbo",
            "Sx Turbo",
            "Hybrid Lx",
            "Ex V6/lx V6",
            "Hybrid Premium",
            "Ex/lx",
            "Lx/se",
            "Sx W/limited Pkg",
            "Sxl",
            "Lx/s",
            "Lx V6/se V6",
            "Lx/s/se",
            "Se",
            "Plug-in Hybrid",
            "Ex/sx",
            "Ex Turbo",
            "Hybrid Hybrid",
            "Ex Premium",
            "Lx/ex",
            "Ex V6",
            "Ex (new)/lx (new)",
            "Lx V6",
            "Plug-in Hybrid Ex",
            "Ex V6 (new)/lx V6 (new)",
            "Sx V6",
            "Plug-in Hybrid/ex",
            "Ex Hybrid",
            "Hybrid Hybrid/ex",
            "Magentis",
            "Plug In Hybrid Ex",
            "Hybrid/ex",
            "Hybrid Base",
            "Hyb",
            "Lx Lx",
            "Plu",
            "Lx Hybrid",
            "Ex Gdi",
            "Ex/ex+/ex Luxury",
            "Ex/lx/sx",
            "Sx W/chrome Limited Pkg",
            "Ex/",
            "Lx 1.6t",
            "Sx Limited",
            "L",
            "O",
            "Lx/",
            "Mited Pkg",
            "Bo",
            "X",
            "Id",
            "Lx/ex/sx",
            "Turbo",
            "Lx Automatic S",
            "Ted",
            "Rome Limited Pkg",
            "Lx/s S",
            "Ium",
            "Lx  V6/se",
            "Plug-in Hybrid Plug-in Hybrid/ex",
            "Ex Ex",
            "Sxt",
            "Sport Hybrid W",
            "Mag",
            "Lx Automatic",
            "Hyb 4d",
            " Hybrid Ex",
            " Hybrid/ex",
            "Se/le/xle",
            "Hyb Lx",
            "Se V6/lx V6",
            "Lander Base",
            "Ex New/lx New",
            "Lx  V6",
            "Magentis/lx/se",
            "Ex (new)/lx/lx (new)",
            "Premium",
            "Plu Plu",
            "Ex/ex Luxury",
            "Lx/lx+",
            "Ex/ex Luxury/ex+",
            "Lx/lx Winter Edition",
            "Ex/ex+",
            "Ex Turbo/ex Turbo +",
            "4d",
            "Ex/ex Tech",
            "Passat Se",
            " Intl (bci) Accord Sed",
            " Ex"
          ]
        },
        {
          "model": "Rio",
          "series": [
            "S",
            "Lx",
            "5-door S",
            "Ex",
            "Cinco (a4)/cinco (m5)",
            "Lx/sx",
            "Base",
            "5-Door",
            "Lx/s",
            "Ex/lx/sx",
            "Rs",
            "Rx-V",
            "Lx/lx+/lx+ Eco/ex/sx",
            "5 Lx",
            "Ex Premium",
            "Cinco",
            "Sx",
            "Lx Premium",
            "5 Sx",
            "Ex/sx",
            "5",
            "Base (a4)/base (m5)",
            "Ex/ex Sport",
            "5-door Lx/s",
            "Gdi",
            "Ex/lx",
            "5-door Lx+/lx Premium",
            "Lx+",
            "5-door Lx",
            "Lx/ex/lx+/sx/lx+ Eco/ex+",
            "Ex Sport",
            "5-door Ex",
            "Ex/lx+/sx/lx/lx+ Eco",
            "Ex Convenience",
            "5 Ex Convenience",
            "Sx/ex/lx",
            "Le/xle/xse/limited/platin",
            "Ex Pre",
            "B/lx/s",
            "Ex Aut",
            "/lx/sx",
            "Re",
            "X/ex",
            "Base/lx/sx",
            "X",
            "5-door Ex/sx",
            "S W/in",
            "Premium A-spec/technology",
            "5-door Sx",
            "X/lx",
            " Lx/sx",
            "X Line",
            "4d",
            "Utback 2.5i",
            "Base (a4)",
            "5 Sx 5 Sx",
            "Base Base",
            "Lx/lx+",
            "Ex/lx/lx+/sx",
            "Ex/ex-Convenience",
            "Ex/ex+ W/sunroof/lx/lx+/lx+ Eco/sx",
            "Lx Premium/lx+",
            "Ex/ex+/lx/lx+/sx",
            "Ex/ex Sport/ex Tech Navi",
            "Anniversary Edition/ls/rs/s",
            "Ex Special Edition/ex+ W/sunroof/lx/lx+/sx/sx W/navigation",
            "Ex/lx+",
            "Ex/lx/lx+",
            "Ls",
            "Sx Automatic Lx"
          ]
        },
        {
          "model": "Rio5",
          "series": [
            "Lx",
            "Sx",
            "Ex",
            "Lx+",
            "5 Sx",
            "Ex/sx",
            "Lx/sx",
            "Ex/ex-Convenience/ex-Sport"
          ]
        },
        {
          "model": "Rondo",
          "series": [
            "Lx",
            "Lx/ex",
            "Lx V6",
            "Base",
            "Ex V6",
            "Ex/ex W/3rd Row",
            "Ex",
            "Lx Base",
            "Lx Base/lx/ex",
            "Ex/lx/lx Base",
            "Ex V6/lx V6",
            "Ex Luxury V6",
            "Lx Lx V6",
            "Ex/ex-Premium/lx",
            "Ex/ex Luxury/se",
            "Ex/ex-Premium",
            "Lx/lx Value/lx Winter Edition",
            "L/lx",
            "Ex-v6/ex-v6 Luxury",
            "Ex/ex Luxury/ex Value",
            "Ex/ex-v6/ex-v6 Luxury",
            "Lx/lx Value",
            "Ex/ex Luxury/ex Premium",
            "Ex V6/ex-luxury"
          ]
        },
        {
          "model": "Sedona",
          "series": [
            "Lx",
            "Sxl",
            "Ex",
            "L",
            "Ex/lx",
            "Sx Luxury",
            "Sx",
            "Ex Premium",
            "Ex/sx",
            "Sx Limited",
            "L Lx",
            "Lx/ex",
            "Lx/lx+",
            "Base (a5)/lx",
            "Ex Luxury",
            "Base (a5)",
            "Lx+",
            "X",
            "Sx-L",
            "Lxe",
            "Ex/",
            "Ry",
            "Carnival",
            "Van",
            "Sxl Sxl",
            "E Ex",
            "L Ex",
            "Lx/lx Convenience",
            "Sx/sx+",
            "T Line",
            "Sx/sx+/sxl/sxl+",
            "Sx+",
            "Ex/ex Luxury/ex Power",
            "L Sx Prestige"
          ]
        },
        {
          "model": "Seltos",
          "series": [
            "Lx",
            "S",
            "Sx Turbo",
            "Ex",
            "X-Line",
            "Sx",
            "Nightfall",
            "X Line",
            "S Turbo",
            "Nightfall Edition",
            "Nig",
            "4d",
            "X L",
            "Ll",
            "O",
            "Uty",
            "Ex/ex Premium",
            "Lx Lx",
            "Nightfall Awd Nightfall Edition",
            "Sx Turbo W/black Interior/sx Turbo W/burgundy Interior/x-line",
            "Sx Turbo W/black Interior/sx Turbo W/burgundy Interior",
            "Sx W/black Interior/sx W/burgundy Interior/x-line",
            "X-line Turbo"
          ]
        },
        {
          "model": "Sorento",
          "series": [
            "Sx",
            "Lx",
            "S",
            "Ex",
            "L",
            "Ex V6",
            "Lx Base",
            "2.4l Lx",
            "X-line Sx Prestige",
            "2.4l L",
            "3.3l Ex",
            "Ex/lx",
            "3.3l Sx",
            "Lx V6",
            "Limited V6",
            "Base",
            "Sx V6",
            "3.3l Lx",
            "2.0t Ex",
            "Hybrid Ex",
            "X-line S",
            "3.3l S",
            "3.3l Sxl",
            "Sxp",
            "Lx/s",
            "L/lx",
            "Lx/l",
            "Plug-in Hybrid Sx",
            "Hybrid Sx Prestige",
            "Sx Prestige",
            "3.3l Ex Sport",
            "Ex/s",
            "Ex/ex Sport",
            "Sx/sx Limited",
            "Hybrid S",
            "Ta Sport",
            "Sx/sxp",
            "Plug-in Hybrid Sx Prestige",
            "2.0t Sxl",
            "Hybrid",
            "X-line Ex",
            "Lx/ex",
            "Ex/x-line Ex",
            "Sx/sxl",
            "X-line Turbo",
            "Lx Turbo",
            "X-pro Sx Prestige",
            "X-line Sx",
            "X",
            "V6",
            "Xl",
            "Sx/x-line Sx Prestige/x-p",
            "Sx/x-line Sx Prestige",
            "2.4l L/2.4l Lx",
            "Ex+ Turbo",
            "Ex+ V6",
            "Sx Limited V6",
            "Ba",
            "Sx Limited",
            "Lx W/gasolin Lx",
            "S V6",
            "Sxl",
            "Ex Sport V6",
            "Sxl V6",
            "4d Lx",
            "L/",
            "Hy",
            "Sx Prestige X-line",
            "Ed",
            "Ige X-line",
            "Base/lx",
            "Ige",
            "4d",
            "Mited",
            " V6",
            "Lx W/gasoline Dir",
            "X Prestige",
            "Ort",
            "Ed V6",
            "Lx Lx",
            "Base A5",
            "Limited V6/sx V6",
            "Sorrentolx",
            "3.3l Ex/3.3l Sx/3.3l Sxl",
            " Luxury",
            "Ex/ex+",
            "2.0l Sx",
            "2.4l Ex",
            "3.3l Ex/3.3l Ex+",
            "2.0l Ex",
            "3.3l Black Line/3.3l Lx+",
            "2.0l Ex/2.0l Lx Turbo",
            "Lx/lx Premium",
            "2.5t X-line",
            "3.3l Sx/3.3l Sx+",
            "Lx+",
            "Sx/x-line Sx Prestige/x-pro Sx Prestige",
            "2.5t Sx W/black Leather/2.5t Sx W/burgundy Leather",
            "3.3l Lx +",
            "2.0l Lx",
            "2.0l Lx Turbo",
            "3.3l Lx V6 7-seater",
            "Ex Luxury V6/ex V6",
            "2.4l Lx/2.4l Lx+/3.3l Lx+",
            "2.5l Lx Premium/2.5l Lx+/2.5t Ex/2.5t Ex+",
            "2.4l Lx/3.3l Lx",
            "Lx/se",
            "2.5l Lx Premium/2.5l Lx+",
            "Sxl Limited V6",
            " Lx",
            "2.0l Ex/2.0l Lx+",
            "2.5t Ex/2.5t X-line",
            "Lx/lx Premium/se",
            "2.5t Ex/2.5t Ex+",
            "3.3l Luxury/lx",
            "2.0l Lx+",
            "Lx/sx",
            "Lx/lx V6",
            "Sx/sx Prestige",
            "2.5t X-line Limited W/black Interior/2.5t X-line Limited W/olive Brown Interior/2.5t X-pro W",
            "Percrew",
            "Lx+ V6",
            "Ta Se"
          ]
        },
        {
          "model": "Soul",
          "series": [
            "!",
            "Lx",
            "+",
            "Gt Line",
            "Ex",
            "Gt-line Turbo",
            "X-Line",
            "S",
            "Base",
            "X-Line/lx/s",
            "Lx/s",
            "Ev",
            "Lx/x Line/s",
            "Gt-Line",
            "Ev Base",
            "+/!/sport",
            "Sport",
            "Turbo",
            "2u",
            "Ev +",
            "2u/4u/4u Retro",
            "!/+",
            "/!/sport",
            "4u",
            "Ex/ex+",
            "Ex/ex+/ex+ Eco",
            "Sx",
            "Ev Limited",
            "Suv",
            "4u Burner",
            "Plus",
            "2u/4u/4u Retro/4u Burner/4u Sx/luxury",
            "Ex/ex+/ex Premium/ex Tech",
            "4u Retro",
            "Gt-Li",
            "Gt Li",
            "+/|/s",
            "4u Sx",
            "+/!/s",
            "Automatic",
            "Soul",
            "Ev Pr",
            "!/+/s",
            "Ev De",
            "! Aut",
            "+ Aut",
            "Ev Lu",
            "E",
            "Ne",
            "+/!",
            "Autom",
            "Sw Sp",
            "Sw +",
            "Lx/x-",
            "Port",
            "Line/s",
            "Lx/s/x-Line",
            "Sw Ex",
            "Sw",
            "Gt-line W/intel",
            "Ne Turbo",
            "Ex/ex+ Eco/sx",
            "S/s Plus/sv/sr/sl",
            "Sw Ltd",
            "4 Cyl.",
            "Ort",
            "4d",
            "Ntra Sr",
            "Ev Ba",
            "!/+/sport",
            "S W/intelligent Lx",
            "Ev Li",
            "Ex Ex",
            "Base (m5)",
            "I Sv",
            "Ex Premium",
            "Manual",
            "Ex W/ Lx",
            "Energy Edition/ex/ex+/ex+ Eco/sport Special Edition/sx/sx Luxury/urban Special Edition",
            "Ex/ex Anniversary Edition/ex Limited/ex Premium/ex+/gt-line Limited/gt-line Premium",
            "Lx/lx+",
            "Ex/ex Premium/ex Tech/ex+",
            "Ex/ex+/ex+ Eco/sport Special Edition/sx/sx Luxury/urban Special Edition",
            "Premium",
            "Ev Designer",
            "2.0l 2u/2.0l 4u/2.0l 4u Burner/2.0l 4u Luxury/2.0l 4u Retro/2.0l 4u Sx",
            "Sx Turbo/sx Turbo Tech",
            "Ex/ex Premium/ex+",
            "S W/intelligent S",
            "Ex/ex Premium/ex+/gt-line Limited",
            "2.0l 2u/2.0l 4u/2.0l 4u Burner/2.0l 4u Luxury/2.0l 4u Retro",
            "2.0l 2u/2.0l 4u/2.0l 4u Burner/2.0l 4u Retro/2.0l 4u Sx",
            "Ex+",
            "2.0t Premium",
            "2.0l 2u/2.0l 4u/2.0l 4u Burner/2.0l 4u Luxury/2.0l 4u R",
            "Sx/sx Luxury/two-tone Fathom Blue/white Special Edition/two-tone Inferno Red",
            "Ex Limited",
            "2u Eco",
            "Sx/sx Luxury",
            "Llenger Sxt",
            "Gt-line Limited"
          ]
        },
        {
          "model": "Soul EV",
          "series": [
            "+",
            "Ev",
            "Premium",
            "Designer",
            "Limited",
            "Ev-E",
            "Ev+",
            "Base",
            "Lu",
            "Ba",
            "Eve",
            "Luxury"
          ]
        },
        {
          "model": "Sportage",
          "series": [
            "Lx",
            "Ex",
            "Lx V6",
            "Ex V6/lx V6",
            "X-Line",
            "Sx-Prestige",
            "Ex V6",
            "Sx Turbo",
            "Nightfall Edition",
            "Base",
            "Sx",
            "Ex/lx",
            "Hybrid Lx",
            "Hybrid Ex",
            "X Line",
            "S",
            "Hybrid Sx-prestige",
            "X-Pro",
            "Sx Prestige",
            "X-pro Prestige",
            "Plug-in Hybrid X-line",
            "X-line Prestige",
            "L",
            "Base (a4)",
            "Ex/limited",
            "Hybrid",
            "Base (a4)/base (m5)/ex/limited",
            "Age",
            "Lx/ex",
            "Plug-in Hybrid X-line Prestige",
            "X-pro/x-pro Prestige",
            "Hybrid Sx Prestige",
            "Ex/sx",
            "Ex/limited/base (a4)/base (m5)",
            "Base (a4)/base (m5)",
            "Ex S",
            "Plug-in Hybrid",
            "Sport",
            "Ex Hev",
            "X",
            "Base (m5)/ex",
            "E",
            "X Line Limited",
            "Ex Awd",
            "B",
            "Ex Awd Ex",
            "L L",
            "Nightfall",
            "Base/lx",
            "/l",
            "4d Ex",
            "Ge",
            "New Sporta",
            "Stige",
            "4d 4x4 X-p",
            "Ro Prestige",
            "Slt",
            "Base A4/base M5",
            "Base A4/base M5/ex/limited",
            "Ex Premium",
            "Sx Prestige Sx-prestige",
            "Se",
            "X-line Limited",
            "Lx/lx S",
            "10th Anniversary Edition/lx",
            "Lx/x-Line",
            "Ex/ex Premium W/black Interior/ex Premium W/red Interior",
            "Ex/ex Premium/ex Tech",
            "Ex Ex",
            "Sx Awd Sx Turbo",
            "Sx/sx Luxury",
            "Ex Premium S/ex S",
            "Ex/ex Premium/ex Premium S/ex S/ex Tech",
            "X-line/x-line Limited W/black Interior/x-line Limited W/green Interior",
            "Ex/ex Luxury/ex W/luxury Pkg",
            "Ex/ex Luxury",
            "Ex-Luxury/lx-V6",
            "Lx/lx Anniversary/lx S",
            "Lx-V6/sx",
            "Base (a4)/base (m5)/ex",
            "Lx-v6/lx-v6 Luxury",
            "Lx-V6",
            "X-line Limited W/black Interior/x-line Limited W/green Interior",
            "Ex Premium S",
            "Luxury/lx-V6",
            "Sx Prestige Sx Prestige",
            "H",
            "Lx-Convenience"
          ]
        },
        {
          "model": "Stinger",
          "series": [
            "Gt1",
            "Gt2",
            "Gt-Line",
            "Gt Line",
            "Gt",
            "Premium",
            "Gts",
            "Pr",
            "Base",
            "4d 2wd/4x4 Gt",
            "Gt Limited V6",
            "Gt Limited",
            "Gt2 Rwd Gt2",
            "Gt Elite - Suede Package/gt Elite W/black Interior/gt Elite W/red Interior/gt Limited/scorpion",
            "Gt1 Rwd Gt1"
          ]
        },
        {
          "model": "Telluride",
          "series": [
            "S",
            "Sx",
            "Ex",
            "Ex X-line",
            "Lx",
            "Sx X-pro",
            "Sx Prestige X-line",
            "Sx Prestige X-pro",
            "Sx/sx X-line/sx X-pro/sx Prestige/sx Prest X-ln/sx Prest X-pro",
            "Sx Prestige",
            "Ex/ex X-line",
            "Sx/sx X-line/sx X-pro/sx",
            "Sx X-line",
            "Sx Prestige/sx Prest X-ln",
            "Sv",
            "Sx-p X-pro",
            "Sx-P",
            "E X-line",
            "Ne/sx X-pro/sx",
            "S Awd",
            "Sx/sx X-line/sx X-pro",
            "Ex/ex",
            "Sx/sx X-line/sx X-pro/sx Prestige/sx Prest X-ln/sx Pres",
            "S Fwd S",
            "Lx Awd Lx",
            "Sx Limited",
            "Ex/ex X-line/ex X-pro",
            "S Awd S",
            "Ex X-pro",
            "Nightsky/sx/sx Limited",
            "Sx/sx X-line/sx Prestige/sx Prestige X-line/sx Prestige X-pro",
            "Sx/sx Limited/sx Limited W/nappa",
            "Sx/sx Limited/x-line/x-pro",
            "Sx/sx Limited/nightsky",
            "X-Line",
            "Sx/sx X-line/sx Prestige/sx Prestige X-line/sx Prestige"
          ]
        }
      ]
    },
    {
      "make": "Lamborghini",
      "models": [
        {
          "model": "Aventador",
          "series": [
            "Svj",
            "50th Anniversario",
            "Lp750-4 Superveloce",
            "Sv",
            "Lp 750-4 Superveloce",
            "S",
            "Lp700-4/lp700-4 Pirelli Edition",
            "Lp700-4"
          ]
        },
        {
          "model": "Centenario",
          "series": []
        },
        {
          "model": "Gallardo",
          "series": [
            "Lp550-2",
            "Lp560-4",
            "Superleggera",
            "Spyder",
            "S"
          ]
        },
        {
          "model": "Huracan",
          "series": [
            "Lp580-2s",
            "Evo",
            "Evo Coupe",
            "Lp610-4",
            "Tecnica",
            "Performante",
            "Evo Rwd",
            "Tecnica Coupe",
            "Tecnica Tecnica",
            "Evo Spyder Rwd",
            "Evo Evo",
            "Lp580-2",
            "Lp610-4/lp610-4 Avio",
            "Sto",
            "Lp 610-4 Spyder",
            "Lp 610-4",
            "Evo Spyder",
            "Pe",
            "St",
            "Ev",
            "Steratto",
            "Te",
            "Ls Huracan",
            "Sto Coupe"
          ]
        },
        {
          "model": "Murcielago",
          "series": [
            "Lp640"
          ]
        },
        {
          "model": "Urus",
          "series": [
            "Pearl Capsule/graphite Capsule",
            "S",
            "Graphite Capsule/pearl Capsule",
            "Performante",
            "Perfo",
            "Odels Urus"
          ]
        },
        {
          "model": "Veneno",
          "series": []
        }
      ]
    },
    {
      "make": "Land Rover",
      "models": [
        {
          "model": "Defender",
          "series": [
            "90 S",
            "110 X-dynamic Se",
            "110 S",
            "X-dynamic Se",
            "130 X-dynamic Se",
            "110 Se",
            "130 S",
            "110",
            "110 X-dynamic Hse",
            "110 Hse",
            "110 X",
            "X-dynamic Hse",
            "1",
            "90 X-dynamic Se",
            "90 First Edition",
            "110 P400 S",
            "110 Carpathian Edition/110 V8",
            "110 Xs Edition",
            "110 First Edition/110 Hse",
            "S",
            "X",
            "90 Carpathian Edition/90 V8",
            "110 1st Edition",
            "110 P300",
            "130 X",
            "130 First Edition",
            "110 P400 X",
            "9",
            "110 P500 Se",
            "130 P400 S",
            "110 P525 V8",
            "110 Standard",
            "110 P400 X-dynamic Se",
            "90 Standard",
            "130 P400 X-dynamic Se",
            "130 Se",
            "90 X-dynamic Hse",
            "90 X-dynamic S",
            "Hse/first Edition",
            "Hse",
            "Se",
            "X-dynamic S",
            "V8/carpathian Edition",
            "Carpathian Edition/v8",
            "First Edition",
            "90 75th Edition",
            "Xs Edition",
            "Carpathian Edition/ V8",
            "V8",
            "90/90 Carpathian Edition",
            "110 First Edition",
            "P400 Sedona Red Edition",
            "90 1st Edition",
            "90 P400 X-dynamic Se",
            "110 P525 Carpathian Edition",
            "1 1",
            "110/110 Carpathian Edition",
            "130 Outbound",
            "110 Carpathian Edition",
            "130 P400 X",
            "110 75th Ltd Edition",
            "130",
            "90 X",
            "130 P300 S",
            "90 P300 S",
            "110 P500 X-dynamic Se"
          ]
        },
        {
          "model": "Defender 110",
          "series": [
            "Hse",
            "S",
            "X-dynamic Se",
            "Se",
            "X-dynamic Hse",
            "Xs Edition",
            "X",
            "1st Edition",
            "75th Ltd Edition"
          ]
        },
        {
          "model": "Defender 130",
          "series": [
            "Se",
            "X-dynamic Se",
            "X",
            "First Edition",
            "S"
          ]
        },
        {
          "model": "Defender 90",
          "series": [
            "X-dynamic Se",
            "X",
            "S",
            "Se",
            "X-dynamic Hse",
            "X-dynamic S",
            "Soft Top"
          ]
        },
        {
          "model": "Discovery",
          "series": [
            "Sport Se",
            "Se",
            "Hse",
            "Sport Hse",
            "Sport Hse Luxury",
            "S R-dynamic",
            "Sport S",
            "Ii Se",
            "P360 Hse R-dynamic",
            "P300 S",
            "S",
            "Series Ii Se",
            "Series Ii Cloth/series Ii Leather",
            "Hse Luxury",
            "Sport Se R-dynamic",
            "Sport S R-dynamic",
            "Landmark",
            "Sport",
            "Series Ii",
            "Landmark Edition",
            "Ii Sd",
            "Hse R-dynamic",
            "Se/sd/se7",
            "P300 S R-dynamic",
            "Series Ii Sd",
            "P360 Metropolitan Edition",
            "Ii",
            "Le/ls",
            "P360 S R-dynamic",
            "Ii S",
            "Ii Hse",
            "Sport Hse R-dynamic",
            "First Edition",
            "Metropolitan Edition",
            "P300 Dynamic Se",
            "R Evoque Pure Plus",
            "Sd/se/se7",
            "Sport Dynamic Se",
            "R Evoque Se",
            "Dynamic Se",
            "P360 Dynamic Se",
            "Sport Hse Luxury Dynamic",
            "Series Ii Le",
            "Dynamic Hse",
            "Hse Luxury Td6",
            "Ii Series Ii Cloth/series Ii Leather",
            "Diesel Td6 Hse",
            "P360 R-dynamic S",
            "Sport Hse Dynamic"
          ]
        },
        {
          "model": "Discovery Sport",
          "series": [
            "Hse/landmark Edition",
            "Hse Lux",
            "Hse",
            "Se",
            "Hse Luxury",
            "S",
            "R-dynamic S/r-dynamic Se",
            "Standard",
            "S R-dynamic",
            "Se R-dynamic",
            "R-dynamic Se",
            "Hse/landmark",
            "R-Dynamic",
            "Hse R-dynamic",
            "Core S",
            "R-dynamic Hse",
            "Dynamic Se"
          ]
        },
        {
          "model": "LR2",
          "series": [
            "Se",
            "Hse",
            "Hse Technology",
            "Hse Luxury",
            "Se Technology",
            "Se/hse",
            "Se V6",
            "E Rover Hse",
            "Base/hse",
            "Hse V6",
            "Hse Te",
            "Base/h",
            "Hse Lux",
            "Se Tec",
            "Hse Lu",
            "Base",
            "Hse Hse",
            "Hse Te Hse Te",
            "Hse/se"
          ]
        },
        {
          "model": "LR4",
          "series": [
            "Hse",
            "Hse Luxury",
            "Hse Plus",
            "Hse Lu",
            "Lux",
            "Hse Pl",
            "Hse Lux",
            "Hse Silver Edition",
            "Lux Limited Edition",
            "Base",
            "Hse Lux Landmark Edition",
            "Hse Hse",
            "Hse Luxury Landmark Edition",
            "Hse Lu Hse Lu",
            "Se"
          ]
        },
        {
          "model": "Range Rover",
          "series": [
            "Hse",
            "Autobiography",
            "5.0l V8 Supercharged",
            "5.0l V8 Supercharged Autobiography",
            "P525 Hse",
            "P530 Se",
            "Supercharged",
            "3.0l V6 Supercharged Hse",
            "P525 Westminster",
            "3.0l V6 Turbocharged Diesel Hse Td6",
            "3.0l V6 Supercharged",
            "5.0l V8 Supercharged/5.0l V8 Supercharged Ebony Edition",
            "Sv Autobiography Dynamic",
            "Se",
            "4.0/4.0 Se/county",
            "Westminster",
            "P400 Se",
            "Hse Luxury",
            "5.0l V8 Holland Holland/5.0l V8 Supercharged Autobiography",
            "4.6 Hse",
            "4.6 Hse Long Wheelbase",
            "Td6",
            "3.0l V6 Turbocharged Diesel Td6",
            "5.0l V8 Holland & Holland/5.0l V8 Supercharged Autobiography",
            "Autobiography/autobiography 7 Seat",
            " Velar Dynamic Hse",
            "Sc",
            "5.0l V8 Supercharged Sv Autobiography Dynamic",
            "Parts Only",
            "Hse 4.6",
            "Hse Td6",
            "4.0 Se",
            "Long Wheelbase",
            " Hse",
            " Sport Hse",
            " Sport Lux",
            " Supercharged",
            " Velar R-dynamic Se",
            " Sport P525 Autobiography",
            " Evoque Se",
            " Velar S",
            " Evoque Pure Plus",
            " Sport Hse Luxury",
            " Autobiography",
            " Hse Luxury",
            " Evoque Prestige Premium",
            " Sport Supercharged",
            " Sport Sc",
            " 4.0 Se Long Wheelbase",
            " Sport Se",
            " Sport Hse Dynamic",
            " Evoque Hse",
            " Sport P525 Hse",
            " Sport Supercharged Dynamic",
            " Velar R-dynamic Hse",
            " Sport Hst",
            " Evoque Pure",
            " Evoque Pure Premium",
            " Velar R-dynamic S",
            " Se",
            " Sv Autobiography",
            " 4.6 Hse Long Wheelbase",
            " Velar 1st Edition",
            " Sport Dynamic Se",
            " Evoque S",
            " Long Wheelbase",
            " Sport Hse Silver Edition",
            "P530 Autobiography/p530 Autobiography 7 Seat",
            " Sport Autobiography",
            " Evoque Hse Dynamic",
            " Evoque Dynamic Premium",
            " Westminster Edition",
            " P525 Hse",
            "Autobio Supercharg",
            " Hse Westminster Edition",
            " Sport Svr",
            " Evoque R-dynamic Se",
            " Evoque Prestige Premiu",
            " Hse Westminster Editio",
            "El Hse",
            "5.0l V8 Holland   Holland/5.0l V8 Supercharged Autobiography",
            "Fifty",
            "Bumper",
            "4.0 Se Long Wheelbase",
            "Se 4.0",
            "Hse Lux",
            "P530 Autobiography",
            "4.0/4.0 Se/4.0s",
            "Westminster Edition",
            "5.0l V8 Supercharged Sv Autobiography",
            "Hse Westminster Edition",
            "Evoqu",
            "Sc Autobiography",
            "Diesel Hse",
            "Diesel",
            "4.6 Se Long Wheelbase",
            "Ange Rove",
            "Sport Sc",
            "Evoque Dynamic Premium",
            "Sport Supercharged Dynamic",
            "Evoque Pure",
            "Velar R-dynamic Hse",
            "Velar R-dynamic Se",
            "Sport Supercharged",
            "3.0l V6 Turbocharged",
            "4.6 Se",
            "Evoque First Edition",
            "Evoque Dynamic Se",
            "Sport Hse Dynamic",
            "Sport Autobiography",
            "Evoque Prestige Premium",
            "Sport P525 Hse",
            "Evoque Se",
            "Sport Svr",
            "Sc Autobiography/sc Autobiography Ultimate Edition",
            "Sport Hse Silver Edition",
            "Evoque R-dynamic Hse",
            "Sport Autobiography Dynamic",
            "Sv Autobiography",
            "Hse/westminster",
            "First Edition",
            "Sport Se",
            "Evoque S",
            "Evoque R-dynamic Se",
            "Velar R-dynamic S",
            "Sport Supercharged Autobiography",
            "Evoque Hst",
            "Sport",
            "Autobiography Black",
            "Evoque Pure Plus",
            "Velar S",
            "Sport Hse Luxury",
            "Evoque Hse",
            "Sport Hst",
            "Evoque Hse Dynamic",
            "Supercharged Plus Autobiography Pkg",
            "Sport Dynamic Se",
            "Velar",
            "Sport P525 Autobiograp",
            "Sport P525 Autobiography",
            "Sport Hse",
            "Evoque Pure Premium",
            "Sport Lux",
            "Sport Supercharged Dyn",
            "Velar Dynamic Se",
            "5.0l V8 Holland   Holland/5.0l V8 Supercharged Autobiog",
            "Velar Hst",
            "Evoque R-dynamic S",
            "Ndmark",
            "Evoque Autobiography",
            "L Hse",
            "Sport Hse Silver Editi",
            "Velar Dynamic Hse",
            "Hse Westminster Editio",
            "Sv",
            "Evoque Landmark Edition",
            "Velar 1st Edition",
            "Sport First Edition",
            "Evoque Se Dynamic",
            "Evoque Prestige Premiu",
            "Velar Sv Autobiography Dynamic",
            "Velar Se",
            "P400 Se 7 Seat",
            "Range Rove",
            "     Rangerover",
            "P550e Se",
            "P530 Se 7 Seat",
            "P530 Autobiography Swb",
            "P440e Se",
            "Autobio P530",
            "4.4 Hse",
            "Autobiography Fifty Edition",
            "P550e Autobiography",
            "Diesel Td6 Hse",
            "P615 Sv Swb"
          ]
        },
        {
          "model": "Range Rover Evoque",
          "series": [
            "S",
            "Pure",
            "R-dynamic Hse",
            "Pure Plus",
            "R-dynamic S",
            "Se/se Premium",
            "Dynamic Premium",
            "Hse",
            "Dynamic",
            "First Edition",
            "Se",
            "R-dynamic Se",
            "Prestige",
            "Pure Premium",
            "Hse Dynamic",
            "Se Dynamic",
            "Core S",
            "Prestige Premium",
            "Autobiography",
            "Landmark Edition",
            "S P250",
            "Se Premium",
            "Landmark Edition/se Premium",
            "R-dynamic Hst",
            "Se Premium/landmark Ed",
            "Dynamic Se",
            "Pure City",
            "P250 S",
            "Landmark Special Edition",
            "Hst",
            "Bronze Collection",
            "P250 Dynamic Hse"
          ]
        },
        {
          "model": "Range Rover Sport",
          "series": [
            "Hse Luxury",
            "Hst",
            "Hse",
            "Sc",
            "Svr/svr Carbon Edition",
            "Hse Mhev",
            "3.0l V6 Supercharged Hse",
            "3.0l V6 Supercharged Se",
            "Se Mhev",
            "Hse Td6",
            "Supercharged/supercharged Dynamic",
            "Hse Silver Edition Mhev",
            "Hst Mhev",
            "Se Dynamic",
            "Se",
            "Hse Dynamic",
            "Supercharged",
            "3.0l V6 Supercharged Hse/3.0l V6 Supercharged Se",
            "5.0l V8 Supercharged",
            "Lux",
            "5.0l V8 Supercharged/5.0l V8 Supercharged Dynamic",
            "Supercharged Dynamic",
            "Svr",
            "3.0l V6 Supercharged Hse Dynamic",
            "Autobiography",
            "5.0l V8 Supercharged Autobiography",
            "3.0l V6 Turbocharged Diesel Hse Td6",
            "Hse Silver Edition",
            "5.0l V8 Supercharged Svr",
            "First Edition",
            "Dynamic",
            "Dynamic Se",
            "Autobiography Dynamic",
            "P525 Hse",
            "3.0l V6 Turbocharged Diesel Se Td6",
            "Hse Lux",
            "P525 Autobiography",
            "Se Td6",
            "Td6 Hse",
            "V6 Hse",
            "V6 Se",
            "Sc Autobiography",
            "V6 Diesel Hse",
            "Hse/se",
            "V6 Diesel Se",
            "V8",
            "V8 Svr",
            "Hse Limited Edition",
            "3.0l V6 Turbocharged",
            "Se/hse",
            "V6 Hst Le",
            "Hse Gt Limited Edition",
            "Supercharged Autobiography",
            "V8 Dynamic",
            "5.0l V8",
            "Hse/hse Gt Limited Edition",
            "Autobiograph",
            "P460 Dynamic Se",
            "P360 Se",
            "Dynamic Hse",
            "Diesel Td6 Hse",
            "Hse Silver Td6",
            "Hse Mhev/hse Phev",
            "P400 Dynamic Hse",
            "Sv Edition One Carbon Bronze",
            "V8 Supercharged",
            "Hse/hse Dynamic",
            "P400 Dynamic Se",
            "P530 Dynamic Se",
            "Autobio Dyn"
          ]
        },
        {
          "model": "Range Rover Velar",
          "series": [
            "P250 R-dynamic S",
            "P250 S",
            "P340 S",
            "P380 First Edition/p380 Hse R-dynamic",
            "P340 R-dynamic S Mhev",
            "P380 S",
            "P250 R-dynamic Se",
            "P250 Se R-dynamic",
            "P380 Se R-dynamic",
            "P340 R-dynamic S",
            "R-dynamic S",
            "P400 R-dynamic Hse",
            "D180 S",
            "S",
            "D180 Se R-dynamic",
            "P250 Hse R-dynamic",
            "P250",
            "R-dynamic Se",
            "D180 Hse R-dynamic",
            "P250 Dynamic Se",
            "R-dynamic Hse",
            "Svautobiography Dynamic",
            "P340 R-dynamic Se/p380 R-dynamic Se",
            "P340 S/p380 S",
            "P380 R-dynamic Hse",
            "Dynamic Se",
            "P250 Base",
            "R-dynamic Hse/first Ed",
            "P340 R-dynamic Se",
            "First Edition/r-dynamic Hse",
            "P400 Dynamic Hse",
            "P400 Dynamic Se",
            "Hse R-dyn",
            "P300 Hse R-dynamic",
            "P400 Hst"
          ]
        }
      ]
    },
    {
      "make": "Lexus",
      "models": [
        {
          "model": "CT200h",
          "series": [
            "Premium",
            "200",
            "Hybrid",
            " Hybrid",
            " 200",
            " F Sport",
            " Premium",
            "Hy",
            "Hybrid 200"
          ]
        },
        {
          "model": "ES250",
          "series": [
            " Base",
            "250 Base/250 Luxury/250 U",
            "Base",
            "H",
            "4d 4wd",
            "Es 250",
            " F Sport",
            "250",
            "Es 250 Bas",
            " Luxury",
            "Bas Es 250 Bas",
            " 250 Base/250 Luxury/250 U",
            " Base/250 Luxury",
            "Luxury",
            "Bas",
            "F Sport",
            "250 Base/250 Luxury/250 Ultra Luxury/250 F Sport",
            "Ultra Luxury",
            "250 Base/250 Luxury/250 Ultra Luxury/250 F Sport Design"
          ]
        },
        {
          "model": "ES300h",
          "series": [
            "F Sport",
            "Ultra Luxury",
            "300h",
            "Luxury",
            "F-sport Handling",
            "300h Base/300h Luxury/300h Ultra Luxury/300h F-sport Design/300h F-sport Handling",
            "F Sport Handling",
            "300h Base/300h Luxury/300",
            "Signature",
            "Base",
            "300h F Sport Handling",
            "Ba",
            "300h Base/300h Luxury/300h Ultra Luxury",
            "300h Base/300h Luxury/300h Ultra Luxury/300h F Sport Design/300h F Sport Handling",
            " 300h",
            "S 300h",
            "Lu",
            " F-",
            "S 300h Ul",
            " Ba",
            " Hybrid",
            " Luxury",
            " Ultra Luxury",
            " F-sport",
            " Ul",
            " F",
            "Hy",
            " F Sport",
            "S 300h Ba",
            " Lu",
            "S 300h Lu",
            " Base/300h Luxury/300",
            " F Sport Handling",
            " F-sport Handling",
            "00h",
            " Base",
            "F-",
            " 300h Base/300h Luxury/300",
            " Base/300h Luxury/300h Ultra Luxury/300h F-sport Design/300h F-sport Handling",
            " 300h Ultra Luxury",
            "H",
            "F Sport Design",
            "F",
            "300h Ultra Luxury",
            "Es 300h",
            "Ba Es 300h Ba",
            "300h Base/300h Luxury/300h Ultra Luxury/300h F Sport De",
            "Hybrid",
            "Luxury/ultra Luxury"
          ]
        },
        {
          "model": "ES350",
          "series": [
            " Base",
            "Luxury",
            "F Sport",
            "Base (a6)",
            "F Sport Handling",
            "350",
            "350 Base/350 Luxury/350 U",
            " F-sport Handling",
            " F-sport",
            " Luxury",
            "Crafted Line",
            "Ultra Luxury",
            "F Sport/luxury/ultra Luxury",
            "350 F-sport Handling",
            "4dr Sdn",
            "Premium",
            " 4d",
            "Base",
            "F-sport Handling",
            "350 Base/350 Luxury/350 F-sport/350 Ultra Luxury",
            "Signature",
            "350 F Sport Handling",
            "350 Ultra Luxury",
            "350 Base/350 Luxury/350 F",
            "Bas",
            " Ultra Luxury",
            "350 F Sport",
            "Es 350",
            "350 Base/350 Luxury/350 Ultra Luxury/350 F Sport",
            " F Sport",
            "Premium/signature",
            " 4dr Sdn",
            " 350",
            " 350 Base/350 Luxury/350 Ultra Luxury/350 F-sport",
            " 350 F Sport Handling",
            " Ult",
            " 350 Base/350 Luxury/350 F",
            " Fwd",
            " F S",
            "Lux",
            "N",
            "Es 350 F-s",
            " Crafted Line",
            "D Line",
            "H",
            "Es 350 4d",
            " 350 Ultra Luxury",
            "Es 350 Bas",
            " Bas",
            " F-s",
            "Es 350 Ult",
            " Slt",
            " Lux",
            " Luxury/ultra Luxury/f Sport",
            "4d",
            "Es 350 Lux",
            " 350 Base/350 Luxury/350 U",
            " 350 Base/350 Luxury/350 F-sport/350 Ultra Luxury",
            " 350 F-sport",
            " F Sport Handling",
            " Base/350 Luxury/350 Ultra Luxury/350 F-sport Design/350 F-sport Handling",
            " Base/350 Luxury",
            " 350 F-sport Handling",
            " Base (a6)",
            " Base A6",
            " F Sport/luxury/ultra Luxury",
            " 350 Luxury",
            "H F-",
            "Inum Tool High Box",
            "F S",
            "350 Base/350 Luxury/350 F Sport/350 Ultra Luxury",
            "350 Base/350 Luxury/350 Ultra Luxury/350 F-sport Design",
            "Fwd",
            "350 Base/350 Luxury/350 Ultra Luxury/350 F-sport Design/350 F Sport Handling",
            "350 Base/350 Luxury"
          ]
        },
        {
          "model": "GS F",
          "series": []
        },
        {
          "model": "GS200t",
          "series": [
            "Base",
            "Ba",
            "200t Base/200t F Sport",
            " 200t Base/200t F Sport",
            "S 200t",
            " Ba",
            "S 200t Ba",
            " F Sport",
            " Base",
            "F Sport"
          ]
        },
        {
          "model": "GS300",
          "series": [
            "Base (a5)",
            "300",
            "Luxury Perform Sdn",
            "Base (a6)",
            "                Gs 300",
            "Gs 300 Bas",
            "Gs 300",
            " Base (a5)",
            " Base (a6)",
            " Base A5",
            " Awd"
          ]
        },
        {
          "model": "GS350",
          "series": [
            "Crafted Line",
            " Base",
            "F Sport",
            " F-sport",
            "350",
            "Base",
            "Base (a6)",
            " 350",
            "Gs 350",
            "350 Base/350 F Sport",
            "Bas",
            " F-s",
            " F S",
            "4d",
            " Crafted Line",
            " F Sport",
            "T",
            "Gs 350 Bas",
            "Gs 350 Awd",
            " Awd",
            " F Sport Black Line",
            "Gs 350 F-s",
            " 350/base/f Sport",
            "Se/f Sport",
            "D Line",
            " Bas",
            "350 Base/350 F-sport",
            " Base (a6)",
            " Base A6",
            "H 400h",
            " Gs 350",
            " 350 F-sport",
            " 350 Base/350 F Sport",
            "F S",
            "Premium"
          ]
        },
        {
          "model": "GS450h",
          "series": [
            "450h",
            "S 450h Ba",
            "S 450h",
            " Hybrid",
            "S 450h Hy",
            " 450h",
            "Gs 450h"
          ]
        },
        {
          "model": "GS460",
          "series": [
            "Gs 460",
            "460"
          ]
        },
        {
          "model": "GX460",
          "series": [
            "Luxury",
            "Premium",
            "Ultra Premium",
            " Premium",
            " Luxury",
            " Lux",
            "4wd",
            "M",
            " Pre",
            " Base (a6)",
            "Pre",
            "Base (a6)",
            "460"
          ]
        },
        {
          "model": "HS250h",
          "series": [
            "Premium",
            "250h",
            "Premium/premium Luxury",
            "Base (ecvt)",
            " Base (ecvt)",
            " Premium",
            " 250h"
          ]
        },
        {
          "model": "IS F",
          "series": [
            "F",
            "Is 300",
            "Base (a8)"
          ]
        },
        {
          "model": "IS200t",
          "series": [
            "200t",
            " 200t",
            " Is Turbo"
          ]
        },
        {
          "model": "IS250",
          "series": [
            "250",
            "Crafted Line",
            "Auto",
            " 250",
            "D Line",
            " Crafted Line",
            " Awd",
            " Auto",
            " Manual/auto",
            " Manual",
            " Base A6",
            " Base (a6)",
            "Base (a6)",
            "Base (m6)",
            "Manual/auto"
          ]
        },
        {
          "model": "IS300",
          "series": [
            "300",
            "Base W/5-speed Manual",
            "Sport Cross",
            "Base (a5)",
            "Base W/5-speed Auto",
            "300 Sportcross",
            "F Sport Design",
            "Sportcross",
            "F-Sport",
            "300/300 F Sport Design/30",
            "F Sport",
            " 300",
            " F-s",
            "4d",
            "Rwd",
            " F Sport",
            " F Sport Design",
            " F S",
            " Sport",
            "F-S",
            " Base W/5-speed Manual",
            " Base W/5-speed Auto",
            " Sportcross",
            " F-sport",
            " Spo",
            " Premium",
            " Sport Cross",
            " Base (a5)",
            "Awd",
            " Base A5",
            " Base A6",
            " Base W/5-speed Auto/base W/5-speed Manual",
            " Pre",
            " 300 F-sport",
            "F S",
            "Base (a6)",
            "300 F Sport",
            "Pre 300 Pre",
            "Rwd 300",
            "Base W/5-speed Auto/base W/5-speed Manual"
          ]
        },
        {
          "model": "IS350",
          "series": [
            "F Sport",
            "F-Sport",
            "F Sport Design",
            "350",
            "350 F-sport",
            "Base (a8)",
            "350 F Sport Design/350 F-",
            "350 F Sport Design/350 F",
            "350 F Sport",
            " 350",
            "Auto",
            " 350 F Sport",
            "F S",
            " F Sport",
            " Auto",
            " 350 F Sport Design/350 F",
            "F-S",
            " F S",
            " F Sport Design/350 F-",
            " F Sport Design",
            " F-s",
            " F-sport",
            " Base (a6)",
            " 350 F Sport Design/350 F-",
            " Base A6",
            " 350 F-sport",
            " Base (a8)",
            "Base (a6)",
            "Awd 250"
          ]
        },
        {
          "model": "IS500",
          "series": [
            "F Sport",
            "F Sport Performance Premium",
            "F Sport Performance Launch Edition",
            "F S",
            "500 F Sport/500 F Sport P",
            " F S",
            " 500 F Sport/500 F Sport P",
            " F Sport",
            " F Sport Performance Launch Edition",
            " F Sport Performance Premium",
            "F Sport Performance"
          ]
        },
        {
          "model": "LC500",
          "series": [
            "Lc 500",
            "H",
            "Sport",
            "500",
            " 500",
            "Lc 500h"
          ]
        },
        {
          "model": "LC500h",
          "series": []
        },
        {
          "model": "LFA",
          "series": []
        },
        {
          "model": "LS460",
          "series": [
            "L",
            "460",
            "Crafted Line",
            "460l",
            "Ls 460l",
            " 460",
            "Lwb",
            "L 4",
            "Ls 460",
            "Awd",
            " L",
            " Lwb",
            "L Awd",
            " L 4",
            " 460l",
            " Base A8",
            " Crafted Line",
            " Base (a8)"
          ]
        },
        {
          "model": "LS500",
          "series": [
            "F Sport",
            " Base",
            " F-sport",
            "500 Base/500 F-sport",
            "500",
            "Base",
            "Bas",
            "Ls 500 Bas",
            "H",
            "500 Base/500 F Sport",
            "Ls 500",
            " Bas",
            " F Sport",
            "Ls 500h",
            "Ls 500 F-s",
            " 500 Base/500 F-sport",
            " 500",
            " 500 Base/500 F Sport",
            "L"
          ]
        },
        {
          "model": "LS500h",
          "series": [
            "S 500h",
            " 500h"
          ]
        },
        {
          "model": "LS600h",
          "series": [
            "L",
            "600hl",
            " L"
          ]
        },
        {
          "model": "LX570",
          "series": [
            "Three-Row",
            "Two-Row",
            "570",
            "Lx 570",
            " 570",
            " Two-row",
            " Three-row",
            "Three-Row/two-Row"
          ]
        },
        {
          "model": "LX600",
          "series": [
            "Base",
            "Ultra Luxury",
            "F Sport",
            "Base/600 Premium/600",
            "Bas",
            " Bas",
            "Ult",
            " Ultra Luxury",
            " Ult",
            " Luxury",
            " Base",
            " F Sport",
            "Premium",
            "Luxury",
            "Pre"
          ]
        },
        {
          "model": "NX200t",
          "series": [
            "Base",
            "F Sport",
            "200t/base/f Sport",
            "200t",
            "Ba",
            " F Sport",
            "Se/f Sport",
            " 200t",
            " Ba",
            " 200t/base/f Sport",
            " Base",
            " Nx Turbo",
            "Urbo",
            "/base/f Sport",
            "Aw"
          ]
        },
        {
          "model": "NX250",
          "series": [
            "250 Premium",
            "Premium",
            "Base",
            "250",
            "250 Base/250 Premium",
            " Bas",
            " Pre",
            " 250",
            " 250 Base/250 Premium",
            " Base",
            "Bas",
            " Premium",
            "Pre",
            " 250 Premium"
          ]
        },
        {
          "model": "NX300",
          "series": [
            "F Sport",
            "Base",
            "F-Sport",
            "300 Base/300 F-sport",
            "Base/300 F-sport",
            "Base/300 Luxury/300 F-sport",
            "300/base/f Sport",
            "300 F-sport",
            "300",
            "Luxury",
            "300 Base/300 F Sport",
            "300 Base/300 Luxury/300 F",
            "300 F Sport",
            " F Sport",
            " 300 Base/300 F Sport",
            " 300 Base/300 Luxury/300 F Sport",
            " F S",
            "F-S",
            " Luxury",
            " Base",
            " Bas",
            " F-s",
            "Lux",
            " 300 Base/300 F-sport",
            " Base/300 Luxury/300 F-sport",
            "/base/f Sport",
            " 300 Base/300 Luxury/300 F",
            " Lux",
            " F-sport",
            " 300/base/f Sport",
            " 300",
            " 300 F-sport",
            "Se/f Sport",
            " 300 Base/300 Luxury",
            "Fwd",
            " 300 F Sport",
            "F S",
            "300 Base/300 Luxury/300 F Sport",
            "Awd 300 Base/300 Luxury/300 F Sport"
          ]
        },
        {
          "model": "NX300h",
          "series": [
            "Base",
            "Base/300h Luxury/300h F Sport Black Line",
            "300h Base/300h Luxury/300",
            "300h",
            "F Sport Black Line",
            " Ba",
            " F Sport Black",
            " Luxury",
            " F Sport Black Line",
            " Base",
            " 300h",
            " 300h Base/300h Luxury/300",
            " 300h Base",
            "Executive",
            "300h Base/300h Luxury/300h F Sport Black Line",
            "Ba"
          ]
        },
        {
          "model": "NX350",
          "series": [
            "Premium",
            "Base",
            "F Sport Handling",
            "Luxury",
            "350 Base/350 Premium/350 Luxury/350 F-sport",
            "350",
            "350 Luxury/350 F Sport",
            " 350 Luxury/350 F Sport",
            " Lux",
            "Pre",
            "Lux",
            " 350 Luxury/350 F-sport",
            " Bas",
            "Bas",
            " F Sport Handling",
            " Premium",
            " Luxury",
            " Pre",
            " Base",
            " 350",
            "350 Base/350 Premium/350",
            " 350 Premium",
            "350 Base/350 Premium/350 Luxury/350 F Sport",
            "350h Base/350h Premium/350h Luxury"
          ]
        },
        {
          "model": "NX350h",
          "series": [
            "Premium",
            "Base",
            "350h",
            "Luxury",
            "Ba",
            "350h Base/350h Premium/35",
            "Hy",
            " 350h Base/350h Premium/35",
            " Premium",
            " Luxury",
            " Base",
            " Base/350h Premium/350h Luxury",
            " Ba",
            " 350h",
            "350h Base/350h Premium/350h Luxury"
          ]
        },
        {
          "model": "NX450h+",
          "series": [
            "F Sport Handling",
            "Luxury",
            "F Sport",
            "450h Luxury/450h F Sport",
            " Luxury",
            " F Sport",
            "0h+ F Sport",
            " F Sport Handling"
          ]
        },
        {
          "model": "RC F",
          "series": [
            "Track Edition",
            "Track",
            "-F",
            "Base (a8)"
          ]
        },
        {
          "model": "RC200t",
          "series": [
            "200t",
            " 200t",
            "O"
          ]
        },
        {
          "model": "RC300",
          "series": [
            " Base",
            " F-sport",
            "300",
            "F Sport",
            "300 Base/300 F Sport",
            "Rc 300 Bas",
            "Bas",
            "Rc 300",
            " F Sport",
            "Rc 300 F-s",
            " Bas",
            " F-s",
            " 300",
            "F S",
            " F S",
            " 300 Base/300 F Sport"
          ]
        },
        {
          "model": "RC350",
          "series": [
            " F-sport",
            " Base",
            "F Sport",
            "350 Base/350 F-sport",
            "F-Sport",
            "Base",
            "350",
            "Base A8",
            " F S",
            " F Sport",
            " F-s",
            " Bas",
            " 350 F Sport",
            "Rc 350 F-s",
            " 350",
            "Rc 350 Bas",
            "Rc 350",
            " Base A8",
            "Bas",
            "Preferred",
            "350 Base/350 F Sport",
            "Bas Rc 350 Bas",
            "F S",
            "Wd"
          ]
        },
        {
          "model": "RX350",
          "series": [
            " F-sport",
            " Base",
            "F Sport",
            "Premium",
            "Premium Plus",
            "F Sport Handling",
            " L",
            "F Sport Appearance",
            "350",
            "350 Base/350 F-sport",
            "E",
            " Premium",
            " L Luxury",
            "F Sport/sportdesign",
            "F Sport Performance",
            "Luxury/premium/premium Plus",
            "350/base/f Sport",
            "350 Base/350 Premium/350",
            "Sportdesign",
            "Luxury",
            "350 Premium/350 Premium P",
            "350 Base/350 Premium/350 Premium Plus/350 Luxury",
            "Base",
            "F-Sport",
            "Crafted Line",
            "Crafted Line/f Sport",
            "350 Base/350 F Sport",
            "350 F-sport",
            "Rc 350",
            "Rx 350 Bas",
            "Rx 350 L",
            "F Sport Handling/luxury/premium/premium Plus",
            " Bas",
            "350 F Sport",
            " 350/base/f Sport",
            "Rx 350",
            "Bas",
            " 350",
            " 350 F-sport",
            " 350 Base/350 F Sport",
            " 350 F Sport",
            "Fwd",
            " F Sport",
            " F Sport Appearance",
            " Crafted Line F Sport",
            " F Sport Handling",
            " Awd",
            " F S",
            "F S",
            " Le/se/xle/l",
            "Rx 350 F-s",
            "Se/f Sport",
            "T",
            " F-s",
            "Awd",
            "H Ba",
            " Rx 350",
            "Rx 350 L L",
            "F4",
            " Premium Plus",
            "H Base",
            "/base/f Sport",
            " Base A5",
            " Luxury/premium/premium Plus",
            " Base (a6)",
            " 350 Base/350 F-sport",
            " Crafted Line/f Sport",
            " Pre",
            " 350 Base/350 Premium/350 Premium Plus/350 Luxury",
            " Base A6",
            " Luxury",
            " Crafted Line",
            " Base/350 F-sport",
            " Base (a5)",
            " 350 Premium/350 Premium P",
            " 350 Base/350 Premium/350",
            "Pre",
            " F Sport Performance",
            "Base (a5)",
            "Base (a6)",
            "Fwd 350",
            "4d",
            "F Sport Design",
            " F S Awd",
            "F Sport Design/f Sport Handling/luxury/premium/premium Plus"
          ]
        },
        {
          "model": "RX350L",
          "series": [
            "Premium",
            "Luxury",
            "350 L",
            " Luxury",
            " Premium",
            "L",
            "50l",
            "X 350 L",
            "L Luxury",
            " Luxury/premium",
            " 350 L",
            "Rx 350 L",
            "Luxury/premium"
          ]
        },
        {
          "model": "RX450h",
          "series": [
            "F Sport Handling",
            "F Sport",
            "450",
            "F Sport Performance",
            "F Sport Appearance",
            "450h",
            "Sportdesign",
            "F-Sport",
            "L",
            "Base",
            "450h/base/f Sport",
            "X 450h L",
            "450h Base/450h F Sport",
            "X 450h",
            " 450",
            "Ba",
            " 450h Base/450h F Sport",
            " F Sport",
            "X 450h Ba",
            "X 450h F-",
            " Ba",
            " F Sport Handling",
            " L",
            " L Luxury",
            " 450h",
            " F-",
            " 450h/base/f Sport",
            " L Base",
            "50h",
            " Base",
            " F Sport Appearance",
            "/base/f Sport",
            " Base/450h F-sport",
            " F-sport",
            " Base (cvt)",
            " F Sport Performance",
            " F",
            "Hybrid",
            "F",
            "Rx 450h",
            "L Rx 450h L",
            "Fwd 450",
            "(rx Hybrid)"
          ]
        },
        {
          "model": "RX450hL",
          "series": [
            "Luxury",
            "450h L Base/450h L Luxury",
            "Premium",
            " Luxury",
            " Premium",
            " 450h L",
            "450h L"
          ]
        },
        {
          "model": "SC430",
          "series": [
            "430",
            "Base (a5)",
            "Sc 430",
            " Base (a5)",
            " Base A5"
          ]
        },
        {
          "model": "UX200",
          "series": [
            "F Sport",
            "Base",
            "200",
            " Bas",
            " F Sport",
            " Luxury",
            "Bas",
            " Base",
            " 200 Base/200 F Sport/200",
            " 200",
            "Luxury",
            "200 Base/200 F Sport/200 Luxury"
          ]
        },
        {
          "model": "UX250h",
          "series": [
            "F Sport",
            "Premium",
            "Base",
            "250h",
            "250h Base/250h Premium/25",
            "F Sport Design",
            "Luxury",
            "250h Base/250h Premium/250h F Sport Design/250h F Sport Handling",
            "F Sport/luxury",
            "Ba",
            "250h Premium/250h F Sport",
            "F Sport Handling",
            " 250h Premium/250h F Sport",
            " Pr",
            " F Sport",
            " Luxury",
            "Pr",
            " Ba",
            " Premium",
            " F Sport Handling",
            " Base",
            " Premium/250h F Sport",
            " 250h",
            " F Sport Design"
          ]
        },
        {
          "model": "CT200",
          "series": [
            "F-Sport",
            "Base",
            " Ct200h",
            " H",
            "H",
            "Ct200h",
            "300"
          ]
        }
      ]
    },
    {
      "make": "Lincoln",
      "models": [
        {
          "model": "Aviator",
          "series": [
            "Reserve",
            "Black Label",
            "Grand Touring",
            "Livery",
            "Black Label Grand Touring",
            "Standard",
            "Luxury/premium",
            "Rve",
            "Re",
            " Select",
            "Luxury",
            "Luxury (300a)",
            "R L Select",
            "Premium",
            "Gr",
            "Bl",
            "Bel",
            "Luxury/ultimate",
            "Uring",
            "Ultimate",
            "Premiere",
            "Grand Touring Hybrid",
            "Iere",
            "R Reserve"
          ]
        },
        {
          "model": "Corsair",
          "series": [
            "Standard",
            "Reserve",
            "Premiere",
            "Grand Touring",
            "Gr",
            "Uring",
            "Re"
          ]
        },
        {
          "model": "Mark LT",
          "series": []
        },
        {
          "model": "MKC",
          "series": [
            "Reserve",
            "Premiere",
            "Select",
            "Standard",
            "Premier",
            "Black Label",
            "Reserv",
            "Ct",
            "Rve",
            "Premie",
            "Dard",
            "Ier",
            "Iere",
            "Rv",
            "Ie",
            "K Label",
            "Ls",
            "Mkc",
            "Hybrid",
            "Black",
            "Standard Fwd Standard",
            "Select Select",
            "Premie Premie",
            "Reserve Awd Reserve"
          ]
        },
        {
          "model": "MKS",
          "series": [
            "Ecoboost",
            "Base 100a",
            "Oost",
            "Oboost",
            "Awd",
            "W/ecoboost",
            "4d 4wd"
          ]
        },
        {
          "model": "MKT",
          "series": [
            "Livery",
            "Ecoboost",
            "Reserve",
            "Standard",
            "Limo/hearse",
            "Premiere",
            "Oboost",
            "Oost",
            "Rve",
            "Reserve/standard",
            "Elite",
            "W/ecoboost",
            "Rve/standard",
            "Iere",
            "Fwd",
            "Awd",
            "Builders Package Livery",
            "Limo"
          ]
        },
        {
          "model": "MKX",
          "series": [
            "Select",
            "Reserve",
            "Fwd",
            "Premiere",
            "Black Label",
            "Premier",
            "Base (100a)",
            " Xb",
            "Reserv",
            "Ct",
            "Rv",
            "Iere",
            "Premie",
            "Ier",
            "K Label",
            "Ie",
            "Rve",
            "Rese",
            "Black",
            "K",
            "Awd",
            "Awd Black Label",
            "4d 2wd Awd",
            "Erv"
          ]
        },
        {
          "model": "MKZ",
          "series": [
            "Reserve",
            "Hybrid",
            "Awd",
            "Hybrid Reserve",
            "Premiere",
            "Reserve I",
            "Select",
            "Standard",
            "Black Label",
            "Hybrid Reserve Ii",
            "Reserve Ii",
            "Hybrid Premiere",
            "Hybrid Hybrid",
            "Hybrid Select",
            "Hybrid Reserve I",
            "Hybrid Hybrid Select",
            "Hybrid Hybrid Premiere",
            "Base (200b)",
            "Hybrid Standard",
            "Hybrid Black Label",
            "Id Black Label",
            "Hybrid Hybrid Reserve",
            "Reserv",
            "Id Standard",
            "Id",
            "Ie",
            "Rve",
            "Mkc",
            "Id Premiere",
            "Id Reserve",
            "Mkc Black",
            "Id Reserve Ii",
            "Id Premier",
            "Premier",
            "Ct",
            "Premie",
            "Rve Ii",
            "Rve I",
            "Dard",
            "K Label",
            "Rv",
            "Iere",
            "Id Select",
            "Ier",
            "Hybrid Premier",
            "Black",
            "Id Reserve I",
            "4d Blk Label",
            "4d 4wd",
            "K",
            "High Country",
            "Reserve V6"
          ]
        },
        {
          "model": "Nautilus",
          "series": [
            "Reserve",
            "Select",
            "Standard",
            "Black Label",
            "Premiere",
            "P",
            "R",
            " L",
            "B",
            "S",
            "El",
            "Fwd 4c Select",
            "Reserve V6"
          ]
        },
        {
          "model": "Navigator",
          "series": [
            "Reserve",
            "L",
            "L Reserve",
            "Select",
            "Luxury/premium/ultimate",
            "Ultimate",
            "Luxury/ultimate",
            "L Select",
            "Black Label L",
            "Reserve L",
            "Black Label",
            "L Black Label",
            "Premiere",
            "Standard",
            "L L",
            "Standard L",
            "L/reserve",
            "Se/se Night Shade",
            "L L/select",
            "L L/reserve",
            "Bel",
            "Navig",
            "Premier",
            "L/black Label",
            "Base (120a)",
            "R/t",
            "L/select",
            "Ultimate/luxury/premium",
            "Luxury",
            "Premium",
            "L L Reserve",
            "Limousine",
            "Premiere L"
          ]
        },
        {
          "model": "Town Car",
          "series": [
            "Cartier",
            "Signature Limited",
            "Signature",
            "Ultimate",
            "Executive",
            "Signature L",
            "Sig./sig. Prem./sig. Prem. Touring/sig. Touring",
            "Executive L",
            "Designer Series",
            "Designer",
            "Signature/spinnaker",
            "Cartier L",
            "Executive/signature",
            "Sig./sig. Prem./sig. Prem. Touring/signature",
            "Sgn/dmnd Anv/cypress/jn",
            "Signature/signature Premium",
            "Cartier/cartier Prem.",
            "Executive W/limousine Pkg",
            "Signature/tournament",
            "C",
            "Signature/jack Nicklaus",
            "Ultimate L",
            "Executive Pkg",
            "Cartier Premium",
            "W/livery Pkg",
            "Livery Pkg",
            "Cartier/cartier Premium",
            "Own Car S",
            " Limited",
            "Own Car E",
            " W/limousine Pkg",
            "Sig.",
            "E",
            " L W/livery Pkg",
            "S",
            "Limited",
            "Executive L W/livery Pkg",
            "Signature Long Wheelbase",
            "W/limosine Builders Pkg",
            "Executive W/livery Pkg",
            "Own Car",
            "Signature Premium",
            " L",
            "Sig./sig. Prem.",
            "Sig./sig. Prem./signature",
            "Ultimate Long Wheelbase",
            "S Town Car S",
            "Signature L Signature Limited",
            "Signature/touring",
            "Sig. Prem./signature"
          ]
        }
      ]
    },
    {
      "make": "Lotus",
      "models": [
        {
          "model": "Elise",
          "series": [
            "Sc"
          ]
        },
        {
          "model": "Emira",
          "series": [
            "First Edition",
            "V6 First Edition",
            "Firs"
          ]
        },
        {
          "model": "Evora",
          "series": [
            "2+2",
            "400",
            "S",
            "S 2+2",
            "Gt"
          ]
        },
        {
          "model": "Evora GT",
          "series": [
            "Coupe"
          ]
        },
        {
          "model": "Exige",
          "series": [
            "S"
          ]
        }
      ]
    },
    {
      "make": "Lucid",
      "models": [
        {
          "model": "Air",
          "series": [
            "Grand Touring",
            "Pure",
            "Touring",
            "Rs Air Pure",
            "Dream Edition",
            "Rs Air Touring"
          ]
        }
      ]
    },
    {
      "make": "Maserati",
      "models": [
        {
          "model": "Ghibli",
          "series": [
            "S Q4",
            "S",
            "S Gransport",
            "S/q4",
            "Modena",
            "Base",
            "Luxury",
            "Mc Edition",
            "Gransport",
            "S/q4/sport",
            "Modena Q4",
            "S Q4 Gransport",
            "S Granlusso",
            "S/q4/luxury",
            "Sport",
            "S/sport",
            "S/luxury",
            "Granlusso",
            "S Q4 Granlusso",
            "Trofeo",
            "S Q",
            "Lux",
            "Spo",
            "Mod",
            "Dv6",
            "Gt",
            "V6",
            "F Tributo Q4",
            "Tro",
            "Bas",
            "Mc",
            "S V",
            "Ghibli"
          ]
        },
        {
          "model": "GranCabrio",
          "series": []
        },
        {
          "model": "GranTurismo",
          "series": [
            "Sport/mc",
            "S",
            "Mc/sport",
            "Modena",
            "S Automatic",
            "Mc/mc Centennial/sport",
            "Sport/mc/mc Centennial",
            "S/sport/mc",
            "Sport",
            "Sport/mc Stradale",
            "Convertible",
            "Mc/sport/mc Centennial",
            "Mc",
            "Convertible Sport/mc",
            "Convertible S/sport/mc",
            "Mc Stradale",
            "Convertible Sport/mc/mc Centennial",
            "Convertible Sport",
            "Gransport",
            "Trofeo",
            "S/s Automatic"
          ]
        },
        {
          "model": "Grecale",
          "series": [
            "Gt",
            "Modena",
            "Trofeo",
            "Mo",
            "Tr"
          ]
        },
        {
          "model": "Levante",
          "series": [
            "S Granlusso",
            "Gts",
            "Modena",
            "Gt",
            "Sport",
            "S",
            "Base",
            "Granlusso",
            "S Luxury",
            "S Gransport",
            "Luxury",
            "S Sport",
            "Trofeo",
            "Gransport",
            "Mc Edition/tributo",
            "Gts/trofeo",
            "Modena S",
            "Lu",
            "Sp",
            "D",
            "Mo",
            "Ba",
            "Tributo",
            "Levante",
            "V8",
            "Ls Levante",
            "Mc Edition"
          ]
        },
        {
          "model": "MC20",
          "series": [
            "Mc20",
            "Cielo"
          ]
        },
        {
          "model": "Quattroporte",
          "series": [
            "S Q4",
            "S Q4 Granlusso",
            "S",
            "Executive Gt/sport Gt",
            "M139",
            "Gts",
            "S Gransport",
            "S/sport",
            "Base Automatic/executive Gt Automatic/sport Gt S Automatic",
            "Base Automatic/executive Gt Automatic/sport Gt Automatic",
            "Modena",
            "Base Duoselect/executive Duoselect/sport Gt Duoselect",
            "Gts Granlusso",
            "Gt",
            "S/luxury",
            "S Q4 Gransport",
            "S Granlusso",
            "Sport Gt S",
            "Gts Gransport",
            "Modena Q4",
            "S/sport Gt-s",
            "Trofeo",
            "Executive Gt",
            "Sport Gt Duoselect/base Duoselect/executive Duoselect",
            "Sport Gt S Automatic/base Automatic/executive Gt Automatic",
            "Sport Gt/executive Gt",
            "S/q4/sport",
            "S V6 Q4",
            "Gts/sport"
          ]
        }
      ]
    },
    {
      "make": "Maybach",
      "models": [
        {
          "model": "57",
          "series": [
            "S"
          ]
        },
        {
          "model": "62",
          "series": []
        }
      ]
    },
    {
      "make": "Mazda",
      "models": [
        {
          "model": "2",
          "series": [
            "Zda2",
            "Touring",
            "Sport",
            "Zda2 Sport",
            "Zda2 Touring",
            "T",
            "Gx",
            "Mazda",
            "Mazda Spo",
            "Zda Spo",
            "Mazda Gx",
            "Zda",
            "Ort",
            "Uring",
            "Zda2 Sport/touring",
            "Zda Tou",
            "Zda2 Spo",
            "Zda2 Mazda",
            "Zda2 Spo Mazda Spo",
            "I",
            "Mazda Tou",
            "Cv",
            "Mazda Gs",
            "Mazda2 Spo",
            "Tou Mazda2 Tou",
            "Mazda2",
            "Sport/touring",
            "Gs/gx"
          ]
        },
        {
          "model": "3",
          "series": [
            "I",
            "Touring",
            "I Touring",
            "I Sport",
            "S Touring",
            "2.5 S Carbon Edition",
            "Sport",
            "I Grand Touring",
            "Select",
            "Back",
            "2.5 S Select",
            "Premium Package",
            "Grand Touring",
            "2.5 S Preferred",
            "Premium Plus",
            "I/i Sport/i Touring Value",
            "S Grand Touring",
            "I Touring Value",
            "Select Package",
            "S Sport",
            "I/i Sport",
            "Sp23",
            "Premium",
            "Mazda3i",
            "S",
            "I Sv",
            "Preferred",
            "Preferred Package",
            "Carbon Edition",
            "2.5 S Select Sport",
            "2.5 Turbo Premium Plus",
            "Sv",
            "Hatchback",
            "2.5 Turbo",
            "Touring 2.5",
            "Gx",
            "2.5 S",
            "Mazdaspeed3 Sport",
            "Mazdaspeed3 Gt",
            "Gs-Sky",
            "Preferred Plus",
            "Gs",
            "Mazda Sport Gx",
            "Sport Gs",
            "Gs I-activ",
            "Carbon Turbo",
            "S/sp23",
            "-5 Touring",
            "Select Sport",
            "-9",
            "Gt",
            "Mazda",
            "Mazda Sport Gs",
            "Mazda Gs",
            "2.0",
            "Mazdaspeed3 Touring",
            "-30 Select",
            "2.5 Carbon Turbo",
            "Sport Gt Sky",
            "Mazda3",
            "3",
            "-3 Grand Touring",
            "Sport Gx",
            "Sport Gs Sky",
            "Gs Sky",
            "Eed 3",
            "Sport Gt",
            "Mazda .",
            "Gx Sky",
            "Mazda Gx",
            "Gt Sky",
            "S/s Grand Touring/s Touring",
            "Gx/gs",
            "Se",
            "2.5 S Premium",
            "Sport Gx Sky",
            "3 S",
            "Grand To",
            "And Touring",
            "Zda3 I Sport",
            "Zda3 4-door Grand Touring",
            "Zda3 S Sport",
            "S Grand Touring/s Sport/s Touring",
            "Zda3 I Touring",
            "Mazda Gt",
            "Preferre",
            "I Sport/i Sv/i Touring",
            "Zda3 5-door Grand Touring",
            "S Grand Touring/s Touring",
            "L Other Speed 3",
            "Zda3 Sedan W/preferred Pkg",
            "Zda3 Touring",
            "-5 Sport",
            "Sport D",
            "Zda3 Sv",
            "Zda3 5-door",
            "Zda3 I Grand Touring",
            "Mazda Gra",
            "Zda3 I",
            "Zda3",
            "Zda3 Sport",
            "Zda3 4-door Sport",
            "Uring",
            "Zda3 3",
            "Zda3 Hatchback",
            "Zda3 S",
            "Zda3 Sedan",
            "I Grand",
            "Zda3 5-door Sport",
            "Zda3 3 S",
            "Zda3 4-door Touring",
            "Zda3 Grand Touring",
            "Zda3 I Touring Value",
            "Zda3 4-door",
            "And To",
            "Ort",
            "I Tourin",
            "Zda3 Mazdaspeed3 Sport",
            "Zda3 I Sv",
            "Zda3 Hatchback W/preferred Pkg",
            "Lect Package",
            "Zda3 S Touring",
            "Mazda S",
            "Zda3 Sedan Select Package",
            "Zda3 Hatchback Premium Package",
            "Zda3 S Grand Touring",
            "Zda3 5-door Touring",
            "Select Pkg",
            "Zda 3",
            "Zda3 Mazdaspeed3 Touring",
            "Eferred Package",
            "Zda3 Sedan W/select Pkg",
            "Zda3 Mazdaspeed3 Gt",
            "Zda3 Hatchback W/premium Pkg",
            "Zda3 Hatchback Preferred Package",
            "Preferred Pkg",
            "Eferred",
            "Zda3 Sedan Premium Package",
            "Zda3 Hatchback Premium",
            "0",
            "Zda3 Sedan Preferred",
            "5 S",
            "5 Turbo Premium Plus",
            "Touring Value",
            "Premium Pkg",
            "Emium Package",
            "Uring 2.5",
            "Zda3 5-door Touring 2.5",
            "Mazda I",
            "Zda3 Sedan W/premium Pkg",
            "G",
            "Emium",
            "Zda3 Hatchback 2.5 Turbo Premium Plus",
            "Lect",
            "Zdaspeed3 Sport",
            "Zda3 S Touring *ltd Avail*",
            "Zda3 Sedan Select",
            "Zda3 Sedan 2.5 S",
            "Zda3 Sedan 2.0",
            "Mazda Tou",
            "Eferred Plus",
            "Zdaspeed3 Gt",
            "Zda3 Hatchback Preferred",
            "Zda3 Hatchback 2.5 Turbo",
            "Zda3 Sedan Premium",
            "Zda3 Sedan 2.5 Turbo Premium Plus",
            "Sedan W/preferred Pkg",
            "Zda3 Gs",
            "Zda3 Hatchback 2.5 S",
            "Zda3 Sedan Carbon Edition",
            "Zda3 Mazdaspeed3 Gt *ltd",
            "Zdaspeed3 Touring",
            "Zda3 Sedan Pkg",
            "Eferre",
            "Zdas",
            "Emium Plus",
            "Hatchbac",
            "Zdai",
            "5 Turbo",
            "Zda3 Hatchback Select",
            "Zda3 Sedan Preferred Package",
            "Zda3 Sedan 2.5 Turbo",
            "Zda",
            "Zda3 Hatchback Carbon Edition",
            "Rbon Edition",
            "Zda3 I Touring *ltd Avail",
            "Zda3 Sport *ltd Avail*",
            "Zda3 Man I Sport *ltd Avail*",
            "4d Hbk 4x4 Prm",
            "Zda3 Mazdaspeed3",
            "4d I G.tou",
            "Grand Touring Ex-l",
            "Zda3 Gx",
            "Zda3 3 Hatchbac",
            "Zda3 S Sport *ltd Avail*",
            "Sport I",
            "Zda3 S Gt *ltd Avail*",
            "5 S Premium",
            "Zda3 Special Edition",
            "Zda3 S/special Edition",
            "Zda I",
            "Zda3 Preferred Package",
            "Zda3 2.5 S Select",
            "Zdaspeed3 Grand Touring",
            "Zda 3 I Grand Touring",
            "Zda3 Preferred",
            "Zda3 Hatchback 2.5 S Preferred",
            "Zda3 Man I Sport *ltd",
            "Zda3 Sedan 2.5 S Select",
            "Zda 3 S Touring",
            "Zda3 2.5 S Preferred",
            "Zda3 Hatchback 2.5 S Carbon Edition",
            "Zda3 Sedan 2.5 S Preferred",
            "Mazdai",
            "Zda3 Sedan 2.5 S Premium",
            "Zda3 Touring 2.5",
            "Zda3 2.5 S Carbon Edition",
            "Zda3 Premium",
            "Zda3 Hatchback 2.5 S Premium",
            "Zda3 Hatchback 2.5 S Select",
            "Zda3 Select Package",
            "Ex",
            "Zda3 Select",
            "Zda3 Premium Package",
            "Zda3 Mazda3",
            "Zda3 Mazdaspeed3 Sport*ltd",
            "Zda3  Premium",
            "Zda3 Sedan 2.5 S Carbon Edition",
            "5 S Select",
            "Zda3  2.0",
            "Zda3 2.5 S",
            "Mazda Sport Gt",
            "I Gs",
            "Zda3 2.5 Turbo Premium Plus",
            "Zda3 S/s Grand Touring/s Touring",
            "Zda3 2.5 S Premium",
            "Zda3 Sedan Premium Plus",
            "Zda3 Premium Plus",
            "Zda3 I/i Sport/i Touring Value",
            "Zda3 S Grand Touring/s Sport/s Touring",
            "Zda3 Sp23",
            "Zda3 2.5 Carbon Turbo",
            "Zda3 I/i Sport",
            "Zda3 2.5 Turbo",
            "Zda3 Carbon Edition",
            "Zda3 2.0",
            "Zda3 2.5 S Select Sport",
            "Zda3 Select Sport",
            "Mazda Spo",
            "Mazda Se",
            "Zda3 S/sp23",
            "Zda3 Mazda",
            "5-door Touring Aut Touring",
            "Zdaspeed3 3",
            "Sv Autom",
            "Zda3 Preferred Plus",
            "Mazdas",
            "Select S",
            "Zda3 Fwd 4d Sedan S Carbon Edition",
            "0th An",
            "100th An",
            "Zda S",
            "Carbon T",
            "Grand",
            "Zda Tou",
            "Zda3 I Sport/i Sv/i Touring",
            "Speed 3",
            "-5 Grand Touring",
            "Skyactive",
            "3 Hatchbac",
            "Ng",
            "Zda3 I Mazda I",
            "-9 Grand Touring",
            "S Grand Touring/s Sport",
            "Um",
            "Ibute Hybrid",
            "-3 Touring",
            "Gs/gt",
            "50th Anniversary Edition/gs/se",
            "5d",
            "G Sky",
            "5d Touring",
            "Premium - Manual",
            "Gs/gx",
            "Sv Sv",
            "Sport *ltd Avail*",
            "-7",
            "G/gx",
            "Gt W/turbo",
            "Mazdaspeed",
            "Sed",
            "Msp3",
            "Se Se",
            "Gt-Sky",
            "Mazda3s",
            "Gx-Sky",
            " Touring",
            "Gt I-activ",
            "50th Anniversary Edition/gs",
            "Oach Transit Bus Mustang",
            "Sport Gs I-activ",
            "Gt/gt *ltd Avail*",
            "Gt/gx",
            "-5 Gt",
            "Rred",
            "Otege Dx",
            "-30 Premium"
          ]
        },
        {
          "model": "5",
          "series": [
            "Touring",
            "Sport",
            "Grand Touring",
            "-5 Grand Touring",
            "Sport/touring",
            "Mazda Gt",
            "Mazda Gs",
            "Gs",
            "Mazda",
            "Grand To",
            "Grand Touring/sport/touring",
            "Zda5 Touring",
            "Ort",
            "Zda5",
            "Uring",
            "Zda  Sp",
            "Mazda Se",
            "Mazda  Gr",
            "Mazda  Se",
            "Zda5 Sport",
            "Zda5 Grand Touring",
            "And Touring",
            "Zda5 Sport/touring",
            "And To",
            "Zda5 Mazda5",
            "Zda5 Grand Touring/sport/touring",
            "Mazda Spo",
            "Mazda  Sp",
            "Zda  Gr",
            "Zda  To",
            "Zda",
            "Mazda  To",
            "Mazda5",
            "Tou Mazda5 Tou",
            "Touring Touring",
            "Preferred",
            "Sport Sport",
            "Grand To Grand To",
            "Gs/gt",
            "Gt",
            "Sport/touring/grand Touring",
            "-5 Preferred"
          ]
        },
        {
          "model": "6",
          "series": [
            "Sport",
            "Touring",
            "Grand Touring Reserve",
            "I Touring",
            "Grand Touring",
            "S",
            "I Grand Touring",
            "I Sport",
            "I Touring Plus",
            "S Grand Touring",
            "I Sport Ve",
            "S Sport",
            "I Base",
            "I",
            "S Touring Plus",
            "Signature",
            "S Grand Sport",
            "Touring Plus",
            "I Grand Sport",
            "Sport S",
            "Sport I",
            "Carbon Edition",
            "S Sport Ve",
            "Gs V6",
            "Gs",
            "Eed 3",
            "S Touring",
            "Gs/gt",
            "Gs-L",
            "Mazda",
            "Sport Mazdaspeed",
            "Mazda Gs",
            "Sport Gs V6",
            "Gt V6",
            "Grand To",
            "I Sv",
            "Ort",
            "And To",
            "Zda6 I Touring",
            "Sport Gt V6",
            "Zda6 Signature",
            "Signatur",
            "I Grand Touring/i Touring/i Touring Plus",
            "Mazda Gt",
            "I Grand Touring/i Touring",
            "Zda6 I",
            "And Touring",
            "Zda6 Grand Touring",
            "Zda6 I Sport",
            "Zda6 S Sport Ve",
            "Zda6 Sport",
            "Zda6 I Grand Touring",
            "Zda6 I Touring Plus",
            "Zda6 Touring",
            "Uring",
            "Zda6",
            "Zdai",
            "Mazdas",
            "4d I Spt",
            "Zda6 S Grand Touring",
            "Zda6 S Touring Plus",
            "Zda6 S Touring",
            "Zda6 I Sv",
            "Zda6 S Sport",
            "Gnature",
            "Zda6 I Sport Ve",
            "And Touring Reserve",
            "Zda6 Grand Touring Reserve",
            "Zda6 Carbon Edition",
            "Zda",
            "Zda6 S",
            "Zda6 Sport I",
            "Rbon Edition",
            "Zda6 Grand Touring S",
            "Zda6 6",
            "Zda6 Touring Plus",
            "Sv",
            "Mazdai",
            "Zda6 Sport S",
            "Mazdaspeed",
            "Zda6 Grand Sport S",
            "4d Spt",
            "Zda6 Grand Touring I",
            "Zda6 I/sport I/grand Touring I",
            "Zda 6 I",
            "Zda6 Grand Touring Mazdaspeed",
            "Zda6 Sport S/grand Sport S",
            "Zda6 S Grand Sport",
            "Zda 6 I Touring",
            "Zda6 I Base",
            "4d Tou",
            "4d 2wd G",
            "Zda 6",
            "Zda6 I/sport I",
            "Zda6 I Grand Sport",
            "Zda6 S Base",
            "Zda6 Sport Mazdaspeed",
            "Zda6 Grand Sport I",
            "Zda6 Grand Touring S/sport S",
            "Gnatur",
            "Mazda I/i",
            "Zda6 Mazda",
            "Zda6 I Grand Touring/i Touring/i Touring Plus",
            "S S",
            "Sport Gs",
            "I Sport/i Touring",
            "Eed 6",
            "-5 Touring",
            "Gs-I4",
            "-5 Grand Touring Reserve",
            "S Base",
            "Mazdaspeed6",
            "Gs-V6/gt-V6",
            "Gt",
            "Gs-I4/gt-I4",
            "Gt-I4",
            "Gt-V6",
            "4d Tou Touring",
            "Gx",
            "Gs-V6",
            "Kuro Edition",
            "Gs-L-I4/gt-I4",
            "4d 2wd",
            "S Grand Touring/s Touring Plus"
          ]
        },
        {
          "model": "3 Sport",
          "series": [
            " Hatchbac",
            "Sport"
          ]
        },
        {
          "model": "B2300",
          "series": [
            "Se",
            "Cab Plus",
            "Se/sx",
            "Cab Plus 4 Dr",
            "Short Box",
            "Her",
            "Cab",
            "Cab Plus Cab Plus",
            "Sx"
          ]
        },
        {
          "model": "B4000",
          "series": [
            "Cab Plus",
            "Se",
            "Ds",
            "Se/tl",
            "Cab Plus 4dr",
            "Troy Lee Edition",
            "Cab",
            "Se/tl/troy Lee",
            "Dx/se"
          ]
        },
        {
          "model": "CX-3",
          "series": [
            "Sport",
            "Grand Touring",
            "Touring",
            "Sv",
            "Gt",
            "Touri",
            "Rt",
            "Gs",
            "Ng",
            " Touring",
            "Grand",
            "4d 2wd/4x4 G.tou",
            "4d 2wd Sport",
            "Touri Touri",
            "Touring Touring",
            "Grand Grand",
            "Gx",
            "50th Anniversary Edition"
          ]
        },
        {
          "model": "CX-30",
          "series": [
            "Premium",
            "Select",
            "Preferred",
            "Carbon Edition",
            "Select Package",
            "2.5 S Carbon Edition",
            "2.5 S Premium",
            "2.5 S",
            "2.5 S Preferred",
            "Preferred Package",
            "2.5 Turbo Premium Plus",
            "2.5 S Preferred Package",
            "Premium Plus",
            "2.5 S Select",
            "2.5 S Select Sport",
            "Sele",
            "2.5 Turbo",
            "Carbon Turbo",
            "2.5 Turbo Premium Plus Package",
            "Premium Package",
            "2.5 Turbo Premium",
            "2.5 Turbo Premium Package",
            "2.5 S Premium Package",
            "Gx",
            "Gt",
            "2.5 Carbon Turbo",
            "Red Package",
            "X-30 Prem",
            "X-30",
            "M",
            "Prem",
            "Turbo Premium Package",
            "Red",
            "Turbo",
            "2.5 S Select Package",
            " Package",
            "X-30 Sele",
            "X-30 Pref",
            "Turbo Premium Plus",
            "M Package",
            "Pref",
            "Rbo Premium Plus",
            "Rbo Premium Package",
            "X-30 Gx",
            "Cx-30",
            "Carb",
            "X-30 Gt",
            "Gs",
            "Suna",
            "Rss Sv",
            "Gt W/turbo",
            "Mainstreet"
          ]
        },
        {
          "model": "CX-5",
          "series": [
            "Grand Touring",
            "Gt",
            "Touring",
            "Carbon Edition Turbo",
            "2.5 S Preferred",
            "2.5 S Carbon Edition",
            "Sport",
            "Grand Select",
            "2.5 S Select",
            "2.5 S",
            "Signature",
            "Premium",
            "Carbon Edition",
            "2.5 S Premium Plus",
            "Grand Touring Reserve",
            "Preferred",
            "2.5 S Premium",
            "Select",
            "2.5 Turbo",
            "2.5 Turbo Signature",
            "Premium Plus",
            "Carbon Turbo",
            "Carbon Edition/touring",
            "2.5 S Select Package",
            "Grand Touring/grand Touring Reserve",
            "2.5 Turbo Premium",
            "Gs",
            "300",
            "2.5 Carbon Turbo",
            "Touri",
            "Base",
            "Gx",
            " Tr6",
            "Carbo",
            "Se",
            "Prefe",
            "Signa",
            "Ng",
            "Premi",
            "Selec",
            "Grand",
            "2.5 S Carbon Edition/2.5 S Preferred",
            " Touring",
            "N Edition",
            "Touring/carbon Edition",
            "2.5 S Preferred Package",
            "2.5 S Premium Package",
            " Touring Reserve",
            "N Edition Turbo",
            " Select",
            " Preferred Package",
            "Ture",
            "Signature Turbo Awd Signature",
            " Premium Package",
            " Select Package",
            "Ng/carbon Edition",
            "Rred",
            "/se/xle",
            "Signature Diesel",
            " Carbon Edition",
            "Urbo",
            "T",
            "Um",
            "Urbo Signature",
            " Premium Plus",
            "4d Gx",
            "S Preferred/s Carbon",
            "Awd",
            "Um Plus",
            "2.5 S Premium Plus Package",
            "Rt",
            "S Car",
            "Ouring Awd Touring",
            "Signature W/diesel",
            "Gt W/turbo",
            "Gs/kuro Edition",
            "Gs W/o Cd",
            "Gs/kuro",
            "Suna",
            "2 Sport",
            "Gs/kuro Edition/signature",
            "Sport Design W/turbo",
            "4d 2w Gt",
            "Gt/sport Design",
            "Gx W/o Cd",
            "Grand Select/grand Touring"
          ]
        },
        {
          "model": "CX-50",
          "series": [
            "Preferred Plus",
            "Premium Plus",
            "Base",
            "2.5 S Premium Plus",
            "Select",
            "2.5 S Select",
            "2.5 Turbo Premium Plus",
            "2.5 S Preferred Plus",
            "Premium",
            "Preferred",
            "2.5 Turbo Meridian Edition",
            "2.5 S Preferred",
            "2.5 S Premium",
            "Gs-L",
            "Meridian",
            "2.5 Turbo Premium",
            "2.5 Turbo",
            "2.5 S",
            "Prem",
            "Sele",
            "2.5 S Preferred Package",
            "2.5 S Select Package",
            "2.5 Turbo Premium Package",
            "Rbo Premium Plus",
            "M",
            "Rbo Meridian",
            "Rbo Premium Package",
            "Pref",
            "M Plus",
            "2.5 Turbo Meridian",
            "Select Package",
            "2.5 S Premium Plus Package",
            "2.5 Turbo Premium Plus Package",
            "2.5 S Premium Package",
            "Gt",
            "Hybrid Premium Package",
            "Gt W/turbo/meridian Edition",
            "Hybrid Premium Plus Package",
            "Hybrid Preferred Package",
            "Preferred Package",
            "Hybrid Gs-l/kuro",
            "Base Base"
          ]
        },
        {
          "model": "CX-7",
          "series": [
            "I Sport",
            "I Sv",
            "S Grand Touring",
            "Grand Touring/sport/touring",
            "Grand Touring",
            "Touring",
            "S Touring",
            "Sport",
            "I Touring",
            "Gt",
            "S Grand Touring/s Touring",
            "I Sport/i Sv",
            "Gs/gt",
            "Sv",
            " Touring",
            "Ng",
            "Nd Touring",
            "Ring",
            "Rt",
            "Sv/sport",
            "Touring/grand Touring",
            "Select",
            "4d I Spt",
            "Sport/touring",
            "Gx",
            "4d 2w",
            "Gs"
          ]
        },
        {
          "model": "CX-9",
          "series": [
            "Touring",
            "Grand Touring",
            "Touring Plus",
            "Sport",
            "Signature",
            "Carbon Edition",
            "Gs-L",
            "Gs",
            "Grand",
            "Grand Touring/sport/touring",
            "Touri",
            "Signa",
            "Se",
            "Ng",
            " Touring",
            "Sport/touring",
            "Ture",
            "N Edition",
            "Sv",
            "Ng Plus",
            "Awd",
            "4d",
            "Signa Signa",
            "Grand Grand",
            "Sport Sport",
            "Phev Premium",
            "Gt",
            "Gs/gs-L",
            "Gs/gt",
            "Gt/kuro Edition",
            "4d G.",
            " Select",
            "Carbon Edition/grand Touring"
          ]
        },
        {
          "model": "MX-30 EV",
          "series": [
            "Premium Plus",
            "Gt"
          ]
        },
        {
          "model": "MX-5",
          "series": [
            "Sport",
            "Touring",
            "Grand Touring",
            "Rf",
            "Club Spec",
            "Gs/gs-P",
            "Special Edition",
            "3rd Generation Limited",
            "Gt",
            "Gs"
          ]
        },
        {
          "model": "MX-5 Miata",
          "series": [
            "Cloth/ls/se",
            "Rf Grand Touring",
            "Club",
            "Grand Touring",
            "Miata/ls",
            "Ls",
            "Leather Pkg/popular Equipment Pkg/sports Pkg/touring Pkg",
            "Sport",
            "Rf Club",
            "Cloth/ls/se/shinsen",
            "Base",
            "Ls/special Edition",
            "Cloth",
            "Speed",
            "Touring Pkg/popular Equipment Pkg/leather Pkg/sports Pkg",
            "Leather Pkg/m Edition/popular Equipment Pkg/r Pkg./sto/touring Pkg",
            "Base/ls/se Special Edition",
            "Touring",
            "Ls/se Special Edition",
            "Se Special Edition/ls",
            "Popular Equipment Pkg/r Pkg.",
            "Leather/m-edition/popular Equipment/r/sto-edition/touring",
            "100th Anniversary",
            "Special Edition",
            "30th Sv",
            "Ata",
            "Grand Touring/sport/sv/touring",
            "Rf",
            "Rf Launch Edition",
            "Rf 100th Anniversary",
            "Rf Grand Touring/launch Edition",
            "Rf 30th Anniversary",
            "Ng",
            "Rsary",
            "Tion",
            "Mx-5",
            "30th Anniversary",
            "Mazdaspeed",
            "Base/ls",
            "3rd Generation Limited",
            "Sv/sport/touring",
            "Mx-5 Miata",
            "Leather/leather Pkg/m Edition/popular Equipment Pkg/r Pkg./sto/touring Pkg",
            "Launch Edition",
            "10th Anniversary Package",
            "Grand Touring/launch Edition",
            "Base/sport/popular Equip/leather/10th Anniversary Edition/touring",
            "1.8",
            "Leather Pkg/popular Equipment Pkg/sports Pkg/touring/touring Pkg",
            "Club Spec",
            "Leather Pkg/m Edition/popular Equipment/popular Equipment Pkg/r Pkg./sto/touring Pkg"
          ]
        },
        {
          "model": "RX-8",
          "series": [
            "Sport Automatic",
            "6 Speed Manual",
            "Touring",
            "Sport",
            "6-speed Sport Automatic",
            "Grand Touring",
            "Shinka Special Edition",
            "6 Speed Manual/sport Automatic",
            "40th Anniversary Edition",
            "Grand Touring/sport/touring",
            "Rx-8",
            " Touring",
            "R3",
            "Ng",
            "40th Anniversary",
            "6 Speed Manual (m6)",
            "Sport Automatic (a4)",
            "X-8"
          ]
        },
        {
          "model": "Tribute",
          "series": [
            "Lx V6",
            "S Touring",
            "I Touring",
            "I",
            "S",
            "Es V6",
            "Lx",
            "Dx",
            "Es",
            "I Sport",
            "S Grand Touring",
            "Es V6/lx V6",
            "Hybrid",
            "Lx/es",
            "Sport",
            "Touring",
            "I Grand Touring",
            "S Sport",
            "I Grand Touring/i Sport/i Touring",
            "Suv",
            "Dx V6",
            "Gs V6",
            "Hybrid Grand Touring",
            "Gt V6",
            "Hybrid Touring",
            "S S",
            "Uring",
            "Hy",
            "Grand Touring",
            "Sport/touring",
            "Gs",
            "Es/lx",
            "Es V6/lx",
            "Gx",
            "Gx I4",
            "Gs V6/gt V6/gx V6",
            "Gx V6"
          ]
        },
        {
          "model": "CX-90",
          "series": [
            "3.3 Turbo Premium",
            "Premium",
            "3.3 Turbo Preferred Plus",
            "Premium Plus",
            "3.3 Turbo Select",
            "Um Plus",
            "Um",
            "Rred Plus",
            "T",
            "Rred",
            "3.3 Turbo S",
            "3.3 Turbo Preferred",
            "3.3 Turbo S Premium",
            "3.3 Turbo Premium Plus",
            "Preferred Plus",
            "Preferred",
            "4d 4",
            "Select",
            "Gs-L",
            "Phev Preferred",
            "Sele",
            "Phev Premium",
            "Pref",
            "Prem",
            "Phev Premium Plus",
            "3.3 Turbo Select Package",
            "Mhev",
            "3.3 Turbo Preferred Package",
            "Select Package",
            "3.3 Turbo S Premium Plus",
            "Um Sport",
            "Mhev Gt",
            "Premium Sport",
            "3.3 Turbo S Premium Plus Package",
            "Mhev Gs",
            "3.3 Turbo Premium Sport",
            "Mhev Gt-p",
            "Premium Plus Package",
            "3.3 Turbo Premium Plus Package",
            "Mhev Signature",
            "Gt",
            "3.3 Turbo S Premium Package",
            "Mhev Gs-l"
          ]
        }
      ]
    },
    {
      "make": "McLaren",
      "models": [
        {
          "model": "540C",
          "series": []
        },
        {
          "model": "570GT",
          "series": []
        },
        {
          "model": "570S",
          "series": []
        },
        {
          "model": "600LT",
          "series": []
        },
        {
          "model": "650S",
          "series": [
            "Spider"
          ]
        },
        {
          "model": "675LT",
          "series": []
        },
        {
          "model": "720S",
          "series": [
            "Luxury/performance",
            "Performance /luxury /",
            "Performance/luxury/",
            "Luxury Spider/performance Spider/spider",
            "Luxury /performance /"
          ]
        },
        {
          "model": "765LT",
          "series": [
            "Coupe",
            "Spider"
          ]
        },
        {
          "model": "Artura",
          "series": [
            "Performance/techlux/vision"
          ]
        },
        {
          "model": "MP4-12C",
          "series": [
            "Spyder"
          ]
        },
        {
          "model": "P1",
          "series": []
        }
      ]
    },
    {
      "make": "Mercedes-Benz",
      "models": [
        {
          "model": "A-Class",
          "series": [
            "A 220",
            "4matic",
            "220",
            "220 4matic",
            "4mtic",
            "A 220 4mat",
            "4mat",
            "Amg A 35",
            "R A 220 4mat",
            "R A 220",
            "A220",
            "A 35 Amg",
            "A 250",
            "Atic",
            "A 250 4mat",
            "R A 35 Amg",
            "0",
            "A 35 4mati",
            " 4matic",
            "0 4matic",
            "A2",
            "180a",
            "At",
            "35 Amg",
            "4mat A 220 4mat"
          ]
        },
        {
          "model": "Allegro",
          "series": []
        },
        {
          "model": "Alliado",
          "series": []
        },
        {
          "model": "AMG-Class",
          "series": [
            "4-door Coupe",
            "Coupe",
            "4-door Coupe 53",
            "4-Door",
            "43",
            "S",
            "53",
            "C",
            "63 S",
            "4-door Coupe 43",
            "4-door Coupe S",
            "4-door Coupe 63",
            "Roadster",
            "4-door Coupe 63 S",
            "Mg Gt 63",
            "Mg Gt R",
            "Mg Gt",
            "Mg Gt S",
            "Mg Gt 53",
            "Mg Gt C",
            "Mg Gt 43",
            " Gt 53",
            " Gt C",
            " Gt 63",
            "4-door Coupe Amg Gt 53",
            "Oupe",
            "4-door Coupe Amg Gt 43",
            "Pe",
            "Oadster",
            "C Amg",
            "Amg Gt 63",
            "55",
            "Black Series",
            "4matic+ 4-door",
            "63",
            "Coupe 4matic"
          ]
        },
        {
          "model": "Andare",
          "series": []
        },
        {
          "model": "B Electric Drive",
          "series": [
            "C"
          ]
        },
        {
          "model": "B-Class",
          "series": [
            "Electric Drive",
            "B 200",
            "B 250",
            "T",
            "4matic",
            "B 250e",
            "B200",
            "B250",
            "B 250 4mat",
            "B200 T",
            "B Electric",
            "250e",
            "B300",
            "El",
            "B250 4mati",
            "Atic",
            "At",
            "B Class",
            "Ic",
            "4mat",
            "Electric Drive Electric",
            "Sports Tourer",
            "Turbo"
          ]
        },
        {
          "model": "Boxer 40",
          "series": []
        },
        {
          "model": "Boxer 50",
          "series": []
        },
        {
          "model": "Boxer 60",
          "series": []
        },
        {
          "model": "Boxer OF",
          "series": []
        },
        {
          "model": "Busstar 380",
          "series": []
        },
        {
          "model": "C-Class",
          "series": [
            "Luxury 4matic/sport 4matic",
            "230 Sport",
            "Cabriolet",
            "Sport/luxury",
            "Luxury/sport",
            "4matic/luxury 4matic/sport 4matic",
            "4matic",
            "Sedan",
            "Coupe",
            "230 Kompressor Sport",
            "230 Kompressor Sport/sport",
            "Sport/luxury/",
            "230",
            "320 Sport",
            "Sport 4matic/luxury 4matic",
            "240 Luxury 4matic",
            "1.8l",
            "Base (a5)",
            "280 Luxury 4matic",
            "4 Matic",
            "300",
            "55 Amg",
            "240",
            "Sport 4matic/luxury 4matic/4matic",
            "Sport",
            "230 Kompressor",
            "C 300",
            "S",
            "250",
            "300 4matic",
            "2.6l",
            "320 Luxury 4matic",
            "240 4matic",
            "3.0l",
            "220",
            "300 4mati",
            "450 4mati Amg",
            "230 4mati",
            "Amg",
            "320",
            "Luxury",
            "43 4matic Amg",
            "63 Amg-s",
            "43 Amg",
            "280",
            "Base (m6)",
            "320 Luxury/sport",
            "280 Luxury",
            "Luxury 4matic",
            "230 230k Sport Sedan",
            "230k Sport Sedan",
            "350",
            "350 4mati",
            "Sport 4matic",
            "4matic Cabriolet",
            "C 250",
            "3.5l Sport",
            "280 280 4matic",
            "4matic Sedan",
            "240 Luxury",
            "280 4matic",
            "C 300 Luxury/c 300 Sport",
            "C 250 Luxury/c 250 Sport",
            "Amg C 43",
            "32 Amg",
            "2.5l Sport",
            "3.2l",
            "Base A5",
            "320 4matic",
            "C 300/c 300 Luxury/c 300 Sport",
            "350 4matic",
            "230k Sport Coupe",
            "240 240 4matic",
            "450 4matic Amg",
            "C250 4matic",
            "350e",
            "230 230k Sport Coupe",
            "240 240",
            "400 4mati",
            "280 280",
            "240 Sportwagon",
            "43 4mati Amg",
            "C230",
            "43",
            "400 4matic",
            "230 230",
            "Amg C 63 S",
            "320 Sport Coupe",
            "240 Sportwagon 4matic",
            "30",
            "36",
            "230 4matic",
            "C 400",
            "C 300 Sport/luxury 4matic",
            "C 300 4mat",
            "63 Amg",
            "C 43 4mati",
            "250 4mati",
            "C 63 Amg",
            "55 Amg 55 Amg",
            "C 43 Amg",
            "C 350",
            "55 Amg 5.5l Amg",
            "C 350e",
            "C 63 Amg-s",
            "C300",
            "C 450 4mat",
            "C300 4 Mat",
            "C 230",
            " C 450 4mat",
            "C 350 Sport",
            "6.3l Amg",
            "Cla 250",
            "Cls 400",
            "C 350 4mat",
            " 4matic",
            "C 300 Luxury",
            "C 450 Amg",
            "C 250 Sport",
            "Ort 4matic/luxury 4matic",
            "Cla 250 4m",
            "Ort 4matic/luxury 4matic/4matic",
            " -s",
            "C 250 Luxury",
            "C 250 4mat",
            "C 400 4mat",
            "C350",
            "Clk 350",
            "Cls 400 4m",
            "C 300 Sport",
            "Amg C 63",
            "3.0l Luxury",
            "Cl 550 4ma",
            "C 230k Spo",
            "At",
            "Ort",
            "Cla Amg 35",
            "3.0l Sport",
            "Clk 550",
            "C250",
            "Cls 450",
            "Ic",
            "C",
            "C Class",
            "Atic",
            "Cls 450 4m",
            "Cls Amg 53",
            "C350 Sport",
            "Ort/luxury",
            "-S",
            "C 350e Luxury",
            "Ic Amg",
            "Mpressor",
            "C3",
            "C Amg",
            "Xury",
            "C 63",
            "Xury 4matic",
            " S",
            "C Cls 4d 4",
            "L",
            "Port Sedan",
            "4mati",
            "3.5l Luxury",
            "Ort 4matic",
            "Super Sport",
            "C2",
            "5.5l Amg",
            "C 240",
            "Mpressor Sport",
            "C 240 4mat",
            "G 4matic",
            " Kompressor",
            "C 320",
            "Ort/luxury/",
            "3.2l Amg",
            "Ortwagon 4matic",
            "C 230 4mat",
            "Cls 300",
            "Ort/kompressor Sport",
            "C 240 Spor",
            "Port Coupe",
            "C 280 4mat",
            "C 32 Amg K",
            "Uxury",
            "C 320 4mat",
            "Ort Coupe",
            "Xury 4matic/sport 4matic",
            "Atic/luxury 4matic/sport 4matic",
            "Xury/sport",
            "Tic Amg",
            "Atic Amg",
            "4d",
            "Cls Class",
            "C 280",
            "3.5l",
            "C320",
            "Atic Sedan",
            "Dan",
            "3.0l Luxury/3.0l Sport",
            "50e",
            "Atic Cabriolet",
            "C 55 Amg",
            "Cls 4d 300",
            "0",
            "Atic Coupe",
            "Briolet",
            "Mpressor Sport/sport",
            "Base M6",
            "0 4matic",
            "Upe",
            " 63 Amg-s",
            "C300 4mati",
            "Ti",
            "C Sedan",
            "Clk 430",
            "C230k",
            "Cl-class C",
            "C 320 Spor",
            " 63 Amg",
            "Ortwagon",
            "C240/spt",
            "Rt C240 Sport",
            "Cl",
            "C3 C3",
            "C250 Coupe",
            " 43 Amg",
            " 43 4matic Amg",
            "G 450 4matic Amg",
            "Cla",
            "C240",
            "C Class 2d",
            "C23",
            "C 220",
            "C280 4m Aw",
            "Clk",
            "C43",
            "C230k Spor",
            "C 43",
            "C Cls 4d 2",
            "C32 Amg Ko",
            "Cla250",
            "Cls550",
            "C43 Amg",
            "C180",
            "C2 C2",
            "C250d 4mat",
            "C300 Awd",
            "4mat",
            "C250 4mati",
            "C Class Sp",
            "C280",
            "C Cls 4d 3",
            "C32",
            "Unknown",
            "240 240 Sportwagon",
            "C300 4matic",
            "Mg",
            "C 250 Sport/luxury",
            "C 300 Luxury/sport 4matic",
            "1.8l/sport",
            "Gl43",
            "32 Amg 32 Amg Kompressor",
            "280 4mati",
            "C 300/luxury/sport",
            "32 Amg Kompressor",
            "4mat C 250 4mat",
            "Kompressor Sport",
            "E Performance",
            "320 320",
            "Tic",
            "Kompressor",
            "G C 63 S",
            "Kompressor Sport/sport",
            "280 Avantgarde Edition 4matic",
            "Matic",
            "4d C 300 4mat",
            " S E Performance",
            "2.5l",
            "Amg C 63 S E Performance",
            " Accord Cou",
            "S E Performance",
            "30 C Class",
            "230k Sport Oupe",
            "280 4matic/avantgarde Edition 4matic",
            "230 Classic",
            "3.0l Luxury/sport 4matic",
            "320 Sport Oupe",
            "240 4matic/elegance 4matic",
            "280 Elegance"
          ]
        },
        {
          "model": "CL-Class",
          "series": [
            "4matic",
            "Base (a5)",
            "5.5l Amg",
            "500",
            "550",
            "63 Amg",
            "Cl 550",
            "Cl 63 Amg",
            "6.3l V8 Amg",
            "5.5l V8",
            "Cl 550 4ma",
            "5.0l",
            "Cl 600",
            "V8",
            "Cl63 Amg",
            "Cl 55 Amg",
            "V8 Amg",
            "Amg",
            "5.5l",
            "Cl 65 Amg",
            "Cl 500",
            "Atic",
            "Cl55 Amg",
            "V12",
            "50",
            "Cl",
            "0 4matic",
            "Cl550",
            "A",
            "4ma",
            "4ma Cl 550 4ma",
            "600",
            "40th Anniversary Edition"
          ]
        },
        {
          "model": "CLA-Class",
          "series": [
            "4matic",
            "Cla 250",
            "Coupe",
            "250",
            "45 Amg",
            "Coupe 4matic",
            "250 4matic",
            "Coupe 250",
            "Amg 35 4matic",
            "Cla 250 4m",
            "Cla Amg 35",
            "Cla 45 Amg",
            "Coupe 250 4matic",
            "Atic",
            "4m",
            "Cla250",
            " 4matic",
            "0",
            "Upe 4matic",
            "A 250",
            "Upe",
            "Upe Cla 250",
            "Upe 250",
            "Amg 35",
            "0 4matic",
            " 45 Amg",
            " Amg 35 4matic",
            "Cla",
            "Class",
            "Cla 45",
            "A 45",
            "Amg 35 Cla Amg 35",
            "4m Cla 250 4m",
            "Amg Cla 35",
            "45",
            "Amg Cla 45",
            "Amg 45s 4matic",
            "Coupe 4maitc"
          ]
        },
        {
          "model": "CLS-Class",
          "series": [
            "550",
            "4matic",
            "500c",
            "450",
            "63 Amg S-model",
            "63 Amg",
            "S 4matic",
            "Coupe",
            "55 Amg",
            "5.5l",
            "550 4matic",
            "400",
            "Amg 53 4matic",
            "Cls 550 4m",
            "Cls 63 Amg",
            "Cls 550",
            "Coupe 4matic",
            "Cls 450",
            "400 4matic",
            "Cls 400",
            "Cls 63 Amg S-model",
            " S-model",
            "0",
            " S",
            "0 4m",
            "63 Amg/s-model",
            "Atic",
            "Cls Amg 53",
            "6.3l Amg",
            "4m",
            "Cls400",
            "Cls 400 4m",
            "Cls 450 4m",
            "Cls63 Amg",
            "Cls",
            "/s-Model",
            " 4matic",
            "Cls550",
            "Amg",
            "Cls 55 Amg",
            " S 4matic",
            "5l",
            "Upe",
            "0 4matic",
            " Amg 53 4matic",
            "Upe 4matic",
            "Cls Class",
            "Cls500c",
            "4m Cls 450 4m",
            "4m Cls 400 4m",
            "4m Cls 550 4m",
            "S",
            "450 4matic",
            "55 Amg 55 Amg"
          ]
        },
        {
          "model": "Coraza S2",
          "series": []
        },
        {
          "model": "E-Class",
          "series": [
            "4matic",
            "E 350 Sport",
            "3.2l",
            "E 400",
            "Base (a5)",
            "4m Awd",
            "3.5l",
            "4matic All-terrain",
            "Bluetec",
            "E 300",
            "350",
            "300 4matic",
            "E 300 Luxury/e 300 Sport",
            "3.0l",
            "Amg E 63 S",
            "400 4matic",
            "E 350",
            "43 4matic Amg",
            "Bluetec 350 Bluetec",
            "E 550",
            "S 4matic",
            "63 Amg-s 4matic",
            "Diesel",
            "550",
            "300",
            "E 63 Amg",
            "500",
            "Special Edition/4m (a5)",
            "350 4matic",
            "320",
            "Awd",
            "Amg 53 4matic",
            "Bluetec 4matic",
            "5.0l",
            "4m (a5)/special Edition",
            "Amg",
            "E 350 Luxury/e 350 Sport",
            "550 4matic",
            "450",
            "E 63 Amg S-model",
            "Diesel 300td",
            "4matic Wagon",
            "Hybrid",
            "4m All Terrain",
            "Amg 53",
            "E 420",
            "E 300 4mat",
            "E 400 Hybr",
            "Xury",
            "E 450",
            "3.2l Cdi",
            "63 Amg",
            "4matic/e 350 Sport",
            "E 350 4mat",
            "E 55 Amg",
            "E 320",
            "350 4matic Wagon",
            "E 63 Amg-s",
            "E Amg 53 4",
            "4mat",
            "Bluetec 250 Bluetec",
            "E 350 Bluetec",
            "400",
            "Hybrid Sport",
            "E 400 4mat",
            "450 4matic",
            "E 250 Blue",
            "E 350 Blue",
            "-S",
            "E 300 Luxury",
            "E350",
            "E 550 Sport",
            "E 350 Luxury",
            "E 250 Bluetec Sport",
            "E 350 Luxury Bluetec",
            "Base (a5)/special Edition",
            "500 4matic",
            "E 43 4mati",
            "Amg E 53",
            "E 550 4mat",
            "3.0l Bluetec",
            "6.3l Amg",
            "E250 Bluetec",
            "E 400 Sport",
            "E 550 Luxury",
            "Sport 3.5l",
            "Sport 5.5l",
            "Luxury 3.5l",
            "E 250 Bluetec Luxury",
            "E 450 4mat",
            "E 300 Sport",
            "Amg E 43",
            " 4matic",
            "E 320 Cdi",
            "E 250 Bluetec",
            "E Amg 53",
            "E Class",
            "5series",
            "E3",
            "Ic",
            "At",
            "Atic",
            "350 Bluetec",
            "E-Class",
            "Uetec",
            "E300 4 Mat",
            "Ort",
            "250 Bluetec",
            "E320",
            " S-model",
            "E 500",
            "Special Edition",
            "E",
            "5.5l",
            "E300",
            "E550",
            "E 500 4mat",
            "E 350 Wago",
            "Ort 5.5l",
            "5.5l Amg",
            "E 320 4mat",
            "Atic Wagon",
            "E 350 Sport Bluetec",
            "E350 4mat",
            "E 430",
            "E 400 Luxury",
            "55 Amg",
            " S",
            "Tic Amg",
            " S 4matic+",
            "Base A5",
            "0 4matic",
            " Amg 53 4matic",
            " 63 Amg-s 4matic",
            " 63 Amg",
            "Atic/e 350 Sport",
            "0 4matic Wagon",
            "-s 4matic",
            "5l",
            " S 4matic",
            " 6.3l Amg",
            "0",
            "Uetec 4matic",
            "4m (a5)",
            "E 450 4m A",
            "Gon",
            "Sport 3.5l/luxury 3.5l",
            "Base A5/special Edition",
            "Atic All-terrain",
            " All Terrain",
            " 43 4matic Amg",
            "Brid",
            "E500",
            " Amg 53",
            " 4",
            "I",
            "E400",
            "E350 4mati",
            "Brid Sport",
            "350 Sport",
            "Uetec 350 Bluetec",
            "0 4m All Terrain",
            "Ue",
            "320e",
            "E Series",
            "Br",
            "T",
            "E200 Cdi",
            "420e",
            "E-320",
            "E400 4mati",
            "E320 Cdi",
            "E500 4mati",
            "Blue",
            "Ti",
            "E3504m Awd",
            " A",
            "E63",
            "E350 .",
            "E 280 4mat",
            "E63 Amg",
            "Hybr",
            "Benz E550",
            "35",
            "E Cls Sw 3",
            "S",
            "Ti E500 4mati",
            "4mat E 400 4mat",
            "4mat E 350 4mat",
            "63 Amg-s",
            "Se",
            "4mat E 300 4mat",
            "4m",
            "S 4matic+",
            "E 550 Luxury/e 550 Sport",
            "Blue E 350 Blue",
            "4m A",
            "Wagon",
            "4m A E 450 4m A",
            "4matic/luxury 4matic/sport 4matic"
          ]
        },
        {
          "model": "EQA300",
          "series": []
        },
        {
          "model": "EQC400",
          "series": []
        },
        {
          "model": "FS65",
          "series": []
        },
        {
          "model": "G-Class",
          "series": [
            "4matic",
            "Suv",
            "Amg G 63",
            "4matic/grand Edition 4matic",
            "G 550",
            "500",
            "550",
            "G 63 Amg",
            "Grand Edition 4matic",
            "63 Amg",
            "Squared",
            "4",
            "G 550 4x4 Squared",
            "5.5l",
            "5.5l Amg",
            "G 55 Amg",
            "Amg G 65",
            " 4matic",
            "G 500",
            " 63 Amg",
            "Amg",
            "5.0l",
            "G 550 4x4",
            "Atic",
            "V",
            " Grand Edition 4matic",
            " 4matic/grand Edition 4matic",
            "0",
            "Atic/grand Edition 4matic",
            "G 65 Amg",
            "G55 Amg",
            "4 Squared",
            "G Wagon",
            "G55",
            "G5",
            "G65 Amg",
            "Matic"
          ]
        },
        {
          "model": "GL-Class",
          "series": [
            "4matic",
            "450 4matic",
            "4 Matic",
            "Bluetec 350 Bluetec",
            "320 Cdi 4matic",
            "550 4matic",
            "Bluetec 4matic",
            "Gl 450",
            "350 Bluetec",
            "320 Bluetec",
            "Bluetec",
            "320 Cdi",
            "Atic",
            "63 Amg",
            "450",
            "5.5l",
            "4.6l",
            "Gl 350 Bluetec",
            "320 Bluetec 4matic",
            "Gl 450 4ma",
            "Gl 550 4ma",
            "Gl Parts Only",
            "Gl 550",
            "4ma",
            "L 350 Blu",
            "L",
            "Gl 63 Amg",
            "L 550 4ma",
            "Gl63 Amg",
            "L 450 4ma",
            "Uetec",
            "3.0l Bluetec",
            "Gl 350 Blu",
            "Gl",
            "Gl350 Bluetec",
            "Gl450",
            "Blu",
            "Gl450 4mat",
            "Gl350",
            "L450",
            "3.0l Cdi",
            "I",
            "Gl 320 Cdi",
            "Uetec 4matic",
            "0 4matic",
            "Class",
            "L 450",
            "I 4matic",
            " 4matic",
            "Gl550",
            "Gl-Glass",
            "Uetec 350 Bluetec",
            "G",
            "A",
            "Gl450 4 Ma",
            "Gl Cls 4d",
            "L450 4mat",
            "L350",
            "U",
            "Gl550 4 Ma",
            "Gl320 Cdi",
            "Gl320",
            "Matic",
            "4ma Gl 450 4ma",
            "Blu Gl 350 Blu",
            " 63 Amg"
          ]
        },
        {
          "model": "GLA-Class",
          "series": [
            "4matic",
            "45 Amg",
            "250 4matic",
            "250",
            "45",
            "35 Amg",
            "Gla 250",
            "Gla 45 Amg",
            "A",
            "Gla 250 4m",
            "A 250",
            "A 250 4m",
            "-class 250",
            "Atic",
            "A250",
            "Gla250",
            "Gla 35 Amg",
            "4m",
            "0",
            " 4matic",
            "0 4matic",
            " 45 Amg",
            "Gla",
            "Gla250 4m",
            "4m Gla 250 4m",
            "Class"
          ]
        },
        {
          "model": "GLB-Class",
          "series": [
            "4matic",
            "250 4matic",
            "250",
            "Amg 35 4matic",
            "Atic",
            "Glb 250 4m",
            "B 250 4m",
            "Glb 250",
            "B 250",
            " 4matic",
            "0",
            "Glb Amg 35",
            " Amg 35 4matic",
            "0 4matic",
            "4m",
            "4m Glb 250 4m"
          ]
        },
        {
          "model": "GLC-Class",
          "series": [
            "Coupe",
            "4matic",
            "4matic Suv",
            "Suv",
            "Glc 300",
            "300 4matic",
            "300",
            "Coupe 4matic",
            "4matic Coupe",
            "Coupe 300 4matic",
            "43 4matic Amg",
            "Atic",
            "Coupe 43 4matic Amg",
            "4m",
            "Coupe S 4matic",
            "Glc 350e",
            "63 S 4matic Amg",
            "350e",
            "Glc 43 4ma",
            "Glc 300 4m",
            "Glc Coupe",
            "C 300 4m",
            "C 300",
            "C 43 4ma",
            "C 350e",
            " S",
            "0",
            "C Coupe",
            "C 63 4ma",
            "Glc300",
            "63 4matic Amg",
            "Glc 63 4ma",
            "Tic Amg",
            "Glc",
            "V",
            "Upe",
            "Cls 300",
            "Upe Glc 300",
            "0e",
            " Coupe",
            " Coupe S 4matic",
            " 4matic",
            " Coupe 4matic",
            "Upe 4matic",
            "Atic Coupe",
            " 4matic Coupe",
            "Atic Suv",
            "Matic",
            "0 4matic",
            "Upe 300 4matic",
            " 43 4matic Amg",
            "Class",
            "C",
            "Glc 63 S 4",
            "4m Glc 300 4m",
            "Amg Glc 43",
            "43 Amg",
            "Amg Glc 63 S",
            "Ic",
            "S 4matic",
            "Ic Amg",
            "Matic Amg"
          ]
        },
        {
          "model": "GLE-Class",
          "series": [
            "Coupe 4matic",
            "4matic",
            "S 4matic",
            "Coupe",
            "350",
            "4matic+",
            "Amg 53 4matic",
            "450e 4matic",
            "Gle400",
            "Coupe 43 Amg",
            "-s 4matic",
            "Plug-in Hybrid 4matic",
            "350 4matic",
            "Amg Gle 43",
            "43 Amg",
            "350d 4matic",
            "450 4matic",
            "S 4matic+",
            "Amg Gle 63 S",
            "S",
            "400 4matic",
            "63 Amg-s 4matic",
            "63 Amg-s",
            "Atic",
            "Gle 350",
            "63 S 4matic Amg",
            "63 Amg 4matic",
            "Gle 350 4m",
            "Amg Gle 53",
            "Gle 450",
            "Gle 580 4m",
            "580 4matic",
            "Gle Coupe",
            "E Coupe",
            "E 350 4m",
            "0 4m",
            " S-model",
            " S",
            "Coupe 450 4matic",
            "E 400 4m",
            "E 350",
            "E 350d 4",
            "G",
            "E 550e 4",
            "E 43",
            "Gle 400 4m",
            "Gle 300d 4",
            "Gle 43 Amg",
            "-S",
            "E 300d 4",
            " Coupe",
            "Gle 450 4m",
            "Gle 550e 4",
            "4m",
            " 4matic",
            " Coupe 4matic",
            "Gle Amg 53",
            "Gle Class",
            "C Amg",
            "Gle 63 Amg",
            "E",
            "Tic",
            "Gle 350d 4",
            "Gle 450 Am",
            "G Coupe 4matic",
            " Coupe Amg Gle 43",
            "0",
            "Matic",
            "0 4matic",
            "00d 4matic",
            "Ug-in Hybrid 4matic",
            " S 4matic+",
            "0d",
            " S 4matic",
            "Cls 350",
            "E 63 S 4",
            " Coupe S",
            "G Coupe",
            " Coupe 4matic+",
            " Coupe Amg 53 4matic",
            " Coupe S 4matic",
            "E 550 4m",
            " 63 Amg-s 4matic",
            " 4matic+",
            " 63 Amg 4matic",
            " 43 Amg",
            "Gle 550 4m",
            " Amg 53 4matic",
            "E Amg 53",
            "E 63 S",
            "E 53",
            "Amg 53",
            "Gle",
            " Coupe 43 Amg",
            "G Coupe 450 4matic",
            "G Sport 4matic",
            "E 580 4m",
            "Matic Amg",
            "Gle 63 S 4",
            "Lug-in Hybrid 4matic",
            "4m Gle 350 4m",
            "4m Gle 450 4m",
            "550e 4matic",
            "450e 4",
            "4m Gle 580 4m",
            "63 S 4",
            "4m Gle 400 4m",
            "300d 4matic",
            "4",
            "Amg 53 Gle Amg 53",
            "E 450 4matic",
            "63 S 4 Gle 63 S 4",
            "63"
          ]
        },
        {
          "model": "GLK-Class",
          "series": [
            "4matic",
            "Atic",
            "350 4matic",
            "350",
            "Bluetec",
            "Bluetec 4matic",
            "Bluetec 250 Bluetec",
            "Glk 350",
            "Uetec",
            "Glk350",
            "Glk 350 4m",
            "Glk 250 Bluetec",
            "K 350 4m",
            "K 350",
            "K 250 Bl",
            "Bl",
            "Glk 250 Bl",
            "250 Bluetec",
            "Glk",
            "0",
            "Glk250 Blu",
            "K350",
            "Uetec 4matic",
            "0 4matic",
            "Glk350 4ma",
            "Glk3504mat",
            "Glk250",
            "4ma Glk350 4ma",
            " Suv"
          ]
        },
        {
          "model": "GLS-Class",
          "series": [
            "4matic",
            "450 4matic",
            "580 4matic",
            "550 4matic",
            "63 Amg 4matic",
            "Gls 580 4m",
            "Atic",
            "Gls 450",
            "Gls 450 4m",
            "Mercedes-maybach Gls600 4m",
            "Maybach Gls 600",
            "Mercedes-maybach Gls600 4",
            "S 550 4m",
            "S 450 4m",
            "Parts Only",
            "4m",
            "S 600",
            "Gls 550 4m",
            "Gls 63 Amg",
            " 4matic",
            "0",
            "0 4matic",
            " 63 Amg 4matic",
            "Es-maybach Gls600 4",
            "S",
            "Es-maybach Gls600 4m",
            "H Gls 600",
            "Gls Merced",
            "Gls",
            "Class",
            "-s 4matic",
            "4m Gls 450 4m",
            "Gls 550",
            "Merced",
            "Tic",
            "4matic+"
          ]
        },
        {
          "model": "Gran Viale",
          "series": []
        },
        {
          "model": "Gran Viale Articulado",
          "series": []
        },
        {
          "model": "Gran Viale LE",
          "series": []
        },
        {
          "model": "Gran Viale RF",
          "series": []
        },
        {
          "model": "HDX",
          "series": []
        },
        {
          "model": "LO 916",
          "series": []
        },
        {
          "model": "Marco Polo",
          "series": []
        },
        {
          "model": "Maybach GLS600",
          "series": []
        },
        {
          "model": "Maybach S550",
          "series": []
        },
        {
          "model": "Maybach S560",
          "series": []
        },
        {
          "model": "Maybach S580",
          "series": []
        },
        {
          "model": "Maybach S600",
          "series": []
        },
        {
          "model": "Maybach S650",
          "series": []
        },
        {
          "model": "Maybach S680",
          "series": []
        },
        {
          "model": "MBO 1018",
          "series": []
        },
        {
          "model": "MBO 12000",
          "series": []
        },
        {
          "model": "MBO 1218",
          "series": []
        },
        {
          "model": "MBO 1221",
          "series": []
        },
        {
          "model": "MBO 14000",
          "series": []
        },
        {
          "model": "MBO 1421",
          "series": []
        },
        {
          "model": "Metris",
          "series": [
            "Passenger",
            "Cargo Van",
            "Passenger Van",
            "Van",
            "Er Metris",
            "Passenger Van Worker",
            "Cargo Van Worker",
            "Pas",
            "Worker"
          ]
        },
        {
          "model": "M-Class",
          "series": [
            "4matic",
            "Base (a5)",
            "Hybrid",
            "Bluetec 4matic",
            "350 4matic",
            "Ml 350 Bluetec",
            "500",
            "3.2l",
            "350",
            "Ml 350",
            "3.7l",
            "Amg",
            "550 4matic",
            "Bluetec 350 Bluetec",
            "Bluetec",
            "3.5l",
            "Ml 63 Amg",
            "5.0l",
            "350 Bluetec",
            "4ma",
            "Ml 350 4ma",
            "Ml 550",
            "Matic",
            "Ml 400",
            "Ml 550 4ma",
            "Ml 250 Bluetec",
            "5.5l",
            "3.0l",
            "400 4matic",
            "Ml 350 Blu",
            "Ml350",
            "3.0l Bluetec",
            "Ml350 Bluetec",
            "Ml 400 4ma",
            "Ml 250 Blu",
            "Ml",
            "G",
            "550",
            "Blu",
            "6.3l Amg",
            "63 Amg",
            "Ml 500",
            "Ml350 4x4",
            "3.0l Cdi",
            "Ml 320 Cdi",
            "Luetec",
            "320",
            "Ml 320",
            "5.5l Amg",
            "Ma",
            "Lu",
            "Ml-Class",
            "Ml250 Blue",
            "L 350",
            "Luetec 350 Bluetec",
            "Ml 450 Hyb",
            "50",
            ".5l",
            "G 4matic",
            "Luetec 4matic",
            "50 4matic",
            "Ml 430",
            "Ybrid",
            "Ml320",
            "Ml500",
            "Ml 55",
            "Ml-350",
            "M Class",
            "Ml550",
            "Di",
            "4ma Ml 350 4ma",
            "Blu Ml 350 Blu",
            "4ma Ml 550 4ma",
            "Hyb",
            "Classic 4matic/elegance 4matic"
          ]
        },
        {
          "model": "MP60 Express",
          "series": []
        },
        {
          "model": "Multego",
          "series": []
        },
        {
          "model": "O500",
          "series": []
        },
        {
          "model": "OC 500",
          "series": []
        },
        {
          "model": "OF 1118",
          "series": []
        },
        {
          "model": "OF 1318",
          "series": []
        },
        {
          "model": "OF 1321",
          "series": []
        },
        {
          "model": "OH 1500",
          "series": []
        },
        {
          "model": "OH 1518",
          "series": []
        },
        {
          "model": "OH 1524",
          "series": []
        },
        {
          "model": "OH 1600",
          "series": []
        },
        {
          "model": "OH 1621",
          "series": []
        },
        {
          "model": "OH 1624",
          "series": []
        },
        {
          "model": "OH 1625",
          "series": []
        },
        {
          "model": "OMC 1400",
          "series": []
        },
        {
          "model": "Paradiso 1200",
          "series": []
        },
        {
          "model": "Paradiso 1350",
          "series": []
        },
        {
          "model": "Paradiso 1800",
          "series": []
        },
        {
          "model": "R-Class",
          "series": [
            "4matic",
            "3.0l Cdi",
            "5.0l",
            "350",
            "R Class",
            "Bluetec 4matic",
            "350 4matic",
            "Bluetec",
            "R 350",
            "R 350 Bluetec",
            "3.5l",
            "R 350 Blue",
            "R350",
            "R 350 4mat",
            "4mat",
            "3.0l Bluetec",
            "Blue",
            "320",
            "R 320",
            "R350 Bluet",
            "3.0l",
            "R 320 Cdi",
            "Atic",
            "R 500",
            "Uetec",
            "R3",
            "0 4matic",
            "Uetec 4matic",
            "R500",
            "At",
            "R320 Cdi",
            "4mat R 350 4mat",
            "I",
            "Uetec 350 Bluetec",
            "Blue R 350 Blue"
          ]
        },
        {
          "model": "S-Class",
          "series": [
            "4matic",
            "430",
            "500",
            "Base (a5)",
            "4.3l",
            "550 4matic",
            "550",
            "S 400 Hybrid",
            "63 Amg",
            "5.0l",
            "500 4matic",
            "Plug-in Hybrid",
            "430 4matic",
            "6.0l Amg",
            "560 4matic",
            "560",
            "S 550",
            "Atic",
            "320 Base Lwb",
            "5.5l V8",
            "430 430 4matic",
            "580 4matic",
            "320",
            "S600",
            "580e 4matic",
            "430 430",
            "55 Amg",
            "320 Base Swb",
            "Hybrid",
            "Base",
            "320w",
            "420",
            "S580e 4matic",
            "Bluetec 4matic",
            "600",
            "450 4matic",
            "S 560",
            "350",
            "350d",
            "Bluetec",
            "Mercedes-maybach S650",
            "450",
            "Mercedes-maybach S600",
            "550e",
            "S 350",
            "S 500 4mat",
            "S 550 4mat",
            "Hybrid 400",
            "S 65 Amg",
            "S 450 4mat",
            "S 500",
            "4mat",
            "S 63 Amg",
            "S 580 4mat",
            "400",
            "Mercedes-maybach S560 4matic",
            "55 Amg 55 Amg",
            "Slk 250",
            "S 560 4mat",
            "S550 4matic",
            "Slc 300",
            "S 550e",
            "Maybach S 550",
            "S Mercedes",
            "Maybach S 600",
            "S 450",
            "5.5l V12",
            "S 400",
            "Amg S 63",
            "Amg S 65",
            "S 600",
            "63 E Performance",
            "Sl 550",
            "Slk 350",
            "Slk 300",
            "  4",
            "6.3l V8 Amg",
            "S 350 Bluetec",
            "S 550 Plug-in Hybrid",
            "Sl 400",
            "S550",
            "Ic",
            "S 580",
            "R S Mercedes",
            " 4matic",
            "Maybach S 650",
            "S Class",
            "S400 Hybrid",
            "Sl 450",
            "S 550e Plug-in Hybrid",
            "S 350 Blue",
            "Maybach S 560",
            "S 63 Amg 4",
            "Matic",
            "S5",
            "Maybach S 580",
            "Amg",
            "Tec",
            "6.0l V12 Amg",
            "Lug-in Hybrid",
            "-maybach S600",
            "5.5l",
            "S 430",
            "6.0l",
            "3.7l",
            "S 430 4mat",
            "S500",
            "Uetec",
            "5l V8",
            "Es-mybc S560 4mtc",
            "Es-maybach S 580 4m",
            "S 55 Amg",
            "Brid 400",
            "Ug-in Hybrid",
            "5.0l/base",
            "Brid",
            "Base A5",
            "0 4matic",
            "0",
            "Es-maybach S600",
            "At",
            "Es-maybach S560 4matic",
            "500s",
            "S500 4mati",
            "Uetec 4matic",
            "S550 4mati",
            "Ug-in Hybrid 550e",
            "00",
            "S",
            "Se",
            "S S600",
            "4",
            "S 400 4mat",
            "S6",
            "Es-maybach S680 4m",
            "Es-maybach S650",
            "Es-maybach S550 4matic",
            "Sl450",
            "S560",
            " 63 Amg",
            "Maybach S650",
            "S350",
            "S63",
            "S430 4mati",
            "S350 Bluet",
            "S55 Amg",
            "S450",
            "S-550",
            "R S Type",
            "S580e 4m",
            "S Class 4d",
            "4m",
            "Ti S500 4mati",
            "S-500",
            "55",
            "S S560e",
            " 4",
            "S320",
            "350 S",
            "E 4matic",
            "350 Bluetec",
            "Mercedes S Mercedes",
            "63 E Per",
            "4mat S 550 4mat",
            "4mat S 580 4mat",
            "Mercedes-mybc S550 4mtc",
            "Blue S 350 Blue",
            "Blue",
            "430 Swb 4matic",
            "430 4.3l",
            "Plug-in Hybrid 550e",
            "4mati",
            "Mercedes",
            "63 Amg 4matic",
            "S63 Amg",
            "Base (a5) Lwb",
            "420 420",
            "65 Amg"
          ]
        },
        {
          "model": "Safety Bus",
          "series": []
        },
        {
          "model": "SL-Class",
          "series": [
            "Base (a5)",
            "550",
            "4matic",
            "320",
            "500",
            "Class",
            "5.5l V8",
            "400",
            "500r",
            "380 Sl",
            "Sl 500",
            "Sl 550",
            "Sl 55 Amg",
            "450",
            "Amg Sl 63",
            "Sl 600",
            "43 Amg",
            "Sl 400",
            "Sl 63 Amg",
            "Sl 65 Amg",
            "V8",
            "Sl 450",
            "55 Amg",
            "Amg",
            "5.0l",
            "6.0l Amg",
            "5.5l Amg",
            "5.5l",
            "5.5l V12",
            "Sl 500r",
            " 4matic",
            "230 Sl",
            "0",
            "500 Sl",
            "Sl500",
            "Sl450",
            "Sl550",
            "S",
            "Base (a7)",
            "63 Amg",
            "Class Sl550",
            "600",
            "V",
            "4matic+",
            "Class 4",
            "Tic",
            "Amg Sl 43",
            "Ompressor"
          ]
        },
        {
          "model": "SLC-Class",
          "series": [
            "Slc 300",
            "300",
            "Slc 43 Amg",
            "0",
            "350slc",
            "Ic",
            "43 Amg",
            "Slc 43"
          ]
        },
        {
          "model": "SLK-Class",
          "series": [
            "280",
            "300",
            "320",
            "230 Kompressor",
            "32 Amg",
            "280 280",
            "320 320",
            "230",
            "3.2l",
            "230 230 Kompressor",
            "32 Amg Kompressor",
            "250",
            "Slk 350",
            "3.0l",
            "350",
            "Class",
            "Slk 300",
            "Slk 55 Amg",
            "3.5l",
            "Slk 250",
            "2.3l",
            "5.5l Amg",
            "0",
            "Kompressor",
            "2.3l Kompressor",
            "Sp Edition",
            "Slk 320",
            "3.2l Amg",
            "Slk 280",
            "Slk 230 Ko",
            "Mpressor",
            "Slk250",
            "Base (m6)",
            "5l",
            "Base M6",
            "Slk 32 Amg",
            " Kompressor",
            "Slk",
            "Slk230",
            "Slk280",
            "Slk350",
            "Slk300",
            "Slk Class",
            "Slk320",
            "Slk55 Amg",
            "320 Sp Edition",
            "Tic",
            "55 Amg",
            "280 3.0l"
          ]
        },
        {
          "model": "SLS-Class",
          "series": []
        },
        {
          "model": "Sprinter",
          "series": [
            "2500",
            "3500 High Roof V6",
            "3500",
            "Cargo Vans",
            "3500/4500",
            "2500/3500",
            "2500 High Roof V6",
            "2500 2500",
            "3500 High Roof V6/standard Roof V6",
            "2500 High Roof I4 Diesel",
            "2500 Standard Roof V6/high Roof V6",
            "Standard Roof 4-cyl Diesel",
            "1500/2500",
            "2500 High Roof I4",
            "2500 Normal Roof",
            "2500 High Roof",
            "2500 Standard Roof I4",
            "2500 Standard Roof V6",
            "1500",
            "2500 High Roof/high Roof",
            "Cargo Vans High Roof/ext",
            "1500 Standard Roof I4",
            "2500 Standard Roof I4 Diesel",
            "2500 High Roof V6/standard Roof V6",
            "2500 Standard Roof 4-cyl Gas",
            "3500xd High Roof V6",
            "500",
            "4500",
            "2500 High Roof 4-cyl Gas",
            "2500 High Roof 4-cyl Diesel",
            "3500 High Roof",
            "S",
            "Van 2500 High Roof",
            "2500 High Roof 4-cyl Diesel Ho",
            "3500xd 3500",
            "3500 High Roof I4",
            "3500 3500",
            "2500 Standard Roof 4-cyl Diesel Ho",
            "4500 High Roof 4-cyl Diesel Ho",
            "2500 Standard Roof 4-cyl Diesel",
            "3500xd Standard Roof I4",
            "3500xd High Roof 4-cyl Diesel Ho",
            "1500 Standard Roof 4-cyl Gas",
            "3500 High Roof 4-cyl Diesel Ho",
            "2500 High Roof 4-cyl Diesel Ho/standard Roof 4-cyl Diesel Ho",
            "3500 Solera",
            "4500 High Roof V6/standard Roof V6",
            "Van 2500",
            "Cargo Van",
            "Van",
            "4500 High Roof V6",
            "Passenger Vans",
            "3500 High  Roof",
            "1500 High Roof I4/standard Roof I4",
            "4500 Standard Roof V6",
            " 2500",
            "3500xd Standard Roof 4-cyl Diesel Ho",
            "3500xd Standard Roof V6",
            "Van 2500/3500",
            "S High Roof",
            "4500 3500/4500",
            "3500xd High Roof V6/standard Roof V6",
            "1500 1500",
            "Chassis-Cabs",
            "3",
            "S High Roof/high Roof",
            "Cargo Van 2500",
            "Cab Chassis",
            "Crew Vans",
            "Vans",
            "2",
            "1",
            "Passenger Van",
            "Passenger Vans 2500",
            "Cargo Vans 2500",
            "Crew Van",
            "Cargo Vans Ext",
            "Cargo Van Worker",
            "Cargo Vans Worker",
            "2500 High  Roof",
            "2500 High  Roof/high Roof",
            "Cargo Vans Normal Roof",
            "2500 Standard Roof I4/high Roof I4",
            "Van 3500 High Roof",
            "Wagon 2500 High Roof",
            "Cargo Van Standard Roof V6/worker",
            "High Roof V6",
            "High Roof",
            "Blue",
            "Cab Chassis 3500",
            "2500 High Roof I4/standard Roof I4",
            "Chassis-cabs 3500",
            "Standard Roof 4-cyl Diesel Ho",
            "S High  Roof/high Roof",
            "C",
            "     Sprinter",
            "4",
            "High Roof 4-cyl Diesel",
            "Normal Roof",
            "Standard Roof V6",
            "High Roof V6/standard Roof V6",
            "Van Standard Roof V6",
            "High Roof I4",
            "Cargo Vans High Roof",
            "High Roof I4/standard Roof I4",
            "1500 High Roof I4",
            "High Roof/high Roof",
            "High Roof 4-cyl Diesel Ho",
            "Standard Roof I4",
            "500/3500",
            "Cargo Van High Roof 4-cyl Diesel Ho",
            "Van High Roof V6",
            "High Roof 4-cyl Gas",
            "Cargo Van Standard Roof 4-cyl Diesel Ho",
            "Box Truck",
            "Wagon 2500",
            "High Roof I4 Diesel",
            "Nter Van",
            "-Cabs",
            "Cargo Van Standard Roof I4 Diesel",
            "High  Roof/high Roof",
            "Van 3500",
            "Sprinter",
            "Tic",
            "S Normal Roof"
          ]
        },
        {
          "model": "Toreto 45",
          "series": []
        },
        {
          "model": "Toreto 48",
          "series": []
        },
        {
          "model": "Torino",
          "series": []
        },
        {
          "model": "Tres Ejes",
          "series": []
        },
        {
          "model": "V220d",
          "series": []
        },
        {
          "model": "V250",
          "series": []
        },
        {
          "model": "Viaggio 1050",
          "series": []
        },
        {
          "model": "Viaggio 900",
          "series": []
        },
        {
          "model": "Viale BRT",
          "series": []
        },
        {
          "model": "Viano",
          "series": []
        },
        {
          "model": "Vito",
          "series": []
        },
        {
          "model": "EQB",
          "series": [
            "300 Suv 4matic",
            "300 4matic",
            "350 4matic",
            "250+",
            "350 Suv 4matic",
            "300 4m",
            "300 Suv 300 4matic",
            "300",
            "250 Suv 250+",
            "250 Suv",
            "250 Suv Eqb 250+",
            "350 4m",
            "4matic",
            "350 Suv 350 4matic",
            "Eqb 250+"
          ]
        },
        {
          "model": "EQE",
          "series": [
            "Amg Eqe",
            "Suv 4matic",
            "Suv 350 4matic",
            "Suv 350+",
            "Sedan 350 4matic",
            "Sedan 350+",
            "Sedan 53 4matic+",
            "Suv 500 4matic",
            "Eqe 350",
            "4matic",
            "350+",
            "500 Suv 4matic",
            "Sedan",
            "Suv Amg 4matic",
            "500 4matic+",
            "Sedan 500 4matic",
            "350",
            "Sedan 4matic",
            "350 Suv",
            "350+ Suv",
            "350 Sedan",
            "Suv 35",
            "350 Suv 4matic",
            "350 4matic",
            "500 Suv 500 4matic",
            "350+ Suv 350+",
            "350 Suv 350 4matic",
            "4m",
            "Suv Am",
            "500 Sedan",
            "Sedan Amg Eqe 4matic+",
            "Eqe 350+",
            "Suv 50",
            "Suv",
            "Sedan Eqe 350",
            "500 4matic",
            "350+ Sedan",
            "350+ 350+"
          ]
        },
        {
          "model": "EQS",
          "series": [
            "Suv",
            "Suv 580 4matic",
            "Sedan 450+",
            "Suv 450 4matic",
            "Sedan 580 4matic",
            "Sedan 450 4matic",
            "Suv 450+",
            "Suv 4matic",
            "450+",
            "4matic",
            "Sedan",
            "Sedan 53 4matic+",
            " 450+",
            "Eqs",
            "580",
            "580 4matic",
            "580 Sedan",
            "450",
            "450 Eqs 450+",
            "450 Suv 4matic",
            "4m",
            "Suv 45",
            "580 Suv",
            "450 Suv",
            "450+ Suv 450+",
            "580 Suv 4matic",
            "450+ Suv",
            "450 Suv 450 4matic",
            "450 4matic",
            "450+ Sedan",
            "580 Suv 580 4matic",
            "450  Sedan",
            "Suv 58",
            "53 4ma",
            "Suv 680 4matic Maybach",
            "Sedan Amg Eqs 4matic+",
            "Sedan 4matic",
            "Suv 68",
            "Sedan 53 Amg 4matic+"
          ]
        }
      ]
    },
    {
      "make": "Mercury",
      "models": [
        {
          "model": "Grand Marquis",
          "series": [
            "Ls",
            "Gs",
            "Ls/lse",
            "Ls (fleet Only)",
            "Ls Premium/ls Ultimate",
            "Ls Premium/ls Ultimate/lse",
            "Ls/bayshore",
            "Gs/gs Convenience",
            "Ls Ultimate",
            "Ls/limited",
            "Ls/ls Ultimate",
            "Ls Premium",
            "Gs Convenience",
            "Ls Premium/lse",
            "Marquis",
            "Lse",
            " Marq",
            "D Marq",
            "Ls Fleet Only",
            "Ls/ls Premium"
          ]
        },
        {
          "model": "Mariner",
          "series": [
            "V6",
            "I4",
            "Luxury/premier",
            "Premier",
            "Premier V6",
            "Hybrid",
            "Luxury",
            "Hev",
            "Convenience",
            "Hybrid Hev",
            "Pr",
            "Premier 4wd Premier",
            "Hy",
            "He",
            "Lu",
            "Hybrid Hybrid",
            "V6 (320a)",
            "Co",
            "Hy Hy",
            "Fw"
          ]
        },
        {
          "model": "Milan",
          "series": [
            "V6",
            "V6 Premier",
            "I4",
            "Premier",
            "I4 Premier",
            "Hybrid",
            "Prem",
            "R",
            "Hybr",
            "4d",
            "Hybrid Hybrid",
            "4d 4"
          ]
        },
        {
          "model": "Mountaineer",
          "series": [
            "Premier",
            "Convenience/luxury/premier",
            "Luxury",
            "Convenience",
            "Convenience/luxury",
            "Premier Premier",
            "W/4.6l",
            "Premier W/4.6l",
            "4.6l",
            "Convenience W/4.6l/luxury W/4.6l/premier W/4.6l",
            "Ountainee",
            "N 4x4"
          ]
        }
      ]
    },
    {
      "make": "Mini",
      "models": [
        {
          "model": "Cooper",
          "series": [
            "Clubman All4",
            "S",
            "Cooper S",
            "Cooper",
            "S Countryman",
            "Hardtop S",
            "Hardtop Base (m5)",
            "Countryman",
            "Clubman",
            "Countryman All4",
            "S E Countryman All4",
            "S Clubman All4",
            "S S",
            "S Clubman",
            "John Cooper Works",
            "S Countryman All4",
            "S Paceman",
            "Paceman Jcw",
            "Countryman Jcw",
            "Roadster S",
            "Paceman",
            "Jcw Countryman All4",
            "Se",
            "Jcw Clubman",
            "John Cooper Works Clubman",
            "Coupe John Cooper Works",
            "Roadster",
            "Oxford Edition",
            "Hardtop",
            "S Countryman S Countryman",
            "Sportback Ls Jcw",
            "Coupe S",
            "S Clubman S Clubman",
            "Clubman/john Cooper Gp Kt",
            "Coupe",
            "Hardtop 5 Door",
            "Cooper/oxford Edition",
            "Roadster John Cooper Works",
            "Clubman Jcw",
            "                Cooper",
            "S C",
            "Classic",
            "Joh",
            "Cou",
            "Convertible",
            "John Cooper Works Clubman All4",
            " 2 Door",
            "Clu",
            "Hardtop 4 Door",
            "Hardtop Sportback Ls/john Cooper",
            "Spo",
            "Convertible S",
            " 4 Door",
            "Pac",
            "Convertible S/john Cooper Works",
            " 2 Door Cooper S",
            "Roa",
            " 2 Door Cooper",
            " 2 Door John Cooper Works",
            "Hardtop 4 Door S",
            " 4 Door Cooper",
            " 2 Door Cooper/oxford Edition",
            " 4 Door Cooper S",
            "Hardtop John Cooper Works",
            " 2 Door Oxford Edition",
            "S P",
            " 2 Door Cooper Se",
            " 4 Door Cooper/oxford Edition",
            "Convertible John Cooper Works",
            "Jcw",
            " 4 Door S",
            " 4 Door Oxford Edition",
            "Ryman",
            "Man",
            "Oper Works",
            "An",
            "An All4",
            "Oper Works Clubman",
            "Johncooper Works",
            " Cooper",
            "S Countryman S",
            "S Clubman S",
            "Cla",
            " Cooper/oxford Edition",
            "R",
            "Hardtop Base M5",
            " S",
            "Gra",
            "D P",
            "D G",
            "D B",
            "D S",
            "/john Cooper Gp Kt",
            "R Cooper S",
            " 4 Door Cooper S Classic",
            "2d",
            "Aut",
            " 2 Door John Cooper Works Gp",
            " Oxford Edition",
            "S S/john Cooper Works",
            "Hardtop Cooper (m6)",
            "R John Cooper Works",
            "Sd",
            "D A",
            "Cam",
            "Ryman All4",
            " Cooper S",
            "S E",
            "R Cooper",
            "Exc",
            "D L",
            "Pim",
            "Mini Coope",
            " 2 Door S",
            "Ooper S",
            "Top Cooper",
            "2-door Fwd Cooper",
            "D",
            "S A",
            "Lon",
            "Bak",
            "S All4",
            "Ctrymn/johncooper Works",
            "Ck Ls/john Cooper",
            "Oper Works Gp",
            " John Cooper Works",
            "John Cooper Works Gp",
            "D C",
            "Sev",
            "Bay",
            "S B",
            "4-D",
            "Soh",
            "D H",
            "Clubman S",
            "Clu Clu",
            "Base (m6)",
            "Vehicle",
            "Base (m5)",
            "Roa Roa",
            "Cooper Se",
            "3-D",
            "John Works",
            "4-door Fwd Cooper",
            "Base",
            "Man Se All4",
            "Man S All4",
            "Bas",
            "Cooper Classic"
          ]
        },
        {
          "model": "Cooper Clubman",
          "series": [
            "John Cooper Works",
            "Cooper",
            "Cooper S",
            "S Clubman All4",
            "Clubman",
            "All4",
            "Base (m6)",
            "Jcw Clubman",
            "Jcw",
            "S",
            "S Clubman",
            "Oper Works",
            "Clubvan",
            "An",
            "N All4",
            "An All4",
            "Bman",
            "Ubm",
            " Clubman",
            "Lubman"
          ]
        },
        {
          "model": "Cooper Countryman",
          "series": [
            "Cooper S",
            "Cooper",
            "John Cooper Works",
            "Oxford Edition",
            "S Countryman",
            "S",
            "Countryman",
            "S Countryman All4",
            "All4",
            "Cooper S Classic",
            "S All4",
            "Countryman All4",
            "S E Countryman All4",
            "S E",
            "John Cooper Works All4",
            "Oper Works",
            "Edition",
            "Se",
            "N All4",
            "R S",
            "S Classic",
            "Jcw",
            "Man",
            "N",
            "Ntryman All4",
            "Ryman All4",
            "Ryman",
            "Jcw Countryman All4",
            "Man All4",
            "Fw Cooper",
            "S Cooper S",
            "Cooper/oxford Edition",
            "S S Countryman",
            "Cooper Se",
            "Cooper S E"
          ]
        },
        {
          "model": "Cooper Paceman",
          "series": [
            "Cooper S",
            "Cooper",
            "Jcw",
            "S",
            "Paceman",
            "S All4",
            "John Cooper Works All4",
            "John Cooper Works",
            "Cooper (m6)"
          ]
        },
        {
          "model": "Convertible",
          "series": [
            "Cooper",
            "Cooper S",
            "John Cooper Works",
            "S"
          ]
        }
      ]
    },
    {
      "make": "Mitsubishi",
      "models": [
        {
          "model": "ASX",
          "series": []
        },
        {
          "model": "Eclipse",
          "series": [
            "Gs",
            "Spyder Gt",
            "Cross Le",
            "Spyder Gs",
            "Gt",
            "Gts",
            "Cross Es",
            "Cross Se",
            "Spyder Gts",
            "Gs/gs Sport/se",
            "Spyder Gs Sport",
            "Cross",
            "Spyder Gs-t",
            "Spyder Gs Sport/se",
            "Rs",
            "Es",
            "Gs Sport",
            "Gs/gs Sport",
            "Se",
            "S",
            "Spyder Spyder Gs",
            "Spyder Spyder Gt",
            "Gs/se",
            "Spyder Gst",
            "Cr",
            "Se V6",
            "Gt/gt W/premium Pkg",
            "Lt",
            "Ort",
            "Gt Gt",
            "Gst",
            "Sp",
            "Ort/se",
            "/se",
            "2.5 S",
            "Se-V6",
            "Gs Sport/se",
            "Cross Sel",
            "Sp Sp",
            "Gsx",
            "Spyder Spyder Gts",
            "Gs-T",
            "Spyder Gt-p"
          ]
        },
        {
          "model": "Eclipse Cross",
          "series": [
            "Le S-awc",
            "Es 1.5t",
            "Es",
            "Es S-awc",
            "Se/se Special Edition/sel/sel Special Edition",
            "Es 1.5t Awc",
            "Le S-awc/ralliart S-awc",
            "Se S-awc/sel S-awc",
            "Sel",
            "Se",
            "Se S-awc/se Special Edition S-awc/sel S-awc/sel Special Edition S-awc",
            "Le",
            "Se/sel",
            "Se 1.5t",
            "Se Special Edition /sel /sel Special Edition /se",
            "Se Special Edition/sel/sel Special Edition/se",
            "Le/sp",
            "Se 1.5t Awc/sel 1.5t Awc",
            "Sel S-awc",
            "Se S-awc",
            "Se/se Special Edition/sel",
            "Le 1.5t",
            "Sel 1.5t",
            "Se /se Special Edition /sel /sel Special Edition",
            "Sp",
            "Sel 1.5t Awc",
            "Le/ralliart",
            "Black Edition S-awc/le S-awc/ralliart S-awc/se S-awc",
            "Gt",
            "Le 1.5t/se 1.5t/sp 1.5t",
            "Ralliart S-awc",
            "Se 1.5t Awc",
            "Le 1.5t Awc",
            "Le S-awc/ralliart S-awc/se S-awc",
            "Se 1.5t/sel 1.5t",
            "Se S-awc/se Special Edition S-awc/sel S-awc/sel Special",
            "Sp 1.5t Awc",
            "Le/sp/se",
            "Le/se/sp",
            "Se/se Technology/sel/sel",
            "Ralliart /le",
            "Edition/sel",
            "Gy/sel/sel",
            "Black Edition",
            "Ralliart",
            "Le /ralliart",
            "Se /sel",
            "Black Edition /le /ralliart /se",
            "Black Edition S-awc/le/ralliart S-awc/se",
            "Gt/noir/se/sel",
            "Gt/se/sel",
            "Black Edition S-awc/se S-awc/sel S-awc",
            "Gt/se",
            "Gt/limited Edition/se",
            "Carbon Edition/gt/se/sel",
            "Black Edition S-awc",
            "Sp 1.5t"
          ]
        },
        {
          "model": "Endeavor",
          "series": [
            "Xls",
            "Ls",
            "Se",
            "Limited",
            "L",
            "X",
            "S",
            "Ls/rt"
          ]
        },
        {
          "model": "Galant",
          "series": [
            "Es/ls",
            "Fe",
            "Ls/es",
            "De",
            "Se/es",
            "Ls",
            "Es/se",
            "Sport Edition/es",
            "Es",
            "Es/sport Edition",
            "Es Medium/ls Medium",
            "Sport V6",
            "Ls Premium",
            "Es Medium",
            "Ralliart",
            "Gts",
            "Gtz/es",
            "Es/gtz/ls",
            "Ls Medium",
            "Es/ls Medium",
            "Es Premium",
            "Es V6/gtz/ls V6",
            "S",
            "Sport",
            "Es High/ls High",
            "Es V6/gtz",
            "Es High",
            "Es/ls/gtz",
            "Ls High",
            "T Edition",
            "Ral",
            "Es/",
            "T",
            "Spo",
            "Es/sport",
            "6",
            "Es Premium/ls Premium",
            "Gtz/ls/es",
            "Se",
            "4d Es",
            "Es/gtz",
            "Gtz",
            "Es Es",
            "Ls/gts",
            "Es Diamond Package",
            "Gts Sun And Sound",
            "Gs"
          ]
        },
        {
          "model": "i-MiEV",
          "series": [
            "Es/se",
            "Es"
          ]
        },
        {
          "model": "L200",
          "series": []
        },
        {
          "model": "Lancer",
          "series": [
            "Evolution Mr",
            "De",
            "Es",
            "Es/es Sport",
            "Se",
            "Gt",
            "Sel/es/se",
            "Es/es-Sport",
            "Es/se",
            "Evolution",
            "Evolution Rs",
            "Gts",
            "Sportback Gt",
            "Evolution Gsr",
            "Evolution Ix/mr",
            "Es/le",
            "De/es",
            "Ralliart",
            "Sportback Es",
            "Sportback Gts",
            "Ls",
            "Es/se/sel",
            "Oz Rally",
            "Evolution Se",
            "Le",
            "Sportback Ls",
            "Sportback Ralliart",
            "Evolution Final Edition",
            "Sel",
            "Le/es",
            "Evolution Mr/mr Touring",
            "Evolution Evolution Gsr",
            "Evolution Evolution Se",
            "Limited",
            "Evolution Mr/viii",
            "Evolution Evolution Mr",
            "O-z Rally",
            "Sportback",
            "Evolution Evolution",
            "Se Ltd/es",
            "Evolution Iv",
            "Se/es/sel",
            "4d Es",
            "Spo",
            "Evo Lancer",
            "Sportback Es/es Sport",
            "Es/",
            "Port",
            "Ral",
            "El",
            "Cer",
            "On Gsr",
            "T",
            "Oz",
            "On Mr",
            "Evo",
            "On Se",
            "Es Sport",
            "Evolution Ix",
            "Oz-Rally",
            "Ral Ral",
            "Gt Gt",
            "Gsr",
            "Es Es",
            "Se Se",
            "Sportback Se Ltd/sptbk Gt",
            "Mr",
            "Gts Gts",
            "Sportback Se",
            "Sportback Se Limited",
            "Gt/se",
            "Evo Lancer Evo",
            "Gt/gts",
            "Es/gts/se Anniversary Edition/se Black Edition/se Ltd",
            "Se Awc",
            "Ix/mr",
            "Es/se Anniversary Edition/se Black Edition/se Ltd",
            "Es/se Ltd",
            "Final Edition",
            "Evl",
            "Se/gt",
            "Es/es Spo"
          ]
        },
        {
          "model": "Mirage",
          "series": [
            "G4 Es",
            "De",
            "Es",
            "Se",
            "Le",
            "G4 Se",
            "Carbonite Edition/es/le",
            "Black Edition",
            "Gt",
            "Es/le",
            "Rf",
            "De/rf",
            "Se/black Edition/ralliart",
            "Es/rf",
            "Se/black Edition",
            "Es/se",
            "G4 Se/g4 Le",
            "Le/gt",
            "G4 Es/g4 Le/g4 Black Edit",
            "Ls",
            "Black Edition/ralliart/se",
            "Le/es/carbonite Edition",
            "Rf/de",
            "Rf/es",
            "Black Edition/se",
            "Es/le/carbonite Edition",
            "Ls 1.8l",
            "Noir",
            "G4 Es/g4 Le/g4 Carbonite",
            "G4 Es/g4 Le/g4 Carbonite Edition",
            "Se/black Edition/gt",
            "Gt/le",
            "G4 Es/g4 Le/g4 Black Edition",
            "Ralliart",
            "S",
            "Bla",
            "Ls Ls",
            "G4",
            "4 Le/g4 Black Edit",
            "K Edition/gt",
            "Te Edition/es/le",
            "4d Es",
            "Se/es",
            "Arbonite Edition",
            "G4 Es/g4 Le",
            "K Edition",
            "Carbonite Edition",
            "4 Le",
            "Le/es",
            "Black Edition/se/ralliart",
            "Gt Gt",
            "Black Edition/es/le",
            "Es/es Limited",
            "Carbon Edition/es/se",
            "Le/se",
            "Sel",
            "Gt/noir"
          ]
        },
        {
          "model": "Mirage G4",
          "series": [
            "Es",
            "Black Edition",
            "Carbonite Edition/es/le",
            "Black Edition/es/le",
            "Le/se",
            "Es/rf",
            "Se",
            "Le",
            "Le/es/black Edition",
            "Carbonite Edition/le/es",
            "G4 Se",
            "G4 Es",
            "G4 Es/g4 Le/g4 Black Edit",
            "G4 Es/g4 Le/g4 Carbonite",
            "Rf",
            "G4 Se/g4 Le",
            "Rf/es",
            "Se/le",
            "Es/le/carbonite Edition",
            "K Edition",
            "Onite Edition",
            "Ion",
            "Carbonite Edition",
            "Es/le/black Edition",
            "Se/g4 Le",
            "G4"
          ]
        },
        {
          "model": "Montero",
          "series": [
            "Sport Es/sport Ls",
            "20th Anniversary/limited",
            "Sport Xls",
            "Xls",
            "Limited",
            "Sport Limited",
            "Sport Ls/sport Xls",
            "20th Anniversary",
            "Sport Es",
            "Ls",
            "Sr",
            "Sport Ls",
            "Rs",
            "Sport Xs",
            "Sport",
            "20",
            "20th Anniv",
            "Xl",
            "20th Anniv/ltd",
            "Ltd",
            "Ltd/20th Anniv",
            "Sp",
            "Li",
            "Ls/xls",
            "Sp Sport Ls/sport Xls",
            "Rs/ls",
            "Es",
            "Es/ls"
          ]
        },
        {
          "model": "Montero Sport",
          "series": [
            "Ls/es",
            "Es/ls",
            "Ltd",
            "Ls/xls",
            "Xls",
            "3.5/xls",
            "Sport Limited",
            "Sport Xls",
            "Es",
            "Limited",
            "Ls",
            "Sport Es/sport Ls",
            "Xs"
          ]
        },
        {
          "model": "Outlander",
          "series": [
            "Sport Es",
            "Sel",
            "Sel 2.4",
            "Es 2.4",
            "Es",
            "Black Edition 2wd/se 2.5 2wd/se Launch Edition 2wd",
            "Le",
            "Se",
            "Es 2.5 S-awc",
            "Black Edition S-awc",
            "Xls",
            "Es 2.5 2wd",
            "Se/sel/le",
            "Gt",
            "Se 2.4",
            "Sel/es/se",
            "Sport S/se",
            "Es 2.4 S-awc/le 2.4 S-awc/se 2.4 S-awc/sel 2.4 S-awc/sp 2.4 S-awc",
            "Le/sel/es/se",
            "Sel 2.5 S-awc/sel Launch Edition S-awc/sel Special Edition S-awc",
            "Sport Se",
            "Ls",
            "Se 2.5 2wd",
            "Black Edition S-awc/se 2.5 S-awc/se Launch Edition S-awc",
            "Se 2.5 S-awc",
            "Sport Gt",
            "Es/ls",
            "Se Black Edition S-awc",
            "Se/se Black Edition/se Te",
            "Sel 2.5 S-awc",
            "Se/sel",
            "Es/se/sel",
            "Sel 2.4 S-awc",
            "Le 2.4/se 2.4/sel 2.4/sp 2.4",
            "Le 2.4 S-awc",
            "Sel 2.5 2wd/sel Black Edition 2wd",
            "Es/le/se/sel",
            "Sel 2.5 S-awc/sel 40th Anniversary S-awc/sel Black Edition S-awc",
            "Sport Sel",
            "Ited",
            "Sel 2.5 2wd/sel Special Edition 2wd",
            "Sel Special Edition 2wd",
            "Es 2.5",
            "Se 2.5 2wd/se Launch Edition 2wd/black Edition 2wd",
            "Se/black Edition",
            "Se Black Edition 2wd",
            "Sport Le",
            "Sel Black Edition 2wd",
            "Se/se Black Edition/se Technology/se Special",
            "Se 2.5 2wd/se Black Edition 2wd/se Special Edition 2wd",
            "Sel/sel Special Edition",
            "Ralliart S-awc",
            "Sel/platinum Edition",
            "Le/se/sel",
            "Se 2.5 2wd/se Black Edition S-awc/se Black Edition W/pano Roof",
            "Es 2.4 S-awc",
            "Sel 2.5",
            "Sel 2.5 /sel Launch Edition /sel Special Edition",
            "Sel 2.5 2wd",
            "Le/sel/se",
            "Se 2.5",
            "Ralliart S-awc/se 2.5 S-awc/se Black Edition S-awc/se Special Editiont S-awc",
            "Ralliart /se 2.5 /se Black Edition /se Special Editiont",
            "Sel Special Edition S-awc",
            "Se 2.4/le 2.4/sel 2.4/sp 2.4",
            "Black Edition",
            "Le 2.4",
            "Sel/se",
            "Sel 40th Anniversary S-awc",
            "Se/se Black Edition/se Technology/se Special Edition",
            "Se 2.5 S-awc/se Black Edition S-awc/se Black Edition W/pano Roof S-awc/se Ralliart S-awc",
            "Se/se Technology/ralliart",
            "Sp 2.4",
            "Sel/sel Black Edition/sel Touring/sel Premium",
            "Limited",
            "Sel 2.5 S-awc/sel Launch Edition S-awc/sel Special Edition",
            "Fe/sel/le/gt",
            "Fe",
            "Se/gt",
            "Sel/sel Black Edition/sel",
            "Se/black Edition/ralliart",
            "Sel/le/gt",
            "Se 2.4 S-awc",
            "Se Black Edition W/pano Roof",
            "Ralliart S-awc/se 2.5 S-awc/se Black Edition S-awc/se Special Editiont S-a",
            "Sel 2.5 S-awc/sel Black Edition S-awc/sel Platinum Edition S-awc",
            "Phev",
            "Sel/gt/fe",
            "Es/se/sel/le/sp",
            "Se/sel/le/sp",
            "Sp 2.4 S-awc",
            "Se 2.5 2wd/se Black Edition S-awc/se Black Edition W/pa",
            "Se Black Edition W/pano Roof S-awc",
            "Se Black Edition",
            "Es 2.4 S-awc/le 2.4 S-awc/se 2.4 S-awc/sel 2.4 S-awc/sp",
            "Sel Hybrid",
            "Sel/sel Black Edition/sel Touring/sel Premium/40th Anniversary",
            "Sel/40th Anniversary/sel",
            "Se/sel/le/le Premium",
            "Sel Special Edition",
            "2.4 Se",
            "Plug-in Hybrid Es",
            "Sel Black Edition S-awc",
            "Ralliart /se 2.5",
            "Se 2.4 /le 2.4 /sel 2.4 /sp 2.4 /es 2.4",
            "Black Edition /se 2.5 /se Launch Edition",
            "Es 2.4 /le 2.4 /se 2.4 /sel 2.4 /sp 2.4",
            "Se/se Black Edition/se Special Edition",
            "Wc",
            "Black Edition S-awc/se 2.5 S-awc/se Launch Edition S-aw",
            "Sel/sel Black Edition/sel Touring/sel Premium/40th Anni",
            "Sel/sel Launch Edition/sel Special Edition",
            "Ralliart S-awc/se 2.5 S-awc/se Black Edition S-awc/se S",
            "Se 2.5 2wd/se Black Edition S-awc",
            "Se 2.5 S-awc/se Black Edition S-awc",
            "Sel 2.5 S-awc/sel Launch Edition S-awc/sel Special Edit",
            "Se 2.5 S-awc/se Black Edition S-awc/se Black Edition W/pano Roof S-awc/se ",
            "Gt 3.0 S-awc",
            "Se 2.5 S-awc/se Black Edition S-awc/se Black Edition W/",
            "Sel 2.5 S-awc/sel Black Edition S-awc/sel Platinum Edit",
            "Rvr",
            "Se Special Edition",
            "Awd",
            "Rvr Se",
            "Rvr Gt",
            "Es/se/sel/le",
            "Se/sel/es",
            "Le/sp",
            "Sp",
            "Ls/es",
            "Sel 2.5 /sel 40th Anniversary /sel Black Edition",
            "4d Sel",
            "Black Edition 2wd",
            "Es 2.4 /le 2.4",
            "Rvr Se Lim",
            "K Edition/se Te",
            "Es/le/sp",
            "4d Es",
            "Le 2.4/se 2.4/sel 2.4",
            "Sel Launch Edition",
            "Dition",
            "Sr5/limited/limited Night",
            "Es Awd",
            "Sel/gt",
            "Se 2.5 /se Launch Edition /black Edition",
            "Ecial Edition",
            "Se/se Black Edition",
            "Edition",
            "Ack Edition/sel",
            "K Edition",
            "Se Black Edition/se Special Edition/se",
            "Se 2.5 /se Black Edition /se Black Edition W/pano Roof",
            "Sel 2.5 S-awc/sel 40th Anniversary S-awc/sel Black Edit",
            "Sel Black Edition",
            "Es/le 2.4 /se 2.4 /sel 2.4 /sp 2.4",
            "Sel/40th Anniversary/sel Touring/sel Premium",
            "Se/ralliart",
            "Se 2.5 /se Black Edition /se Black Edition W/pano Roof /se Ralliart",
            "Se Hybrid",
            "Es/se",
            "Gt S-awc/le S-awc/sel S-awc",
            "Se 2.5 2wd/se Black Edition S-awc/se Black Edition W/pano Roof S-awc",
            "Limited Edition/se/sel",
            "Gt/gt Noir/gt Premium",
            "Le/le Premium/se/sel",
            "Sel Platinum Edition S-awc",
            "Se/se Black Edition/se Black Edition W/pano Roof S-awc",
            "4d 2wd",
            "Sel 2.5 2wd/sel Special Edition",
            "Se 2.5 S-awc/se Black Edition S-awc/se Black Edition W/pano Roof/se Ralliart S-awc",
            "Ralliart S-awc/se S-awc",
            "Es/ex/ex-L",
            "Se/se Anniversary Edition",
            "Se S-awc",
            "Ex",
            "Gt Hybrid",
            "Sel 2.5 S-awc/sel Black Edition S-awc/sel Platinum Edition",
            "Sel Platinum Edition",
            "Gt/sel",
            "Se Ralliart/se S-awc",
            "Le/le Premium/noir/se/sel",
            "Gt/gt Premium",
            "Gt/gt Noir/gt Premium/noir",
            "Ls/xls",
            "Plug-in Hybrid Le/se/sel",
            "Le Hybrid",
            "Plug-in Hybrid",
            "Sport S",
            "Se 2.5 S-awc/trail Edition",
            "Sel Phev",
            "Sel S-awc",
            "Se/diamond Trail Edition",
            "Gt S-awc",
            "Es/se/le/sp",
            "Es Hybrid",
            "Se 2.5 S-awc/trail Edition S-awc",
            "2.0 Se",
            "Ex-L"
          ]
        },
        {
          "model": "Outlander PHEV",
          "series": [
            "Es S-awc",
            "Ralliart S-awc/se S-awc",
            "Gt S-awc/le S-awc/sel S-awc",
            "Gt",
            "Sel S-awc",
            "Sel",
            "Sel S-",
            "Se S-awc",
            "Se/gt",
            "Ralliart S-awc",
            "Sel Platinum Edition",
            "Se Ralliart/se S-awc",
            "40th Anniversary S-awc",
            "Se/gt/se Touring",
            "Gt S-awc",
            "40th Anniversary S-awc/sel S-awc",
            "Sel/le/gt",
            "40th Anniversary",
            "Se/se Technology/ralliart",
            "Sel/gt",
            "Se/ralliart",
            "Se",
            "Sel/40th Anniversary",
            "Sel/gt/le",
            "Gt S-/le S-/sel S-",
            "Gt/sel",
            "Se Ralliart/se S-",
            "Gt W/ Gt",
            "Sel Black Edition/sel Platinum Edition/sel S-",
            "Ralliart S-/se S-",
            "Gt S-/sel S-",
            "40th Anniversary S-/sel S-",
            "Se S-",
            "Sel/gt/fe",
            "Le/sel",
            "Gt/se",
            "Gt/le/se/sel",
            "Sel Black Edition/sel Platinum Edition/sel S-awc",
            "Gt S-awc/sel S-awc",
            "Black Edition/gt/le/se"
          ]
        },
        {
          "model": "Outlander Sport",
          "series": [
            "Se",
            "2.0 Be Awc/2.0 Es Awc/2.0 Le Awc/2.0 Se Awc/2.0 Se Special Edition Awc",
            "2.4 Se",
            "2.0 Be 2wd/2.0 Es 2wd/2.0 Le 2wd/2.0 S 2wd",
            "2.0 Se",
            "Gt",
            "Es",
            "2.0 Se 2wd",
            "Es 2.0/sp 2.0",
            "2.0 Es",
            "2.4 Sel",
            "2.0 Be /2.0 Es /2.0 Se /2.0 Sp",
            "2.4 Gt",
            "2.0 Es/2.0 Le",
            "2.0 Be Awc/2.0 Es Awc/2.0 Le Awc/2.0 Se Awc",
            "2.4 Es",
            "2.0 Es/2.0 Le/2.0 Sp",
            "2.0 Se Awc",
            "2.0 Le",
            "2.4 Es/2.4 Se",
            "Le",
            "2.0 Se 2wd/2.0 Se Special Edition 2wd",
            "2.0 Be/2.0 Es/2.0 Sp",
            "2.0 Be Awc",
            "2.0 Be Awc/2.0 Es Awc/2.0 Se Awc/2.0 Sp Awc",
            "Es/se/sp",
            "2.0 Sp",
            "2.0 Es Awc",
            "2.0 Le Awc",
            "2.0 Be /2.0 Es /2.0 Le /2.0 Se",
            "2.0 Be",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se Awc/2.0 Trail Edition Awc",
            "2.0 Es/2.0 Le/2.0 Se/2.0 Sp",
            "Es/sp",
            "Es/se/le/sp",
            "Es/se",
            "Es/le/be",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se Awc",
            "Es/le/sp",
            "Se/gt",
            "Es/le/be/se",
            "S/se/es/le/ralliart/rugged",
            "2.0 Be /2.0 Es /2.0 Le /2.0 Se /2.0 Se Special Edition",
            "S/se/es/le/ralliart/trail",
            "2.4 Gt/2.4 Sel",
            "Se 2.0",
            "2.0 Ralliart Awc",
            "Es/se/le",
            "2.4 Gt Awc",
            "Sel/gt",
            "Es/se/le/be",
            "2.0 Es 2wd",
            "Es/le/be/se/se Special Ed",
            "S/se/es/le/ralliart/rugge",
            "S/se/es/le/ralliart/trail Edition",
            "2.0 Be Awc/2.0 Es Awc/2.0 Le Awc/2.0 Se Awc/2.0 Se Special Edition A",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se",
            "Es/le/be/se/se Special Edition",
            "Se/se Special Edition",
            "Es 2.0",
            "2.0",
            "2.0 Es/le 2.0",
            "Le 2.0",
            "2.4 Gt Awc/2.4 Gt Special Edition Awc",
            "2.0 Trail Edition Awc",
            "2.0 Le 2wd",
            "2.0 Es/2.0 Le/es 2.0",
            "Sel",
            "2.0 Es/2.0 Le/2.0 Se",
            "2.0 Es /2.0 Le",
            "2.0 Be Awc/2.0 Es Awc/2.0 Le Awc/2.0 Se Awc/2.0 Se Spec",
            "Be/es/le/se/se Special Edition",
            "Be/es/le/s",
            "2.0 Be Awc/2.0 Es Awc/2.0",
            "2.4 Sel Awc",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se Awc/2.0 Trai",
            "2.4",
            "Se 2.4",
            "Sel 2.4",
            "Es 2.0/se 2.0",
            "Es/le/be/s",
            "Sp 2.0",
            "Gt 2.4",
            "Black Edition 2.0",
            "Pecial Ed",
            "Es/le/s",
            "Es/le/se/s/ralliart",
            "Es 2.0/se 2.0/sp 2.0/black Edition 2.0",
            "2.0 S 2wd",
            "Es/le/se",
            "Es/le/s/be",
            "S",
            "Art",
            "S/se/es/le/ralliart",
            "2.0 Be 2wd",
            "Art/rugge",
            "2.0 Es /2.0 Le /2.0 Ralliart /2.0 S /2.0 Se",
            "Ralliart",
            "2.0 Be /2.0 Es",
            "2.0 Trail Edition",
            "2.4 Sel Awc/sel",
            "2.0 Es /2.0 Le /2.0 Ralliart /2.0 S /2.0 Se /2.0 Trail Edition /es/le/ralliart/s/se/trail Edition",
            "Es W 2.0 Be",
            "2.0 Es /2.0 Le /2.0 Ralliart /2.0 S /2.0 Se /2.0 Trail",
            "2.4 Gt /2.4 Gt Special Edition",
            "2.0 Es Awc/2.0 Ralliart Awc/2.0 S Awc/es/le/ralliart/s/se/trail Edition",
            "Se A Se",
            "2.0 Es Awc/2.0 Ralliart Awc/2.0 S Awc/es/le/ralliart/s/",
            "2.0 Le/2.0 Sp",
            "Gt/gt Special Edition",
            "Trail Edition",
            "S/es/le/se/trail Edition",
            "2.0 Es Awc/2.0 Le Awc/2.0 S Awc/2.0 Se Awc",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se Awc/2.0 Trail Edition Awc/s",
            "2.0 S Awc",
            "2.0 Es Awc/2.0 Le Awc/2.0 S Awc/2.0 Se Awc/trail Edition",
            "2.0 Es Awc/2.0 Le Awc/2.0 S Awc/2.0 Se Awc/trail Editio",
            "2.0 Es Awc/2.0 Le Awc/2.0 S Awc/2.0 Se Awc/2.0 Trail Edition Awc",
            "2.0 Es/es 2.0",
            "2.0 Es Awc/2.0 Le Awc/2.0 Ralliart Awc/2.0 S Awc/2.0 Se Awc/2.0 Trail Edition Awc/trail Edition"
          ]
        },
        {
          "model": "RVR",
          "series": [
            "Se",
            "Es",
            "Gt",
            "Se/sel/le/gt",
            "Es/se",
            "Se Limited/gt",
            "Se Limited",
            "Se/es",
            "Se/sel/limited/gt",
            "Se/sel/noir/gt",
            "Se Ltd/gt",
            "S",
            "Imited Edition/gt",
            "El/le/gt",
            "Gt/le/se/sel",
            "Gt/se Anniversary Edition/se Limited Edition",
            "Gt/se Black Edition/se Limited Edition",
            "Se/se Black Edition/se Limited Edition",
            "Black Edition/gt/se Limited Edition",
            "Se Limited Edition",
            "Gt/se",
            "Gt/se Limited Edition",
            "Gt/noir/se/sel",
            "Sel",
            "Gt/limited Edition/se/sel",
            "Le"
          ]
        },
        {
          "model": "Xpander",
          "series": []
        }
      ]
    },
    {
      "make": "Nissan",
      "models": [
        {
          "model": "370Z",
          "series": [
            "Base",
            "Touring",
            "Sport",
            "7-speed Automatic",
            "Nismo",
            "Sport Tech",
            "Nismo Tech",
            "Nismo/touring",
            "Nismo/nismo Tech/sport/sport Tech/touring",
            "Touring/sport/sport Tech/",
            "Touring/nismo",
            "Tour/spt/tech/nismo/tech",
            "Sport Touring 7-speed Automatic",
            "Touring/touring Sport",
            "Sport Touring",
            "Touring Sport",
            "Nismo 6-speed Manual",
            "Nismo Tech/sport/sport Tech/touring",
            "Coupe",
            "Sport 7-speed Automatic",
            "Touring/sport/nismo",
            "7-speed Automatic/base 6-speed Manual/nismo 6-speed Manual/nismo 7-speed Automatic",
            "Base 6-speed Manual",
            "Ier Crew Cab Le",
            "Sport/sport Touring/nismo",
            "Coupe Touring",
            "Roadster",
            "Base (m6)",
            "Coupe Sport Touring",
            "Coupe Sport",
            "Coupe Sport Tech",
            "Coupe Nismo",
            "Ng",
            "Spt/tech/nismo/tech",
            "Ng/sport/sport Tech/",
            " Tech",
            "Ng Sport",
            "Ng/nismo",
            "/sport Touring/nismo",
            "Ng/touring Sport",
            "Ng/sport/nismo",
            "I",
            "Touri",
            "Nismo/nismo Tech/touring/sport/sport Tech",
            "Nismo 7-speed Automatic",
            "Sport 6-speed Manual",
            "2d",
            "7-speed Automatic/base 6-speed Manual/nismo 6-speed Man",
            "Base (a7)",
            "Nismo/sport/touring Sport",
            "Mo",
            "Sport Touring/touring",
            "Touring Edition"
          ]
        },
        {
          "model": "Altima",
          "series": [
            "2.5 S",
            "Sr Fwd",
            "2.5 Sl",
            "2.5 Sv",
            "S",
            "Sr",
            "2.5",
            "Base",
            "3.5s",
            "Sr Vc-turbo Fwd",
            "2.5 Sl/2.5 Sr/2.5 Sv/2.5/2.5 S",
            "3.5 Sv",
            "Xe",
            "2.5 Sr",
            "Sr Intelligent Awd",
            "Sv Fwd",
            "3.5 Se",
            "3.5sl/3.5 Sr",
            "S Fwd",
            "2.5/2.5 S/2.5 Sl/2.5 Sv",
            "3.5 S/3.5 Sl/3.5 Sv",
            "3.5 Sr",
            "3.5 Sl",
            "2.5/2.5 S/2.5 Sl/2.5 Sr/2.5 Sv",
            "Sl Intelligent Awd",
            "Sl",
            "Sv",
            "Se",
            "S/sl",
            "2.5 Sv/2.5/2.5 S/2.5 Sl",
            "2.5 Sl/2.5 Sv/2.5/2.5 S",
            "Hybrid",
            "Se-L/gxe/gle/xe/se",
            "Gle",
            "Gxe/gle/xe/se",
            "2.5 Sr/2.5 Sv/2.5/2.5 S/2.5 Sl",
            "Gxe",
            "Platinum Fwd",
            "3.5 Sl/3.5 Sr",
            "2.5/2.5 S",
            "Xe/gxe/se/gle",
            "3.5s/3.5sv/3.5sl",
            "2.5/s/sv/sl",
            "Sl Fwd",
            "Platinum",
            "Sv Intelligent Awd",
            "3.5sl",
            "3.5se",
            "3.5 S",
            "2.5/s/sv/sl/sr",
            "2.5s",
            "Gle/gxe/se/se-L/xe",
            "S Intelligent Awd",
            "3.5se/3.5sl",
            "2.5 S/2.5 Sl/2.5 Sr/2.5 Sv",
            "2.5/2.5s",
            "Platinum Intelligent Awd",
            "Gle/gxe/se/xe",
            "2.5 Platinum",
            "Edition One",
            "Platinum Vc-turbo Fwd",
            "3.5 Se-r",
            "Hybrid Hybrid",
            "Se/sl/se-R",
            "Gxe/gle/se",
            "2.0 Platinum",
            "2.0 Sr",
            "Gle/gxe/se",
            "Touring",
            "Xe/gxe/se",
            "S Hybrid",
            "+/!/sport",
            "3.5 Se/3.5 Sl",
            " S/2.5 Sl/2.5 Sv",
            "Se-R",
            "Se/sel",
            "25s",
            "Hyb",
            "Pla",
            "Bas",
            "3.5",
            "Edi",
            "2.5/2.5 S/2.5 Sl",
            ".5 Sl/3.5 Sv",
            "M Fwd",
            " S/2.5 Sl/2.5 Sr/2.5 Sv",
            "Ring",
            "S S",
            "2.5 2.5",
            "Man",
            "Fwd",
            "Sr Cv1",
            "4d 2wd",
            "2.0 Edition One",
            "A2s",
            "S/s",
            "V/sl",
            "S A",
            "2.5 Sr/sv/sl/plat",
            "Tinum",
            "K1500 Lt",
            "S W",
            "M",
            "V/sl/sr",
            ".5sl",
            "5sv/3.5sl",
            ".5 Sr",
            "201",
            "W/c",
            "2.5 Hybrid",
            "S/l",
            "Altama",
            "S M",
            "/s/s",
            "S/sv/sr/sl",
            "4d",
            "Ultima",
            "Xe/",
            "Alitma",
            "3.5se/3.5 Se/3.5 Sl",
            "4 D",
            "2d 2.5 S",
            "Base/s/sr/sv/sl",
            "Sed",
            "Tion One",
            "              Altima 2.5",
            "L",
            "Sle",
            "Base/s",
            "Se/",
            "Lligent Awd",
            " S/2.5 Sl",
            "Urbo Fwd",
            "Base/s/sr",
            "Sxt Plus",
            "2d",
            "La Lt",
            "4c",
            "Spo",
            "S A S A",
            "Man Man",
            "25/",
            "E-R",
            "Aut",
            "Bas Bas",
            "Aut Aut",
            "Premier",
            "Sv Awd",
            "Sr Sr",
            "Hyb Hyb",
            "2.5 Sr Midnight Edition",
            "2.5 S/2.5 Sl Tech/2.5 Sv",
            "Sr Awd",
            " W/xenon He 3.5 Sr",
            "2.5/2.5 S/2.5 Sl Tech/2.5 Sr/2.5 Sv",
            "Sl Awd",
            "2.5 Edition One/2.5 Platinum",
            "Xle",
            "Sr Midnight",
            "2.5 Base (a4)"
          ]
        },
        {
          "model": "Aprio",
          "series": []
        },
        {
          "model": "Ariya",
          "series": [
            "Engage",
            "Platinum +",
            "Venture+",
            "Evolve+",
            "Evolve+/empower +/premier",
            "Premiere",
            "Evolve+/engage +",
            "Engage+",
            "Platinum+",
            "Evol",
            "Re",
            "Enga",
            "Plat",
            "R+",
            "Vent",
            "Empower+",
            "Engage+/evolve+",
            "Evolve+/empower +",
            "Platinum+/premiere"
          ]
        },
        {
          "model": "Armada",
          "series": [
            "Se",
            "Sl 2wd",
            "Le",
            "Sv",
            "Platinum",
            "Sl",
            "Sl 4wd",
            "Platinum/sl/sv",
            "Se/le",
            "Platinum 4wd",
            "Sv 4wd",
            "Se/titanium/platinum",
            "Sv 2wd",
            "S 4wd",
            "Titanium",
            "Platinum 2wd",
            "S",
            "Sv/sl/platinum",
            "Platinum/sv/sl",
            "Se Off-road",
            "S/sv",
            "Le/se/se Off-road",
            "Der S",
            "Platinum/se/titanium",
            "Pla",
            "S 2wd",
            "M 4wd",
            "Suv",
            "Sl/platinum/sv",
            "M",
            "Latinum",
            "-V8",
            "Nium/platinum",
            "Se/",
            "Sv/",
            "Se/ Se/",
            "Sl Sl",
            "Pla Pla",
            "Sv Sv",
            "Le/se",
            "Evolve+",
            "Platinum/sl",
            "Pro-4x"
          ]
        },
        {
          "model": "Cabstar",
          "series": []
        },
        {
          "model": "Cube",
          "series": [
            "1.8sl",
            "1.8s",
            "1.8 Krom",
            "Base",
            "S",
            "1.8 Sl",
            "S/sl",
            "S/sl/krom",
            "1.8 S",
            "1.8 S Krom Edition",
            "1.8",
            "1.8 S/1.8 Sl",
            "Sl",
            "1.8 Base",
            "Lverado C1500 Lt",
            "Rom",
            "Ase",
            "L",
            "Krom",
            " Krom Edition",
            "Base/",
            "S S",
            "S/sl/"
          ]
        },
        {
          "model": "Frontier",
          "series": [
            "S/sv-I4",
            "Desert Runner",
            "Xe-V6",
            "Sv",
            "Nismo Off Road",
            "King Cab S 4x2",
            "Sv 4x2",
            "King Cab Sv 4x4",
            "S",
            "Sv 4x4",
            "King Cab Xe",
            "Se-V6",
            "Se-V6/xe-V6",
            "Se",
            "Pro-4x 4x4",
            "Xe",
            "2wd Xe/se",
            "2wd Xe",
            "2wd",
            "King Cab Se/le/nismo",
            "Pro-4x",
            "Crew Cab Se",
            "4wd Xe",
            "Crew Cab Le",
            "Crew Cab Xe",
            "Desert Runner Se-v6/desert Runner Xe-v6",
            "King Cab Le",
            "Sl",
            "Desert Runner Xe-v6",
            "King Cab S 4x4",
            "King Cab Se",
            "S 4x2",
            "Crew Cab Se/le/nismo",
            "Crew Cab Le/se/off Road",
            "S/sv/pro-X",
            "S/sv/pro-4x",
            "King Cab Xe/king Cab Se",
            "S/sv",
            "Se/xe",
            "Sl/sv",
            "S/sv/sl/desert Runner",
            "Crew Cab Xe V6",
            "Desert Runner Se-v6",
            "S 4x4",
            "Le",
            "L",
            "Crew Cab Sc",
            "King Cab Xe V6",
            "Crew Cab Xe/crew Cab Se",
            "Desert Runner/s/sl/sv",
            "King Cab Sv 4x2",
            "Pro-x 4x2",
            "Sv-I4",
            "Pro-4x/s/sl/sv",
            "Sc-V6",
            "S/sv/sl/pro-4x",
            "Se-I4",
            "Se-V6/xe/xe-V6",
            "2wd King Cab Le/se/off Road",
            "S/sv/pro-4x/sl",
            "King Cab Le/se/off Road",
            "Long Bed Sv 4x2",
            "Sl 4x2",
            "Sv/pro-4x",
            "Sv/sl/pro-4x",
            "Desert Runner/sv",
            "King Cab S 4x2/king Cab Sv 4x2",
            "Standard",
            "Sv V6",
            "2wd Se",
            "Long Bed Sv 4x4",
            "Pro-4x/sv",
            "4wd Se",
            "Desert Runner/s/sv-i4",
            "Standard/xe",
            "2wd Sc Supercharger",
            "Xe King Cab",
            "Sve-V6",
            "Le/se/nismo",
            "Xe/se",
            "Se/le/off",
            "King Cab S 4x4/king Cab Sv 4x4",
            "Crew Cab Se/crew Cab Le",
            "Xe King Cab V6",
            "S/sv/pro-X/sl",
            "King Cab Sc",
            "Sv/sl",
            "Pro-4x Crew Cab V6",
            "Sv King Cab V6",
            "Se-I4/xe",
            "Sv/sl/platinum Reserve",
            "K",
            "Le/nismo Off Road/se",
            "Pro-4x/sv/sv V6",
            "4wd Xe Desert Runner",
            "Se Crew Cab V6",
            "Nismo Crew Cab V6",
            "Rt Wheelbase",
            "O",
            "4wd Sve",
            "Pro-X",
            "Sl Crew Cab V6",
            "Le/pro-4x/se",
            "C",
            "4wd Xe/se",
            "/",
            "Nner/s/sl/sv",
            "2wd Xe Desert Runner",
            "4wd",
            "S/sv/desert Runner/sl",
            "Sv/desert Runner",
            "4wd Sc",
            "4wd Sve Sc Sb",
            "2wd Se Desert Runner",
            "2wd Standard (m5)",
            "Le V6",
            "P",
            "Front Base",
            "S/sv/desert Runner",
            "Se/le",
            "S/sv V6/desert Runner/sl",
            "Crew Cab Se/crew Cab Le/c",
            "Sl/sv V6",
            "S/sv V6/pro-4x/sl",
            "Se/pro-4x/le",
            "Ro-4x/sl",
            "Nner",
            "4x/sl",
            "Ro-4x",
            "Pro-4x Crew Sl",
            "Rt Runner/sl",
            "Frnter Se/",
            "4x",
            "Esert Runner/sl",
            "-4x",
            "Nismo",
            "Se/crew Cab Le",
            "Rt Runner",
            " Runner",
            "Se/le/nismo",
            "Esert Runner",
            "X",
            "Xe/king Cab Se",
            "Crew Cab S/sl/sv",
            "Front Dese",
            "Frntr Xcab",
            "Frntier Se",
            "4wd Sc Supercharger",
            "E",
            "4 4",
            "/le",
            "Frntr Cap",
            "Le/se/n",
            "Crew 4x4",
            "2wd Standard (a4)",
            "4",
            "2wd Se W/leather",
            "Front 4x4",
            "G Cab",
            "/x",
            "S S",
            "Se/se-V6/xe-V6",
            "K K",
            "Sl 4x4",
            "D",
            "X2xe",
            "2wd Se-v6/xe-v6",
            "4x2 Cr",
            " Crew Cab Sv 4x4",
            "Se King Cab V6",
            "Le Crew Cab V6",
            "2wd Se/xe",
            "Sv Crew Cab V6",
            "Pro-4x King Cab V6",
            "King Cab Se/king Cab Le/k",
            "S Pickup Truck",
            "Pro-x 4x2/ S 4x2/ Sl 4x2/ Sv 4x2",
            "Le King Cab V6",
            "Hardbody Edition/pro-4x/sl",
            "King Cab Le/king Cab Se/k",
            "Hardbody Edition/sl/sv",
            "Midnight Edition/pro-4x/sl/sv",
            "Pro-4x 4x4/ S 4x4/ Sl 4x4/ Sv 4x4",
            "Midnight Edition/sl/sv",
            "O-4x",
            "2wd Xe-v6",
            "Pro-4x/s/sv",
            "2wd Se-v6/xe/xe-v6",
            "Sve-V6/xe-V6",
            "2wd Standard (m5)/xe",
            "Pro-4x/sl/sv"
          ]
        },
        {
          "model": "GT-R",
          "series": [
            "Premium",
            "Base",
            "Premium Dual-clutch 6-speed Transmission",
            "Track Edition",
            "Black Edition",
            "Nismo/premium/black Edition",
            "Nismo/premium/track Edition",
            "Premium/black",
            "Black Edition/nismo/premium/track Edition",
            "Premi",
            "Track",
            "T-r Premi",
            "Nismo",
            "Um",
            "T-r Pure",
            "T-r Base",
            "Pure",
            "Premium/nismo/track Ed",
            "T-Spe",
            "Pure/premium/track Editio",
            "Base Gt-r Base",
            "Premi Gt-r Premi",
            "Premium/t-spec/skyline Edition",
            "Black Edition/premium",
            "Black Edition/nismo/premium"
          ]
        },
        {
          "model": "Juke",
          "series": [
            "Sl",
            "S",
            "Sv",
            "Nismo Rs",
            "Nismo",
            "Nismo/s/sl/sv",
            "S/sv/sl/nismo",
            "Nismo/sl/s/sv",
            "S/sv/sl",
            "S/sv/",
            " S",
            "S/sl/sv",
            "Sl/sv/s/nismo",
            "Sl/sv/nismo/s",
            "Gs Sport",
            "S Fwd",
            "Sl Ma",
            "Sl/nismo",
            "/nismo/s",
            " Rs",
            "/s/nismo",
            "S Awd",
            "S/l",
            "Nismo/sl/sv",
            "Nismo/sv",
            "Nismo/nismo Rs",
            "Sl/sv"
          ]
        },
        {
          "model": "Kicks",
          "series": [
            "Sr",
            "Sv",
            "S",
            "Sv Xtronic Cvt",
            "S Xtronic Cvt",
            "Sr Xtronic Cvt",
            "S/sr/sv",
            "S/sv/sr",
            "S Fw",
            "S/sr",
            "V",
            "R",
            "Nic Cvt",
            "Onic Cvt",
            " 2.5i",
            "Sr Fwd",
            "S Fwd",
            "Sv Fwd",
            "Play Sv",
            "S Intelligent Awd",
            "Sv Intelligent Awd",
            "Sr Intelligent Awd",
            "Play S"
          ]
        },
        {
          "model": "Kicks e-Power",
          "series": []
        },
        {
          "model": "Leaf",
          "series": [
            "Sv",
            "Sv Plus 60 Kwh",
            "S",
            "Sl",
            "S 40 Kwh",
            "Sl Plus 62 Kwh",
            "Sl Plus",
            "Sv 40 Kwh",
            "S Plus 62 Kwh",
            "S/sv/sl",
            "Sv Plus",
            "S Plus",
            "Sv Plus 62 Kwh",
            "S/sl/sv",
            "Sv/sl",
            "S Plus/sl Plus/sv Plus",
            "Elect",
            "S Plus 62 Kwh/sl Plus 62 Kwh/sv Plus 62 Kwh",
            "Sl/sv",
            "S Plu",
            "Sl-E",
            "Sv Pl",
            "Sl Pl",
            "Us",
            "/sl-e/sv W",
            "S With Electric Charger",
            "Sl W/cold Weather Pkg",
            "S/sl Plus/sv Plus",
            "Electric",
            "24kw",
            "Cv1",
            "Sv/sv Plus",
            "S/sv/",
            "Ev 5d"
          ]
        },
        {
          "model": "March",
          "series": []
        },
        {
          "model": "Maxima",
          "series": [
            "3.5 Sl",
            "S",
            "Sv",
            "S/sv",
            "3.5s",
            "3.5 Sv",
            "3.5 S",
            "Sv Xtronic Cvt",
            "Gxe",
            "3.5 Sr",
            "3.5 Sv W/sport Pkg",
            "3.5 Platinum",
            "Sr Xtronic Cvt",
            "Gxe/gle/se",
            "3.5 Se",
            "Gle",
            "Se",
            "3.5 S/3.5 Sv",
            "3.5 Platinum/3.5 S/3.5 Sl/3.5 Sr/3.5 Sv",
            "Gle/gxe/se",
            "Gxe/se/gle/20th Anniversary",
            "Platinum Xtronic Cvt",
            "Sl",
            "Se/sl",
            "Sr",
            "3.5s/sv/sl/sr/plat",
            "Platinum",
            "Sl Xtronic Cvt",
            "Gle/gxe/se/se-L",
            "Gxe/se/gle/20th Anniv",
            "3.5 Sv W/premium Pkg",
            "S/sl/sr/sv/platinum",
            "Gle/se",
            "S Xtronic Cvt",
            "S/sv/sl/sr/platinum",
            "3.5 Se/3.5 Sl",
            "Sv/s/sl/sr/platinum",
            "3.5",
            "3.5 S W",
            "Nic Cvt",
            "3.5 S/3.5 Sv/3.5 Sv W/premium Pkg/3.5 Sv W/sport Pkg",
            "Platinum/s/sl/sr/sv",
            "S W",
            "Gt",
            "Pla",
            "W/sport Pkg",
            "Se/",
            "Tinum",
            "W/premium Pkg",
            "M",
            "/sl/sr/plat",
            "S/s",
            "/sr/platinum",
            "/sv/platinum",
            "Se 20th Anniv",
            "2.5 Sr",
            "3.5 S/sv",
            "Gxe/se/se 20th Anniv/gle",
            "Plat",
            "3.5s/3.5sv/3.5sl/3.5 Sr/3",
            "5sv/3.5sl/3.5 Sr/3",
            "3.5 Platinum/3.5 S",
            ".5 Sv",
            "Tinum/3.5 S",
            "M Xtronic Cvt",
            "3.5 S W/limited Edition Pkg",
            "3.5 3.5",
            "Gxe/se/gle",
            "3.5 Platinum/3.5 S/3.5 Sl/3.5 Sr/sv",
            "Gxe/se/gle/se-L",
            "Platinum/sl/sr/sv",
            "3.5 Platinum/3.5 S/3.5 Sl/3.5 Sr/3.5 Sv/s",
            "Maxium"
          ]
        },
        {
          "model": "Micra",
          "series": [
            "S/sv/sr",
            "Sv",
            "March",
            "S/sr/sv",
            "Sr",
            "S",
            "Ar"
          ]
        },
        {
          "model": "Murano",
          "series": [
            "Sl",
            "S",
            "Se",
            "Sv",
            "Sv Fwd",
            "Platinum",
            "S Fwd",
            "Sl Fwd",
            "Sv Intelligent Awd",
            "S Intelligent Awd",
            "Le",
            "Platinum/s/sv/sl",
            "Platinum/s/sl/sv",
            "Se/sl/s",
            "Crosscabriolet",
            "Sl Intelligent Awd",
            "Platinum Fwd",
            "Le/s/sl/sv",
            "S/sl/sv/platinum",
            "S/sl/le",
            "Platinum Intelligent Awd",
            "Hybrid Platinum",
            "Sl/se",
            "Pla",
            "Sl/se/s",
            "S/sl",
            "Sl Hev",
            "S/sl/sv/le",
            "S/sv/sl/platinum",
            "Cro",
            "Hybrid Sl",
            "Crosscabriolet Crosscabriolet",
            "Le/s/sl",
            "S/sv/sl/le",
            "S/s",
            "Ligent Awd",
            "/sv",
            "M",
            "Murrano",
            "S/sv/sl/plat",
            "Sl/",
            "Platinum Hev",
            "/le",
            "Briolet",
            "/platinum",
            "Sl/platinum/s/sv",
            "V/s",
            "S/m",
            "4d",
            "S/sl/se",
            "Le/sl/sv/s",
            "Lligent Awd",
            "M/s/sl/sv",
            "M Intelligent Awd",
            "Awd",
            "Sl/le/sv/s",
            "Uxe",
            "Se/",
            " Sv Sv",
            "S - Gray",
            "S/sl/sv/p",
            "Rcrew",
            "Le Le",
            "Midnight Edition/sl",
            "Limited Edition/platinum",
            "Platinum/sl/sv",
            "Midnight Edition/platinum/sl/sv",
            "Ex-L",
            "Plat",
            "S/sv",
            "Se/sl"
          ]
        },
        {
          "model": "Note",
          "series": [
            "5dsv"
          ]
        },
        {
          "model": "NP 300",
          "series": []
        },
        {
          "model": "NP 300 Frontier",
          "series": []
        },
        {
          "model": "NT 400 Cabstar",
          "series": []
        },
        {
          "model": "NV 1500",
          "series": [
            "Nv1500 S V6",
            "S/sv/2500 S/sv/sl",
            "S",
            "Nv1500 Sv V6",
            "S V6 Cargo Van",
            "S/1500 Sv",
            "1500"
          ]
        },
        {
          "model": "NV 200",
          "series": [
            "Sv",
            "2.5s",
            "S",
            "Compact Cargo S Xtronic Cvt",
            "2.5s/2.5sv",
            "S/sv",
            "Compact Cargo Sv Xtronic Cvt",
            "Taxi",
            "Sv Cargo Van",
            "Compact Cargo 2.5s/2.5sv",
            "Compact Cargo Sv",
            "Compact Cargo S/sv",
            "Compact Cargo",
            ".5s/2.5sv",
            "V",
            "Ompact Cargo Sv",
            "Ompact Cargo",
            "Axi Taxi",
            "Ompact Cargo S",
            "Ompact Cargo 2.5s/2.5sv",
            "Axi",
            "Ompact Cargo S/sv",
            "/sv",
            "Ompact Cargo Sv Xtronic Cvt",
            ".5s",
            "2.5",
            "5sv",
            "Ompact Cargo S Xtronic Cvt",
            "Crg",
            ".5s 200 2.5s",
            "Tax",
            "Cargo S",
            "Cargo S Xtronic Cvt",
            " Cargo Sv Xtronic Cvt",
            "S Xtronic Cvt",
            "Sv Xtronic Cvt",
            "Cargo Sv Xtronic Cvt",
            "Cargo S Xtronic Cvt/sv Xtronic Cvt",
            " Cargo S Xtronic Cvt/sv Xtronic Cvt",
            "S Cargo Van",
            " Cargo S Xtronic Cvt",
            "Sv Sv"
          ]
        },
        {
          "model": "NV 2500",
          "series": [
            "Nv2500 Hd S V6",
            "S",
            "Sv",
            "Nv2500 Hd Sv V8",
            "Nv2500 Hd Sv V6",
            "S V8 Cargo Van",
            "Nv2500 Hd S V8",
            "S/sv/2500 Sl/s/sv/sl",
            "S/2500 Sv",
            "2500",
            "Sv/3500 S/3500 Sv/3500 Sl",
            "1500/2500",
            "S/2500 Sv/2500 Sl",
            "S/s",
            "Hi",
            "2500/3500",
            "Sl",
            "S 2500 S",
            "Sv V6 Cargo Van",
            "Nv2500 Hd S V8/nv2500 Hd Sv V8/nv3500 Hd S V8/nv3500 Hd Sv V8"
          ]
        },
        {
          "model": "NV 350 Urvan",
          "series": []
        },
        {
          "model": "NV 3500",
          "series": [
            "S",
            "Nv3500 Hd S V8",
            "Nv3500 Hd Sv V6",
            "Nv3500 Hd Sv V8",
            "Nger Nv3500 Hd Sl",
            "D Sl",
            "Nger Nv3500 Hd S",
            "D S",
            "Nger Nv3500 Hd Sv",
            "D Sv",
            "Nv3500 Hd S V6/nv3500 Hd Sv V6",
            "Nv3500 Hd Sl V8"
          ]
        },
        {
          "model": "Pathfinder",
          "series": [
            "S",
            "Sl",
            "Le/se/xe",
            "Le",
            "Sl 2wd",
            "Sv 4wd",
            "Le/xe",
            "Platinum",
            "Se",
            "Sv 2wd",
            "Platinum 4wd",
            "Sv",
            "Le Platinum",
            "Silver",
            "Sl 4wd",
            "Hybrid Sv",
            "Platinum/sv/s/sl",
            "Le/xe/se",
            "S/sv/sl/platinum",
            "Le/se",
            "S/sv/sl/platnu",
            "S/le/se",
            "Platinum/s/sl/sv",
            "S 2wd",
            "Platinum Fwd",
            "S 4wd",
            "Sl Fwd",
            "S/sl/sv",
            "S Fe+",
            "Platinum 2wd",
            "S Fwd",
            "Rock Creek",
            "Silver/sv",
            "Armada Le",
            "Rock Creek 4wd",
            "Le V8",
            "Xe",
            "Sv Hybrid",
            "Hybrid Sl",
            "Hybrid Platinum",
            "S/sl/sv/platinum",
            "Xe/le",
            "Armada Se",
            "Le/s/silver/sv",
            "Se Off-road",
            "Armada",
            "Hybrid/sv/sl/platinum",
            "Sv Fwd",
            "Xe/se",
            "Armada Se Off-road",
            "S/sv Tech",
            "Se V8",
            "Se Off Road",
            "Le/se/se Off-road/xe",
            "Le/s/se/se Off-road",
            "Sl Suv",
            "Armada Le/se/se Off-road",
            "Armada Se/le",
            "Silver Edition",
            "D",
            "Sl/sv",
            "Hybrid Platinum/sl/sv",
            "S/sv/platinum/sl",
            "Hybrid Hybrid/sv/sl/platinum",
            "Sl Hybrid",
            "Platinum Hybrid",
            "Le/silver Edition/sv/s",
            "Path Le",
            "Platinum/sv/sl/s",
            "Tinum",
            "/sl/s",
            "Ion",
            "Um/sl",
            "L/platinum",
            "Path Finde",
            "Brid",
            "S/se/le",
            "S/se/se Off Road/le",
            "Path Sl",
            "Cv2",
            "4d 4x2",
            "Hybrid",
            "Sl 4wd Sl",
            "Sl/platinum/s/sv",
            "4d 4x4",
            "Le Platinum/se",
            "Le/s/se",
            "Le/s/sv",
            "Rock Creek/sv",
            "Ew Cab Xe",
            "Midnight Edition/platinum/s/sl Premium/sv Tech",
            "Platinum/s/sl Premium/sv Tech",
            "S/sl",
            "Sv Tech",
            "Sl Premium",
            "Xe/se/le",
            "Chinook"
          ]
        },
        {
          "model": "Pickup",
          "series": [
            "Journey"
          ]
        },
        {
          "model": "Platina",
          "series": []
        },
        {
          "model": "Qashqai",
          "series": [
            "Sv",
            "Sl",
            "/ Rogue Sport",
            "S/sv/sl",
            "S",
            "S 4dr2wd",
            "S/sv",
            "Ort S",
            "Ort Sv",
            "Aw",
            "Gray",
            "Green",
            "Sport S",
            "Qashqai",
            "S/sl/sv",
            "Sl/sv",
            " S 4dr2wd",
            "Sl Awd",
            "Sv 4d"
          ]
        },
        {
          "model": "Quest",
          "series": [
            "S",
            "Platinum/s/sl/sv",
            "Le",
            "3.5 Sl",
            "Sl",
            "S/sv/sl/platinum",
            "3.5",
            "3.5 Se",
            "Sv",
            "3.5 S",
            "Gxe/xe",
            "Xe",
            "S/sv/sl/le",
            "Le/s/sl/sv",
            "Gxe",
            "Gle",
            "Se/gle/gxe",
            "Gle/gxe/se-Cloth/se-Leather",
            "Gle/gxe/se",
            "S/se/sl",
            "Xe/gxe",
            "Se",
            "Sl/platinum/s/sv",
            "Platinum",
            "Xe/gxe/gle",
            "0 S",
            "Gle/gxe/se/se-Cloth",
            "Base",
            "Latinum/sl",
            "Sv/s/platinum/sl",
            "S/se",
            "Le/sl/sv/s",
            "L/le",
            "L",
            "S/sv",
            "L/platinum",
            "S Special Edition",
            "3.5s",
            "Van",
            "L/sv",
            "S Sv",
            "Quest",
            "3.5 Le",
            "3.5/3.5 S",
            "0"
          ]
        },
        {
          "model": "Rogue",
          "series": [
            "S",
            "Sport S",
            "Select S",
            "Sl",
            "Sv",
            "Sv Fwd",
            "Platinum Intelligent Awd",
            "Sv W/sl Pkg",
            "S/sl/sv",
            "S Fwd",
            "Sv Intelligent Awd",
            "Sl Intelligent Awd",
            "Sl Fwd",
            "Platinum Fwd",
            "S Intelligent Awd",
            "Sport Sv",
            "Platinum",
            "Sl/sv/s",
            "Sv Hybrid",
            "S/sv/sl",
            "S/sv/sv W/sl Pkg",
            "Spor",
            "S/sl",
            "S/sv",
            "S/sv/krom",
            "Sv/sl",
            "Hybrid Sv",
            "Sport Sl",
            "S Krom Edition",
            "S/sl/krom",
            "Hybrid Sl",
            "Sl/s/sv",
            "Hybrid Sl/sv",
            "Sv/s/sl",
            "S Intelligent Awd/sl Intelligent Awd/sv Intelligent Awd",
            "I",
            "S/sv/midnight Edition/sl",
            "Sele",
            "Hybrid Sv Hybrid/sl Hybrid",
            "S/sv/sl Platinum",
            "S/s Krom Edition/sv",
            "S 4d",
            "Midnight",
            "I White",
            "S/s Krom Edition/sl",
            "4d 2wd",
            "Sl Hybrid",
            "Sv/sl/s",
            "Sv H",
            "Lligent Awd",
            "Krom Edition",
            "S/sv/s Krom",
            "S Fwd/sl Fwd/sv Fwd",
            "S/sv/krom Edition",
            "Fwd",
            "Plat",
            "S Aw",
            "Rom",
            "L",
            "Rougue",
            "Rid",
            "Rock Creek/sv",
            " Edition",
            "Um",
            "Sv Hybrid/sl Hybrid",
            "V",
            "Rid/sl Hybrid",
            "Slct",
            "Dition",
            "Sv F",
            "Awd",
            "S/sl/s Krom Edition",
            "Slt",
            "Rouge",
            "Spt",
            "Sp",
            "Qashqai",
            "Hybr",
            "S Fw",
            "Um Intelligent Awd",
            "Elligent Awd",
            "2.5 S",
            "Sl A",
            "L Pkg",
            "Se",
            "Rock Creek",
            "Base",
            "4d 2",
            "S Sv",
            "Rogue",
            "Sl Platinum",
            "S Sv S Sv",
            "Sv/rc",
            "Spt S/sv/sl",
            "Hybrid",
            "I S",
            "Sport",
            "S/sl Premium/sv",
            "S/sl Platinum/sv",
            "Sv Midnight Edition/sv Moonroof",
            "Midnight Edition/s/sl/sl W/propilot Assist/sv",
            "Sv Moonroof",
            " S - Gray",
            "S Suv",
            "Rock Creek/sv Intelligent Awd",
            "Ile Other",
            "2.5",
            "I Sv",
            "Parts Only",
            "60th Anniversary Edition/sv Moonroof",
            "2.5 Rogue"
          ]
        },
        {
          "model": "Rogue Select",
          "series": [
            "S",
            "S/sl/sv"
          ]
        },
        {
          "model": "Rogue Sport",
          "series": [
            "Sv",
            "S",
            "Sl",
            "S Fwd Xtronic Cvt",
            "Sv Fwd Xtronic Cvt",
            "S Awd Xtronic Cvt",
            "Sl Fwd Xtronic Cvt",
            "Sv Awd Xtronic Cvt",
            "S/sv/sl",
            "Sl Awd Xtronic Cvt",
            "S/sl/sv",
            "C Cvt",
            "Por",
            "Sl/s/sv",
            "0 Wagon",
            "Fw",
            "T",
            "E",
            "Ic Cvt",
            "Sl Awd 2 Sl",
            "Aw",
            "S Fwd S Fwd Xtronic Cvt"
          ]
        },
        {
          "model": "Sentra",
          "series": [
            "S",
            "Xe",
            "2.0",
            "Sv",
            "Sv/s/sr/sl",
            "Sv Xtronic Cvt",
            "Sr Xtronic Cvt",
            "S Xtronic Cvt",
            "Sr",
            "2.0 Sl",
            "2.0s",
            "Nismo",
            "2.0 Sr",
            "2.0sr",
            "Se",
            "1.8s",
            "Fe+ S/fe+ Sv/s/sl/sr/sv",
            "Fe+ S/s/sl/sr/sv",
            "2.0 S",
            "S/sl/sr/sv",
            "Fe+ S",
            "Sl",
            "S/sv/sr/sl",
            "Xe/gxe",
            "1.8",
            "2.0sl",
            "Gxe",
            "Fe+ S/s/sv/sr/sl",
            "Fe+ S/fe+ Sv/sv/s/sr/sl",
            "Se-R",
            "Fe+ S/sv/s/sr/sl",
            "Sr Turbo",
            "1.8/1.8s",
            "2.0/2.0s/sr/2.0sl",
            "Gxe/xe",
            "Base",
            "E/xe/gxe/gle",
            "2.0/2.0s/2.0sl",
            "Gle/gxe/xe",
            "E/xe/se/le",
            "1.8 Sv",
            "Se-r Limited",
            "Fe+ Sv",
            "Sr Turbo/nismo",
            "2.0 Sl Fe+",
            "Fe+ S/fe+ Sv/s/sv/sr/sl",
            "2.5",
            "E",
            "Se-r Spec V",
            "Gle",
            "Fe+",
            "2.5s",
            "E/xe/se",
            "Se/se-L",
            "E/xe",
            "2.0 Sr Fe",
            "1.8 Sr",
            "2.0 Sv",
            "1.8 S",
            "S/fe/sl/sr/sv",
            "2.0 S Fe+",
            "Xe/gxe/gle",
            "2.0 S Fe",
            "E/xe/gxe/le",
            "S/sv/sl",
            "2.0/2.0s/2.0sl/2.0sr",
            "Sahara",
            "S/fe+ S/sv/fe+ Sv/sr/sl",
            "4d",
            "Nismo/sr Turbo",
            "2.0/2.0 S/2.0 Sl/2.0 Sr",
            "Sr/sl/s/sv/fe+ S",
            "1.8 Sl",
            "Ic Cvt",
            "Sr/sl/s/sv",
            "S/s",
            "Se-",
            "Gxe Sntrxe/gxe",
            "Classic",
            "B",
            "Gxe Limited Edition",
            "S/sv/pro-4x",
            "2.0 Sr Fe+",
            "S/sv/fe+ S/fe+ Sv/sr/sl",
            "Sr Turbo/nis",
            "Xl/xlt",
            "Sentra",
            "2.5 S",
            "/sv/fe+ S",
            "/s/s",
            "Cd",
            "O",
            "/sv/fe+ Sv/sr/sl",
            "/sv",
            "1.8 S/sv/sr/sl",
            "/sl",
            "S/sr/2.0sl",
            "S/2.0sl",
            "2.0 Fe+",
            "+ S/fe+ Sv/sr/sl",
            "O/nismo",
            "E+",
            "Bas",
            "Ec V",
            "Aut",
            "Sr/sl/s/sv/fe  S",
            "/sv/fe  S",
            "S/sv/fe  S/fe  Sv/sr/sl",
            "Lt",
            "S/fe  S/sv/fe  Sv/sr/sl",
            "Nis",
            "2.0 Fe",
            "Limited Edition",
            "Xe/",
            "4d 1.8 S/sv/sr/sl",
            "  S/fe  Sv/sr/sl",
            "S W",
            "F",
            "1.8 S/sv/sr/sl/fe+",
            "Aut Aut",
            "Man",
            "Ca",
            "4d 4d",
            "Ls",
            "-4 C",
            "S M",
            "Fe  Sv",
            "/sv/fe  Sv/sr/sl",
            "S/sv/sr/s",
            "/sl/sr/sv",
            "E+ Sv/s/sl/sr/sv",
            "Fe  S",
            "Fe",
            "S A",
            "Nic Cvt",
            "4wd",
            "Sntrxe/gxe",
            "S A S A",
            "Er 2.5",
            "E/xe/gxe",
            "Sl W/continuo 2.0 Sl",
            "Sl Sl",
            "Sv Sv",
            "S W S W",
            "3.5s",
            "Centra",
            "Lx",
            "2.5l Se",
            "1.8 S/1.8 Sl/1.8 Sr/1.8 Sv",
            "Se- Se-",
            "Sed Se",
            "1.8 S/1.8 Sv/1.8 Sv Midnight Edition",
            "1.8 S/1.8 Sv",
            "S/s Plus",
            "Sr/sr Midnight Edition",
            "S/sv",
            "1.8 S/1.8 Sl/1.8 Sv",
            "Ex",
            "1.8/1.8 Special Edition Package/1.8s",
            "1.6 Sr Turbo/nismo",
            "Ote S",
            "S/sr/sl",
            "Sv Fwd",
            "Le",
            "1.8 Special Edition",
            "Sel",
            "1.8 (50 State) Ulev (a4)"
          ]
        },
        {
          "model": "Tiida",
          "series": []
        },
        {
          "model": "Titan",
          "series": [
            "Xe",
            "Platinum Reserve",
            "Platinum Reserve 4x4",
            "Pro-4x/s/sl/sv",
            "S",
            "Sv",
            "Sl",
            "Se",
            "Pro-4x",
            "Le",
            "Pro-4x 4x4",
            "Sv 4x4",
            "Xd S",
            "Xd Sl",
            "King Cab Se",
            "Le/se/xe",
            "Sv 4x2",
            "S/sv/sl/pro-4x",
            "Xe/se/le",
            "Xd Sv",
            "King Cab",
            "5.6 Le Crew Cab",
            "Le/pro-4x/se/xe",
            "King Cab Xe",
            "S 4x4",
            "Xe/se/le/pro-4x",
            "Sv/sl/platinum Reserve",
            "Sv/sl/pro-4x/platinum Reserve",
            "Sv/sl/pro-4x/platinum Res",
            "S/sv",
            "Sv/sl/pro-4x/plat Res",
            "Platinum Reserve/pro-4x/s/sl/sv",
            "Le/xe/se",
            "Pro-4x/s/sv",
            "S 4x2",
            "Sv/platinum/pro-4x/platinum Reserve",
            "Crew Cab Sv 4x4",
            "Sv/platinum/pro-4x/platin",
            "Pro-4x/platinum Reserve",
            "Sl 4x4",
            "Pro-4x/se",
            "Platinum Reserve 4x2",
            "S/sv/pro-4x",
            "5.6 Sv Crew Cab",
            "King Cab S 4x2",
            "5.6 Se King Cab",
            "Platinum Reserve/sl",
            "Xd S 4x4",
            "Se/xe",
            "King Cab S 4x4",
            "Le/se",
            "Sv/platinum Reserve",
            "Xd Platinum Reserve",
            "Plat",
            "2008.5 Se",
            "/s/sl/sv",
            "(2008.5) Se",
            "Xe/se/pro-4x/le",
            "King Cab Sv 4x4",
            "S/sl/sv",
            "Xe/se/pro-4x",
            "S/sv/sl",
            "Sl/pro-4x/sv/s",
            "S/pro-4x",
            "S/sv/sl/platinum Reserve",
            "Sv Pro4x",
            "S/sv/pro-4x/sl",
            "Crew",
            "Um Reserve",
            "Ro-4x/sl",
            "Ro-4x",
            "L/pro-4x",
            "Le/pro-4x",
            "Pro-4x/platinum Res",
            "Pro-4x/plat Res",
            "Um Reserve/sl",
            "Xe/s",
            "Pro-4x/le",
            "Pro-",
            "S W/premium Pkg",
            "Le C",
            "Sv/s",
            "Tinum/pro-4x/platin",
            "Le/xe/se/pro-4x",
            "Xe/s Xe/s",
            "Sv/platinum/pro-4x",
            "Platinum Reserve/s/sv/pro-4x/sl",
            "Sv/sl/pro-4x",
            "Le/pro-4x/se",
            "Sv/pro-4x",
            "Pro-4x/xe",
            "Xd",
            "Le Le",
            "Pro4",
            "5.6 S Crew Cab",
            "5.6 Xe Crew Cab",
            "Xe Xe",
            "5.6 Pro-4x Crew Cab",
            "5.6 Se Crew Cab",
            "5.6 Sv King Cab",
            "Le/xe",
            "Pro-4x/sv",
            "King Cab Pro-4x 4x4",
            "Sl C Sl",
            "Platinum Reserve/pro-4x/s/sv",
            "King",
            "Platinum/pro-4x/s/sl Midnight Edition/sv/sv Midnight Edition",
            "King Cab Sv 4x2",
            "5.6 Sl Crew Cab"
          ]
        },
        {
          "model": "Titan XD",
          "series": [
            "Pro-4x Diesel",
            "Platinum Reserve Diesel",
            "S",
            "Sv Diesel",
            "S Gas",
            "Sl Diesel",
            "Sl Gas",
            "Sv",
            "Sl",
            "Platinum Reserve",
            "Pro-4x Gas",
            "Sv Gas",
            "Platinum Reserve Diesel/pro-4x Diesel/s Diesel/sl Diesel/sv Diesel",
            "S Diesel",
            "Platinum Reserve Gas/pro-4x Gas/s Gas/sl Gas/sv Gas",
            "Sl Diesel/platinum Reserve Diesel/sv Diesel/pro-4x Diesel/s Diesel",
            "S/sv/pro-4x/sl/platinum Reserve",
            "Sl/pro-4x/plat Reserve",
            "Sl/pro-4x/platinum Reserv",
            "S/sv",
            "Platinum Reserve Diesel/s Diesel/sl Diesel/sv Diesel",
            "Sl/pro-4x/platinum Reserve",
            "Sv/sl/pro-4x/platinum Reserve",
            "Sv 4x4",
            "Sl/pro-4x/plat Res/sv",
            "Platinum Reserve Gas",
            "S 4x4",
            "Sv/pro-4x/platinum Reserve",
            "Platinum Reserve Gas/s Gas/sv Gas",
            "Pro-4x 4x4",
            "Sv/sl/pro-4x/platinum Res",
            "Platinum Reserve/pro-4x/s/sl/sv",
            "Platinum Reserve Diesel/pro-4x Diesel/s Diesel/sl Diese",
            "Pro-4x",
            "S/sv/pro-4x/sl",
            "S/sv/sl/platinum Reserve",
            "Reserve",
            "/plat Reserve",
            "Sl/platinum Reserve",
            "/platinum Reserv",
            "/plat Res/sv",
            "Sl/platinum Reserve/sv",
            "Platinum",
            "Sv/pro-4x",
            "4x/sl",
            "Um Reserve",
            "Latinum Reserve",
            "Um Reserve/sv",
            "-4x/platinum Res",
            "Reserve Diesel",
            "Platinum Reserve 4x4",
            "Sv/pro-4x/platinum Reserv",
            "Sv Crew Cab",
            "Platinum Reserve Diesel/pro-4x Diesel/s Diesel/sv Diesel",
            "Sl 4x4"
          ]
        },
        {
          "model": "Tsuru",
          "series": []
        },
        {
          "model": "Urvan",
          "series": []
        },
        {
          "model": "V-Drive",
          "series": []
        },
        {
          "model": "Versa",
          "series": [
            "1.6 Sv Xtronic Cvt",
            "1.6 Sv",
            "S",
            "S Xtronic Cvt",
            "1.8sl",
            "1.6 S+",
            "1.8s",
            "1.6 Sl",
            "1.6",
            "1.6 S/1.6 S+/1.6 Sl/1.6 Sv",
            "1.8 S",
            "Sv Xtronic Cvt",
            "Sr Xtronic Cvt",
            "Note S",
            "1.6 S",
            "Sv",
            "S/sl",
            "Sl",
            "Sedan S Plus",
            "S/s Plus/sv/sl",
            "Sr",
            "1.6 S Xtronic Cvt",
            "1.6 Sr Xtronic Cvt",
            "S/sv/sl",
            "S/s Plus/sl/sv",
            "S 5-speed Manual Transmission",
            "1.6 Sr",
            "1.8 Sl",
            "Sedan Sv",
            "S/s Plus/sv",
            "Sedan",
            "1.6 S/1.6 S+/1.6 Sv",
            "Sedan S/s Plus/sl/sv",
            "Note Sv",
            "1.6 Base",
            "Sedan S/s Plus/sv",
            "Note Sl",
            "1.8s/1.8sl",
            "S W/",
            "Sedan S/s Plus/sv/sl",
            "1.8 S/1.8 Sl",
            "4d",
            "1.6 S/1.6 Sl/1.6 Sv",
            "1.6 S/1.6 S+/1.6 Sl",
            "S Plus",
            " S",
            "1.8 S/1.8s/1.8sl",
            "Sedan Sr",
            "Note",
            "Sedan S",
            "Base",
            "1.6 S+/1.6 Sl",
            "Nic Cvt",
            "Sedan Sl",
            "Sv W",
            "Seda",
            "4 Cyl.",
            "S Au",
            "S S",
            "S/s",
            "S/sv",
            "2.5 Sl",
            "1.8",
            "S/sv/sl/s Plus",
            "1.8 Sl Fe+",
            "Us/sv/sl",
            " 2.0",
            "Plus",
            "Us/sl/sv",
            "Us/sv",
            "L",
            " Fe+",
            "Auto",
            "Se",
            "E Pls/prm/s/s Pls",
            "No S",
            "1.6 S/+/sv/sl",
            "Base/s/sv/",
            "S 5-speed Manual",
            " Xtronic Cvt",
            "Sl W",
            "Onic Cvt",
            "Eed Manual",
            "S Plus/s/sv/sl",
            "Xtronic Cvt",
            "1.6 S+/1.6 Sl/1.6 Sv",
            "S/s S/s",
            "4d 4d",
            "Hatc",
            "Sl W Sl W",
            "M50i",
            "Sel"
          ]
        },
        {
          "model": "Versa Note",
          "series": [
            "Sv",
            "S Plus",
            "S Plus/sv/sr/s (sr)/sl",
            "Sr",
            "S Plus/sv/s (sr)",
            "S",
            "Sl",
            "S (sr)/s Plus/sl/sr/sv",
            "S (sr)",
            "S/sv/sl/sr",
            "S/s Plus/sv/sl/sr",
            "S/s Plus/sv/sl",
            "S/sv/sl",
            "S (sr)/s Plus/sv",
            "S/sr/sv",
            "S/s Plus/sv",
            "S Sr/s Plus/sl/sr/sv",
            "S W/conti",
            "S/sv/sr/sl",
            "S/s Plus/sv/sr/sl",
            "S/s Plus/sl/sr/sv",
            "/sr/sl",
            "/sl/sr",
            "/sl",
            "S Sr",
            "Us/sl/sr/sv",
            "/sl/sr/sv",
            "Note",
            "1.6 S/1.6 Sr/1.6 Sv",
            "1.6 S/1.6 Sl/1.6 Sv",
            "1.6 S/1.6 Sl/1.6 Sr/1.6 Sv",
            "S/sv",
            "S/spl"
          ]
        },
        {
          "model": "X-Trail",
          "series": [
            "Xe",
            "Xe/se",
            "Bonavista Edition",
            "Le",
            "Se",
            "E",
            "Xe/se/le",
            "Le/se/xe",
            "Se/xe"
          ]
        },
        {
          "model": "Xterra",
          "series": [
            "S",
            "Off Road",
            "Pro-4x",
            "X",
            "Xe",
            "Se",
            "Xe I4",
            "Off Road/s/se",
            "Xe-V6",
            "Se S/c",
            "Xe/se",
            "Pro-4x/s/x",
            "Se/xe",
            "X/s/pro-4x",
            "Se/sc",
            "4.0",
            "S/x",
            "Xe Sc",
            "Xe S/c W/vss",
            "Off Road/s/se/x",
            "Xe S/c",
            "S/se/x",
            "Se/xe-V6",
            "S A",
            "Off",
            "Exter 4x4",
            "X/s",
            "S/pro-4x/x",
            "4x4",
            "D/s/se",
            "Se Sc",
            "D",
            "-4x",
            "X/s/off Road/se",
            "Xe/",
            "4d",
            "E",
            " E",
            "Se Se",
            "Off Road/se/s",
            "Ing Cab Se",
            "Pro-4x/s",
            "S/se"
          ]
        },
        {
          "model": "Z",
          "series": [
            "Roadster",
            "Touring",
            "Track",
            "Coupe",
            "Enthusiast",
            "Performance Manual",
            "Performance Auto",
            "Sport",
            "Anniversary Edition",
            "Performance",
            "Sport Auto",
            "Grand Touring",
            "Nismo",
            "Nismo Auto",
            "Performance/proto Spec",
            "Enthusiast/performance/touring/track",
            "Proto Spec Auto",
            "0z Roadster",
            "0z",
            "0z Base (m6)",
            "0z Conv",
            "Sport Manual",
            "Performa",
            "0z Anniversary Edition",
            "0z Touring",
            "0z Track",
            "0z Coupe",
            "0z Enthusiast",
            "0z Roads",
            "0z Performance",
            "0z Nismo",
            "0z 35th Anniv. Edition",
            "0z Grand Touring",
            "Rformance",
            "A S",
            "S",
            "Evolve+",
            "Roads"
          ]
        }
      ]
    },
    {
      "make": "Porsche",
      "models": [
        {
          "model": "911",
          "series": [
            "Carrera/carrera 4",
            "Targa S",
            "Carrera",
            "Gt3",
            "Turbo",
            "Carrera 4s",
            "Carrera 4 Gts/carrera 4s/carrera Gts/carrera S",
            "Carrera S",
            "Carrera 2",
            "Targa",
            "Carrera/carrera 4/carrera Tiptronic",
            "Targa 4s",
            "Carrer",
            "New Generation Carrera",
            "Turbo Cabriolet",
            "Carrera 4s/carrera S",
            "Carrera S Cabriolet",
            "New Generation Carrera Cabriolet",
            "New Generation Carrera S",
            "Carrera/carrera 4s/carrera S",
            "Carrera Turbo (m6)",
            "Turbo S",
            "Carrera 4 Gts Cabriolet/carrera 4s Cabriolet/carrera Gts Cabriolet/carrera S Cabriolet",
            "Gt3 Rs",
            "Carrera/carrera 4/carrera T",
            "Carrera S Cabriolet/4s",
            "Carrera/carrera 40th Anniversary/carrera 4s",
            "Carrera S/carrera 4s/carr",
            "Carrera 2/carrera 4",
            "Turbo/turbo S",
            "Gt2 Rs",
            "Carrera 4s /carrera S",
            "Gt3 Rs/r",
            "Carrera 4 Gts/carrera 4s/carrera Gts/carrera S/dakar",
            "Carrera Turbo (m6)/s",
            "Carrera 4s/turbo",
            "Sc",
            "Targa 4 Gts",
            "Carrera Cabriolet",
            "Speedster",
            "Turbo Cabriolet/turbo S Cabriolet",
            "Black Edition",
            "Edition 50 Years Porsche Design/targa 4 Gts/targa 4s",
            "Carrera T",
            "Carrera 2/carrera 4s",
            "Carrera Carrera (m6)/carrera 4 (m6)",
            "R",
            "Carrera/carrera 4/carrera 4s",
            "Carrera 2 Black",
            "Targa 4 Gts/targa 4s",
            "Che",
            "Carrera 4 Gts Cabriolet/carrera 4s Cabriolet/carrera Gts Cabriolet/carrera S Cabrio",
            "Carrera S/carrera 4s/carrera Gts/carrera 4 Gts",
            "S",
            "Carrera 2 Cabriolet",
            "Carrera/carrera 4s",
            "Targa 4s/targa 4s Heritage Design Edition",
            "Carrera S/carrera 4s",
            "Gt3/gt3 Touring",
            "New Ge",
            "T",
            "Carrera S/carrera 4s/carrera Gts",
            "A",
            "Carrera/carrera 4/carrera 4 (m6)",
            "Targa 4",
            "Carrera 4s Cabriolet/carrera S Cabriolet",
            "Gt3/gt3 W/touring Package",
            "Carrera 4 Cabriolet/carrera Cabriolet",
            "Carrera 4 Gts",
            "Carrera Gts",
            "Carrera 997",
            "Gt2/turbo",
            "Edition 50 Years Porsche Design",
            "Porsche",
            "Car2/r",
            "Carrera /carrera 4",
            "Carrera S 997",
            "4",
            "Gt2",
            "Gt3/gt3 Rs",
            "Cs",
            "Carrera 4",
            "Turbo/s Turbo",
            "4 Gts",
            "Carrera S/turbo (m6)",
            "Turbo/turbo S/gt2 Rs",
            "4s",
            "991 Carrera",
            "997 Carrera",
            "Carrera S/4s/gts/spdster",
            "Carrera Targa",
            "4s/4 Gts",
            "991 Carrera S",
            "997 Carrera S",
            "S Turbo",
            "Carrera/4/4s",
            "Carrera S/carrera 4s/gts",
            "Carrera Carrera (m6)/s",
            "Targa 4 Gts/targa 4s/edition 50 Years Porsche Design",
            "9tb",
            "Speeds",
            "Turbo/turbo S/turbo S Exc",
            "Turbo/gt2",
            "Targa S/targa S Gts",
            "Targa 4s/targa 4 Gts/targ",
            "Carrera/carrera 4/carrera",
            "Carrera 4 Gts Cabriolet/carrera 4s Cabriolet/carrera Gt",
            "Turbo Gt2/turbo",
            "Sport",
            "Turbo /turbo S",
            "Targa 4s/targa 4 Gts",
            "Carrera/carrera 4s/carrera Tiptronic/s",
            "Gt3 Rs/s/t",
            "Targa Targa",
            "S/4s/4 Gts/gts",
            "Carrer Carrer",
            "Turbo Turbo",
            "Targa S/targa Gts",
            "Carrera 4 /carrera",
            "Gt3/rs",
            "N S",
            "Carrera 4 /carrera 4 Gts /carrera 4s/carrera Gts /carrera S",
            "O",
            "Carrera/carrera T",
            "Carrera Targa/carrera Targa Tiptronic",
            "Carrera 2/4s/s",
            "Turbo/turbo 50 Years/turbo S",
            "Carrera 4 Gts /carrera 4s /carrera Gts /carrera S",
            "Carrera 2/2 Rs Am/4 Turbo",
            "Carrera S - Awd",
            "Carrera Carrera/carrera 4",
            "Carrera 4 /carrera 4 Gts /carrera 4s/carrera Gts /carre",
            "Carrera/carrera (a5)/carrera 4",
            "Carrera /carrera T",
            "Carrera 4 Gts/carrera Gts"
          ]
        },
        {
          "model": "718 Boxster",
          "series": [
            "T",
            "S",
            "Gts",
            "Style Edition",
            "S/gts",
            "Gts/s",
            "25 Years/gts 4.0",
            "Base (m6)",
            "Gts 4.0",
            "Gts 4.0/25 Years"
          ]
        },
        {
          "model": "718 Cayman",
          "series": [
            "Gts",
            "S",
            "T",
            "Gt4 Rs",
            "Style Edition",
            "Gt4",
            "S/gts",
            "Gts 4.0"
          ]
        },
        {
          "model": "718 Spyder",
          "series": [
            "Rs"
          ]
        },
        {
          "model": "918 Spyder",
          "series": []
        },
        {
          "model": "Boxster",
          "series": [
            "Base (m5)",
            "S",
            "Base",
            "Spyder",
            "Limited Edition",
            "S Black",
            "Gts",
            "Sp",
            "Black Edition",
            "Spyder Rs",
            "Gts/s",
            "S/s Se",
            "T",
            "S/s Special Edition",
            "S/spyder/s Black Edition",
            "S/spyder",
            "S/s",
            "S/s Limited Edition",
            "S Black/r",
            "Gt",
            "S/gts",
            "Gts 4.0/25 Years",
            "Ba",
            "Gts/25th Anniversary Edit",
            "Base (m6)",
            "Gts 4.0",
            "Rs 60 Spyder/s/s Design Edition 2/s Limited Edition",
            "Limited V8"
          ]
        },
        {
          "model": "Cayenne",
          "series": [
            "E-Hybrid",
            "S",
            "Coupe",
            "Platinum Edition",
            "Gts",
            "Turbo",
            "Diesel/diesel Platinum Edition",
            "S Hybrid",
            "Turbo Gt",
            "Hybrid S",
            "Diesel",
            "E-hybrid Coupe Platinum Edition",
            "Se Hybrid",
            "Base",
            "Gt",
            "Se Hybrid Platinum",
            "Turbo S E Hybrid Coupe",
            "V6",
            "E Hybrid Coupe",
            "Turbo S",
            "Gts Coupe",
            "Diesel Platinum Edition",
            "E-hybrid Se Hybrid/platinum",
            "E-hybrid Se Hybrid",
            "E-hybrid S",
            "E-hybrid S Platinum Edition",
            "S/s Titanium Edition",
            "Turbo/turbo S",
            "S Titanium Edition/s",
            "Coupe Platinum Edition",
            "S Coupe",
            "Se Hybrid/platinum",
            "Coupe Turbo Gt",
            "E-hybrid Coupe Turbo S",
            "Turbo Coupe",
            "E-hybrid Coupe E Hybrid Coupe",
            "E-hybrid Coupe",
            "S/s Platinum Edition",
            "Coupe S",
            "Coupe Turbo",
            "E-hybrid Platinum Edition",
            "Turbo Gt Coupe",
            "Coupe Gts",
            "Turbo S E-hybrid",
            "Coupe/coupe Platinum Edit",
            "E-hybrid Coupe Turbo S E Hybrid Coupe",
            "E-hybrid S/s Platinum Edition",
            "Se",
            "S Platinum Edition",
            "E",
            "E-",
            "E-hybrid Turbo S",
            "S Platinum Edition/s",
            "Tu",
            "S E-hybrid",
            "Base Tiptronic",
            "Ba",
            "Gts/s Transsyberia",
            "S E-hybrid Platinum",
            "Co",
            "Coupe/coupe Platinum Edition",
            "Aw",
            "Hybrid S Hybrid",
            "Base (m6)/platinum Edition",
            "Co Co",
            "Coupe S/s Platinum Edition",
            "S S",
            "Tu Tu",
            "Gt Gt",
            "Turbo E-hybrid",
            "Base (tiptronic)",
            "Turbo E-hybrid Coupe",
            "E E",
            "Coupe Coupe"
          ]
        },
        {
          "model": "Cayman",
          "series": [
            "S",
            "Base",
            "R",
            "Gts",
            "Gt4 Rs",
            "Gt4",
            "Black Edition",
            "T",
            "Style Edition",
            "Gts/s",
            "Bas",
            "S/s Black Edition/r",
            "S/gts",
            "Bas Bas",
            "Gt4 Gt4",
            " S",
            "S Porsche Design Edition 1",
            "S S"
          ]
        },
        {
          "model": "Macan",
          "series": [
            "S",
            "Sport Edition",
            "Base",
            "Gts",
            "Turbo",
            "T",
            "Turbo W/performance Package",
            "Turbo/turbo W/performance Package",
            "S Aw",
            "Turb",
            "T/base (pdk)",
            "Base (pdk)",
            "Base Pdk",
            "Awd",
            "S S",
            "Turb Turb",
            "Gts Gts",
            "Electric Turbo",
            "Base (pdk)/t",
            "Electric 4",
            "4",
            "4s"
          ]
        },
        {
          "model": "Panamera",
          "series": [
            "4",
            "2",
            "Gts",
            "S",
            "Base",
            "Turbo",
            "4/4 Platinum Edition/platinum Edition",
            "4s",
            "4s/s",
            "S Hybrid",
            "4 E-hybrid",
            "2/4",
            "4s Sport Turismo",
            "Turbo/turbo S",
            "4 Sport Turismo E-hybrid",
            "Turbo Sport Turismo",
            "Se Hybrid",
            "E-hybrid 4 E-hybrid",
            "S/4",
            "Turbo Executive",
            "E-hybrid 4",
            "Turbo S",
            "E-hybrid S",
            "E-hybrid Se Hybrid",
            "Sport Turismo Gts",
            "Hybrid S Hybrid",
            "4s Executive",
            "Hybrid S",
            "4 Sport Turismo",
            "2/4/4 Edition/edition",
            "S/4s",
            "Sport Turismo 4",
            "T",
            "Gts Sport Turismo",
            "Turbo S E-hybrid Sport Turismo",
            "Exclusive",
            "Turbo S E-hybrid",
            "Platinum Edition/4/4 Plat",
            "G",
            "5",
            "4 Executive",
            "S E-hybrid",
            "Turbo/turbo 4",
            "E-hybrid Sport Turismo Turbo S",
            "Platinum Edition/4/4 Platinum Edition",
            "E-hybrid Turbo S",
            "Sport Turismo Turbo",
            "B",
            "4s E-hybrid Executive",
            "4s E-hybrid",
            "E-hybrid 4s",
            "Platinum Edition",
            "4 Edition",
            "4s Executi",
            "Platinum Edition/2/4/4 Platinum Edition",
            "/4",
            "4 4",
            "Edition",
            "10 Years Edition",
            "E-hybrid 4/4 Platinum Edition",
            "4s E-hybrid Sport Turismo",
            "E",
            "E-hybrid S Hybrid",
            "2 2",
            "S S",
            "Turbo S Executive",
            "2/4/4 Platinum Edition/platinum Edition",
            "10 Years Edition/4/4 10 Years Edition",
            "Turbo - All Wheel Drive",
            "R G",
            "Turbo S E-hybrid Executive",
            "Sport Turismo 4s",
            "E-hybrid Sport Turismo 4",
            "E-hybrid 4/4 10 Years Edition"
          ]
        },
        {
          "model": "Taycan",
          "series": [
            "4s",
            "Turbo/turbo S",
            "Gts",
            "Cross Turismo 4",
            "Turbo",
            "Cross Turismo",
            "Cross Turismo Turbo/turbo S",
            "Cross Turismo 4s",
            "Gts Sport Turismo",
            "Cro",
            "Cross Turismo Turbo",
            "Tur",
            "4",
            "Cross Turismo Cross Turismo 4",
            "Turbo S",
            "Turbo Gt",
            "Sport Turismo Gts",
            "Cross Turismo Cross Turismo Turbo/cross"
          ]
        }
      ]
    },
    {
      "make": "Ram",
      "models": [
        {
          "model": "700",
          "series": []
        },
        {
          "model": "1500",
          "series": [
            "St",
            "Sport",
            "Big Horn/lone Star",
            "Rebel",
            "Laramie",
            "Big Horn 4x2 5'7\" Box",
            "Laramie 4x4 5'7\" Box",
            "Big Horn 4x4 5'7\" Box",
            "Lone Star Quad Cab 4x2 6'4 Box",
            "Lone Star",
            "Classic Slt",
            "Slt",
            "Lone Star 4x2 5'7 Box",
            "Big Horn 4x2 5'7 Box",
            "Big Horn 4x4 5'7 Box",
            "Lone Star 4x4 5'7 Box",
            "Big Horn",
            "Slt Quad Cab 4x4 6'4 Box",
            "Big Horn Quad Cab 4x2 6'4 Box",
            "Classic Tradesman",
            "Express",
            "Slt Quad Cab 4x2 6'4 Box",
            "Limited",
            "Big Horn/lone Star 4x4 5'7 Box",
            "Big Horn Quad Cab 4x4 6'4 Box",
            "Big Horn Regular Cab 4x2 6'4 Box",
            "Laramie 4x4 5'7 Box",
            "Trx",
            "Tradesman/express",
            "Big Horn 4x4 6'4 Box",
            "Lone Star Quad Cab 4x4 6'4 Box",
            "Express Quad Cab 4x4 6'4 Box",
            "Tradesman 4x4 5'7 Box",
            "Trx 4x4 5'7 Box",
            "Tradesman",
            "Outdoorsman",
            "Big Horn/lone Star 4x2 5'7 Box",
            "Tradesman Quad Cab 4x2 6'4 Box",
            "Express Regular Cab 4x2 6'4 Box",
            "Limited 4x4 5'7 Box",
            "Express 4x4 5'7 Box",
            "Express Quad Cab 4x2 6'4 Box",
            "Big Horn/lone Star 4x4 5'7\" Box",
            "Tradesman 4x4 5'7\" Box",
            "Longhorn",
            "Express 4x2 6'4 Box",
            "Big Horn 4x4 6'4\" Box",
            "Express 4x4 6'4\" Box",
            "Rebel 4x4 5'7 Box",
            "Longhorn 4x2 5'7 Box",
            "Classic Ssv",
            "Longhorn 4x4 6'4 Box",
            "Class",
            "Night 4x4 5'7 Box",
            "Big Horn 4x2 6'4\" Box",
            "Laramie 4x2 5'7\" Box",
            "Big Horn/lone Star Quad Cab 4x2 6'4 Box",
            "Laramie 4x4 6'4 Box",
            "Classic Warlock",
            "Tradesman Quad Cab 4x4 6'4 Box",
            "Tradesman Regular Cab 4x2 6'4 Box",
            "Laramie Quad Cab 4x4 6'4 Box",
            "Laramie 4x2 5'7 Box",
            "Slt 4x4 5'7 Box",
            "Lone Star Silver 4x2 5'7 Box",
            "Big Horn/lone Star Quad Cab 4x4 6'4 Box",
            "Rebel 4x2 5'7 Box",
            "Laramie Longhorn 4x4 5'7 Box",
            "Limited Longhorn 4x4 5'7 Box",
            "Big Horn/lone Star 4x4 6'4 Box",
            "Sport 4x2 5'7 Box",
            "Crew Short 4x4",
            "Express 4x2 5'7 Box",
            "Tradesman 4x2 5'7 Box",
            "Tradesman Regular Cab 4x2 8' Box",
            "Lone Star Silver 4x4 5'7 Box",
            "Hfe",
            "Tradesman 4x4 6'4 Box",
            "Rebel Quad Cab 4x4 6'4 Box",
            "Limited 4x2 5'7 Box",
            "Tradesman 4x2 6'4\" Box",
            "Laram",
            "Ssv",
            "Lone Star Silver 4x4 6'4 Box",
            "Slt 4x2 6'4 Box",
            "Lone Star 4x2 6'4 Box",
            "Laramie Longhorn/limited Edition",
            "R/t",
            "Express Regular Cab 4x4 6'4 Box",
            "Trx 4x4 5'7\" Box",
            "Lone Star 4x4 5'7\" Box",
            "Slt 4x4 6'4\" Box",
            "Longhorn 4x4 5'7 Box",
            "Laramie Longhorn 4x4 5'7\" Box",
            "Express 4x4 5'7\" Box",
            "Sport 4x2 6'4\" Box",
            "Sport Regular Cab 4x2 6'4 Box",
            "Sport 4x4 5'7 Box",
            "Laramie Limited",
            "Laramie Longhorn",
            "Limited Longhorn",
            "Laramie Limited Edition",
            "Slt 4x4 6'4 Box",
            "Big Horn/lone Star 4x2 6'4 Box",
            "Reg Cab",
            "Laramie Longhorn Edition",
            "Night Quad Cab 4x4 6'4 Box",
            "Big Horn/lone Star 4x4 6'4\" Box",
            "Longhorn Limited",
            "Sport/rebel",
            "Rebel 4x4 5'7\" Box",
            "Slt 4x2 6'4\" Box",
            "Limited 4x4 5'7\" Box",
            "Night 4x4 6'4\" Box",
            "Express 4x2 6'4\" Box",
            "Tradesman Regular Cab 4x4 8' Box",
            "Laramie Quad Cab 4x2 6'4 Box",
            "Lone Star Silver 4x4 5'7\" Box",
            "Longhorn 4x4 5'7\" Box",
            "Express 4x4 64 Box",
            "Laramie 4x4 6'4\" Box",
            "Tradesman 4x4 6'4\" Box",
            "Sport 4x4 5'7\" Box",
            "Big Horn 4x2 6'4 Box",
            "Night 4x4 5'7\" Box",
            "Lone Star 4x2 6'4\" Box",
            "Rebel 4x2 5'7\" Box",
            "Laramie 4x2 6'4 Box",
            "Limited 4x4 6'4\" Box",
            "Ssv 4x4 5'7\" Box",
            "Big Horn/lone Star 4x2 6'4\" Box",
            "Limited Longhorn 4x4 5'7\" Box",
            "Lone Star 4x2 5'7\" Box",
            "Laramie Longhorn 4x2 5'7 Box",
            "Ssv 4x4 5'7 Box",
            "Tradesman 4x2 6'4 Box",
            "Classic Laramie",
            "Night 4x4 5'7 Box/sport 4x4 5'7 Box",
            "Harvest 4x2 5'7 Box",
            "Big H",
            "Slt Regular Cab 4x4 8' Box",
            "Ruck",
            "Express  4x2 5'7 Box",
            "Classic Warlock Edition",
            "Rebel  4x4 5'7 Box",
            "Big Horn  4x2 5'7 Box",
            "Laramie  4x4 6'4 Box",
            "Tradesman  4x2 5'7 Box",
            "Limited 4x4 6'4 Box",
            "Night Regular Cab 4x2 6'4 Box",
            "Harvest 4x4 5'7 Box",
            " 1500 St",
            "Night Quad Cab 4x2 6'4 Box",
            "Ster 1500 1500 High",
            "Big Horn/lone Star  4x4 5'7 Box",
            "Big Horn  4x4 5'7 Box",
            "Tradesman  4x4 5'7 Box",
            "Sport  4x4 5'7 Box",
            "Lone Star  4x2 5'7 Box",
            "Big Horn  4x4 6'4 Box",
            "Night 4x4 6'4 Box",
            "Tradesman Regular Cab 4x4 6'4 Box",
            "Sport 4x4 6'4 Box",
            "Lone Star Silver  4x2 5'7 Box",
            "Laramie  4x4 5'7 Box",
            "Big Horn  4x4 5'7\" Box",
            "Laramie  4x2 5'7 Box",
            "Express  4x4 5'7 Box",
            "Trx  4x4 5'7 Box",
            "Lone Star  4x4 5'7 Box",
            "Laramie  4x2 5'7\" Box",
            "Limited Longhorn  4x4 5'7 Box",
            "Big Horn/lone Star  4x2 5'7 Box",
            "Slt  4x2 6'4 Box",
            "Big Horn/lone Star/outdoorsman/slt",
            "Longhorn  4x4 5'7 Box",
            "Night  4x4 6'4\" Box",
            "Big Horn  4x2 6'4 Box",
            "Harvest  4x2 5'7 Box",
            "Rebel  4x2 5'7 Box",
            "Slt  4x4 6'4 Box",
            "Limit",
            "Express  4x4 5'7\" Box",
            "Big Horn/lone Star  4x4 6'4 Box",
            "Limited  4x4 5'7 Box",
            "Rebel  4x4 5'7\" Box",
            "Limited  4x2 5'7 Box",
            "Express  4x4 6'4\" Box",
            "Big Horn Crew Cab 4x4 5'7\" Box",
            "Tradesman  4x4 6'4\" Box",
            "Night  4x4 5'7 Box",
            "Ster 1500 1500 Standard",
            "Big Horn  4x4 6'4\" Box",
            "Rebel  4x2 5'7\" Box",
            "Limited  4x4 6'4 Box",
            "Sport  4x2 5'7 Box",
            "Slt  4x2 6'4\" Box",
            "Lone Star Silver  4x4 5'7 Box",
            "Trx  4x4 5'7\" Box",
            "Express/tradesman",
            "Big Horn  4x2 5'7\" Box",
            "Tradesman  4x2 6'4 Box",
            "Trade",
            "Slt  4x4 5'7 Box",
            "Slt Slt",
            "Big Horn/lone Star  4x4 5'7\" Box",
            "Big Horn  4x4 5'7 Box/harvest  4x4 5'7 Box/lone Star  4x4 5'7 Box/lone Star Silver  4x",
            "Lone Star 4x4 6'4 Box",
            "Big Horn  4x2 6'4\" Box",
            "Big Horn Regular Cab 4x2 8' Box",
            "Big Horn 4x2 5'7 Box/lone Star 4x2 5'7 Box",
            "Sport Quad Cab 4x4 6'4 Box",
            "Ssv  4x4 5'7 Box",
            "Laramie Longhorn  4x4 5'7\" Box",
            "Laramie Longhorn  4x4 5'7 Box",
            "Crew",
            "Big Horn/lone Star/slt",
            "Ster City",
            "Longhorn 4x2 6'4 Box",
            "Night  4x4 6'4 Box",
            "Sport  4x4 5'7\" Box",
            "Laramie  4x4 6'4\" Box",
            "Sport  4x4 6'4 Box",
            "Longhorn  4x2 5'7 Box",
            "Laramie  4x4 5'7\" Box",
            "Ster 2500 2500 High",
            "Harvest Quad Cab 4x4 6'4 Box",
            "Express  4x2 6'4\" Box",
            "Big Horn  4x2 5'7 Box/lone Star  4x2 5'7 Box",
            "Harvest  4x4 5'7 Box",
            "Hfe Quad Cab 4x2 6'4 Box",
            "Parts",
            "Big Horn 4x4 5'7 Box/harvest 4x4 5'7 Box/lone Star 4x4 5'7 Box/lone Star Silver 4x4 5'7 Box",
            " 1500",
            "Express Crew Ca Express",
            "Laramie Crew Ca Laramie 4x2 5'7 Box",
            "Sport Quad Cab 4x2 6'4 Box",
            "Express Regular Cab 4x4 8' Box/tradesman Regular Cab 4x4 8' Box",
            "Longh",
            "Lone Star  4x4 6'4\" Box",
            "Slt  4x4 6'4\" Box",
            "Mpg",
            "Big Horn/slt",
            "St/tradesman",
            "Lone Star  4x2 5'7\" Box",
            "Big Horn/lone Star  4x2 5'7\" Box",
            "Big Horn/lone Star  4x4 6'4\" Box",
            "Big Horn/lone Star  4x2 57 Box",
            "Big Horn  4x4 57 Box",
            "Harvest  4x4 5'7\" Box",
            "Tradesman  4x2 5'7\" Box",
            "Tradesman  4x4 8' Box",
            "Lone Star  4x4 5'7\" Box",
            "Express  4x2 5'7\" Box",
            "Laramie  4x2 6'4\" Box",
            "Night  4x4 5'7\" Box",
            "Tradesman  4x2 6'4\" Box",
            "Longhorn  4x4 5'7\" Box",
            "Limited  4x4 5'7\" Box",
            "Lone Star  4x2 6'4\" Box",
            "St/slt/lone Star",
            "Slt/big Horn/lone Star",
            "Laramie Edition",
            "Limited  4x2 5'7\" Box",
            "Lone Star Silver  4x2 5'7\" Box",
            "Slt  4x4 5'7\" Box",
            "Big Horn Quad Cab 4x4 64 Box",
            "Night  4x2 5'7\" Box",
            "Limited  4x4 57 Box",
            "Lone Star  4x2 6'4 Box",
            "Big Horn/lone Star  4x2 64 Box",
            "Big Horn/lone Star  4x2 6'4\" Box",
            "Clsc 4x4 Slt",
            "Crew Short Slt",
            "4wd",
            "Rebel  4x4 6'4\" Box",
            "Tradesman  4x2 8' Box",
            "Slt  4x4 8' Box",
            "Expre",
            "Clsc Crw 4x4 Ssv",
            "Odels 1500",
            "Adventurer/express",
            "Tradesman  4x4 5'7\" Box",
            "Limited  4x4 6'4\" Box",
            "Night",
            "Sport  4x2 5'7\" Box",
            "Lone Star Silver  4x4 5'7\" Box",
            "Limited Longhorn  4x4 5'7\" Box",
            "Sport  4x4 6'4\" Box",
            "Slt/lone Star",
            "Laramie Limited 2.0",
            "Slt/big Horn",
            "Harvest",
            "Hfe Express",
            "St/express",
            "Lone Star Silver",
            "Slt/outdoorsman",
            "Trade Trade",
            "Sport Sport",
            "Sport  4x2 6'4\" Box",
            "Crw 4x4 Slt",
            "4x4 St",
            "Longhorn  4x4 6'4\" Box",
            " 1500 Slt",
            "Lone Star  4x2 8' Box",
            "Laramie Longhorn  4x2 5'7\" Box",
            "Night  4x2 6'4\" Box",
            "Limited Longhorn  4x4 6'4 Box",
            "Big Horn/lone Star  4x2 6'4 Box",
            "Express  4x4 57 Box",
            "Laramie  4x2 57 Box",
            "Rebel  4x4 64 Box",
            "Lone Star Silver  4x2 57 Box",
            "Slt Regular Cab 4x4 6'4 Box",
            "Big Horn Regular Cab 4x4 6'4 Box",
            "Lone Star Silver  4x4 6'4\" Box",
            "Laramie  4x2 64 Box",
            "Laramie  4x4 64 Box",
            "Tradesman  4x4 57 Box",
            "Limited  4x2 57 Box",
            "Lone Star  4x4 6'4 Box",
            "Night  4x2 5'7 Box",
            "Laramie  4x2 6'4 Box",
            "Rebel  4x4 57 Box",
            "Laramie  4x4 57 Box",
            "Slt Quad Cab 4x4 64 Box",
            "Limited  4x4 64 Box",
            "Express  4x2 6'4 Box",
            "Tradesman  4x4 64 Box",
            "Trx  4x4 57 Box",
            "Slt  4x4 64 Box",
            "Big Horn  4x4 64 Box",
            "Tradesman  4x4 6'4 Box",
            "Lone Star Silver  4x4 6'4 Box",
            "Laramie Longhorn  4x2 5'7 Box",
            "Big Horn/lone Star  4x4 57 Box",
            "Express  4x2 64 Box",
            "Big Horn  4x2 57 Box",
            "Lone Star  4x2 57 Box",
            "Express  4x4 6'4 Box",
            "Big Horn Quad Cab 4x2 64 Box",
            "Longhorn  4x4 6'4 Box",
            "Slt  4x2 5'7 Box",
            "Night  4x4 5'7 Box/sport  4x4 5'7 Box",
            "Express Quad Cab 4x4 6'4 Box/tradesman Quad Cab 4x4 6'4",
            "Big Horn  4x4 5'7 Box/harvest  4x4 5'7 Box/lone Star  4",
            "Longhorn  4x2 6'4 Box",
            " 1500 Sport",
            "Rebel 4x4 6'4 Box",
            "Night 4x2 5'7 Box",
            "Big Horn 4x4 5'7 Box/lone Star 4x4 5'7 Box/lone Star Silver 4x4 5'7 Box/slt",
            "Express Quad Ca Tradesman Quad Cab 4x4 6'4 Box",
            "Lone Star Quad Lone Star 4x2 6'4 Box",
            "4x4 Slt",
            "Big Horn 4x2 6'4 Box/lone Star 4x2 6'4 Box",
            "Sport  4x2 6'4 Box",
            "Trx Trx",
            "Rho",
            "Harvest 4x4 6'4 Box",
            "Tradesman 4x4 8' Box",
            "Laramie Crew Ca Laramie  4x2 5'7 Box",
            "Big H Big H",
            "Express Regular Cab 4x4 8' Box/tradesman Regular Cab 4x",
            "Tradesman 4x2 8' Box",
            "St St",
            "Class Class",
            "Laram Laram",
            "Ssv Ssv",
            "Laramie Longhorn 4x4 6'4 Box",
            "Night 4x2 6'4 Box",
            "Longh Longh",
            "Limit Limit",
            "Rebel Rebel",
            "Rebel  4x4 6'4 Box",
            "Hfe 4x2 6'4 Box",
            "Big Horn/lone Star 4x2 5'7\" Box",
            "Express 4x4 6'4 Box",
            "Big Horn 4x2 6'4 Box/lone Star 4x2 6'4 Box/lone Star Silver 4x2 6'4 Box/slt 4x2 6'4 Box",
            "Sport 4x2 6'4 Box",
            "Warlock",
            "Express  4x4 64 Box",
            "St/express/tradesman",
            "Harvest  4x4 6'4 Box",
            "Laramie Longhorn  4x4 6'4 Box",
            "Expres Quad Cab Express",
            "Night  4x2 6'4 Box",
            "Big Horn 4x2 6'4 Box/harvest 4x2 6'4 Box/lone Star 4x2 6'4 Box/slt 4x2 6'4 Box",
            "Outdoorsman/lone Star/slt/big Horn",
            "S 1500 Rebel",
            "S 1500 Trx",
            "S 1500 Laram",
            "S 1500 Big H",
            "S 1500 Slt",
            "Big Horn 4x4 6'4 Box/harvest 4x4 6'4 Box/lone Star 4x4 6'4 Box",
            "Big Horn  4x4 5'7 Box/lone Star  4x4 5'7 Box/lone Star",
            "Warlock 4x4 5'7 Box",
            "Lone Star Quad Lone Star  4x2 6'4 Box",
            "S 1500 St",
            "S 1500 Limit",
            "S 1500 Class",
            "Laramie Crew Ca Laramie",
            "Ster 3500 3500 Standard",
            "Big Horn 4x4 5'7 Box/lone Star 4x4 5'7 Box",
            "Laramie Longhor Laramie Longhorn",
            "Slt 4x2 5'7 Box",
            "Express 4x4 6'4 Box/tradesman 4x4 6'4 Box",
            "S 1500 Sport",
            "Big Horn 4x4 6'4 Box/harvest 4x4 6'4 Box/lone Star 4x4 6'4 Box/slt 4x4 6'4 Box",
            "Rebel 4x4 57 Box",
            "Big Horn  4x2 6'4 Box/harvest  4x2 6'4 Box/lone Star  4",
            "S 1500 Longh",
            "Laramie Crew Ca Laramie  4x4 5'7 Box",
            "S 1500 Trade",
            "Big Horn 4x4 6'4 Box/lone Star 4x4 6'4 Box",
            "Express  4x4 6'4 Box/tradesman  4x4 6'4 Box",
            "Warlock  4x4 5'7 Box",
            "Big Horn  4x2 6'4 Box/lone Star  4x2 6'4 Box/lone Star",
            "Rho 4x4 5'7 Box",
            "Tungsten",
            "Big Horn Crew Cab 4x4 6'4 Box",
            "Lone Star Silver 4x2 6'4 Box",
            "Bighorn",
            "Classic St",
            "Tungsten 4x4 5'7 Box",
            "Tungs"
          ]
        },
        {
          "model": "2500",
          "series": [
            "Tradesman",
            "Slt",
            "Big Horn",
            "Laramie",
            "St",
            "Tradesman 4x4 8' Box",
            "Longhorn 4x4 6'4 Box",
            "Tradesman 4x4 6'4 Box",
            "Big Horn 4x4 6'4 Box",
            "Laramie 4x4 6'4\" Box",
            "Laramie Longhorn",
            "Lone Star",
            "Laramie Mega Cab 4x4 6'4 Box",
            "Slt 4x4 6'4 Box",
            "Longhorn",
            "Big Horn/lone Star",
            "Laramie Longhorn Edition",
            "Limited",
            "Big Horn 4x4 6'4\" Box",
            "Laramie 4x4 6'4 Box",
            "Powerwagon",
            "Tradesman 4x4 6'4\" Box",
            "Tradesman 4x2 8' Box",
            "Big Horn 4x4 8' Box",
            "Tradesman 4x2 6'4 Box",
            "Laramie 4x4 8' Box",
            "Outdoorsman",
            "Lone Star 4x4 6'4 Box",
            "Longhorn Mega Cab 4x4 6'4 Box",
            "Limited 4x4 6'4 Box",
            "Lone Star Regular Cab 4x4 8' Box",
            "Longhorn Limited",
            "Power Wagon 4x4 6'4 Box",
            "Slt 4x4 8' Box",
            "Longhorn 4x4 6'4\" Box",
            "Limited 4x4 6'4\" Box",
            "Power Wagon",
            "Limited 4x4 8' Box",
            "Tradesman Regular Cab 4x4 8' Box",
            "Tradesman Regular Cab 4x2 8' Box",
            "Limited Longhorn 4x4 6'4 Box",
            "Tradesman Power Wagon",
            "Limited Mega Cab 4x4 6'4 Box",
            "Laramie 4x2 6'4 Box",
            "Limited Longhorn Mega Cab 4x4 6'4 Box",
            "Power Wagon 4x4 6'4\" Box",
            "Lone Star 4x4 8' Box",
            "Big Horn Mega Cab 4x4 6'4' Box",
            "Laramie Longhorn 4x4 6'4 Box",
            "Promaster High",
            "Longh",
            "Lone Star 4x4 6'4\" Box",
            "Tradesman Std Cab",
            "Laram",
            "Tradesman  4x4 6'4 Box",
            "Laramie Longhorn/limited Edition",
            "Ster 2500 2500 High",
            "Big Horn Mega Cab 4x4 6'4 Box",
            "Big Horn  4x4 6'4 Box",
            "Laramie  4x4 6'4 Box",
            "Tradesman  4x4 8' Box",
            "Lone Star Mega Cab 4x4 6'4 Box",
            "Slt  4x4 8' Box",
            "Tradesman 4x4",
            "Big Horn  4x4 8' Box",
            "Tradesman  4x2 8' Box",
            "Power Wagon  4x4 6'4 Box",
            "Tradesman  4x4 6'4\" Box",
            "Tradesman  4x2 6'4 Box",
            "Laramie  4x4 6'4\" Box",
            "Slt  4x4 6'4 Box",
            "Longhorn  4x4 6'4 Box",
            "Limited  4x4 6'4 Box",
            "Laramie Power Wagon",
            "Laramie Longhorn  4x4 6'4 Box",
            "Laramie  4x4 8' Box",
            "Limited Longhorn  4x4 6'4 Box",
            "Power Wagon Rebel 4x4 6'4 Box",
            "Lone Star  4x4 8' Box",
            "Limited  4x4 6'4\" Box",
            "Power Wagon Rebel",
            "Big Horn 4x2 6'4 Box",
            "Big Horn 4x4 6'4 Box/lone Star 4x4 6'4 Box",
            "Limited Longhorn 4x4 8' Box",
            "Laramie Mega Ca Laramie",
            "Slt Mega Cab 4x2 6'4 Box",
            "Big Horn 4x4 8' Box/lone Star 4x4 8' Box/slt 4x4 8' Box",
            "Trade",
            "Big Horn  4x2 6'4 Box",
            "Lone Star  4x4 6'4 Box",
            "Lone Star 4x2 6'4 Box",
            "Limited 4x4 6'4 Box/longhorn 4x4 6'4 Box",
            "Big Horn  4x4 6'4\" Box",
            "Lone Star Regular Cab",
            "St Power Wagon",
            "Power Wagon  4x4 6'4\" Box",
            "Slt  4x4 6'4\" Box",
            "Lone Star  4x4 6'4\" Box",
            "Big Horn  4x4 6'4\"' Box",
            "Slt Mega Cab 4x4 6'4 Box",
            "Odels 2500",
            "Slt/outdoorsman",
            "Power Wagon  4x4 64 Box",
            "Power",
            "Big H",
            "Limit",
            "St/slt/lone Star",
            "Tradesman  4x4 64 Box",
            "Tradesman 4dr",
            "Lone Star/big Horn/slt",
            "Slt/lone Star",
            "Slt/big Horn/lone Star",
            "Laramie Limited",
            "Longhorn  4x4 6'4\" Box",
            "Laramie Longhorn  4x4 6'4\" Box",
            "Slt  4x4 64 Box",
            "Tradesman  4x4 8 Box",
            "Big Horn  4x4 64 Box",
            "Lone Star  4x4 64 Box",
            "Laramie  4x4 64 Box",
            "Laramie  4x2 6'4\" Box",
            "Tradesman  4x2 8 Box",
            "Tradesman  4x2 64 Box",
            "Slt  4x2 6'4 Box",
            "Limited  4x2 6'4 Box",
            "Limited  4x4 8' Box",
            "Laramie  4x2 6'4 Box",
            "Big Horn  4x4 8' Box/lone Star  4x4 8' Box/slt  4x4 8'",
            "Crew",
            "Sit T-350",
            " 2500 Longhorn",
            "Limited Longhorn  4x4 8' Box",
            "Laramie Longhorn 4x2 6'4 Box",
            "Laramie Crew Cab 4x4 6'4 Box",
            "Slt 4x2 6'4 Box",
            "Big Horn 4x4 6'4' Box",
            "Big H Big H",
            "Trade Trade",
            "Laram Laram",
            "Longh Longh",
            "Power Wagon Rebel  4x4 6'4 Box",
            "Laramie Longhorn Mega Cab 4x4 6'4 Box",
            "Big Horn 4x2 8' Box",
            "Big Horn  4x2 8' Box",
            "Big Horn/lone Star/outdoorsman/slt",
            "S 2500 Big H",
            "Big Horn  4x4 6'4 Box/lone Star  4x4 6'4 Box",
            "Truck",
            "Tradesman Crew Tradesman",
            "S 2500 Trade",
            "Rebel",
            "S 2500 Laram",
            "Laramie Crew Ca Laramie 4x4 6'4 Box",
            "Limited Longhorn",
            "Limited Longhorn Crew Cab 4x4 8' Box",
            "Big Horn 4x4 8' Box/lone Star 4x4 8' Box",
            "Limit Limit",
            "Longhorn 4x4 8' Box",
            "Trade Service Truck",
            "Laramie Crew Ca Laramie  4x4 6'4 Box",
            "Big Horn  4x4 6'4' Box",
            "6.7l Turbo Diesel Big Horn",
            " 2500"
          ]
        },
        {
          "model": "3500",
          "series": [
            "Tradesman",
            "Laramie 4x4 8' Box",
            "Tradesman 4x4 8' Box",
            "Laramie",
            "St",
            "Big Horn/lone Star",
            "Big Horn",
            "Slt",
            "Laramie Longhorn/limited Edition",
            "Big Horn 4x4 8' Box",
            "Chassis Tradesman/slt",
            "Chassis Tradesman/slt/laramie",
            "Big Horn 4x4 6'4\" Box",
            "Tradesman 4x2 8' Box",
            "Tradesman Crew Cab 4x4 8' Box",
            "Tradesman 4x4 6'4 Box",
            "Chassis Tradesman/slt/laramie/limited",
            "Longhorn",
            "Big Horn 4x2 8' Box",
            "Limited Mega Cab 4x4 6'4 Box",
            "Big Horn Crew Cab 4x4 8' Box",
            "Lone Star 4x4 8' Box",
            "Limited",
            "Laramie 4x4 6'4 Box",
            "Longhorn 4x4 8' Box",
            "Big Horn Mega Cab 4x4 6'4 Box",
            "Laramie Mega Cab 4x2 6'4 Box",
            "Limited 4x4 8' Box",
            "Chassis St/slt",
            "Chassis St/slt/laramie",
            "Laramie Longhorn Mega Cab 4x4 6'4 Box",
            "Lone Star",
            "Laramie Longhorn",
            "Slt 4x4 8' Box",
            "Limited Longhorn Mega Cab 4x4 6'4 Box",
            "Slt Mega Cab 4x4 6'4 Box",
            "Laramie Mega Cab 4x4 6'4 Box",
            "Lone Star 4x4 6'4\" Box",
            "Limited Longhorn 4x4 8' Box",
            "Laramie Longhorn Edition",
            "Lone Star 4x2 8' Box",
            "Longhorn Limited",
            "Tradesman 4x4 6'4\" Box",
            "Lone Star 4x4 6'4 Box",
            "Tradesman Regular Cab 4x4 8' Box",
            "Laramie 4x4 6'4\" Box",
            "Limited 4x4 6'4\" Box",
            "Slt 4x4 6'4\" Box",
            "Longhorn Mega Cab 4x4 6'4 Box",
            "Tradesman 4x4 8 Box",
            "Laramie Longhorn 4x4 8' Box",
            "Big Horn 4x4 6'4 Box",
            "Tradesman Regular Cab 4x2 8' Box",
            "Chassis",
            "Limited Longhorn",
            "Big H",
            "Tradesman  4x2 8' Box",
            "Laramie Longhorn/laramie Longhorn/limited Edition",
            "Chassis Cab Tradesman",
            "Trade",
            "Lone Star Mega Cab 4x4 6'4 Box",
            "Slt 4x4 6'4 Box",
            "Tradesman  4x4 8' Box",
            "Lone Star  4x4 8' Box",
            "Limited Longhorn  4x4 8' Box",
            "Slt  4x4 6'4 Box",
            "Tradesman  4x4 6'4\" Box",
            "Tradesman  4x4 6'4 Box",
            "Laramie Longhorn  4x4 8' Box",
            "Big Horn  4x4 8' Box",
            "Laramie  4x4 8' Box",
            "Limited  4x4 8' Box",
            "Big Horn  4x4 6'4\" Box",
            "Big Horn  4x4 6'4 Box",
            "Laramie  4x4 6'4 Box",
            "Big Horn  4x2 8' Box",
            "Tradesman Crew Tradesman 4x4 8' Box",
            "Slt  4x4 8' Box",
            "Longh",
            "Big Horn 4x4 8 Box",
            "Slt/lone Star/big Horn",
            "Odels 3500",
            "Truck 2 Door Cab",
            "Big Horn  4x4 8 Box",
            "Chassis Cab Limited",
            "+",
            "Longhorn  4x4 64 Box",
            "Chassis Cab Slt/tradesman/laramie",
            "Chassis Cab Slt",
            "Laramie Limited",
            "Laramie  4x2 8 Box",
            "Laram",
            "Chassis Cab Laramie",
            "Limited  4x4 6'4\" Box",
            "Ram  S",
            "Chassis Cab",
            "Limit",
            "Slt/tradesman/laramie",
            "4wd",
            "Chassis Tradesman",
            "Laramie  4x4 6'4\" Box",
            "Tradesman Crew Cab 4 Tradesman",
            "Tradesman  4x4 8 Box",
            "Laramie Longhorn  4x4 6'4 Box",
            "Laramie Longhorn  4x4 8'",
            "Limited  4x4 6'4 Box",
            "Longhorn  4x4 8' Box",
            "Promaster 3500 High",
            "Limit Limit",
            "Ster 3500 3500 High",
            "Laramie Longhorn 4x4 6'4 Box",
            "500",
            "Tradesman/slt",
            "Tradesman/slt/laramie/limited",
            "Limited Longhorn 4x4 6'4 Box",
            "Tradesman Crew Tradesman  4x4 8' Box",
            "3500",
            "Lone Star  4x4 6'4 Box",
            "Limited Longhorn  4x4 6'4 Box",
            "Trade Trade",
            "Big Horn 4x4 8' Box/lone Star 4x4 8' Box",
            "Longh Longh",
            "Tradesman/slt/laramie",
            "Big H Big H",
            "Limited 4x4 6'4 Box",
            "Laramie 4x2 6'4 Box",
            "500 Longhorn",
            "Laramie 4x2 8' Box",
            "Slt Crew Cab 4x2 8' Box",
            "Utility / Service Truck",
            "Laramie  4x2 6'4 Box",
            "500 Tradesman",
            "Lone Star  4x2 8' Box",
            "Flat Bed Truck",
            "S 3500 Laram",
            "Big Horn  4x4 6'4 Box/lone Star  4x4 6'4 Box",
            "Service Bed Only",
            "Crew Cab Flat Bed Pickup Truck",
            "Laramie Longhorn 4x2 8' Box",
            "And 2018 Kauf Trailer",
            "Big Horn 4x2 6'4 Box",
            "S 3500 Trade",
            "Chasis Tradesman/slt/laramie",
            "Flatbed Pickup Truck",
            "Laramie Longhorn  4x2 8' Box",
            "Laramie  4x2 8' Box",
            "Big Horn  4x2 6'4 Box",
            "Van"
          ]
        },
        {
          "model": "4000",
          "series": [
            "4400"
          ]
        },
        {
          "model": "4500",
          "series": [
            "Chassis Tradesman/slt/laramie/limited",
            "Chassis Tradesman/slt",
            "Chassis Tradesman/slt/laramie",
            "Chassis St/slt",
            "Chassis*ors Tradesman/slt/laramie/limited",
            "Chassis St/slt/laramie",
            "Chassis Cab Tradesman",
            "Odels 4500",
            "Laramie",
            "Chassis Cab Slt",
            "St",
            "Tradesman",
            "Slt",
            "Chassis Cab",
            "Tradesman/slt",
            "Chassis",
            "Tradesman/slt/laramie/limited",
            "Tradesman/slt/laramie",
            "Crew Cab Flat Bed Truck",
            "Utility / Service Truck",
            "Tow Truck"
          ]
        },
        {
          "model": "5500",
          "series": [
            "Chassis Tradesman/slt/laramie",
            "Chassis Tradesman/slt",
            "Chassis Tradesman/slt/laramie/limited",
            "Chassis",
            "Chassis St/slt",
            "Chassis St/slt/laramie",
            "Tradesman",
            "Slt",
            "St/slt/laramie",
            "Odels 5500",
            "Chassis Cab Limited",
            "Tradesman/slt/laramie",
            "Chassis Cab",
            "Chassis Cab Laramie",
            "St",
            "Chassis Cab Tradesman",
            "Laramie",
            "Chassis Cab Slt",
            "Laramie/slt/tradesman",
            "Chassis Laramie",
            "5500",
            "Tradesman/slt",
            "Tradesman/slt/laramie/limited",
            "Rollback Tow Truck",
            "Rollback Truck",
            "Dump Truck",
            "Tow Truck",
            "Flatbed Truck",
            "Trucks Flat Bed Truck"
          ]
        },
        {
          "model": "1500 Classic",
          "series": [
            "Slt 4x2 5'7\" Box",
            "Tradesman 4x4 6'4 Box",
            "Tradesman 4x4 5'7 Box",
            "Warlock Quad Cab 4x4 6'4 Box",
            "Slt 4x4 5'7 Box",
            "Tradesman Quad Cab 4x2 6'4 Box",
            "Big Horn 4x2 6'4 Box",
            "Slt",
            "Slt 4x2 6'4\" Box",
            "Tradesman 4x2 6'4\" Box",
            "Warlock 4x4 5'7 Box",
            "Warlock 4x2 5'7 Box",
            "Tradesman Regular Cab 4x2 8' Box",
            "Express 4x4 5'7 Box",
            "Express Quad Cab 4x4 6'4 Box",
            "Slt 4x2 5'7 Box",
            "Slt 4x4 6'4 Box",
            "Big Horn 4x4 6'4\" Box",
            "Big Horn 4x4 5'7 Box",
            "Tradesman Quad Cab 4x4 6'4 Box",
            "Lone Star 4x4 5'7 Box",
            "Tradesman Regular Cab 4x2 6'4 Box",
            "Express Regular Cab 4x2 6'4 Box",
            "Lone Star 4x2 5'7 Box",
            "Slt 4x2 6'4 Box",
            "St",
            "Tradesman",
            "Tradesman 4x2 5'7 Box",
            "Warlock/slt",
            "Express Regular Cab 4x4 6'4 Box",
            "Lone Star Quad Cab 4x4 6'4 Box",
            "Tradesman Regular Cab 4x4 8' Box",
            "Big Horn 4x4 6'4 Box",
            "Tradesman 4x2 6'4 Box",
            "Express Quad Cab 4x2 6'4 Box",
            "Ssv",
            "Slt 4x4 5'7\" Box",
            "Lone Star 4x2 57 Box",
            "Tradesman 4x4 6'4\" Box",
            "Express 4x4 6'4\" Box",
            "Slt Quad Cab 4x2 6'4 Box",
            "Big Horn 4x2 5'7 Box",
            "Laramie",
            "Big Horn 4x2 6'4\" Box",
            "Express 4x2 6'4\" Box",
            "Big Horn Quad Cab 4x2 6'4 Box",
            "Warlock 4x4 57 Box",
            "Warlock Quad Cab 4x2 6'4 Box",
            "Warlock 4x4 6'4\" Box",
            "Lone Star Silver 4x2 5'7 Box",
            "Tradesman/express",
            "Tradesman 4x4 8' Box",
            "Lone Star Silver 4x4 5'7\" Box",
            "Warlock 4x4 5'7\" Box",
            "Big Horn 4x4 5'7\" Box",
            "Tradesman 4x2 5'7\" Box",
            "Slt 4x4 6'4\" Box",
            "Tradesman Quad Cab 4x2 64 Box",
            "Big Horn",
            "Tradesman Regular Cab 4x4 6'4 Box",
            "Warlock 4x2 6'4\" Box",
            "Slt 4x4 64 Box",
            "Lone Star 4x2 5'7\" Box",
            "Warlock 4x4 6'4 Box",
            "Warlock",
            "Express",
            "Lone Star Silver 4x4 5'7 Box",
            "Express 4x2 5'7 Box",
            "Ssv 4x4 5'7 Box",
            "Lone Star  4x2 5'7 Box",
            "Tradesman  4x2 5'7 Box",
            "Slt  4x4 6'4 Box",
            "Big Horn  4x4 5'7\" Box",
            "Big Horn  4x4 5'7 Box",
            "Slt  4x2 6'4 Box",
            "Laramie 4x2 5'7 Box",
            "Tradesman  4x2 8' Box",
            "Big Horn  4x2 6'4 Box",
            "Big Horn  4x4 6'4 Box",
            "Tradesman  4x4 5'7 Box",
            "Warlock  4x2 5'7 Box",
            "Big Horn  4x2 5'7 Box",
            "Tradesman  4x4 6'4 Box",
            "Warlock  4x4 5'7 Box",
            "Express  4x4 5'7 Box",
            "Tradesman  4x4 6'4\" Box",
            "Laramie  4x2 5'7 Box",
            "Warlock  4x4 5'7\" Box",
            "Tradesman  4x4 8' Box",
            "Big Horn Quad Cab 4x4 6'4 Box",
            "Slt Quad Cab 4x4 6'4 Box",
            "Laramie 4x4 5'7 Box",
            "Slt  4x2 5'7 Box",
            "Tradesman 4x2 8' Box",
            "Slt Regular Cab 4x4 8' Box",
            "Express  4x2 5'7 Box",
            "Lone Star  4x4 5'7 Box",
            "Slt  4x4 5'7 Box",
            "Slt/warlock",
            "Express Quad Cab 4x2 6'4 Box/tradesman Quad Cab 4x2 6'4 Box",
            "Tradesman  4x4 5'7\" Box",
            "Slt  4x2 5'7\" Box",
            "Express  4x4 6'4\" Box",
            "Slt  4x4 5'7\" Box",
            "Slt  4x2 6'4\" Box",
            "Slt  4x4 6'4\" Box",
            "Express  4x2 6'4\" Box",
            "Tradesman  4x2 6'4\" Box",
            "Warlock Quad Cab 4x4 64 Box",
            "Warlock  4x4 6'4\" Box",
            "Warlock  4x2 6'4\" Box",
            "Tradesman  4x2 6'4 Box",
            "Big Horn  4x2 5'7\" Box",
            "Slt  4x2 57 Box",
            "Lone Star  4x2 5'7\" Box",
            "Lone Star Silver  4x2 5'7\" Box",
            "Slt  4x4 8' Box",
            "Lone Star Silver",
            "Big Horn  4x4 6'4\" Box",
            "Express  4x4 5'7\" Box",
            "Tradesman  4x2 5'7\" Box",
            "Express  4x2 5'7\" Box",
            "Big Horn  4x4 64 Box",
            "Warlock  4x4 6'4 Box",
            "Express  4x4 64 Box",
            "Lone Star",
            "Slt/big Horn",
            "Big Horn  4x2 6'4\" Box",
            "Lone Star  4x4 6'4\" Box",
            "Lone Star  4x2 57 Box",
            "Warlock  4x4 57 Box",
            "Tradesman  4x2 57 Box",
            "Slt  4x2 64 Box",
            "Lone Star Silver  4x4 5'7\" Box",
            "Tradesman  4x2 64 Box",
            "Warlock  4x4 64 Box",
            "Warlock  4x2 64 Box",
            "Slt  4x4 64 Box",
            "Big Horn  4x2 64 Box",
            "Tradesman  4x4 57 Box",
            "Laramie  4x4 5'7 Box",
            "Lone Star Quad Cab 4x2 6'4 Box",
            "Lone Star Silver  4x2 5'7 Box",
            "Lone Star Silver  4x4 5'7 Box",
            "Express Quad Cab 4x2 6'4 Box/tradesman Quad Cab 4x2 6'4",
            "Ssv  4x4 5'7 Box",
            "Express  4x4 6'4 Box",
            "Express 4x2 6'4 Box",
            "Big Horn 4x2 5'7 Box/lone Star 4x2 5'7 Box/lone Star Silver 4x2 5'7 Box/warlock 4x2 5'7 Box",
            "Tradesm Tradesman 4x4 5'7 Box",
            "Express  4x2 6'4 Box",
            "Warlock 4x2 6'4 Box",
            "Express 4x4 6'4 Box",
            "Warlock  4x2 6'4 Box",
            "Big Horn 4x4 6'4 Box/lone Star 4x4 6'4 Box",
            "Lone Star 4x2 6'4 Box",
            "Tradesm Tradesman  4x4 5'7 Box",
            "Tradesm Tradesman 4x2 5'7 Box",
            "Big Horn  4x4 6'4 Box/lone Star  4x4 6'4 Box",
            "Tradesman Quad Cab 4x2 6'4\" Box",
            "Tradesm Tradesman  4x2 5'7 Box",
            "Lone Star  4x2 6'4 Box",
            "Big Horn  4x2 5'7 Box/lone Star  4x2 5'7 Box/lone Star",
            "Slt 4x2 6'4 Box/warlock 4x2 6'4 Box",
            "Slt Cre Slt 4x2 6'4 Box",
            "Slt 4x4 8' Box"
          ]
        },
        {
          "model": "DAKOTA",
          "series": [
            "Bighorn/lonestar",
            "Laramie",
            "St",
            "Sxt",
            "Slt"
          ]
        },
        {
          "model": "C/V",
          "series": []
        },
        {
          "model": "ProMaster 1500",
          "series": [
            "1500 Standard",
            "Low Roof 136 Wb",
            "1500 High",
            "Low Roof 136\" Wb",
            "Low Roof 118 Wb",
            "High Roof 136 Wb",
            "Low Roof",
            "Low Roof 118\" Wb",
            "136 Wb",
            "Slt High Roof 136 Wb",
            "136\" Wb",
            "Low Roof 136 In. Wb",
            "High Roof",
            "High",
            "Standard",
            "High Roof 136 In. Wb",
            "Cargo Van Tradesman High Roof 136 Wb W/pass Seat",
            "Low Roof 118 In. Wb",
            "Low Roof 118 Wb W/pass Seat",
            "Tradesman High Roof 136 Wb W/pass Seat",
            "Slt Low Roof 136 Wb",
            "Cargo Van Ext",
            "Cargo Van",
            "Low Roof 136 Wb W/pass Seat",
            "Tradesman Low Roof 118 Wb W/pass Seat"
          ]
        },
        {
          "model": "ProMaster 2500",
          "series": [
            "High Roof 159\" Wb",
            "High Roof 159 Wb",
            "2500 High",
            "High Roof 136 Wb",
            "High Roof",
            "Window Van High Roof",
            "2500 Standard",
            "Low Roof 136 Wb",
            "High Roof 136\" Wb",
            "Window Van",
            "High Roof 136 In. Wb",
            "Window Van High Roof 159 Wb",
            "Cargo Van",
            "Tradesman High Roof 136 Wb W/pass Seat",
            "High Roof 159 In. Wb",
            "Slt High Roof 159 Wb",
            "Tradesman High Roof 159 Wb W/pass Seat",
            "136\" Wb",
            "High",
            " Cargo",
            "Cutaway 2500 Standard",
            "Window Van High Roof 159 Wb Ext",
            "136 Wb",
            "Tradesman Low Roof 136 Wb W/pass Seat",
            "Cargo Van Ext",
            "Slt High Roof 136 Wb",
            "Cargo Van High Roof 159&quot; Wb"
          ]
        },
        {
          "model": "ProMaster 3500",
          "series": [
            "3500 High",
            "Cargo Van High Roof 159 Wb Ext",
            "3500 Standard",
            "Cargo Van High Roof 159\" Wb Ext",
            "High Roof",
            "Cutaway Low Roof",
            "High Roof 159 Wb",
            "High Roof 159\" Wb",
            "High Roof Extended 159 In. Wb",
            "Cab",
            "Cargo Van Ext",
            "Cab Chassis 3500 Standard",
            "Cutaway 3500 Standard",
            "Cab Low Roof",
            "High",
            "Window Van High Roof 159 Wb Ext",
            "Window Van High Roof 159\" Wb Ext",
            "Cab Chassis Low Roof",
            "High Roof 159 In. Wb",
            "Cab Chassis",
            "Motor Home",
            "Tradesman High Roof 159 Wb W/pass Seat",
            "Cargo Van Super High Roof 159 Wb Ext",
            "3500 Super High",
            "Cargo Van High Roof 159\"",
            " Van",
            "Cutaway",
            "High Roof 136 Wb",
            "Low Roof",
            "Super High Roof",
            "Roadtrek Zion Srt",
            "Low Roof 136 Wb",
            "Cargo Van Tradesman High Roof 159 Wb Ext W/pass Seat",
            "Cargo Van Tradesman High Roof 159 Wb Ext",
            "Tradesman Low Roof 136 Wb W/pass Seat",
            "An",
            " 3500"
          ]
        },
        {
          "model": "ProMaster City",
          "series": [
            "Slt",
            "Tradesman",
            "Tradesman Slt",
            "Wagon",
            "Cargo Van",
            "St",
            "Tradesman /wagon",
            "Tradesman/slt",
            "Cargo Van Tradesman",
            "Cargo Van Slt",
            "Cargo Van Tradesman Slt",
            "Cargo Tradesman",
            "Slt Cargo Van",
            "Tradesman Slt Cargo Van/ Slt"
          ]
        },
        {
          "model": "ProMaster Rapid",
          "series": []
        }
      ]
    },
    {
      "make": "Rolls-Royce",
      "models": [
        {
          "model": "Cullinan",
          "series": [
            "Black Badge",
            "Cullinan",
            "B"
          ]
        },
        {
          "model": "Dawn",
          "series": [
            "Base"
          ]
        },
        {
          "model": "Ghost",
          "series": [
            "Ewb",
            "Blac",
            "Dels Ghost",
            "Base",
            "Black Badge",
            "Blac Blac"
          ]
        },
        {
          "model": "Phantom",
          "series": [
            "Drophead Coupe",
            "Coupe Drophead Coupe",
            "Dr",
            "Coupe"
          ]
        },
        {
          "model": "Wraith",
          "series": []
        }
      ]
    },
    {
      "make": "Saab",
      "models": [
        {
          "model": "9-3",
          "series": [
            "2.0t",
            "Arc",
            "Aero",
            "Linear",
            "Se",
            "Turbo4",
            "S",
            "Comfort",
            "Vector",
            "Viggen",
            "9-3 2.0t",
            "9-3 Aero",
            "Xwd",
            "Touring",
            "Aero Xwd",
            "Touring/comfort/sport",
            "9-3",
            "Se Spring Edition",
            "Base (a4)/base W/sunroof (a4)",
            "Turbox",
            "9-3 Linear",
            "9-3 Turbox",
            "Aero 9-2 Aero",
            "Sport",
            "Aero 9-3 Aero",
            "2.0t 9-3 2.0t"
          ]
        },
        {
          "model": "9-3X",
          "series": [
            "Turbo4"
          ]
        },
        {
          "model": "9-4",
          "series": []
        },
        {
          "model": "9-4X",
          "series": [
            "Aero",
            "Premium",
            "3.0i Premium",
            "3.0i",
            "-4x",
            "-4x Premi",
            "-4x Aero"
          ]
        },
        {
          "model": "9-5X",
          "series": []
        },
        {
          "model": "9-5",
          "series": [
            "Arc",
            "Linear Sport",
            "Linear",
            "2.3t",
            "Aero",
            "Turbo6",
            "2.3t Sport",
            "Se",
            "2.3t W/aero Package",
            "Base",
            "Griffin",
            "Turbo4",
            "3.0t Arc",
            "Turbo",
            "2.3",
            "2.3t Linear",
            "Turbo4/turbo4 Premium",
            "Se V6t",
            "Turbo4 Premium",
            "Turbo6 Xwd",
            "Aero Xwd",
            "9-5 2.3t",
            "9-5 Turbo",
            "9-5 Aero",
            "Sportcombi",
            "Arc Sport",
            "Sport",
            "9-5",
            "9-5 Base",
            "9-5 Griffi",
            "Se V6",
            "3.0",
            "Turbo 9-5 Turbo"
          ]
        }
      ]
    },
    {
      "make": "Scion",
      "models": [
        {
          "model": "FR-S",
          "series": [
            "Release Series",
            "On Fr-s",
            "10 Series",
            "Monogram",
            "Release Series 2.0",
            "Scion 10",
            "Release Series 1.0",
            "Base (a6)",
            "R-s 2d Rw",
            "R-S",
            "N Fr-s",
            "Base (m6)",
            "2d Rw",
            "Base M6",
            "Fr-S",
            "Man Scion 10/scion 10"
          ]
        },
        {
          "model": "iA",
          "series": [
            "Ion Ia",
            "Automat",
            "Base (a6)",
            "Ia"
          ]
        },
        {
          "model": "iM",
          "series": [
            "Ion Im",
            "Base (m6)",
            "Im",
            "A Fe"
          ]
        },
        {
          "model": "iQ",
          "series": [
            "10 Series",
            "Ion Iq",
            "Iq"
          ]
        },
        {
          "model": "tC",
          "series": [
            "10 Series",
            "Release Series 9.0",
            "Ion Tc",
            "Release Series 7.0",
            "Release Series 6.0",
            "Monogram",
            "Ion Ia",
            "Release Series 8.0",
            "Release Series 10.0",
            "10 Series/monogram",
            "Ion Xa",
            "2d",
            "Release Series",
            "Base (a6)",
            "Base (a6)/release Series 8.0",
            "Scion",
            "Spec",
            "Base (a4)",
            "Manual",
            "Automat",
            "Ion Xd",
            "Base A4",
            "Automatic",
            "Base (m6)",
            "Base (m5)",
            "Ion Xb",
            "Tc",
            "10 Series/base (m6)/monogram",
            "On"
          ]
        },
        {
          "model": "xB",
          "series": [
            "Release Series 9.0",
            "Release Series 7.0",
            "Release Series",
            "Ion Xb",
            "Xb",
            "686 Parklan Edition",
            "Base (retail Orders Only) (a4)",
            "Base A4",
            "10 Series",
            "Release Series 8.0",
            "Base (retail Orders Only) (m5)",
            "Sw",
            "Release Series 10.0",
            "Base (a4)",
            "Van",
            "Automat",
            "Base (m5)",
            "Base Retail Orders Only A4",
            "686 Parklan Edition/base A4/base M5",
            "Manual"
          ]
        },
        {
          "model": "xD",
          "series": [
            "10 Series",
            "Release Series 4.0",
            "Ion Xd",
            "Release Series 3.0",
            "Base (retail Orders Only) (a4)/base (retail Orders Only) (m5)",
            "Ion Xb",
            "Xd",
            "Automat",
            "Base A4",
            "Base (a4)/release Series 4.0",
            "Base (a4)",
            "Sw",
            "Base (retail Orders Only) (m5)"
          ]
        }
      ]
    },
    {
      "make": "Smart",
      "models": [
        {
          "model": "EQ fortwo",
          "series": [
            "Pure/passion/prime",
            "Passion/prime/pure"
          ]
        },
        {
          "model": "Forfour",
          "series": []
        },
        {
          "model": "Fortwo",
          "series": [
            "Brabus/passion/pure",
            "Passion/pure",
            "Passion/prime/proxy/pure",
            "Electric Drive Passion",
            "Passion/prime/proxy",
            "Passion",
            "Pure",
            "Passion/brabus/pure",
            "Pure/passion",
            "Brabus/passion",
            "Passion/brabus",
            "Electric Drive Passion/prime",
            "Electric Drive Passion/prime/pure",
            "Pur",
            "Pas",
            "Electric Drive",
            "Ele",
            "Pure/passion/prime/proxy",
            "Passion/pure/prime/proxy",
            "Brabus",
            "Electric",
            "Smp",
            "Cab",
            "Electric Drive Electric",
            "Pure/passion/brabus",
            "Electric Drive Pure/passion/prime",
            "Prime",
            "Pur Pur",
            "Pas Pas",
            "Rtwo",
            "Passion/prime/pure",
            "Cdi Passion"
          ]
        }
      ]
    },
    {
      "make": "Subaru",
      "models": [
        {
          "model": "Ascent",
          "series": [
            "Touring",
            "Limited",
            "Premium",
            "Base 8-passenger",
            "Premium 7-passenger",
            "Onyx Edition",
            "Limited 8-passenger",
            "2.5i Limited",
            "Limited 7-passenger",
            "Touring 7-passenger",
            "Onyx Edition Limited 7-passenger",
            "Premium 8-passenger",
            "R Premium",
            "Ek Premium",
            " Premium",
            "Onyx Edition 7-passenger",
            "Tou",
            "Ek Sport",
            "Ek",
            "Pre",
            "Lim",
            "Strek 2.0 Premium",
            " 2.5i Premium",
            " 3.6r Limited",
            " 2.5i Limited",
            "Ony",
            "Onyx Edition Limited",
            "Pre Pre",
            "R",
            "Lim Lim",
            "Tou Tou",
            "Ited",
            "R Limited",
            " Limited",
            "Mium",
            "Premier",
            "Convenience",
            "Onyx Touring",
            "Onyx",
            "Outback H6 3.0 Ll Bean",
            "Ony Sp",
            "2.5i Premium"
          ]
        },
        {
          "model": "BRZ",
          "series": [
            "2.0 Limited",
            "Limited",
            "Ts",
            "Premium",
            "2.0 Premium",
            "Series.gray",
            "Series.hyperblue",
            "Series. Yellow",
            "2.0 Ts",
            "2.0 Limited/yellow Series",
            "2.0 Limited/blue.series",
            "2.0 Li",
            "Series.blue",
            "2.0 Pr",
            "Series.yellow",
            "Limite",
            "Premiu",
            "Limited/series.gray",
            "Limited/premium/series. Yellow",
            "Sport-Tech",
            "2.0 Li 2.0 Li",
            "Limite Limite",
            "2.0 Pr 2.0 Pr",
            "Ts Ts",
            "Aozora Edition/sport-tech"
          ]
        },
        {
          "model": "Crosstrek",
          "series": [
            "2.0i Limited",
            "Premium",
            "Limited",
            "2.0i Premium",
            "Sport",
            "2.0i",
            "Wilderness",
            "2.0i Hybrid Touring",
            "Hybrid",
            "Onyx",
            "Hybrid Touring",
            "Xv Limited",
            "Ek Sport Limited",
            "Ek 2.0 Limited",
            "Ek 2.0 Premium",
            "2.0i Hybrid",
            "Touring",
            "2.0i (cvt)",
            "Touring/convenience",
            "Plug-in Hybrid",
            "Crosstrek",
            "Premium Awd",
            "Base (cvt)",
            "Hybrid 2.0i Hybrid Touring",
            "Hybrid 2.0i Hybrid",
            "Outdoor",
            "Hood",
            "Sport Package/touring Package",
            "Convenience",
            "Ek 2.0i Hybrid",
            "Sport/touring",
            "Fx4/lariat/xl/xlt",
            "Limited Package",
            "Convenience/outdoor",
            "2.0i W/touring Pkg/sport Package"
          ]
        },
        {
          "model": "Forester",
          "series": [
            "2.5x",
            "2.5i",
            "Premium",
            "Xs",
            "2.5i Limited",
            "Wilderness",
            "2.5xt Limited",
            "2.5x Premium",
            "Limited",
            "2.5x Limited",
            "2.5i Premium",
            "Sport",
            "2.5i Touring",
            "Touring",
            "2.0xt Touring",
            "S",
            "2.5 X W/premium Pkg",
            "L",
            "(natl) X",
            "X",
            "2.5xs",
            "2.5xt",
            "Sports 2.5x",
            "2.0xt Premium",
            "2.5xs L.l. Bean",
            "2.5x Touring",
            "2.5 Xt Limited",
            "2.5x Ll Bean",
            "S W/premium Pkg",
            "Sports 2.5x/sports 2.5xt",
            "2.5x L.l. Bean Edition",
            "2.5xs Ll Bean",
            "2.5xt Premium",
            "(natl) 2.5x",
            "2.5x/sports 2.5x",
            "Sports 2.5xt",
            "S W/premium Pkg/s W/premium Pkg & Leather",
            "2.5x Limited/2.5x Premium",
            "2.5xt Touring",
            "Convenience",
            "2.5 X",
            "2.5i Sport",
            "Tback",
            "Cross Sports",
            "2.5 Xs",
            "2.0xt",
            "5xs Ll Bean",
            "5x Limited",
            "5i Premium",
            "5x Ll Bean",
            "5i",
            "5x",
            "5x Premium",
            "5i Touring",
            "5i Limited",
            "0xt Touring",
            "5xt Limited",
            "5xs",
            "0xt Premium",
            "2.5 X Touring",
            "S/s Limited",
            "2.5xt Ltd",
            "5xt",
            "Premier",
            "W",
            "P",
            "2",
            "T",
            "2.5 X Limited",
            "2.5xt/xt W/premium Pkg",
            "X Limited",
            "2.5i Premier",
            "2.5",
            "Xt",
            "S/tb",
            "Tback Awp",
            "Ium",
            "Premium Black Edition",
            "S W/premium Pkg/s W/premium Pkg   Leather",
            "X W/premium Pkg",
            "X L.l. Bean Ed",
            "X Limited W/nav",
            "X W/prem/all-weather",
            "Xt Ltd W/nav",
            "Xt Ltd",
            "Xs W/premium Pkg",
            "Ted",
            "2.5 X L.l. Bean Edition",
            "Mium",
            "Sports X",
            "Sports Xt",
            "Ited",
            "Xs W/prem Pkg & Lthr",
            "X/sports X",
            "2.5 I Sport Awd",
            "X Long Whlbs Sr5",
            "C",
            "S W/premium Pkg & Leather",
            "2.",
            "Forest 2.5",
            "2.5i Cvt",
            " B9",
            "T Xt",
            "2 2",
            "X X",
            "Sr",
            " 2.5x",
            "S/s W/premium Pkg",
            "Base (cvt)",
            "Natl X",
            "2.5 I Premium Aw",
            "Natl Xs/xs W/prem Pkg   Lthr/xs W/premium Pkg",
            ".5i Premium",
            "2.5 X Pzev",
            "Ing",
            "Ring",
            "X L.l. Bean W/nav",
            "L L",
            "P P",
            "S S",
            "T T",
            "4d 4wd",
            "I Limited",
            "W W",
            "(natl) X Limited",
            "Th Anniversary Outback",
            "2.5i Limited Package",
            "2.5 X Awd",
            "2.0xt Limited Package/2.5i Touring Package",
            "2.5 X Sport-tech",
            "2.0 X",
            "2.5 X Convenience Package",
            "2.0xt Limited",
            "(natl) X L.l. Bean Ed",
            "(",
            "2.5 X Limited Package",
            "4wd Double Cab Long Bed Lt",
            "2.5i Touring Package",
            "2.5i Convenience/2.5i Touring",
            "2.5i Convenience Package",
            "2.5i/2.5i Convenience Package",
            "2.0xt Limited/2.0xt Touring",
            "Columbia Edition/x",
            "2.5xt Ltd/sports 2.5xt",
            "Sport/wilderness",
            "2.5i Limited/2.5i Touring",
            "S Limited/sport",
            "S/s Limited/sport",
            "2.5i Convenience",
            "2.5 X Touring Package",
            "Rek 2.0 Premium",
            "2.5x Limited Package",
            "Anniversary Edition",
            "Limited Hybrid",
            "2.5xs/xs W/premium Pkg",
            "X Automatic 2.5x",
            "Limited/wilderness",
            "2.0xt Limited Package",
            "2.5x Convenience Package",
            "X Premium A 2.5x Premium",
            "2.5x/2.5x Convenience Package",
            "2.5i Wilderness",
            "Hybrid Premium",
            "Hybrid Touring",
            "Hybrid Sport"
          ]
        },
        {
          "model": "Impreza",
          "series": [
            "Rs",
            "Premium",
            "Limited",
            "2.5i Premium",
            "Premium Plus",
            "2.0i Sport",
            "Premium 5-door",
            "2.0i",
            "Sport",
            "2.0i Sport Premium",
            "Sedan",
            "2.0i Premium",
            "2.0i Limited",
            "2.5i",
            "5-Door",
            "Sport Limited",
            "2.0i Sport Limited",
            "Wrx",
            "Wagon 2.0i Premium",
            "Outback",
            "Outback Sport",
            "Sport 5-door",
            "Sport Premium",
            "L Awd",
            "L",
            "Wrx Sti Limited",
            "2.5rs",
            "Base 5-door",
            "Wrx Sti",
            "Outback Sport Outback Sport",
            "Wagon 2.0i Sport Premium",
            "Wrx Premium",
            "Outback Sport Base W/special Edition",
            "Wrx/wrx Limited/wrx Tr",
            "Wrx Limited",
            "Outback Sport Outback Sport/outback Spc",
            "Base",
            "2.5i Sports Wagon",
            "Wrx Sport",
            "Wagon Wrx Wrx",
            "Wrx Tr",
            "Ts",
            "Wrx/vdt",
            "Rs 5-door",
            "Wrx Wrx Sti",
            "2.5ts",
            "Outback Sport/outback Spc",
            "L Plus",
            "Wrx Sti Special Edition",
            "Wrx/limited",
            "Limited 5-door",
            "Wagon Wrx Wrx Premium",
            "Rs Pro",
            "Pr",
            "Lx",
            "Wrx/wrx265",
            "Wagon Sport Limited",
            "Brighton",
            "2.5 Gt",
            "Wrx Wrx",
            "Wrx Sti Wrx Sti",
            "Wrx/wrx Limited",
            "2.5i Sport",
            "Wagon Premium",
            " Sport",
            " Sti",
            " Premium",
            "Wagon Wrx",
            "Wagon 2.0i Sport Limited",
            "2.5gt",
            "Wagon Sport Premium",
            "Li",
            "Sp",
            "Sedan Automa",
            "Wagon Wrx W/premium Pkg",
            "Wagon 2.0i",
            "Sedan I Premium Special Edition",
            "Wrx 265",
            "2.5rs Sport",
            "Sedan Wrx Wrx",
            "Sedan Wrx Tr",
            "Wagon Limited",
            "Wagon",
            "Sport 2.5 Ts",
            "L Plus/outback",
            "Se",
            "Wagon 2.5i Premium",
            "Sedan Premium",
            "2.",
            "Sedan 2.5i",
            " Natl Outback Sport",
            " Wrx",
            "Sedan (natl)",
            " Ts",
            " Rs",
            "Sedan Premium Plus",
            "Sedan Wrx Limited",
            "Wagon Sport",
            "Sedan Wrx",
            "Sedan Gt",
            "Sedan 2.0i Limited",
            "Wagon Gt",
            "Wagon I W/premium Pkg",
            "Wagon Wrx W/sat/nav",
            "Sedan I Special Edition",
            "Sedan Rs",
            "Wagon Outback Sport",
            "Sedan Limited",
            "Sedan 2.0i Premium",
            "Sedan I W/premium Pkg",
            "Sedan Wrx W/premium Pkg",
            "Wagon I Premium Special Edition",
            "Wagon 2.5i",
            "Wr",
            "Sedan Wrx Sti Wheels",
            "Sedan Wrx Sti",
            "Sedan Wrx Sti Ltd",
            "Sedan Wrx Ltd",
            "Sedan I W/sat/nav",
            "Wagon Ts Sport",
            "Wagon L",
            "Wagon 2.0i Limited",
            "Wagon I",
            "Wagon I Premium",
            "Wagon Wrx Sti",
            "Wagon Outback Sport Sp Edition",
            "Wagon Sti",
            "Wagon Outback Sport Sp Ed",
            "Wagon Outback",
            "Sedan 2.5i Premium",
            "Ou",
            "Sedan I",
            "Sedan 2.0i",
            "Sedan Wrx W/sat/nav",
            "Wagon Wrx Sport",
            "Premium Awd",
            "Wrx Sport/limited",
            "Rs Pro/vtd",
            "Wagon Wrx Ltd",
            "Wagon Sti W/silver Wheels",
            "Wagon Ts",
            "Wagon Sti W/gold Wheels/nav",
            "Emium",
            "Mited",
            "4wd Z71",
            "Wagon Wrx Limited",
            "Sedan Wrx Wrx Limited",
            "Plus",
            "Unknown",
            "Mium",
            "Ted",
            "Door",
            "Rt",
            "Parts Only",
            "2.0i (cvt)",
            "Ba",
            "Eza Wr",
            "Imp Rs",
            "Se Se",
            " (natl) Rs",
            "2.0i Cvt",
            "/l",
            "Oor",
            " Natl Rs W/sport Pkg",
            "Sr5",
            " Wrx Wrx",
            "Base (cvt)",
            "Rt Limited",
            "Sw 4wd",
            "Imp2.5i/sp",
            "Le",
            "4w",
            "Sw 4x4 2.0i Spt Ltd",
            "Rt Premium",
            "Ited",
            "Ts Sport",
            " (natl) Wrx/wrx W/premium Pkg",
            "2.0i M5",
            "2.0i (m5)",
            "Aw Aw",
            "Sedan I Premium",
            "Wagon I W/sat/nav",
            "Wagon Wrx Sti W/gold Wheels",
            "Aw",
            "Utback Limited",
            "2.5rs/rs",
            "Wrx Sti/sti Limited",
            "Pr Pr",
            "2. 2.",
            "Li Li",
            "Sp Sp",
            "Impreza Wr",
            "2.5 I Awd",
            "Wagon (natl) I W/premium Pkg",
            "I",
            "(natl) I",
            "Sedan Wrx Wrx Sti",
            "Sti/sti Limited",
            "2.5i Se",
            "L/outback",
            "Sedan Wrx Sti Limited",
            "2.0i Touring",
            "2.0i W/limited Pkg",
            "(natl) I W/premium Pkg",
            "Sti",
            "I W/premium Pkg",
            "3.6r Limited",
            "Ls",
            "Ou Ou",
            "Sedan Wrx Wrx Premium",
            "Touring",
            "2.0i Touring Package",
            "Trek 2.0 Premium",
            "Sport-Tech",
            "To",
            "Sport With Eyesight 5-door",
            "Sport/touring",
            "2.5 Ts",
            "Wrx Limited/premium",
            "Convenience",
            "2.5 I Sport Package",
            "Wa",
            "2.5 I/2.5 I Convenience Package/2.5 I Touring Package",
            "2.0i/2.0i Sport Package/2.0i Touring Package",
            "Touring With Eyesight 5-door",
            "2.5 I",
            "2.5 I/2.5 I Sport Package",
            "2.0i/2.0i Touring Package",
            "2.0i Sport Package/2.0i Touring Package",
            "2.0i Sport Package",
            "Sedan L",
            "2.5 I Limited Package",
            "Wilderness",
            "Sti Limited",
            "2.0i Sport Tech",
            "Base W/special Edition",
            "Wrx Sti Sport-tech",
            "2.0i/2.0i Limited Package/2.0i Touring Package",
            "Imprza Wrx",
            "700 Box Truck",
            "Wrx/wrx Limited Package",
            "2.0i Limited Package",
            "Convenience 4-door",
            "Convenience 5-door",
            "Awd",
            "Base (m5)",
            "Touring 5-door",
            "Wrx Type-ra",
            "Sedan Wrx Wrx Sti Limited",
            "2.0i/2.0i Sport Package/2.0i Touring Package/2.0i W/sport Pkg",
            "Convenience With Eyesight 4-door",
            "2.5i Se Sport"
          ]
        },
        {
          "model": "Legacy",
          "series": [
            "3.6r Limited",
            "2.5i Premium",
            "30th Ann. L/l",
            "Touring Xt",
            "2.5i",
            "2.5i Limited",
            "Limited",
            "Outback 3.0r Ll Bean",
            "Sport",
            "Outback Ltd",
            "Wagon Outback",
            "L",
            "2.5gt Limited",
            "Outback W/all Weather Pkg",
            "Outback/outback Limited/outback Sport",
            "Outback/30th Ann. Outback Ltd.",
            "Outback",
            "L/l W/35th Anniversary Edition",
            "2.5i/2.5i Limited",
            "Outback/ssv/limited/30th",
            "Outback 2.5i Awd",
            "Outback 3.0r",
            "Gt Limited",
            "Premium",
            "2.5gt Limited/2.5gt Spec.b",
            "3.0r Limited",
            "Outback/outback Limited",
            " 2.5i Premium",
            "2.5i Sport",
            "2.5 I Sport",
            "L/postal Right-hand Drive",
            "30th Ann. Outback Ltd./outback",
            "Outback Awp",
            "Limited Xt",
            "Outback 2.5i Limited",
            "Outback 2.5i",
            "2.5 Gt",
            "2.5",
            "Outback H6 L.l. Bean Edition",
            "3.6r W/limited",
            " 2.5i Limited",
            "30th Anniversary Outback",
            "Outback Limited",
            "L/right Hand Postal Drive",
            "Outback 2.5 Xt Limited",
            "Lim",
            "Outback H6 3.0 Vdc",
            "Outback/l/l Special Edition",
            "Postal Rhd/l",
            "Right Hand Postal Drive/l",
            " Limited",
            "3.6r Premium",
            "Outback 3.0 H6",
            "L Special",
            "Outback H6 3.0 Ll Bean",
            "Sedan (natl) 2.5i",
            "2.5i Limited/2.5i Special",
            "2.5gt",
            "3.6r",
            "Gt",
            "Outback H6 3.0 Special",
            "2.5 Gt Spec B",
            "L/l Sunsport",
            "30th Ann Outback/ltd/spt",
            "L/outback",
            "L/l W/special Edition Package",
            "L/hx/px/rx",
            "L/l Special Edition",
            "L/postal Rhd",
            " 2.5i",
            "Brighton",
            "Ls Special/lt",
            "Outback W/gb Equip/outback W/gl Equip/outback W/rl Equip",
            "30th Ann. Sus/30th Ann. Sus Ltd.",
            "2.5gt/30th Ann. 2.5 Gt Ltd.",
            "2.5i/2.5i Basic",
            "L/l Special Edition/outback",
            "L/l Alpine",
            "Wagon",
            "Outbk/ssv/ltd/30th",
            "Outback W/rb Equip",
            " 3.0r Ll Bean",
            "Outback H6 R Vdc",
            "3.0r",
            " Outback 2.5i",
            " 3.6r Premium",
            "L/30th Anniversary L",
            "Outback/limited",
            "Outback H6 R Ll Bean",
            " 3.6r Limited",
            "L/l Special",
            "Outback 3.0 H6/3.0 H6 Vdc",
            "2.5i Premier",
            "2.5gt Premium",
            "B4",
            "Postal",
            " Premium",
            "Outback 3.0r Vdc Limited",
            "Gt Spec B",
            "Lsi",
            "30th Anniversary Sus",
            "Ls/lsi",
            " Sport",
            " Outback Sport",
            "Ls Special",
            "Sedan Outback Ltd",
            "Wagon Outback Ltd",
            "Outback 2.5 Xt",
            "Pre",
            " Outback H6 R Ll Bean",
            " Onyx Edition Xt",
            "L/l W/special Edition Package/outback",
            " 2.5xt Limited",
            "R 2.5x Premium",
            "2.5i Ltd Pwr Moon",
            "Wagon Outback 2.5 Xt",
            "Wagon Outback 2.5i",
            "Wagon Outback H6 L.l. Bean Edition",
            "2.5i (cvt)",
            "Gt Limited/gt Ltd",
            " Touring",
            "2.5i Limited/2.5i Limited L.l. Bean Edition",
            " Touring Ldl",
            " Wilderness",
            "Limited Gt",
            "Ek Premium",
            "2.5i Prem Awp",
            "Special Edition",
            "Wagon Outback H6 3.0 Ll Bean",
            "Wagon Outback Basic",
            " Outback W/rb Equip",
            " Outback H6 L.l. Bean Edition",
            "2.5gt Limited/gt Ltd",
            "Sedan Sus",
            "Wagon Outback H6 35th Ann.",
            "Sedan L",
            "Outback H6",
            " (natl) Outback R",
            " L",
            "Wagon (natl) Outback R L.l. Bean",
            " (natl) Outback",
            " (natl) Outback R L.l. Bean Edition",
            " L/l Special Edition",
            " Outback H6 Vdc",
            " Outback",
            " Outback Ltd",
            "Outback H6 Vdc",
            "Spo",
            "3.6",
            "3.0",
            "3.6r Ltd",
            "2.5i Prem Awp/hk Audio",
            "Prem All-wthr",
            "Prem All-wthr/moon",
            "Gt Ltd",
            "Prem All-wthr/hk Aud",
            "Ltd",
            "2.5i Prem Awp/pwr Moon",
            "Prem",
            "2.5i Ltd Pwr",
            "Limited Moon/nav",
            "Prem Moon",
            "Limited Pwr Moon",
            "2.5i Ltd",
            "Prem Hk Aud/moon",
            "3.6r Ltd Pwr Moon",
            "Limited Moon",
            "3.6r Ltd Pwr",
            "Gt Limited Moon/nav",
            "3.6r Prem Pwr Moon",
            "2.5i Prem",
            "2.5i Prem Awp/hk/pwr Moon",
            "Gt Prem Moon",
            "Em Awp/pwr Moon",
            "3.6r Prem",
            "Prem All-weather/pwr Moon",
            "L S",
            "Gt Spec B W/nav",
            "Awd",
            "Gt Ltd W/nav",
            "2wd Work Truck",
            "Sedan",
            "2.5gt Ltd Navigation",
            "Bas",
            "3.6r Prem Hk Audio",
            "Outback Basic",
            "L 4",
            "R Premium",
            "2.5gt Spec.b",
            "Outback H6 L.l. Bean",
            " Natl Outback H6 L.l. Bean Edition",
            "2.5i/special Edition",
            "Limited/outback Ltd",
            "Leg Outbk",
            "L/l W",
            "Wag",
            " Natl Outback Ltd",
            "Outback W",
            "Outback 2.5i/outback 2.5i Special",
            "Ls",
            "Gt/gt Limited",
            "3.0r Ltd W/nav",
            "Prem All-wthr/hk Aud/moon",
            "Gt Limited Pwr Moon",
            "Prem Hk Aud",
            "Prem Aud/moon",
            "Prem All-weather",
            "3.0r Ltd",
            "Out",
            "Tou",
            "Prem All-weather/hk Audio",
            "Gt Limited Moon",
            "2.0 Gt Spec B",
            "4d",
            "Outback/outback Limited/outback Ltd 30th Ann/outback Sport",
            "Wagon L Autom L/l W/35th Anniversary Edition",
            "Lim Lim",
            "3.6 3.6",
            "Wagon (natl) 2.5xt Limited",
            " Limited Xt",
            "(natl) L/l W/35th Anniversary Edition",
            "Gt/30th Anniv Limited Gt",
            "2.5xt Limited",
            "Utb Legcy Outb",
            "Pre Pre",
            "Leg Ps Wgn",
            "Brighton/se",
            "Bri",
            "H6-3.0 L.l. Bean Edition",
            "Premium Autom 2.5i Premium",
            "30th Ann Sus/ltd/outback",
            "Wagon 2.5i",
            "Wagon L",
            "2.5 I/2.5 I Touring Package",
            "Wagon (natl) Outback",
            "Touring",
            "Ek Limited",
            " 3.0r",
            "H6-3.0/h6-3.0 Vdc",
            "Premier Gt",
            "I Limited Awd 2.5",
            "Sed",
            "Wagon Limited",
            "2.5 I",
            " Outback 2.5i Limited",
            "2.5i Touring Package",
            "H6-3.0",
            "3.6r Touring Package",
            "2.5 I Limited Package",
            "H6-3.0 W/35th Anniversary Edition",
            "Outback/2.5/xt/limited",
            " Outback 3.0r Ll Bean",
            "Wagon Outback W/rb Equip",
            "2.5i Convenience Package/2.5i Limited Package/2.5i Touring Package",
            "L W/special Edition Package",
            "2.5i Touring",
            "2.5 Gt Spec.b",
            "3.6r Limited W/eyesight Package",
            "Ls Special/lsi",
            "3.6r Limited Package",
            "2.5 I Touring Package",
            "Sedan (natl) Ltd",
            "Aut",
            "Spo Spo",
            "4d 4wd W/eyesght",
            "R 2.5i Premium",
            "2.5 I/2.5 I Convenience Package",
            "2.5i Limited W/eyesight Package",
            "2.0 Gt Touring",
            "Wagon (natl) 2.5i",
            "Gt Wagon Legacy Gt Wagon"
          ]
        },
        {
          "model": "Outback",
          "series": [
            "2.5i Limited",
            "Premium",
            "2.5i",
            "3.6r Limited",
            "2.5i Touring",
            "2.5i Premium",
            "Touring",
            "Limited",
            "3.0r L.l. Bean Edition",
            "Limited Xt",
            "Wilderness",
            "2.5xt Limited",
            "Onyx Edition Xt",
            "2.5i/2.5i L.l. Bean Edition",
            "Outback 2.5i",
            "3.0r",
            "Onyx Edition",
            "Touring Xt",
            "Outback H6 R Ll Bean",
            "Outback Awp",
            "H6-3.0",
            "H6-3.0 L.l. Bean Edition",
            "3.6r Premium",
            "2.5i Limited/2.5i Limited L.l. Bean Edition",
            "H6-3.0/h6-3.0 Vdc",
            "Touring Ldl",
            "3.6r Touring",
            "2.5i Basic",
            "2.5xt",
            "Outback 3.0r",
            "3.0r Ll Bean",
            "3.0r Vdc Limited",
            "Outback 2.5i Limited",
            "H6-3.0 Vdc",
            "Onyx",
            "Special Edtn",
            "3.6r Limited Pwr Moon",
            "2.5i/2.5i Basic/2.5i L.l. Bean Edition",
            "H6-3.0 W/35th Anniversary Edition",
            "2.",
            "Outback",
            "3.6r",
            "Premier Xt",
            "2.5i Premier",
            "Utback 2.5i Limited",
            "Utback 2.5i",
            "Convenience",
            "Outback 3.0r Ll Bean",
            "Ltd",
            "Li",
            "Pr",
            "To",
            "Utback",
            "Outback Limited",
            "On",
            "Wi",
            "2.5xt/2.5xt Limited",
            "2.5i Pzev",
            " 2.5x Premium",
            "Outback/2.5/xt/limited",
            "Utback 3.0r Ll Bean",
            "Premier",
            "Utback H6 3.0 Ll Bean",
            "Utback H6 3.0 Special",
            "Ou",
            "I/ll Bean W/nav",
            "I",
            "Outback Ltd",
            "Ll Bean W/nav",
            "Ll Bean W/nav/vdc",
            "3.",
            "Prem All-weathr/pwr Moon",
            "2.5i Limited Pwr Moon",
            "All-Weather",
            "Ltd Pwr Moon/navigation",
            "Prem Wth/hk Aud/pwr Moon",
            "Prem Wthr/hk Aud/pwr Moon",
            "Xt Ltd",
            "Prem Pwr Moon",
            "2.5i Prem Awp/hk/moon",
            "3.0r Ll Bean W/nav",
            "2.5i Prem Awp/pwr Moon",
            "3.6r Limited Pwr Moon/nav",
            "3.6r Prem Pwr Moon",
            "2.5i Prem Awp/hk Aud",
            "Legcy Outb",
            "Prem All-weather",
            "Ltd Pwr Moon",
            "Wagon Outback Sport",
            "2.5i Prem",
            "2.5i Prem Awp",
            "3.6r Prem Hk Audio",
            "Premium All-weather",
            "Prem All-weather/pwr Moon",
            "2.5i Limited Pwr Moon/nav",
            "2.5 I Awd",
            "-weathr/pwr Moon",
            "-Weather",
            "Her",
            "Moon",
            "Ited Pwr Moon/nav",
            "Tion Xt",
            "M Awp/pwr Moon",
            "M Awp",
            "Moon/navigation",
            "Ss",
            "3.0r Ltd W/nav",
            "Mium",
            "Xt",
            "M",
            "/aw",
            "Ldl",
            "Ited",
            "Ited Pwr Moon",
            "M Awp/hk/moon",
            "-weather/hk Aud",
            "-weather/pwr Moon",
            "Tion",
            "M Awp/hk Aud",
            "2.5i (cvt)",
            " 2.5i Premium",
            "2. 2.",
            "2",
            "Sw",
            "Li Li",
            "Utback 2.5 Xt Limited",
            "/hk Aud/pwr Moon",
            "Outback W/gb Equip/outback W/gl Equip/outback W/rl Equip",
            "Utback Awp",
            "Ma",
            "Wilderness Editio",
            "3.0r Limited",
            "Utback H6 R Ll Bean",
            "Outback Sport Outback Sport",
            "4c",
            "Outback H6 L.l. Bean",
            "Utback Limited",
            "Sport Awd",
            "Legacy Limited",
            "3.6r Prem",
            "Prem All-weather/hk Audio",
            "Au",
            "2.5i Prem Awp/hk",
            "Prem All-weather/hk Aud",
            "Prem",
            "Prem Hk Audio",
            "Ltd W/nav",
            "Xt Ltd W/nav",
            "3.0r Ltd",
            "Prem Hk Audio/pwr Moon",
            "2.5i Sport",
            "3. 3.",
            "On On",
            "Pr Pr",
            "To To",
            "2.5i Limited L.l. Bean Edition",
            "Outback Sport",
            "Outback W/gl Equip",
            "Ll Bean",
            "I/ll Bean W/nav/ll Bean W/nav/vdc",
            "Premium 2.5i Premium",
            "2.5i Convenience Package/2.5i Touring Package",
            "2.5i Touring Package",
            "2.5i Limited Package",
            "2.5 I/2.5 I Touring Package",
            "2.5 Xt Limit",
            "3.6r Touring Package",
            "3.6r Limited Package",
            "3.6 R Limited Package",
            "3.6r Premier Eyesight Package",
            "Outdoor Xt",
            "(natl)",
            "Co",
            "2.5 I Limited Package",
            "2.5i L.l. Bean Edition",
            "2.5 I Sport",
            "3.0 R Vdc",
            "Ba",
            "Premium Awd Premium",
            "2.5 I",
            "Limited 2.5i Limited",
            "2.5i Premier Eyesight Package/2.5i Touring"
          ]
        },
        {
          "model": "Solterra",
          "series": [
            "Touring",
            "Premium",
            "Limited",
            "Premium/limited/touring",
            "P",
            "Luxury Package/technology Package"
          ]
        },
        {
          "model": "Tribeca",
          "series": [
            "Limited 7-passenger",
            "3.6r Limited",
            "Base 7-passenger",
            "Ca 3.0 H6",
            "Special Edition 7-passenger",
            "Limited",
            "Base 5-passenger",
            "Premium",
            "Special Edition 5-passenger",
            "Limited/touring",
            "3.6r Touring",
            "Limited 5-passenger",
            "Limited 7-passenger/special Edition 7-passenger",
            " 2.5i Touring",
            "Limited 5-passenger/special Edition 5-passenger",
            "B9",
            "Li",
            "3.6r Premium",
            "5-pass Special Edition",
            "5-Pass",
            "5-pass Ltd",
            "7-Pass",
            "7-pass Special Edition",
            "7-pass Ltd W/dvd/nav",
            "Touring",
            "7-pass Ltd W/nav",
            "(natl) 7-pass Ltd W/nav",
            "Special Edition",
            "B9triebeca",
            "5-pass Ltd W/nav",
            "7-pass Ltd",
            "Pr",
            "3.6r Limited/3.6r Touring",
            "K Premium",
            "Li Li",
            "B9 Limited",
            "Limited 7-passenger/premier 7-passenger",
            "Ca",
            " L",
            "2.5i Limited"
          ]
        },
        {
          "model": "WRX",
          "series": [
            "Premium",
            "Eza Wrx",
            "Gt",
            "Limited",
            "Eza Wrx Limited",
            "Sti",
            "Eza Wrx Sti",
            "Sti Limited",
            "Eza Wrx Premium",
            "Premiu",
            "Sti Launch Edition",
            "Tr",
            "Eza Wrx Sport",
            "Eza Wrx Sti Limited",
            "Sport Tech",
            "Eza Wrx Tr",
            "Sti Li",
            "Impreza Wr",
            "Za Wrx",
            "Limite",
            "Eza Sedan Wrx Wrx",
            "Eza Sedan Wrx Wrx Premium",
            "Eza Wagon Wrx Wrx",
            "Eza Wagon Wrx Wrx Premium",
            "Eza Wagon Wrx Wrx Limited",
            "Sti Type Ra",
            "Imprza",
            "Imprezasti",
            "Eza Sedan Wrx Wrx Limited",
            "Eza Wrx Wrx",
            "Base (m6)",
            "Sport",
            "Base M6",
            "Sti Series.gray",
            "Sti/limited",
            "Sti La",
            "Wd",
            "Eza Rs",
            "Premiu Premiu",
            "Eza Wr",
            "Limite Limite",
            "Sport-Tech",
            "Awd",
            " Intl (bci) Accord Cou",
            "Raiu Edition/sport-tech",
            "Sport Package",
            "Sport-tech Package",
            "Rs",
            "Sport Package/sport-tech Package",
            "W/sport Pkg",
            "30 Scissor Lift"
          ]
        },
        {
          "model": "WRX STI",
          "series": [
            "Limited",
            "Sti",
            "Series.hyperblue",
            "Launch Edition",
            "Sti Limited",
            "Sedan Wrx Wrx Sti",
            "Sti/limited",
            "Wagon Wrx Wrx Sti",
            "Sedan Wrx Wrx Sti Limited",
            "Sedan Wrx Wrx Sti W/navigation",
            "Li",
            "La",
            "Wrx Sti Wrx Sti",
            "Sti/launch Edition",
            "Li Sti Li",
            "Sport-tech W/lip/sport-tech W/wing",
            "Sport",
            "Sport-tech W/wing",
            "S209",
            "Sport/sport-Tech",
            "S2",
            "Sport-tech Package"
          ]
        },
        {
          "model": "XV",
          "series": [
            "Crosstrek 2.0 Premium",
            "Crosstrek 2.0i Hybrid Touring",
            "Crosstrek 2.0 Limited",
            "Crosstrek 2.0i Hybrid",
            "Crosstrek Sport Limited",
            "Crosstrek",
            "Sstrek Premium",
            "Crosstr",
            "Xtrek S",
            "Xtrek W/eyesght 2.0i P",
            "Sstrek"
          ]
        },
        {
          "model": "XV Crosstrek",
          "series": [
            "2.0i Premium",
            "2.0i Limited",
            "Hybrid Touring",
            "2.0 Premium",
            "Hybrid 2.0i Touring",
            "2.0i",
            "2.0 Limited",
            "Sport Limited",
            "2.0i Hybrid",
            "Hybrid 2.0i",
            "Hybrid 2.0i Hybrid Touring",
            "Limited",
            "Touring",
            "Hybrid 2.0i Hybrid",
            "Hybrid",
            "K 2.0 Premium",
            "K 2.0 Limited",
            "K Sport Limited",
            "K 2.0i Hybrid Touring",
            "K 2.0i Hybrid",
            "K",
            "2.0i Hybrid Touring",
            "2.0",
            "Suv",
            "Premium",
            "2.0i Pkg",
            "2.0 I Premiu",
            "Mium",
            "Crosstr",
            "2.0i Touring",
            "Sport Package/touring",
            "Sport Package",
            "Limited Package",
            "Limited Package/sport Package/touring"
          ]
        }
      ]
    },
    {
      "make": "Suzuki",
      "models": [
        {
          "model": "Baleno",
          "series": []
        },
        {
          "model": "Ciaz",
          "series": []
        },
        {
          "model": "Equator",
          "series": [
            "Sport",
            "Base",
            "Premium",
            "Rmz-4",
            "Ba",
            "Sport/rmz-4 Sport",
            "Sp",
            "Rm",
            "Jx V6"
          ]
        },
        {
          "model": "Ertiga",
          "series": []
        },
        {
          "model": "Grand Vitara",
          "series": [
            "Jlx/jlx+",
            "Jlx/limited",
            "Xsport",
            "Luxury",
            "Premium",
            "Appearance/appearance +",
            "Xl-7 Touring/standard/plus",
            "Jls Limited",
            "Limited",
            "Ultimate Adventure",
            "Xl-7",
            "Jlx Limited",
            "Limited/jlx/jlx+",
            "Jlx",
            "Lx",
            "Jls/limited",
            "Ja V6",
            "Jx",
            "Jlx/jlx+/limited",
            "Xl-7 Plus/standard/touring",
            "Ex/lx",
            "Xsport V6",
            "Base (a4)/base (m5)",
            "Js/js+",
            "Jx V6",
            "Jlx V6",
            "Jx/jlx",
            "Xl7 Touring",
            "Premium/premium W/alloy Wheels",
            "Lx/ex",
            "Jls/jls+/limited",
            "Jlx/limited/jx",
            "Js",
            "Jlx/jlx /limited",
            "Um W",
            "Jx/urban",
            "Xl7 Touring/xl7 Limited",
            "Jx/jlx/limited/se",
            "Nd Vita",
            "Jls/limited/jls Se",
            "Limited V6",
            "Premium/premium W",
            "Nture",
            "Xsport W/snrf",
            "Um W/alloy Wheels",
            "Se",
            "Limited/jls",
            "W/spare & Cargo Covers",
            "Luxury V6",
            "Plus/standard/touring",
            "Jlx-L",
            "Jlx/jlx-L/jx"
          ]
        },
        {
          "model": "Ignis",
          "series": []
        },
        {
          "model": "Jimny",
          "series": []
        },
        {
          "model": "Kizashi",
          "series": [
            "Sport Gts",
            "Sport Sls",
            "Se",
            "Gts",
            "Sls",
            "Sx",
            "S",
            "Sp",
            "Sl",
            "Sport",
            "Sls Sport",
            "Gt",
            "Er Edition",
            "Gts Sport",
            "T W/navi",
            "Se Leather Edition",
            "T",
            "Sp Sp"
          ]
        },
        {
          "model": "S-Cross",
          "series": []
        },
        {
          "model": "Swift",
          "series": [
            "Ga",
            "Dlx",
            "Ga/gl",
            "+",
            "Ga/dlx",
            "S",
            "Base",
            "Ga/gs"
          ]
        },
        {
          "model": "Swift+",
          "series": []
        },
        {
          "model": "SX4",
          "series": [
            "Touring",
            "Sport Convenience/sport Road Trip Edition Touring 2",
            "Le/le Popular",
            "Tech Valu Pkg (nav)/premium",
            "Convenience/rally",
            "Convenience",
            "Sport/sport Technology",
            "Premium/tech Valu Pkg (nav)",
            "Convenience/touring",
            "Technology",
            "Sport",
            "Sport S/sport Se",
            "Premium",
            "Le",
            "Hatchback",
            "Le/le Anniversary Edition",
            "Base",
            "Jx",
            "Convenience Regional Edition/regional Edition/touring 2 Regional Edition",
            "Fstbk",
            "Technology (nav)",
            "Rally/convenience",
            "Sport Touring 2",
            "Sport Touring",
            "Tourin",
            " Awd",
            "T S",
            "Ium",
            "T Touring",
            "Jlx",
            "Crossover Technology/premium/tech Valu Pkg (nav)",
            "Tech Valu Pkg (nav)",
            "Sedan",
            "Automatic Awd Technology",
            "Ja",
            "Techno",
            "Le Popular",
            "Sport Fwd",
            "Ing",
            "In",
            "4d",
            "Touring Pkg Awd",
            "Crossover Technology",
            "Crossover Premium",
            "No",
            "Pkg",
            "Conven",
            "Man Touring Pkg Awd",
            "E Popular",
            "Sport Convenience",
            " Valu Pkg (nav)",
            "Ium/tech Valu Pkg (nav)",
            "Man Awd/auto Awd",
            "Auto Sport Touring Pkg",
            "Awd/auto Awd",
            "Sportback",
            "Le Anniversary Edition",
            "Auto Touring Pkg Awd",
            "Sport Se",
            "Sport Touring Pkg Fwd",
            "T",
            "Ing Pkg Awd",
            "Nniversary Edition",
            " Sport Touring Pkg",
            "Auto Awd",
            "Man Fwd/man Le Fwd",
            "Regional Edition",
            "Sport Pkg",
            "Crossover Technology/premium/tech Valu Pkg Nav",
            "Sport Gts",
            "Crossover",
            "Man Fwd/auto Fwd",
            "T Se",
            " Touring Pkg Awd",
            "Tback",
            "Awd",
            "Sover Technology",
            "Fwd/auto Fwd",
            "T Touring Pkg Fwd",
            "Nology",
            "Touring Pkg 2",
            "Sover",
            "Fwd/man Le Fwd",
            "Opular",
            "Sover Premium",
            "Sport S",
            "Man Awd/auto Awd/man Technology Pkg Awd/auto Technology Pkg Awd",
            "Man Awd/auto Awd/man Technology Pkg Awd/auto Technology",
            "Techno Techno",
            "Aero",
            "Aero Jlx"
          ]
        },
        {
          "model": "SX4 Crossover",
          "series": []
        },
        {
          "model": "Vitara",
          "series": [
            "Jls/js",
            "Jlx",
            "Jlx/jx",
            "Jls",
            "Itara Xl7 Touring",
            "Jx",
            "Jlx/ja/jx",
            "V6 Lx",
            "Lx",
            "Suv",
            "Js",
            "Base (a4)/base (m5)",
            "Jx/jlx",
            "Js/jls",
            "Jx/jx+",
            "Ja",
            "Jx 2.0",
            "Itara Xsport"
          ]
        }
      ]
    },
    {
      "make": "Tesla",
      "models": [
        {
          "model": "Model 3",
          "series": [
            "Mid Range/standard Range/standard Range Plus/long Range",
            "Long Range/mid Range",
            "Rear-wheel Drive",
            "Long Range Dual Motor All-wheel Drive",
            "Standard Range Plus Rear-wheel Drive/standard Range Rear-wheel Drive",
            "Performance Dual Motor All-wheel Drive",
            "Standard Range Plus Rear-wheel Drive",
            "Long Range/performance",
            "Long Range/mid Range/standard Range/standard Range Plus",
            "Performance/long Range",
            "Standard Range/standard Range Plus/long Range/mid Range",
            "Standard Range/long Range",
            "Long Range/standard",
            "Long Range",
            "Mid Range/long Range",
            "Range",
            "Standard Range Plus",
            "Mid Range",
            "E",
            "Long Range Battery/performance",
            "Performance",
            "Ev",
            "Range Battery",
            "Standard Range Plus Rear-wheel Drive/standard Range Rea",
            "50",
            "Sport",
            "E Battery",
            "Mid Range Battery",
            "Long Range Dual Motor",
            " Range",
            "Aw",
            "Awd",
            "Nce",
            "Ge Battery",
            "4x",
            "Model 2 4d",
            "Standard/long Range",
            "Ge/performance",
            "Std Range Plus",
            "Performance Dual Motor",
            "Standard Range",
            "Long Range Battery",
            "Ge",
            "Ttery",
            " Range Plus",
            "/long Range",
            "3",
            "Pe",
            "Lr",
            "Standard Range Plus 50",
            "Long Range All-wheel Drive",
            "Long Range Rear-wheel Drive",
            "Performance All-wheel Drive",
            "75d",
            "Long Range Dual Motor All-wheel Drive/rear-wheel Drive",
            "Rwd",
            "Standard Range/standard Range Plus",
            "Rwd/standard Range",
            "Long Range 75d"
          ]
        },
        {
          "model": "Roadster",
          "series": [
            "Sport",
            "2.5",
            "2.5 Base"
          ]
        },
        {
          "model": "Model S",
          "series": [
            "70d/85d/p85d",
            "60/75",
            "100d/75d/p100d",
            "100d/60d/75d/90d/p100d",
            "Plaid Tri Motor All-wheel Drive",
            "85d/p85d",
            "Performance Dual Motor All-wheel Drive",
            "90d/p100d/p85d/p90d",
            "60d/75d/90d/p100d/100d",
            "60d/70d/75d/85d/90d",
            "Dual Motor All-wheel Drive/standard Range",
            "85d",
            "85",
            "P85",
            "60 Kwh Battery/p85",
            "Long Range Dual Motor All-wheel Drive",
            "Performance",
            "P90d",
            "Long Range Dual Motor All-wheel Drive/long Range Plus Dual Motor All-wheel Drive",
            "70d",
            "90d",
            "60/70/85",
            "100d/75d/long Range/standard Range",
            "P85d",
            "60/70/75/85",
            "Performance/signature Performance",
            "60",
            "Long Range",
            "Signature",
            "Dual Motor All-wheel Drive",
            "75d/p100d/100d",
            "P100d/performance/long Range/100d",
            "Standard Range/dual Motor All-wheel Drive",
            "70 Kwh Battery/70/75/60/85 Kwh Battery",
            "100d/long Range/p100d/performance",
            "75d/standard Range/long Range/100d",
            "60 Kwh Battery",
            "Plaid",
            "Long Range Dual Motor All-wheel Drive/long Range Plus D",
            "70",
            "75d",
            "Long Range Plus",
            "100d/90d/75d/60d",
            "75d/100d/p100d",
            "85d/70d/90d/p90d",
            "70 Kwh",
            "100d/90d/75d/60d/p100d",
            "0d/performance",
            "90d/p90d/p100d",
            "Tesla",
            "P9",
            "Roadster",
            "Model 2 4d",
            "100d/p100d/performance",
            "Kwh Battery",
            "85d/p85d/90d/p90d",
            "Attery",
            "90 Kwh Battery",
            "90",
            "Signature Performance",
            "/75d/60d/p100d",
            "/90d/p90d",
            "P85d/90d/p90d",
            "Sat Se",
            "Ev",
            "85d/p85d/70d/90d/p90d",
            "90d/70d/75d/60d/85d",
            "75d/60d/85d",
            "90d/p90d",
            "85 Kwh Battery",
            "P100d",
            "P8",
            "75",
            "/p90d",
            "Dual Motor All-wheel",
            "Plaid Tri Motor",
            "Ge",
            "90d/p90d/p100d/p85d",
            "Ery",
            "Nce",
            "/p100d/p85d",
            "Attery/p85",
            "100d",
            "/p100d",
            "/70d/90d/p90d",
            "60d",
            "Long Range Dual Motor",
            "Pe",
            "5d",
            "100d/75d",
            "P9 P9",
            "S P85",
            "70 70",
            "P90d Awd 85d/p85d",
            "Rear-wheel Drive",
            "Awd"
          ]
        },
        {
          "model": "Model X",
          "series": [
            "Performance Dual Motor All-wheel Drive",
            "60d/70d/75d/90d",
            "Long Range Dual Motor All-wheel Drive/long Range Plus Dual Motor All-wheel Drive",
            "100d/75d/p100d",
            "75d/p100d/100d",
            "75d/100d/p100d",
            "60d/70d/75d/90d/p100d",
            "60d/p100d/p90d",
            "Dual Motor All-wheel Drive",
            "P100d",
            "Plaid Tri Motor All-wheel Drive",
            "P100d/performance",
            "Dual Motor All-wheel Drive/standard Range",
            "75d/p100d/p90d",
            "100d/75d/90d",
            "75d/90d/100d",
            "100d/75d/long Range",
            "90d/75d/100d",
            "Dual Motor All-wheel Drive/plaid Tri Motor All-wheel Drive",
            "Long Range Dual Motor All-wheel Drive",
            "Standard Range/dual Motor All-wheel Drive",
            "75d/standard Range/long Range/100d",
            "Plaid",
            "Plaid Tri Motor All-wheel Drive/dual Motor All-wheel Drive",
            "Long Range",
            "75d/long Range/100d",
            "100d/75d/long Range/standard Range",
            "60d",
            "Standard Range",
            "75d",
            "100d",
            "Performance",
            "70d/90d/75d/60d/p100d",
            "P90d/75d/p100d",
            "Nce",
            "Rformance",
            "Long Range Plus",
            "Dual Motor All-wheel Drive/plaid Tri Motor All-wheel Dr",
            "Ge",
            "75",
            "Long Range Dual Motor",
            "Long Range Dual Motor All-wheel Drive/long Range Plus D",
            "P90d/p100d",
            "P90d/60d/p100d",
            "70d/90d/75d/60d",
            "75d/60d/p100d",
            "/p100d",
            "Dual Motor All-wheel",
            "P90d",
            "90d",
            "75d/60d",
            "Plaid Tri Motor",
            "P100d/p90d",
            "100d/75d",
            "Awd",
            "Awd/standard Range",
            "Awd/plaid",
            "100d/75d/base W/extended Range (disc)/long Range/standard Range",
            "Long Range/long Range Plus"
          ]
        },
        {
          "model": "Model Y",
          "series": [
            "Long Range Dual Motor All-wheel Drive",
            "Awd/long Range Dual Motor All-wheel Drive",
            "Performance Dual Motor All-wheel Drive",
            "Awd/performance Dual Motor All-wheel Drive",
            "Rwd",
            "Performance Dual Motor All-wheel Drive/awd",
            "Long Range",
            "Long Range Dual Motor All-wheel Drive/performance Dual Motor All-wheel Drive",
            "Standard Range Rear-wheel Drive",
            "Performance Dual Motor All-wheel Drive/long Range Dual Motor All-wheel Drive",
            "Sl 500",
            "Performance Dual Motor All-wheel Drive/standard Range Rear-wheel Drive",
            "Long Range/rwd",
            "Performance",
            "Del Y",
            "Long Range Dual Motor All-wheel Drive/rwd",
            "Long Range Awd",
            "75d Long Range",
            "Y",
            "Long Range/performance",
            "Ge/performance",
            "Awd",
            "Standard Range",
            "Long Range Dual Motor All-wheel Drive/performance Dual ",
            "Nce",
            "Long Range Dual Motor",
            "Long Range Dual Motor All-wheel Drive/performance Dual",
            "Ge",
            " Range",
            "Performance Dual Motor",
            "Ev",
            "Performance Dual Motor All-wheel Drive/standard Range R",
            "Performance/standard Range",
            "Long Range/long Range Launch Series",
            "Long Range Dual Motor All-wheel Drive/long Range Launch Series",
            "Long Range/performance Dual Motor All-wheel Drive"
          ]
        }
      ]
    },
    {
      "make": "Toyota",
      "models": [
        {
          "model": "86",
          "series": [
            "Base",
            "Gt/trd Se",
            "Trd Se",
            "Special Edition",
            "860 Special Edition",
            "Gt",
            "Gt/hakone Edition",
            "Trd Special Edition",
            "Gt/special Edition",
            "Hakone Edition",
            "E",
            " Special Edition",
            "Cial Edition",
            " Se",
            "Base (a6)",
            "86 Gt",
            "Base Base",
            "Gt Gt"
          ]
        },
        {
          "model": "4Runner",
          "series": [
            "Sr5 V6",
            "Vn39 Sr5",
            "Sr5",
            "Limited",
            "Limited V6",
            "Trd Off Road Premium",
            "Limited V8",
            "Sr5 Premium",
            "Venture",
            "Venture Special Edition",
            "Sr5 Sport V6",
            "Trd Pro",
            "Sr5 Sport V8",
            "Limited/sr5/sr5 Premium",
            "Sr5/sport",
            "Sr5 V8",
            "Sr5/sr5 Premium",
            "Sr5/limited/trail/trd Pro",
            "Se",
            "40th Anniversary Se",
            "Rn60",
            "Trail Special Edition",
            "Sr5 Prem/ltdl/trail/trd",
            "Sport V6",
            "Trd Off Road",
            "Sr5/limited/limited Night",
            "Sr5/limited/sr5 Premium",
            "Sr5 V6 Limited",
            "Sr5 Sport V6/sr5 V6",
            "Trail Premium",
            "Sr5 Sport V8/sr5 V8",
            "Limited Nightshade",
            "Se/sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Prem/trd Pro",
            "Sr5/sr5 Premium/venture/trail/limited Night Shade/trd Off Road/trd Off Road Prem/trd Pro",
            "Limited/limited Nightshade/sr5/sr5 Premium/trd Off Road/trd Off Road Premium/trd Pro",
            "Trail",
            "Nightshade Special Edition",
            "Limited V6/sr5 V6",
            "Night Shade",
            "Rn37",
            "Sr5/limited",
            "Trd Sport",
            "Limited/sr5/sr5 Premium/trail/trail Premium/trd Pro",
            "Base (a5)",
            "Sr5/trail/sr5 Premium/limited/night Shade",
            "Sr5/sr5 Premium/venture/t",
            "Limited/sr5/sr5 Premium/trail/trail Premium",
            "Sr5/sr5 Premium/venture/l",
            "Sr5/limited/trail",
            "Sr5/sr5 Premium/limited/trd Off Road/trd Off Road Premium/trd Pro/limited Nightshade",
            "Vn29 Sr5",
            "Se/sr5 Premium/limited/tr",
            "40th Anniversary Special Edition",
            "Sr5/limited/limited Night Shade/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5/trail/sr5 Premium/lim",
            "Limited/sr5/sr5 Premium/trd Off Road/trd Off Road Premium/trd Pro",
            "Limited V6/sr5 V6/trail V6",
            "Sr5 Premium/trail Premium",
            "Trd Sport/sr5 Premium",
            "Limited/trail/trail Premium/trd Pro/sr5/sr5 Premium",
            "Sr5/sr5 Premium/limited/n",
            "Sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Prem/trd Pro",
            "Sr5/limited/limited Night Shade",
            "Trail/sr5/sr5 Premium/lim",
            "Limited/sr5/trail",
            "Sport V6/sr5 V6",
            "Vn66 Sr5",
            "Sr5 Premium/venture/trd O",
            "Ltd",
            "Sr5 Sport",
            "Sr5/trd Sport/sr5 Premium",
            "Sr5/trd Sport/sr5 Premium/limited",
            "Trail/sr5/sr5 Premium/limited/night Shade",
            "Sr5/sr5 Premium/trail/limited/trd Sport/trd Off Road/trd Off Road Prem/trd Pro",
            "Sr5/trd Sport/trail/sr5 Premium/limited",
            "Limited/sr5",
            "Sport V8",
            "Sr5 Premium/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Night Shade/limited",
            "Sr5/sr5 Premium/venture/limited/night Shade/trd Off Road/trd Off Road Prem/trd Pro",
            "Sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Prem/trd Pro",
            "Sr5 Premium/trd Sport/trd",
            "Sr5/trd Sport/trail/sr5 P",
            "Sr5 Premium/limited/trd S",
            "Se/sr5/sr5 Premium/limite",
            "Se/sr5 Premium/trd Sport/",
            "Sr5 Premium/venture/trd Off Road/trd Off Road Premium/trd Pro",
            "V6",
            "R5",
            "Sr5/sr5 Premium/limited/t",
            "R5/sr5 Premium",
            "Limited/limited Nightshade/sr5/sr5 Premium/trd Off Road/trd Off Road Premium/trd",
            "Venture/trd Pro/trd Off R",
            "Sr5/sr5 Premium/limited",
            "Sr",
            "Sr5/trail/limited",
            "Rn27",
            "Li",
            "Parts Only",
            "Sr5 Premium/trd Sport/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/trail/lim",
            "Se/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Prem/trd Pro",
            "Trail V6",
            "Se/sr5 Premium/trd Sport/trd Off Road Premium/trd Pro",
            "Ouble Cab Prerunner",
            "Trail/sr5/limited",
            "Limited/trail/sr5",
            "4 Runner",
            "Sr5 Prm/ltd/trl/tlprm/trd",
            "Sport/trail/sr5 P",
            "40th Anniversary Special",
            "Ade/limited",
            "4d",
            "Trd Pro/trd Off R",
            "5/sr5 Premium/lim",
            "T/sr5 Premium",
            "Iversary Special",
            " 4 Runner",
            "R5 Premium/limite",
            " Sr5/sport",
            "Limited/trd Off Road/trd Off Road Premium/trd Pro/limited Nightshade/sr5/sr5 Pre",
            "5/limited",
            "Premium/venture/t",
            "Ted",
            "4runr Lmtd",
            "Ted/trail",
            "Ted/sr5 Premium",
            "Trail/sr5",
            "Ted/trail/trd Pro",
            "Ted/limited Night",
            "Ium/trd Sport/trd",
            "De",
            "L/limited",
            "Road Premium",
            "Premium/limited",
            "T",
            " Sr5/limited/trail/trd Pro",
            "Ecial Edition",
            "Road",
            "Sr5/sr5 Premium/venture/limited/night Shade/trd Off Roa",
            "40th Anniversary Se/sr5 P",
            " Sr5 Premium",
            "Limited/limited Nightshade/sr5/sr5 Premium",
            "Sr Sr",
            "Sr5/sr5 Premium/venture/trail/limited Night Shade/trd O",
            "Sr5/limited/limited Night Shade/trd Off Road/trd Off Ro",
            "Forerunner",
            "Sr5/sr5 Premium/limited/trd Off Road/trd Off Road Premi",
            "Remium/limited/tr",
            "V6 -v6",
            "Sr5/sr5 Sport",
            "Remium/trd Sport/",
            "Ium/venture/trd O",
            "Sport V8/sr5 V8",
            "De Special",
            "Sr5/trd Sport",
            "Sport/trail",
            "Sr5/sr5 Premium/limited/nightshade/trd Off Road/trd Off",
            "Sr5 Premium/trd Sport/trd Off Road/trd Pro",
            "L",
            "Sr5 Premium/venture",
            "Sr5/sr5 Premium/trail/limited/trd Sport/trd Off Road/tr",
            "Se/sr5 Premium/limited/trd Sport/trd Off Road/trd Off R",
            "Emium",
            "Limited/sr5/sr5 Premium/trd Off Road/trd Off Road Premi",
            "Fourunner",
            "/ltdl/trail/trd",
            " Sr5",
            "L/sr5 Premium/lim",
            "Premium/trail/lim",
            "Premium/venture/l",
            "Sport",
            "Ium/venture/trdor",
            "Premium/limited/n",
            "Sport/sr5 Premium",
            "Sr5/trail",
            "Nightshade Special",
            "Se/sr5",
            "Venture/trd Pro",
            "Sr5 Premium/trd Sport/trd Off Road/trd Off Road Premium",
            "Sr5/sr5 Premium/limited/night Shade",
            "Se/sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd O",
            "Sr5 Premium/venture/trd Off Road/trd Off Road Premium/t",
            "Sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd Off",
            "Forunner",
            "-V6",
            "Lt",
            "4 Runr Sr5",
            "Tr",
            "Nightshade",
            "Ium",
            "Limited/limited Nightshade/sr5/sr5 Premium/trd Off Road",
            "Sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road",
            "Ve",
            "Sr5/sr5 Premium/sr5 Limit",
            "4 Run Lmtd",
            "Ni",
            "Sr5 Premium/venture/trdor",
            " Sr5/sr5 Premium/venture/l",
            "4 Runner S",
            "4-Runner",
            "Trail/trail Premium",
            "4 Run",
            "Er",
            "Tr Tr",
            "Venture/trd Pro/trd Off Road/sr5 Premium",
            " 4 4-runner 4",
            "4run Limit",
            "Sr5/sr5 Premium/venture/limited/trail/night Shade/trd O",
            "It",
            "R",
            "Forrunner",
            "40",
            "Au",
            "R5 4 Runr Sr5",
            "/sr",
            "Li Li",
            "Td Ltd",
            "40th Anniversary Se/sr5 Premium/trd Sport/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/limited/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/limited/nightshade/trd Off Road/trd Off Road Premium/trd Pro/venture",
            "40th Anniversary Se/sr5 Premium/trd Sport/trd Off Road",
            "Sport Sr5 V8",
            "Sr5/sr5 Premium/venture/limited/night Shade/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/limited/limited Night Shade/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Limited 4wd Limited",
            "4d 4x2",
            "Base (a4)",
            "Se/sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Limited/trail/sr5/sr5 Premium/trail Premium/trd Pro",
            "Sr5/sr5 Premium/venture/trail/limited Night Shade/trd Off Road/trd Off Road Premium/trd Pro",
            "Se/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/limited/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Sr5/sr5 Premium/trail/limited/trd Sport/trd Off Road/trd Off Road Premium/trd Pro",
            "Er Limited",
            "Td",
            "Sr5/limited/limited Night Shade/sr5 Premium",
            "Sr5/sr5 Premium/limited/limited Night Shade/trd Off Roa",
            "E Gls",
            "Badlands",
            "Sr5/sr5 Premium/venture/limited/trail/night Shade/trd Off Road/trd Off Road Premium/trd Pro"
          ]
        },
        {
          "model": "Avalon",
          "series": [
            "Xl",
            "Limited/xls/xl",
            "Base",
            "Touring",
            "Hybrid Xle Touring",
            "Limited",
            "Xse Nightshade Hybrid",
            "Xle Premium",
            "Hybrid Limited",
            "Xle",
            "Xls",
            "Hybrid",
            "Xse",
            "Xle/xle Plus",
            "Limited/xle/xle Premium/xle Touring/xle Touring Se",
            "Xl/xls",
            "Xls W/bucket Seats",
            "Xl/xls/touring/limited",
            "Limited/xls/touring/xl",
            "Premium/touring/limited",
            "Xl/xls/limited",
            "Hybrid Xle/xse/limited",
            "Xle Touring",
            "Hybrid/prem/tour/ltd",
            "Xle Touring Se",
            "Hybrid Xle Premium",
            "Trd",
            "Xle/premium/touring/ltd",
            "Hybrid Xle",
            "Night Shade",
            "Xle Plus/premium/tour/ltd",
            "Limited/touring/xl/xls",
            "Hybrid/plus/xle Prem/ltd",
            "Limited/touring/xle/xse",
            "Xse Hybrid",
            "Xl W/bench Seat/xl W/bucket Seats/xls W/bench Seat/xls W/bucket Seats",
            "Limited/xl/xls",
            "Xle Hybrid",
            "Hybrid Hybrid/prem/tour/ltd",
            "Xle/xse/limited/touring",
            "Xle Plus",
            "Limited/xle/xle Premium/xle Touring",
            "Hyb",
            "Hybrid Xse",
            "Xle/xse/limited",
            "Xls/xl",
            "Limited Hybrid",
            "Night Shade/trd",
            "Xl W/bucket Seats",
            "Hybrid Limited/xle Premium/xle Touring",
            "Touring/limited/xls/xl",
            "Touring/xls",
            "Xl W/bench Seat",
            "Xl/touring/xls/limited",
            "Hybrid Limited/xle/xse",
            "Xse/trd",
            "Xse Nightshade",
            "Base/prem",
            "Limited/xle",
            "Lim",
            "Limited Awd",
            "E",
            "Hybrid Limited/xle Touring",
            "Hybrid Xle Touring/limited",
            "Xle/touring/limited/xse",
            "Xls Xls",
            "Hybrid Limited/xle/xle Premium",
            "Limited/touring/xle/xle Plus/xle Premium",
            "Xl W/bucket Seats/xl W/bench Seat/xls W/bucket Seats/xls W/bench Seat",
            "Hybrid Hybrid/plus/xle Prem/ltd",
            "Limited/xle Touring/xle/xle Premium/xle Touring Se",
            "Hybrid Xle Premium/limited",
            "Xle/limited",
            "Bas",
            "Limited/touring/xle",
            "Plus/xle Prem/ltd",
            "Hade",
            "Htshade/trd",
            "4d",
            "Base/prem/tour/ltd",
            "S/premium/tour/ltd",
            "Ited",
            "/touring/xle",
            "/limited/touring",
            " Plus",
            "/touring/limited",
            "Ring/limited/xse",
            "Prem/tour/ltd",
            "Xls W/bench Seat",
            "/limited",
            "Mium/touring/ltd",
            "Xle Awd",
            "/lim",
            "L",
            "Hybrid Xse Nightshade",
            "Avallon",
            "Hade/trd",
            "Xl/",
            "Alvalon",
            "Avlnxl/xls",
            "-V6",
            "Limited/xle/xle Plus/xle Premium/touring",
            "Xse Nightshade/trd",
            "Hybrid Xle Plus",
            "Tou",
            "Nig",
            "Ult",
            "Ud2000",
            "Xl Xl",
            "Hyb Hyb",
            "Avolon",
            "Lx",
            "Av Hyb/xle",
            "Av Xle/xle",
            "Xl/ Xl/",
            "Xls Avlnxl/xls",
            "Lx Lx",
            "Xle Xle",
            "Tou Tou",
            "Xle/limited/xle Premium/xle Touring",
            "Trd Trd",
            "Limited/touring",
            "Xle Xle Plus",
            "Hyb Hybrid/prem/tour/ltd",
            "Olara Se",
            "(canada)"
          ]
        },
        {
          "model": "Avanza",
          "series": []
        },
        {
          "model": "bZ4X",
          "series": [
            "Limited",
            "Xle/limited",
            "Xle",
            "Le",
            "Imited",
            "L/le",
            "Limit",
            "Limited/xle"
          ]
        },
        {
          "model": "C-HR",
          "series": [
            "Xle",
            "Xle Premium",
            "Le",
            "Limited",
            "Xle/xle Premium",
            "Le/limited/xle",
            "Xle/night Shade/limited",
            "Nightshade Edition",
            "Limited/xle Premium",
            "Le/limited/xle Premium",
            "Xle/le/limited",
            "Xle/le/night Shade/limite",
            "Xle/le/night Shade/limited",
            "Base (cvt)/xle",
            "Le/xle/limited",
            "Chr",
            "Ight Shade/limited",
            "E/limited/nightshade",
            "Imited/nightshade",
            "E/limited",
            "Le Premium",
            "E/night Shade/limite",
            "Ch-R",
            "Xle F",
            "Ed",
            "Limited/xle/le",
            "E",
            "Nightshade",
            "Remium",
            "Xle/le",
            "Le/xle/limited/nightshade",
            "Xle/limited/nightshade",
            "Xle/x",
            "Lmtd",
            "Xle/l",
            "Xle/x Xle",
            "Limited/nightshade/xle",
            "Le/limited/nightshade Edition/xle"
          ]
        },
        {
          "model": "Camry",
          "series": [
            "Xle V6",
            "Le",
            "Hybrid",
            "Se",
            "Std",
            "Solara Sle",
            "L",
            "Xse",
            "Base",
            "Ce",
            "Solara Se Sport",
            "Se Awd",
            "Xle",
            "Hybrid Xle",
            "Se Hybrid",
            "Se V6",
            "Le Hybrid",
            "Se Nightshade Edition Awd",
            "Se/le/xle",
            "Se Nightshade Edition",
            "Le V6",
            "Le Awd",
            "Solara Se V6",
            "Xse V6",
            "Dx/le/xle",
            "Hybrid Le",
            "Xse Hybrid",
            "L/le/xle/se/xse",
            "Hybrid Se Limited Edition",
            "Trd",
            "Night Shade",
            "Solara Se",
            "L/le/se/se Sport/xle",
            "Solara Se/sle",
            "Ce/xle/le/se",
            "Le/xle/se",
            "Se Night Shade",
            "Solara Se Sport V6/se V6/sle V6",
            "L/le/xle/se/se Sport",
            "Xle/le/se",
            "Le/xle/ce",
            "Ce/le/xle",
            "Xle/se Sport/se/l/le",
            "Ce/xle/se/le",
            "Xle/se/std/le",
            "Solara Se V6/sle V6",
            "Ce/le/se/xle",
            "Le/se Sport/xle/se/l",
            "Xle/se/le",
            "Xse Awd",
            "Ce/xle/le",
            "Hybrid Le/se Limited Edition/xle",
            "Le/xle/xse/se",
            "Se Sport",
            "Se Night Shade/se",
            "Hybrid Se",
            "Ce/le/xle/se",
            "Le/xle/se/xse",
            "Dx",
            "Le/xle/se/",
            "Xle Hybrid",
            "Le/se/xle",
            "Nightshade Edition Hybrid",
            "Se Limited Edition",
            "L/se/le/xle",
            "L/le/se/xle",
            "Xle Awd",
            "Se Nightshade Edition/se Nightshade Edition Hybrid/se",
            "L/le/se/se Limited Edition/xle",
            "Le/se/std/xle",
            "Hybrid/le/xle/se",
            "Se V6/xle V6/le V6",
            "Se/se Night Shade",
            "Hybrid/le/xle",
            "Hybrid Hybrid",
            "Solara Se/sport/sle",
            "Trd V6",
            "Solara Sle V6",
            "Hybrid Le/xle",
            "Le/xle",
            "Solara Sport",
            "Se Nightshade",
            "Se/se Nightshade Edition",
            "Hybrid Hybrid/le/xle",
            "Std/le/se/xle",
            "Le/se",
            "Se/night Shade",
            "Hybrid Le/se/xle",
            "Dlx",
            "A Xle",
            "Le V6/xle V6",
            "Solara Se Sport V6",
            "Le V6/se V6/xle V6",
            "Le/se/xle/xse",
            "Xse/xle",
            "Se V6/xle V6",
            "Se Nightshade Edition Hybrid",
            "Hybrid Xse",
            "Trd/xse",
            "Hybrid Se Limited Edition/xle/le",
            "Xle/le/std/se",
            "Se/se Nightshade Edition/se Nightshade Edition Hybrid",
            "Hybrid Se/se Nightshade",
            "Solara Se/sle/sport",
            "Hybr",
            "Hybrid Se Night Shade/se",
            "Xle V6/xse V6",
            "Se/xle",
            "Night Shade/se",
            "Solara Se/spt/sle",
            "Ce/ce V6/le",
            "Xse/",
            "Xle/se/le/xse/se W/special Edition Pkg",
            "New Generat Le/xle/se",
            "Xle/se/le/xse",
            "Xle V6/le V6",
            "Hybrid Hybrid/le/xle/se",
            "L/le/se/xle/se Sport Limited Edition",
            "Xle/se/l/le",
            "Se Limited Edition/xle/se/l/le",
            "Trd/xse V6",
            "Hybrid Se Nightshade",
            "Xle/le",
            "Se Nightshade Special Awd",
            "A Base",
            "A Le",
            "Le/se/xle/std",
            "Hybrid Le/xle/se",
            "Hybrid Se/xle",
            "Se Awd/se Nightshade Edition Awd",
            "Xle/se",
            "New Generation Ce",
            "Solara Sport V6",
            "Ce/le/xle/se Le",
            "Ce V6/le V6/xle V6",
            " Xl",
            "Solara Sle Automatic",
            "Base (retail Orders Only) (a5)/le/se/xle",
            "Base (retail Orders Only) (a5)",
            "Ce/le",
            "Le/se/xle/l",
            "Dx/le",
            "V6",
            "Se/le/xle/xse",
            "A Ve",
            "Solara",
            "470",
            "Hybrid Xle/le",
            "Le A",
            "Solara Se V6/sle V6/sport V6",
            "Xse/xle/le/se",
            "Se/se Nightshade",
            "Se/xle/xse",
            "Se/se Limited Edition",
            "350 4matic",
            "Se Xse Awd",
            "L/le",
            "Se N",
            "Ce V6/le/xle V6",
            "Xse/xse V6",
            "Hybrid Base (e-cvt)",
            "Ce V6/xle V6",
            "Solara Se V6 / Sle V6",
            "Solara Se/se Sport/sle",
            "Se Nightshade/se Nightshade Edition",
            "Ce/le/xle V6",
            " Se",
            "Se Hybrid/se Nightshade Edition Hybrid",
            "Le/le V6/se V6/xle V6",
            "Se W/special Edition Pkg",
            "New Generation Hybrid",
            "/se/l",
            "Le/s",
            "/le/xse",
            "Le/x",
            "Hybrid Le/xle/se Limited Edition",
            "L/se",
            "New Generation Le",
            "Le Hybrid/camry Xle",
            "Le/c",
            "Camray",
            "4d 2wd",
            "Se Nightshade Edition/se",
            "Hyb Le",
            "Solara Sle/se",
            "Hybrid Xle/se/le",
            "Std/le/xle/se",
            "Hybrid Base Cvt",
            "Hybrid Base Retail Orders Only Cvt",
            "Ce A",
            "Le/x Le/x",
            "Xlt",
            "Se/x",
            "Xle/se/xse/le",
            "Ce M Ce M",
            "Le A Le A",
            "S",
            "Le/se/xse",
            " Xle",
            " Le",
            "Le/se/se Sport",
            "Ce/l",
            " Xse",
            "E",
            "Se/nitshd",
            "Shade/se",
            "Nightshade",
            "Ht Shade/se",
            "/le/xle",
            "Ht Shade",
            "/le/xle/se",
            "Le 4",
            "Htshade",
            "Xle Premium",
            "Hyb Le/se/xle",
            "Base (retail Orders Only) (m5)",
            "Camrey",
            "Ls",
            "Sola",
            "Ce Ce",
            "Xle/xse/se/le",
            "D",
            "Auto Auto",
            "Solara Se/sle/se Sport",
            " Ex",
            "Base/se/le/xle",
            "Sr/sl/s/sv/fe+ S",
            "Rt",
            "Ited Edition",
            "S/le/xle",
            "Hybrid Base (retail Orders Only) (cvt)",
            "Std/",
            "/le/",
            "Ba",
            "L/",
            "Auto",
            "Carmry",
            "Hyb Le/xle",
            "Rid",
            "300",
            "L/le/se",
            "Le/",
            "New",
            "Se/se Black Edition/se Te",
            "4d 2 4d 2",
            "Ce/c",
            " Ce",
            "-v6 S",
            "Le X",
            "Ex",
            "4d",
            "Se/l",
            "Le H",
            "-4 Cy",
            "Nigh",
            "Camary",
            "Se Sport Limited Edition",
            "4c",
            "Camery",
            "Se/s",
            "L Au",
            "Se A",
            "Camary Se",
            "Rt 100th Anniversary",
            "Le M",
            "4d 2",
            "/le/x",
            "E/xle",
            "-Le",
            "Xle/l",
            "/se/xse",
            "Camy",
            "Le/se/xle/xse, Sd, 3.5",
            "Nigh Nigh",
            "Le/camry Se/camry Xle",
            "Nder S",
            "Seda",
            "Ce L",
            "- Se",
            "Se S",
            "Trd Trd",
            "Parts",
            "Se V",
            "Cam",
            "Le/xl",
            "Manu",
            "Cmry Le/se",
            "Cam Sol",
            "1.8",
            "Cam Dlx Wg",
            "Le Le",
            "Xl",
            "Sole",
            "Carmy",
            "L Le",
            "Ce 4",
            " S/w",
            "- Ov",
            "All-Trac",
            "Her Uk",
            "Se A Se A",
            " Solora",
            "Xle Xle",
            "4wd 4wd",
            "Her 033fg35",
            "Solara V6",
            "Ce V6",
            "Se Upgrade",
            "Base (retail Orders Only) (a6)",
            "A Ce",
            "Awd Hybrid 4d Sedan Xle",
            "Se/se Nightshade/hybrid Se Nightshade",
            " Equipment Reel Trailer",
            "Se/se Sport",
            "Ile Other",
            "V6 S",
            "Sel",
            "4 Cy",
            "Hyb",
            "1lt",
            "A Se",
            " Automatic Le",
            "Trd V6/xse V6",
            " 2.5",
            "Nightshade Edition Hybrid/se Hybrid",
            "Solara Se V6/sle",
            "Trd/trd V6",
            "Xxe Xse"
          ]
        },
        {
          "model": "Corolla",
          "series": [
            "Ce",
            "Se Nightshade Edition",
            "S",
            "Le",
            "L",
            "Base",
            "Se",
            "S Plus",
            "Xle",
            "Le Plus",
            "Hybrid Le",
            "Matrix S",
            "Ce/le",
            "S Premium",
            "Xse",
            "Night Shade",
            "Se/night Shade",
            "Ve",
            "Le/s/l",
            "Ce/s/le",
            "Le/se Special Edition/xle/xse/se/l",
            "Ce/le/ve",
            "Se Apex Edition",
            "S Plus/s Premium/s/le Plus/le Premium/le/l",
            "Sr5",
            "(u.s.) Ve/ce/le",
            "Dx",
            "(u.s.) Ce/le/s",
            "Ce/le/s",
            "S/le/xle",
            "Cor L/le/lepl/pr/s/spl/pr",
            "Se Special Edition/xle/le/xse/se/l",
            "Xle/le/s",
            "S Plus/s Premium/s/le Plus/le Premium/l/le",
            "Se Special Edition",
            "Im",
            "Dlx",
            "L/le/s/s Plus/le Plus",
            "Eco",
            "Le Eco",
            "Ve/ce/le",
            "Matrix Xr",
            "Std",
            "Le Eco/le Eco Plus/le Eco Premium",
            "Nightshade Edition",
            "L/le/le Plus/le Premium/s/s Plus/s Premium",
            "Le Eco Plus",
            "Le/dx",
            "Le/s/xle",
            "Matrix",
            "Matrix Base",
            "Matrix Xrs",
            "L/le/le Pls/prm/s/s Pls",
            "L/le/s/s Special Edition/le Special Edition",
            "Le/se/xle",
            "S/le",
            "L/le/xle/se/xse",
            "Se/xse/night Shade",
            "Hybrid Se",
            "L/le/le Plus/le Premium/s/s Plus/s Premium/s W/special Edition Pkg",
            "L/le/se/xle/xse",
            "Le/s",
            "Xrs",
            "Le/xle",
            "S W/special Edition Pkg",
            "L/le/le Special Edition/s/s Special Edition",
            "L/le/xle",
            "Se 6mt",
            "L/le/s",
            "S Special Edition",
            "Ce/se/le",
            "Ce/le/se",
            "Hybrid Le/se",
            "Fx16",
            "Le Premium",
            "L/le",
            "Hybrid Xle",
            "Se/xse",
            "Hybrid Le/hybrid Nightshade Edition/hybrid Se/hybrid Xle",
            "Hatchback",
            "Le Eco Premium",
            "L/le/se/se Special Edition/xle/xse",
            "Ce/le/sport",
            "Le/se/xle/night Shade",
            "Gt-S",
            "Le Special Edition",
            "Fx",
            "L/le/le Plus/premium/s/s Plus/premium",
            "L/le/s/s Plus/le Plus/le Premium/s Premium",
            "Nvenience",
            "Eco/eco Plus/eco Premium",
            "Le/eco",
            "Hybrid Le/hybrid Se/hybrid Se Infrared/hybrid Xle",
            "Double Cab Sr5",
            "Xle/s/le",
            "L/le/s/s Plus/le Plus/le Premium/s Premium/s W/special Edition Pkg",
            "Hybrid",
            "S Plus/s Premium/s W/special Edition Pkg/le/le Plus/le Premium/s/l",
            "Xse/se",
            "Deluxe",
            "Hybrid Se Infrared",
            "Se Apex Edition/se Nightshade Edition/se",
            "Hybrid Base W/li Battery",
            "Le/xle/xse/se/l",
            "Cr",
            "S/le/l",
            "S Plus/s Premium/s W/special Edition Pkg/s/le Plus/le Premium/l/le",
            "Hybrid Le/se/xse",
            "Sport",
            "Le/se/night Shade",
            "Le/dlx",
            "L/le/xle/se",
            "N",
            "Nightshade Edition/se",
            "Base/s/le/xle",
            "Se  6mt",
            "Se/xle/xse",
            "Se/se Nightshade Edition",
            "Le/nightshade Edition/se/xse",
            "Sport Sr5",
            "Ce Anniversary Edition",
            " Base",
            "Le Eco/le Eco Technology",
            "Base (cvt)",
            "Le/le Plus/le Premium",
            "Hybrid Nightshade Edition",
            "Ce/sport/le",
            "Le/l/xle",
            "S/s Plus/s Premium",
            "S/s Special Edition",
            "Le Eco/le Eco Upgrade",
            "Le/le Special Edition",
            "(u.s.)",
            "Xr",
            "50th Anniversary Special",
            "Se/nightshade/apex Se",
            "Hybrid Se/xse",
            "Le Hybrid",
            "L/le/xle/se/50th Anniversary Special Edition/xse",
            "Sd",
            "Se Hybrid",
            "Awd",
            "Ha",
            "Xse Apex Edition",
            "Se/se Apex Edition/se Nightshade Edition",
            "Ce Special Edition",
            "Xse/xse Apex Edition",
            "Se/se Nightshade Edition/xse",
            "Xs",
            "Sport Gt-s",
            "Gls/limited",
            "Ba",
            "/se/xse",
            "Se/nightshade",
            "Ec",
            "/se",
            "/s/",
            "Ma",
            "Hatchback Se/xse",
            "Std/s/le/xle",
            "Le/se",
            "B/s/le",
            "Apex Xse",
            "Ba Ba",
            "Se Se",
            "Cv1",
            "L Edition",
            "Coroll",
            "Crs L",
            "S Special Edition/le/le Special Edition/s/l",
            "S Plus/s Premium/le/le Plus/le Premium/s/l",
            "Xle/xse",
            "Pls/prm/s/s Pls",
            "Shade",
            "Shade/apex Se",
            "Ghtshade/apex Se",
            "Coroilla",
            " Shade",
            "Carrolla",
            "Ight Shade",
            "Corrola Le",
            "Plus/eco Premium",
            "Iversary Special",
            " Xse",
            "Sp",
            "Supercrew",
            "K1500",
            "Hy",
            "Le Le",
            "L/le/s/s Plus/le Plus/le Premium/s Premium/s W/special ",
            "Le Special Edition/s Special Edition",
            "Corollo",
            "Touring",
            "50th Anniversary Special Edition",
            "K1500 Lt",
            "Corolaa",
            "Special Ed",
            "K1500 Ltz",
            "Xle/se Special Edition/xse/l/le/se",
            "Xle/le/xse/se/l",
            "Xle/se Special Edition/xse/le/l/se",
            "S Plus/s Premium/s W/special Edition Pkg/s/le Plus/le Premium/le/l",
            "Ial Edition Pkg",
            "Carola",
            "L/le/se",
            "As Bas",
            "Ght Shade",
            "/sr/2.0sl",
            "/ma",
            "M",
            "L/le/le Plus",
            "Rado K2500 Heavy Duty Lt",
            "Le Eco/le Eco Premium/le Plus",
            "Corroll",
            " S",
            "S/ /s/",
            "Corrola S/",
            "Coroalla",
            "Std/le/xle",
            "Hyb",
            "Corilla",
            "Sr/sr5",
            "Lt",
            "Ls",
            "Le Ec",
            "L/le/le Plus/le Premium/s/s Plus/s Premium/s W/special",
            "Hybrid Le/hybrid Nightshade Edition/hybrid Se/hybrid Xl",
            "4d",
            "2w",
            "Cor",
            "L/le/s/s Plus/le Plus/le Premium/s Premium/s W/special",
            "Cross L",
            "2.4 Ex",
            "Corolloa",
            "V2",
            "Co",
            "Corrola Im",
            "2d",
            "4 -4",
            "4",
            "Corlla L L",
            "Corol",
            "Se/apex Se",
            "Hatchback Se/xse/nightshade",
            "L/le/le Plus/premium/s/s",
            "Hatchback Se",
            "Hatchback Xse",
            "Xse/apex Xse",
            "Le L/le/se/xle/xse",
            "Base M5",
            "Corrolla",
            "Apex Se",
            "Corola",
            "L/s/le",
            "Hatchback Se/nightshade/xse",
            "L/",
            "Xl",
            "/le",
            "Carolla",
            "Au",
            "Nightshade",
            " Plus/le Plus",
            "Corrola",
            "S/",
            "E",
            "Cor L/le/l",
            "Se/se Nightshade/apex Se",
            "Ha L",
            "Art",
            "Cross Xle",
            "-4",
            "Corrolla S",
            "/ce",
            "Le/sport",
            "Ma Ma",
            "Xs Xs",
            "Ec Ec",
            "Le/ve/ce",
            "Corola Sr5",
            "5-",
            " Corrolla",
            "Ni",
            "Corlooa",
            "Coroll Dlx",
            "L L",
            "Sr",
            "Sa",
            "Coroll Ltd",
            "/l",
            "W Sw",
            "De",
            "Gt",
            "Orola",
            " Coroilla",
            "Ck 1 Ton Pick",
            "50",
            "La Core",
            "Se/fx",
            "Le Eco Upgrade",
            "S S",
            "Sedan 2wd",
            "Base (a4)",
            "Le Eco Technology",
            "Fx16 Gt-s",
            "Eco/eco",
            "Ce Automatic Ce",
            "Trd Off-road",
            "Base (a4)/le/s/xle",
            "Xl Xl",
            "Lara Se",
            "Cross Se",
            "Dl",
            "*s",
            "S W/continuo S Plus",
            "Truck",
            "Hybrid Xse",
            "Cross Le",
            "L/le/le",
            "Rewmax Sr5",
            "Hybrid Le/hybrid Nightshade Edition/hybrid Se",
            "Hybrid Le/hybrid Se/hybrid Xle",
            "Ce/std",
            "Hybrid Hybrid Le",
            "Xle S/le/xle"
          ]
        },
        {
          "model": "Corolla Cross",
          "series": [
            "Le",
            "L",
            "Xle",
            "Se/xse/night Shade",
            "Hybrid Xse",
            "Hybrid Se",
            "Hybrid Se Hybrid",
            "Se",
            "Hybrid S",
            "Hybrid Xse Hybrid",
            "Hybrid",
            "Hybrid Se/xse/night Shade",
            "Le/xle/s/se/xse",
            "Hybrid Nightshade Edition",
            "Hybrid Nightshade Edition/s/se/xse",
            "Se Hybrid",
            "Hybrid Xle Hybrid",
            "E",
            "S",
            "Xse",
            "Le Le",
            "Hybrid Le/xle/s/se/xse",
            "Hybrid Se/xse",
            "Hybrid Se/hybrid Xse",
            "Xle Awd",
            "Nightshade Edition/s/se/xse",
            "Hybrid S/se/xse"
          ]
        },
        {
          "model": "Corolla iM",
          "series": [
            "Base M6",
            "Base (m6)",
            "Im",
            "W/continu",
            "Base (cvt)"
          ]
        },
        {
          "model": "FJ Cruiser",
          "series": [
            "Base Retail Orders Only A5",
            "Base (retail Orders Only) (a5)",
            "Base (a5)",
            "Fj"
          ]
        },
        {
          "model": "GR 86",
          "series": [
            "Premium",
            "Trueno Edition",
            "Prem",
            "M",
            "Premium/10th Ann Special Edit",
            "True",
            "Hakone",
            "Hako"
          ]
        },
        {
          "model": "GR Corolla",
          "series": [
            "Core",
            "Circuit Edition",
            "Morizo Edition",
            "Circuit",
            "Premium",
            "Core/circuit/premium",
            "Circuit Edition/core/morizo Edition",
            " Edition",
            "Core/morizo Edition",
            "Core/premium/premium Plus",
            "Premium Plus"
          ]
        },
        {
          "model": "GR Supra",
          "series": [
            "3.0 Premium",
            "3.0/3.0 Premium",
            "45th Anniversary Edition",
            "Launch Edition/premium",
            "A91-mt Edition",
            "A91 Edition",
            "Premium/cf Edition",
            "2.0",
            "Launch Edition",
            "3.0",
            "Remium",
            "3.0/3.0 Premium/a91 Edition",
            "3.0/3.0 Premium/a91-mt Edition",
            "Premium/special Edition",
            "Rims"
          ]
        },
        {
          "model": "GR86",
          "series": [
            "Premium",
            "Trueno Edition",
            "10th Anniversary Special Edition",
            "Base (a6)",
            "Base (m6)",
            "Anniversary Special",
            "Um",
            "10th Anniversary Special",
            "2d Rw",
            " Premium",
            "Hakone Edition"
          ]
        },
        {
          "model": "Hiace",
          "series": [
            "Sv"
          ]
        },
        {
          "model": "Highlander",
          "series": [
            "Limited",
            "Se",
            "L",
            "Base V6",
            "Sport",
            "Hybrid Xle Bronze",
            "Xle V6",
            "Xle",
            "Le Plus",
            "V6",
            "Hybrid Limited V6",
            "Le",
            "Hybrid",
            "Limited V6",
            "Limited V6/v6",
            "Hybrid Le",
            "Base",
            "Base Plus V6",
            "Hybrid Platinum",
            "Sport V6",
            "Se V6",
            "Hybrid V6",
            "Sport/limited",
            "Hybrid Xle",
            "Limited/limited Platinum",
            "Hybrid Limited",
            "Le V6",
            "Limited/ltd Platinum",
            "Limited V6/sport V6/v6",
            "Ander Xle",
            "Hybrid Limited Platinum V6",
            "Limited Platinum",
            "Platinum",
            "V6 (a4)",
            "Le Plus V6",
            "Xse",
            "Limited Platinum V6",
            "Se/xle",
            "L/le/xle/limited/platinum",
            "Le/le Plus",
            "Hybrid Limited Platinum",
            "Hybrid Xle Bronze Edition",
            "Hybrid Limited Max",
            "Hybrid Bronze Edition",
            "Hybrid Xle/hybrid Xle Bronze Edition",
            "Hybrid Base V6",
            "Le/xle/xse/limited/platinum",
            "Hybrid Limited/ltd Platin",
            "V6/v6 7 Passenger",
            "L/le/xle/limited/platinum/xse",
            "Sport V6/v6",
            "Sr5",
            "Ander Limited",
            "V6 Limited",
            "Base Plus",
            "Le Plus V6/le V6",
            "Xle/limited/platinum",
            "L/le",
            "Limited/platinum",
            "L/le/limited/platinum/xle/xse",
            "Xle/limited",
            "Plus/se",
            "Hybrid Hybrid",
            "Hybrid Xle/hybrid Bronze",
            "Limited/ltd Platnum",
            "Hybrid Hybrid Limited",
            "Le/limited/xle/xse",
            "Le/xle/xse/limited/platin",
            "Hybrid Limited V6/v6",
            "Base (a4)",
            "Hybrid Platinum Max",
            "Le/l",
            "Limited/v6 (a4)",
            "Hybrid Limited/xle",
            "Limited/xle",
            "Hybrid Le/limited/xle",
            "Hybrid Limited/hybrid Platinum",
            "Plus",
            "V6 Sr5",
            "Base V6/se V6",
            "Hybrid/xle",
            "Hybrid Limited/platinum",
            "Base Plus V6/base V6/se V6",
            "Hybrid Ltd Platinum",
            "Limited/xle/xse",
            "Limited Platinum V6/limited V6",
            "Limited/platinum/xle",
            "Hybrid Xle/hybrid Bronze Edition",
            "Le/limited/platinum/xle/xse",
            "Hybrid Limited/ltd Platinum",
            "V6 Sport",
            "Gls",
            "Hybrid Limited/ltd Platnm",
            "Hybrid Limited/hybrid Pla",
            "Le/xle/xse/limited",
            "W/3rd Row/sport W",
            "Hybrid Hybrid Ltd Platinum",
            "V6 7 Passenger",
            "Hybrid Le Nightshade/hybrid Xle/hybrid Xle Nightshade",
            "Base/se",
            "Hybrid/le",
            "Hybrid V6 (ecvt)",
            "Y Hybrid",
            "Hybrid Limited V6/v6 (ecvt)",
            "Hybrid Limited/limited Platinum",
            "Base W/o 3rd Row (a4)",
            "Le Hybrid",
            "Xle/se",
            "Hybrid W/3rd Row",
            "Se V6/base V6",
            "Ted/ltd Platin",
            "Ted/hybrid Pla",
            "Sport W/3rd Row",
            "Hybrid Bronze",
            "4d 2wd",
            "Hybrid Ltd",
            " Platinum",
            "Ted",
            "Inum",
            "Tinum",
            " Platnum",
            "Limited W/3rd Row",
            "L/le/xle/xse/limited",
            "Hybrid Xle Bro",
            "E/limited",
            "W/3rd Row",
            "Ze Edition",
            "Ander Hybrid Xle",
            "V",
            "Se V6/base Plus V6/base V6",
            "Ander Xle/limited/platinum",
            "Ander Hybrid Max",
            "Ander Xle/limited",
            "Adventure/xle",
            "L/le/xle/limited",
            "Tinum V6",
            "Ander Limited/platinum",
            "Ander Hybrid Limited",
            "Highland",
            "Mited/platinum",
            "Hylander",
            "Hybrid 3rd Row/limited W/3rd Row",
            "Mited",
            "Base A4",
            "V6 A4",
            "3rd Row",
            "Ander Hybrid Limited Max",
            "Ander Platinum",
            "Ander Limited/platinum/xle",
            "Highlnder",
            "Highla",
            "Unknown",
            "Hybrid Limited W/3rd Row",
            "Higlander",
            "Highla Xle",
            "W/3rd Row/limited W",
            "Hybrid Xle/hybrid Xle Bro",
            "Hybrid W/3rd Row/limited W",
            "Hybrid Hybrid Limited/ltd Platnm",
            "Base V6 (a5)",
            "V6 W/3rd Row (a5)",
            "Hilndr Hyb",
            "Hilandr Le",
            "Hybri",
            "Hybrid Xle/hybrid Le",
            "          Highlander",
            "Le Plus/le Plus V6",
            "3rd Row/limited W/3rd Row/sport W/3rd Row",
            "Le Fwd Le",
            "V6 W/o 3rd Row (a5)",
            "Xle Hybrid",
            "Ander Le",
            "Limited V6/v6/v6 W/o 3rd Row (a5)",
            "Medium",
            "Xle/xle V6",
            "Parts",
            "Xse V6",
            "Sr5 V6",
            "Le/limited/xle",
            "Hybrid Platinum/hybrid Xle",
            "Le/limited/platinum/xle",
            "Hybrid Nightshade Edition",
            "Le/xle/limited/platinum",
            "Le/xle/limited/night Shade",
            "Limited 25th Edition"
          ]
        },
        {
          "model": "Hilux",
          "series": [
            "Surf",
            "Ssrs Limited"
          ]
        },
        {
          "model": "Land Cruiser",
          "series": [
            "Hj85",
            "Fj80",
            "V8",
            "Fj62 Gx",
            "Vx-R",
            "Base (a4)",
            "Dj81",
            "Fj60",
            "Heritage Edition",
            "Base (a5)",
            "1958/first Edition",
            "First Edition",
            "V8 A8",
            "Base A4",
            "1958",
            "Vxr/heritage",
            "Vx-R/heritage",
            "Prato"
          ]
        },
        {
          "model": "Matrix",
          "series": [
            "S",
            "Xr",
            "Standard",
            "Xrs",
            "Wagon",
            "L",
            " Matrix Xr",
            " Matrix S",
            " Matrix",
            "Std",
            " Matrix Base",
            "Base",
            "Xr/xrs",
            "Std/xr",
            "B",
            "Standard/xr",
            " Matrix Xrs",
            "Trd Special Edition",
            "Sport",
            "Base (a4)",
            "Sw",
            "Bas",
            "Fam",
            "Standard/std/xr",
            "Matrx",
            "/s",
            "/x",
            "Mattix",
            "/xr",
            "4dr",
            "Man",
            "Standard/std",
            "Matris",
            "Aut",
            "-4 C",
            "Matr",
            "S A",
            "Base (m5)",
            "Corrola",
            "Ma",
            "4x4",
            "Ss"
          ]
        },
        {
          "model": "Mirai",
          "series": [
            "Xle",
            "Le",
            "Limited",
            "Le/xle/limited",
            "Xle/limited",
            "Mirai",
            "/limited",
            "Mited",
            "Limited/xle"
          ]
        },
        {
          "model": "Prius",
          "series": [
            "Two",
            "Le",
            "Three",
            "V",
            "Iv",
            "Ii",
            "C",
            "Iii",
            "Touring",
            "L Eco",
            "Night Shade",
            "Le Awd-e",
            "Prime Se",
            "Three Touring",
            "Four Touring",
            "Five/four/one/three/two",
            "Base (ecvt)",
            "L Eco/le/xle/limited",
            "L",
            "I/ii/iii/iv/v",
            "Base (cvt-e)",
            "Four",
            "Xle",
            "Prime Le",
            "Standard",
            "Xle Awd-e",
            "Prime",
            "Special Edition",
            "Three Se",
            "Limited",
            "Two Eco",
            "Nightshade Edition Awd-e",
            "Five",
            "Plug-In",
            "Le/xle",
            "Limited Awd-e",
            "Night Shade/l/le/xle/limited",
            "Five/four/persona Series Special Edition/three/two",
            "Awd-E",
            "2020 Edition",
            "Limited/xle",
            "Special Edition/l/le/xle/",
            "Persona Series Special Edition",
            "Standard/touring",
            "Four/four Touring/one/three/three Touring/two/two Eco",
            "One",
            "Night Shade/l/le/xle/limi",
            "Le/xle/limited",
            "Ii/iii/iv/v/i",
            "C Technology",
            "One/two/three/four/five",
            "Five/four/three/two",
            "Five/four/three/three Se/two",
            "Touring/standard/base (cvt-e)",
            "Std",
            "Base (cvt)",
            "Four/persona Series Special Edition/five/three/one/two",
            "L/le/xle/limited",
            "Four/five/three/one/two",
            "Nightshade Edition",
            "Technology/touring",
            "Four/four Touring/three/three Touring/two Eco",
            "Technology",
            "L/le/limited/nightshade Edition/xle",
            "2020 Edition/l Eco/le/limited/xle",
            "Awd-e/technology Awd-e",
            "Le/xle/night Shade",
            "Four/four Touring/three/two Eco/three Touring",
            "Special Edition/l/le/xle/limited",
            "One/two/three/four/five/persona",
            "Spec",
            "Prim",
            "I",
            "L Eco/le/xle/limited/20th Anniversary Edition",
            "L Eco/le/xle/limited/nightshade",
            "-4 Cy",
            "Nigh",
            "Base/prius Touring",
            "Le/limited/xle",
            "Plug",
            "/iv/v/i",
            "O/three/four/five",
            "Two/two Eco/three",
            "Hybrid 4d",
            "Type 4",
            "Hybrid",
            "Hyb",
            "/limited",
            "Hyb L/le/xle/ltd",
            "Hybr",
            "Touring/standard",
            "Night",
            "/nightshade",
            "/night Shade",
            "L Edition/l/le/xle/",
            "O Eco/three",
            "Ii/iv/v",
            "Ive/three/one/two",
            "O",
            "Base",
            "Le/limited",
            "Shade/l/le/xle/limi",
            "Five/four/one/persona Series Special Edition/three/two",
            "D",
            "G",
            "Two/two Eco/three/three Touring/four/four Touring/one",
            "Xle/limited/le/2020 Edition/l Eco",
            "Four/four Touring/one/three/two/three Touring/two Eco",
            "Ouring",
            "Base Cvt-e",
            "Se",
            "Special",
            "Our/three/two",
            "Five/four",
            "-E",
            "A",
            "Gls",
            "Hade",
            "L Eco/le/limited/xle",
            "Ii Ii",
            "C Fo",
            "C Hy",
            "Lift",
            "Persona",
            "Pruis",
            "20th Anniversary Edition",
            "Le/xle/nightshade",
            "Persona Series Special",
            "Hy",
            "Pirus",
            "L L",
            "Hybi",
            "Spec Spec",
            "Premium",
            "Prime Limited",
            "C Tw",
            "V Fi",
            "               Prius",
            "Hyb Hyb",
            "C Hy C Hy",
            "Le Le",
            "5",
            "(ov1)",
            "Ra Sel",
            "Le Xle Lim",
            "Le/xle/limited/night Shade",
            "Limi",
            "Nightshade",
            "Five/four/persona/three/two"
          ]
        },
        {
          "model": "Prius AWD-e",
          "series": []
        },
        {
          "model": "Prius C",
          "series": [
            "Two",
            "Four",
            "Three",
            "One",
            "Four/one/three/two",
            "Technology",
            "Persona Series",
            "Four/one/persona Series/three/two",
            "One/three/two/four",
            "L",
            "One/two/three/four",
            "One/two/three/four/persona Series",
            "E/two/four",
            "Le",
            "L/le",
            "Hyb",
            "Three/four",
            "C",
            "Fo",
            "Upgrade",
            "Base (cvt)/technology",
            "Th C"
          ]
        },
        {
          "model": "Prius Plug-In",
          "series": [
            "Advanced",
            "Base (cvt)",
            "In",
            "G",
            "Plug"
          ]
        },
        {
          "model": "Prius Prime",
          "series": [
            "Xle",
            "Premium",
            "Le",
            "Plus",
            "Advanced",
            "Limited",
            "Upgrade",
            "Xse",
            "Le/xle/limited",
            "Plus/premium/advanced",
            "Xse Premium",
            "Se/xse/xse Premium",
            " Le",
            "Se",
            " Se",
            "Advanced/plus/premium",
            "Technology",
            "Ed",
            "Remium",
            "Shade",
            "Le X",
            "/advanced",
            "Prim",
            "Rim",
            "Le/limited/xle",
            "Xse/xse Premium"
          ]
        },
        {
          "model": "Prius V",
          "series": [
            "Five",
            "Two",
            "Three",
            "Four",
            "Two/three/five",
            "Five/three/two",
            "Five/four/three/two",
            "Two/five/three/four",
            "E/five",
            "/three/four",
            "V"
          ]
        },
        {
          "model": "Raize",
          "series": []
        },
        {
          "model": "RAV4",
          "series": [
            "Xle",
            "Xse",
            "Le",
            "Hybrid Xle",
            "Limited Hybrid",
            "Limited",
            "Xle Premium",
            "Se Hybrid",
            "Se",
            "Limited V6",
            "Sport V6",
            "Prime Se",
            "Le Hybrid",
            "Xle Hybrid",
            "Sport",
            "Hv Limited",
            "Adventure",
            "Hybrid Xse",
            "Xse Hybrid",
            "Hybrid Limited",
            "Base (a4)/base (m5)",
            "Newgener Sport",
            "Newgener Rav4",
            "Hv Le",
            "Base V6",
            "Hv Xle",
            "Base (a4)",
            "Xle Premium Hybrid",
            "4d 2wd",
            "Ev",
            "Hybrid Le",
            "Prime Xse",
            "Trd Off Road",
            "Woodland Edition Hybrid",
            "Trail",
            "Xle/xle Premium",
            "Woodland Edition",
            "Hv Se",
            "Hybrid Le+",
            "Xle/adventure",
            "Xle Premium/xse",
            "Platinum",
            "Limited/platinum",
            "Base",
            "Trd Off-road",
            "Hv Le Plus/xle",
            "Xle P",
            "Xle/xse",
            "Adventure/xle",
            "Limited/se/platinum",
            "Xle/woodland Edition",
            "Xle/xle Premium/xse",
            "Adventure/trd Off Road",
            "Hybrid Se",
            "Base (m5)",
            "Hv Le/xle",
            "Hybrid Le Plus",
            "Newgener Limited",
            "Newgener Rav4 Sport",
            "Hybrid Xle Premium",
            "V6 Sport",
            "Le/xle",
            "Hybrid Le/xle",
            "Hardtop",
            "V6",
            "Hybrid Le+/se",
            "Softtop",
            "Ev Fw",
            "Tr6",
            "Hybrid Xle Premium/xse",
            "Rime Xse",
            "Ltd",
            "Prime",
            "Hybrid Woodland Edition",
            "E",
            "Advntr/trd Off Road",
            "4.6l",
            "Hybrid Le Plus/xle",
            "Limit",
            "Hybrid Xle/xse",
            "Sport V6 Sport V6",
            "Hv Li",
            "Chili",
            "Hybrid",
            "Adven",
            "Hybrid Xle/xle Premium/xse",
            "Hybrid Xle/woodland Edition",
            "Hv",
            "Hv Xl",
            "And Edition",
            " Xle/le Plus",
            "Limited Awd",
            "D Woodland",
            "4wd",
            "Oodland Edition",
            "Xle/prm",
            "Hyb Ltd",
            "Rava 4",
            "Remium",
            "D Le",
            "Le Premium",
            "Dventure",
            "Ture/xle",
            "D Limited",
            "Sr5",
            "D Xle Premium",
            "Num",
            "Remium/xse",
            "D Xse",
            "D Xle",
            "Ed/platinum",
            "D",
            "Ture/trd Off Road",
            "Ture",
            "D Se",
            "Autom",
            "Le Aw",
            "Le Premium/xse",
            "Ff Road",
            "Ed/se/platinum",
            "4d 4w",
            "L",
            " 240",
            " Rav 4",
            "Rav-4",
            "Ed Hybrid",
            "Base V6 A5",
            " V6",
            "Brid",
            "T",
            "Woodl",
            "Remium Hybrid",
            "Ed V6",
            "Ce/le/xle",
            "Ybrid",
            "Base A4/base M5",
            " Gx Preferred",
            "Base A4",
            "Autom Autom",
            "Base V6 (a5)",
            "Rave 4",
            "Hybd Le",
            "4d 2w",
            "Hybrid Xle/le Plus",
            "Trd Offroad",
            "Hybrid Xle Awd",
            "Rav 4",
            "Unknown",
            "Hybri",
            "Trd O",
            "Le Plus/xle",
            "Ed",
            "Rav",
            "Le Fw",
            "4d",
            "New G",
            "4x4",
            "Trd O Trd O",
            "Uze Lt",
            "-4 Cyl",
            "Xle F",
            "Rav 4 4",
            "Rava4",
            "-Ev",
            "Xle A",
            "4",
            " Le",
            " Xle",
            " Rava4",
            "Xle Xle",
            "Hv Xl Hv Xl",
            "Er Sr5",
            "Hv Hy",
            "Xse Xse",
            "Limited V6 Limited V6",
            "Newgener Rav4 Ltd",
            "Le Suv",
            "Suv",
            "X",
            "Sel",
            "Automatic Fwd",
            "Plug-in Hybrid Xse",
            "La Cross L",
            "S/sv/krom",
            " Base",
            "Woodland Edition/xle",
            "Le/hybrid Le"
          ]
        },
        {
          "model": "RAV4 Prime",
          "series": [
            "Se",
            "Xse",
            "Prime"
          ]
        },
        {
          "model": "Sequoia",
          "series": [
            "Sr5 V8",
            "Limited",
            "Limited V8",
            "Sr5 5.7l V8",
            "Sr5",
            "Ltd",
            "Limited 5.7l V8",
            "Trd Pro",
            "Li",
            "Platinum",
            "Capstone",
            "Trd Sport",
            "Platinum 5.7l V8",
            "Sr5 4.6l V8",
            "Nightshade Special Edition",
            "Sr5/trd Sport",
            "Sr5 4.7l V8",
            "Limited/night Shade",
            "Sr5/trd Sport/trd Pro",
            "Limited 5.7l V8/platinum 5.7l V8/sr5 5.7l V8",
            "Sr5/ltd/platinum/capstone",
            "Sr5/ltd/platinum/capstone/trd Pro",
            "Pl",
            "Sr",
            "Night Shade",
            "Limited/nightshade",
            "Sport",
            "Sport/trd Pro",
            "Sr5/limited/platinum",
            "Li Li",
            "Sr5/ltd/platinum",
            "Seqouia",
            "Sequioa",
            "Ni",
            "Sr Sr",
            "Sequoya",
            "Sequia",
            "-V8",
            "4d",
            "Tr",
            "4d 4d",
            "Pl Pl",
            "Limited/platinum/trd Off Road",
            "Touring",
            "Sr5/ltd/platinum/capstone/trd Pro/1974",
            "Trd Off Road",
            "1794 Edition",
            "Le"
          ]
        },
        {
          "model": "Sienna",
          "series": [
            "Le",
            "Xle",
            "Ce",
            "Sport",
            "Xle 7 Passenger",
            "Le V6 8 Passenger",
            "Xle V6 8 Passenger",
            "Xle 8 Passenger",
            "Limited 7 Passenger",
            "Limited",
            "Se",
            "Xse",
            "Le 8 Passenger",
            "L V6 7 Passenger",
            "Se Premium 8 Passenger",
            "Le V6/le V6 Auto Access Seat",
            "Limited 7 Passenger/limited Premium 7 Passenger",
            "Le V6",
            "Xle/xle Premium/limited/l",
            "Xle/limited",
            "Se 8 Passenger/se Premium 8 Passenger",
            "Xle Premium",
            "Xle V6",
            "Ce/le",
            "Xle/xle Limited",
            "Se 8 Passenger",
            "Base V6",
            "Xle Limited",
            "Ce 7 Passenger/ce 8 Passenger",
            "Limited/platinum",
            "Limited 7 Passenger/limited Premium 7 Passenger/xle 7 Passenger/xle 8 Passenger",
            "Limited Premium 7 Passenger",
            "Xle Premium 8 Passenger",
            "Platinum",
            "Le 7 Passenger/le 8 Passenger",
            "L 7 Passenger",
            "Base V6 7 Passenger",
            "Xle Premium 7 Passenger",
            "V6 7 Passenger",
            "Limited V6 7 Passenger",
            "Le 7 Passenger",
            "Base 7 Passenger",
            "Limited V6",
            "L",
            "Ce V6",
            "Se V6",
            "Le/xle",
            "Limited 7 Passenger/xle 7 Passenger",
            "Limited/xle",
            "Base",
            "Le V6 7 Passenger Auto Access Seat/le V6 8 Passenger",
            "Le V6 7 Passenger Auto Access Seat/le V6 7 Passenger Mobility/le V6 8 Passenger",
            "Limited V6 7 Passenger/xle V6 7 Passenger Auto Access Seat/xle V6 8 Passenger",
            "Woodland Edition",
            "Se Premium",
            "Xle Auto Access",
            "Limited Premium",
            "Xse 7-passenger",
            "Xle/xle Premium/limited/limited Premium",
            "Ce 7 Passenger/ce 8 Passenger/le 7 Passenger/le 8 Passenger",
            "25th Anniversary Edition",
            "Le 8 Passenger/base 7 Passenger",
            "Xle Aas/xle/ltd",
            "Le 8-passenger",
            "Se 8-passenger",
            "Limited 7-passenger/xle 7-passenger/xse 7-passenger",
            "Se/se Premium",
            "Le V6 7 Passenger Auto Access Seat",
            "Xle Woodland Edition",
            "7 Passenger",
            "Le/xle/platinum/xse/limit",
            "Xle 7-passenger",
            "Le 8-passenger/limited 7-passenger/xle 7-passenger/xse 7-passenger",
            "Le/xle/xse/limited/platinum",
            "Xle/xle Aas/ltd/xle Premium/ltd Premium",
            "Ce 7-passenger",
            "Ce 7 Passenger/ce 8 Passenger/le 8 Passenger",
            "V6",
            "Limited 7-passenger",
            "Le/xle/xse/limited",
            "Limited 7-passenger/xle 7-passenger",
            "Xse Hybrid",
            "Le 8 Passenger/se 8 Passenger",
            "Xse/xse 25th Anniversary",
            "Ce 8 Passenger",
            "Xle 8-passenger",
            "Le 8-passenger/xle 8-passenger/xse 7-passenger",
            "Xle V6 7 Passenger Auto Access Seat",
            "Le V6 Auto Access Seat",
            "Xe",
            "Ce/le/s",
            "Le/le 7 Passenger",
            "Xle Limited V6",
            "Ltd/xle/xle Premium",
            "Lim",
            "Le 8-passenger/limited 7-passenger/xse 7-passenger",
            "Ltd/xle",
            "Le 7-passenger",
            "Xse/woodland Edition",
            "Le Van",
            "Ltd",
            "Le/xse/limited/platinum",
            "Xle V6/xle V6 Auto Access Seat",
            "Limited Hybrid",
            "Xle/ltd",
            "Limited V6/xle V6/xle V6 Auto Access Seat",
            "Limited/limited Premium/xle/xle Premium",
            "Limited 7 Passenger/limited Premium 7 Passenger/xle/xle Premium 7 Passenger",
            "Limited 7 Passenger/limited Premium 7 Passenger/xle 7 Passenger/xle Premium 7 Passenger",
            "Base 7 Passenger/le 8 Passenger",
            "Limited 7-passenger/xse 7-passenger",
            "Sport V6",
            "Xle Limited 7 Passenger",
            "Xle/woodland Edition",
            "Xle Auto Access Seat/xle/xle Premium/limited/limited Premium",
            "Bas",
            "Spo",
            "Xle/xle Aas/ltd",
            "Van 2wd",
            "- Cv 1",
            "              Sienna",
            "4x4 4x4",
            "Mium",
            " Premium/limited/l",
            " Limited",
            "Ited",
            "/platinum",
            " Premium",
            "Ce 7 Passenger",
            "M",
            "Remium",
            "Dland Edition",
            "Double Cab",
            "Limited V6 7 Passenger/xle V6 7 Passenger Auto Access S",
            "-V6",
            "Ce Sienna Ce",
            "Assenger",
            "Xle 7 Passenger/xle 8 Passenger/xle Premium 8 Passenger/limited 7 Passenger/limit",
            "Limited Premium 7",
            "Xle V6 7 Passenger Auto Access Seat/xle V6 8 Passenger/limited V6 7 Passenger",
            "Awd Le",
            "/ce",
            "Limited V6/xle V6",
            "Le V6 7 Passenger Auto",
            " Passenger",
            "Ium",
            "Xse 25th Anniversary",
            "Xle 7 Passenger/limited 7 Passenger",
            " 7 Passenger",
            "Limited 7 Passenger/limited Premium 7 Passenger/xle/xle",
            "Limited 7 Passenger/limited Premium 7 Passenger/xle 7 P",
            "Sienle/xle",
            "Le V6 7 Passenger Auto Access Seat/le V6 7 Passenger Mo",
            "Le Aas",
            "Le Mobility",
            "Le Auto Access Seat",
            "Xle Ltd",
            "Ltd Premium",
            "Van",
            "Xle Aas",
            "Sieanna",
            "O Access",
            "/xle/ltd",
            " Aas/ltd",
            "L F",
            "/xle Premium",
            "Ce/",
            "Seinna",
            "Ce 7 Passenger/ce 8 Passenger/le/le 7 Passenger",
            "Xle V6 7 Passenger Auto Access Seat/xle V6 8 Passenger",
            "Bas Bas",
            "Xle 7 Passenger/xle 8 Passenger/xle Premium 8 Passenger",
            "Car",
            "C",
            "/le",
            "Sienna",
            "Ce 7 Passenger/ce 8 Passenger/le/le 8 Passenger",
            "Limited/limited 7 Passenger",
            "Cele",
            "Le/xle/platinum/xse/limited",
            "Xse Xse",
            "7-Passenger",
            "Siena",
            "Le/",
            "4x4",
            "Le Sienna Le",
            "Le/ Le/",
            "Ce /ce",
            "Xle Auto Access Seat/xle/xle Premium/limited/limited Pr",
            "Lim Lim",
            "Le/xle/xse/limited/platin",
            "Se 7 Passenger",
            "Le/le 8 Passenger",
            "Xle V6 Auto Access Seat",
            "Pla",
            "Xle 8 Passenger/xle Premium 8 Passenger",
            "Le V6 7 Passenger Mobility",
            "Xle/autono-Mass",
            "Se 7-passenger",
            "Le/xse/limited/platinum/xse 25th Anniversary",
            " Fwd W/7-pa",
            "Xse Hev",
            "Hv",
            "Der Se",
            "Woodland Edition/xse",
            "Le/xle/platinum/xse/limited/xse 25th Anniversary"
          ]
        },
        {
          "model": "SCION",
          "series": [
            "Tc",
            "Xd",
            "Xb",
            "Fr-S",
            "Im",
            "Ia",
            "Xa",
            "Iq",
            "Xb Xb",
            "Sion",
            "Sion Tc",
            "Sb",
            "Scio",
            "Im Im",
            "Trd",
            "Release Series 10.0",
            "Release Series",
            "Frs",
            "Scino",
            "Scion",
            "Tc 2",
            "Tc Tc",
            "Tc Automat",
            "Ion",
            "N",
            "Release Series 7.0",
            "Base (a4)"
          ]
        },
        {
          "model": "SCION FR-S",
          "series": [
            "Fr-S",
            "10 Series",
            "Base (a6)",
            "Monogram",
            "Release Series"
          ]
        },
        {
          "model": "Supra",
          "series": [
            "Base",
            "Sport Roof",
            "Premium/special Edition",
            "Premium/a91-Mt",
            "Launch Edition/premium",
            "Spor",
            "Turb",
            "Turbo",
            "Premium/cf Edition",
            "M/a91-Mt",
            " Edition/premium",
            "M/special Edition",
            "M/cf Edition",
            "5-Sp",
            "3.0 Premium",
            "Premium/45th Anniversary Edition",
            "Base Base",
            "Sport Roof Limited",
            "2.0",
            "A91 Edition",
            "45th Anniversary Edition",
            "3.0"
          ]
        },
        {
          "model": "Tacoma",
          "series": [
            "Base V6",
            "Double Cab Prerunner",
            "Double Cab",
            "Prerunner V6",
            "Access Cab",
            "Trd Off Road",
            "Trd Sport",
            "Sr",
            "Prerunner",
            "Sr V6",
            "Xtracab Prerunner",
            "Trd Off Road/trd Sport",
            "Trd Off-road",
            "Sr V6/sr5 V6/trail Edition/trd Off Road/trd Pro/trd Sport",
            "Double Cab Long Bed",
            "Xtracab",
            "Double Cab Prerunner Long Bed",
            "Limited",
            "Dbl Cab Prerunner Lng Bed",
            "Sr5 V6",
            "Sr5",
            "V6",
            "Base V6 (a4)",
            "4wd Trail Edition",
            "Prerunner Access Cab",
            "Base (m5)",
            "Trd Off-road/trd Pro/trd Sport/sr V6/sr5 V6",
            "Double Cab/sr5/trd Sport/",
            "Access Cab/sr/sr5/trd Sport",
            "Double Cab/sr/sr5/trail/trd Sport/trd Off Road/trd Pro",
            "Double Cab/sr/sr5/trd Sport/trd Off Road/trd Pro",
            "Double Cab/sr/sr5/trail/t",
            "Dbl Cab/sr5/trd Sport/or",
            "Trd Pro",
            "Double Cab/ltd",
            "Dbl Cab/sr/trdspt/or/pro",
            "Base (a4)",
            "Double Cab/sr/sr5/trd Spo",
            "Access Cab/sr5/trd Spt/or",
            "Xtracab Sr5",
            "Sr/sr5",
            "Sr5 V6/trd Off Road/trd Sport",
            "Sr V6/sr5 V6/trd Off Road/trd Sport",
            "Base V6/trd Pro",
            "Access Cab/sr/sr5",
            "X-runner Access Cab",
            "Base V6 (m5)",
            "Sr V6/sr5 V6/trd Off Road/trd Pro/trd Sport",
            "Dou",
            "2wd Sr5/trd Sport",
            "Xtracab S-runner",
            "Base V6 A4",
            "Base (a4)/base (m5)",
            "Double Cab/sr5/trd Sport",
            "Limited/sr V6/sr5 V6/trd Off Road/trd Pro/trd Sport",
            "Access Cab/sr/sr5/trd Spo",
            "Double Cab/sr5/trd Sport/trd Off Road",
            "Trd Off-road/trd Sport",
            "Limited/sr5 V6/trd Off Road/trd Sport",
            "2wd Sr5/trd Sport/trd Off Road",
            "Sr5 V6 Access Cab",
            "Access Cab/sr/sr5/trd Sport/trd Off Road",
            "Xtracab Limited",
            "Double Cab/trd Pro",
            "Double Cab V6",
            "Access Cab/sr/sr5/trd Spt",
            "Double Cab/sr/sr5",
            "Dbl Cab/sr/sr5/trd Spt/or",
            "4wd Sr/sr5/trd Sport",
            "Sr5 V6/trd Sport",
            "4wd Sr5",
            "Access Cab/trd Pro",
            "Base V6 (a4)/base V6 (m5)",
            "Base Sr5 V6",
            "Limited V6",
            "2wd Sr",
            "Trail Edition",
            "Nightshade",
            "Sr/sr5/trd Sport",
            "Trd Off Road/trd Sport/sr5 V6",
            "X-Runner",
            "4wd Double Cab/sr/sr5/trail/t",
            "Double Cab/sr/trd Sport/t",
            "4wd Sr5/trd Sport/trd Off Road",
            "Sr5/trd Off Road/trd Sport",
            "Acc",
            "Sr5 V6 Xtracab",
            "V6 Access Cab",
            "4wd V6 Dbl Cab3.5l Trd Sport",
            "Xtr",
            "Sr5 V6/trd Off-road/trd Sport",
            "Trd",
            "Le Cab",
            "Le Cab Prerunner",
            "Le Cab Prerunner Long Bed",
            "Le Cab Long Bed",
            "V6 Dbl Cab3.5l Trd Sport",
            "Sr5/trd Off Road",
            "Sr V6/sr5 V6/trd Off-road/trd Pro/trd Sport",
            "Sr5 V6/trd Off Road",
            "Double Cab/sr5/trd Sport/trd Off Road/ltd",
            "S-Runner",
            "4wd Double Cab/sr/sr5/trd Spo",
            "2wd Sr5",
            "4wd Trd Pro",
            "Dbc",
            "Sr/sr5/trd Sport/trd Off Road/trd Pro/limited",
            "4wd Trd Off Road",
            "Tacoma Parts Only",
            "X-runner V6",
            "Sr5/trd Sport",
            "Double Cab/limited",
            "Trd Sport Dou Trd Sport",
            "Ltd Nightshade",
            "Sr5/trd Sport/trd Off Road/limited",
            "2wd Sr/sr5",
            "2wd Sr5/trd Sport/sr",
            "4wd Limited",
            "Doublecab",
            "2wd",
            "Pre",
            "4x4",
            "4wd Sr/sr5",
            "4wd",
            "4wd Sr5/trd Sport",
            "Dbl",
            "Tacoma",
            "R",
            " Sport",
            "Cab/sr/sr5/trd Spo",
            "Cab/trd Pro",
            "Er",
            "/sr5/trd Sport/or",
            "Cab/sr/sr5/trd Spt",
            "Cab/sr/sr5",
            "/sr/trdspt/or/pro",
            "Cab/ltd",
            "Rt",
            "Double Cab Base/pr",
            "Cab/sr/sr5/trail/t",
            "Cab/sr5/trd Sport/",
            "Cab Prerunner",
            "Cab",
            " Road",
            "Cab Long Bed",
            " Prerunner Lng Bed",
            "Rt/sr5",
            "/sr/sr5/trd Spt/or",
            "Cab/sr5/trd Spt/or",
            "Er Access Cab",
            "Base V6 (a5)",
            "Sr5/trd Sport/trd Off Road",
            "Base V6 M5",
            "Sr5/sr5 V6",
            "Double Cab/sr5",
            "Cab/sr5",
            "Base M5",
            "Er V6",
            "-Road",
            "Base A4",
            "Sr V6/sr5 V6",
            "Tacomma",
            "Cab/sr5/trd Sport",
            "2wd Double Cab/sr5/trd Sport/",
            "Double",
            "Trd Off Road/trd Pro/trd Sport/sr V6/sr5 V6",
            "Base V6 (a5)/base V6 (m6)",
            "P/u",
            "Reg Reg",
            "Sr V6/sr5 V6/trail Edition/trd Off Road/trd Pro/trd Spo",
            "Sr5 Sr5 V6",
            "4wd Double Cab/sr5/trd Sport/",
            "Sr5 Double Cab",
            "2wd Double Cab/sr5/trd Sport",
            "Pu",
            "2wd Sr/sr5/trd Sport",
            "Trd Sport/sr5",
            "Sr5/sr",
            "Sr5/sr/trd Sport",
            "X-R",
            "2wd Trd Sport",
            "2wd Limited",
            "4wd Trd Sport",
            "2wd Trd Off Road",
            "4wd Sr",
            "Tocoma",
            "Bas",
            "Ltd",
            "Taccoma",
            "Base V6 A5",
            "Tac",
            "Reg",
            "Hybrid Limited",
            "Xtracab Limited/sr5",
            "Hybrid Trd Sport",
            "Ac",
            "4x2",
            "Tma Ltdsr5",
            "Double Cab Trd Offroad",
            "Double Cab Trd Off Road",
            "Pre Pre",
            "Tac Dbl Ca",
            "Double Cab/sr",
            "Hybrid Trd Off Road",
            "Tcoma Dobl",
            "Base V6/base V6 (m6)/trd Pro",
            "Lim",
            "Trd Sport Dbl Cab/sr/sr5/trd Spt/or",
            "Sr5/trd Sport/trd Off Road/trd Pro/sr",
            "Ac Cab Sr",
            "Trd Sport Double Cab/sr5/trd Sport/trd Off Road/ltd",
            "Xtc",
            "Tac 4x4",
            "D",
            "Tac Xtraca",
            "Sr5 Sr5",
            "Ther",
            "Dou Dou",
            "Prerunner Double Cab Prerunner",
            "Hybrid Trd Pro",
            "Sr+",
            "Base A6",
            "Double Cab/trd Sport/trd Off Road/trd Pro/ltd/trailhunter",
            "Sr5 Double Cab V6",
            "Double Cab/trd Sport/trd Off Road/trd Pro/ltd/trailhunt",
            "Xl",
            "Sr5 2wd",
            "Trd Off Road 4wd",
            "Trd Sport 4wd",
            "Sr+/sr5",
            "Frame Only",
            "Sr 4wd",
            "Limited 4wd",
            "Sr 2wd",
            "Pickup Truck",
            "Trd Sport 2wd",
            "Sr5 4wd",
            "Xtra Cab Sr5",
            "Hybrid Trailhunter",
            "Xtracab/sr",
            "Hybrid",
            "Xtracab/sr5/trd Prerunner",
            "Limited 4wd/sr 4wd/sr5 4wd/trd Off Road 4wd/trd Sport 4wd",
            "Sr V6/sr5 V6/trd Sport",
            "Limited V6/trd Off Road",
            "Trd Prerunner 4wd",
            "Sr5 2wd/trd Sport 2wd",
            "D Trd Sport Trd Sport"
          ]
        },
        {
          "model": "Tundra",
          "series": [
            "Access Cab",
            "Crewmax Limited",
            "Sr5",
            "Double Cab Sr5",
            "Sr5 5.7l V8",
            "Grade 4.6l V8",
            "Ltd V8",
            "Sr5 V8",
            "Sr5 4.6l V8",
            "Crewmax 1794",
            "Crewmax Platinum",
            "Crewmax Sr5",
            "Limited",
            "Grade 5.7l V8",
            "Double Cab Sr/sr5",
            "Double Cab",
            "Limited V8",
            "Hybrid 1794 Edition",
            "Base V6",
            "Ltd",
            "Limited 5.7l V8",
            "Base (a4)",
            "1794 Edition",
            "Base 4.7l V8",
            "Darrell Waltrip Edition/limited V8",
            "Base 5.7l V8",
            "Sr 5.7l V8",
            "Access Cab Limited",
            "Double Cab Limited",
            "Crewmax",
            "Access Cab Sr5",
            "Sr5 4.7l V8",
            "Sr5 Plus 5.7l V8",
            "Double Cab Sr",
            "Crewmax Sr",
            "Sr V6",
            "Platinum",
            "Trd Pro",
            "Platinum 5.7l V8",
            "Sr5 V6",
            "Double Cab/double Cab Sr5",
            "1794 5.7l V8",
            "Hybrid Trd Pro",
            "4wd Sr5",
            "Hybrid Limited",
            "Sr 4.6l V8",
            "Grade V6",
            "Trd Pro 5.7l V8",
            "Sr",
            "Crewmax Capstone",
            "Darrell Waltrip Edition/sr5 V8",
            "Hybrid Capstone",
            "Crewmax Sr5/trd Pro",
            "Sr5 Plus",
            "Base V8",
            "Darrell Waltrip Edition",
            "Crewmax Sr5/crewmax Trd P",
            "4wd Truck Crewmax Sr5",
            "Base 5.7l V8/sr5 5.7l V8",
            "Access Cab/access Cab Sr5",
            "2wd Sr5/limited/platinum/1794 Edition",
            "Hybrid Platinum",
            "4wd Sr",
            "Hybrid Crewmax Limited/crewmax P",
            "Crewmax 1794/crewmax Plat",
            "Crewmax Limited/crewmax T",
            "Crewmax Sr/crewmax Sr5",
            "Limited V8 Double Cab",
            "Sr5 Double Cab V8",
            "Dlx 5.7l V8",
            "2wd Crewmax Sr5",
            "Sr5 5.7l V8/trd Pro 5.7l V8",
            "Double Cab Sr/double Cab",
            "4wd Truck Ltd",
            "Crewmax 1794/platinum",
            "Crewmax Platinum/crewmax",
            "4wd Crewmax Sr5/crewmax Trd P",
            "Double Cab Sr/double Cab Sr5",
            "Crewmax Sr5/crewmax Trd Pro",
            "Double Cab Sr/sr5/trd Pro",
            "Hybrid Crewmax Limited",
            "Crewmax Platinum/crewmax 1794",
            "Double Cab Sr/sr5/double Cab Trd Pro",
            "Limited 4.7l V8",
            "1794 5.7l V8/platinum 5.7l V8",
            "4wd Truck",
            "2wd Sr5",
            "Crewmax/crewmax Sr5",
            "Crewmax 1794/crewmax Platinum",
            "2wd Truck Sr5",
            "Sr 5.7l V8/sr5 5.7l V8",
            "Crewmax Limited/crewmax Trd Pro",
            "4wd Truck Sr",
            "V8",
            "Grade 4.7l V8",
            "Dlx 4.7l V8",
            "Platinum Hybrid Crewmax",
            "Crewmax Limited/crewmax P",
            "Sr/sr5",
            "Ax",
            "2wd Truck Double Cab/double Cab Sr5",
            "Hybrid Crewmax Platinum/crewmax",
            "Hybrid",
            "Limited V6 Double Cab",
            "4wd Truck Crewmax Limited",
            "Sr5/dw",
            "2wd Truck",
            "Double Cab V8",
            "Cre",
            "Crewmax Ltd/platinum",
            "Ltd V8/sr5 V8",
            "4wd Truck Crewmax Sr5/trd Pro",
            "4wd Truck Sr5",
            "2wd Sr/sr5",
            "2wd Truck Platinum/1794",
            "4wd Sr/sr5/trd Pro",
            "4wd Platinum",
            "4wd Truck Sr/sr5",
            "2wd Truck Grade 5.7l V8 (a6)",
            "4wd Platinum/1794 Edition",
            "4wd Truck Sr/sr5/trd Pro",
            "Access Cab V8",
            "4wd Truck 1794",
            "2wd Truck Sr/sr5",
            "Sr 5.7l V8/sr5 5.7l V8/trd Pro 5.7l V8",
            "Hybrid Crewmax Capstone",
            "4wd Limited",
            "2wd Sr/sr5/limited",
            "Acc",
            "Limited V8/ltd",
            "Sr5 V8 Crewmax",
            "Double Cab Sr/double Cab Sr5/double Cab Trd Pro",
            "4wd Truck Double Cab/double Cab Sr5",
            "4wd Truck Platinum/1794",
            "Limited V8 Crewmax",
            "4wd Trd Pro",
            "1794 5.7l V8/limited 5.7l V8/platinum 5.7l V8/sr5 5.7l V8",
            "Crewmax Limited/crewmax Platinum/crewmax 1794/crewmax Trd Pro",
            "4wd Truck Grade 5.7l V8 (a6)",
            "Hybrid Crewmax Limited/crewmax T",
            "2wd Truck Ltd",
            "Dou",
            "4wd Double Cab Sr/sr5",
            "4wd Truck Double Cab Sr/sr5",
            "2wd Truck Crewmax Sr5",
            "4wd Sr5/limited/platinum",
            "4wd",
            "2wd Truck Double Cab Sr5",
            "2wd Truck Double Cab Sr/sr5",
            "2wd",
            "2wd Sr5/limited/platinum",
            "4wd Sr/sr5/limited",
            "4wd Truck Double Cab Sr5",
            "4wd Sr5/trd Pro",
            "Lim",
            "2wd Sr5/sr",
            "4wd Truck Sr5/trd Pro",
            " Limited/crewmax P",
            "Platinum 5.7l V8/1794 5.7l V8",
            "Ex-L",
            "Dw",
            "Cab Sr/sr5",
            " Platinum/crewmax",
            "4wd Platinum Hybrid",
            "2wd Platinum",
            "4wd Truck Crewmax 1794/platinum",
            " Sr5",
            " Limited",
            "Cab Sr/sr5/trd Pro",
            "4x4",
            " Sr5/trd Pro",
            "Cab Sr5",
            "Cab/double Cab Sr5",
            "Cab Limited",
            " 1794/crewmax Plat",
            " Platinum",
            " Sr/crewmax Sr5",
            " 1794/platinum",
            " Sr5/crewmax Trd P",
            "Base A4",
            "4wd Sr5/limited/platinum/1794 Edition",
            "Tun 4x4",
            "Ltd V8/limited V8",
            " Capstone",
            "Limited 5.7l V8/sr 5.7l V8/sr5 5.7l V8",
            "4wd Capstone Hybrid",
            ".6l V8",
            " V8",
            ".7l V8",
            "L V8",
            " Ltd/platinum",
            "Base (m5)",
            "Sr 4.6l V8/sr5 4.6l V8",
            " 5.7l V8",
            "Platinum 5.7l V8/limited 5.7l V8/sr5 5.7l V8/1794 5.7l V8",
            "Cab Sr/double Cab",
            "Cab Sr/sr5/double",
            " Limited/crewmax T",
            "M 5.7l V8",
            " V8/sr5 4.6l V8",
            "4wd Truck Base 5.7l V8 (a6)",
            "Double Cab Sr/double Cab Sr5/trd Pro",
            "Tun Dbl Ca",
            "Reg",
            "2wd Limited",
            "2wd Truck Sr",
            "2wd Truck 1794/platinum",
            "4wd Sr/sr5",
            "2wd Truck 1794",
            "4wd Truck Ltd/platinum",
            "2wd Platinum/1794 Edition",
            "2wd Truck Sr5/sr",
            "4wd 1794 Edition",
            "4wd Truck Trd Pro",
            "4wd Truck Platinum",
            "2wd 1794 Edition",
            "2wd Truck Platinum",
            "2wd Sr",
            "2wd Truck Ltd/platinum",
            "Work Truck",
            "4wd Double Cab Sr/sr5/trd Pro",
            "Double Cab Sr/sr5/double",
            "2wd Double Cab Sr/sr5",
            "4wd Truck Crewmax Ltd/platinum",
            "4wd Truck Double Cab Limited",
            "4wd Truck Crewmax Platinum",
            "4wd Crewmax 1794/platinum",
            "Ltd/dw",
            "2wd Truck Crewmax Limited",
            "4wd Crewmax Sr5/trd Pro",
            "Sr/sr5/trd Pro",
            "4wd Crewmax Sr5",
            "4wd Crewmax Limited",
            "2wd Truck Double Cab Limited",
            "4wd Double Cab Limited",
            "2wd Truck Crewmax/crewmax Sr5",
            "2wd Crewmax Limited",
            "Sr5 Access Cab V8",
            "Sr Double Cab V8",
            "Hybrid 1794 Limited Edition",
            "Pu",
            "Tundra",
            "Grade 4.6l V8 (a6)",
            "Grade 5.7l V8 (a6)",
            "Thundra",
            "Lmt",
            "/sr5",
            "1794 Edition/1794 Limited Edition/limited/platinum/trd Pro",
            "1794 Edition/1794 Limited Edition/limited/platinum/trd",
            "179",
            "Tun Crmax",
            "Tun",
            "Acc Acc",
            "4x4 4x4",
            "Crewmax Limited/crewmax Platinum/crewmax 1794",
            "Platinum/platinum 5.7l V8",
            "1794 Edition/platinum",
            "Platinum V8 Crewmax",
            "Xl",
            "Crewmax Limited/crewmax Platinum/crewmax 1794/crewmax T",
            "Pu Dbl Cab Ln 4x2",
            "Capstone Hybrid Crewmax",
            "Crewmax Platinum/crewmax 1794/crewmax Limited",
            "1794 Edition 4wd",
            "Sr5 Trd Double Cab V8",
            "Hybrid Limited 4wd",
            "Hybrid 1794 Edition 4wd",
            "Sr 4wd",
            "Sr5 2wd",
            "Sr5 4wd",
            "Double Cab Pickup Truck",
            "Hybrid Platinum 4wd",
            "Limited 4wd",
            "Limited 2wd",
            "Hybrid Trd Pro 4wd",
            "Platinum 4wd",
            "Limited Access Cab V8",
            "Capstone",
            "Sr5 V6 Double Cab",
            "Pic",
            "Sr5/sr5 5.7l V8",
            "Crewmax Limited/crewmax Platinum/crewmax 1794/crewmax Sr/crewmax Sr5",
            "Limited V6 Crewmax",
            "Limited 4x4",
            "Platinum 2wd",
            "Hybrid Limited 2wd",
            "Pieces",
            "Trd Pro 4wd",
            "Sr 4x4",
            "Limited Sr5 Dblcab V8",
            "Limited V8/ltd V8",
            "1794 5.7l V8/limited 5.7l V8/platinum 5.7l V8/sr5 5.7l V8/trd Pro 5.7l V8",
            "Hybrid Platinum 4x4",
            "1794 5.7l V8/limited 5.7l V8/platinum 5.7l V8/sr5 5.7l"
          ]
        },
        {
          "model": "Venza",
          "series": [
            "Le",
            "Base V6",
            "Limited",
            "Xle",
            "Limited V6",
            "Le/xle/limited",
            "Xle V6",
            "Nightshade Edition",
            "Le V6",
            "Le/xle/limited/night Shad",
            "Le/xle",
            "Le/xle/limited/night Shade",
            "2.0 S",
            "Xle V6/le V6/limited V6",
            "Le/limited/xle",
            "V6",
            "Limited/xle",
            "Le V6/limited V6/xle V6",
            "Xle Xle",
            "Xle/limited/le",
            "Limited V6/xle V6",
            "Base",
            "Xle/limited",
            "/limited/night Shad",
            "Hybr",
            "D",
            "Mited/le",
            "/limited",
            "Mited",
            "Base V6 (a6)",
            "6",
            "4d 2",
            "Limi",
            "Le/xle/limited/nightshade",
            "Le/x",
            "/limited/nightshade",
            "Le A",
            "(canada)",
            "Base (a6)",
            "Awd",
            "Limi Limi",
            "4d 4"
          ]
        },
        {
          "model": "Yaris",
          "series": [
            "L",
            "Ia",
            "Le",
            "L (tmmf Plant)",
            "Se/le/l",
            "Le (tmc/cbu Plant)",
            "S",
            "L (tmc/cbu Plant)",
            "Se",
            "Se (tmc/cbu Plant)",
            "L/le/xle",
            "Ce/le/se",
            "Le/rs",
            "L/le",
            "L/le/se",
            "Le/se",
            "Ce/rs",
            "Sedan L/le/xle",
            "Xle",
            "Gl",
            "L (tmc/cbu Plant)/le (tmc/cbu Plant)/se (tmc/cbu Plant)",
            "Le (tmmf Plant)",
            "Le/l",
            "Rs",
            "Base (a4)",
            "Ce/le",
            "A Matrix Xr",
            "Le/xle",
            "L/se/le",
            "Premium",
            "L (tmc/cbu Plant)/le (tmc/cbu Plant)",
            "Ce",
            "Rs Rs",
            "Hatchback",
            "Base/s",
            "L (tmmf Plant)/le (tmmf Plant)",
            " Le",
            "Sedan",
            "L Au",
            "X",
            "4d Hbk L/le/se",
            "Sport",
            "Auto",
            "2d L/le/se",
            "E",
            "Xe/gxe",
            "Base",
            "Se Tmc/cbu Plant",
            "A Matrix S",
            "2d B/s",
            "Sx",
            "C/cbu Plant)",
            "Hbk L/le/se",
            "Hatc",
            "Hatchback Le/xle",
            "Sedan Xle",
            "Sedan Le",
            "Hatchback Le",
            "Yarris",
            "Seda",
            "Hatchback Xle",
            "Base A4",
            "Manu",
            "3d",
            "Ia A",
            "L/ya",
            "Yarus",
            "4d",
            "Seda Seda",
            "4d 4d",
            "Automatic",
            "S /s",
            " Ce",
            "Xr",
            "Xle/xle Premium",
            "Base (m5)",
            "Base (m5)/s"
          ]
        },
        {
          "model": "Yaris iA",
          "series": [
            "Base A6",
            "Ia"
          ]
        },
        {
          "model": "Yaris R",
          "series": []
        },
        {
          "model": "Crown",
          "series": [
            "Limited",
            "Xle",
            "Xle/limited",
            "Limi",
            "Num",
            "Platinum",
            "Limited/xle",
            "Salo",
            "Athlete",
            "Royal",
            "Mited",
            "Maje",
            "Signia Xle",
            "Sign",
            "Plat",
            "Signia Limited",
            "Roya",
            "Signia Xle/limited",
            "Xle/limited/night Shade",
            "Nightshade Edition"
          ]
        }
      ]
    },
    {
      "make": "Volkswagen",
      "models": [
        {
          "model": "Amarok",
          "series": []
        },
        {
          "model": "Arteon",
          "series": [
            "Sel",
            "2.0t Sel R-line",
            "2.0t Se",
            "Se",
            "Sel Premium R-line",
            "Sel R-line",
            "2.0t Sel",
            "2.0t Sel Premium R-line",
            "Sel Premium",
            "Se R-line",
            "2.0t Se R-line",
            "2.0 Tsi 4motion",
            "Execline",
            "Exe",
            "Sel Sel",
            "2.0t Sel Premium"
          ]
        },
        {
          "model": "Atlas",
          "series": [
            "Cross Sport Se",
            "Se",
            "2.0t Se W/technology",
            "3.6l V6 Sel Premium R-line",
            "3.6l V6 Se W/technology",
            "3.6l V6 Sel Premium",
            "3.6l V6 Se W/technology R-line",
            "S",
            "Sel",
            "Sel Premium",
            "3.6l V6 Sel R-line",
            "3.6l V6 Se/3.6l V6 Se W/technology",
            "3.6l V6 Se",
            "3.6l V6 Sel",
            "2.0t Se",
            "Cross Sport Sel",
            "3.6l V6 S",
            "2.0t S",
            "Sel Premium R-line",
            "2.0t Sel",
            "Cross Sport Sel R-line",
            "Cross Sport S",
            "Sel R-line",
            "Cross Sport Sel Premium R-line",
            "3.6l V6 Sel R-line Black",
            "2.0t Se/2.0t Se W/technology",
            "Cross Sport Sel Premium",
            "2.0t Peak Edition Sel",
            "Trendline",
            "Peak Edition Se",
            "3.6l V6 Launch Edition",
            "Peak Edition Sel",
            "2.0t Se W/technology/2.0t Se",
            "2.0t Sel Premium R-line",
            "Comfortline",
            "2.0t Sel Premium",
            "Cros",
            "Comfortline 2.0 Tfsi",
            "Touring",
            "2.0t Peak Edition Se W/technology",
            "Execline",
            "3.6l V6 Se W",
            "4d 2wd 2.0t S",
            "3.6 S",
            "Rline",
            "Gls",
            "Exec",
            "Tren",
            "3.6l V6 Se/3.6l V6 Se W/technology R-line",
            "Comf",
            "Awd 4d Suv Se W/technology",
            "Peak",
            "4d 4",
            "Cross Sport Trendline",
            "Cros Se",
            "Sel Sel",
            "Cros Cros",
            "S S",
            "Laun",
            "C1500 Lt",
            "3.6 Fsi Highline",
            "3.6 Fsi Execline",
            "2.0 Tsi Peak Edition",
            "3.6 Fsi Comfortline",
            "2.0t Peak Edition",
            "2.0 Tsi Execline",
            "2.0 Tsi Comfortline",
            "Highline"
          ]
        },
        {
          "model": "Atlas Cross Sport",
          "series": [
            "2.0t S",
            "3.6l V6 Sel",
            "3.6l V6 Sel Premium R-line",
            "3.6l V6 Se W/technology",
            "2.0t Se W/technology",
            "2.0t Sel R-line Black",
            "2.0t Sel Premium R-line",
            "2.0t Se",
            "3.6l V6 Sel/3.6l V6 Sel R-line Black",
            "Se",
            "2.0t Se W/technology/2.0t Se W/technology R-line",
            "3.6l V6 Sel R-line",
            "2.0t Sel R-line",
            "Sel Premium R-line",
            "3.6l V6 Se W/technology/3.6l V6 Se W/technology R-line",
            "Sel R-line",
            "2.0t Sel",
            "3.6l V6 Se W/technology R-line",
            "2.0t Sel/2.0t Sel Premium/2.0t Sel Premium R-line/2.0t Sel R-line",
            "3.6l V6 Sel Premium",
            "S",
            "Sel",
            "Sel Premium",
            "2.0t Sel/2.0t Sel R-line",
            "Comfortline",
            "3.6l V6 Sel/3.6l V6 Sel R-line",
            "3.6l V6 Se W",
            "2.0t Sel Premium",
            "3.6l V6 Sel R-line Black",
            "3.6l V6 Se",
            "2.0t Sel/2.0t Sel Premium/2.0t Sel Premium R-line/2.0t",
            "Awd 4d Suv Se W/",
            "Com 2.0 Tfsi",
            "2.0 Tsi Trendline",
            "3.6 Fsi Highline",
            "3.6 Fsi Execline",
            "2.0 Tsi Execline",
            "3.6 Fsi Comfortline"
          ]
        },
        {
          "model": "Beetle",
          "series": [
            "Gls",
            "Tle 2.5l Option Package 1",
            "1.8t Classic",
            "2.5l",
            "S",
            "2.5l Fender Edition",
            "Gl",
            "1.8t",
            "Triple White",
            "2.5",
            "2.0t Turbo",
            "Coupe 1.8t Entry",
            "Glx",
            "Turbo",
            "Tle",
            "Tle Gl",
            "Tle Gls",
            "2.5l Entry",
            "1.8t Se",
            "2.0t Coast/2.0t S",
            "2.0t Coast/2.0t S/2.0t Se",
            "1.8t Entry",
            "2.5l Blush Edition",
            "1.8t Fleet Edition",
            "2.0t",
            "Coupe S",
            "#pinkbeetle/1.8t Classic/1.8t S",
            "Tdi",
            "S/se",
            "Gls Tdi",
            "Convertible Option Pkg 2",
            "1.8t Sel",
            "2.0t Final Edition Se/2.0t Final Edition Sel/2.0t S",
            "#pinkbeetle/1.8t Classic/1.8t S/1.8t Se/1.8t Sel",
            "2.5l/2.5l 50s Edition/2.5l 70s Edition",
            "Tle Gls Sport",
            "Se",
            "2.5/s",
            "2.0t Dune",
            "2.0l Tdi",
            "Gls 2.0l",
            "Sport Edition",
            "Tle Convertible S",
            "Tle Gls Tdi",
            "Tle Convertible",
            "Dune",
            "Tle Glx",
            "S/se/sel/denim",
            "2.0t R-line",
            "1.8t Dune",
            "2.0t Se",
            "1.8t Se/1.8t Sel",
            "1.8t S",
            "Tle Convertible Option Package 2",
            "Tle Gl Tdi",
            "Tle Convertible Se",
            "Tle 2.5l",
            "Tle S",
            "Coupe S/se",
            "Tle Convertible Option Package 1",
            "R-Line",
            "Convertible Se",
            "Gls 1.8t",
            "Gls 1.8l Turbo",
            "Tle Tdi",
            "Tle Tdi Option Package 1",
            "Tle Triple White",
            "2.5l Option Package 1",
            "Black Tie Edition/triple White",
            "Entry",
            "1.8t/s/classic/pink",
            "Coupe Gls",
            "2.0t Final Edition Se/2.0t Final Edition Sel/2.0t S/2.0t Se",
            "2.0t Gsr",
            "2.5l 50s Edition",
            "Turbo S",
            "Coupe 2.0t Turbo R-line W/sun/sound",
            "2.0t Se/2.0t Coast/2.0t S",
            "Coupe Gl",
            "Tle 2.5l Option Package 2",
            "2.0t Fender Edition",
            "Coupe",
            "2.5l Final Edition",
            "2.5l Option Package 2",
            "Convertible",
            "1.8t Denim",
            "Convertible Option Pkg 1",
            "Tle Turbo S",
            "2.5l Red Rock Edition",
            "S/coast",
            "Tle Tdi Option Package 2",
            "S/final Edition Se/final Edition Sel/se",
            "Gl Tdi",
            "Se/sel",
            "2.0t Turbo Launch Edition",
            "Gls Sport",
            "Eet",
            "Tdi Option Package 1",
            "Tdi Option Package 2",
            "2.0t Fender Edition/2.0t Turbo/r-line",
            "Tle 2.5l Luxury",
            "Convertible S",
            "2.5l/2.5l Fender Edition",
            "Gls 1.8",
            "Convertible Option Package 1",
            "1.8",
            "2.5l Leather",
            "2.5l 70s Edition",
            "Con",
            "Tle Satellite Blue Gls",
            "1.8t/s/wolfsburg",
            "Coupe 2.5l Fender Edition",
            "S/se/coast",
            "S/final Edition Se/final",
            "S/s",
            "Gls/gls 1.8t",
            "1.8t Wolfsburg Edition",
            "Gls/gls Tdi",
            "Tle Convertible Option Pack",
            "Tle Blush Edition",
            "Gls/gls 1.8l Turbo",
            "Convertible 2.5l W/tech",
            "Tle Coupe",
            "Tle Coupe S/se",
            "Coupe 2.5l",
            "Convertible 1.8t W/tech",
            "Entry Pzev",
            "Coupe 2.5l W/sun",
            "Convertible 1.8t",
            "New",
            "Convertible 2.0l Tdi",
            "Tle Coupe Final Edition",
            "Coupe 1.8t Sel",
            "Tur",
            "Dun",
            "2.0t Turbo W/sun/snd",
            "Convertible S/se",
            "Coupe 2.5l Entry",
            "2.5l W/sun Pzev",
            "S/final Edition Se",
            "Coupe 2.0t Turbo W/sun/sound",
            "1.8t Fleet/1.8t S",
            "Coupe 2.0l Tdi",
            "Coupe 1.8t W/sun",
            "2.5l/2.5l Final Edition/2.5l Red Rock Edition",
            "Coupe 1.8t",
            "Convertible 2.0t W/sound/nav",
            "Convertible 2.0l Tdi W/sound/nav",
            "Coupe 1.8t Classic",
            "2.5l W/sun",
            "2.5l W/sound/nav Pzev",
            "Convertible 1.8t Classic",
            "2.5l W/sun/sound/nav",
            "Convertible 1.8t S",
            "Convertible 2.0t R-line",
            "Coupe 1.8t S",
            "Coupe 1.8t Dune",
            "Convertible 2.0t",
            "2.0t Turbo W/sound",
            "Convertible 2.5l W/sound/nav",
            "Convertible 2.5l",
            "Tle Coupe S",
            "2.5l Pzev",
            "Coupe 1.8t Fleet Edition",
            "Coupe 2.0l Tdi W/sun/sound/nav",
            "Coupe 2.0t Turbo Fender Edition",
            "Coupe 2.0t Turbo R-line",
            "Tle Convertible Final Edition",
            "2.0t Turbo W/sun",
            "Coupe 2.0t Turbo Gsr",
            "Coupe 2.0t R-line Se",
            "Tle Coupe Red Rock Edition",
            "Convertible 2.0t R-line Sel",
            "Coupe 2.0t Turbo",
            "2.0l Tdi W/sun",
            "2.0t Turbo Pzev",
            "Convertible 2.0t W/sound",
            "Coupe 2.0t Turbo W/sun/snd/nav",
            "2.0l Tdi W/sun/sound/nav",
            "Convertible 1.8t Denim",
            "Convertible S/coast/se",
            "Convertible 2.5l 50s Edition",
            "2.0t Turbo W/sun/sound",
            "Convertible 1.8t S/1.8t Se",
            "Coupe 1.8t Se",
            "Convertible 1.8t Se",
            "Convertible 1.8t W/premium",
            "Coupe 1.8t W/premium",
            "Coupe 2.5l W/sun/sound/nav",
            "Coupe 1.8t Wolfsburg Edition",
            "2.0t Turbo Launch",
            "Convertible 1.8t W/sound/nav",
            "2.5l W/sun/sound/nav Pzev",
            "Coupe 2.0l Tdi W/premium",
            "Convertible 2.0t R-line W/sound",
            "R-L",
            "2.0t White Turbo Launch",
            "Convertible 2.0t R-line W/sound/nav",
            "Beatle",
            "Coupe 1.8t W/sun/sound/nav",
            "Tle Convertible Blush",
            "Coupe 2.0t R-line W/sun/sound",
            "Convertible 1.8t Dune",
            "Tle S/se",
            "Coupe 1.8t/s/wolfsburg",
            "R-Line/sel",
            "S/se/classic/pink/sel",
            "Coupe Se/sel",
            "Coupe Turbo",
            "Convertible S/se/sel/denim",
            "Convertible #pinkbeetle",
            "2.0t Black Turbo Launch",
            "Convertible Dune",
            "Coast",
            "Convertible 1.8t Sel",
            "Convertible 2.0t 60s Edition",
            "#pinkbeetle",
            "Convertible Turbo",
            "Convertible 2.0t R-line S",
            "Coupe 2.0t R-line Sel",
            "Tle Convertible Option Pkg 1",
            "1.8t/s",
            "Tle Convertible Option Pkg 2",
            "Tle Triple White/black Tie Edition",
            "Tle Coupe Gl",
            "Convertible 2.5l 70s Edition",
            "Tle Gls 1.8t",
            "Tle New",
            "Tle 2.5",
            "Tle 2.5l/2.5l Final Edition/2.5l Red Rock Edition",
            "2.0t Se/2.0t Final Edition Se/2.0t Final Edition Sel/2.0t S",
            "Tle Se/s",
            "Tle Sport",
            "S S",
            "Tle Coupe Tdi Eop 48/06 A6/tdi Eop 48/06 M5",
            "S/final Edition Se/final Edition Sel",
            "Tle Sport Edition",
            "Tle 2.5l Blush Edition",
            "Cou",
            "Tle Coupe Gls",
            "Tle Se",
            "Tle 2.5l Final Edition",
            "Tle Coupe Se/s",
            "Tle Gls 2.0l",
            "2.0t Final Edition",
            "Tle 2.5l Red Rock Edition",
            "2.0t 60s Edition",
            "Tle  2.5 (a6)/2.5 (m5)",
            "Tle 2.5 (a6)",
            "Tle 2.5 A6/2.5 M5",
            "Tle Coupe New Beetle A6",
            "Tle 2.5l Final Edition/2.5l Red Rock Edition",
            "Tle Gls 1.8l Turbo",
            "Tle Coupe New Beetle (a6)",
            "2.0t Turbo/2.0t Turbo Launch Edition",
            "Tle Coupe Black Tie Edition/triple White",
            "Tle 2.5/s",
            "Bug",
            "Tle  Gls",
            "Tle Coupe Se",
            "2.0t Turbo W/sun/sound/nav",
            "Pinkbeetle/1.8t Classic/1.8t S",
            "Tle Blush",
            "2.0t Final Edition Se/2.0t Final Edition Sel/2.0t S/2.0",
            "Tle Coupe Glx",
            "Tle Black Tie Edition/triple White",
            "Se/",
            "Coupe 2.0t Turbo W/sun/sound/nav",
            "2.5l Luxury",
            "Tle Convertible 2.5l",
            "Coupe Black Tie Edition/triple White",
            "Blush Edition",
            "Coupe Gls/gls 2.0l",
            "New Beetle",
            "Tur Tur",
            "2.0t Coast/2.0t S/se",
            "Coupe 2.5l/2.5l Fender Edition",
            "2.5l Comfortline",
            "2.5l W/sound/nav",
            "2.5l Trendline",
            "S/s S/s",
            "2.5l Comfortline/2.5l Fender Edition",
            "R-line Sel",
            "Wolfsburg Edition",
            "Satellite Blue Gls",
            "Sup",
            "2.5l Comfortline/comfortline",
            "1.8 Tsi Classic/1.8 Tsi Pink Edition/1.8 Tsi Trendline",
            "2.0 Tdi Comfortline/2.0 Tdi Highline",
            "2.0t/2.0t Turbo/2.0t Turbo Launch Edition",
            "Bentley Gt"
          ]
        },
        {
          "model": "Beetle Cabrio",
          "series": []
        },
        {
          "model": "Bora",
          "series": []
        },
        {
          "model": "Caddy",
          "series": [
            "Maxi"
          ]
        },
        {
          "model": "CC",
          "series": [
            "2.0t Sport",
            "2.0t R-line",
            "Sport",
            "3.6l Vr6 Executive",
            "Luxury",
            "2.0t Lux",
            "2.0t Sport Plus",
            "R-Line",
            "Lux Plus",
            "Sport/r-Line",
            "Lux",
            "2.0t R-line Executive",
            "Base",
            "Vr6 4motion",
            "Executive",
            "3.6l V6 Executive",
            "3.6l Vr6 Lux",
            "Lux Limited",
            "2.0t Sport/2.0t Sport Plus/2.0t R-line",
            "Vr6 Sport",
            "2.0t R-line/2.0t Sport",
            "2.0t Executive",
            "Vr6 Executive",
            "Vr6",
            "R-Line/executive",
            "2.0t Trend",
            "R-Line/sport",
            "2.0t R-line/2.0t Sport/2.0t Sport Plus",
            "Vr6 4mo",
            "Lux Limited Pzev",
            "Sport Pzev",
            "Sport Plus",
            "Lux Pzev",
            "Lux/lux Limited/lux Plus",
            "Vr6 Executive 4motion",
            "Lux Plus Pzev",
            "Trend",
            "Sport/r-Line/trend",
            "R-line Pzev",
            "R-line/sport/sport Plus",
            "Vr6 Lux",
            "4motion",
            "Pzev",
            "Executive 4motion",
            "R-line 2.0t Executive",
            "R-line Executive",
            "Executi",
            "4d 2.0t Lux",
            "Sport/r",
            "Base/sp",
            "2.0t R-line/2.0t Sport/2.0t Trend",
            "Luxury Luxury",
            "Vr6 4mo Vr6 4mo",
            "Sport Sport",
            "Highline",
            "Sport W",
            "Sportline",
            "Highline V6",
            "Wolfsburg Edition"
          ]
        },
        {
          "model": "Clasico",
          "series": []
        },
        {
          "model": "Combi",
          "series": []
        },
        {
          "model": "Constellation",
          "series": []
        },
        {
          "model": "Crafter",
          "series": []
        },
        {
          "model": "Crafter Van",
          "series": []
        },
        {
          "model": "Cross Sport",
          "series": []
        },
        {
          "model": "CrossFox",
          "series": []
        },
        {
          "model": "Delivery",
          "series": []
        },
        {
          "model": "e-Golf",
          "series": [
            "Se",
            "Sel Premium",
            "Comfortline",
            "Limited Edition",
            "Limited",
            "Com",
            "Sel",
            "Se E- Se",
            "Lim",
            "Sel E- Sel",
            "Lim E- Lim",
            "Sel E-golf Sel",
            "Se E-golf Se"
          ]
        },
        {
          "model": "Eos",
          "series": [
            "Komfort Edition",
            "Komfort",
            "2.0t",
            "Turbo",
            "Lux",
            "Komfort/turbo",
            "3.2l",
            "Komfort/sport",
            "Final Edition",
            "Turbo/komfort",
            "Executive",
            "2.0t Sport",
            "2.0t Luxury",
            "Sport",
            "Lux/executive",
            "3.2l Sport",
            "Base",
            "Vr6",
            "Komfor",
            "Executive/lux",
            "Sport/komfort",
            "2.0t S",
            "2.0t L",
            "Other Eos Turbo",
            "2.0t/base M6",
            "Executive Edition",
            "2.0 Sp",
            "3.2l S",
            "Highli",
            "Komfor Komfor",
            "Lux Lux",
            "Highline",
            "Turbo Eos Turbo",
            " S",
            "Comfortline",
            "2.0t Trendline",
            "Eos Turbo",
            "2.0 Tsi Trendline"
          ]
        },
        {
          "model": "GLI",
          "series": [
            "Autobahn",
            "Gli",
            "Autobahn W/nav",
            "Pzev",
            "Autobahn W/nav Pzev",
            "Autoba",
            "Autobahn Pzev",
            "A Gli",
            "Gli (a6) (eop Cw 26/08)/gli (a6) (late Availability)/gli (m6) (eop Cw 26/08)"
          ]
        },
        {
          "model": "Gol",
          "series": []
        },
        {
          "model": "Gol Sedan",
          "series": []
        },
        {
          "model": "Golf",
          "series": [
            "Tdi 4-door",
            "2.5l 2-door",
            "Tsi Se 4-door",
            "Alltrack S",
            "Gti S 4-door",
            "Gti 2.0t Se 4-door",
            "2.5l 4-door",
            "Gls Tdi",
            "Tdi Sel 4-door",
            "S",
            "Gti 2.0t Autobahn/2.0t S/2.0t Se",
            "F Se",
            "Tdi",
            "Gti 2.0t Autobahn/2.0t Rabbit Edition/2.0t S/2.0t Se",
            "F Sel Premium",
            "Sportwagen S",
            "2-Door",
            "Gti Se 4-door",
            "Tdi 2-door",
            "Tsi S 4-door",
            "Gti Autobahn W/performance Package 4-door",
            "Gti",
            "2.5l",
            "Gti Autobahn 4-door/s 4-door/se 4-door/sport 4-door",
            "Gti S/se/autobahn",
            "Gti S 2-door",
            "Tsi S 4-door/tsi Se 4-door/tsi Sel 4-door/tsi Wolfsburg Edition 4-door",
            "Gti 2.0t S 4-door",
            "Gti 2.0t Autobahn",
            "2.0l Tdi 4-door",
            "Gti 2.0t Se 2-door",
            "Gti 2.0t Autobahn 4-door",
            "Gti 2.0t Se",
            "Gls 2.0l",
            "R",
            "1.4t S/1.4t Se",
            "1.4t Tsi",
            "Sportwagen Tdi S",
            "Trendline/comfortline",
            "Gti Gls",
            "S/se",
            "Gti Autobahn 4-door/s 4-door/se 4-door",
            "Tdi S 4-door",
            "Gls",
            "Gti 2.0t S 2-door",
            "Gti Se 4-door/autobahn 4-door/sport 4-door/s 4-door",
            "Gti 2.0t S",
            "Gti Se W/performance Package 4-door",
            "Base / S",
            "Gl",
            "2.0 Tdi",
            "2.0l Tdi",
            "S/wolfsburg",
            "Tdi Se 4-door",
            "Gti 2.0t Se/2.0t Autobahn/2.0t Rabbit Edition/2.0t S",
            "Tsi S 4-door/tsi Se 4-door/tsi Sel 4-door",
            "Gti Autobahn W/performance Package 4-door/s W/performance Package 4-door/se W/performance Package 4-door",
            "Gti S",
            "S/se/sel",
            "Tsi S 2-door",
            "Gti Autobahn 4-door",
            "4-Door",
            "Cl",
            "Tsi Sel 4-door",
            "Tsi",
            "Gl Tdi",
            "Tsi S/tsi Se",
            "Gti Se 2-door",
            "Gti 40th Anniversary Edition",
            "Iii Sport",
            "Gti 2.0t Se/2.0t Autobahn/2.0t S",
            "Launch Edition 2-door",
            "Tsi S 4-door/tsi Wolfsburg Edition 4-door",
            "2.5",
            "1.8 Tsi",
            "Gl 2.0l",
            "Gti 2.0t Autobahn/2.0t Se/s",
            "Gti 2.0t Autobahn W/performance Package 4-door",
            "Sportwagon",
            "Comfortline 1.4 Tsi",
            "S/wolfsburg/se/sel",
            "2.0l Tdi 2-door",
            "Golf",
            "Gls 1.8l Turbo",
            "Wagon",
            "Gti Glx Vr6",
            "Launch Edition 2-door/tsi S 2-door",
            "Gti 2.0t S W/performance Package 4-door",
            "Gti S/se/autobahn/sport",
            "Comfortline 1.8 Tsi 4moti",
            "Gti 2.0t 380 Autobahn",
            "Tsi Wolfsburg Edition 4-door",
            " S",
            "Cabriolet Dlx",
            "Gti Sport 4-door",
            "Gti Se",
            "Gti S/se",
            "Tsi Sel",
            "Gti S 2-door/se 2-door",
            "Comfortline/highline",
            "1.8 Tsi 4motion",
            "K2",
            "Tsi S",
            "Gls 1.8t",
            "Gti S W/performance Package 2-door",
            "Gti 2.0t 380 Se",
            "Tsi 2-door",
            "Gti S/se/autobahn/rabbit Edit",
            "Sport",
            "E- Sel",
            "S/tsi Se 4-door/tsi Sel 4-door/tsi Wolfsburg Edition 4-door",
            "Gti 2.0t 40th Anniversary Edition",
            "Gti 2.0t 380 S",
            "Gti 2.0t Se W/performance Package 4-door",
            "Sportwagen Sel",
            "F Limited",
            "Gti Autobahn 4-door/s 4-door/se 4-door/sport",
            "Gl/gl 2.0l",
            "Gti 2.0t Rabbit Edition/2.0t S/2.0t Se/autobahn",
            "Gti Sport/se/autobahn",
            "E- Se",
            "Alltr",
            "City",
            "Tdi W/tech Pkg",
            "Gti Autobahn W",
            "W/conv & Sunroof",
            "W/conv",
            "Tdi W/sunroof & Nav",
            "Ts1",
            "Life",
            "Comfortline",
            "Launch Edition",
            "Tsi Se",
            "Tdi Sel",
            "Wolfsburg Edition",
            "Tdi Se",
            "Gti Autobahn",
            "Tdi S",
            "Gti Se W/performance Pkg",
            "S/wolfsburg Edition",
            "Gti W/performance Pkg",
            "Tsi S/launch Edition",
            "Gti Sport",
            "Tsi S W/sunroof",
            "Se",
            "Gti S W/performance Pkg",
            "E- Lim",
            "Base",
            "4d 1.8t S/se/sel",
            "Trend",
            "Sport Sport",
            "Gls Manual",
            "Gls Tdi Auto",
            "4d 1.4t",
            "N  Gl",
            "Gls Auto",
            "Gl Auto",
            "Gl Td",
            "Gls T",
            "Gti Rabbit Edition",
            "Gti S W/performance Package 4-door/se W/performance Package 4-door/autobahn W/performance Package 4-door",
            "Gti Se/sport/autobahn/s",
            "Gti 2.0t 40th Anniversary",
            "Gti Autobahn W/performance Package 4-door/s W/performance Package 4-door/se W/p",
            "Gls/gls Tdi",
            "Gti 2.0t S 2-door/2.0t Se 2-door",
            "T",
            "Gti 2.0t Se W/performance Package 2-door",
            "Gti S W/performance Package 4-door",
            "Gti Autobahn/rabbit Edition/s/se",
            "Gti Se W/performance Package 2-door",
            "Gti Autobahn W/performance Package 4-door/s W/performance P",
            "S/tsi Se 4-door/tsi Sel 4-door/tsi Wolfsburg Edition 4-",
            "Gti 2.0t S W/performance Package 2-door",
            "Tsi S 4-door/tsi Se 4-door/tsi Sel 4-door/tsi Wolfsburg",
            "Gti 2.0t Autobahn 4-door/2.0t S 4-door/2.0t Se 4-door",
            "Gl Gl",
            "Gls/gls 1.8l Turbo",
            "Gti Autobahn/s/se/sport",
            "Gti 2.0t Autobahn W/performance Package 4-door/2.0t S W/performance Package 4-d",
            "S/se/",
            "Sprtw",
            "Gl/harlequin",
            "R6",
            "/se",
            "Alltr Alltr",
            "Tdi Tdi",
            "Trendline",
            "S S",
            "Wolfsburg",
            "Conv",
            "2.0l Tdi/tdi",
            "Sportwagen Highline",
            "Gti 5-door",
            "2.0 Tdi Comfortline/2.0 Tdi Highline",
            "Gti 5-door Autobahn",
            "Sportwagon 2.0 Tdi Comfortline/2.0 Tdi Highline/2.0 Tdi Trendline",
            "1.8 Tsi Comfortline/1.8 Tsi Highline/1.8 Tsi Trendline",
            "4d",
            "2.0 Tdi Comfortline/2.0 Tdi Highline/2.0 Tdi Trendline/2.0 Tdi Wolfsburg Edition",
            "2.5l Comfortline",
            "Gti 8v",
            "Gti 5-door/5-door Wolfsburg Edition",
            "Conv   Sunroof",
            "Gti 3-door/3-door Autobahn",
            "Iii Gl",
            "1.8 Tsi Trendline",
            "1.4 Tsi Comfortline/1.4 Tsi Execline/1.4 Tsi Highline",
            "2.5l Comfortline/2.5l Highline/2.5l Trendline",
            "2.5l 2-door (m5)",
            "Gti 5-door/5-door Autobahn/5-door Rabbit",
            "2.5l Comfortline/2.5l Trendline",
            "2.5l Comfortline/2.5l Highline/2.5l Sportline/2.5l Trendline",
            "Sportwagon 1.8 Tsi Comfortline/1.8 Tsi Highline/1.8 Tsi Trendline",
            "2.0 Tdi Comfortline/2.0 Tdi Highline/wolfsburg Edition 2.0 Tdi",
            "Highline 1.4 Tsi",
            "Trendline/highline/comfortline",
            "2.0 Tdi Comfortline/2.0 Tdi Highline/2.0 Tdi Trendline/",
            "Gti 3-door",
            "Gti 380 Autobahn",
            "Iii Gl/gl",
            "2.0 Tdi Comfortline/2.0 Tdi Highline/2.0 Tdi Trendline",
            "2.0 Tdi Highline/comfortline",
            "Gti 1.8t",
            "Gti 3-door Performance",
            "2.5l Comfortline/2.5l Highline/2.5l Trendline/wolfsburg Edition 2.5l",
            "Trek",
            "4-door W/pzev (a6)",
            "2.5l Comfortline/2.5l Sportline Special Edition/2.5l Trendline",
            "Gls/gls 2.0l",
            "Gti Performance",
            " Tdi",
            "Gti 5-door Performance",
            "Custom",
            "1.4 Tsi Execline",
            "Gti-Vr6",
            "Gti 380 Performance"
          ]
        },
        {
          "model": "Golf Alltrack",
          "series": [
            "Tsi S/tsi Se",
            "Tsi S/tsi Se/tsi Sel",
            "Tsi Sel",
            "S/se/sel",
            "S/se",
            "Tsi Se",
            "S",
            "Se/tsi S/tsi Sel",
            "Sel",
            "Se",
            "1.8 Tsi"
          ]
        },
        {
          "model": "Golf City",
          "series": [
            "2.0l"
          ]
        },
        {
          "model": "Golf R",
          "series": [
            "2-Door",
            "4-Door",
            "2.0t 20th Anniversary Edition",
            "2.0t W/dcc & Navigation",
            "20th Anniversary",
            "2.0t",
            "2.0t W/dcc Navigation",
            "4-door W/dcc Navigation",
            "4-door W/dcc   Navigation",
            "2.0t W/dcc   Navigation",
            "W/sunroof & Navi",
            "4motion",
            "4-door W/dcc & Navigation",
            "20t",
            "2.0t W/dcc Navigation (m6)",
            "R",
            "2.0 Tsi",
            "2.0t W/dcc   Navigation (m6)"
          ]
        },
        {
          "model": "Golf SportWagen",
          "series": [
            "Tdi Sel",
            "Tsi S 4-door",
            "Tsi Se 4-door",
            "Tdi S 4-door",
            "Tdi S/tdi Se/tdi Sel",
            "S/se/sel/limited",
            "Tsi Sel 4-door",
            "S/se/sel",
            "Tsi Limited Edition",
            "Tsi S",
            "Tsi Se",
            "Tdi Se 4-door",
            "1.4t S/1.4t Se",
            "S",
            "1.8t S",
            "Tsi S/tsi Se/tsi Sel",
            "Tdi Sel 4-door",
            "Tdi S",
            "S/se",
            "Tsi Sel",
            "Tsi S/tsi Se",
            "Tdi S 4-door/tdi Se 4-door/tdi Sel 4-door",
            "Tdi Se",
            "Se",
            "Sel",
            "Tdi/s/se/sel",
            "Tsi",
            "Tsi Limited Edition/tsi S 4-door/tsi Se 4-door/tsi Sel 4-door",
            "Tsi Limited Edition/tsi S 4-door/tsi Se 4-door/tsi Sel ",
            "Tsi Limited Edition/tsi S 4-door/tsi Se 4-door/tsi Sel",
            "Highline",
            "1.8 Tsi Comfortline/1.8 Tsi Highline/1.8 Tsi Trendline",
            "1.4t S",
            "1.8 Tsi Comfortline/1.8 Tsi Trendline",
            "1.8 Tsi Comfortline/1.8 Tsi Highline"
          ]
        },
        {
          "model": "GTI",
          "series": [
            "S",
            "S/se",
            "40th Anniversary",
            "2-door Autobahn",
            "Gls",
            "4-Door",
            "4-door/4-door Autobahn/drivers Edition/wolfsburg Edition",
            "Wolfsburg Edition",
            "2-Door",
            "20th Anniversary Edition",
            "4-door Autobahn",
            "Se",
            "Driver's Edition",
            "Sport",
            "1.8l/1.8l (a5)/337",
            "Gti",
            "1.8t",
            "Base",
            "Autobahn",
            "1.8l",
            "Drivers Edition",
            "S/se/autobahn/rabbit Edit",
            "2-Door/fahrenheit",
            "2-door (a6) (eop Cw 21/08)",
            "Vr6",
            "1.8t (a5)/1.8t (m5)",
            "S/se/autobahn",
            "1.8l (a5)",
            "337",
            "Sport/se/autobahn",
            "Pzev",
            "Sunroof Navi Pzev",
            "4-door/4-door Autobahn",
            "A Gli Option Package 1",
            "2.0t",
            "Sunroof Pzev",
            "Glx",
            "Fahrenheit",
            "20th Anniversary",
            "1.8t/1.8t (a5)",
            "Autoba",
            "Driver's Edition/wolfsburg Edition",
            "2-door/2-door Autobahn",
            " Gti 8v",
            "Wolfsburg",
            "W/sunroof Pzev",
            "W/conv & Sunroof Pzev",
            "Autobahn Pzev",
            "W/sunroof & Navi Pzev",
            "W/sunroof",
            "W/sunroof & Navi",
            "W/conv & Sunroof",
            "Pzev/w",
            " Gti",
            "Hatchback (4 Door)",
            "4d 2.0t",
            "1.8l (m5)",
            "20th A",
            "4-door W/pzev  A6 Discontinued",
            "2-door  M6 Discontinued",
            "2-door W/pzev (a6)",
            "4-door W/pzev  (a6) (discontinued)",
            "2-door W/pzev  (m6) (discontinued)",
            "4-door (a6) (eop Cw 21/08)/4-door (a6) (late Availability)",
            "2-door (a6) (eop Cw 21/08)/2-door (a6) (late Availability)",
            "Fahrenheit/2-Door",
            "2-door  (m6) (discontinued)",
            "2-door W/pzev (m6)",
            "4-door (m6) (eop Cw 21/08)/4-door (m6) (late Availability)",
            "1.8l (a5)/1.8l (m5)/337",
            "New",
            "S/se/a",
            "2-door W/pzev  (a6) (discontinued)",
            "Gls 1.8l Turbo",
            "2-door (m6) (eop Cw 21/08)/2-door (m6) (late Availability)",
            "4-door  (a6) (discontinued)",
            "40th A",
            "S/se/autobahn/rabbit Edition",
            " Gti Gti",
            "1.8l/1.8l (m5)/337",
            "4-door (a6)",
            "S/se S/se",
            "2.0t Autobahn/2.0t Rabbit Edition/2.0t S/2.0t Se",
            "4-door/4-door Autobahn/drivers Edition/w/sunroof Navi/wolfsburg Edition",
            "4-door/4-door (m6) (eop Cw 21/08)",
            "S 2-door",
            "2.0t 380 Autobahn",
            "S 4-door",
            "4-door (m6) (eop Cw 21/08)",
            "Autobahn W/performance Package 4-door",
            "Gti Fahrenheit",
            "S S",
            "2-door (a6) (discontinued)",
            "Autobahn 4-door/s 4-door/se 4-door/sport 4-door",
            "Se 4-door",
            "2.0t Autobahn/2.0t S/2.0t Se",
            "2.0t Se",
            "Vr6/golf Vr6",
            "2.0t S 4-door",
            "Gls/gls 1.8l Turbo",
            "2.0t Se 4-door",
            "2.0t Autobahn 4-door",
            "Autobahn W/performance Package 4-door/s W/performance Package 4-door/se W/performance Package 4-door",
            "5-Door",
            "Sport Sport",
            "2.0t S",
            "2.0 Tsi",
            "2.0t Autobahn",
            "Autobahn W/performance Package 4-door/s W/performance P",
            "2.0t 380 S",
            "3-Door",
            "2.0t Se 2-door",
            "S W/performance Package 2-door",
            "4-door/4-door (m6) (late Availability)",
            "2.0t S W/performance Package 4-door",
            "4-door/4-door Autobahn/drivers Edition/wolfsburg Editio",
            "2.0t S 2-door",
            "Gti-Vr6"
          ]
        },
        {
          "model": "ID.4",
          "series": [
            "First Edition",
            "S",
            "Pro",
            "Awd Pro S",
            "Pro S/pro S Plus",
            "Awd Pro",
            "Pro S",
            "Standard",
            "Awd Pro S Plus",
            "1st Edition",
            "Pro S Plus",
            "Awd Pro S/awd Pro S Plus",
            "Pro/pro S",
            "First"
          ]
        },
        {
          "model": "Jetta",
          "series": [
            "1.4t S",
            "2.0l S",
            "Se",
            "S",
            "Gls",
            "Sportwagen 2.5l Se",
            "Wolfsburg",
            "1.5t Se",
            "Gls Tdi",
            "2.5l Se",
            "1.8t Sport",
            "1.8t Se",
            "1.4t R-line/1.4t S/1.4t Se",
            "Limited Edition",
            "Sportwagen 2.0l Tdi",
            "2.0l Tdi",
            "1.4t Se",
            "Tdi",
            "Gli",
            "2.0l Tdi S",
            "1.4t Sel",
            "1.4t R-line/1.4t S",
            "1.8t Sel/1.8t Sel Premium",
            "Tdi Option Package 1",
            "Base",
            "Sport",
            "Limited Edition/s/se",
            "Comfortline",
            "Se/sel",
            "Gl",
            "Gls 2.0l",
            "Sedan 2.0l S W/technology",
            "Gli Autobahn W/nav",
            "Sedan 1.9l Tdi",
            "1.8t Sel",
            "2.0l Tdi Le",
            "Wolfsburg/wolfsburg Edition",
            "2.5",
            "2.0t 35th Anniversary Edition/2.0t Autobahn/2.0t S",
            "1.4t Se/1.4t Wolfsburg Edition",
            "Sel",
            "Glx",
            "Base/s",
            "Sedan Se",
            "Hybrid Sel Premium",
            "1.5t Sport",
            "Diesel",
            "Hybrid",
            "Sedan 2.0t Gli Se",
            "Iii Gl",
            "2.5l Sel/2.5l Sel Premium",
            "Sportwagen 2.5l S",
            "2.0t Gli Se",
            "2.0t Gli Sel",
            "2.5l Sel",
            "Sel Premium",
            "1.4t Sel Premium",
            "2.0t Autobahn",
            "2.0l Tdi Sel",
            "S/se/r-Line",
            "S/se",
            "Gli Autobahn",
            "2.0l Tdi Se",
            "Value Edition",
            "1.5t Sel",
            "Sedan",
            "1.8t Se Sport",
            "Hybrid Se",
            "Gls 1.8t",
            "2.0l Tdi Value Edition",
            "Wolfsburg Edition",
            "40th Anniversary Edition",
            "Hybrid Sel",
            "1.5t S",
            "2.5 Option Package 2",
            "2.0t Luxury",
            "Sportwagen Se",
            "Gli/se/sel",
            "Sportwagen Tdi",
            "Tdi Option Package 2",
            "2.5 Option Package 1",
            "Gls 1.8l",
            "Se W/connectivity",
            "Limited Edition/se/sel",
            "2.5l Leather",
            "2.5l Sel Premium",
            "2.0t",
            "Limited",
            "2.0t Autobahn/2.0t S",
            "Sedan Comfortline",
            "40th Anniversary",
            "2.0t Gli",
            "2.0t Option Package 1",
            "Value",
            "Gli Edition 30",
            "Sportwagen Tdi W/sunroof Nav",
            "S/r-Line",
            "Gl Tdi",
            "Sedan S",
            "Gli Edition 30 W/nav",
            "Sedan Se W/connectivity",
            "Sedan Gls",
            "2.0t Sel",
            " 2.0t",
            "2.0l Base/2.0l S",
            "Sedan 2.5",
            "Sedan Wolfsburg",
            "Gli/s/autobahn",
            "Gt",
            "2.5l Option Package 1",
            "Tdi Cup Edition",
            "2.5l S",
            "Ury",
            "Sportwagen S",
            "Se W/convenience",
            "Gli 1.8t",
            "Tdi Loyal Edition",
            "Gli 16v",
            "Sedan 2.0l S",
            "Sedan 2.5l",
            "2.0l Base",
            "R-Line/s/se",
            "2.0t Gli Se/2.0t Gli Sel",
            "Sedan Wolfsburg Edition",
            "Gl Tdi/gls",
            "Tta 2.5l Option Package 2",
            "Tta Value",
            "Wagon Gls",
            "Gli 1.8t/gls 1.8t",
            "Gls Vr6",
            "Iii Glx/jetta Glx",
            "Sedan Se/sel",
            "Gli/gli Autobahn/gli Autobahn W/nav/gli Edition 30/gli Edition 30 W/nav",
            "Gl 1.8t",
            "Gls 1.8l Turbo",
            "Gli Option Package 1",
            "Tta 2.5",
            "Sedan Se W/convenience Sunroof",
            "Highline",
            "Comfortline 1.5 Tsi",
            "2.0",
            "1.9l Tdi",
            "Etta",
            "1.4 Tsi",
            "1.8 Tsi",
            "2.0l Tdi/2.0l Tdi Value Edition",
            "Execline",
            "Tta 2.5l Option Package 1",
            "Se/wolfsburg",
            "Wagon",
            "Sportwagen S/se",
            "Sedan Tdi Premium Package",
            "Sedan Se W/convenience",
            "Sedan Highline",
            "Tdi Premium Package",
            "2.0 Tdi",
            "Deluxe",
            "Glx 24v",
            "2.0t Option Package 2",
            "Tdi Leather",
            "Gls 2.8l",
            "Sedan Trendline/trendline+",
            "Iii Celebration",
            "Gli Leather",
            "Gli/35th Anniversary Edit",
            "Autobahn",
            "Sportwagen Se W/sunroof",
            "City",
            "Sedan Se W/convenience Pzev",
            "2.0l S W/technology",
            "Gli Option Package 2",
            "Highline 1.4 Tsi",
            "Sel/sel Premium",
            "Sedan Sel",
            "Sportwagen 2.5l S/2.5l Se/se W/sunroof",
            "Tta Tdi Option Package 1",
            "2.5l",
            "Sedan Tdi",
            "Gli/35th Anniversary Edition/autobahn/s",
            "Sedan Comfortline/sportline",
            "Sportwagen Tdi W/sunroof   Nav",
            " Gls Tdi",
            "Gli/gli Autobahn/gli Autobahn W/nav",
            "Sedan Hybrid Sel",
            "Sedan 1.8t Se W/connectivity/navigation",
            "Trendline 1.5 Tsi",
            "Sedan 1.8t Sport",
            "2.0t Option Package 3",
            "Sedan 1.4t S W/technology",
            "Sedan Gli 2.0l Turbo",
            "1.8t Se/1.8t Sport",
            "2.0l Tdi S/2.0l Tdi Se/2.0l Tdi Sel",
            "2.5 Se",
            "Iii Gl/gl",
            "Sportwagen 2.5l S/2.5l Se",
            "Sportwagen Tdi W/sunroof",
            "Tta Tdi Option Package 2",
            "2.5 Luxury",
            "Wolfsburg Edition 1.8t",
            "Sedan Limited",
            "Hybr",
            "Sedan Se W/connectivity/sunroof",
            "Trendline",
            "Highline 1.5 Tsi",
            "Hybrid Se/sel/sel Premium",
            "Sedan Se W/convenience/sunroof",
            "Sedan 1.4t Se W/connectivity",
            "Gli S",
            "Sedan Sel W/sunroof",
            "Sedan 2.0l Tdi S",
            "Sedan Sel W/sport Pkg",
            "Sedan Tdi W/premium & Nav",
            "Sedan S W/sunroof",
            "Spor",
            "Sedan Hybrid",
            "Sedan Sel/sel Premium",
            "4d 1.4t Se",
            "Sedan 1.4t S",
            "Sedan 1.8t Se",
            "2.5 Highline",
            "Limi",
            "Wolf",
            "Sedan 1.4t Se",
            "Sedan Hybrid Se",
            "Sedan 1.8t Se W/connectivity",
            "Sedan 1.8t Sel",
            "Sedan 2.0l Tdi Se",
            "Sedan Sport",
            "Sportwagen",
            "Sedan Tdi W/premium",
            "Sedan Se W",
            "R-Line",
            "1.4t",
            "Sedan 2.0t Gli Sel",
            "Sportwagen Tdi W/sunroof & Nav",
            "Sedan Tdi W/premium/nav",
            "Sedan Tdi W/nav",
            "Sedan Gli Edition 30 W/nav",
            "Sedan Tdi Le",
            "Sedan Hybrid Sel Premium",
            "Sedan Sel W/nav",
            "Sedan Sel W/sunroof Pzev",
            "Gli S/autobahn",
            "Sedan Gli Autobahn W/nav",
            "1.8t Sel Premium",
            "Sedan 2.0t Gli",
            "Sedan Sel W",
            "Sportwagen Se W/sunroof/se/s",
            "Carat/gl",
            "Sedan Se Pzev",
            "Sedan 2.0l Tdi Sel",
            "Sedan Tdi Value Edition",
            "Sedan Gl",
            "Sportwagen Sel",
            "Comf",
            "Sedan Base/s",
            "Sedan Sel W/premium & Sunroof",
            "1.4t Wolfsburg Edition",
            "Sedan Gli Edition 30",
            "Sportwagen S/se/se W/sunroof",
            "Sedan Sel W/sport Pkg Pzev",
            "Sedan Gli",
            "Sedan Base",
            "Sedan 1.8t",
            "Jett Gltdi",
            "Sedan Base/s/s W/sunroof",
            "Sedan Sel Pzev",
            "Sedan Tdi Loyal",
            "Sedan Se/sel/limited",
            "Sedan Gli Autobahn",
            "4d 1.4t Sel Prm",
            "Sedan Tdi Cup",
            "Sedan 1.8t Sel Premium",
            "Base/s S",
            "Sedan Gls/gli",
            "Sedan Gli/se/sel",
            "Se Pzev",
            "New",
            "S W/sunroof",
            "Tdi Sel Premium",
            "Se W/connectivity/sunroof",
            "Se W",
            "Sel/",
            "Sedan Comfortline/highline",
            "High",
            "Sedan Value Edition",
            "Sedan S/se/limited",
            "Sedan Glx",
            "4d 1.4t S",
            "Gli 35th Anniversary Edition",
            "4d Gli 2.0t",
            "Sedan 2.0t",
            "Valu",
            "Sedan 2.0l Turbo",
            "Iii Gls",
            "Tdi Luxury",
            "Gls Wolfsburg",
            "Sedan 1.9l Diesel Edition",
            "Sedan Gli/fahrenheit Gli",
            "Gl T",
            "4d 1.8t Spt",
            "Seda",
            "4d Sel",
            "Gli 2.0t Autobahn/2.0t S",
            "4d 1.4t Hiln",
            "4d Gli 2.0t Ab",
            "Sedan Trendline/comfortline",
            "Hybrid/sel Premium",
            "Sedan S/limited",
            "Gli 2.0t 35th Anniversary Edition/2.0t Autobahn/2.0t S",
            "4d Tdi Comfortline",
            "4d 2.5 S",
            "4d 2.0 Comfortline",
            "Gli 2.0t 35th Anniversary",
            " Se/sel",
            "Jeta 2.0t",
            "Sel W/sunroof Pzev",
            "Sel W/sport Pkg Pzev",
            "1.4t S W/technology",
            "Gls/gls Vr6",
            "Gli Gli Autobahn",
            "Hybrid Hybrid",
            "Gli Gli/35th Anniversary Edit",
            "Se/s",
            "Gli 2.0t Autobahn",
            "Wagon Comfortline",
            "Tren",
            " S",
            " Glx",
            "Gli 35th Anniversary Edition/autobahn/s",
            "Se W/convenience   Sunroof Pzev",
            "Gls/gls Tdi",
            "Wolf Wolf",
            "Gli Gli/s/autobahn",
            "Sedan Se W/convenience   Sunroof",
            "Sedan Se W/convenience   Sunroof Pzev",
            "Wago",
            "1.8t",
            "Cl",
            "2.0t Leather",
            "Se Se",
            " 2.5",
            " Gls",
            "R-Line/s",
            "Gli 40th Anniversary Edition",
            "Preferred",
            "Se A",
            "Exec",
            "40th",
            "Td",
            "Jet Carat",
            "S Au",
            "2.5l Premium",
            "S S",
            "Tdi Tdi",
            "Sel Sel",
            "Tta New",
            "Tta Tdi",
            "Limi Limi",
            "Se W/convenience/sunroof",
            "Carat",
            "Base Base",
            "Spor Spor",
            "4d G",
            "Parts",
            "2.0l Tdi/tdi",
            "Hybr Hybr",
            "Sedan 2.5l Se",
            "Jazz",
            "Comfortline 1.4 Tsi",
            "Wagon Gl",
            "Tobahn",
            "2.0 Tdi Comfortline",
            "2.0l Trendline/2.0l Trendline+",
            "2.5l Comfortline/2.5l Sportline",
            "Comf Comf",
            "Base Se",
            "Sel 1.4 Tsi",
            "2.5l Highline",
            "1.4 Tsi Comfortline",
            "1.4 Tsi Highline",
            "2.0l Comfortline",
            "Glx/glx 24v",
            "1.4 Tsi Execline",
            "2.0 Tdi Highline",
            "2.0 Tdi Highline/2.0 Tdi Trendline+",
            "Rt",
            "1.4 Tsi Trendline/1.4 Tsi Trendline+",
            " Se",
            "Sedan Gls Tdi",
            "Gls Tdi/tdi Sport",
            "2.0l Trendline+",
            "1.4 Tsi Trendline+",
            "(bci) Accord Hyb",
            "1.8 Tsi Comfortline/1.8 Tsi Highline",
            "1.8 Tsi Highline",
            "4d 1",
            "Sedan Trendline+/trendline",
            "Sedan Gli Option Package 1",
            "Sportwagen 2.0l Tdi/tdi W/sunroof",
            "Hybrid Hybrid/sel Premium",
            "2.5l Comfortline/2.5l Trendline",
            "Tdi W/sunroof",
            "2.5l Trendline",
            "2.0 Tdi Comfortline/2.0 Tdi Highline/2.0 Tdi Trendline+",
            "1.8 Tsi Comfortline/1.8 Tsi Trendline+",
            "2.5l Se/se",
            "Tdi/tdi Special Edition",
            "Tdi Sport",
            "2.5l Comfortline",
            "1.8 Tsi Comfortline",
            "S/35th Anniversary Edition/autobahn",
            "Trek",
            "K2",
            "2.5l Highline/highline",
            "2.0t Premium",
            "Gli/gli Autobahn",
            "2.0 Tsi",
            "R Spec V",
            "2.0 Tdi Comfortline/2.0 Tdi Trendline",
            "Sedan 2.5/sport Limited",
            "Gli 4d Sedan Autobahn",
            "Gli/gli Edition 30",
            "Sedan 2.5l Sel",
            "Se W/convenience Sunroof"
          ]
        },
        {
          "model": "Multivan",
          "series": []
        },
        {
          "model": "Nivus",
          "series": []
        },
        {
          "model": "Nuevo Gol",
          "series": []
        },
        {
          "model": "Passat",
          "series": [
            "Sel",
            "1.8t S",
            "2.0l Tdi Se",
            "Turbo",
            "Se",
            "Gls",
            "Lux",
            "2.5l Se",
            "2.0t Se R-line",
            "S",
            "1.8t Se",
            "2.0t R-line",
            "1.8t Limited Edition",
            "Glx",
            "2.0t Se",
            "Sel Premium",
            "R-Line",
            "Wolfsburg",
            "2.5l Sel Premium",
            "2.5l S",
            "1.8t R-line",
            "2.0t Wolfsburg Edition",
            "Sedan 2.0t Luxury",
            "Gl",
            "Komfort",
            "2.0t",
            "Se W/sunroof & Nav",
            "1.8t Wolfsburg Edition",
            "2.0l Tdi Sel Premium",
            "Gt",
            "Limited Edition",
            "2.0t R-line/2.0t S",
            "3.6",
            "2.0t Sel",
            "Se W/sunroof",
            "2.0t/wolfsburg",
            "1.8t Sel Premium",
            "3.6l V6 Gt",
            "2.5l Wolfsburg Edition",
            "T",
            "3.6l V6 Se",
            "Vr6 4motion",
            "2.0t Sel Premium",
            "3.6l V6 Sel Premium",
            "2.0t/2.0t Value",
            "Wolfsburg Edition",
            "Se R-line",
            "Gls Tdi",
            "Sedan Komfort",
            "2.0t Wagon Luxury",
            "Glx 4motion",
            "2.0t Limited Edition",
            "Highline W/ R-line",
            "Tdi Se W/sunroof",
            "2.5l Sel",
            "2.0t/wolfsburg Edition",
            "Wagon Komfort",
            "2.0t S",
            "S/r-Line",
            "2.0t Wagon Value",
            "3.6l Sport",
            "1.8t Sport",
            "Gls V6",
            "Sedan Gls",
            "Sedan",
            "Vr6",
            "2.0t/value Edition",
            "3.6l 4motion",
            "Gl Tdi",
            "Wagon Turbo",
            "W8 4motion",
            "2.0t Luxury",
            "3.6l Wagon Luxury",
            "V6 Sel Premium",
            "S/2.5l S",
            "2.5l Sel/2.5l Sel Premium",
            "W8",
            "Highline",
            "Tdi Sel Premium",
            "S W/appearance",
            "1.8t R-line/1.8t S",
            "1.8t S/1.8t Wolfsburg Edition",
            "Wagon",
            "Value Edition",
            "2.0t Luxury Leather",
            "3.6l 4motion Luxury",
            "1.8 Tsi",
            "Gls 4motion",
            "Sel/sel Premium",
            "Trendline+",
            "Wagon Vr6 4motion",
            "2.5l S/2.5l Wolfsburg Edition",
            "3.6l Luxury",
            "Trendline",
            "Wagon Lux",
            "3.6l 4motion Wagon Luxury",
            "Gls 1.8t",
            "1.8t Sel",
            "2.0 Tdi",
            "Tdi",
            "Gls/gls 1.8t",
            "2.5",
            "Sel 1.8t Sel Premium",
            "R-L",
            "1.8t Sel/1.8t Sel Premium",
            "2.0t Sport",
            "Tdi Se W/sunroof Nav",
            "1.8t Limited Edition/1.8t S/1.8t Wolfsburg Edition",
            "Gls 1.8t 4motion",
            "2.0 Tsi",
            "Wol",
            "1.8t R-line W/comfort Pkg",
            "Highline 2.0 Tsi",
            "Execline W/ R-line",
            "2.0t S/r-line",
            "Kom",
            "Tur",
            "Wagon Wagon Turbo",
            "2.0l Tdi Se W/sunroof",
            "Tdi Se W/sunroof & Nav",
            "1.8t Se W/technology",
            "Sedan Turbo",
            "Cc Highline",
            "1.8t Wolfsburg Ed",
            "1.8t Se W/sunroof & Nav",
            "Wolfsburg Ed",
            "Se W/sunroof & Nav Pzev",
            "R-line W/comfort Pkg",
            "E",
            "S W/nav",
            "Sport",
            "Sel Premium Pzev",
            "Wag",
            "1.8t",
            "2.0l Tdi Se W",
            "2.0t Se W/technology",
            "S/wolfsburg Ed/s W/nav",
            "V6 Gt",
            "Tdi Se",
            "Se W/snrf/nav",
            "S/wolfsburg Ed",
            "V6 Se W/technology",
            "1.8t Limited Edition/1.8t Se/1.8t Sport",
            "Wolfsburg 2.0 Tsi",
            "Se/se W/sunroof",
            "2.0",
            "4d 2.5 S",
            "Lim",
            "4d 2.5 Se",
            "Wolfsburg Edition/2.0t",
            "4d",
            "Hig",
            "3.6l 4motion Sport",
            "3.6l 4motion Wagon Sport",
            "S/r",
            "Ry",
            "3.6l 4motion Wagon",
            "Cc",
            "2.5l S/s",
            "Se W/sunroof   Nav",
            "Tdi Se W/sunroof   Nav",
            "Exe",
            "S A",
            "Se Se",
            "3.6l Wagon",
            "Glx V6",
            "Se W/sunroof Nav",
            "S S",
            "R-l R-l",
            "Se W/sunroof   Nav Pzev",
            "Sel Sel",
            "1.8t Se W/sunroof Nav",
            "Se W/sunroof Nav Pzev",
            "Glx V6 4motion",
            "Tur Tur",
            "2.5l Comfortline",
            "Sw",
            "2.0 Tdi Comfortline",
            "1.8 Tsi Trendline+",
            "- Wagon",
            "1.8 Tsi Comfortline",
            "Sedan Le",
            "Comfortline",
            "2.0 Tdi Comfortline/comfortline",
            "2.5l Trendline/2.5l Trendline+",
            "Execline",
            "V6 Se",
            "2.5l Trendline",
            "2.0 Tdi Highline",
            "2.0 Tdi Trendline+",
            "Sedan 2.0t",
            "1.8 Tsi Trendline/1.8 Tsi Trendline+",
            "Wagon Gls",
            "2.0 Tsi Comfortline",
            "3.6l V6",
            "2.0t/2.0t Base",
            "2.5l Highline",
            "1.8 Tsi Trendline",
            "1.8t Se W/sunroof   Nav",
            "2.0 Tdi Trendline",
            "2.0t Trendline",
            "Psat 3.6l",
            "2.0t Comfortline/2.0t Trendline",
            "1.8 Tsi Highline",
            "3.6l Comfortline",
            "2.0 Tsi Trendline+",
            "2.5l Highline/highline",
            "1.8t Se/1.8t Sport",
            "Ase"
          ]
        },
        {
          "model": "Passat CC",
          "series": [
            "2.0 Tsi",
            "3.6 4motion",
            "Highline V6",
            "Highline",
            "Sportline"
          ]
        },
        {
          "model": "Pointer Truck",
          "series": []
        },
        {
          "model": "Polo",
          "series": []
        },
        {
          "model": "Robust",
          "series": []
        },
        {
          "model": "Routan",
          "series": [
            "Sel",
            "S",
            "Se",
            "Sel Premium",
            "Trendline",
            "Execline",
            "Se W/rse",
            "Se W/rse & Navigation",
            "Sel W/navigation",
            "Se W/rse Navigation",
            "Comfortline",
            "Se Se",
            "Highline"
          ]
        },
        {
          "model": "Saveiro",
          "series": []
        },
        {
          "model": "SportVan",
          "series": []
        },
        {
          "model": "T-Cross",
          "series": [
            "Ac"
          ]
        },
        {
          "model": "Taos",
          "series": [
            "1.5t Se",
            "1.5t S",
            "1.5t Sel",
            "Se",
            "S",
            "Se Iq Drive",
            "Sel",
            "Highline 1.5 Tsi",
            "Se Iq Drive/sel",
            "Highline",
            "Comfortline",
            "Trendline",
            "Se Iq",
            "Se 1.5 Tsi",
            "4d S",
            "Comfo",
            "Highl",
            "Trend",
            "Se Volkswagen",
            "1.5t Se Black",
            "Trendline 1.5 Tsi",
            "Comfortline 1.5 Tsi",
            "Comfortline Black Edition",
            "Se Black",
            "Se Bl"
          ]
        },
        {
          "model": "Teramont",
          "series": []
        },
        {
          "model": "Tiguan",
          "series": [
            "Se",
            "Wolfsburg",
            "Sel Premium",
            "2.0t Se R-line Black/2.0t Sel/2.0t Se",
            "2.0t Se/2.0t Se R-line Black/2.0t Sel",
            "2.0t/2.0t S",
            "S",
            "2.0t Sport",
            "2.0t S",
            "2.0t Se/2.0t Sel",
            "2.0t Se",
            "2.0t Se R-line Black",
            "Sel",
            "S/se/sel",
            "2.0t Se/2.0t Sel/2.0t Sel R-line/2.0t Sel R-line Black",
            "2.0t Wolfsburg Edition",
            "Se/sel/s",
            "Se W/sunroof & Nav",
            "Sport",
            "Wolfsburg Edition",
            "2.0t Sel/2.0t Sel R-line/2.0t Sel R-line Black/2.0t Se",
            "2.0t Sel Premium/2.0t Sel Premium R-line",
            "Se R-line Black",
            "Se/sel",
            "Se/sel/sel R-line Jet-black/sel R-line",
            "2.0t Sel R-line",
            "2.0t Sel Premium R-line",
            "Sel Premium R-line",
            "Sel R-line Black",
            "S/limited",
            "Sel R-line",
            "2.0t Sel Premium",
            "2.0 Tsi",
            "2.0t Sel/2.0t Se",
            "Se/se R-line Black/sel",
            "S/se/sel/r-Line",
            "Se/sel/sel R-line Jet-bla",
            "S/se/sel/se W/leather",
            "Trendline/comfortline",
            "Le",
            "Highline 2.0 Tsi",
            "R-Line",
            "2.0t (a6)/s",
            "Comfortline",
            "2.0t Sel",
            "Sel Premium/sel Premium R",
            "Comfort/high/r-line/sp Ed",
            "Se W/sunroof Nav",
            "R-Line/s/se/sel",
            "Highline",
            "Le/s/se/sel",
            "S/se/sel/wolfsburg Edition",
            "Trendline",
            "Sel Premium/sel Premium R-line",
            "S W/sunroof",
            "2.0t/s",
            "Trendline/highline",
            "2.0t Sel/2.0t Sel R-line/2.0t Sel R-line Black/se",
            "Wol",
            "High R-line 2.0 Tsi",
            "Se 4motion",
            "Sel W/premium Nav",
            "Se/sel/se W/leather",
            "2.0t Se R-line Black/se Black",
            "Lim",
            "Se W/sunroof & Navi",
            "S/sel/se/r-Line",
            "Se/sel/sel R-line",
            "S/s W/sunroof/se",
            "Sel 4motion W",
            "Spo",
            "Se 4motion Wsunroof &",
            "Sel 4motion",
            "S 4motion",
            "Se/sel/se R-line Black",
            "Sel/se",
            "Sel W/premium Navi",
            "Se W/leather",
            "Sel/s/se/r-Line",
            "Hig",
            "S/s W/sunroof",
            "Com",
            "4motion",
            "Comfortline/highline",
            "S/se",
            "S/se/se W",
            "Sel W/premium Nav & Dyn.",
            "2.0t Se/wolfsburg Edition",
            "Comfortline/trendline",
            "Tre",
            "Denali",
            "4d 4wd",
            "Se/sel/r-Line/s",
            "Se/sel/sel R-line/sel R-line Black",
            "S/s",
            "S F",
            "Se W/sunroof   Nav",
            "Er",
            "Se Se",
            "Se W/sunroof   Navi",
            "Se/",
            "S S",
            "Comfortline 2.0 Tsi",
            "2.0t Se/sel",
            "Se/wolfsburg",
            "Sel Sel",
            "Spo Spo",
            "Trendline 2.0 Tsi",
            "Comfortline/highline/special Edition/trendline",
            "Comfort R-line 2.0 Tsi",
            "2.0t Se/2.0t Wolfsburg Edition",
            "Comfortline/highline/special Edition",
            "Comfortline/united",
            "Comfortline/iq Drive",
            "Trendline/comfortline/highline",
            "Highline R-line",
            "2.0 Tsi Comfortline/2.0 Tsi Highline/2.0 Tsi Trendline",
            "Comfortline R-line Black Edition",
            "Comfortline/highline/trendline",
            "Se 4motion Wsunroof Navi",
            "2.0t Highline/2.0t Trendline/comfortline",
            "United 2.0 Tsi",
            "El",
            "S/se/se W/leather/sel/wolfsburg",
            "Comfortline R-line Black",
            "2.0 Tsi Comfortline/2.0 Tsi Trendline",
            " V6"
          ]
        },
        {
          "model": "Tiguan Limited",
          "series": [
            "2.0t"
          ]
        },
        {
          "model": "Touareg",
          "series": [
            "Vr6 Sport",
            "Vr6 Lux",
            "Tdi Executive",
            "V6 Tdi",
            "V6",
            "Hybrid",
            "4.2",
            "Wolfsburg",
            "Tdi",
            "2 Vr6 Fsi",
            "3.6l Lux",
            "Tdi Lux",
            "V8",
            "3.2",
            "2 V8",
            "V6 Sport",
            "Sport",
            "Tdi Sport",
            "2 V10 Tdi",
            "V6 Wolfsburg Edition",
            "Tdi Executive/tdi Lux/tdi Sport",
            "2 V6",
            "Vr6 Executive",
            "Sport/lux/executive",
            "2 V8 Fsi",
            "V6 Lux",
            "Hybrid V6",
            "V6 Executive",
            "Vr6 Fsi",
            "3.6l Sport",
            "3.6l Executive",
            "Hybrid Hybrid",
            "Vr6 Executive/vr6 Lux/vr6 Sport",
            "2 V6 Tdi",
            "3.6l R-line",
            "Tdi R-line",
            "2",
            "Tdi 5.0",
            "Execline W/ R-line",
            "Wo",
            "Executive",
            "Sp",
            "Tdi/sport/lux/executive",
            "X",
            "Td",
            "Exec",
            "Sport W/nav",
            "Lux",
            "Wolfsburg Edition",
            "Sport/lux/exec",
            "2 Vr6",
            "Vr6",
            "Sport W/technology",
            "R-Line",
            "Hy",
            "4.",
            "3.2l V6",
            "5.0l V10",
            "4.2l V8",
            "3.",
            "V10",
            "Comfortline/highline",
            "Ex",
            "V10 Tdi",
            "2 V",
            "3.6l Executive/3.6l Lux/3.6l R-line/3.6l Sport",
            "Tdi Sport W/technology",
            "Highline/execline W/rline",
            "V6 V6",
            "Hy Hy",
            "Td V6",
            "3.6l",
            "3.0 Tdi Execline/3.0 Tdi Highline",
            "3.6l Wolfsburg Edition",
            "3.6l Comfortline/3.6l Execline/3.6l Highline/3.6l Sportline",
            "2 V6 Comfortline",
            "3.6l Comfortline/3.6l Execline/3.6l Highline",
            "Tdi Comfortline/tdi Highline",
            "2 2",
            "3.0 Tdi Comfortline/3.0 Tdi Highline",
            "3.0 Tdi Comfortline/3.0 Tdi Execline/3.0 Tdi Highline",
            "3.0 Tdi Comfortline/3.0 Tdi Execline/3.0 Tdi Highline/3.0 Tdi Sportline",
            "3.6l Sportline"
          ]
        },
        {
          "model": "Transporter",
          "series": []
        },
        {
          "model": "Up!",
          "series": []
        },
        {
          "model": "Vento",
          "series": [
            "/ Jetta R/t Scat Pack"
          ]
        },
        {
          "model": "Virtus",
          "series": []
        },
        {
          "model": "Volksbus",
          "series": []
        },
        {
          "model": "Worker",
          "series": []
        },
        {
          "model": "Workline",
          "series": []
        },
        {
          "model": "Vanagon",
          "series": [
            "Bus",
            "Campmobile",
            "Kombi",
            "Camper",
            "Multivan",
            "Ca",
            "Ba"
          ]
        }
      ]
    },
    {
      "make": "Volvo",
      "models": [
        {
          "model": "7900",
          "series": []
        },
        {
          "model": "8300",
          "series": []
        },
        {
          "model": "9700",
          "series": []
        },
        {
          "model": "9800",
          "series": []
        },
        {
          "model": "7300 BRT",
          "series": []
        },
        {
          "model": "9700 Grand",
          "series": []
        },
        {
          "model": "Access",
          "series": []
        },
        {
          "model": "ALD Enviro500",
          "series": []
        },
        {
          "model": "B11R",
          "series": []
        },
        {
          "model": "B13R",
          "series": []
        },
        {
          "model": "B290R",
          "series": []
        },
        {
          "model": "B410R",
          "series": []
        },
        {
          "model": "B8R",
          "series": []
        },
        {
          "model": "B8RLE",
          "series": []
        },
        {
          "model": "C30",
          "series": [
            "T5/t5 R-design",
            "T5",
            "T5 R-design/t5 Version 1.0/t5 Version 2.0",
            "T5/t5 Platinum/t5 Premier Plus/t5 R-design/t5 R-design Platinum/t5 R-design Premier Plus",
            "2.4i",
            "T5/t5 Platinum/t5 Premier/t5 Premier Plus/t5 R-design/t5 R-design Platinum/t5 R-design Premier",
            "T5 Platinum",
            "T5/t5 Platinum/t5 Premier/t5 Premier Plus/t5 R-design/t5 R-design Platinum/t5 R-desig",
            "T5 R-design",
            "T5/t5 Platinum/t5 Premier Plus/t5 R-design/t5 R-design Platinum/t5 R-design Premier P",
            "Version 1.0",
            "R-design/version 1.0/version 2.0",
            "T5/t5 Platinum/t5 Premier Plus/t5 R-design/t5 R-design ",
            "T5/t5 Platinum/t5 Premier/t5 Premier Plus/t5 R-design/t",
            "T5/t5 Platinum/t5 Premier Plus/t5 R-design/t5 R-design",
            "T5/t5 Platinum",
            "T5 Premier Plus",
            "2.4i 2.4i",
            "T5 T5",
            "R-design/t5 R-design/t5 Version 1.0/t5 Version 2.0",
            "T5 R-design/t5 Version 1.0/t5 Version 2.0/version 2.0",
            "T5 Level 1/t5 Level 2/t5 R-design"
          ]
        },
        {
          "model": "C40",
          "series": [
            "Recharge Pure Electric Twin Ultimate",
            "Recharge Ultimate",
            "Recharge Core",
            "Recharge Plus",
            "P8 Recharge Ultimate",
            "Recharge Pure Electric Twin Plus",
            "Recharge Pure Electric P8 Ultimate",
            "Recharge Pure Electric Recharge Plus",
            "Recharge Pure Electric",
            "Rechar",
            "Recharge Pure Electric Recharge Ultimate",
            "Recharge Pure Plus",
            "P8 Rec",
            "Recharge Pure Ultimate",
            "Recharge Pure Electric Twin Core",
            "P8 Ultimate"
          ]
        },
        {
          "model": "C70",
          "series": [
            "T5",
            "T5/t5 Platinum/t5 Premier Plus",
            "Ht",
            "Hpt",
            "Lpt",
            "Turbo",
            "Lt",
            "2.3l Turbo",
            "T5/t5 Platinum",
            "Lt A Cv",
            "Ht A Cv/ht M Cv",
            "2.4l Turbo",
            "T5 T5",
            "T5/t5 M",
            "Ht/ht A Cv"
          ]
        },
        {
          "model": "Hibrido",
          "series": []
        },
        {
          "model": "ProCity",
          "series": []
        },
        {
          "model": "S40",
          "series": [
            "T5/t5 R-design",
            "1.9t",
            "T5",
            "A/a Sr/sport Edition",
            "2.4i",
            "A/as",
            "A/a Sr",
            "A/lse",
            "T5 R-design",
            "A",
            "A/sport Edition",
            "T5 Awd",
            "2.4i/2.4i A Sr (new)",
            "R-Design",
            "2.5l Turbo",
            "2.4l",
            "2.5t",
            "A Sr W",
            "2.4l W/sunroof",
            "Sport Edition",
            "2.5t R-design",
            "A Sr W/premium Package (fleet)",
            "S 40",
            "2.4i/2.4l",
            "2.4i 2.4i",
            "2.4i/2.4i Premium/2.4i R-design",
            "Base 4",
            "T5 Level 1/t5 Level 2/t5 R-design"
          ]
        },
        {
          "model": "S60",
          "series": [
            "T6",
            "T5",
            "Inscription T5 Drive-e Premier",
            "Core",
            "2.4",
            "B5 Plus Dark Theme",
            "2.5t",
            "B5 Inscription",
            "T5 Momentum",
            "T5 Premier",
            "T5/t5 Platinum/t5 Premier/t5 Premier Plus",
            "T5 Dynamic",
            "2.4/t5",
            "B5 Black Edition Momentum/b5 Inscription/b5 Momentum",
            "Premier",
            "2.5t Awd",
            "T5 Platinum",
            "B5 Momentum",
            "T6 Momentum",
            "T5 Inscription",
            "Dynamic",
            "Platinum",
            "Inscription T5",
            "T6/t6 R-design",
            "T5 Drive-e Premier",
            "Recharge Plug-in Hybrid T8 Inscription Extended Range",
            "Inscription T5 Platinum",
            "T6 Inscription",
            "R",
            "Polestar",
            "Inscription T5 Drive-e Platinum",
            "T6 R-design Platinum",
            "T5 Premier Plus",
            "Inscription",
            "T8 Recharge Inscription",
            "Plus",
            "T5 R-design",
            "T8 Recharge R-design",
            "Inscription T5 Premier",
            "T6 R-design",
            "2.4t",
            "Cross Country T5",
            "Ultimate",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design Platinum",
            "2.5t/2.5t Special Edition",
            "T8 Inscription",
            "2.4l",
            "Recharge Plug-in Hybrid T8 R-design",
            "B5 Core Dark Theme",
            "Recharge Plug-in Hybrid T8 Plus Dark Theme",
            "B5 Ultimate Dark Theme",
            "2.4l Turbo",
            "2.4 A/2.4 A Sr/2.4 M",
            "B5 Ultimate Bright Theme",
            "2.5l Turbo",
            "R Design",
            "Premier+",
            "T6 Platinum",
            "B5 Plus Black Edition",
            "T8 R-design",
            "Recharge Plug-in Hybrid T8 R-design Expression",
            "T8 Recharge R-design Expression",
            "T5 Drive-e",
            "T6 Premier Plus",
            "Dynami",
            "Recharge Plug-in Hybrid T8 Plus Black Edition",
            "B5 R-design",
            "T8 R-d",
            "Platin",
            "T6 R-d",
            "T6 Mom",
            "Recharge Plug-in Hybrid T8 Core Dark Theme",
            "T8 Polestar Engineered",
            "Inscription Platinum",
            "Premie",
            "T5 Ins",
            "T6 Ins",
            "T8 Pol",
            "T8 Rec",
            "Recharge Plug-in Hybrid T8 Black Edition R-design Extended Range",
            "B5 Ins",
            "T5 Mom",
            "T5/t5 A Sr",
            "Recharge Plug-in Hybrid T8 Polestar Engineered Extended Range",
            "Inscription/premier",
            "Awd",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design",
            "R Desi",
            "Inscription Premier",
            "B5 Mom",
            "Recharge Plug-in Hybrid T8 Ultimate Dark Theme",
            "2.4/2.4 A",
            "Ultra",
            "W/moonroof",
            "T6 Awd",
            "2.5l Turbo R",
            "2.3l Turbo",
            "T6 Polestar",
            "Plus Black Edition",
            "Plus Dark Theme",
            "Core Dark Theme",
            "T5/t5 Platinum",
            "T5 A Sr/t5 M Sr",
            "B5 Black Edition",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design ",
            "Hybrid T8 R-design",
            "R-Design",
            "T6 Drive-e Platinum",
            "R-design Platinum",
            "Polest",
            "T6 Drive-e R-design",
            "R-design Expression",
            "R Design/platinum",
            "T8 Ins",
            "2.4/2.4 A Sr/2.4 M",
            "Cross",
            "Inscri",
            "T5 R-d",
            "T6 W/moonroof",
            "Recharge Polestar Engineered",
            "Recharge Inscription",
            "2.4t T5 W/snrf",
            "Recharge Plug-in Hybrid T8 Inscription",
            "2.4t Sr (discontinued)",
            "2.5t/2.5t W/snrf",
            "Black Edition Momentum/inscription/momentum",
            "Recharge Plug-in Hybrid T8 Core Dark Theme/t8 Plus Dark Theme",
            "B5 Core Dark Theme/b5 Plus Dark Theme",
            "T5 Drive-e Premier Plus",
            "Recharge R-design",
            "B5 R-d",
            "Recharge Black Edition R-design",
            "T6 Drive-e Premier Plus",
            "T6/t6 (retail Only)",
            "B5 Black Edition R-design",
            "Momentum",
            "T5 Drive-e Platinum",
            "T5 W/moonroof",
            "T6 Drive-e",
            "2.5t W/sunroof",
            "T5 Drive-e R-design",
            "Momentum/inscription",
            "Inscription Inscription/premier",
            "Ultima",
            "Other 122",
            "Awd -awd",
            "Glt",
            "Premie Premie",
            "Recharge Plug-in Hybrid T8 Ultimate Black Edition",
            "Cross Cross",
            "T8 Plus Dark Theme",
            "Hybrid T8 Polestar",
            "B5 Inscription/b5 Momentum",
            "T8 Ultimate Black Edition",
            "B5 Ultra",
            "T5 T5",
            "2.5t 2.5t",
            "T6 T6",
            "2.5l Turbo/2.5t",
            "Polestar Engineered",
            "Fwd",
            "B5 Plus",
            "T5 Fwd",
            "T5 Special Edition Premier",
            "T5 (fleet Only)",
            "T5 Level 1/t5 Level 2",
            "T5 R-design Special Edition",
            "Recharge Plug-in Hybrid T8 Inscription/t8 R-design Expression",
            "B5 Plus Bright Theme",
            "Ultimate B5",
            "B5 Black Edition R-design/b5 R-design",
            "Inscription T5 P T5 Drive-e Premier",
            "Plug-in Hybrid T8 Plus",
            "T8 Plus Black Edition",
            "T6 Turbo",
            "Recharge Plug-in Hybrid T8 Ultimate Bright Theme",
            "Se Fwd 2.5t",
            "B5 Ultimate Black Edition",
            "2.5t/2.5t A Sr"
          ]
        },
        {
          "model": "S60 Cross Country",
          "series": [
            "T5 Platinum",
            "T5"
          ]
        },
        {
          "model": "S80",
          "series": [
            "3.2",
            "3.0l Platinum/t6/t6 Premier Plus",
            "T6 Turbo",
            "T6",
            "2.9 A Sr",
            "2.5t",
            "Platinum",
            "3.2/3.2 Platinum/3.2 Premier Plus",
            "Premier",
            "T5 Premier Plus",
            "T5 Drive-e Platinum",
            "2.9",
            "V8",
            "3.2l",
            "T6/t6 Platinum/t6 Premier Plus",
            "2.4i",
            "Premier+",
            "T5 Drive-e",
            "T6 Elite",
            "T5",
            "T-6",
            "Executive/t6",
            "2.5t/2.5t Awd",
            "3.2 Premier Plus",
            "Platin",
            "Premie",
            "2.9/t6",
            "T6 Platinum",
            "T6 Exectuvie",
            "T5 Drive-e Premier Plus",
            "3.0l",
            "4.4l",
            "T6 Premier Plus",
            "T5 T5",
            "2.9l Twin Turbo Elite",
            "T6/t6 A Sr",
            "I6 Turbo",
            "3.2/3.2 Platinum",
            "2.5t/2.5t A",
            "3.0l Turbo",
            "2.9l",
            "2.9l Twin Turbo",
            "T6/2.9",
            "T6 Tur",
            "I6",
            "T6/t6 Platinum",
            "T6 Eli",
            "T6 Exe",
            "T6 Awd",
            "3.2 Fw",
            "T6 Premier",
            "3.2 Platinum",
            "2.9/2.9 A (discontinued)",
            "3.2 3.2",
            "T6 T6",
            "Premie Premie",
            "2.5t/2.5t A Awd/2.5t Awd",
            "T5 Platinum"
          ]
        },
        {
          "model": "S90",
          "series": [
            "T5 Momentum",
            "T6 Inscription",
            "B6 R-design",
            "B6 Inscription",
            "T6 Momentum",
            "T8 Inscription",
            "Plus",
            "Hybrid T8 Inscription",
            "T6 R-design",
            "B6 Plus",
            "T5 Inscription",
            "T6 Mom",
            "T6 Ins",
            "T5 Mom",
            "T6 Ocean Race",
            "Ultimate",
            "R-Design",
            "Plus Bright Theme",
            "T8 Ins",
            "T6 Oce",
            "Recharge Plug-in Ultimate",
            "T6/momentum",
            "Inscription",
            "T6/inscription",
            "T5 Ins",
            "Momentum",
            "T5/momentum",
            "T8 Oce",
            "Ultima",
            "T6 R-d",
            "B6 R-d",
            "B6 Ins",
            "T8 Rec",
            "T5 Mom T5 Mom",
            "B6 Momentum",
            "B6 Ultimate",
            "T8 Recharge R-design",
            "T8 Ocean Race"
          ]
        },
        {
          "model": "V40",
          "series": [
            "A/as",
            "A/a Sr/sport Edition",
            "A",
            "1.9t",
            "A/lse",
            "A/sport Edition",
            "A Sr W",
            "A/a Sr",
            "A Sr W/premium Package (fleet)"
          ]
        },
        {
          "model": "V40 Cross Country",
          "series": []
        },
        {
          "model": "V50",
          "series": [
            "2.4i",
            "T5",
            "T5/t5 Awd",
            "T5/t5 R-design",
            "2.4i/2.4l",
            "T5 R-design",
            "R-Design",
            "Olla Le",
            "2.5t",
            "2.4l",
            "2.5l Turbo",
            "2.5t R-design",
            "Wagon Wagon",
            "T5/t5 Awd/t5 Awd M Sr",
            "2.4i 2.4i"
          ]
        },
        {
          "model": "V60",
          "series": [
            "Recharge Plug-in Hybrid T8 Polestar",
            "T6 R-design",
            "Premier",
            "Cross Country Premier",
            "Cross Country T5 Momentum",
            "T5 Premier",
            "Platinum",
            "T5 Momentum",
            "T5 Dynamic",
            "Cross Country T5",
            "T5 R-design",
            "T6 R-design Platinum",
            "T5 Drive-e Premier",
            "Premier+",
            "Cross Country Platinum",
            "Cross Country Plus",
            "T5 Inscription",
            "Polestar Engineered",
            "T8 Polestar Engineered",
            "T5 Platinum",
            "T5 Premier Plus",
            "T5 Pre",
            "T8 Pol",
            "Premie",
            "Polest",
            "T6 R-d",
            "Platin",
            "T5 Drive-e Platinum",
            "T6 Momentum",
            "T5",
            "Cross",
            "Inscription",
            "Dynamic",
            "T5 Pla",
            "T5/dynamic",
            "R Design",
            "Recharge Polestar Engineered",
            "T5 Drive-e",
            "T5 Mom",
            "R-Design",
            "T5/t6 R-design",
            "T5/premier",
            "R-design Platinum",
            "R Desi",
            "Recharge Plug-in Hybrid T8 Polestar Engineered",
            "Momentum",
            "Sw 4x4 T5",
            "T5 Ins",
            "T6 Polestar",
            "T6 Ins",
            "T5 Dyn",
            "T5 Drive-e Premier Plus",
            "T6 Mom",
            "Polestar",
            "T6 R-design/t6 Platinum",
            "T5 R-d",
            "R-Desi",
            "Cross Country Ultimate",
            "T6",
            "Cross Cross",
            "Plug-in Hybrid T8 Polestar Engineered",
            "Premie Premie",
            "Recharge",
            "T6 Premier Plus",
            "Cross Country",
            "T6 Inscription",
            "T6 Dynamic"
          ]
        },
        {
          "model": "V60 Cross Country",
          "series": [
            "B5 Plus",
            "T5",
            "Plus",
            "Premier",
            "T5 Momentum",
            "Platinum",
            "T5 Platinum",
            "Ultimate",
            "B5 Ultimate",
            "T5 Premier",
            "Premier+"
          ]
        },
        {
          "model": "V70",
          "series": [
            "3.2",
            "2.4",
            "2.4 A/2.4 A Sr/2.4 M/2.4 M Sr (discontinued)",
            "Glt",
            "Xc",
            "Xc Cross Country",
            "Fwd",
            "2.5t",
            "Se",
            "Xc A Sr",
            "R",
            "Xc/xc Se",
            "T5",
            "3.2/3.2 R-design",
            "Awd",
            "Xc/se",
            "Gtas/gtms",
            "T5 Turbo",
            "2.4l",
            "Series Wagon",
            "2.5l Turbo Xc70",
            "Xc Awd/se",
            "Base",
            "2.4t",
            "2.4 A/2.4 A Sr/2.4 M",
            "R Wagon Awd",
            "Se Nav",
            "Se Lux",
            "Se D",
            "Busine",
            "2.5t Awd",
            "2.5t/2.5t A/2.5t A Sr",
            "2.3l Turbo",
            "Xc 2.4t A Sr",
            "2.4/2.4 A Sr/2.4 M/2.4 M Sr (discontinued)",
            "2.5l Turbo R/r",
            "2.4t Awd",
            "T5 Tur",
            "T5 A (discontinued)/t5 A Sr/t5 M/t5 M Sr",
            "T5/t5 A (discontinued)/t5 M Sr",
            "2.4t A Sr",
            "2.5l Turbo",
            "Se D3",
            "Xc70",
            "2.5l Turbo R",
            "2.4l Turbo",
            "R/2003 Year",
            "Es D5",
            "Author",
            "Es D2",
            "Se D5",
            "R-Desi",
            "Se D2",
            "Es D3",
            "Se D D",
            "Se D4",
            "3.2/3.2 (retail Only)/3.2 R-design",
            "3.2 3.2",
            "2.4/2.4 A"
          ]
        },
        {
          "model": "V90",
          "series": [
            "Cross Country T6 Inscription",
            "T5 R-design",
            "T6 Inscription",
            "Cross Country T5 Momentum",
            "T6 R-design",
            "Cross",
            "Cross Country Ultimate",
            "T5 Inscription",
            "R-Desi",
            "Inscription",
            "Moment",
            "R-Design",
            "T6 R-d",
            "Inscri",
            "T6 Ins",
            "T5 Ins",
            "T5 R-d",
            "T6",
            "Cross Country B6 Inscription",
            "Cross Country Plus",
            "Cross Country Ocean Race"
          ]
        },
        {
          "model": "V90 Cross Country",
          "series": [
            "T6",
            "B6",
            "B6 Ultimate",
            "Ultimate",
            "T5",
            "B6 Inscription",
            "T6/inscription",
            "Volvo Ocean Race",
            "T6 Volvo Ocean Race",
            "T5/momentum",
            "T6 Inscription",
            "T5 Momentum",
            "B6 Plus"
          ]
        },
        {
          "model": "VAH",
          "series": [
            "Car Carrier Truck"
          ]
        },
        {
          "model": "VAH 300",
          "series": []
        },
        {
          "model": "VAH 400",
          "series": []
        },
        {
          "model": "VAH 430",
          "series": []
        },
        {
          "model": "VAH 640",
          "series": []
        },
        {
          "model": "VHD",
          "series": [
            "Dump Truck",
            "Construction Dump Truck",
            "Ready Mix Truck",
            "Truck Cab And Chassis",
            "Grapple Crane Truck",
            "Roll-off Container Truck"
          ]
        },
        {
          "model": "VNL",
          "series": [
            "Vnl",
            "(amalgamated)",
            "670",
            "Semi Truck",
            "780 Semi Truck",
            "Nl",
            "Grain Truck",
            "Trucks Truck Tractor",
            "Toter Truck",
            "Car Carrier Truck",
            "*dot*"
          ]
        },
        {
          "model": "VNL 300",
          "series": []
        },
        {
          "model": "VNL 400",
          "series": []
        },
        {
          "model": "VNL 430",
          "series": []
        },
        {
          "model": "VNL 630",
          "series": []
        },
        {
          "model": "VNL 670",
          "series": []
        },
        {
          "model": "VNL 740",
          "series": []
        },
        {
          "model": "VNL 760",
          "series": []
        },
        {
          "model": "VNL 860",
          "series": []
        },
        {
          "model": "VNM",
          "series": [
            "Semi Truck",
            "Dump Truck"
          ]
        },
        {
          "model": "VNR",
          "series": [
            "64t",
            "Series",
            "42t",
            "Vnr",
            "Semi Truck"
          ]
        },
        {
          "model": "VNR 300",
          "series": []
        },
        {
          "model": "VNR 400",
          "series": []
        },
        {
          "model": "VNR 640",
          "series": []
        },
        {
          "model": "VNX",
          "series": []
        },
        {
          "model": "VT",
          "series": [
            "880"
          ]
        },
        {
          "model": "XC40",
          "series": [
            "Recharge Plus",
            "P8 Recharge Plus",
            "T4 Momentum",
            "T5 Momentum",
            "Core",
            "B5 Plus Bright Theme",
            "T5 Inscription",
            "T5 R-design",
            "Ultimate",
            "T4 R-design",
            "P8 Recharge Ultimate",
            "B5 Core Dark Theme",
            "Plus",
            "Recharge",
            "Recharge Ultimate",
            "T4 Inscription",
            "B5 Ultimate Bright Theme",
            "B5 Ultimate Dark Theme",
            "T5 Momentum/t5 R-design",
            "B4 Core",
            "B5 Plus Dark Theme",
            "Recharge Core",
            "B5 Core",
            "B5 Core Bright Theme/b5 Core Dark Theme",
            "Momentum T5",
            "Ultimate B5",
            "T5 Mo",
            "T5 In",
            "B4 Plus Dark Theme",
            "Ultim",
            "T4 Mo",
            "T5 R-",
            "Ultimate Dark Theme",
            "B4 Ultimate Bright Theme",
            "Momentum/r-Design",
            "Rdesi",
            "P8 Re",
            "Momentum",
            "Recha",
            "Ultimate Bright Theme",
            "Plus Bright Theme",
            "Plus Dark Theme",
            "B4 Ultimate Dark Theme",
            "Inscription",
            "R-Design",
            "T4 In",
            "T4 R-",
            "Momen",
            "R-Des",
            "T5 Momentum Momentum",
            "B4 Plus Bright Theme",
            "T5",
            "First",
            "Inscr",
            "T4",
            "+ B4",
            "+ B3",
            "T4 Mo T4 Mo",
            "Ultra Dark Theme",
            "P8",
            "T5 R- T5 R-",
            "Twin Plus",
            "T5 Mo T5 Mo",
            "Plus B5",
            "B5 Core Bright Theme",
            "Twin Ultimate",
            "R-design T5",
            "B5 Ultra Dark Theme",
            "B5 Ultra Bright Theme",
            "T6",
            "Ultra",
            "T6 Momentum"
          ]
        },
        {
          "model": "XC40 Recharge",
          "series": [
            "Pure Electric Twin Ultimate",
            "Pure Electric P8 Twin Plus",
            "Pure Electric P8",
            "Pure Electric P8 Twin Ultimate",
            "Plus",
            "Pure Electric Twin Plus",
            "Pure Electric",
            "Ultimate",
            "Pure Twin Ultimate",
            "Core",
            "Pure Electric Twin Core",
            "Pure Twin Plus",
            "Pure Plus",
            "Pure Electric Plus"
          ]
        },
        {
          "model": "XC60 Recharge",
          "series": [
            "Plug-in Hybrid T8 R-design",
            "Plug-in Hybrid T8 Polestar Engineered Extended Range",
            "Plug-in Hybrid T8 Plus Dark Theme",
            "Plug-in Hybrid T8 Recharge Inscription E",
            "Plug-in Hybrid T8 Inscription",
            "Plug-in Hybrid T8 Plus Bright Theme",
            "Plug-in Hybrid T8 Inscription Expression",
            "Plug-in Hybrid T8 Ultimate Bright Theme",
            "Plug-in Hybrid Ultimate Dark Theme",
            "Plug-in Hybrid T8 Core Dark Theme",
            "Plug-in Hybrid T8 Ultimate Dark Theme",
            "Plug-in Hybrid T8 Inscription Expression Extended Range",
            "Plug-in Hybrid Plus",
            "Plug-in Hybrid T8 Polestar Engineered",
            "R-Design",
            "Plus Dark Theme",
            "Plug-in Hybrid T8 Inscription Extended Range",
            "Plus Bright Theme",
            "Inscription",
            "Inscription Expression",
            "Plug-in Hybrid T8 R-design Extended Range",
            "Ultimate Bright Theme",
            "Plug-in Hybrid T8 Recharge Inscription",
            "Plug-in Hybrid",
            "Plug-in Hybrid Ultimate",
            "Plug-in Hybrid T8 Core Bright Theme",
            "Plug-in Hybrid T8 Ultimate Black Edition"
          ]
        },
        {
          "model": "XC60",
          "series": [
            "3.2",
            "T5 Momentum",
            "T5 Drive-e Platinum",
            "T5 Inscription",
            "3.2/3.2 R-design",
            "T6 Inscription",
            "T5/t5 Premier",
            "B5 Plus Bright Theme",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design Platinum/t6 R-design Premier Plus",
            "T5 Premier",
            "T6 Premier",
            "3.2/3.2 Platinum/3.2 Premier/3.2 Premier Plus",
            "T6 Dynamic",
            "T6 Momentum",
            "T8 Polestar Engineered",
            "T5 Dynamic",
            "T6/t6 R-design",
            "Ultimate",
            "T6 R-design",
            "B5 Plus Dark Theme",
            "B5 Ultimate Bright Theme",
            "T5 Drive-e",
            "T6 Drive-e",
            "T5",
            "T5/inscription",
            "T5/dynamic",
            "T6",
            "B5 Core",
            "T6/premier+",
            "T5 R-design",
            "B5 Inscription",
            "T5 Platinum",
            "T6 Platinum",
            "Plus",
            "T8 Recharge Inscription Express",
            "T6/r Design/platinum",
            "T6 Premier+",
            "T8 Recharge R-design",
            "Momentum T6",
            "T8",
            "B5 Momentum",
            "Core",
            "B6 R-design",
            "B6 Inscription",
            "T8 R-design",
            "T6 R-design Premier Plus",
            "Hybrid T8 Inscription",
            "T5 Premier Plus",
            "3.2 Premier +",
            "T8 Inscription",
            "T5 Drive-e Premier",
            "T6/inscription",
            "T6/premier",
            "T6 R-design Platinum",
            "B5 Core Dark Theme",
            "T5 Premier+",
            "T8 Recharge Inscription E",
            "T6 Premier Plus",
            "T5/platinum",
            "T8 Recharge Inscription",
            "B5 Ultimate Dark Theme",
            "Hybrid T8 R-design",
            "B6 Ultimate Bright Theme",
            "Inscription",
            "T5/premier",
            "T6 T6",
            "B5 R-design",
            "Inscription T6",
            "3.2 Platinum",
            "T5/momentum",
            "3.2 Premier",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design Platinum/t6 R-design Premier ",
            "T6 Mo",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design",
            "3.2l",
            "T6/platinum",
            "T5 R-",
            "B6 Ultimate Dark Theme",
            "T6 Pr",
            "Polestar Engineered",
            "T6 Drive-e R-design Platinum",
            "B6 In",
            "T6 R-design Premier",
            "T6/dynamic",
            "T5 In",
            "T6 In",
            "T5 Dy",
            "T5 Pl",
            "T5 Mo",
            "3.2 Premier Plus",
            "T6 Pl",
            "T5 Pr",
            "T6 Drive-e Platinum",
            "T6 Drive-e R-design",
            "T8 R-",
            "T8/inscription",
            "T6/momentum",
            "T6/r Design/premier+",
            "T6 Drive-e Premier Plus",
            "T8 Re",
            "Ultimate Bright Theme",
            "Plus Dark Theme",
            "R-Des",
            "Ultim",
            "Hybrid T8 Momentum",
            "3.2l/3.2l Platinum/3.2l Premier/3.2l Premier Plus",
            "R-Design",
            "3.0t",
            "Dynamic",
            "T8 In",
            "T5 Drive-e Premier Plus",
            "B5 Mo",
            "3.2 P",
            "3.2/premier+",
            "T5/premier+",
            "Momen",
            "T6/t6 Platinum/t6 Premier Plus/t6 R-design/t6 R-design ",
            "T8 Mo",
            "T6 R-",
            "Momentum",
            "Polestar",
            "Inscription Expression",
            "3.2/platinum",
            "Es Aw",
            "3.2/3.2 Platinum",
            "3.0l/3.0l Platinum/3.0l Premier Plus/3.0l R-design/3.0l R-design Platinum/3.0l R-des",
            "T6 Dy",
            "3.2l Premier Plus",
            "B5 In",
            "Se Lu",
            "3.2/premier",
            "Se D4",
            "T6/t6 Platinum",
            "Inscr",
            "3.0l",
            "3.2l Platinum",
            "3.2l Premier",
            "Plus Bright Theme",
            "B6 R-",
            "Se Aw",
            "+ B5",
            "Drive",
            "T6/r Design",
            "P-Str",
            "Se Na",
            "B5 R-",
            "Editi",
            "Se D",
            "S D D",
            "Se D3",
            "Poles",
            "S D A",
            "T8 Po",
            "B6 Momentum",
            "B6 Mo",
            "T5 Mo T5 Mo",
            "B5 Mn",
            "T6 Level Iii",
            "3.2/3.2 Platinum/3.2 Premier Plus/3.2l Premier",
            "Ultra",
            "Parts Only",
            "T6 R- T6 R-",
            "T8 In T8 In",
            "Plug-in Hybrid T8 Plus",
            "T5 Pr T5 Pr",
            "T5 T5",
            "3.2 3.2",
            "T5 Pl T5 Pl",
            "Plug-in Hybrid T8 Core",
            "T8 Momentum",
            "B5 Ultra",
            "B5 Plus",
            "3.2 Platinum/3.2 Premier/3.2 Premier Plus/3.2l",
            "Ultimate B5",
            "T5 Special Edition Premier",
            "T8 Ultra",
            "Plug-in Hybrid T8 Ultra",
            "B6 Plus Bright Theme",
            "T6 Level 3/t6 R-design",
            "T8 Plus",
            "Ultimate Black Edition",
            "3.2/3.2 Platinum/3.2 Premier/3.2 Premier Plus/t6/t6 Platinum/t6 Premier Plus",
            "T8 Plus Dark Theme",
            "T8 Core Dark Theme"
          ]
        },
        {
          "model": "XC70",
          "series": [
            "2.5t",
            "3.2",
            "T6",
            "2.5t/volvo Ocean Race Edition",
            "T6/t6 Platinum/t6 Premier Plus",
            "T6 Platinum",
            "T6 Premier",
            "T6/premier",
            "T5 Classic Premier",
            "2.5t Awd",
            "T6 Premier Plus",
            "3.2/3.2 Platinum/3.2 Premier/3.2 Premier Plus",
            "T5 Premier",
            "T5/premier",
            "2.5t/ocean Race Edition",
            "3.2 Premier +",
            "T5 Platinum",
            "3.2 Platinum",
            "T5 Premier+",
            "T5 Drive-e Premier",
            "T6/platinum",
            "T6 Pr",
            "T6 Pl",
            "3.2 Premier Plus",
            "3.2 Premier",
            "T5 Drive-e Platinum",
            "T6 Premier+",
            "T5 Pr",
            "T5 Cl",
            "3.2l Premier Plus",
            "T5 Pl",
            "3.2l Platinum",
            "T5/classic Platinum",
            "T5",
            "Ocean Race Edition",
            "T5/platinum",
            "T5 Drive-e Premier Plus",
            "Se Lu",
            "3.2 P",
            "2.5l Turbo Xc70",
            "Se P-",
            "Se Aw",
            "3.0l T6",
            "3.2l Premier",
            "T6/premier+",
            "3.2/3.2 Platinum",
            "3.2l",
            "3.0t",
            "T5 Drive-e",
            "T6/t6 Platinum",
            "2.5t A Awd/2.5t A Awd Sr",
            "Se D3",
            "Se Na",
            "Se D",
            "Se D5",
            "Se Pr",
            "3.2/premier",
            "T6 T6",
            "T5 Pr T5 Pr",
            "L",
            "T5 Classic Platinum",
            "T5 Pl T5 Pl",
            "3.2 3.2",
            "3.2/3.2 Premium",
            "T6 Level 3",
            "A",
            "T6 Momentum"
          ]
        },
        {
          "model": "XC90",
          "series": [
            "3.2",
            "V8",
            "T6 Inscription 7 Passenger",
            "T6 Momentum",
            "T6 Inscription",
            "T5 Momentum",
            "T6",
            "3.2/3.2 Platinum/3.2 Premier Plus",
            "T6 R-design",
            "T6 Inscription 6 Passenger",
            "B6 Ultimate 7-seater",
            "T8 Recharge Inscription",
            "T6 Momentum 7 Passenger",
            "B6 Plus 7-seater",
            "T5",
            "B6 Plus Bright Theme 7-seater",
            "2.5t",
            "T6 Momentum 6 Passenger",
            "T8",
            "T5 Momentum 7 Passenger",
            "V8/volvo Ocean Race Edition",
            "T6 R-design 7 Passenger",
            "R Design",
            "Plus",
            "B5 Core",
            "2.5t Awd",
            "3.2 R-design/3.2 R-design Platinum/3.2 R-design Premier Plus",
            "Ultimate",
            "T8 Recharge Inscription Express",
            "Core",
            "T8 Recharge R-design",
            "3.2 R-design",
            "B5 Plus",
            "Hybrid T8 Inscription 7 Passenger",
            "T5 R-design 5p",
            "T5 R-design",
            "B6 Plus 6-seater",
            "I6",
            "Inscription",
            "B6 Core",
            "Sport",
            "V8 Sport",
            "T6 First Edition",
            "T8 Recharge Momentum",
            "B5 Core Bright Theme",
            "T8 Recharge Inscription E",
            "T5 Mo",
            "B6 Ultimate Bright Theme 6-seater",
            "2.5l Turbo",
            "Hybrid T8 Inscription",
            "Hybrid T8 R-design",
            "B5 Plus Bright Theme",
            "T5 Momentum 5p",
            "T8 Re",
            "T8 Inscription",
            "Ultra",
            "Momentum",
            "B6 Ultimate 6-seater",
            "Hybrid",
            "R Des",
            "3.2/3.2 R-design",
            "T6 In",
            "T5 R-",
            "T6 Mo",
            "3.2 Platinum",
            "3.2 R-design Platinum",
            "V8 R-design",
            "Plug-in Hybrid Ultra",
            "T6 Inscrpt",
            "2.9l Twin Turbo",
            "T8 Mo",
            "Activ",
            "Se D5",
            "B6 Plus Bright Theme 6-seater",
            "Se R-",
            "R-Design",
            "Excellence",
            "T6 R-",
            "3.2/3.2 Platinum",
            "R-design/r-design Platinum",
            "Momen",
            "I6 R-design",
            "T8 In",
            "R-Des",
            "Se Aw",
            "Inscr",
            "3.2 R-design/3.2 R-design Platinum",
            "Hybrid T8 Momentum",
            "4.4l V8",
            "B6 Ultimate Bright Theme 7-seater",
            "Hybrid T8 Inscription 7",
            "Se Pr",
            "Platinum",
            "T8 R-",
            "2.5t A Awd",
            "Inscription Expression",
            "Se Lu",
            "3.2 R-design/3.2 R-design Platinum/3.2 R-design Premier",
            "T8 Momentum",
            "T5 In",
            "Ultim",
            "Utili",
            "Execu",
            "Rdesi",
            "3.2 F",
            "Awd",
            "R Des R Des",
            "B6 Core Bright Theme",
            "Plug-in Hybrid Plus",
            "T8 R-design",
            "3.2 Premier Plus",
            "4.4l V8/volvo Ocean Race Edition",
            "Hybrid T8",
            "T8 Inscription 7 Passenger",
            "3.2 R-design/3.2 R-design Platinum/r-design Premier Plus",
            "T6 T6",
            "T5 T5",
            "3.2 3.2",
            "1lt/2lt/lt",
            "3.2 R-design/3.2 R-design Platinum/r-design Premier Plu",
            "T6 R- T6 R-",
            "3.2 Level 1/3.2 Level 2",
            "Hybrid T8 Inscription 6 Passenger",
            "T8 Inscription 7 Passenger/t8 Inscription Expression 7 Passenger",
            "2.5l/2.5t",
            "5 Momentum",
            "T8 R-design 7 Passenger",
            "T6 Mo T6 Mo",
            "T8 Ultimate Bright Theme 7-seater",
            "Hybrid T8 Excellence",
            "T8 Inscription 7 Passenger/t8 Inscription Expression 7",
            "3.2/3.2 R",
            "T8 Plus 6-seater",
            "B6 Plus Bright Theme",
            "B6 Ultra",
            "Hybrid T8 Momentum 6 Passenger",
            "Plug-in Hybrid T8 Ultra 7-seater",
            "Plug-in Hybrid T8 Plus 7-seater",
            "T8 Inscription 6 Passenger",
            "B6 Ultra Bright Theme",
            "Ultimate B6",
            "Plug-in Hybrid T8 Ultra 6-seater",
            "Hybrid T8 Phev Inscription",
            "B5 Ultra",
            "B5 Plus 7-seater"
          ]
        },
        {
          "model": "XC90 Recharge",
          "series": [
            "Plug-in Hybrid T8 Inscription Expression 6 Passenger",
            "Plug-in Hybrid T8 Plus Bright Theme 7-seater",
            "Plug-in Hybrid T8 Ultimate 6-seater",
            "Plug-in Hybrid T8 Ultimate Dark Theme 7-seater",
            "Plug-in Hybrid T8 Inscription Expression Extended Range 6p/t8 Inscription Expression Extended Range 7p",
            "Plug-in Hybrid T8 Inscription 7 Passenger",
            "Plug-in Hybrid T8 Recharge Inscription E",
            "Plug-in Hybrid T8 Plus 6-seater",
            "Plug-in Hybrid T8 Inscription Expression 7 Passenger",
            "Plug-in Hybrid T8 Inscription 6 Passenger",
            "Plug-in Hybrid T8 Ultimate Bright Theme 7-seater",
            "Plug-in Hybrid Plus",
            "Plug-in Hybrid T8 Core Bright Theme",
            "R-Design",
            "Plug-in Hybrid T8 Inscription 7 Passenger/t8 Inscription Expression 7 Passenger",
            "Plug-in Hybrid T8 Inscription Expression Extended Range 6p",
            "Inscription Expression",
            "Ultimate Bright Theme",
            "Plug-in Hybrid T8 Inscription Extended Range 6p/t8 Inscription Extended Range 7p",
            "Plug-in Hybrid T8 Plus Dark Theme 7-seater",
            "Plug-in Hybrid T8 Inscription Extended Range 6p",
            "Plug-in Hybrid T8 R-design 7 Passenger",
            "Inscription",
            "Plug-in Hybrid T8 Recharge Inscription",
            "Plug-in Hybrid T8 R-design Extended Range 7p",
            "Plug-in Hybrid T8 Inscription Extended Range 7p",
            "Plug-in Hybrid T8 Inscription",
            "Plug-in Hybrid T8 Plus Dark Theme"
          ]
        }
      ]
    }
  ]